import * as He from "vue";
import { defineComponent as I, computed as f, createElementBlock as s, openBlock as l, normalizeClass as v, createCommentVNode as x, renderSlot as G, createElementVNode as o, Fragment as n1, toDisplayString as M, ref as E, createTextVNode as h1, normalizeStyle as a1, withDirectives as w1, vModelDynamic as Fe, unref as D, watch as r1, onMounted as m1, nextTick as s1, createBlock as W, Teleport as g1, createVNode as J, Transition as p1, withCtx as Y, withModifiers as o1, resolveDynamicComponent as f1, watchEffect as ge, cloneVNode as Ht, h as _e, provide as ee, inject as he, onUnmounted as y1, toRaw as L1, useSlots as Ft, renderList as u1, withKeys as G1, vShow as Le, createSlots as ve, vModelText as $1, mergeProps as $e, getCurrentScope as At, onScopeDispose as jt, createStaticVNode as N, useId as Xe, TransitionGroup as me, onBeforeUnmount as It } from "vue";
import { useField as U1, useForm as Zt } from "vee-validate";
import { useRouter as Et, useRoute as St, RouterLink as zt } from "vue-router";
const Dt = ["type", "disabled", "title"], Tt = {
  key: 0,
  class: "mr-2"
}, Ot = { key: 1 }, Pt = {
  key: 2,
  class: "ml-2"
}, Rt = "inline-flex items-center justify-center font-normal transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg", Nt = "disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none", V1 = /* @__PURE__ */ I({
  __name: "EcxButton",
  props: {
    text: {},
    variant: { default: "primary" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    type: { default: "button" },
    iconOnly: { type: Boolean, default: !1 },
    title: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = (p) => {
      !r.disabled && !r.loading && n("click", p);
    }, a = {
      primary: "bg-primary text-white hover:bg-secondary focus:ring-primary shadow-md",
      secondary: "bg-white text-default-black border border-border-gray hover:bg-grey-50 focus:ring-grey-200 shadow-sm",
      outline: "bg-transparent text-primary border border-primary hover:bg-royal-25 focus:ring-primary",
      ghost: "bg-transparent text-primary hover:bg-royal-25 focus:ring-primary",
      danger: "bg-red-500 text-white hover:bg-red-600 focus:ring-red-500 shadow-md",
      "danger-outline": "bg-transparent text-error border border-error hover:bg-red-25 focus:ring-error",
      success: "bg-green-500 text-white hover:bg-green-600 focus:ring-green-500 shadow-md",
      "icon-action": "bg-white text-default-black border border-grey-100 hover:bg-grey-50 focus:ring-grey-200"
    }, d = {
      sm: "px-3 py-2 text-sm min-h-[36px]",
      md: "px-4 py-3 text-base min-h-[44px]",
      lg: "px-6 py-4 text-lg min-h-[52px]"
    }, u = {
      sm: "p-1.5 min-h-[32px] min-w-[32px]",
      md: "p-2 min-h-[40px] min-w-[40px]",
      lg: "p-2.5 min-h-[48px] min-w-[48px]"
    }, h = {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    }, C = f(() => h[r.size]), m = f(() => r.block ? "w-full" : ""), c = f(() => {
      const p = r.iconOnly ? u[r.size] : d[r.size];
      return [
        Rt,
        a[r.variant],
        p,
        Nt,
        m.value
      ].join(" ");
    });
    return (p, k) => (l(), s("button", {
      type: e.type,
      class: v(c.value),
      disabled: e.disabled || e.loading,
      title: e.title,
      onClick: i
    }, [
      e.loading ? (l(), s("svg", {
        key: 0,
        class: v(["animate-spin", e.iconOnly ? "" : "-ml-1 mr-2", C.value]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [...k[0] || (k[0] = [
        o("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1),
        o("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)
      ])], 2)) : x("", !0),
      e.iconOnly && !e.loading ? G(p.$slots, "default", { key: 1 }) : e.loading ? x("", !0) : (l(), s(n1, { key: 2 }, [
        p.$slots.iconLeft || p.$slots.prefix ? (l(), s("span", Tt, [
          G(p.$slots, "iconLeft", {}, () => [
            G(p.$slots, "prefix")
          ])
        ])) : x("", !0),
        G(p.$slots, "default"),
        e.text ? (l(), s("span", Ot, M(e.text), 1)) : x("", !0),
        p.$slots.iconRight || p.$slots.suffix ? (l(), s("span", Pt, [
          G(p.$slots, "iconRight", {}, () => [
            G(p.$slots, "suffix")
          ])
        ])) : x("", !0)
      ], 64))
    ], 10, Dt));
  }
});
var Gt = Object.defineProperty, Ut = (e, t, r) => t in e ? Gt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, J1 = (e, t, r) => Ut(e, typeof t != "symbol" ? t + "" : t, r);
const Ae = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, je = (e, t, r) => e.replaceAll(t, "").replace(r, ".").replace("..", ".").replace(/[^.\d]/g, ""), Ie = (e, t, r) => {
  var n;
  return new Intl.NumberFormat(((n = r.number) == null ? void 0 : n.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, Wt = (e, t = !0, r) => {
  var n, i, a, d;
  const u = ((n = r.number) == null ? void 0 : n.unsigned) !== !0 && e.startsWith("-") ? "-" : "", h = ((i = r.number) == null ? void 0 : i.fraction) ?? 0;
  let C = Ie(0, h, r);
  const m = C.formatToParts(1000.12), c = ((a = m.find((L) => L.type === "group")) == null ? void 0 : a.value) ?? " ", p = ((d = m.find((L) => L.type === "decimal")) == null ? void 0 : d.value) ?? ".", k = je(e, c, p);
  if (Number.isNaN(parseFloat(k))) return u;
  const j = k.split(".");
  if (j[1] != null && j[1].length >= 1) {
    const L = j[1].length <= h ? j[1].length : h;
    C = Ie(L, h, r);
  }
  let H = C.format(parseFloat(k));
  return t ? h > 0 && k.endsWith(".") && !k.slice(0, -1).includes(".") && (H += p) : H = je(H, c, p), u + H;
}, Je = (e) => JSON.parse(e.replaceAll("'", '"')), Yt = (e, t = {}) => {
  const r = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (r.mask = qt(e.dataset.maska)), e.dataset.maskaEager != null && (r.eager = ie(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (r.reversed = ie(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (r.tokensReplace = ie(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (r.tokens = Kt(e.dataset.maskaTokens));
  const n = {};
  return e.dataset.maskaNumberLocale != null && (n.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (n.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (n.unsigned = ie(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(n).length > 0) && (r.number = n), r;
}, ie = (e) => e !== "" ? !!JSON.parse(e) : !0, qt = (e) => e.startsWith("[") && e.endsWith("]") ? Je(e) : e, Kt = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Je(e);
  const t = {};
  return e.split("|").forEach((r) => {
    const n = r.split(":");
    t[n[0]] = {
      pattern: et() ? new RegExp(n[1], "u") : new RegExp(n[1]),
      optional: n[2] === "optional",
      multiple: n[2] === "multiple",
      repeated: n[2] === "repeated"
    };
  }), t;
}, et = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
let Qt = class {
  constructor(t = {}) {
    J1(this, "opts", {}), J1(this, "memo", /* @__PURE__ */ new Map());
    const r = { ...t };
    if (r.tokens != null) {
      r.tokens = r.tokensReplace ? { ...r.tokens } : { ...Ae, ...r.tokens };
      for (const n of Object.values(r.tokens))
        typeof n.pattern == "string" && (n.pattern = et() ? new RegExp(n.pattern, "u") : new RegExp(n.pattern));
    } else
      r.tokens = Ae;
    Array.isArray(r.mask) && (r.mask.length > 1 ? r.mask = [...r.mask].sort((n, i) => n.length - i.length) : r.mask = r.mask[0] ?? ""), r.mask === "" && (r.mask = null), this.opts = r;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const r = this.findMask(String(t));
    if (this.opts.mask == null || r == null) return !1;
    const n = this.process(String(t), r).length;
    return typeof this.opts.mask == "string" ? n >= this.opts.mask.length : n >= r.length;
  }
  findMask(t) {
    const r = this.opts.mask;
    if (r == null)
      return null;
    if (typeof r == "string")
      return r;
    if (typeof r == "function")
      return r(t);
    const n = this.process(t, r.slice(-1).pop() ?? "", !1);
    return r.find((i) => this.process(t, i, !1).length >= n.length) ?? "";
  }
  escapeMask(t) {
    const r = [], n = [];
    return t.split("").forEach((i, a) => {
      i === "!" && t[a - 1] !== "!" ? n.push(a - n.length) : r.push(i);
    }), { mask: r.join(""), escaped: n };
  }
  process(t, r, n = !0) {
    if (this.opts.number != null) return Wt(t, n, this.opts);
    if (r == null) return t;
    const i = `v=${t},mr=${r},m=${n ? 1 : 0}`;
    if (this.memo.has(i)) return this.memo.get(i);
    const { mask: a, escaped: d } = this.escapeMask(r), u = [], h = this.opts.tokens != null ? this.opts.tokens : {}, C = this.isReversed() ? -1 : 1, m = this.isReversed() ? "unshift" : "push", c = this.isReversed() ? 0 : a.length - 1, p = this.isReversed() ? () => L > -1 && F > -1 : () => L < a.length && F < t.length, k = (Z) => !this.isReversed() && Z <= c || this.isReversed() && Z >= c;
    let j, H = -1, L = this.isReversed() ? a.length - 1 : 0, F = this.isReversed() ? t.length - 1 : 0, P = !1;
    for (; p(); ) {
      const Z = a.charAt(L), T = h[Z], R = (T == null ? void 0 : T.transform) != null ? T.transform(t.charAt(F)) : t.charAt(F);
      if (!d.includes(L) && T != null ? (R.match(T.pattern) != null ? (u[m](R), T.repeated ? (H === -1 ? H = L : L === c && L !== H && (L = H - C), c === H && (L -= C)) : T.multiple && (P = !0, L -= C), L += C) : T.multiple ? P && (L += C, F -= C, P = !1) : R === j ? j = void 0 : T.optional && (L += C, F -= C), F += C) : (n && !this.isEager() && u[m](Z), R === Z && !this.isEager() ? F += C : j = Z, this.isEager() || (L += C)), this.isEager())
        for (; k(L) && (h[a.charAt(L)] == null || d.includes(L)); ) {
          if (n) {
            if (u[m](a.charAt(L)), t.charAt(F) === a.charAt(L)) {
              L += C, F += C;
              continue;
            }
          } else a.charAt(L) === t.charAt(F) && (F += C);
          L += C;
        }
    }
    return this.memo.set(i, u.join("")), this.memo.get(i);
  }
};
class Xt {
  constructor(t, r = {}) {
    J1(this, "items", /* @__PURE__ */ new Map()), J1(this, "eventAbortController"), J1(this, "onInput", (n) => {
      if (n instanceof CustomEvent && n.type === "input" && !n.isTrusted && !n.bubbles)
        return;
      const i = n.target, a = this.items.get(i);
      if (a === void 0) return;
      const d = "inputType" in n && n.inputType.startsWith("delete"), u = a.isEager(), h = d && u && a.unmasked(i.value) === "" ? "" : i.value;
      this.fixCursor(i, d, () => this.setValue(i, h));
    }), this.options = r, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var r;
    t.value !== "" && t.value !== ((r = this.processInput(t)) == null ? void 0 : r.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const r = this.getOptions(this.options);
    for (const n of t) {
      if (!this.items.has(n)) {
        const { signal: a } = this.eventAbortController;
        n.addEventListener("input", this.onInput, { capture: !0, signal: a });
      }
      const i = new Qt(Yt(n, r));
      this.items.set(n, i), queueMicrotask(() => this.updateValue(n)), n.selectionStart === null && i.isEager() && console.warn("Maska: input of `%s` type is not supported", n.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: r, preProcess: n, postProcess: i, ...a } = t;
    return a;
  }
  fixCursor(t, r, n) {
    var i, a;
    const d = t.selectionStart, u = t.value;
    if (n(), d === null || d === u.length && !r) return;
    const h = t.value, C = u.slice(0, d), m = h.slice(0, d), c = (i = this.processInput(t, C)) == null ? void 0 : i.unmasked, p = (a = this.processInput(t, m)) == null ? void 0 : a.unmasked;
    if (c === void 0 || p === void 0) return;
    let k = d;
    C !== m && (k += r ? h.length - u.length : c.length - p.length), t.setSelectionRange(k, k);
  }
  setValue(t, r) {
    const n = this.processInput(t, r);
    n !== void 0 && (t.value = n.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((i) => i(n)) : this.options.onMaska(n)), t.dispatchEvent(new CustomEvent("maska", { detail: n })), t.dispatchEvent(new CustomEvent("input", { detail: n.masked })));
  }
  processInput(t, r) {
    const n = this.items.get(t);
    if (n === void 0) return;
    let i = r ?? t.value;
    this.options.preProcess != null && (i = this.options.preProcess(i));
    let a = n.masked(i);
    return this.options.postProcess != null && (a = this.options.postProcess(a)), {
      masked: a,
      unmasked: n.unmasked(i),
      completed: n.completed(i)
    };
  }
}
const ye = /* @__PURE__ */ new WeakMap(), Jt = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const r = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : r && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, Ze = (e, t) => {
  var r;
  const n = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (n == null || (n == null ? void 0 : n.type) === "file") return;
  let i = {};
  if (t.value != null && (i = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const a = (d) => {
      const u = t.modifiers.unmasked ? d.unmasked : t.modifiers.completed ? d.completed : d.masked;
      Jt(t, u);
    };
    i.onMaska = i.onMaska == null ? a : Array.isArray(i.onMaska) ? [...i.onMaska, a] : [i.onMaska, a];
  }
  ye.has(n) ? (r = ye.get(n)) == null || r.update(i) : ye.set(n, new Xt(n, i));
}, e2 = { class: "flex flex-col w-full" }, t2 = ["for"], o2 = {
  key: 0,
  class: "text-error"
}, n2 = {
  key: 0,
  class: "inline-flex shrink-0 items-center pl-3 text-subtitle-gray [&_svg]:block"
}, r2 = {
  key: 1,
  class: "flex-1 min-w-0 flex items-center relative"
}, l2 = { class: "text-subtitle-gray shrink-0" }, s2 = ["id", "type", "placeholder", "disabled", "readonly", "autocomplete", "maxlength"], i2 = ["id", "type", "placeholder", "disabled", "readonly", "autocomplete", "maxlength"], a2 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, d2 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, u2 = {
  key: 1,
  class: "text-error text-sm mt-1"
}, c2 = {
  key: 2,
  class: "text-subtitle-gray text-sm mt-1"
}, h2 = /* @__PURE__ */ I({
  __name: "EcxInput",
  props: {
    modelValue: { default: "" },
    label: {},
    placeholder: {},
    type: { default: "text" },
    size: { default: "md" },
    variant: { default: "default" },
    mask: {},
    eager: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    autocomplete: {},
    id: {},
    suffixFollowsText: { type: Boolean, default: !1 },
    maxLength: {},
    decimalKeystrokesOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(!1), u = E(!1), h = f(() => n.id || `ecx-input-${Math.random().toString(36).substr(2, 9)}`), C = f(() => {
      if (n.mask)
        return typeof n.mask == "object" && !Array.isArray(n.mask) ? { ...n.mask, eager: n.eager } : {
          mask: n.mask,
          eager: n.eager
        };
    }), m = f({
      get: () => String(n.modelValue || ""),
      set: (A) => i("update:modelValue", A)
    }), c = () => {
      u.value = !u.value;
    }, p = f(() => n.type === "password" ? u.value ? "text" : "password" : n.type), k = () => {
      d.value = !0, i("focus");
    }, j = () => {
      d.value = !1, i("blur");
    };
    function H(A) {
      if (!n.decimalKeystrokesOnly || n.disabled || n.readonly || A.isComposing || A.inputType === "insertFromPaste" || A.inputType !== "insertText" && A.inputType !== "insertReplacementText")
        return;
      const _ = A.data;
      if (!(_ == null || _ === "")) {
        for (const w of _)
          if (!/[0-9.,]/.test(w)) {
            A.preventDefault();
            return;
          }
      }
    }
    const L = f(() => n.disabled ? "text-grey-400" : n.error ? "text-grey-700" : String(n.modelValue ?? "").trim().length > 0 ? "text-grey-500" : "text-grey-800"), F = f(
      () => n.type === "date" ? "translate-y-0.5" : ""
    ), P = {
      sm: { height: "36px", padding: "px-3 py-2", fontSize: "text-sm" },
      md: { height: "48px", padding: "px-3 py-3", fontSize: "text-base" },
      lg: { height: "56px", padding: "px-4 py-4", fontSize: "text-lg" }
    }, Z = f(() => {
      const A = "w-full rounded-lg flex items-center transition-all duration-200 border bg-white focus-within:outline-none";
      if (n.disabled)
        return `${A} cursor-not-allowed border-grey-200 bg-grey-50`;
      if (n.error)
        return `${A} border-red-500 shadow-[0_0_0_3px_rgba(255,189,198,0.30)]`;
      if (d.value)
        return `${A} border-royal-300 shadow-[0_0_0_3px_rgba(189,191,255,0.30)]`;
      const w = String(n.modelValue ?? "").trim().length > 0 ? "border-grey-200" : "border-grey-300";
      return `${A} ${w}`;
    }), T = f(() => ({
      height: P[n.size].height
    })), R = f(() => {
      const A = P[n.size];
      return [
        "focus:outline-none w-full flex-1 h-full border-0 bg-transparent placeholder:text-grey-600",
        A.padding,
        A.fontSize,
        n.disabled ? "text-grey-400" : "text-default-black",
        { "cursor-not-allowed": n.disabled }
      ];
    });
    return t({
      focus: () => {
        var A;
        return (A = a.value) == null ? void 0 : A.focus();
      },
      blur: () => {
        var A;
        return (A = a.value) == null ? void 0 : A.blur();
      }
    }), (A, _) => (l(), s("div", e2, [
      e.label && !e.hideLabel ? (l(), s("label", {
        key: 0,
        for: h.value,
        class: v(["text-xs font-normal pb-1 transition-colors duration-200", L.value])
      }, [
        h1(M(e.label) + " ", 1),
        e.required ? (l(), s("span", o2, "*")) : x("", !0)
      ], 10, t2)) : x("", !0),
      o("div", {
        class: v(Z.value),
        style: a1(T.value)
      }, [
        A.$slots.prefix ? (l(), s("span", n2, [
          G(A.$slots, "prefix")
        ])) : x("", !0),
        A.$slots.suffix && e.suffixFollowsText ? (l(), s("div", r2, [
          o("span", {
            "aria-hidden": "true",
            class: v(["invisible whitespace-pre pr-1 pointer-events-none select-none", [P[n.size].padding, P[n.size].fontSize, n.disabled ? "text-grey-400" : "text-default-black"]])
          }, M(m.value || " "), 3),
          o("span", l2, [
            G(A.$slots, "suffix")
          ]),
          w1(o("input", {
            id: h.value,
            ref_key: "inputRef",
            ref: a,
            "onUpdate:modelValue": _[0] || (_[0] = (w) => m.value = w),
            type: p.value,
            placeholder: e.placeholder,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete,
            maxlength: e.maxLength,
            class: v(["absolute inset-0 w-full h-full focus:outline-none border-0 bg-transparent placeholder:text-grey-600 min-w-0 text-default-black", [P[n.size].padding, P[n.size].fontSize, n.disabled ? "text-grey-400" : ""]]),
            onFocus: k,
            onBlur: j,
            onBeforeinput: H
          }, null, 42, s2), [
            [Fe, m.value],
            [D(Ze), C.value]
          ])
        ])) : (l(), s(n1, { key: 2 }, [
          w1(o("input", {
            id: h.value,
            ref_key: "inputRef",
            ref: a,
            "onUpdate:modelValue": _[1] || (_[1] = (w) => m.value = w),
            type: p.value,
            placeholder: e.placeholder,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete,
            maxlength: e.maxLength,
            class: v(R.value),
            onFocus: k,
            onBlur: j,
            onBeforeinput: H
          }, null, 42, i2), [
            [Fe, m.value],
            [D(Ze), C.value]
          ]),
          e.type === "password" ? (l(), s("button", {
            key: 0,
            type: "button",
            class: "px-3 text-subtitle-gray hover:text-default-black transition-colors",
            onClick: c
          }, [
            u.value ? (l(), s("svg", a2, [..._[2] || (_[2] = [
              o("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
              }, null, -1)
            ])])) : (l(), s("svg", d2, [..._[3] || (_[3] = [
              o("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              }, null, -1),
              o("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              }, null, -1)
            ])]))
          ])) : x("", !0),
          A.$slots.suffix ? (l(), s("span", {
            key: 1,
            class: v(["inline-flex shrink-0 items-center pr-3 text-subtitle-gray [&_svg]:block", F.value])
          }, [
            G(A.$slots, "suffix")
          ], 2)) : x("", !0)
        ], 64))
      ], 6),
      e.error && !e.hideError ? (l(), s("span", u2, M(e.error), 1)) : x("", !0),
      e.hint && !e.error ? (l(), s("span", c2, M(e.hint), 1)) : x("", !0)
    ]));
  }
}), p2 = { class: "flex flex-col w-full" }, f2 = ["for"], C2 = {
  key: 0,
  class: "text-error"
}, g2 = {
  key: 0,
  class: "pl-3 text-subtitle-gray"
}, v2 = {
  key: 1,
  class: "pl-3 text-subtitle-gray"
}, m2 = ["id", "value", "placeholder", "disabled", "readonly"], x2 = {
  key: 2,
  class: "pr-3 text-subtitle-gray"
}, w2 = {
  key: 1,
  class: "text-error text-sm mt-1"
}, k2 = {
  key: 2,
  class: "text-subtitle-gray text-sm mt-1"
}, hw = /* @__PURE__ */ I({
  __name: "EcxMoneyInput",
  props: {
    modelValue: { default: void 0 },
    label: {},
    placeholder: {},
    size: { default: "md" },
    variant: { default: "default" },
    error: {},
    hint: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    id: {},
    limit: {},
    showCurrencySymbol: { type: Boolean, default: !0 },
    currencySymbol: { default: "R$" },
    locale: { default: "pt-BR" }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(!1), u = E(0), h = f(() => n.id || `ecx-money-input-${Math.random().toString(36).slice(2, 9)}`), C = f(() => n.modelValue !== void 0 && n.modelValue !== null ? n.modelValue : u.value);
    function m(_) {
      if (_ == null) return "";
      const w = _ / 100;
      return new Intl.NumberFormat(n.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(w);
    }
    const c = f(() => m(C.value ?? 0)), p = f(() => (C.value ?? 0) > 0), k = f(() => n.disabled ? "text-grey-400" : n.error ? "text-grey-700" : p.value ? "text-grey-500" : "text-grey-800"), j = {
      sm: { height: "36px", padding: "px-3 py-2", fontSize: "text-sm" },
      md: { height: "48px", padding: "px-3 py-3", fontSize: "text-base" },
      lg: { height: "56px", padding: "px-4 py-4", fontSize: "text-lg" }
    }, H = f(() => {
      const _ = "w-full rounded-lg flex items-center transition-all duration-200 border bg-white focus-within:outline-none";
      if (n.disabled)
        return `${_} cursor-not-allowed opacity-60 border-grey-200 bg-grey-50`;
      if (n.error)
        return `${_} border-red-500 shadow-[0_0_0_3px_rgba(255,189,198,0.30)]`;
      if (d.value)
        return `${_} border-royal-300 shadow-[0_0_0_3px_rgba(189,191,255,0.30)]`;
      const w = p.value ? "border-grey-200" : "border-grey-300";
      return `${_} ${w}`;
    }), L = f(() => ({
      height: j[n.size].height
    })), F = f(() => {
      const _ = j[n.size];
      return [
        "focus:outline-none w-full flex-1 h-full border-0 bg-transparent text-default-black placeholder:text-grey-600",
        _.padding,
        _.fontSize,
        { "cursor-not-allowed": n.disabled }
      ];
    });
    function P(_) {
      _.key.match(/\d/) || _.preventDefault();
    }
    const Z = f(() => n.modelValue !== void 0 && n.modelValue !== null);
    function T(_) {
      const O = _.target.value.replace(/\D/g, "");
      let U = parseInt(O, 10) || 0;
      n.limit !== void 0 && U > n.limit && (U = n.limit), Z.value || (u.value = U), i("update:modelValue", U);
    }
    function R() {
      d.value = !0, i("focus");
    }
    function A() {
      d.value = !1, i("blur");
    }
    return r1(
      () => n.modelValue,
      (_) => {
        _ != null && (u.value = _);
      },
      { immediate: !0 }
    ), r1(
      () => C.value,
      (_) => {
        if (n.limit !== void 0 && _ > n.limit) {
          const w = n.limit;
          Z.value || (u.value = w), i("update:modelValue", w);
        }
      }
    ), t({
      focus: () => {
        var _;
        return (_ = a.value) == null ? void 0 : _.focus();
      },
      blur: () => {
        var _;
        return (_ = a.value) == null ? void 0 : _.blur();
      },
      /** Valor atual em centavos */
      getValue: () => C.value ?? 0
    }), (_, w) => (l(), s("div", p2, [
      e.label && !e.hideLabel ? (l(), s("label", {
        key: 0,
        for: h.value,
        class: v(["text-xs font-normal pb-1 transition-colors duration-200", k.value])
      }, [
        h1(M(e.label) + " ", 1),
        e.required ? (l(), s("span", C2, "*")) : x("", !0)
      ], 10, f2)) : x("", !0),
      o("div", {
        class: v(H.value),
        style: a1(L.value)
      }, [
        _.$slots.prefix ? (l(), s("span", g2, [
          G(_.$slots, "prefix")
        ])) : e.showCurrencySymbol ? (l(), s("span", v2, M(e.currencySymbol), 1)) : x("", !0),
        o("input", {
          id: h.value,
          ref_key: "inputRef",
          ref: a,
          type: "text",
          inputmode: "numeric",
          value: c.value,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          class: v(F.value),
          onInput: T,
          onFocus: R,
          onBlur: A,
          onKeypress: P
        }, null, 42, m2),
        _.$slots.suffix ? (l(), s("span", x2, [
          G(_.$slots, "suffix")
        ])) : x("", !0)
      ], 6),
      e.error && !e.hideError ? (l(), s("span", w2, M(e.error), 1)) : x("", !0),
      e.hint && !e.error ? (l(), s("span", k2, M(e.hint), 1)) : x("", !0)
    ]));
  }
}), y2 = {
  key: 1,
  class: "flex justify-center mb-6"
}, b2 = {
  key: 2,
  class: "text-2xl font-semibold text-default-black text-center mb-4"
}, _2 = ["innerHTML"], M2 = /* @__PURE__ */ I({
  __name: "EcxModal",
  props: {
    open: { type: Boolean },
    title: {},
    description: {},
    icon: {},
    type: { default: "default" },
    size: { default: "md" },
    cancelText: { default: "Cancelar" },
    confirmText: { default: "Confirmar" },
    confirmVariant: { default: "primary" },
    loading: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    showActions: { type: Boolean, default: !0 },
    actionsFullWidth: { type: Boolean, default: !1 },
    actionsCenter: { type: Boolean, default: !0 },
    contentClass: { default: "" }
  },
  emits: ["close", "confirm", "update:open"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(!1);
    r1(() => r.open, (p) => {
      i.value = p;
    }, { immediate: !1 }), m1(() => {
      r.open && s1(() => {
        i.value = !0;
      });
    });
    const a = () => {
      n("update:open", !1), n("close");
    }, d = () => {
      n("confirm");
    }, u = {
      sm: "max-w-sm w-full p-6",
      md: "max-w-md w-full p-8",
      lg: "max-w-lg w-full p-10",
      xl: "max-w-2xl w-full p-12"
    }, h = f(() => u[r.size]), C = {
      default: "bg-royal-25 text-primary",
      success: "bg-green-25 text-green-600",
      warning: "bg-yellow-25 text-yellow-600",
      danger: "bg-red-25 text-error",
      info: "bg-blue-25 text-blue-600"
    }, m = f(() => C[r.type]), c = f(
      () => r.actionsCenter ? "justify-center" : "justify-end"
    );
    return (p, k) => (l(), W(g1, { to: "body" }, [
      J(p1, { name: "modal" }, {
        default: Y(() => [
          i.value ? (l(), s("div", {
            key: 0,
            class: "fixed inset-0 z-[10000] flex items-center justify-center p-4",
            onClick: k[1] || (k[1] = o1((j) => e.closeOnBackdrop && a(), ["self"]))
          }, [
            k[3] || (k[3] = o("div", { class: "absolute inset-0 bg-default-black/25 modal-backdrop pointer-events-none" }, null, -1)),
            o("div", {
              class: v([
                "relative bg-white rounded-xl shadow-xl modal-content",
                h.value,
                e.contentClass
              ]),
              onClick: k[0] || (k[0] = o1(() => {
              }, ["stop"]))
            }, [
              e.showCloseButton ? (l(), s("button", {
                key: 0,
                class: "absolute top-4 right-4 text-subtitle-gray hover:text-default-black transition-colors",
                onClick: a
              }, [...k[2] || (k[2] = [
                o("svg", {
                  class: "w-6 h-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])])) : x("", !0),
              e.icon || p.$slots.icon ? (l(), s("div", y2, [
                G(p.$slots, "icon", {}, () => [
                  e.icon ? (l(), s("div", {
                    key: 0,
                    class: v([
                      "w-16 h-16 rounded-full flex items-center justify-center",
                      m.value
                    ])
                  }, [
                    (l(), W(f1(e.icon), { class: "w-8 h-8" }))
                  ], 2)) : x("", !0)
                ], !0)
              ])) : x("", !0),
              e.title ? (l(), s("h2", b2, M(e.title), 1)) : x("", !0),
              e.description ? (l(), s("p", {
                key: 3,
                class: "text-subtitle-gray text-center mb-8",
                innerHTML: e.description
              }, null, 8, _2)) : x("", !0),
              G(p.$slots, "default", {}, void 0, !0),
              e.showActions ? (l(), s("div", {
                key: 4,
                class: v(["flex gap-4 mt-8", c.value])
              }, [
                G(p.$slots, "actions", {}, () => [
                  e.cancelText ? (l(), W(V1, {
                    key: 0,
                    variant: "secondary",
                    class: v(e.actionsFullWidth ? "flex-1" : "min-w-[140px]"),
                    onClick: a
                  }, {
                    default: Y(() => [
                      h1(M(e.cancelText), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])) : x("", !0),
                  e.confirmText ? (l(), W(V1, {
                    key: 1,
                    variant: e.confirmVariant,
                    loading: e.loading,
                    class: v(e.actionsFullWidth ? "flex-1" : "min-w-[140px]"),
                    onClick: d
                  }, {
                    default: Y(() => [
                      h1(M(e.confirmText), 1)
                    ]),
                    _: 1
                  }, 8, ["variant", "loading", "class"])) : x("", !0)
                ], !0)
              ], 2)) : x("", !0)
            ], 2)
          ])) : x("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), g = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, i] of t)
    r[n] = i;
  return r;
}, pw = /* @__PURE__ */ g(M2, [["__scopeId", "data-v-a65c56ed"]]);
function L2(e, t, r) {
  let n = E(r == null ? void 0 : r.value), i = f(() => e.value !== void 0);
  return [f(() => i.value ? e.value : n.value), function(a) {
    return i.value || (n.value = a), t == null ? void 0 : t(a);
  }];
}
var Ee;
let $2 = Symbol("headlessui.useid"), V2 = 0;
const xe = (Ee = He.useId) != null ? Ee : function() {
  return He.inject($2, () => `${++V2}`)();
};
function C1(e) {
  var t;
  if (e == null || e.value == null) return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function B1(e, t, ...r) {
  if (e in t) {
    let i = t[e];
    return typeof i == "function" ? i(...r) : i;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, B1), n;
}
var B2 = Object.defineProperty, H2 = (e, t, r) => t in e ? B2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Se = (e, t, r) => (H2(e, typeof t != "symbol" ? t + "" : t, r), r);
let F2 = class {
  constructor() {
    Se(this, "current", this.detect()), Se(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Ve = new F2();
function A2(e) {
  if (Ve.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = C1(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let ze = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var j2 = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(j2 || {}), I2 = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(I2 || {}), Z2 = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Z2 || {}), Be = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Be || {});
function tt(e, t = 0) {
  var r;
  return e === ((r = A2(e)) == null ? void 0 : r.body) ? !1 : B1(t, { 0() {
    return e.matches(ze);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(ze)) return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var E2 = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(E2 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function S2(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let i = t(r), a = t(n);
    if (i === null || a === null) return 0;
    let d = i.compareDocumentPosition(a);
    return d & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : d & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function z2() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function D2() {
  return /Android/gi.test(window.navigator.userAgent);
}
function T2() {
  return z2() || D2();
}
function ae(e, t, r) {
  Ve.isServer || ge((n) => {
    document.addEventListener(e, t, r), n(() => document.removeEventListener(e, t, r));
  });
}
function O2(e, t, r) {
  Ve.isServer || ge((n) => {
    window.addEventListener(e, t, r), n(() => window.removeEventListener(e, t, r));
  });
}
function P2(e, t, r = f(() => !0)) {
  function n(a, d) {
    if (!r.value || a.defaultPrevented) return;
    let u = d(a);
    if (u === null || !u.getRootNode().contains(u)) return;
    let h = function C(m) {
      return typeof m == "function" ? C(m()) : Array.isArray(m) || m instanceof Set ? m : [m];
    }(e);
    for (let C of h) {
      if (C === null) continue;
      let m = C instanceof HTMLElement ? C : C1(C);
      if (m != null && m.contains(u) || a.composed && a.composedPath().includes(m)) return;
    }
    return !tt(u, Be.Loose) && u.tabIndex !== -1 && a.preventDefault(), t(a, u);
  }
  let i = E(null);
  ae("pointerdown", (a) => {
    var d, u;
    r.value && (i.value = ((u = (d = a.composedPath) == null ? void 0 : d.call(a)) == null ? void 0 : u[0]) || a.target);
  }, !0), ae("mousedown", (a) => {
    var d, u;
    r.value && (i.value = ((u = (d = a.composedPath) == null ? void 0 : d.call(a)) == null ? void 0 : u[0]) || a.target);
  }, !0), ae("click", (a) => {
    T2() || i.value && (n(a, () => i.value), i.value = null);
  }, !0), ae("touchend", (a) => n(a, () => a.target instanceof HTMLElement ? a.target : null), !0), O2("blur", (a) => n(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function De(e, t) {
  if (e) return e;
  let r = t ?? "button";
  if (typeof r == "string" && r.toLowerCase() === "button") return "button";
}
function R2(e, t) {
  let r = E(De(e.value.type, e.value.as));
  return m1(() => {
    r.value = De(e.value.type, e.value.as);
  }), ge(() => {
    var n;
    r.value || C1(t) && C1(t) instanceof HTMLButtonElement && !((n = C1(t)) != null && n.hasAttribute("type")) && (r.value = "button");
  }), r;
}
function Te(e) {
  return [e.screenX, e.screenY];
}
function N2() {
  let e = E([-1, -1]);
  return { wasMoved(t) {
    let r = Te(t);
    return e.value[0] === r[0] && e.value[1] === r[1] ? !1 : (e.value = r, !0);
  }, update(t) {
    e.value = Te(t);
  } };
}
var Me = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Me || {}), G2 = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(G2 || {});
function W1({ visible: e = !0, features: t = 0, ourProps: r, theirProps: n, ...i }) {
  var a;
  let d = nt(n, r), u = Object.assign(i, { props: d });
  if (e || t & 2 && d.static) return be(u);
  if (t & 1) {
    let h = (a = d.unmount) == null || a ? 0 : 1;
    return B1(h, { 0() {
      return null;
    }, 1() {
      return be({ ...i, props: { ...d, hidden: !0, style: { display: "none" } } });
    } });
  }
  return be(u);
}
function be({ props: e, attrs: t, slots: r, slot: n, name: i }) {
  var a, d;
  let { as: u, ...h } = rt(e, ["unmount", "static"]), C = (a = r.default) == null ? void 0 : a.call(r, n), m = {};
  if (n) {
    let c = !1, p = [];
    for (let [k, j] of Object.entries(n)) typeof j == "boolean" && (c = !0), j === !0 && p.push(k);
    c && (m["data-headlessui-state"] = p.join(" "));
  }
  if (u === "template") {
    if (C = ot(C ?? []), Object.keys(h).length > 0 || Object.keys(t).length > 0) {
      let [c, ...p] = C ?? [];
      if (!W2(c) || p.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(h).concat(Object.keys(t)).map((H) => H.trim()).filter((H, L, F) => F.indexOf(H) === L).sort((H, L) => H.localeCompare(L)).map((H) => `  - ${H}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((H) => `  - ${H}`).join(`
`)].join(`
`));
      let k = nt((d = c.props) != null ? d : {}, h, m), j = Ht(c, k, !0);
      for (let H in k) H.startsWith("on") && (j.props || (j.props = {}), j.props[H] = k[H]);
      return j;
    }
    return Array.isArray(C) && C.length === 1 ? C[0] : C;
  }
  return _e(u, Object.assign({}, h, m), { default: () => C });
}
function ot(e) {
  return e.flatMap((t) => t.type === n1 ? ot(t.children) : [t]);
}
function nt(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let i in n) i.startsWith("on") && typeof n[i] == "function" ? (r[i] != null || (r[i] = []), r[i].push(n[i])) : t[i] = n[i];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r) Object.assign(t, { [n](i, ...a) {
    let d = r[n];
    for (let u of d) {
      if (i instanceof Event && i.defaultPrevented) return;
      u(i, ...a);
    }
  } });
  return t;
}
function U2(e) {
  let t = Object.assign({}, e);
  for (let r in t) t[r] === void 0 && delete t[r];
  return t;
}
function rt(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function W2(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var lt = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(lt || {});
let Y2 = I({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var n;
    let { features: i, ...a } = e, d = { "aria-hidden": (i & 2) === 2 ? !0 : (n = a["aria-hidden"]) != null ? n : void 0, hidden: (i & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return W1({ ourProps: d, theirProps: a, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), st = Symbol("Context");
var te = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(te || {});
function q2() {
  return he(st, null);
}
function K2(e) {
  ee(st, e);
}
var x1 = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(x1 || {});
function Q2(e) {
  throw new Error("Unexpected object: " + e);
}
var k1 = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(k1 || {});
function X2(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0) return null;
  let n = t.resolveActiveIndex(), i = n ?? -1;
  switch (e.focus) {
    case 0: {
      for (let a = 0; a < r.length; ++a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 1: {
      i === -1 && (i = r.length);
      for (let a = i - 1; a >= 0; --a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 2: {
      for (let a = i + 1; a < r.length; ++a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 3: {
      for (let a = r.length - 1; a >= 0; --a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 4: {
      for (let a = 0; a < r.length; ++a) if (t.resolveId(r[a], a, r) === e.id) return a;
      return n;
    }
    case 5:
      return null;
    default:
      Q2(e);
  }
}
function it(e = {}, t = null, r = []) {
  for (let [n, i] of Object.entries(e)) dt(r, at(t, n), i);
  return r;
}
function at(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function dt(e, t, r) {
  if (Array.isArray(r)) for (let [n, i] of r.entries()) dt(e, at(t, n.toString()), i);
  else r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : it(r, t, e);
}
let Oe = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Pe(e) {
  var t, r;
  let n = (t = e.innerText) != null ? t : "", i = e.cloneNode(!0);
  if (!(i instanceof HTMLElement)) return n;
  let a = !1;
  for (let u of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) u.remove(), a = !0;
  let d = a ? (r = i.innerText) != null ? r : "" : n;
  return Oe.test(d) && (d = d.replace(Oe, "")), d;
}
function J2(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let n = r.split(" ").map((i) => {
      let a = document.getElementById(i);
      if (a) {
        let d = a.getAttribute("aria-label");
        return typeof d == "string" ? d.trim() : Pe(a).trim();
      }
      return null;
    }).filter(Boolean);
    if (n.length > 0) return n.join(", ");
  }
  return Pe(e).trim();
}
function e3(e) {
  let t = E(""), r = E("");
  return () => {
    let n = C1(e);
    if (!n) return "";
    let i = n.innerText;
    if (t.value === i) return r.value;
    let a = J2(n).trim().toLowerCase();
    return t.value = i, r.value = a, a;
  };
}
function t3(e, t) {
  return e === t;
}
var o3 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(o3 || {}), n3 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(n3 || {}), r3 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(r3 || {});
function l3(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let ut = Symbol("ListboxContext");
function ne(e) {
  let t = he(ut, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ne), r;
  }
  return t;
}
let D1 = I({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => t3 }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: r, emit: n }) {
  let i = E(1), a = E(null), d = E(null), u = E(null), h = E([]), C = E(""), m = E(null), c = E(1);
  function p(Z = (T) => T) {
    let T = m.value !== null ? h.value[m.value] : null, R = S2(Z(h.value.slice()), (_) => C1(_.dataRef.domRef)), A = T ? R.indexOf(T) : null;
    return A === -1 && (A = null), { options: R, activeOptionIndex: A };
  }
  let k = f(() => e.multiple ? 1 : 0), [j, H] = L2(f(() => e.modelValue), (Z) => n("update:modelValue", Z), f(() => e.defaultValue)), L = f(() => j.value === void 0 ? B1(k.value, { 1: [], 0: void 0 }) : j.value), F = { listboxState: i, value: L, mode: k, compare(Z, T) {
    if (typeof e.by == "string") {
      let R = e.by;
      return (Z == null ? void 0 : Z[R]) === (T == null ? void 0 : T[R]);
    }
    return e.by(Z, T);
  }, orientation: f(() => e.horizontal ? "horizontal" : "vertical"), labelRef: a, buttonRef: d, optionsRef: u, disabled: f(() => e.disabled), options: h, searchQuery: C, activeOptionIndex: m, activationTrigger: c, closeListbox() {
    e.disabled || i.value !== 1 && (i.value = 1, m.value = null);
  }, openListbox() {
    e.disabled || i.value !== 0 && (i.value = 0);
  }, goToOption(Z, T, R) {
    if (e.disabled || i.value === 1) return;
    let A = p(), _ = X2(Z === k1.Specific ? { focus: k1.Specific, id: T } : { focus: Z }, { resolveItems: () => A.options, resolveActiveIndex: () => A.activeOptionIndex, resolveId: (w) => w.id, resolveDisabled: (w) => w.dataRef.disabled });
    C.value = "", m.value = _, c.value = R ?? 1, h.value = A.options;
  }, search(Z) {
    if (e.disabled || i.value === 1) return;
    let T = C.value !== "" ? 0 : 1;
    C.value += Z.toLowerCase();
    let R = (m.value !== null ? h.value.slice(m.value + T).concat(h.value.slice(0, m.value + T)) : h.value).find((_) => _.dataRef.textValue.startsWith(C.value) && !_.dataRef.disabled), A = R ? h.value.indexOf(R) : -1;
    A === -1 || A === m.value || (m.value = A, c.value = 1);
  }, clearSearch() {
    e.disabled || i.value !== 1 && C.value !== "" && (C.value = "");
  }, registerOption(Z, T) {
    let R = p((A) => [...A, { id: Z, dataRef: T }]);
    h.value = R.options, m.value = R.activeOptionIndex;
  }, unregisterOption(Z) {
    let T = p((R) => {
      let A = R.findIndex((_) => _.id === Z);
      return A !== -1 && R.splice(A, 1), R;
    });
    h.value = T.options, m.value = T.activeOptionIndex, c.value = 1;
  }, theirOnChange(Z) {
    e.disabled || H(Z);
  }, select(Z) {
    e.disabled || H(B1(k.value, { 0: () => Z, 1: () => {
      let T = L1(F.value.value).slice(), R = L1(Z), A = T.findIndex((_) => F.compare(R, L1(_)));
      return A === -1 ? T.push(R) : T.splice(A, 1), T;
    } }));
  } };
  P2([d, u], (Z, T) => {
    var R;
    F.closeListbox(), tt(T, Be.Loose) || (Z.preventDefault(), (R = C1(d)) == null || R.focus());
  }, f(() => i.value === 0)), ee(ut, F), K2(f(() => B1(i.value, { 0: te.Open, 1: te.Closed })));
  let P = f(() => {
    var Z;
    return (Z = C1(d)) == null ? void 0 : Z.closest("form");
  });
  return m1(() => {
    r1([P], () => {
      if (!P.value || e.defaultValue === void 0) return;
      function Z() {
        F.theirOnChange(e.defaultValue);
      }
      return P.value.addEventListener("reset", Z), () => {
        var T;
        (T = P.value) == null || T.removeEventListener("reset", Z);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: Z, modelValue: T, disabled: R, form: A, ..._ } = e, w = { open: i.value === 0, disabled: R, value: L.value };
    return _e(n1, [...Z != null && L.value != null ? it({ [Z]: L.value }).map(([O, U]) => _e(Y2, U2({ features: lt.Hidden, key: O, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: A, disabled: R, name: O, value: U }))) : [], W1({ ourProps: {}, theirProps: { ...r, ...rt(_, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: w, slots: t, attrs: r, name: "Listbox" })]);
  };
} });
I({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-listbox-label-${xe()}`, a = ne("ListboxLabel");
  function d() {
    var u;
    (u = C1(a.buttonRef)) == null || u.focus({ preventScroll: !0 });
  }
  return () => {
    let u = { open: a.listboxState.value === 0, disabled: a.disabled.value }, { ...h } = e, C = { id: i, ref: a.labelRef, onClick: d };
    return W1({ ourProps: C, theirProps: h, slot: u, attrs: t, slots: r, name: "ListboxLabel" });
  };
} });
let T1 = I({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: n }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-button-${xe()}`, d = ne("ListboxButton");
  n({ el: d.buttonRef, $el: d.buttonRef });
  function u(c) {
    switch (c.key) {
      case x1.Space:
      case x1.Enter:
      case x1.ArrowDown:
        c.preventDefault(), d.openListbox(), s1(() => {
          var p;
          (p = C1(d.optionsRef)) == null || p.focus({ preventScroll: !0 }), d.value.value || d.goToOption(k1.First);
        });
        break;
      case x1.ArrowUp:
        c.preventDefault(), d.openListbox(), s1(() => {
          var p;
          (p = C1(d.optionsRef)) == null || p.focus({ preventScroll: !0 }), d.value.value || d.goToOption(k1.Last);
        });
        break;
    }
  }
  function h(c) {
    switch (c.key) {
      case x1.Space:
        c.preventDefault();
        break;
    }
  }
  function C(c) {
    d.disabled.value || (d.listboxState.value === 0 ? (d.closeListbox(), s1(() => {
      var p;
      return (p = C1(d.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })) : (c.preventDefault(), d.openListbox(), l3(() => {
      var p;
      return (p = C1(d.optionsRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })));
  }
  let m = R2(f(() => ({ as: e.as, type: t.type })), d.buttonRef);
  return () => {
    var c, p;
    let k = { open: d.listboxState.value === 0, disabled: d.disabled.value, value: d.value.value }, { ...j } = e, H = { ref: d.buttonRef, id: a, type: m.value, "aria-haspopup": "listbox", "aria-controls": (c = C1(d.optionsRef)) == null ? void 0 : c.id, "aria-expanded": d.listboxState.value === 0, "aria-labelledby": d.labelRef.value ? [(p = C1(d.labelRef)) == null ? void 0 : p.id, a].join(" ") : void 0, disabled: d.disabled.value === !0 ? !0 : void 0, onKeydown: u, onKeyup: h, onClick: C };
    return W1({ ourProps: H, theirProps: j, slot: k, attrs: t, slots: r, name: "ListboxButton" });
  };
} }), O1 = I({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: n }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-options-${xe()}`, d = ne("ListboxOptions"), u = E(null);
  n({ el: d.optionsRef, $el: d.optionsRef });
  function h(c) {
    switch (u.value && clearTimeout(u.value), c.key) {
      case x1.Space:
        if (d.searchQuery.value !== "") return c.preventDefault(), c.stopPropagation(), d.search(c.key);
      case x1.Enter:
        if (c.preventDefault(), c.stopPropagation(), d.activeOptionIndex.value !== null) {
          let p = d.options.value[d.activeOptionIndex.value];
          d.select(p.dataRef.value);
        }
        d.mode.value === 0 && (d.closeListbox(), s1(() => {
          var p;
          return (p = C1(d.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        }));
        break;
      case B1(d.orientation.value, { vertical: x1.ArrowDown, horizontal: x1.ArrowRight }):
        return c.preventDefault(), c.stopPropagation(), d.goToOption(k1.Next);
      case B1(d.orientation.value, { vertical: x1.ArrowUp, horizontal: x1.ArrowLeft }):
        return c.preventDefault(), c.stopPropagation(), d.goToOption(k1.Previous);
      case x1.Home:
      case x1.PageUp:
        return c.preventDefault(), c.stopPropagation(), d.goToOption(k1.First);
      case x1.End:
      case x1.PageDown:
        return c.preventDefault(), c.stopPropagation(), d.goToOption(k1.Last);
      case x1.Escape:
        c.preventDefault(), c.stopPropagation(), d.closeListbox(), s1(() => {
          var p;
          return (p = C1(d.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case x1.Tab:
        c.preventDefault(), c.stopPropagation();
        break;
      default:
        c.key.length === 1 && (d.search(c.key), u.value = setTimeout(() => d.clearSearch(), 350));
        break;
    }
  }
  let C = q2(), m = f(() => C !== null ? (C.value & te.Open) === te.Open : d.listboxState.value === 0);
  return () => {
    var c, p;
    let k = { open: d.listboxState.value === 0 }, { ...j } = e, H = { "aria-activedescendant": d.activeOptionIndex.value === null || (c = d.options.value[d.activeOptionIndex.value]) == null ? void 0 : c.id, "aria-multiselectable": d.mode.value === 1 ? !0 : void 0, "aria-labelledby": (p = C1(d.buttonRef)) == null ? void 0 : p.id, "aria-orientation": d.orientation.value, id: a, onKeydown: h, role: "listbox", tabIndex: 0, ref: d.optionsRef };
    return W1({ ourProps: H, theirProps: j, slot: k, attrs: t, slots: r, features: Me.RenderStrategy | Me.Static, visible: m.value, name: "ListboxOptions" });
  };
} }), F1 = I({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r, expose: n }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-option-${xe()}`, d = ne("ListboxOption"), u = E(null);
  n({ el: u, $el: u });
  let h = f(() => d.activeOptionIndex.value !== null ? d.options.value[d.activeOptionIndex.value].id === a : !1), C = f(() => B1(d.mode.value, { 0: () => d.compare(L1(d.value.value), L1(e.value)), 1: () => L1(d.value.value).some((Z) => d.compare(L1(Z), L1(e.value))) })), m = f(() => B1(d.mode.value, { 1: () => {
    var Z;
    let T = L1(d.value.value);
    return ((Z = d.options.value.find((R) => T.some((A) => d.compare(L1(A), L1(R.dataRef.value))))) == null ? void 0 : Z.id) === a;
  }, 0: () => C.value })), c = e3(u), p = f(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return c();
  }, domRef: u }));
  m1(() => d.registerOption(a, p)), y1(() => d.unregisterOption(a)), m1(() => {
    r1([d.listboxState, C], () => {
      d.listboxState.value === 0 && C.value && B1(d.mode.value, { 1: () => {
        m.value && d.goToOption(k1.Specific, a);
      }, 0: () => {
        d.goToOption(k1.Specific, a);
      } });
    }, { immediate: !0 });
  }), ge(() => {
    d.listboxState.value === 0 && h.value && d.activationTrigger.value !== 0 && s1(() => {
      var Z, T;
      return (T = (Z = C1(u)) == null ? void 0 : Z.scrollIntoView) == null ? void 0 : T.call(Z, { block: "nearest" });
    });
  });
  function k(Z) {
    if (e.disabled) return Z.preventDefault();
    d.select(e.value), d.mode.value === 0 && (d.closeListbox(), s1(() => {
      var T;
      return (T = C1(d.buttonRef)) == null ? void 0 : T.focus({ preventScroll: !0 });
    }));
  }
  function j() {
    if (e.disabled) return d.goToOption(k1.Nothing);
    d.goToOption(k1.Specific, a);
  }
  let H = N2();
  function L(Z) {
    H.update(Z);
  }
  function F(Z) {
    H.wasMoved(Z) && (e.disabled || h.value || d.goToOption(k1.Specific, a, 0));
  }
  function P(Z) {
    H.wasMoved(Z) && (e.disabled || h.value && d.goToOption(k1.Nothing));
  }
  return () => {
    let { disabled: Z } = e, T = { active: h.value, selected: C.value, disabled: Z }, { value: R, disabled: A, ..._ } = e, w = { id: a, ref: u, role: "option", tabIndex: Z === !0 ? void 0 : -1, "aria-disabled": Z === !0 ? !0 : void 0, "aria-selected": C.value, disabled: void 0, onClick: k, onFocus: j, onPointerenter: L, onMouseenter: L, onPointermove: F, onMousemove: F, onPointerleave: P, onMouseleave: P };
    return W1({ ourProps: w, theirProps: _, slot: T, attrs: r, slots: t, name: "ListboxOption" });
  };
} });
const s3 = { class: "ecx-select flex flex-col gap-1" }, i3 = ["for"], a3 = {
  key: 0,
  class: "text-error"
}, d3 = { class: "relative" }, u3 = {
  key: 0,
  class: "inline-flex shrink-0 items-center text-subtitle-gray [&_svg]:block",
  "aria-hidden": "true"
}, c3 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, h3 = { class: "relative cursor-pointer select-none py-3 px-4 hover:bg-grey-50" }, p3 = { class: "text-subtitle-gray italic" }, f3 = {
  key: 0,
  class: "block truncate text-xs text-subtitle-gray mt-0.5"
}, C3 = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-4 text-primary"
}, g3 = {
  key: 1,
  class: "py-3 px-4 text-subtitle-gray text-center"
}, v3 = {
  key: 0,
  class: "text-xs text-error"
}, m3 = {
  key: 1,
  class: "text-xs text-subtitle-gray"
}, x3 = 240, w3 = /* @__PURE__ */ I({
  __name: "EcxSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: { default: "Selecione..." },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    error: {},
    hideError: { type: Boolean, default: !1 },
    hint: {},
    required: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    clearText: { default: "Limpar seleção" },
    emptyText: { default: "Nenhuma opção disponível" },
    id: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const r = Ft(), n = E(!1);
    function i(k) {
      const H = k.currentTarget.getBoundingClientRect();
      n.value = window.innerHeight - H.bottom < x3;
    }
    const a = f(() => !!r.prefix), d = e, u = t, h = f(() => d.id || `ecx-select-${Math.random().toString(36).substr(2, 9)}`), C = f({
      get: () => d.modelValue ?? null,
      set: (k) => {
        u("update:modelValue", k), u("change", k);
      }
    }), m = f(() => d.disabled ? "text-grey-400" : d.error ? "text-grey-700" : C.value != null && C.value !== "" ? "text-grey-500" : "text-grey-800"), c = f(() => {
      const k = d.options.find((j) => j.value === d.modelValue);
      return k == null ? void 0 : k.label;
    }), p = f(() => ({
      sm: "min-h-[36px] text-sm",
      md: "min-h-[44px] text-base",
      lg: "min-h-[52px] text-lg"
    })[d.size]);
    return (k, j) => (l(), s("div", s3, [
      J(D(D1), {
        modelValue: C.value,
        "onUpdate:modelValue": j[0] || (j[0] = (H) => C.value = H),
        disabled: e.disabled
      }, {
        default: Y(({ open: H }) => [
          e.label ? (l(), s("label", {
            key: 0,
            for: h.value,
            class: v(["text-xs font-normal transition-colors duration-200", m.value])
          }, [
            h1(M(e.label) + " ", 1),
            e.required ? (l(), s("span", a3, "*")) : x("", !0)
          ], 10, i3)) : x("", !0),
          o("div", d3, [
            J(D(T1), {
              onMousedown: i,
              id: h.value,
              class: v([
                "relative flex w-full cursor-pointer items-center rounded-lg border py-3 pr-10 text-left transition-all",
                a.value ? "pl-3" : "pl-4",
                "focus:outline-none focus:border-royal-300 focus:shadow-[0_0_0_3px_rgba(189,191,255,0.30)] focus:bg-white",
                e.disabled ? "bg-grey-50 border-grey-400 cursor-not-allowed opacity-60" : "bg-white",
                e.error ? "border-2 border-error" : C.value ? "border-grey-200" : "border-grey-300",
                p.value
              ])
            }, {
              default: Y(() => [
                k.$slots.prefix ? (l(), s("span", u3, [
                  G(k.$slots, "prefix")
                ])) : x("", !0),
                o("span", {
                  class: v([
                    "min-w-0 flex-1 truncate",
                    a.value ? "pl-2" : "",
                    !C.value && "text-form-placeholder"
                  ])
                }, M(c.value || e.placeholder), 3),
                o("span", c3, [
                  (l(), s("svg", {
                    class: v(["h-5 w-5 text-subtitle-gray transition-transform duration-200", { "rotate-180": H }]),
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [...j[1] || (j[1] = [
                    o("path", {
                      "fill-rule": "evenodd",
                      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ])], 2))
                ])
              ]),
              _: 2
            }, 1032, ["id", "class"]),
            J(p1, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: Y(() => [
                J(D(O1), {
                  class: v([
                    "absolute z-50 max-h-60 w-full overflow-auto rounded-lg bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                    n.value ? "bottom-full mb-1" : "mt-1"
                  ])
                }, {
                  default: Y(() => [
                    e.clearable && C.value ? (l(), W(D(F1), {
                      key: 0,
                      value: null,
                      as: "template"
                    }, {
                      default: Y(() => [
                        o("li", h3, [
                          o("span", p3, M(e.clearText), 1)
                        ])
                      ]),
                      _: 1
                    })) : x("", !0),
                    (l(!0), s(n1, null, u1(e.options, (L) => (l(), W(D(F1), {
                      key: String(L.value),
                      value: L.value,
                      disabled: L.disabled
                    }, {
                      default: Y(({ active: F, selected: P, disabled: Z }) => [
                        o("div", {
                          class: v([
                            "relative cursor-pointer select-none py-3 px-4",
                            F && !Z ? "bg-royal-25" : "",
                            Z ? "opacity-50 cursor-not-allowed" : ""
                          ])
                        }, [
                          o("span", {
                            class: v(["block truncate", P ? "font-semibold text-primary" : "font-normal"])
                          }, M(L.label), 3),
                          L.description ? (l(), s("span", f3, M(L.description), 1)) : x("", !0),
                          P ? (l(), s("span", C3, [...j[2] || (j[2] = [
                            o("svg", {
                              class: "h-5 w-5",
                              viewBox: "0 0 20 20",
                              fill: "currentColor"
                            }, [
                              o("path", {
                                "fill-rule": "evenodd",
                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                "clip-rule": "evenodd"
                              })
                            ], -1)
                          ])])) : x("", !0)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value", "disabled"]))), 128)),
                    e.options.length ? x("", !0) : (l(), s("div", g3, M(e.emptyText), 1))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"]),
      e.error && !e.hideError ? (l(), s("span", v3, M(e.error), 1)) : e.hint ? (l(), s("span", m3, M(e.hint), 1)) : x("", !0)
    ]));
  }
}), k3 = ["value", "data-testid", "placeholder", "disabled"], Cw = /* @__PURE__ */ I({
  __name: "EcxSearchInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Pesquisar..." },
    size: { default: "md" },
    variant: { default: "default" },
    width: { default: "w-64" },
    disabled: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    inputTestId: { default: void 0 }
  },
  emits: ["update:modelValue", "enter", "clear"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(!1), u = (L) => {
      const F = L.target;
      i("update:modelValue", F.value);
    }, h = () => {
      i("enter");
    }, C = () => {
      var L;
      i("update:modelValue", ""), i("clear"), (L = a.value) == null || L.focus();
    }, m = {
      sm: {
        container: "gap-x-2 h-8",
        icon: "w-4 h-4",
        input: "text-sm"
      },
      md: {
        container: "gap-x-3 h-10",
        icon: "w-5 h-5",
        input: "text-base"
      },
      lg: {
        container: "gap-x-4 h-12",
        icon: "w-6 h-6",
        input: "text-lg"
      }
    }, c = {
      default: {
        container: "",
        input: "placeholder:text-subtitle-gray placeholder:opacity-50 text-default-black"
      },
      filled: {
        container: "bg-grey-50 rounded-lg px-3",
        input: "placeholder:text-subtitle-gray placeholder:opacity-50 text-default-black"
      },
      outlined: {
        container: "border border-grey-200 border-solid rounded-lg px-3 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary",
        input: "placeholder:text-subtitle-gray placeholder:opacity-50 text-default-black"
      }
    }, p = f(() => [
      n.width,
      m[n.size].container,
      c[n.variant].container,
      n.disabled && "opacity-50 cursor-not-allowed"
    ]), k = f(() => m[n.size].icon), j = f(() => m[n.size].input), H = f(() => [
      "w-full font-normal",
      c[n.variant].input,
      n.disabled && "cursor-not-allowed"
    ]);
    return t({
      focus: () => {
        var L;
        return (L = a.value) == null ? void 0 : L.focus();
      },
      blur: () => {
        var L;
        return (L = a.value) == null ? void 0 : L.blur();
      },
      clear: C
    }), (L, F) => (l(), s("div", {
      class: v(["flex items-center", p.value])
    }, [
      (l(), s("svg", {
        class: v(["flex-shrink-0 text-subtitle-gray", k.value]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...F[2] || (F[2] = [
        o("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        }, null, -1)
      ])], 2)),
      o("input", {
        ref_key: "inputRef",
        ref: a,
        value: e.modelValue,
        "data-testid": e.inputTestId,
        class: v([
          "bg-transparent focus:outline-none text-ellipsis",
          H.value,
          j.value
        ]),
        placeholder: e.placeholder,
        disabled: e.disabled,
        onInput: u,
        onKeyup: G1(h, ["enter"]),
        onFocus: F[0] || (F[0] = (P) => d.value = !0),
        onBlur: F[1] || (F[1] = (P) => d.value = !1)
      }, null, 42, k3),
      e.clearable && e.modelValue ? (l(), s("button", {
        key: 0,
        type: "button",
        class: "flex-shrink-0 p-1 hover:bg-grey-100 rounded-full transition-colors",
        onClick: C
      }, [...F[3] || (F[3] = [
        o("svg", {
          class: "w-4 h-4 text-subtitle-gray",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })
        ], -1)
      ])])) : x("", !0),
      G(L.$slots, "suffix")
    ], 2));
  }
}), y3 = ["checked", "disabled", "name", "value", "data-testid"], b3 = {
  key: 0,
  class: "flex-1"
}, _3 = {
  key: 0,
  class: "text-error ml-0.5"
}, M3 = {
  key: 1,
  class: "text-sm text-subtitle-gray mt-0.5"
}, L3 = {
  key: 2,
  class: "text-xs text-error block mt-1"
}, $3 = /* @__PURE__ */ I({
  __name: "EcxCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    value: {},
    name: {},
    label: {},
    description: {},
    size: { default: "md" },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    error: {},
    required: { type: Boolean, default: !1 },
    weight: { default: "md" },
    inputTestId: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = f(() => Array.isArray(n.modelValue) ? n.modelValue.includes(n.value) : n.modelValue === !0), u = (j) => {
      const H = j.target.checked;
      if (Array.isArray(n.modelValue)) {
        const L = [...n.modelValue];
        if (H)
          L.push(n.value);
        else {
          const F = L.indexOf(n.value);
          F > -1 && L.splice(F, 1);
        }
        i("update:modelValue", L);
      } else
        i("update:modelValue", H);
      i("change", H);
    }, h = f(() => ({
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6"
    })[n.size]), C = f(() => ({
      sm: "w-3 h-3",
      md: "w-3.5 h-3.5",
      lg: "w-4 h-4"
    })[n.size]), m = f(() => ({
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg"
    })[n.size]), c = f(() => ({
      sm: "font-normal",
      md: "font-medium",
      lg: "font-semibold"
    })[n.weight]), p = f(() => [
      "flex items-center gap-6 p-4 rounded-lg border-2 transition-all",
      d.value ? "border-primary bg-royal-25" : "border-grey-200 hover:border-grey-300"
    ]), k = f(() => [!!(n.description || n.error) ? "items-start" : "items-center", "gap-3"]);
    return t({
      focus: () => {
        var j;
        return (j = a.value) == null ? void 0 : j.focus();
      }
    }), (j, H) => (l(), s("label", {
      class: v([
        "ecx-checkbox group relative flex cursor-pointer",
        e.disabled ? "cursor-not-allowed opacity-60" : "",
        e.variant === "card" ? p.value : k.value
      ])
    }, [
      o("input", {
        ref_key: "inputRef",
        ref: a,
        type: "checkbox",
        checked: d.value,
        disabled: e.disabled,
        name: e.name,
        value: e.value,
        class: "sr-only",
        "data-testid": e.inputTestId,
        onChange: u
      }, null, 40, y3),
      o("div", {
        class: v([
          "flex-shrink-0 flex items-center justify-center rounded border-2 transition-all",
          h.value,
          d.value ? "bg-primary border-primary text-white" : "bg-white border-grey-300 group-hover:border-grey-400",
          e.disabled ? "" : "group-hover:ring-2 group-hover:ring-primary group-hover:ring-offset-2",
          e.error ? "border-error" : ""
        ])
      }, [
        d.value ? (l(), s("svg", {
          key: 0,
          class: v(C.value),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [...H[0] || (H[0] = [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "3",
            d: "M5 13l4 4L19 7"
          }, null, -1)
        ])], 2)) : x("", !0)
      ], 2),
      e.label || e.description || e.error || j.$slots.default ? (l(), s("div", b3, [
        e.label ? (l(), s("span", {
          key: 0,
          class: v(["text-default-black", m.value, c.value])
        }, [
          G(j.$slots, "default", {}, () => [
            h1(M(e.label), 1)
          ]),
          e.required ? (l(), s("span", _3, "*")) : x("", !0)
        ], 2)) : x("", !0),
        e.description ? (l(), s("p", M3, M(e.description), 1)) : x("", !0),
        e.error ? (l(), s("span", L3, M(e.error), 1)) : x("", !0)
      ])) : x("", !0)
    ], 2));
  }
}), V3 = ["checked", "disabled", "name", "value"], B3 = ["aria-checked", "onKeydown"], H3 = {
  key: 0,
  class: "absolute inset-1/4 rounded-full bg-royal-500"
}, gw = /* @__PURE__ */ I({
  __name: "EcxRadio",
  props: {
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    name: {},
    value: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = f(
      () => n.value !== void 0 ? String(n.value) : void 0
    );
    function u() {
      if (n.disabled) return;
      const p = !n.modelValue;
      i("update:modelValue", p), i("change", p);
    }
    function h(p) {
      p.preventDefault(), u();
    }
    function C(p) {
      n.disabled || p.target.getAttribute("role") === "radio" || (p.preventDefault(), u());
    }
    function m() {
      u();
    }
    function c() {
      u();
    }
    return t({
      focus: () => {
        var p;
        return (p = a.value) == null ? void 0 : p.focus();
      }
    }), (p, k) => (l(), s("label", {
      class: v([
        "ecx-radio group relative flex cursor-pointer items-center",
        e.disabled ? "cursor-not-allowed opacity-60" : ""
      ]),
      onClick: C
    }, [
      o("input", {
        ref_key: "inputRef",
        ref: a,
        type: "radio",
        checked: e.modelValue,
        disabled: e.disabled,
        name: e.name,
        value: d.value,
        class: "sr-only",
        "aria-hidden": !0
      }, null, 8, V3),
      o("div", {
        role: "radio",
        "aria-checked": e.modelValue,
        class: v([
          "relative flex shrink-0 items-center justify-center rounded-full border-2 transition-all w-4 h-4",
          e.modelValue ? "border-royal-200" : "border-grey-300"
        ]),
        tabindex: "0",
        onClick: o1(h, ["stop"]),
        onKeydown: [
          G1(o1(m, ["prevent"]), ["enter"]),
          G1(o1(c, ["prevent"]), ["space"])
        ]
      }, [
        e.modelValue ? (l(), s("div", H3)) : x("", !0)
      ], 42, B3),
      G(p.$slots, "default")
    ], 2));
  }
}), F3 = {
  class: "ecx-stepper-indicator",
  "aria-label": "Progress"
}, A3 = { class: "flex items-center" }, j3 = {
  key: 0,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, I3 = { key: 1 }, Z3 = {
  key: 0,
  class: "flex justify-between mt-2"
}, E3 = /* @__PURE__ */ I({
  __name: "EcxStepperIndicator",
  props: {
    steps: {},
    currentStep: {},
    size: { default: "md" },
    variant: { default: "default" },
    labels: {}
  },
  setup(e) {
    const t = e, r = f(() => ({
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg"
    })[t.size]), n = (i) => i === t.currentStep ? "border-2 border-primary text-primary bg-white shadow-lg" : i < t.currentStep ? "border-2 border-primary bg-primary text-white shadow-md" : "border-2 border-grey-200 text-grey-400 bg-white";
    return (i, a) => (l(), s("nav", F3, [
      o("ol", {
        class: v(["flex items-center", e.variant === "default" ? "justify-center gap-0" : "gap-4"])
      }, [
        (l(!0), s(n1, null, u1(e.steps, (d) => (l(), s(n1, { key: d }, [
          o("li", A3, [
            o("div", {
              class: v([
                "flex items-center justify-center rounded-full font-semibold transition-all duration-300",
                r.value,
                n(d - 1)
              ])
            }, [
              d - 1 < e.currentStep ? (l(), s("svg", j3, [...a[0] || (a[0] = [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])])) : (l(), s("span", I3, M(d), 1))
            ], 2)
          ]),
          d < e.steps ? (l(), s("li", {
            key: 0,
            class: v([
              "flex-1 transition-all duration-300",
              e.variant === "default" ? "h-1 min-w-[40px]" : "h-0.5 min-w-[60px]",
              d - 1 < e.currentStep ? "bg-primary" : "bg-grey-200"
            ])
          }, null, 2)) : x("", !0)
        ], 64))), 128))
      ], 2),
      e.labels && e.labels.length ? (l(), s("div", Z3, [
        (l(!0), s(n1, null, u1(e.labels, (d, u) => (l(), s("span", {
          key: u,
          class: v([
            "text-xs font-medium text-center flex-1",
            u <= e.currentStep ? "text-primary" : "text-subtitle-gray"
          ])
        }, M(d), 3))), 128))
      ])) : x("", !0)
    ]));
  }
}), S3 = { class: "ecx-stepper" }, z3 = { class: "ecx-stepper-content" }, vw = /* @__PURE__ */ I({
  __name: "EcxStepper",
  props: {
    initialStep: { default: 0 },
    showIndicator: { type: Boolean, default: !0 },
    showNavigation: { type: Boolean, default: !0 },
    showCancel: { type: Boolean, default: !0 },
    canProceed: { type: Boolean, default: !0 },
    prevText: { default: "Voltar" },
    nextText: { default: "Próximo" },
    finishText: { default: "Finalizar" },
    cancelText: { default: "Cancelar" },
    loading: { type: Boolean, default: !1 },
    indicatorClass: {},
    navigationClass: { default: "justify-center mt-8" },
    buttonClass: { default: "min-w-[140px]" }
  },
  emits: ["update:step", "finish", "cancel", "step-change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(n.initialStep), d = E(0);
    ee("STEP_COUNTER", d), ee("CURRENT_STEP_INDEX", a);
    const u = f(() => a.value === 0), h = f(() => a.value === d.value - 1), C = () => {
      !h.value && n.canProceed && (a.value++, i("step-change", a.value, "next"), i("update:step", a.value));
    }, m = () => {
      u.value || (a.value--, i("step-change", a.value, "prev"), i("update:step", a.value));
    }, c = (j) => {
      if (j >= 0 && j < d.value) {
        const H = j > a.value ? "next" : "prev";
        a.value = j, i("step-change", j, H), i("update:step", j);
      }
    }, p = () => {
      n.canProceed && i("finish");
    }, k = () => {
      i("cancel");
    };
    return r1(
      () => n.initialStep,
      (j) => {
        j !== a.value && (a.value = j);
      }
    ), t({
      next: C,
      prev: m,
      goTo: c,
      currentStep: a,
      stepCount: d,
      isFirstStep: u,
      isLastStep: h
    }), (j, H) => (l(), s("div", S3, [
      e.showIndicator ? (l(), W(E3, {
        key: 0,
        steps: d.value,
        "current-step": a.value,
        class: v(e.indicatorClass)
      }, null, 8, ["steps", "current-step", "class"])) : x("", !0),
      o("div", z3, [
        G(j.$slots, "default")
      ]),
      e.showNavigation ? (l(), s("div", {
        key: 1,
        class: v(["ecx-stepper-navigation flex gap-3", e.navigationClass])
      }, [
        G(j.$slots, "navigation", {
          isFirst: u.value,
          isLast: h.value,
          next: C,
          prev: m
        }, () => [
          e.showCancel && u.value ? (l(), W(V1, {
            key: 0,
            variant: "danger-outline",
            text: e.cancelText,
            class: v(e.buttonClass),
            onClick: k
          }, null, 8, ["text", "class"])) : x("", !0),
          u.value ? x("", !0) : (l(), W(V1, {
            key: 1,
            variant: "secondary",
            text: e.prevText,
            class: v(e.buttonClass),
            onClick: m
          }, {
            iconLeft: Y(() => [...H[0] || (H[0] = [
              o("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                o("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 19l-7-7 7-7"
                })
              ], -1)
            ])]),
            _: 1
          }, 8, ["text", "class"])),
          h.value ? x("", !0) : (l(), W(V1, {
            key: 2,
            text: e.nextText,
            disabled: !e.canProceed,
            class: v(e.buttonClass),
            onClick: C
          }, {
            iconRight: Y(() => [...H[1] || (H[1] = [
              o("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                o("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 5l7 7-7 7"
                })
              ], -1)
            ])]),
            _: 1
          }, 8, ["text", "disabled", "class"])),
          h.value ? (l(), W(V1, {
            key: 3,
            text: e.finishText,
            disabled: !e.canProceed,
            loading: e.loading,
            class: v(e.buttonClass),
            onClick: p
          }, null, 8, ["text", "disabled", "loading", "class"])) : x("", !0)
        ])
      ], 2)) : x("", !0)
    ]));
  }
}), D3 = { class: "ecx-step" }, mw = /* @__PURE__ */ I({
  __name: "EcxStep",
  props: {
    title: {},
    description: {},
    disabled: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const r = he("STEP_COUNTER"), n = he("CURRENT_STEP_INDEX"), i = E(-1);
    m1(() => {
      i.value = r.value++;
    });
    const a = f(() => i.value === n.value);
    return t({
      stepIndex: i,
      isActive: a
    }), (d, u) => w1((l(), s("div", D3, [
      G(d.$slots, "default", {
        isActive: a.value,
        stepIndex: i.value
      })
    ], 512)), [
      [Le, a.value]
    ]);
  }
}), T3 = /* @__PURE__ */ I({
  __name: "EcxInputField",
  props: {
    name: {},
    modelValue: { default: "" },
    label: {},
    type: { default: "text" },
    placeholder: {},
    error: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hint: {},
    mask: {},
    eager: { type: Boolean, default: !1 },
    id: {},
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    autocomplete: {}
  },
  emits: ["update:modelValue", "blur"],
  setup(e, { expose: t }) {
    const r = e, n = E(null), i = f(() => r.id || `ecx-input-${r.name}`);
    return t({
      focus: () => {
        var a;
        return (a = n.value) == null ? void 0 : a.focus();
      },
      blur: () => {
        var a;
        return (a = n.value) == null ? void 0 : a.blur();
      }
    }), (a, d) => (l(), W(h2, {
      ref_key: "inputRef",
      ref: n,
      "model-value": e.modelValue,
      label: e.label,
      placeholder: e.placeholder,
      type: e.type,
      size: e.size,
      mask: e.mask,
      eager: e.eager,
      error: e.error,
      hint: e.hint,
      disabled: e.disabled,
      readonly: e.readonly,
      required: e.required,
      "hide-label": e.hideLabel,
      "hide-error": e.hideError,
      autocomplete: e.autocomplete,
      id: i.value,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => a.$emit("update:modelValue", u)),
      onBlur: d[1] || (d[1] = (u) => a.$emit("blur"))
    }, ve({ _: 2 }, [
      a.$slots.prefix ? {
        name: "prefix",
        fn: Y(() => [
          G(a.$slots, "prefix")
        ]),
        key: "0"
      } : void 0,
      a.$slots.suffix ? {
        name: "suffix",
        fn: Y(() => [
          G(a.$slots, "suffix")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["model-value", "label", "placeholder", "type", "size", "mask", "eager", "error", "hint", "disabled", "readonly", "required", "hide-label", "hide-error", "autocomplete", "id"]));
  }
});
function O3(e) {
  const {
    value: t,
    errorMessage: r,
    meta: n,
    setValue: i,
    resetField: a,
    validate: d,
    handleBlur: u
  } = U1(
    e.name,
    e.validations,
    { initialValue: e.initialValue }
  ), h = f(() => r.value), C = f(() => ({
    modelValue: t.value,
    error: r.value
  }));
  return {
    value: t,
    error: h,
    meta: n,
    setValue: i,
    resetField: a,
    validate: d,
    handleBlur: u,
    fieldProps: C,
    fieldHandlers: {
      "onUpdate:modelValue": (c) => i(c),
      onBlur: () => u()
    }
  };
}
const xw = /* @__PURE__ */ I({
  __name: "EcxFormField",
  props: {
    name: {},
    label: {},
    type: { default: "text" },
    placeholder: {},
    initialValue: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hint: {},
    mask: {},
    eager: { type: Boolean, default: !1 },
    validations: {},
    id: {},
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    autocomplete: {}
  },
  setup(e, { expose: t }) {
    var a;
    const r = e, n = E(null), i = O3({
      name: r.name,
      validations: r.validations,
      initialValue: ((a = r.initialValue) == null ? void 0 : a.toString()) ?? ""
    });
    return r1(
      () => r.initialValue,
      (d) => {
        d != null && (i.resetField({ value: d.toString() }), i.validate());
      }
    ), t({
      /** Foca o input */
      focus: () => {
        var d;
        return (d = n.value) == null ? void 0 : d.focus();
      },
      /** Remove o foco do input */
      blur: () => {
        var d;
        return (d = n.value) == null ? void 0 : d.blur();
      },
      /** Valor atual do campo */
      value: i.value,
      /** Mensagem de erro atual */
      errorMessage: i.error,
      /** Metadados do campo (dirty, touched, valid, etc) */
      meta: i.meta,
      /** Reseta o campo */
      resetField: i.resetField,
      /** Valida o campo */
      validate: i.validate,
      /** Define o valor do campo */
      setValue: i.setValue
    }), (d, u) => (l(), W(T3, {
      ref_key: "inputRef",
      ref: n,
      name: e.name,
      "model-value": D(i).value.value,
      error: D(i).error.value,
      label: e.label,
      placeholder: e.placeholder,
      type: e.type,
      size: e.size,
      mask: e.mask,
      eager: e.eager,
      hint: e.hint,
      disabled: e.disabled,
      readonly: e.readonly,
      required: e.required,
      "hide-label": e.hideLabel,
      "hide-error": e.hideError,
      autocomplete: e.autocomplete,
      id: e.id,
      "onUpdate:modelValue": u[0] || (u[0] = (h) => D(i).setValue(h)),
      onBlur: D(i).handleBlur
    }, ve({ _: 2 }, [
      d.$slots.prefix ? {
        name: "prefix",
        fn: Y(() => [
          G(d.$slots, "prefix")
        ]),
        key: "0"
      } : void 0,
      d.$slots.suffix ? {
        name: "suffix",
        fn: Y(() => [
          G(d.$slots, "suffix")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["name", "model-value", "error", "label", "placeholder", "type", "size", "mask", "eager", "hint", "disabled", "readonly", "required", "hide-label", "hide-error", "autocomplete", "id", "onBlur"]));
  }
}), ww = /* @__PURE__ */ I({
  __name: "EcxSelectField",
  props: {
    name: {},
    options: {},
    label: {},
    placeholder: { default: "Selecione..." },
    initialValue: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hint: {},
    blank: { type: Boolean, default: !1 },
    blankText: { default: "Limpar seleção" },
    emptyText: { default: "Nenhuma opção disponível" },
    validations: {},
    id: {}
  },
  emits: ["change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, { value: a, errorMessage: d, setValue: u, resetField: h } = U1(
      n.name,
      n.validations,
      { initialValue: n.initialValue }
    ), C = f(() => n.id || `ecx-select-${n.name}`), m = f(
      () => n.options.map((p) => ({
        value: p.value ?? null,
        label: p.text,
        description: p.subtext,
        disabled: p.disabled
      }))
    ), c = (p) => {
      const k = p === null ? void 0 : p;
      u(k), i("change", k);
    };
    return r1(
      () => n.initialValue,
      (p) => {
        h({ value: p });
      }
    ), m1(() => {
      n.initialValue !== void 0 && u(n.initialValue);
    }), t({
      value: a,
      errorMessage: d
    }), (p, k) => (l(), W(w3, {
      "model-value": D(a),
      options: m.value,
      label: e.label,
      placeholder: e.placeholder,
      size: e.size,
      disabled: e.disabled,
      error: D(d),
      hint: e.hint,
      required: e.required,
      clearable: e.blank,
      "clear-text": e.blankText,
      "empty-text": e.emptyText,
      id: C.value,
      "onUpdate:modelValue": c,
      onChange: c
    }, ve({ _: 2 }, [
      p.$slots.prefix ? {
        name: "prefix",
        fn: Y(() => [
          G(p.$slots, "prefix")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["model-value", "options", "label", "placeholder", "size", "disabled", "error", "hint", "required", "clearable", "clear-text", "empty-text", "id"]));
  }
}), kw = /* @__PURE__ */ I({
  __name: "EcxCheckboxField",
  props: {
    name: {},
    value: { type: [String, Number, Boolean], default: !0 },
    label: {},
    description: {},
    size: { default: "md" },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    initialValue: { type: Boolean, default: !1 },
    validations: {}
  },
  emits: ["change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), { value: d, errorMessage: u, setValue: h } = U1(
      n.name,
      n.validations,
      { initialValue: n.initialValue }
    ), C = f(() => {
      if (typeof n.value != "boolean")
        return n.value;
    }), m = (p) => {
      typeof p == "boolean" && h(p);
    }, c = (p) => {
      i("change", p);
    };
    return t({
      focus: () => {
        var p;
        return (p = a.value) == null ? void 0 : p.focus();
      },
      value: d,
      errorMessage: u
    }), (p, k) => (l(), W($3, {
      ref_key: "inputRef",
      ref: a,
      "model-value": D(d),
      value: C.value,
      name: e.name,
      label: e.label,
      description: e.description,
      size: e.size,
      variant: e.variant,
      disabled: e.disabled,
      error: D(u),
      required: e.required,
      "onUpdate:modelValue": m,
      onChange: c
    }, {
      default: Y(() => [
        G(p.$slots, "default")
      ]),
      _: 3
    }, 8, ["model-value", "value", "name", "label", "description", "size", "variant", "disabled", "error", "required"]));
  }
}), P3 = ["for"], R3 = ["id", "name", "value", "checked", "disabled"], N3 = { class: "flex flex-col gap-1 flex-1 min-w-0" }, yw = /* @__PURE__ */ I({
  __name: "EcxCheckboxCard",
  props: {
    value: {},
    title: {},
    description: {},
    name: {},
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    modelValue: { type: Boolean },
    standalone: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = f(() => `checkbox-${r.name || "field"}-${r.value}`), a = r.name && !r.standalone ? U1(r.name, void 0, {
      type: "checkbox",
      checkedValue: r.value
    }) : null, d = f(() => {
      var F;
      return r.standalone ? r.modelValue : ((F = a == null ? void 0 : a.checked) == null ? void 0 : F.value) ?? !1;
    }), u = () => {
      var F;
      r.disabled || (r.standalone ? (n("update:modelValue", !r.modelValue), n("change", r.value, !r.modelValue)) : a && (a.handleChange(r.value), n("change", r.value, !((F = a.checked) != null && F.value))));
    }, h = (F) => {
      const P = F.target;
      n("change", r.value, P.checked);
    }, C = {
      sm: {
        container: "py-3 px-6",
        checkbox: "h-4 w-4",
        checkIcon: "w-2.5 h-2.5",
        title: "text-sm",
        description: "text-xs"
      },
      md: {
        container: "py-6 px-10",
        checkbox: "h-5 w-5",
        checkIcon: "w-3 h-3",
        title: "text-base",
        description: "text-sm"
      },
      lg: {
        container: "py-8 px-12",
        checkbox: "h-6 w-6",
        checkIcon: "w-4 h-4",
        title: "text-lg",
        description: "text-base"
      }
    }, m = f(() => C[r.size].container), c = f(() => C[r.size].checkbox), p = f(() => C[r.size].checkIcon), k = f(() => [
      C[r.size].title,
      r.disabled ? "text-grey-400" : "text-default-black"
    ]), j = f(() => [
      C[r.size].description,
      r.disabled ? "text-grey-300" : "text-subtitle-gray"
    ]), H = f(() => r.disabled ? "border-grey-200 bg-grey-50 cursor-not-allowed" : d.value ? "border-primary bg-white" : "border-border-gray bg-white hover:border-grey-300"), L = f(() => r.disabled ? "outline-grey-200 bg-grey-100" : d.value ? "outline-primary bg-primary text-white" : "outline-input-outline-gray bg-white");
    return (F, P) => (l(), s("fieldset", {
      class: v([
        "flex gap-6 items-center border border-solid rounded-lg duration-150 cursor-pointer transition-colors",
        H.value,
        m.value
      ]),
      onClick: o1(u, ["stop"])
    }, [
      o("label", {
        for: i.value,
        class: v([
          "select-none cursor-pointer rounded-lg flex outline outline-2 justify-center items-center transition-colors",
          c.value,
          L.value
        ]),
        onClick: P[0] || (P[0] = o1(() => {
        }, ["stop"]))
      }, [
        w1((l(), s("svg", {
          class: v(p.value),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [...P[1] || (P[1] = [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "3",
            d: "M5 13l4 4L19 7"
          }, null, -1)
        ])], 2)), [
          [Le, d.value]
        ])
      ], 10, P3),
      o("input", {
        type: "checkbox",
        class: "hidden",
        id: i.value,
        name: e.name,
        value: e.value,
        checked: d.value,
        disabled: e.disabled,
        onChange: h
      }, null, 40, R3),
      o("div", N3, [
        o("p", {
          class: v(["font-semibold truncate", k.value])
        }, M(e.title), 3),
        e.description ? (l(), s("p", {
          key: 0,
          class: v(["break-words", j.value])
        }, M(e.description), 3)) : x("", !0),
        G(F.$slots, "content")
      ]),
      G(F.$slots, "suffix")
    ], 2));
  }
}), G3 = { class: "ecx-money-input-field flex flex-col" }, U3 = ["for"], W3 = {
  key: 0,
  class: "text-error"
}, Y3 = {
  key: 0,
  class: "pl-3 text-subtitle-gray font-medium"
}, q3 = ["id", "value", "placeholder", "disabled", "readonly"], K3 = {
  key: 1,
  class: "text-xs text-error"
}, Q3 = {
  key: 2,
  class: "text-xs text-subtitle-gray"
}, bw = /* @__PURE__ */ I({
  __name: "EcxMoneyInputField",
  props: {
    name: {},
    label: {},
    placeholder: {},
    initialValue: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hint: {},
    limit: {},
    validations: {},
    id: {},
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    currencySymbol: { default: "R$" },
    showCurrencySymbol: { type: Boolean, default: !0 },
    locale: { default: "pt-BR" },
    hasExternalError: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update", "blur"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(!1), { value: u, errorMessage: h, handleBlur: C, setValue: m, meta: c } = U1(
      n.name,
      n.validations,
      { initialValue: n.initialValue ?? 0 }
    ), p = f(() => n.id || `ecx-money-input-${n.name}`), k = f(() => !!h.value || n.hasExternalError), j = (w) => {
      if (w == null) return "";
      const O = w / 100;
      return new Intl.NumberFormat(n.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(O);
    }, H = f(() => j(u.value ?? 0)), L = f(() => ({
      sm: "px-3 py-2 text-sm",
      md: "px-3 py-3 text-base",
      lg: "px-4 py-4 text-lg"
    })[n.size]), F = f(() => n.disabled ? "text-subtitle-gray" : "text-primary"), P = {
      sm: "36px",
      md: "48px",
      lg: "56px"
    }, Z = f(() => {
      const w = [];
      return n.disabled && w.push("bg-grey-50 cursor-not-allowed"), w.join(" ");
    }), T = f(() => {
      const w = P[n.size], O = "#E2E4EE", U = "#000EC6", $ = "#F01A1A", B = "#D1D5DB";
      let y = O, b = "1px", V = "none", S = "0";
      return n.disabled ? y = B : k.value ? (y = $, b = "2px") : d.value && (y = U, b = "2px", V = `2px solid ${U}`, S = "0"), {
        height: w,
        border: `${b} solid ${y}`,
        outline: V,
        outlineOffset: S
      };
    }), R = (w) => {
      w.key.match(/\d/g) || w.preventDefault();
    }, A = (w) => {
      const O = w.target, U = parseInt(O.value.replace(/[^\d]/g, ""), 10) || 0;
      let $ = U;
      n.limit !== void 0 && U > n.limit && ($ = n.limit), m($), i("update:modelValue", $), i("update");
    }, _ = () => {
      d.value = !1, C(), i("blur");
    };
    return r1(
      () => u.value,
      (w) => {
        n.limit !== void 0 && w > n.limit && m(n.limit);
      }
    ), r1(
      () => n.initialValue,
      (w) => {
        w !== void 0 && m(w);
      }
    ), t({
      focus: () => {
        var w;
        return (w = a.value) == null ? void 0 : w.focus();
      },
      blur: () => {
        var w;
        return (w = a.value) == null ? void 0 : w.blur();
      },
      /** @deprecated Use getValue() instead - this returns a Ref, not the value */
      value: u,
      /** Returns the current value in cents */
      getValue: () => u.value,
      setValue: m,
      errorMessage: h,
      meta: c
    }), (w, O) => (l(), s("div", G3, [
      e.label && !e.hideLabel ? (l(), s("label", {
        key: 0,
        for: p.value,
        class: "text-sm font-medium pb-1 text-default-black"
      }, [
        h1(M(e.label) + " ", 1),
        e.required ? (l(), s("span", W3, "*")) : x("", !0)
      ], 8, U3)) : x("", !0),
      o("div", {
        class: v([
          "w-full rounded-lg flex items-center bg-white transition-all duration-200",
          Z.value
        ]),
        style: a1(T.value)
      }, [
        e.showCurrencySymbol ? (l(), s("span", Y3, M(e.currencySymbol), 1)) : x("", !0),
        o("input", {
          id: p.value,
          ref_key: "inputRef",
          ref: a,
          type: "text",
          inputmode: "numeric",
          value: H.value,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          class: v([
            "focus:outline-none w-full flex-1 h-full border-0 bg-transparent",
            L.value,
            F.value,
            { "opacity-50 cursor-not-allowed": e.disabled }
          ]),
          onInput: A,
          onBlur: _,
          onFocus: O[0] || (O[0] = (U) => d.value = !0),
          onKeypress: R
        }, null, 42, q3)
      ], 6),
      k.value && !e.hideError ? (l(), s("span", K3, M(D(h)), 1)) : e.hint ? (l(), s("span", Q3, M(e.hint), 1)) : x("", !0)
    ]));
  }
}), X3 = { class: "ecx-searchable-select-field flex flex-col gap-1" }, J3 = ["for"], e0 = {
  key: 0,
  class: "text-error"
}, t0 = { class: "relative" }, o0 = { class: "flex items-center gap-3 flex-1 min-w-0" }, n0 = { class: "flex-1 min-w-0" }, r0 = {
  key: 0,
  class: "text-xs text-subtitle-gray truncate block"
}, l0 = {
  key: 0,
  class: "px-4 py-2.5 border-b bg-grey-50 border-grey-200"
}, s0 = { class: "text-sm font-medium text-default-black" }, i0 = {
  key: 1,
  class: "border-b border-border-gray sticky top-0 bg-white z-10 p-2"
}, a0 = { class: "flex items-center w-full h-8 px-3 py-1.5 bg-grey-50 rounded-lg gap-1.5" }, d0 = ["placeholder"], u0 = { class: "overflow-y-auto flex-1 max-h-60" }, c0 = {
  key: 0,
  class: "px-4 py-3 text-sm text-subtitle-gray text-center"
}, h0 = { class: "flex-1 flex flex-col min-w-0" }, p0 = { class: "text-sm text-default-black truncate" }, f0 = {
  key: 0,
  class: "text-xs text-subtitle-gray truncate"
}, C0 = {
  key: 1,
  class: "px-2 py-0.5 rounded text-xs text-subtitle-gray bg-grey-100"
}, g0 = {
  key: 2,
  class: "w-5 h-5 text-primary flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, v0 = {
  key: 1,
  class: "text-xs text-error"
}, m0 = {
  key: 2,
  class: "text-xs text-subtitle-gray"
}, _w = /* @__PURE__ */ I({
  __name: "EcxSearchableSelectField",
  props: {
    name: {},
    label: {},
    title: {},
    placeholder: { default: "Selecione" },
    options: {},
    initialValue: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    hint: {},
    validations: {},
    id: {},
    hideLabel: { type: Boolean, default: !1 },
    hideError: { type: Boolean, default: !1 },
    icon: {},
    searchable: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Pesquisar" },
    emptyText: { default: "Nenhum resultado encontrado" }
  },
  emits: ["update:modelValue", "change", "search"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(""), u = E({
      top: "0px",
      left: "0px",
      width: "300px",
      maxHeight: "384px"
    }), { value: h, errorMessage: C, setValue: m, resetField: c, meta: p } = U1(
      n.name,
      n.validations,
      { initialValue: n.initialValue }
    ), k = f(() => n.id || `ecx-searchable-select-${n.name}`), j = f(() => !!C.value), H = f(() => n.disabled ? "text-grey-400" : j.value ? "text-grey-700" : h.value != null && h.value !== "" ? "text-grey-500" : "text-grey-800"), L = f(
      () => n.options.find(($) => $.value === h.value)
    ), F = f(() => {
      var $;
      return ($ = L.value) == null ? void 0 : $.text;
    }), P = f(() => {
      var $;
      return ($ = L.value) == null ? void 0 : $.subtext;
    }), Z = f(() => {
      if (!d.value.trim()) return n.options;
      const $ = d.value.toLowerCase().trim();
      return n.options.filter(
        (B) => {
          var y;
          return B.text.toLowerCase().includes($) || ((y = B.subtext) == null ? void 0 : y.toLowerCase().includes($));
        }
      );
    }), T = {
      sm: "h-9 px-3 text-sm",
      md: "h-12 px-3 text-base",
      lg: "h-14 px-4 text-lg"
    }, R = f(() => {
      const $ = [T[n.size]];
      return n.disabled ? $.push("bg-grey-50 border border-grey-200 cursor-not-allowed outline-none") : j.value ? $.push("bg-white outline outline-2 outline-error") : $.push("bg-white outline outline-2 outline-input-outline-gray focus:outline-primary"), $.join(" ");
    }), A = f(() => h.value ? "text-default-black" : "text-subtitle-gray"), _ = () => {
      if (!a.value) return;
      let $ = null;
      if (a.value instanceof HTMLElement ? $ = a.value : a.value && typeof a.value == "object" && "$el" in a.value && ($ = a.value.$el), !$ || typeof $.getBoundingClientRect != "function") return;
      const B = $.getBoundingClientRect(), b = window.innerHeight - B.bottom;
      let S = Math.min(384, b - 20);
      S < 200 && (S = 200), u.value = {
        top: `${B.bottom + 4}px`,
        left: `${B.left}px`,
        width: `${B.width}px`,
        maxHeight: `${S}px`
      };
    }, w = () => {
      s1(() => {
        setTimeout(_, 50);
      });
    }, O = ($) => {
      m($), i("update:modelValue", $), i("change", $), d.value = "";
    };
    let U = null;
    return r1(d, ($) => {
      U && clearTimeout(U), U = setTimeout(() => {
        i("search", $);
      }, 300);
    }), r1(
      () => n.initialValue,
      ($) => {
        $ !== void 0 && c({ value: $ });
      }
    ), m1(() => {
      window.addEventListener("scroll", _, !0), window.addEventListener("resize", _);
    }), y1(() => {
      window.removeEventListener("scroll", _, !0), window.removeEventListener("resize", _), U && clearTimeout(U);
    }), t({
      value: h,
      errorMessage: C,
      meta: p,
      resetField: c
    }), ($, B) => (l(), s("div", X3, [
      e.label && !e.hideLabel ? (l(), s("label", {
        key: 0,
        for: k.value,
        class: v(["text-xs font-normal pb-1 transition-colors duration-200", H.value])
      }, [
        h1(M(e.label) + " ", 1),
        e.required ? (l(), s("span", e0, "*")) : x("", !0)
      ], 10, J3)) : x("", !0),
      J(D(D1), {
        "model-value": D(h),
        "onUpdate:modelValue": O
      }, {
        default: Y(({ open: y }) => [
          o("div", t0, [
            J(D(T1), {
              ref_key: "buttonRef",
              ref: a,
              id: k.value,
              disabled: e.disabled,
              class: v([
                "w-full rounded-lg text-left flex justify-between items-center transition-colors",
                R.value
              ]),
              onClick: w
            }, {
              default: Y(() => [
                o("div", o0, [
                  e.icon ? (l(), W(f1(e.icon), {
                    key: 0,
                    class: v([
                      "w-5 h-5 flex-shrink-0 transition-colors",
                      y || D(h) ? "text-primary" : "text-subtitle-gray"
                    ])
                  }, null, 8, ["class"])) : x("", !0),
                  o("div", n0, [
                    o("span", {
                      class: v(["truncate block", A.value])
                    }, M(F.value || e.placeholder), 3),
                    P.value ? (l(), s("span", r0, M(P.value), 1)) : x("", !0)
                  ])
                ]),
                (l(), s("svg", {
                  class: v(["w-5 h-5 text-subtitle-gray transition-transform flex-shrink-0", { "rotate-180": y }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...B[3] || (B[3] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 2))
              ]),
              _: 2
            }, 1032, ["id", "disabled", "class"]),
            (l(), W(g1, { to: "body" }, [
              J(p1, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "opacity-0 scale-95",
                "enter-to-class": "opacity-100 scale-100",
                "leave-active-class": "transition duration-150 ease-in",
                "leave-from-class": "opacity-100 scale-100",
                "leave-to-class": "opacity-0 scale-95"
              }, {
                default: Y(() => [
                  y ? (l(), W(D(O1), {
                    key: 0,
                    style: a1(u.value),
                    class: "fixed rounded-lg shadow-xl overflow-hidden bg-white z-[10001] outline-none border border-border-gray flex flex-col"
                  }, {
                    default: Y(() => [
                      e.title ? (l(), s("div", l0, [
                        o("h3", s0, M(e.title), 1)
                      ])) : x("", !0),
                      e.searchable ? (l(), s("div", i0, [
                        o("div", a0, [
                          B[4] || (B[4] = o("svg", {
                            class: "w-4 h-4 text-subtitle-gray flex-shrink-0",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            o("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ], -1)),
                          w1(o("input", {
                            "onUpdate:modelValue": B[0] || (B[0] = (b) => d.value = b),
                            type: "text",
                            class: "flex-1 text-sm text-default-black placeholder:text-subtitle-gray focus:outline-none bg-transparent",
                            placeholder: e.searchPlaceholder,
                            onClick: B[1] || (B[1] = o1(() => {
                            }, ["stop"])),
                            onKeydownCapture: B[2] || (B[2] = o1(() => {
                            }, ["stop"]))
                          }, null, 40, d0), [
                            [$1, d.value]
                          ])
                        ])
                      ])) : x("", !0),
                      o("div", u0, [
                        Z.value.length === 0 ? (l(), s("div", c0, M(e.emptyText), 1)) : x("", !0),
                        (l(!0), s(n1, null, u1(Z.value, (b) => (l(), W(D(F1), {
                          key: b.value,
                          value: b.value,
                          disabled: b.disabled
                        }, {
                          default: Y(({ active: V, selected: S }) => [
                            o("div", {
                              class: v([
                                "px-4 py-3 flex items-center gap-3 transition-colors cursor-pointer",
                                V ? "bg-grey-100" : "",
                                S ? "bg-grey-50" : "",
                                b.disabled ? "opacity-50 cursor-not-allowed" : ""
                              ])
                            }, [
                              e.icon ? (l(), W(f1(e.icon), {
                                key: 0,
                                class: v([
                                  "w-5 h-5 flex-shrink-0 transition-colors",
                                  S || V ? "text-primary" : "text-subtitle-gray"
                                ])
                              }, null, 8, ["class"])) : x("", !0),
                              o("div", h0, [
                                o("span", p0, M(b.text), 1),
                                b.subtext ? (l(), s("span", f0, M(b.subtext), 1)) : x("", !0)
                              ]),
                              b.count !== void 0 ? (l(), s("span", C0, M(b.count), 1)) : x("", !0),
                              S ? (l(), s("svg", g0, [...B[5] || (B[5] = [
                                o("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M5 13l4 4L19 7"
                                }, null, -1)
                              ])])) : x("", !0)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["style"])) : x("", !0)
                ]),
                _: 2
              }, 1024)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      j.value && !e.hideError ? (l(), s("span", v0, M(D(C)), 1)) : e.hint ? (l(), s("span", m0, M(e.hint), 1)) : x("", !0)
    ]));
  }
}), x0 = {
  key: 0,
  class: "text-error"
}, w0 = {
  key: 0,
  class: "animate-spin w-4 h-4 text-subtitle-gray mx-auto",
  fill: "none",
  viewBox: "0 0 24 24"
}, k0 = {
  key: 1,
  class: "flex flex-1 flex-wrap items-center gap-2 min-w-0"
}, y0 = {
  class: "inline-flex items-center gap-2 py-1 pr-1 pl-3 rounded-lg bg-royal-25 text-royal-500 text-sm tracking-status-badge flex-shrink-0",
  "data-testid": "multi-select-summary-chip"
}, b0 = ["aria-label"], _0 = {
  key: 2,
  class: "flex flex-1 flex-wrap items-center gap-2 min-w-0"
}, M0 = ["aria-label", "onClick"], L0 = {
  key: 0,
  class: "inline-flex items-center py-1 px-3 rounded-lg bg-royal-50 text-royal-200 text-sm tracking-status-badge flex-shrink-0",
  "data-testid": "multi-select-badge-overflow"
}, $0 = {
  key: 0,
  class: "px-4 py-2.5 border-b bg-grey-50 border-grey-100"
}, V0 = { class: "text-sm font-medium text-default-black" }, B0 = {
  key: 1,
  class: "border-b border-grey-100 sticky top-0 bg-white z-10 p-2"
}, H0 = { class: "flex items-center w-full h-8 px-3 py-1.5 bg-grey-50 rounded-lg gap-1.5" }, F0 = ["placeholder"], A0 = {
  key: 0,
  class: "px-4 py-3 text-sm text-subtitle-gray text-center"
}, j0 = {
  key: 0,
  class: "sticky top-0 z-10 bg-grey-50 px-3 py-1.5 text-xs font-medium text-grey-600",
  "data-testid": "multi-select-group-header"
}, I0 = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, Z0 = ["title"], E0 = {
  key: 1,
  class: "px-4 py-2 text-center text-xs text-subtitle-gray"
}, S0 = {
  key: 2,
  class: "border-t border-grey-100 bg-white"
}, z0 = 24, D0 = 240, T0 = 300, Mw = /* @__PURE__ */ I({
  __name: "EcxMultiSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    title: {},
    placeholder: { default: "Selecione..." },
    allText: { default: "Todos" },
    searchable: { type: Boolean, default: !0 },
    remoteSearch: { type: Boolean, default: !1 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    loadingMoreText: { default: "" },
    searchPlaceholder: { default: "Pesquisar" },
    emptyText: { default: "Nenhum resultado encontrado" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    size: { default: "md" },
    inputVariant: { default: "default" },
    displayMode: { default: "text" },
    removeBadgeLabel: { default: "Remover" },
    maxVisibleBadges: {},
    required: { type: Boolean, default: !1 },
    groups: {},
    summaryChip: {},
    dropdownMaxHeightPx: {}
  },
  emits: ["update:modelValue", "search", "load-more", "clear-all"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = f(() => n.dropdownMaxHeightPx ?? D0), d = E(null), u = E(null), h = E({ top: -9999, left: -9999, width: 200 }), C = E(""), m = f(
      () => n.loadingMoreText !== "" ? n.loadingMoreText : "Carregando..."
    ), c = f({
      get: () => n.modelValue,
      set: (b) => i("update:modelValue", b)
    }), p = f(() => n.displayMode !== "badge" || n.maxVisibleBadges == null ? c.value : c.value.slice(0, n.maxVisibleBadges)), k = f(() => n.displayMode !== "badge" || n.maxVisibleBadges == null ? 0 : Math.max(0, c.value.length - n.maxVisibleBadges)), j = f(() => {
      if (n.remoteSearch || !C.value.trim())
        return n.options;
      const b = C.value.toLowerCase().trim();
      return n.options.filter((V) => V.text.toLowerCase().includes(b));
    }), H = f(() => n.groups ? n.groups.map((b, V) => ({
      key: `group-${V}-${b.label}`,
      label: b.label,
      options: b.options
    })) : [{ key: "__flat", label: null, options: j.value }]), L = f(
      () => H.value.reduce((b, V) => b + V.options.length, 0)
    ), F = f(
      () => c.value.length > 0 || n.summaryChip != null
    );
    let P = null;
    r1(C, (b) => {
      n.remoteSearch && (P != null && clearTimeout(P), P = setTimeout(() => {
        P = null, i("search", b.trim());
      }, T0));
    }), y1(() => {
      P != null && clearTimeout(P);
    });
    const Z = f(() => {
      if (c.value.length === 0)
        return n.placeholder;
      if (n.displayMode === "badge")
        return "";
      if (c.value.length === 1) {
        const b = n.options.find((V) => V.value === c.value[0]);
        return (b == null ? void 0 : b.text) ?? n.placeholder;
      }
      return c.value.map((b) => T(b)).join(", ");
    });
    function T(b) {
      const V = n.options.find((S) => S.value === b);
      return (V == null ? void 0 : V.text) ?? String(b ?? "");
    }
    function R(b) {
      if (n.disabled || n.loading) return;
      const V = c.value.filter((S) => S !== b);
      i("update:modelValue", V);
    }
    function A(b) {
      if (!n.remoteSearch || !n.hasMore || n.loading || n.loadingMore)
        return;
      const V = b.target;
      if (!(V instanceof HTMLElement))
        return;
      V.scrollHeight - V.scrollTop - V.clientHeight <= z0 && i("load-more");
    }
    const _ = () => {
      var X;
      const b = (X = d.value) == null ? void 0 : X.querySelector("button");
      if (!b) return;
      const V = b.getBoundingClientRect(), z = window.innerHeight - V.bottom < a.value;
      h.value = {
        top: z ? V.top - a.value - 4 : V.bottom + 4,
        left: V.left,
        width: V.width
      };
    }, w = () => {
      _();
    }, O = f(() => ({
      transform: `translate3d(${h.value.left}px, ${h.value.top}px, 0)`,
      width: `${Math.max(h.value.width, 200)}px`,
      maxHeight: `${a.value}px`
    })), U = f(() => n.disabled || n.loading ? "text-grey-400" : F.value ? "text-grey-500" : "text-grey-800"), $ = f(() => n.inputVariant === "select" ? {
      sm: "py-2.5 pl-3 pr-9 min-h-[36px] text-sm",
      md: "py-3 pl-4 pr-10 min-h-[44px] text-base",
      lg: "py-3 pl-4 pr-10 min-h-[52px] text-lg"
    }[n.size] : {
      sm: "px-2.5 py-1.5 min-h-[28px]",
      md: "px-3 py-1.5 min-h-[32px]",
      lg: "px-4 py-3 min-h-[40px]"
    }[n.size]), B = () => {
      if (n.inputVariant === "select") {
        if (n.disabled || n.loading)
          return "bg-grey-50 border border-grey-200 cursor-not-allowed opacity-60";
        const b = F.value, V = "bg-white border border-grey-300 focus:outline-none focus:border-royal-300 focus:shadow-[0_0_0_3px_rgba(189,191,255,0.30)] focus:bg-white";
        return b ? `${V} border-grey-200` : V;
      }
      return n.disabled || n.loading ? "bg-grey-100 border border-grey-200 cursor-not-allowed" : F.value ? "bg-royal-25 border border-royal-25 focus:outline-none focus:ring-2 focus:ring-primary" : "bg-grey-50 border border-transparent hover:bg-grey-100 focus:outline-none focus:ring-2 focus:ring-primary";
    }, y = f(() => n.inputVariant === "select" ? n.disabled || n.loading ? "text-grey-400" : c.value.length === 0 ? "text-form-placeholder" : "text-default-black" : n.disabled || n.loading ? "text-grey-400" : c.value.length > 0 ? "text-primary" : "text-default-black");
    return t({
      selectedValues: c
    }), (b, V) => (l(), s("div", {
      class: "ecx-multi-select relative",
      ref_key: "containerRef",
      ref: d
    }, [
      J(D(D1), {
        modelValue: c.value,
        "onUpdate:modelValue": V[4] || (V[4] = (S) => c.value = S),
        multiple: "",
        disabled: e.disabled || e.loading
      }, {
        default: Y(({ open: S }) => [
          e.label ? (l(), s("label", {
            key: 0,
            class: v([
              "block mb-1 text-xs font-normal transition-colors duration-200",
              e.inputVariant !== "select" && "text-form-label",
              e.inputVariant === "select" && U.value
            ])
          }, [
            h1(M(e.label) + " ", 1),
            e.required ? (l(), s("span", x0, "*")) : x("", !0)
          ], 2)) : x("", !0),
          o("div", { onMousedown: w }, [
            J(D(T1), {
              class: v([
                "w-full text-left flex justify-between items-center transition-colors gap-2",
                e.inputVariant === "select" ? "rounded-lg" : "rounded-xl",
                e.displayMode === "badge" && "flex-wrap",
                $.value,
                B()
              ])
            }, {
              default: Y(() => [
                e.loading ? (l(), s("svg", w0, [...V[5] || (V[5] = [
                  o("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  o("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ])])) : e.displayMode === "badge" && e.summaryChip ? (l(), s("div", k0, [
                  o("span", y0, [
                    h1(M(e.summaryChip.text) + " ", 1),
                    o("button", {
                      type: "button",
                      class: "flex items-center justify-center w-5 h-5 rounded hover:bg-royal-100 transition-colors flex-shrink-0",
                      "aria-label": e.removeBadgeLabel,
                      onClick: V[0] || (V[0] = o1((z) => i("clear-all"), ["stop"]))
                    }, [...V[6] || (V[6] = [
                      o("svg", {
                        class: "w-5 h-5",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        o("path", {
                          d: "M6.66602 6.6665L13.3327 13.3332",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        o("path", {
                          d: "M13.3327 6.6665L6.66602 13.3332",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ])], 8, b0)
                  ])
                ])) : e.displayMode === "badge" && c.value.length > 0 ? (l(), s("div", _0, [
                  (l(!0), s(n1, null, u1(p.value, (z) => (l(), s("span", {
                    key: String(z),
                    class: "inline-flex items-center gap-2 py-1 pr-1 pl-3 rounded-lg bg-royal-25 text-royal-500 text-sm tracking-status-badge flex-shrink-0"
                  }, [
                    h1(M(T(z)) + " ", 1),
                    o("button", {
                      type: "button",
                      class: "flex items-center justify-center w-5 h-5 rounded hover:bg-royal-100 transition-colors flex-shrink-0",
                      "aria-label": e.removeBadgeLabel,
                      onClick: o1((X) => R(z), ["stop"])
                    }, [...V[7] || (V[7] = [
                      o("svg", {
                        class: "w-5 h-5",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        o("path", {
                          d: "M6.66602 6.6665L13.3327 13.3332",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        o("path", {
                          d: "M13.3327 6.6665L6.66602 13.3332",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ])], 8, M0)
                  ]))), 128)),
                  k.value > 0 ? (l(), s("span", L0, " +" + M(k.value), 1)) : x("", !0)
                ])) : (l(), s("span", {
                  key: 3,
                  class: v(["text-sm truncate flex-1 min-w-0", y.value])
                }, M(Z.value), 3)),
                e.loading ? x("", !0) : (l(), s("svg", {
                  key: 4,
                  class: v([
                    "transition-transform duration-150 flex-shrink-0 w-4 h-4",
                    e.displayMode === "badge" ? "ml-0" : "ml-1.5",
                    S && "rotate-180",
                    e.disabled ? "text-gray-300" : F.value ? "text-primary" : "text-grey-600"
                  ]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...V[8] || (V[8] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 2))
              ]),
              _: 2
            }, 1032, ["class"])
          ], 32),
          (l(), W(g1, { to: "body" }, [
            J(p1, {
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95",
              "enter-to-class": "opacity-100 scale-100",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100",
              "leave-to-class": "opacity-0 scale-95"
            }, {
              default: Y(() => [
                S ? (l(), W(D(O1), {
                  key: 0,
                  class: "rounded-xl fixed top-0 left-0 shadow-xl overflow-hidden bg-white cursor-pointer z-[9999] outline-none border border-grey-200 flex flex-col will-change-transform",
                  style: a1(O.value)
                }, {
                  default: Y(() => [
                    e.title ? (l(), s("div", $0, [
                      o("h3", V0, M(e.title), 1)
                    ])) : x("", !0),
                    e.searchable ? (l(), s("div", B0, [
                      o("div", H0, [
                        V[9] || (V[9] = o("svg", {
                          class: "w-4 h-4 text-subtitle-gray flex-shrink-0",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          o("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          })
                        ], -1)),
                        w1(o("input", {
                          "onUpdate:modelValue": V[1] || (V[1] = (z) => C.value = z),
                          type: "text",
                          class: "flex-1 text-sm text-default-black placeholder:text-subtitle-gray focus:outline-none bg-transparent",
                          placeholder: e.searchPlaceholder,
                          onClick: V[2] || (V[2] = o1(() => {
                          }, ["stop"])),
                          onKeydown: V[3] || (V[3] = o1(() => {
                          }, ["stop"]))
                        }, null, 40, F0), [
                          [$1, C.value]
                        ])
                      ])
                    ])) : x("", !0),
                    o("div", {
                      ref_key: "optionsScrollRef",
                      ref: u,
                      class: "overflow-y-auto flex-1",
                      onScrollPassive: A
                    }, [
                      L.value === 0 && !e.loading ? (l(), s("div", A0, M(e.emptyText), 1)) : x("", !0),
                      (l(!0), s(n1, null, u1(H.value, (z) => (l(), s(n1, {
                        key: z.key
                      }, [
                        z.label ? (l(), s("div", j0, M(z.label), 1)) : x("", !0),
                        (l(!0), s(n1, null, u1(z.options, (X) => (l(), W(D(F1), {
                          key: String(X.value),
                          value: X.value,
                          disabled: X.disabled
                        }, {
                          default: Y(({ active: c1, selected: b1 }) => [
                            o("div", {
                              class: v([
                                "transition-colors cursor-pointer flex items-center px-2 py-2 mx-1 gap-2",
                                b1 ? "bg-royal-25 rounded-lg" : c1 ? "bg-grey-100 rounded-lg" : "",
                                X.disabled && "opacity-50 cursor-not-allowed"
                              ])
                            }, [
                              o("div", {
                                class: v([
                                  "w-4 h-4 rounded border-2 flex items-center justify-center transition-colors border-solid flex-shrink-0",
                                  b1 ? "bg-primary border-primary" : c1 ? "border-grey-400 bg-white" : "border-grey-300 bg-white"
                                ])
                              }, [
                                b1 ? (l(), s("svg", I0, [...V[10] || (V[10] = [
                                  o("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "3",
                                    d: "M5 13l4 4L19 7"
                                  }, null, -1)
                                ])])) : x("", !0)
                              ], 2),
                              G(b.$slots, "option", {
                                option: X,
                                selected: b1,
                                active: c1
                              }, () => [
                                o("span", {
                                  class: v([
                                    "text-sm truncate min-w-0 flex-1",
                                    b1 ? "text-primary font-medium" : "text-default-black"
                                  ]),
                                  title: X.text
                                }, M(X.text), 11, Z0)
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ], 64))), 128)),
                      e.loadingMore && L.value > 0 ? (l(), s("div", E0, M(m.value), 1)) : x("", !0)
                    ], 544),
                    b.$slots.footer ? (l(), s("div", S0, [
                      G(b.$slots, "footer")
                    ])) : x("", !0)
                  ]),
                  _: 3
                }, 8, ["style"])) : x("", !0)
              ]),
              _: 2
            }, 1024)
          ]))
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"])
    ], 512));
  }
}), O0 = { class: "w-full shrink-0 border-b border-grey-100 bg-grey-50 px-3 py-2.5" }, P0 = { class: "font-be-vietnam text-xs font-normal uppercase leading-tight tracking-tight text-grey-600" }, R0 = /* @__PURE__ */ I({
  name: "EcxPickerListHeader",
  __name: "EcxPickerListHeader",
  props: {
    label: {}
  },
  setup(e) {
    return (t, r) => (l(), s("div", O0, [
      o("p", P0, M(e.label), 1)
    ]));
  }
}), N0 = ["src", "alt"], G0 = {
  key: 1,
  class: "inline-flex size-full select-none items-center justify-center leading-none"
}, ct = /* @__PURE__ */ I({
  __name: "EcxAvatar",
  props: {
    name: {},
    src: { default: void 0 },
    size: { default: "md" },
    variant: { default: "default" },
    status: { default: void 0 },
    containerClass: { default: "" }
  },
  setup(e) {
    const t = e;
    function r(u) {
      switch (u) {
        case "invited":
          return "bg-royal-950 text-white";
        case "approved":
        case "rejected":
          return "bg-royal-800 text-white";
        case "in_review":
          return "bg-royal-500 text-white";
        case "inactive":
          return "bg-grey-600 text-white";
        default:
          return "bg-royal-800 text-white";
      }
    }
    const n = E(!1);
    r1(() => t.src, () => {
      n.value = !1;
    });
    const i = f(() => {
      const u = (t.name ?? "").trim(), h = u.split(/\s+/).filter(Boolean);
      if (h.length >= 2) {
        const C = h[0][0], m = h[h.length - 1][0];
        return `${C}${m}`.toUpperCase();
      }
      return u.substring(0, 2).toUpperCase() || "—";
    }), a = f(() => ({
      sm: "h-8 w-8 text-xs",
      md: "h-10 w-10 text-sm",
      lg: "h-12 w-12 text-base"
    })[t.size]), d = f(() => {
      var C;
      const u = "rounded-xl";
      return (C = t.containerClass) != null && C.trim() ? "" : t.status ? `${u} ${r(t.status)}` : {
        default: `${u} bg-royal-950 text-white`,
        light: `${u} bg-royal-950 text-royal-100`
      }[t.variant];
    });
    return (u, h) => (l(), s("div", {
      class: v([
        "flex flex-shrink-0 items-center justify-center overflow-hidden font-semibold font-be-vietnam",
        a.value,
        d.value,
        e.containerClass
      ]),
      "aria-hidden": ""
    }, [
      e.src && !n.value ? (l(), s("img", {
        key: 0,
        src: e.src,
        alt: e.name,
        class: "h-full w-full object-cover",
        onError: h[0] || (h[0] = (C) => n.value = !0)
      }, null, 40, N0)) : (l(), s("span", G0, M(i.value), 1))
    ], 2));
  }
}), U0 = ["title"], W0 = /* @__PURE__ */ I({
  name: "EcxUserOptionRow",
  __name: "EcxUserOptionRow",
  props: {
    label: {},
    imageSrc: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = [
      "rounded-lg bg-royal-950 text-white border border-grey-100",
      "rounded-lg bg-royal-800 text-white border border-grey-100",
      "rounded-lg bg-royal-700 text-white border border-grey-100",
      "rounded-lg bg-royal-500 text-white border border-grey-100",
      "rounded-lg bg-royal-400 text-white border border-grey-100",
      "rounded-lg bg-primary text-white border border-grey-100"
    ];
    function n(d) {
      let u = 0;
      for (let C = 0; C < d.length; C += 1)
        u = d.charCodeAt(C) + ((u << 5) - u);
      const h = Math.abs(u) % r.length;
      return r[h];
    }
    const i = f(() => {
      const d = t.imageSrc;
      if (typeof d != "string")
        return;
      const u = d.trim();
      return u.length > 0 ? u : void 0;
    }), a = f(() => i.value != null ? "rounded-lg border border-grey-100 bg-grey-100 text-grey-950" : n(t.label.trim() || "—"));
    return (d, u) => (l(), s("div", {
      class: v([
        "flex w-full min-w-0 cursor-pointer items-center gap-2 rounded-xl py-1.5 pl-1.5 pr-3 text-left transition-colors",
        e.selected ? "bg-royal-25" : "",
        e.highlighted && !e.selected ? "bg-grey-100" : ""
      ])
    }, [
      J(ct, {
        name: e.label,
        src: i.value,
        size: "sm",
        "container-class": a.value
      }, null, 8, ["name", "src", "container-class"]),
      o("span", {
        class: v([
          "min-w-0 flex-1 truncate font-be-vietnam text-sm tracking-tight",
          e.selected ? "font-medium text-primary" : "text-grey-950"
        ]),
        title: e.label
      }, M(e.label), 11, U0)
    ], 2));
  }
}), Y0 = {
  key: 0,
  class: "size-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, q0 = ["title"], K0 = /* @__PURE__ */ I({
  name: "EcxVehicleOptionRow",
  __name: "EcxVehicleOptionRow",
  props: {
    label: {},
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, r) => (l(), s("div", {
      class: v([
        "flex w-full min-w-0 cursor-pointer items-center gap-2 rounded-xl py-1.5 pl-1.5 pr-3 text-left transition-colors",
        e.selected ? "bg-royal-25" : "",
        e.highlighted && !e.selected ? "bg-grey-100" : ""
      ])
    }, [
      o("span", {
        class: v([
          "flex size-4 shrink-0 items-center justify-center rounded border-2 border-solid",
          e.selected ? "border-primary bg-primary" : "border-grey-300 bg-white"
        ]),
        "aria-hidden": "true"
      }, [
        e.selected ? (l(), s("svg", Y0, [...r[0] || (r[0] = [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "3",
            d: "M5 13l4 4L19 7"
          }, null, -1)
        ])])) : x("", !0)
      ], 2),
      o("span", {
        class: v([
          "min-w-0 flex-1 truncate font-be-vietnam text-sm tracking-tight",
          e.selected ? "font-medium text-primary" : "text-grey-950"
        ]),
        title: e.label
      }, M(e.label), 11, q0)
    ], 2));
  }
}), Q0 = {
  key: 0,
  class: "truncate text-sm text-default-black"
}, X0 = {
  key: 1,
  class: "truncate text-sm text-primary"
}, J0 = {
  key: 1,
  class: "border-b border-grey-100 bg-grey-50 px-4 py-2.5"
}, e5 = { class: "text-sm font-medium text-default-black" }, t5 = { class: "sticky top-0 z-10 shrink-0 border-b border-grey-100 bg-white p-1" }, o5 = ["value", "placeholder"], n5 = {
  key: 2,
  class: "border-b border-grey-100 bg-grey-50 px-4 py-2.5 text-center text-sm text-subtitle-gray"
}, r5 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-2 px-4 py-8"
}, l5 = { class: "text-center text-sm text-subtitle-gray" }, s5 = {
  key: 0,
  class: "px-4 py-3 text-center text-sm text-subtitle-gray"
}, i5 = {
  key: 0,
  class: "mx-1"
}, a5 = {
  key: 0,
  class: "size-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, d5 = ["title"], u5 = {
  key: 1,
  class: "px-4 py-2 text-center text-xs text-subtitle-gray"
}, c5 = {
  key: 3,
  class: "shrink-0 border-t border-grey-100 bg-grey-50 px-3 py-2 text-center text-xs text-subtitle-gray"
}, h5 = 300, p5 = 15, de = 8, Re = 320, ht = /* @__PURE__ */ I({
  name: "EcxAsyncMultiSelectFilter",
  __name: "EcxAsyncMultiSelectFilter",
  props: {
    modelValue: {},
    fetchPage: {},
    placeholder: {},
    title: {},
    allText: {},
    minApiQueryLength: { default: 0 },
    localSearchFirst: { type: Boolean, default: !1 },
    optionPresentation: { default: "default" },
    searchPlaceholder: { default: "Search" },
    emptyText: { default: "No results found" },
    loadingText: { default: "Loading…" },
    formatMinCharsHint: { type: Function, default: (e) => `Type at least ${e} characters` },
    formatResultsCount: { type: Function, default: (e, t) => `${e} of ${t}` },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = I({
      name: "ListboxOpenBridge",
      props: {
        open: { type: Boolean, required: !0 }
      },
      emits: ["opened"],
      setup(K, { emit: Q }) {
        return r1(
          () => K.open,
          (l1, i1) => {
            l1 && i1 === !1 && Q("opened");
          }
        ), () => null;
      }
    }), n = e, i = t, a = E(null), d = E(null), u = E({ top: -9999, left: -9999, width: 200 }), h = E(""), C = E(!1), m = E(0), c = E(!0), p = E(null), k = E([]), j = E({}), H = E(!0), L = /* @__PURE__ */ new Map();
    let F = null;
    const P = E(0), Z = f({
      get: () => n.modelValue,
      set: (K) => i("update:modelValue", K)
    }), T = f(() => n.searchPlaceholder), R = f(() => n.emptyText), A = f(() => n.loadingText), _ = f(() => n.formatMinCharsHint(n.minApiQueryLength)), w = f(
      () => n.minApiQueryLength > 0 && h.value.trim().length < n.minApiQueryLength && !C.value
    ), O = f(() => {
      const K = h.value.trim();
      return !(n.minApiQueryLength > 0 && K.length < n.minApiQueryLength);
    }), U = f(
      () => p.value !== null && H.value && !w.value
    ), $ = f(() => {
      const K = p.value;
      return K === null ? "" : n.formatResultsCount(k.value.length, K);
    }), B = f(
      () => n.optionPresentation === "user" || n.optionPresentation === "vehicle"
    ), y = f(() => {
      const K = "fixed top-0 left-0 z-50 flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-grey-200 bg-white outline-none";
      return n.optionPresentation === "user" || n.optionPresentation === "vehicle" ? `${K} max-h-80 min-w-56 shadow-lg` : `${K} max-h-60 min-w-48 shadow-xl`;
    }), b = f(
      () => n.disabled || C.value ? "text-grey-300" : Z.value.length > 0 ? "text-primary" : "text-grey-600"
    ), V = f(() => {
      const K = /* @__PURE__ */ new Map();
      for (const Q of n.modelValue) {
        const l1 = j.value[Q];
        l1 && K.set(Q, { value: Q, text: l1 });
      }
      for (const Q of k.value)
        K.set(Q.value, Q);
      return [...K.values()];
    }), S = f(() => {
      if (n.modelValue.length === 0)
        return n.placeholder;
      if (n.modelValue.length === 1) {
        const K = n.modelValue[0];
        return j.value[K] ?? K;
      }
      return `${n.modelValue.length} ${n.allText}`;
    }), z = f(
      () => n.optionPresentation === "user" || n.optionPresentation === "vehicle" ? 224 : 200
    ), X = f(() => ({
      transform: `translate3d(${u.value.left}px, ${u.value.top}px, 0)`,
      width: `${Math.max(u.value.width, z.value)}px`
    }));
    function c1() {
      p.value = null;
    }
    function b1(K) {
      K != null && (p.value = K);
    }
    function H1(K) {
      const Q = { ...j.value };
      for (const l1 of K)
        Q[l1.value] = l1.text;
      j.value = Q;
    }
    function I1(K) {
      k.value = K, H1(K);
    }
    function Y1(K) {
      const Q = new Set(k.value.map((i1) => i1.value)), l1 = [...k.value];
      for (const i1 of K)
        Q.has(i1.value) || (Q.add(i1.value), l1.push(i1));
      k.value = l1, H1(K);
    }
    function le(K) {
      return n.minApiQueryLength > 0 && K.length < n.minApiQueryLength;
    }
    function we(K) {
      for (const Q of K)
        L.set(Q.value, Q);
      H1(K);
    }
    function se(K) {
      const Q = K.toLowerCase();
      return [...L.values()].filter((l1) => l1.text.toLowerCase().includes(Q)).sort((l1, i1) => l1.text.localeCompare(i1.text, "pt-BR"));
    }
    function q1(K) {
      const Q = se(K);
      return Q.length === 0 ? !1 : (c1(), I1(Q), m.value = 1, c.value = !1, H.value = !1, !0);
    }
    function ke(K, Q) {
      return !n.localSearchFirst && le(K) ? (Q || (c1(), I1([]), m.value = 1, c.value = !1), !0) : !1;
    }
    function Z1(K, Q, l1, i1) {
      Q ? Y1(K) : I1(K), m.value = l1, c.value = i1, H.value = !0;
    }
    function A1() {
      P.value = 0;
    }
    function q() {
      s1(() => {
        requestAnimationFrame(() => {
          v1();
        });
      });
    }
    function t1(K) {
      const { clientHeight: Q, scrollHeight: l1 } = K;
      return Q === 0 || l1 === 0 ? !1 : l1 <= Q + 4;
    }
    async function v1() {
      const K = d.value;
      if (!K || !c.value || C.value || n.localSearchFirst && !H.value || !t1(K) || P.value >= p5)
        return;
      P.value += 1;
      const Q = m.value + 1;
      await M1(h.value.trim(), Q, !0);
    }
    async function e1(K, Q, l1) {
      C.value = !0;
      try {
        const { items: i1, hasMore: E1, totalCount: j1 } = await n.fetchPage(K, Q);
        we(i1), b1(j1), Z1(i1, l1, Q, E1);
      } finally {
        C.value = !1, q();
      }
    }
    async function d1(K, Q, l1) {
      const i1 = K.trim();
      ke(i1, l1) || (!l1 && Q === 1 && c1(), await e1(i1, Q, l1));
    }
    async function _1(K, Q) {
      n.localSearchFirst && !H.value || await d1(K, Q, !0);
    }
    async function P1(K) {
      return n.localSearchFirst ? K === "" ? (await d1("", 1, !1), !0) : q1(K) : !1;
    }
    async function M1(K, Q, l1) {
      const i1 = K.trim();
      if (l1) {
        await _1(i1, Q);
        return;
      }
      await P1(i1) || await d1(i1, Q, !1);
    }
    function yt(K) {
      return window.innerHeight - K.bottom < Re ? Math.max(de, K.top - Re - 4) : K.bottom + 4;
    }
    function bt(K, Q) {
      const l1 = window.innerWidth;
      let i1 = K.left;
      i1 + Q > l1 - de && (i1 = K.right - Q);
      const E1 = l1 - Q - de;
      return Math.min(Math.max(i1, de), E1);
    }
    function _t() {
      var i1;
      const K = (i1 = a.value) == null ? void 0 : i1.querySelector("button");
      if (!K)
        return;
      const Q = K.getBoundingClientRect(), l1 = Math.max(Q.width, z.value);
      u.value = {
        top: yt(Q),
        left: bt(Q, l1),
        width: l1
      };
    }
    function Mt() {
      s1(() => {
        _t(), h.value = "", k.value = [], c1(), m.value = 0, c.value = !0, H.value = !0, A1(), M1("", 1, !1);
      });
    }
    function Lt() {
      F && clearTimeout(F), F = setTimeout(() => {
        F = null, M1(h.value.trim(), 1, !1);
      }, h5);
    }
    function $t(K) {
      const Q = K.target;
      h.value = Q.value, Lt();
    }
    function Vt() {
      h.value = "", k.value = [], c1(), m.value = 0, c.value = !0, A1();
    }
    function Bt(K) {
      const Q = K.target;
      if (!(Q.scrollTop + Q.clientHeight >= Q.scrollHeight - 24) || !c.value || C.value || n.localSearchFirst && !H.value)
        return;
      const i1 = m.value + 1;
      M1(h.value.trim(), i1, !0);
    }
    return r1(
      () => n.modelValue,
      (K) => {
        for (const Q of K)
          j.value[Q] || (j.value = { ...j.value, [Q]: Q });
      },
      { deep: !0, immediate: !0 }
    ), y1(() => {
      F && clearTimeout(F);
    }), (K, Q) => (l(), s("div", {
      ref_key: "containerRef",
      ref: a,
      class: "relative w-fit shrink-0"
    }, [
      J(D(D1), {
        modelValue: Z.value,
        "onUpdate:modelValue": Q[2] || (Q[2] = (l1) => Z.value = l1),
        multiple: "",
        disabled: e.disabled
      }, {
        default: Y(({ open: l1 }) => [
          J(D(r), {
            open: l1,
            onOpened: Mt
          }, null, 8, ["open"]),
          J(D(T1), {
            class: v([
              "flex w-full min-w-0 items-center justify-between gap-2 rounded-xl border border-transparent bg-grey-50 px-3 py-1.5 text-left transition-colors min-h-8",
              Z.value.length > 0 ? "border-royal-25 bg-royal-25 focus:outline-none focus:ring-2 focus:ring-primary" : "hover:bg-grey-100 focus:outline-none focus:ring-2 focus:ring-primary",
              e.disabled ? "cursor-not-allowed opacity-60" : ""
            ])
          }, {
            default: Y(() => [
              Z.value.length === 0 ? (l(), s("span", Q0, M(e.placeholder), 1)) : (l(), s("span", X0, M(S.value), 1)),
              (l(), s("svg", {
                class: v(["size-4 shrink-0 transition-transform", l1 ? "rotate-180" : "", b.value]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [...Q[3] || (Q[3] = [
                o("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                }, null, -1)
              ])], 2))
            ]),
            _: 2
          }, 1032, ["class"]),
          (l(), W(g1, { to: "body" }, [
            J(p1, {
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95",
              "enter-to-class": "opacity-100 scale-100",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100",
              "leave-to-class": "opacity-0 scale-95",
              onAfterLeave: Vt
            }, {
              default: Y(() => [
                l1 ? (l(), W(D(O1), {
                  key: 0,
                  class: v(y.value),
                  style: a1(X.value)
                }, {
                  default: Y(() => [
                    e.title && B.value ? (l(), W(R0, {
                      key: 0,
                      label: e.title
                    }, null, 8, ["label"])) : e.title ? (l(), s("div", J0, [
                      o("h3", e5, M(e.title), 1)
                    ])) : x("", !0),
                    o("div", t5, [
                      o("div", {
                        class: v([
                          "flex w-full items-center gap-2 rounded-lg bg-grey-50",
                          e.optionPresentation === "vehicle" ? "p-2" : "h-8 px-3 py-1.5 gap-1.5"
                        ])
                      }, [
                        Q[4] || (Q[4] = o("svg", {
                          class: "size-4 shrink-0 text-subtitle-gray",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          o("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          })
                        ], -1)),
                        o("input", {
                          value: h.value,
                          type: "search",
                          class: "min-w-0 flex-1 bg-transparent text-sm text-default-black placeholder:text-subtitle-gray focus:outline-none",
                          placeholder: T.value,
                          autocomplete: "off",
                          onClick: Q[0] || (Q[0] = o1(() => {
                          }, ["stop"])),
                          onKeydown: Q[1] || (Q[1] = o1(() => {
                          }, ["stop"])),
                          onInput: $t
                        }, null, 40, o5)
                      ], 2)
                    ]),
                    w.value ? (l(), s("div", n5, M(_.value), 1)) : x("", !0),
                    o("div", {
                      ref_key: "optionsScrollRef",
                      ref: d,
                      class: v([
                        "min-h-0 flex-1 overflow-y-auto",
                        e.optionPresentation === "vehicle" ? "flex flex-col gap-1 p-1" : "p-1"
                      ]),
                      onScroll: Bt
                    }, [
                      C.value && k.value.length === 0 ? (l(), s("div", r5, [
                        Q[5] || (Q[5] = o("span", { class: "inline-block size-6 animate-spin rounded-full border-2 border-grey-200 border-t-primary" }, null, -1)),
                        o("span", l5, M(A.value), 1)
                      ])) : (l(), s(n1, { key: 1 }, [
                        !C.value && V.value.length === 0 && O.value ? (l(), s("div", s5, M(R.value), 1)) : x("", !0),
                        (l(!0), s(n1, null, u1(V.value, (i1) => (l(), W(D(F1), {
                          key: i1.value,
                          value: i1.value
                        }, {
                          default: Y(({ active: E1, selected: j1 }) => [
                            e.optionPresentation === "user" ? (l(), s("div", i5, [
                              J(W0, {
                                label: i1.text,
                                "image-src": i1.imageSrc,
                                selected: j1,
                                highlighted: E1
                              }, null, 8, ["label", "image-src", "selected", "highlighted"])
                            ])) : e.optionPresentation === "vehicle" ? (l(), W(K0, {
                              key: 1,
                              label: i1.text,
                              selected: j1,
                              highlighted: E1
                            }, null, 8, ["label", "selected", "highlighted"])) : (l(), s("div", {
                              key: 2,
                              class: v([
                                "mx-1 flex cursor-pointer items-center gap-2 rounded-lg px-2 py-2 transition-colors",
                                j1 ? "bg-royal-25" : E1 ? "bg-grey-100" : ""
                              ])
                            }, [
                              o("span", {
                                class: v([
                                  "flex size-4 shrink-0 items-center justify-center rounded border-2 border-solid",
                                  j1 ? "border-primary bg-primary" : "border-grey-300 bg-white"
                                ])
                              }, [
                                j1 ? (l(), s("svg", a5, [...Q[6] || (Q[6] = [
                                  o("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "3",
                                    d: "M5 13l4 4L19 7"
                                  }, null, -1)
                                ])])) : x("", !0)
                              ], 2),
                              o("span", {
                                class: v([
                                  "min-w-0 flex-1 truncate text-sm",
                                  j1 ? "font-medium text-primary" : "text-default-black"
                                ]),
                                title: i1.text
                              }, M(i1.text), 11, d5)
                            ], 2))
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128)),
                        C.value && V.value.length > 0 ? (l(), s("div", u5, M(A.value), 1)) : x("", !0)
                      ], 64))
                    ], 34),
                    U.value ? (l(), s("div", c5, M($.value), 1)) : x("", !0)
                  ]),
                  _: 1
                }, 8, ["class", "style"])) : x("", !0)
              ]),
              _: 2
            }, 1024)
          ]))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ], 512));
  }
}), Lw = /* @__PURE__ */ I({
  name: "EcxUserAsyncMultiSelectFilter",
  __name: "EcxUserAsyncMultiSelectFilter",
  props: {
    modelValue: {},
    fetchPage: { type: Function },
    placeholder: {},
    title: {},
    allText: {},
    minApiQueryLength: {},
    localSearchFirst: { type: Boolean },
    searchPlaceholder: {},
    emptyText: {},
    loadingText: {},
    formatMinCharsHint: { type: Function },
    formatResultsCount: { type: Function },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    return (i, a) => (l(), W(ht, $e(r, {
      "option-presentation": "user",
      "onUpdate:modelValue": a[0] || (a[0] = (d) => n("update:modelValue", d))
    }), null, 16));
  }
}), $w = /* @__PURE__ */ I({
  name: "EcxVehicleAsyncMultiSelectFilter",
  __name: "EcxVehicleAsyncMultiSelectFilter",
  props: {
    modelValue: {},
    fetchPage: { type: Function },
    placeholder: {},
    title: {},
    allText: {},
    minApiQueryLength: {},
    localSearchFirst: { type: Boolean },
    searchPlaceholder: {},
    emptyText: {},
    loadingText: {},
    formatMinCharsHint: { type: Function },
    formatResultsCount: { type: Function },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    return (i, a) => (l(), W(ht, $e(r, {
      "option-presentation": "vehicle",
      "onUpdate:modelValue": a[0] || (a[0] = (d) => n("update:modelValue", d))
    }), null, 16));
  }
});
function N1(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}", "gu"), "").toLowerCase();
}
const f5 = {
  key: 0,
  class: "text-sm font-medium pb-1 text-default-black block"
}, C5 = {
  key: 0,
  class: "text-error"
}, g5 = { class: "relative" }, v5 = { class: "flex items-center gap-3 flex-1 min-w-0" }, m5 = {
  key: 0,
  class: "px-4 py-2.5 border-b bg-grey-50 border-grey-100"
}, x5 = { class: "text-sm font-medium text-default-black" }, w5 = {
  key: 1,
  class: "border-b border-grey-100 bg-white z-10 p-2 shrink-0"
}, k5 = { class: "flex items-center w-full h-8 px-3 py-1.5 bg-grey-50 rounded-lg gap-1.5" }, y5 = ["placeholder"], b5 = { class: "overflow-y-auto flex-1 max-h-60" }, _5 = {
  key: 0,
  class: "px-4 py-6 flex justify-center"
}, M5 = {
  key: 1,
  class: "px-4 py-3 text-sm text-subtitle-gray text-center"
}, L5 = { class: "flex-1 flex flex-col min-w-0" }, $5 = { class: "text-sm text-default-black truncate" }, V5 = {
  key: 0,
  class: "text-xs text-subtitle-gray truncate"
}, B5 = {
  key: 1,
  class: "px-2 py-0.5 rounded text-xs text-subtitle-gray bg-grey-100"
}, H5 = {
  key: 2,
  class: "w-5 h-5 text-primary flex-shrink-0",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, F5 = {
  key: 1,
  class: "text-xs text-error mt-1"
}, Vw = /* @__PURE__ */ I({
  __name: "EcxSearchableSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    title: {},
    placeholder: { default: "Selecione..." },
    searchable: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Pesquisar" },
    emptyText: { default: "Nenhum resultado encontrado" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    size: { default: "md" },
    iconComponent: {},
    error: {},
    externalSearch: { type: Boolean, default: !1 },
    searchByTextOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "search"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(null), u = E(null), h = E(""), C = E({ top: -9999, left: -9999, width: 300, maxHeight: 384 }), m = E(!1), c = f({
      get: () => n.modelValue,
      set: (R) => {
        i("update:modelValue", R), i("change", R), h.value = "";
      }
    }), p = f(() => {
      var R;
      if (n.options && n.options.length > 0)
        return (R = n.options.find((A) => A.value === c.value)) == null ? void 0 : R.text;
    }), k = f(() => {
      if (n.externalSearch || !h.value.trim())
        return n.options;
      const R = h.value.toLowerCase().trim();
      return n.options.map((A) => ({
        option: A,
        score: j(A, R)
      })).filter((A) => A.score !== null).sort((A, _) => A.score - _.score || A.option.text.localeCompare(_.option.text, "pt-BR")).map((A) => A.option);
    });
    function j(R, A) {
      var B, y;
      const _ = N1(A), w = N1(R.text);
      if (n.searchByTextOnly) {
        const b = ((B = w.split(" (")[0]) == null ? void 0 : B.trim()) ?? w;
        return b.startsWith(_) ? 0 : b.includes(_) ? 1 : null;
      }
      const O = ((y = w.split(" (")[0]) == null ? void 0 : y.trim()) ?? w, U = N1(
        R.searchText ?? `${R.text} ${R.subtext ?? ""} ${String(R.value ?? "")}`
      ), $ = N1(String(R.value ?? ""));
      return O.startsWith(_) ? 0 : O.includes(_) ? 1 : U.includes(_) ? 2 : $.includes(_) ? 3 : null;
    }
    function H(R) {
      return R && !m.value && (h.value = "", s1(() => {
        var A;
        (A = u.value) == null || A.focus();
      })), m.value = R, !0;
    }
    const L = f(() => ({
      sm: "h-10 px-3 text-sm",
      md: "h-12 px-3",
      lg: "h-14 px-4 text-lg"
    })[n.size]);
    let F = null;
    r1(h, (R) => {
      n.externalSearch && (F && clearTimeout(F), F = setTimeout(() => {
        i("search", R);
      }, 300));
    });
    const P = () => {
      Z();
    };
    function Z() {
      if (!d.value) return;
      let R = null;
      if (d.value instanceof HTMLElement ? R = d.value : d.value && typeof d.value == "object" && "$el" in d.value && (R = d.value.$el), !R || typeof R.getBoundingClientRect != "function") return;
      const A = R.getBoundingClientRect(), w = window.innerHeight - A.bottom, O = 200;
      let $ = Math.min(384, w - 20);
      $ < O && ($ = O), C.value = {
        top: A.bottom + 4,
        left: A.left,
        width: A.width,
        maxHeight: $
      };
    }
    const T = f(() => ({
      transform: `translate3d(${C.value.left}px, ${C.value.top}px, 0)`,
      width: `${C.value.width}px`,
      maxHeight: `${C.value.maxHeight}px`
    }));
    return t({
      selectedValue: c
    }), (R, A) => (l(), s("div", {
      class: "ecx-searchable-select flex flex-col",
      ref_key: "containerRef",
      ref: a
    }, [
      e.label ? (l(), s("label", f5, [
        h1(M(e.label) + " ", 1),
        e.required ? (l(), s("span", C5, "*")) : x("", !0)
      ])) : x("", !0),
      J(D(D1), {
        modelValue: c.value,
        "onUpdate:modelValue": A[3] || (A[3] = (_) => c.value = _),
        disabled: e.disabled
      }, {
        default: Y(({ open: _ }) => [
          w1(o("span", null, M(H(_)), 513), [
            [Le, !1]
          ]),
          o("div", g5, [
            J(D(T1), {
              ref_key: "buttonRef",
              ref: d,
              disabled: e.disabled,
              class: v(["rounded-lg w-full text-left flex justify-between items-center relative transition-colors", [
                e.disabled ? "bg-grey-50 border border-grey-200 outline-none cursor-not-allowed" : "outline outline-2 " + (_ ? "outline-primary" : "outline-grey-200"),
                L.value
              ]]),
              onClick: P
            }, {
              default: Y(() => [
                o("div", v5, [
                  G(R.$slots, "prefix", {}, () => [
                    e.iconComponent ? (l(), W(f1(e.iconComponent), {
                      key: 0,
                      class: v([
                        "w-5 h-5 flex-shrink-0 transition-colors",
                        _ || c.value ? "text-primary" : "text-subtitle-gray"
                      ])
                    }, null, 8, ["class"])) : x("", !0)
                  ]),
                  o("span", {
                    class: v(["truncate", c.value ? "text-default-black" : "text-subtitle-gray"])
                  }, M(p.value || e.placeholder), 3)
                ]),
                (l(), s("svg", {
                  class: v(["transition duration-150 flex-shrink-0 w-4 h-4", _ && "rotate-180"]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...A[4] || (A[4] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 2))
              ]),
              _: 2
            }, 1032, ["disabled", "class"]),
            (l(), W(g1, { to: "body" }, [
              J(p1, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition duration-200 ease-in",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: Y(() => [
                  _ ? (l(), W(D(O1), {
                    key: 0,
                    style: a1(T.value),
                    class: "rounded-lg fixed top-0 left-0 shadow-xl overflow-hidden bg-white z-[10001] outline-none border border-grey-200 flex flex-col will-change-transform"
                  }, {
                    default: Y(() => [
                      e.title ? (l(), s("div", m5, [
                        o("h3", x5, M(e.title), 1)
                      ])) : x("", !0),
                      e.searchable ? (l(), s("div", w5, [
                        o("div", k5, [
                          A[5] || (A[5] = o("svg", {
                            class: "w-4 h-4 text-subtitle-gray flex-shrink-0",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            o("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ], -1)),
                          w1(o("input", {
                            ref_key: "searchInputRef",
                            ref: u,
                            "onUpdate:modelValue": A[0] || (A[0] = (w) => h.value = w),
                            type: "text",
                            class: "flex-1 text-sm text-default-black placeholder:text-subtitle-gray focus:outline-none bg-transparent",
                            placeholder: e.searchPlaceholder,
                            onClick: A[1] || (A[1] = o1(() => {
                            }, ["stop"])),
                            onKeydown: A[2] || (A[2] = o1(() => {
                            }, ["stop"]))
                          }, null, 40, y5), [
                            [$1, h.value]
                          ])
                        ])
                      ])) : x("", !0),
                      o("div", b5, [
                        e.loading && n.options.length === 0 ? (l(), s("div", _5, [...A[6] || (A[6] = [
                          o("svg", {
                            class: "animate-spin h-5 w-5 text-primary",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            o("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            o("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ])])) : k.value.length === 0 ? (l(), s("div", M5, M(e.emptyText), 1)) : x("", !0),
                        (l(!0), s(n1, null, u1(k.value, (w) => (l(), W(D(F1), {
                          key: String(w.value),
                          value: w.value,
                          disabled: w.disabled
                        }, {
                          default: Y(({ active: O, selected: U }) => [
                            o("div", {
                              class: v(["px-4 py-3 flex items-center gap-3 transition-colors cursor-pointer", [
                                O ? "bg-grey-100" : "",
                                U ? "bg-grey-50" : "",
                                w.disabled && "opacity-50 cursor-not-allowed"
                              ]])
                            }, [
                              e.iconComponent ? (l(), W(f1(e.iconComponent), {
                                key: 0,
                                class: v([
                                  "w-5 h-5 flex-shrink-0 transition-colors",
                                  U || O ? "text-primary" : "text-subtitle-gray"
                                ])
                              }, null, 8, ["class"])) : x("", !0),
                              o("div", L5, [
                                o("span", $5, M(w.text), 1),
                                w.subtext ? (l(), s("span", V5, M(w.subtext), 1)) : x("", !0)
                              ]),
                              w.count !== void 0 ? (l(), s("span", B5, M(w.count), 1)) : x("", !0),
                              U ? (l(), s("svg", H5, [...A[7] || (A[7] = [
                                o("path", {
                                  "fill-rule": "evenodd",
                                  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                  "clip-rule": "evenodd"
                                }, null, -1)
                              ])])) : x("", !0)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["style"])) : x("", !0)
                ]),
                _: 2
              }, 1024)
            ]))
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"]),
      e.error ? (l(), s("span", F5, M(e.error), 1)) : x("", !0)
    ], 512));
  }
});
function A5(e) {
  return At() ? (jt(e), !0) : !1;
}
function pt(e) {
  return typeof e == "function" ? e() : D(e);
}
const j5 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const I5 = Object.prototype.toString, Z5 = (e) => I5.call(e) === "[object Object]", E5 = () => {
}, S5 = j5 ? window : void 0;
function z5(e) {
  var t;
  const r = pt(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function pe(...e) {
  let t, r, n, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([r, n, i] = e, t = S5) : [t, r, n, i] = e, !t)
    return E5;
  Array.isArray(r) || (r = [r]), Array.isArray(n) || (n = [n]);
  const a = [], d = () => {
    a.forEach((m) => m()), a.length = 0;
  }, u = (m, c, p, k) => (m.addEventListener(c, p, k), () => m.removeEventListener(c, p, k)), h = r1(
    () => [z5(t), pt(i)],
    ([m, c]) => {
      if (d(), !m)
        return;
      const p = Z5(c) ? { ...c } : c;
      a.push(
        ...r.flatMap((k) => n.map((j) => u(m, k, j, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), C = () => {
    h(), d();
  };
  return A5(C), C;
}
const D5 = {}, T5 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function O5(e, t) {
  return l(), s("svg", T5, [...t[0] || (t[0] = [
    o("path", {
      d: "M6.6665 6.66699L13.3332 13.3337",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13.3332 6.66699L6.6665 13.3337",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ft = /* @__PURE__ */ g(D5, [["render", O5]]), Ne = /* @__PURE__ */ I({
  __name: "VehicleAssetSliderVehicleIcon",
  props: {
    active: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = f(
      () => t.color != null && t.color !== "" ? { color: t.color } : void 0
    );
    return (n, i) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      class: "block h-5 w-5 shrink-0",
      "aria-hidden": "true",
      style: a1(r.value)
    }, [...i[0] || (i[0] = [
      N('<path d="M17.5001 13.75V16.6667C17.5001 17.1269 17.127 17.5 16.6667 17.5H15.0001C14.5398 17.5 14.1667 17.1269 14.1667 16.6667V15.4167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83333 15.4167V16.6667C5.83333 17.1269 5.46024 17.5 5 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 13.75V11.4545C2.5 10.7909 2.76347 10.1545 3.2325 9.685L4.16667 8.75H15.8333L16.7675 9.68417C17.2365 10.1532 17.5 10.7893 17.5 11.4526V13.75C17.5 14.6705 16.7538 15.4167 15.8333 15.4167H4.16667C3.24619 15.4167 2.5 14.6705 2.5 13.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.4999 7.91683L15.8333 8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.16667 8.3335L2.5 7.91683" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.16675 8.74984V8.32817L4.86341 5.714C5.10659 4.80147 5.93295 4.16649 6.87733 4.1665H13.1962C14.1606 4.1665 14.9989 4.82842 15.2226 5.7665L15.8334 8.32817V8.74984" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 12.0832H6.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3333 12.0832H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 8)
    ])], 4));
  }
}), Ct = "/assets/images/vehicles", Ge = {
  car: { standard: "cars/car.png", large: "cars/car-4x.png" },
  pickup: { standard: "cars/pickup.png", large: "cars/pickup-4x.png" },
  van: { standard: "cars/van.png", large: "cars/van-4x.png" },
  vuc: { standard: "cars/vuc.png", large: "cars/vuc-4x.png" },
  heavy: { standard: "cars/heavy.png", large: "cars/heavy-4x.png" },
  motorcycle: { standard: "cars/motorcycle.png", large: "cars/motorcycle-4x.png" },
  other: { standard: "cars/other.png", large: "cars/other-4x.png" }
}, Ue = {
  agricultural: {
    standard: "equipments/agricultural.png",
    large: "equipments/agricultural-4x.png"
  },
  logistics: {
    standard: "equipments/logistics.png",
    large: "equipments/logistics-4x.png"
  },
  cleaning: {
    standard: "equipments/cleaning.png",
    large: "equipments/cleaning-4x.png"
  },
  energy: {
    standard: "equipments/energy.png",
    large: "equipments/energy-4x.png"
  },
  other: {
    standard: "equipments/other.png",
    large: "equipments/other-4x.png"
  }
};
function P5(e) {
  if (e.assetKind === "equipment") {
    const r = e.equipmentsType ?? "other";
    return Ue[r] ?? Ue.other;
  }
  const t = e.vehicleType ?? "car";
  return Ge[t] ?? Ge.other;
}
function R5(e) {
  return e.replace(/\/$/, "");
}
function N5(e, t = {}) {
  const r = t.density ?? "1x", n = R5(t.publicBasePath ?? Ct), i = P5(e), a = r === "4x" ? i.large : i.standard;
  return `${n}/${a}`;
}
function Bw(e) {
  if (typeof window > "u" || e === "")
    return;
  const t = new Image();
  t.src = e;
}
const G5 = ["src", "loading", "fetchpriority"], We = 32, U5 = /* @__PURE__ */ I({
  __name: "VehicleIllustrationIcon",
  props: {
    spec: {},
    publicBasePath: { default: Ct },
    assetDensity: { default: "1x" },
    imgClass: { default: "h-8 w-8" },
    imgLoading: { default: "lazy" }
  },
  setup(e) {
    const t = e, r = f(
      () => N5(t.spec, {
        density: t.assetDensity,
        publicBasePath: t.publicBasePath
      })
    ), n = f(
      () => t.imgLoading === "eager" ? "high" : "auto"
    );
    return (i, a) => (l(), s("img", {
      class: v(["shrink-0 object-cover", e.imgClass]),
      src: r.value,
      alt: "",
      width: We,
      height: We,
      loading: e.imgLoading,
      fetchpriority: n.value,
      decoding: "async",
      "aria-hidden": "true"
    }, null, 10, G5));
  }
}), W5 = {
  class: "ecx-vehicle-search-select flex w-full flex-col gap-1",
  "data-testid": "ecx-vehicle-search-select"
}, Y5 = { class: "relative" }, q5 = {
  class: "inline-flex shrink-0 text-subtitle-gray [&_svg]:block",
  "aria-hidden": "true"
}, K5 = { class: "flex min-w-0 flex-1 items-center gap-2" }, Q5 = { class: "flex max-w-full min-h-0 min-w-0 items-center justify-center gap-2 rounded-lg bg-royal-25 py-1 pl-3 pr-1" }, X5 = { class: "min-w-0 truncate text-left text-sm text-royal-500" }, J5 = ["aria-label"], e4 = {
  class: "inline-flex shrink-0 text-subtitle-gray [&_svg]:block",
  "aria-hidden": "true"
}, t4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, o4 = { class: "flex shrink-0 items-center border-b border-grey-100 bg-grey-50 px-3 py-2" }, n4 = { class: "text-xs font-normal uppercase tracking-tight text-grey-600" }, r4 = { class: "border-b border-grey-100 bg-white p-2" }, l4 = { class: "flex h-9 w-full items-center gap-1.5 rounded-lg bg-grey-50 px-3 py-1.5" }, s4 = ["placeholder"], i4 = { class: "cursor-pointer select-none rounded-lg px-3 py-2 text-sm text-subtitle-gray italic hover:bg-grey-50" }, a4 = {
  key: 1,
  class: "px-3 py-4 text-center text-sm text-error"
}, d4 = {
  key: 2,
  class: "px-3 py-4 text-center text-sm text-subtitle-gray"
}, u4 = {
  key: 3,
  class: "px-3 py-4 text-center text-sm text-subtitle-gray"
}, c4 = {
  key: 0,
  class: "h-3 w-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, h4 = { class: "flex min-w-0 flex-1 gap-2" }, p4 = { class: "flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-grey-100" }, f4 = { class: "min-w-0 flex-1" }, C4 = { class: "truncate text-sm text-grey-950" }, g4 = { class: "truncate text-xs text-grey-500" }, v4 = {
  key: 4,
  class: "px-3 py-2 text-center text-xs text-subtitle-gray"
}, m4 = 80, S1 = 8, R1 = 4, Ye = 320, Hw = /* @__PURE__ */ I({
  __name: "EcxVehicleSearchSelect",
  props: {
    modelValue: {},
    items: {},
    label: { default: "" },
    dropdownTitle: { default: "" },
    searchPlaceholder: { default: "Pesquisar" },
    triggerPlaceholder: { default: "Selecione..." },
    clearSelectionLabel: { default: "Limpar seleção" },
    emptyText: { default: "Nenhum resultado" },
    loadingText: { default: "Carregando..." },
    errorText: { default: "Erro ao carregar" },
    loading: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    hasMore: { type: Boolean, default: !1 },
    loadingMoreText: { default: "" },
    error: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "clear", "search", "load-more"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = `ecx-vehicle-search-select-${Math.random().toString(36).slice(2, 9)}`, a = E(null), d = E(null), u = E("");
    let h;
    const C = f(
      () => r.loadingMoreText !== "" ? r.loadingMoreText : r.loadingText
    );
    function m(B) {
      if (!r.hasMore || r.loading || r.loadingMore || r.error)
        return;
      const y = B.target;
      if (!(y instanceof HTMLElement))
        return;
      y.scrollHeight - y.scrollTop - y.clientHeight <= m4 && n("load-more");
    }
    const c = E({ top: -9999, left: -9999, width: 300, maxHeight: 320 });
    function p() {
      const B = a.value;
      if (B instanceof HTMLElement)
        return B;
      if (B && typeof B == "object" && "$el" in B) {
        const y = B.$el;
        return y instanceof HTMLElement ? y : null;
      }
      return null;
    }
    function k(B, y) {
      const b = window.innerWidth, V = S1, S = b - S1 - y;
      return Number.isFinite(S) && S < V ? V : Math.min(Math.max(B.left, V), Math.max(V, S));
    }
    function j(B, y) {
      const b = Math.max(
        0,
        y - B.bottom - R1 - S1
      ), V = Math.max(0, B.top - R1 - S1), S = Math.min(Ye, b), z = Math.min(Ye, V), X = S >= z;
      return X && S > 0 ? { top: B.bottom + R1, maxHeight: S } : !X && z > 0 ? { top: B.top - R1 - z, maxHeight: z } : S > 0 ? { top: B.bottom + R1, maxHeight: S } : z > 0 ? { top: B.top - R1 - z, maxHeight: z } : {
        top: S1,
        maxHeight: Math.max(120, y - S1 * 2)
      };
    }
    function H() {
      const B = p();
      if (!B || typeof B.getBoundingClientRect != "function")
        return;
      const y = B.getBoundingClientRect(), b = window.innerHeight, V = window.innerWidth, S = Math.min(y.width, V - S1 * 2), z = k(y, S), { top: X, maxHeight: c1 } = j(y, b);
      c.value = { top: X, left: z, width: S, maxHeight: c1 };
    }
    function L(B) {
      if (B.getAttribute("aria-expanded") === "true")
        return !0;
      const y = B.getAttribute("data-headlessui-state");
      return y !== null && y.includes("open");
    }
    function F() {
      const B = p();
      B && L(B) && H();
    }
    const P = f(() => ({
      transform: `translate3d(${c.value.left}px, ${c.value.top}px, 0)`,
      width: `${c.value.width}px`,
      maxHeight: `${c.value.maxHeight}px`
    }));
    pe(window, "scroll", F, { capture: !0 }), pe(window, "resize", F);
    const Z = [
      "relative flex w-full min-h-11 cursor-pointer items-center rounded-lg border border-grey-300",
      "bg-white py-3 pl-3 pr-10 text-left transition-all",
      "focus:border-royal-300 focus:bg-white focus:outline-none focus:shadow-ecx-focus-ring"
    ].join(" "), T = E(null), R = f(() => r.modelValue ? r.items.find((B) => B.id === r.modelValue) ?? T.value : null), A = f(
      () => !!(r.modelValue && R.value)
    ), _ = f(() => {
      const B = R.value;
      return B == null ? "" : `${B.plate} • ${B.detailLine}`;
    }), w = f(() => {
      var y;
      if (!r.modelValue)
        return r.triggerPlaceholder;
      const B = r.items.find((b) => b.id === r.modelValue);
      return B ? B.plate : ((y = T.value) == null ? void 0 : y.id) === r.modelValue ? T.value.plate : r.modelValue;
    });
    function O() {
      window.clearTimeout(h), h = window.setTimeout(() => {
        n("search", u.value);
      }, 280);
    }
    function U() {
      T.value = null, n("update:modelValue", null), n("clear");
    }
    function $(B) {
      if (B == null || B === "") {
        T.value = null, n("update:modelValue", null), n("clear");
        return;
      }
      const y = r.items.find((b) => b.id === B);
      y && (T.value = y, n("update:modelValue", B));
    }
    return r1(u, () => {
      O();
    }), r1(
      () => r.modelValue,
      (B) => {
        B == null && (T.value = null);
      }
    ), r1(
      () => [r.items.length, r.loading],
      () => {
        s1(() => F());
      }
    ), (B, y) => (l(), s("div", W5, [
      e.label ? (l(), s("label", {
        key: 0,
        class: "text-xs font-normal text-grey-800",
        for: i
      }, M(e.label), 1)) : x("", !0),
      J(D(D1), {
        "model-value": e.modelValue,
        disabled: e.disabled,
        as: "div",
        "onUpdate:modelValue": $
      }, {
        default: Y(({ open: b }) => [
          o("div", Y5, [
            J(D(T1), {
              ref_key: "listboxButtonRef",
              ref: a,
              id: i,
              type: "button",
              class: v([D(Z), A.value ? "min-h-12 py-2.5" : ""]),
              onClick: H
            }, {
              default: Y(() => [
                A.value && R.value ? (l(), s(n1, { key: 0 }, [
                  o("span", q5, [
                    J(Ne)
                  ]),
                  o("div", K5, [
                    o("div", Q5, [
                      o("span", X5, M(_.value), 1),
                      o("button", {
                        type: "button",
                        class: "inline-flex size-5 shrink-0 items-center justify-center rounded text-royal-500 transition-colors hover:bg-royal-50 hover:text-royal-600",
                        "aria-label": e.clearSelectionLabel,
                        onClick: o1(U, ["stop"])
                      }, [
                        J(ft, {
                          class: "size-5",
                          "aria-hidden": "true"
                        })
                      ], 8, J5)
                    ])
                  ])
                ], 64)) : (l(), s(n1, { key: 1 }, [
                  o("span", e4, [
                    J(Ne)
                  ]),
                  o("span", {
                    class: v([
                      "min-w-0 flex-1 truncate pl-2 text-left text-base",
                      e.modelValue ? "text-grey-950" : "text-form-placeholder"
                    ])
                  }, M(w.value), 3)
                ], 64)),
                o("span", t4, [
                  (l(), s("svg", {
                    class: v(["h-5 w-5 text-subtitle-gray transition-transform duration-200", { "rotate-180": b }]),
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [...y[3] || (y[3] = [
                    o("path", {
                      "fill-rule": "evenodd",
                      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ])], 2))
                ])
              ]),
              _: 2
            }, 1032, ["class"]),
            (l(), W(g1, { to: "body" }, [
              J(p1, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition duration-75 ease-in",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0",
                onAfterEnter: H
              }, {
                default: Y(() => [
                  b ? (l(), W(D(O1), {
                    key: 0,
                    style: a1(P.value),
                    class: "fixed top-0 left-0 z-ecx-vehicle-search-dropdown flex min-w-0 flex-col overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 will-change-transform focus:outline-none"
                  }, {
                    default: Y(() => [
                      o("div", o4, [
                        o("p", n4, M(e.dropdownTitle), 1)
                      ]),
                      o("div", r4, [
                        o("div", l4, [
                          y[4] || (y[4] = o("svg", {
                            class: "h-4 w-4 shrink-0 text-subtitle-gray",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true"
                          }, [
                            o("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ], -1)),
                          w1(o("input", {
                            "onUpdate:modelValue": y[0] || (y[0] = (V) => u.value = V),
                            type: "search",
                            class: "min-w-0 flex-1 bg-transparent text-sm text-grey-950 placeholder:text-subtitle-gray focus:outline-none",
                            placeholder: e.searchPlaceholder,
                            autocomplete: "off",
                            onClick: y[1] || (y[1] = o1(() => {
                            }, ["stop"])),
                            onKeydown: y[2] || (y[2] = o1(() => {
                            }, ["stop"]))
                          }, null, 40, s4), [
                            [$1, u.value]
                          ])
                        ])
                      ]),
                      o("div", {
                        ref_key: "listScrollRef",
                        ref: d,
                        class: "min-h-0 flex-1 overflow-y-auto p-1",
                        onScrollPassive: m
                      }, [
                        e.modelValue && !e.disabled ? (l(), W(D(F1), {
                          key: 0,
                          value: null,
                          as: "template"
                        }, {
                          default: Y(() => [
                            o("li", i4, M(e.clearSelectionLabel), 1)
                          ]),
                          _: 1
                        })) : x("", !0),
                        e.error ? (l(), s("div", a4, M(e.errorText), 1)) : e.loading && e.items.length === 0 ? (l(), s("div", d4, M(e.loadingText), 1)) : !e.loading && e.items.length === 0 ? (l(), s("div", u4, M(e.emptyText), 1)) : x("", !0),
                        (l(!0), s(n1, null, u1(e.items, (V) => (l(), W(D(F1), {
                          key: V.id,
                          value: V.id,
                          as: "template"
                        }, {
                          default: Y(({ active: S, selected: z }) => [
                            o("li", {
                              class: v([
                                "flex cursor-pointer select-none gap-2 rounded-xl px-3 py-2",
                                S ? "bg-grey-100" : "bg-white",
                                z ? "ring-1 ring-royal-200" : ""
                              ])
                            }, [
                              o("span", {
                                class: v(["mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 border-solid", z ? "border-primary bg-primary" : "border-grey-300 bg-white"])
                              }, [
                                z ? (l(), s("svg", c4, [...y[5] || (y[5] = [
                                  o("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "3",
                                    d: "M5 13l4 4L19 7"
                                  }, null, -1)
                                ])])) : x("", !0)
                              ], 2),
                              o("div", h4, [
                                o("div", p4, [
                                  J(U5, {
                                    spec: V.illustrationSpec,
                                    "img-class": "h-full w-full min-h-0 min-w-0 object-cover"
                                  }, null, 8, ["spec"])
                                ]),
                                o("div", f4, [
                                  o("p", C4, M(V.plate), 1),
                                  o("p", g4, M(V.detailLine), 1)
                                ])
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128)),
                        e.loadingMore && e.items.length > 0 ? (l(), s("div", v4, M(C.value), 1)) : x("", !0)
                      ], 544)
                    ]),
                    _: 1
                  }, 8, ["style"])) : x("", !0)
                ]),
                _: 2
              }, 1024)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["model-value", "disabled"])
    ]));
  }
}), x4 = {}, w4 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function k4(e, t) {
  return l(), s("svg", w4, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 5.28613V14.7142",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M14.714 10.0002H5.28595",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const gt = /* @__PURE__ */ g(x4, [["render", k4]]), y4 = {}, b4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none",
  class: "w-5 h-5"
};
function _4(e, t) {
  return l(), s("svg", b4, [...t[0] || (t[0] = [
    o("path", {
      d: "M4 6L8 10L12 6",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const vt = /* @__PURE__ */ g(y4, [["render", _4]]), M4 = {
  class: "ecx-creatable-select flex w-full flex-col gap-1",
  "data-testid": "ecx-creatable-select"
}, L4 = { class: "relative" }, $4 = {
  key: 0,
  class: "inline-flex shrink-0 text-subtitle-gray [&_svg]:block",
  "aria-hidden": "true"
}, V4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center gap-1 pr-3" }, B4 = ["aria-label"], H4 = {
  key: 0,
  class: "flex shrink-0 items-center border-b border-grey-100 bg-grey-50 px-3 py-2"
}, F4 = { class: "text-xs font-normal uppercase tracking-tight text-grey-600" }, A4 = {
  key: 1,
  class: "border-b border-grey-100 bg-white p-2"
}, j4 = { class: "flex h-9 w-full items-center gap-1.5 rounded-lg bg-grey-50 px-3 py-1.5" }, I4 = ["placeholder"], Z4 = { class: "truncate" }, E4 = { class: "min-h-0 flex-1 overflow-y-auto p-2" }, S4 = {
  key: 0,
  class: "flex items-center justify-center px-3 py-8",
  "data-testid": "ecx-creatable-select-loading"
}, z4 = {
  key: 1,
  class: "px-3 py-6 text-center",
  "data-testid": "ecx-creatable-select-error"
}, D4 = { class: "text-sm text-error" }, T4 = {
  key: 2,
  class: "px-3 py-6 text-center",
  "data-testid": "ecx-creatable-select-empty"
}, O4 = { class: "text-sm text-subtitle-gray" }, P4 = { class: "flex min-w-0 flex-1 flex-col" }, R4 = {
  key: 0,
  class: "truncate text-xs text-grey-500"
}, z1 = 8, ue = 4, qe = 320, Fw = /* @__PURE__ */ I({
  __name: "EcxCreatableSelect",
  props: {
    modelValue: {},
    options: {},
    selectedOption: { default: null },
    label: { default: "" },
    dropdownTitle: { default: "" },
    placeholder: { default: "Selecione" },
    searchPlaceholder: { default: "Pesquisar" },
    searchable: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    emptyText: { default: "Nenhum resultado" },
    disabled: { type: Boolean, default: !1 },
    externalSearch: { type: Boolean, default: !1 },
    creatable: { type: Boolean, default: !1 },
    createLabel: { default: "" },
    canCreate: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    clearLabel: { default: "Limpar seleção" },
    icon: { default: void 0 },
    optionIcon: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "search", "create"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = `ecx-creatable-select-${Math.random().toString(36).slice(2, 9)}`, a = E(null), d = E("");
    let u;
    const h = f(
      () => r.clearable && !!r.modelValue && !r.disabled
    ), C = f(
      () => [
        "relative flex w-full min-h-12 cursor-pointer items-center rounded-lg border border-grey-300",
        "bg-white py-3.5 pl-3 text-left transition-all",
        "focus:border-royal-300 focus:bg-white focus:outline-none focus:shadow-ecx-focus-ring",
        h.value ? "pr-16" : "pr-10"
      ].join(" ")
    ), m = f(
      () => typeof r.error == "string" ? r.error.length > 0 : r.error
    ), c = f(
      () => typeof r.error == "string" ? r.error : ""
    ), p = f(
      () => r.creatable && r.canCreate
    ), k = f(() => {
      var b;
      if (!r.modelValue) return null;
      const y = r.options.find((V) => V.value === r.modelValue);
      return y || (((b = r.selectedOption) == null ? void 0 : b.value) === r.modelValue ? r.selectedOption : null);
    }), j = f(() => {
      var y;
      return r.modelValue ? ((y = k.value) == null ? void 0 : y.text) ?? r.modelValue : r.placeholder;
    }), H = f(() => {
      const y = d.value.trim();
      if (r.externalSearch || !y) return r.options;
      const b = N1(y);
      return r.options.filter((V) => L(V, b));
    });
    function L(y, b) {
      return N1(`${y.text} ${y.searchText ?? ""}`).includes(b);
    }
    function F() {
      const y = _();
      y && y.getAttribute("aria-expanded") === "true" && y.click();
    }
    function P() {
      F(), n("create");
    }
    function Z() {
      d.value = "", n("update:modelValue", null), n("change", null);
    }
    function T(y) {
      d.value = "", n("update:modelValue", y), n("change", y);
    }
    function R() {
      window.clearTimeout(u), u = window.setTimeout(() => n("search", d.value), 280);
    }
    r1(d, () => {
      r.externalSearch && R();
    });
    const A = E({ top: -9999, left: -9999, width: 300, maxHeight: 320 });
    function _() {
      const y = a.value;
      if (y instanceof HTMLElement) return y;
      if (y && typeof y == "object" && "$el" in y) {
        const b = y.$el;
        return b instanceof HTMLElement ? b : null;
      }
      return null;
    }
    function w(y, b) {
      const V = z1, S = window.innerWidth - z1 - b;
      return Number.isFinite(S) && S < V ? V : Math.min(Math.max(y.left, V), Math.max(V, S));
    }
    function O(y, b) {
      const V = Math.max(0, b - y.bottom - ue - z1), S = Math.max(0, y.top - ue - z1), z = Math.min(qe, V), X = Math.min(qe, S);
      return z >= X && z > 0 ? { top: y.bottom + ue, maxHeight: z } : X > 0 ? { top: y.top - ue - X, maxHeight: X } : {
        top: z1,
        maxHeight: Math.max(120, b - z1 * 2)
      };
    }
    function U() {
      const y = _();
      if (!y || typeof y.getBoundingClientRect != "function") return;
      const b = y.getBoundingClientRect(), V = Math.min(b.width, window.innerWidth - z1 * 2), S = w(b, V), { top: z, maxHeight: X } = O(b, window.innerHeight);
      A.value = { top: z, left: S, width: V, maxHeight: X };
    }
    function $() {
      const y = _();
      y && y.getAttribute("aria-expanded") === "true" && U();
    }
    const B = f(() => ({
      transform: `translate3d(${A.value.left}px, ${A.value.top}px, 0)`,
      width: `${A.value.width}px`,
      maxHeight: `${A.value.maxHeight}px`
    }));
    return pe(window, "scroll", $, { capture: !0 }), pe(window, "resize", $), r1(
      () => [r.options.length, r.loading],
      () => void s1(() => $())
    ), (y, b) => (l(), s("div", M4, [
      e.label ? (l(), s("label", {
        key: 0,
        class: "text-xs font-normal text-grey-800",
        for: i
      }, M(e.label), 1)) : x("", !0),
      J(D(D1), {
        "model-value": e.modelValue,
        disabled: e.disabled,
        as: "div",
        "onUpdate:modelValue": T
      }, {
        default: Y(({ open: V }) => [
          o("div", L4, [
            J(D(T1), {
              ref_key: "listboxButtonRef",
              ref: a,
              id: i,
              type: "button",
              class: v(C.value),
              onClick: U
            }, {
              default: Y(() => [
                e.icon ? (l(), s("span", $4, [
                  (l(), W(f1(e.icon), { class: "h-5 w-5" }))
                ])) : x("", !0),
                o("span", {
                  class: v([
                    "min-w-0 flex-1 truncate text-left text-base",
                    e.icon ? "pl-2" : "",
                    e.modelValue ? "text-grey-950" : "text-form-placeholder"
                  ])
                }, M(j.value), 3),
                o("span", V4, [
                  h.value ? (l(), s("button", {
                    key: 0,
                    type: "button",
                    class: "pointer-events-auto inline-flex size-5 shrink-0 items-center justify-center rounded text-subtitle-gray transition-colors hover:bg-grey-100 hover:text-grey-700 focus:outline-none focus:shadow-ecx-focus-ring",
                    "aria-label": e.clearLabel,
                    "data-testid": "ecx-creatable-select-clear",
                    onClick: o1(Z, ["stop"])
                  }, [
                    J(ft, {
                      class: "size-5",
                      "aria-hidden": "true"
                    })
                  ], 8, B4)) : x("", !0),
                  J(vt, {
                    class: v(["h-5 w-5 text-subtitle-gray transition-transform duration-200", { "rotate-180": V }])
                  }, null, 8, ["class"])
                ])
              ]),
              _: 2
            }, 1032, ["class"]),
            (l(), W(g1, { to: "body" }, [
              J(p1, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition duration-75 ease-in",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0",
                onAfterEnter: U
              }, {
                default: Y(() => [
                  V ? (l(), W(D(O1), {
                    key: 0,
                    style: a1(B.value),
                    class: "fixed left-0 top-0 z-ecx-vehicle-search-dropdown flex min-w-0 flex-col overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 will-change-transform focus:outline-none"
                  }, {
                    default: Y(() => [
                      e.dropdownTitle ? (l(), s("div", H4, [
                        o("p", F4, M(e.dropdownTitle), 1)
                      ])) : x("", !0),
                      e.searchable ? (l(), s("div", A4, [
                        o("div", j4, [
                          b[3] || (b[3] = o("svg", {
                            class: "h-4 w-4 shrink-0 text-subtitle-gray",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true"
                          }, [
                            o("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ], -1)),
                          w1(o("input", {
                            "onUpdate:modelValue": b[0] || (b[0] = (S) => d.value = S),
                            type: "search",
                            class: "min-w-0 flex-1 bg-transparent text-sm text-grey-950 placeholder:text-subtitle-gray focus:outline-none",
                            placeholder: e.searchPlaceholder,
                            autocomplete: "off",
                            "data-testid": "ecx-creatable-select-search",
                            onClick: b[1] || (b[1] = o1(() => {
                            }, ["stop"])),
                            onKeydown: b[2] || (b[2] = o1(() => {
                            }, ["stop"]))
                          }, null, 40, I4), [
                            [$1, d.value]
                          ])
                        ])
                      ])) : x("", !0),
                      p.value ? (l(), s("button", {
                        key: 2,
                        type: "button",
                        class: "mx-2 mt-2 flex shrink-0 items-center justify-center gap-1.5 rounded-lg border border-royal-300 px-3 py-2.5 text-sm font-medium text-royal-500 transition-colors hover:bg-royal-25 focus:outline-none focus:shadow-ecx-focus-ring",
                        "data-testid": "ecx-creatable-select-create",
                        onClick: o1(P, ["stop"])
                      }, [
                        J(gt, { class: "h-5 w-5 shrink-0" }),
                        o("span", Z4, M(e.createLabel), 1)
                      ])) : x("", !0),
                      o("div", E4, [
                        e.loading ? (l(), s("div", S4, [...b[4] || (b[4] = [
                          o("svg", {
                            class: "h-6 w-6 animate-spin text-primary",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true"
                          }, [
                            o("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            o("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ])])) : m.value ? (l(), s("div", z4, [
                          G(y.$slots, "error", {}, () => [
                            o("p", D4, M(c.value), 1)
                          ])
                        ])) : H.value.length === 0 ? (l(), s("div", T4, [
                          G(y.$slots, "empty", {}, () => [
                            o("p", O4, M(e.emptyText), 1)
                          ])
                        ])) : (l(!0), s(n1, { key: 3 }, u1(H.value, (S) => (l(), W(D(F1), {
                          key: S.value,
                          value: S.value,
                          disabled: S.disabled,
                          as: "template"
                        }, {
                          default: Y(({ active: z, selected: X }) => [
                            o("li", {
                              class: v([
                                "flex cursor-pointer select-none items-center gap-2 rounded-lg px-3 py-2.5",
                                z ? "bg-grey-100" : "",
                                X ? "bg-royal-25 ring-1 ring-royal-200" : "",
                                S.disabled ? "cursor-not-allowed opacity-50" : ""
                              ]),
                              "data-testid": "ecx-creatable-select-option"
                            }, [
                              e.optionIcon ?? e.icon ? (l(), W(f1(e.optionIcon ?? e.icon), {
                                key: 0,
                                class: v(["h-5 w-5 shrink-0", X ? "text-royal-500" : "text-subtitle-gray"]),
                                "aria-hidden": "true"
                              }, null, 8, ["class"])) : x("", !0),
                              o("div", P4, [
                                o("span", {
                                  class: v(["truncate text-sm", X ? "font-medium text-royal-500" : "text-grey-950"])
                                }, M(S.text), 3),
                                S.subtext ? (l(), s("span", R4, M(S.subtext), 1)) : x("", !0)
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ])
                    ]),
                    _: 3
                  }, 8, ["style"])) : x("", !0)
                ]),
                _: 2
              }, 1024)
            ]))
          ])
        ]),
        _: 3
      }, 8, ["model-value", "disabled"])
    ]));
  }
}), Aw = /* @__PURE__ */ I({
  __name: "EcxForm",
  props: {
    initialValues: {},
    validationSchema: {},
    validateOnMount: { type: Boolean, default: !1 },
    class: {},
    gap: { default: "md" },
    direction: { default: "column" }
  },
  emits: ["submit", "invalid-submit", "reset", "change"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), {
      handleSubmit: d,
      resetForm: u,
      values: h,
      errors: C,
      meta: m,
      setFieldValue: c,
      setValues: p,
      validate: k,
      validateField: j,
      isSubmitting: H
    } = Zt({
      initialValues: n.initialValues,
      validationSchema: n.validationSchema,
      validateOnMount: n.validateOnMount
    }), L = f(() => h), F = f(() => C.value), P = f(() => m.value.valid), Z = f(() => m.value.dirty), T = E(!1), R = d(
      async (B) => {
        T.value = !0;
        try {
          i("submit", B);
        } finally {
          T.value = !1;
        }
      },
      (B) => {
        i("invalid-submit", B.errors);
      }
    ), A = () => {
      u(), i("reset");
    }, _ = async () => (await k()).valid, w = {
      none: "",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    }, O = {
      column: "flex flex-col",
      row: "flex flex-row flex-wrap"
    }, U = f(() => [
      O[n.direction],
      w[n.gap],
      n.class
    ].filter(Boolean).join(" ")), $ = Symbol("EcxFormContext");
    return ee($, {
      handleSubmit: d,
      resetForm: u,
      values: h,
      errors: C,
      meta: m,
      setFieldValue: c,
      setValues: p,
      validate: k,
      validateField: j,
      isSubmitting: H
    }), t({
      values: L,
      errors: F,
      isValid: P,
      isDirty: Z,
      isSubmitting: T,
      submit: R,
      reset: A,
      setFieldValue: c,
      setValues: p,
      validate: _,
      validateField: j,
      formRef: a
    }), (B, y) => (l(), s("form", {
      ref_key: "formRef",
      ref: a,
      class: v(U.value),
      onSubmit: y[0] || (y[0] = o1(
        //@ts-ignore
        (...b) => D(R) && D(R)(...b),
        ["prevent"]
      )),
      onReset: o1(A, ["prevent"])
    }, [
      G(B.$slots, "default", {
        values: L.value,
        errors: F.value,
        isValid: P.value,
        isDirty: Z.value,
        isSubmitting: T.value,
        submit: D(R),
        reset: A,
        setFieldValue: D(c),
        setValues: D(p),
        validate: _,
        validateField: D(j)
      })
    ], 34));
  }
}), N4 = {
  key: 0,
  class: "w-8 h-8 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, G4 = {
  key: 1,
  class: "w-8 h-8 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, U4 = {
  key: 2,
  class: "w-8 h-8 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, W4 = {
  key: 3,
  class: "w-8 h-8 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, Y4 = ["innerHTML"], q4 = ["innerHTML"], K4 = { class: "flex justify-center gap-3" }, jw = /* @__PURE__ */ I({
  __name: "EcxInfoModal",
  props: {
    open: { type: Boolean },
    title: {},
    description: {},
    variant: { default: "success" },
    size: { default: "md" },
    buttonText: { default: "Fechar" },
    buttonVariant: { default: "primary" },
    contentBoxed: { type: Boolean, default: !1 },
    contentPreserveWhitespace: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:open"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = () => {
      n("update:open", !1), n("close");
    }, a = f(() => ({
      sm: "max-w-md py-10 px-8",
      md: "max-w-xl py-12 px-10",
      lg: "max-w-3xl py-16 px-16"
    })[r.size]), d = f(() => ({
      success: "bg-primary border-2 border-primary",
      error: "bg-error border-2 border-error",
      warning: "bg-warning border-2 border-warning",
      info: "bg-primary border-2 border-primary"
    })[r.variant]);
    return (u, h) => (l(), W(g1, { to: "body" }, [
      J(p1, {
        "enter-active-class": "transition duration-300 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-200 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: Y(() => [
          e.open ? (l(), s("div", {
            key: 0,
            class: "fixed inset-0 z-[10000] flex justify-center items-center bg-black/25",
            onClick: o1(i, ["self"])
          }, [
            J(p1, {
              "enter-active-class": "transition duration-300 ease-out",
              "enter-from-class": "opacity-0 scale-95 translate-y-4",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-200 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 translate-y-4"
            }, {
              default: Y(() => [
                e.open ? (l(), s("div", {
                  key: 0,
                  class: v(["bg-white rounded-xl shadow-xl text-center flex flex-col", a.value])
                }, [
                  o("div", {
                    class: v([
                      "mx-auto w-16 h-16 rounded-full flex items-center justify-center shadow-lg mb-6",
                      d.value
                    ])
                  }, [
                    e.variant === "success" ? (l(), s("svg", N4, [...h[0] || (h[0] = [
                      o("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      }, null, -1)
                    ])])) : e.variant === "error" ? (l(), s("svg", G4, [...h[1] || (h[1] = [
                      o("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      }, null, -1)
                    ])])) : e.variant === "warning" ? (l(), s("svg", U4, [...h[2] || (h[2] = [
                      o("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      }, null, -1)
                    ])])) : (l(), s("svg", W4, [...h[3] || (h[3] = [
                      o("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      }, null, -1)
                    ])]))
                  ], 2),
                  o("h1", {
                    class: "text-2xl md:text-3xl font-semibold text-default-black mb-4",
                    innerHTML: e.title
                  }, null, 8, Y4),
                  e.description || u.$slots.default ? (l(), s("div", {
                    key: 0,
                    class: v([
                      "text-base mb-8",
                      e.contentBoxed ? "text-left outline outline-1 outline-grey-200 rounded-lg p-6 overflow-y-auto max-h-64" : "text-grey-600",
                      e.contentPreserveWhitespace && "whitespace-pre-wrap"
                    ])
                  }, [
                    G(u.$slots, "default", {}, () => [
                      o("p", { innerHTML: e.description }, null, 8, q4)
                    ])
                  ], 2)) : x("", !0),
                  o("div", K4, [
                    G(u.$slots, "actions", {}, () => [
                      J(V1, {
                        variant: e.buttonVariant,
                        class: "min-w-[150px]",
                        onClick: i
                      }, {
                        default: Y(() => [
                          h1(M(e.buttonText), 1)
                        ]),
                        _: 1
                      }, 8, ["variant"])
                    ])
                  ])
                ], 2)) : x("", !0)
              ]),
              _: 3
            })
          ])) : x("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), mt = /* @__PURE__ */ I({
  __name: "EcxSpinner",
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    containerClass: {}
  },
  setup(e) {
    const t = e, r = f(() => ({
      xs: "h-4 w-4 border-2",
      sm: "h-6 w-6 border-2",
      md: "h-8 w-8 border-2",
      lg: "h-12 w-12 border-3",
      xl: "h-16 w-16 border-4"
    })[t.size]), n = f(() => ({
      primary: "border-primary border-t-transparent",
      secondary: "border-grey-300 border-t-transparent",
      white: "border-white border-t-transparent",
      dark: "border-grey-800 border-t-transparent"
    })[t.variant]);
    return (i, a) => (l(), s("div", {
      class: v(["ecx-spinner flex justify-center items-center", e.containerClass])
    }, [
      o("div", {
        class: v([
          "animate-spin rounded-full border-solid",
          r.value,
          n.value
        ])
      }, null, 2)
    ], 2));
  }
}), Q4 = {
  key: 0,
  class: "fixed inset-0 z-[10000] flex justify-center items-center bg-black/25"
}, X4 = { class: "mb-6" }, J4 = { class: "text-2xl md:text-3xl font-semibold text-default-black mb-2" }, eo = {
  key: 0,
  class: "text-base text-grey-600"
}, to = { class: "mb-6" }, oo = {
  key: 0,
  class: "w-full max-w-xs mb-4"
}, no = { class: "w-full bg-grey-200 rounded-full h-2 overflow-hidden" }, ro = { class: "text-sm text-grey-600 mt-2" }, lo = {
  key: 1,
  class: "text-sm text-grey-500"
}, Iw = /* @__PURE__ */ I({
  __name: "EcxLoadingModal",
  props: {
    open: { type: Boolean },
    title: {},
    subtitle: {},
    footerText: {},
    size: { default: "md" },
    progress: {},
    spinnerSize: { default: "xl" },
    spinnerVariant: { default: "primary" }
  },
  setup(e) {
    const t = e, r = f(() => ({
      sm: "max-w-sm py-10 px-8",
      md: "max-w-xl py-12 px-10",
      lg: "max-w-2xl py-16 px-14"
    })[t.size]);
    return (n, i) => (l(), W(g1, { to: "body" }, [
      J(p1, {
        "enter-active-class": "transition duration-300 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-200 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: Y(() => [
          e.open ? (l(), s("div", Q4, [
            J(p1, {
              "enter-active-class": "transition duration-300 ease-out",
              "enter-from-class": "opacity-0 scale-95 translate-y-4",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-200 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 translate-y-4"
            }, {
              default: Y(() => [
                e.open ? (l(), s("div", {
                  key: 0,
                  class: v(["bg-white rounded-xl shadow-xl text-center flex flex-col items-center", r.value])
                }, [
                  o("div", X4, [
                    o("h1", J4, M(e.title), 1),
                    e.subtitle ? (l(), s("p", eo, M(e.subtitle), 1)) : x("", !0)
                  ]),
                  o("div", to, [
                    J(mt, {
                      size: e.spinnerSize,
                      variant: e.spinnerVariant
                    }, null, 8, ["size", "variant"])
                  ]),
                  e.progress !== void 0 ? (l(), s("div", oo, [
                    o("div", no, [
                      o("div", {
                        class: "h-full bg-primary rounded-full transition-all duration-300",
                        style: a1({ width: `${e.progress}%` })
                      }, null, 4)
                    ]),
                    o("p", ro, M(e.progress) + "%", 1)
                  ])) : x("", !0),
                  e.footerText ? (l(), s("p", lo, M(e.footerText), 1)) : x("", !0),
                  G(n.$slots, "default")
                ], 2)) : x("", !0)
              ]),
              _: 3
            })
          ])) : x("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), so = ["innerHTML"], fe = /* @__PURE__ */ I({
  __name: "EcxTooltip",
  props: {
    content: {},
    placement: { default: "top" },
    variant: { default: "dark" },
    arrow: { type: Boolean, default: !0 },
    delay: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    html: { type: Boolean, default: !1 },
    maxWidth: { default: void 0 },
    align: { default: "center" }
  },
  setup(e) {
    const t = e, r = E(null), n = E(null), i = E(!1), a = E({ top: 0, left: 0 });
    let d = null;
    const u = f(() => `ecx-tooltip--${t.variant}`), h = f(() => `ecx-tooltip-arrow--${t.placement} ecx-tooltip-arrow--${t.variant}`), C = f(() => {
      const k = {
        position: "fixed",
        top: `${a.value.top}px`,
        left: `${a.value.left}px`,
        zIndex: 9999
      };
      return t.maxWidth && (k.maxWidth = t.maxWidth), k;
    }), m = async () => {
      if (await s1(), !r.value || !n.value) return;
      const k = r.value.getBoundingClientRect(), j = n.value.getBoundingClientRect(), H = 8;
      let L = 0, F = 0;
      const P = () => {
        switch (t.align) {
          case "start":
            return k.left;
          case "end":
            return k.right - j.width;
          default:
            return k.left + (k.width - j.width) / 2;
        }
      }, Z = () => {
        switch (t.align) {
          case "start":
            return k.top;
          case "end":
            return k.bottom - j.height;
          default:
            return k.top + (k.height - j.height) / 2;
        }
      };
      switch (t.placement) {
        case "top":
          L = k.top - j.height - H, F = P();
          break;
        case "bottom":
          L = k.bottom + H, F = P();
          break;
        case "left":
          L = Z(), F = k.left - j.width - H;
          break;
        case "right":
          L = Z(), F = k.right + H;
          break;
      }
      const T = 8;
      F = Math.max(T, Math.min(F, window.innerWidth - j.width - T)), L = Math.max(T, Math.min(L, window.innerHeight - j.height - T)), a.value = { top: L, left: F };
    }, c = () => {
      t.disabled || (t.delay > 0 ? d = setTimeout(() => {
        i.value = !0, m();
      }, t.delay) : (i.value = !0, m()));
    }, p = () => {
      d && (clearTimeout(d), d = null), i.value = !1;
    };
    return m1(() => {
      window.addEventListener("scroll", m, !0), window.addEventListener("resize", m);
    }), y1(() => {
      window.removeEventListener("scroll", m, !0), window.removeEventListener("resize", m), d && clearTimeout(d);
    }), (k, j) => (l(), s("div", {
      ref_key: "triggerRef",
      ref: r,
      class: "ecx-tooltip-trigger inline-flex",
      onMouseenter: c,
      onMouseleave: p,
      onFocusin: c,
      onFocusout: p
    }, [
      G(k.$slots, "default"),
      (l(), W(g1, { to: "body" }, [
        J(p1, { name: "tooltip" }, {
          default: Y(() => [
            i.value && (e.content || k.$slots.content) ? (l(), s("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: n,
              class: v(["ecx-tooltip", u.value]),
              style: a1(C.value),
              role: "tooltip"
            }, [
              G(k.$slots, "content", {}, () => [
                e.html ? (l(), s("span", {
                  key: 0,
                  innerHTML: e.content
                }, null, 8, so)) : (l(), s(n1, { key: 1 }, [
                  h1(M(e.content), 1)
                ], 64))
              ]),
              e.arrow ? (l(), s("div", {
                key: 0,
                class: v(["ecx-tooltip-arrow", h.value])
              }, null, 2)) : x("", !0)
            ], 6)) : x("", !0)
          ]),
          _: 3
        })
      ]))
    ], 544));
  }
}), io = ["aria-checked", "aria-label", "aria-disabled", "disabled"], ao = ["aria-label"], Zw = /* @__PURE__ */ I({
  __name: "EcxToggle",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    ariaLabel: {},
    label: {},
    infoLabel: {},
    labelPosition: {},
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    function i() {
      r.disabled || n("update:modelValue", !r.modelValue);
    }
    const a = f(() => ({
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-3.5",
      xl: "gap-4"
    })[r.size]), d = f(() => ({
      sm: "text-xs leading-label-xs tracking-label-xs",
      md: "text-sm tracking-body-sm",
      lg: "text-base tracking-body-sm",
      xl: "text-lg leading-6"
    })[r.size]), u = f(() => ({
      sm: "w-3.5 h-3.5",
      md: "w-4 h-4",
      lg: "w-5 h-5",
      xl: "w-6 h-6"
    })[r.size]);
    return (h, C) => (l(), s("div", {
      class: v([
        "flex min-w-0 items-center",
        a.value,
        e.labelPosition === "left" ? "w-full" : ""
      ])
    }, [
      o("button", {
        type: "button",
        role: "switch",
        "aria-checked": e.modelValue ? "true" : "false",
        "aria-label": e.ariaLabel,
        "aria-disabled": e.disabled ? "true" : void 0,
        disabled: e.disabled,
        class: v([
          "relative inline-flex w-10 h-6 shrink-0 rounded-full border border-grey-100 transition-colors duration-200 ease-out",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-royal-300",
          e.modelValue ? "bg-[#1dc37b]" : "bg-grey-200",
          e.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
          e.labelPosition === "left" ? "order-3" : ""
        ]),
        onClick: i
      }, [
        o("span", {
          class: v([
            "absolute top-1/2 -translate-y-1/2 w-[18px] h-[18px] rounded-full bg-white shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)] transition-[left] duration-200 ease-out",
            e.modelValue ? "left-[calc(100%-20px)]" : "left-[2px]"
          ]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, io),
      e.label ? (l(), s("span", {
        key: 0,
        class: v([
          "min-w-0 font-be-vietnam font-normal text-grey-950",
          d.value,
          e.labelPosition === "left" ? "order-1 flex-1" : ""
        ])
      }, M(e.label), 3)) : x("", !0),
      h.$slots.info && e.infoLabel ? (l(), W(fe, {
        key: 1,
        content: e.infoLabel,
        placement: "top",
        delay: 200,
        class: v(e.labelPosition === "left" ? "order-2" : "")
      }, {
        default: Y(() => [
          o("span", {
            class: v(["flex shrink-0 items-center justify-center text-grey-500 cursor-help", u.value]),
            "aria-label": e.infoLabel,
            role: "img"
          }, [
            G(h.$slots, "info")
          ], 10, ao)
        ]),
        _: 3
      }, 8, ["content", "class"])) : h.$slots.info ? (l(), s("span", {
        key: 2,
        class: v([
          "flex shrink-0 items-center justify-center text-grey-500",
          u.value,
          e.labelPosition === "left" ? "order-2" : ""
        ]),
        "aria-hidden": "true"
      }, [
        G(h.$slots, "info")
      ], 2)) : x("", !0)
    ], 2));
  }
}), uo = ["id", "aria-selected", "onClick"], co = "#585B79", Ew = /* @__PURE__ */ I({
  __name: "EcxSegmentedControl",
  props: {
    modelValue: {},
    tabs: {},
    iconClass: { default: "w-5 h-5" },
    inactiveTabIconColor: {},
    tabIdPrefix: { default: "ecx-segmented-tab" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(null), a = E([]);
    function d(c, p) {
      const k = [...a.value], j = p ?? null;
      k[c] !== j && (k[c] = j, a.value = k);
    }
    function u(c) {
      return r.modelValue === c ? "#FFF" : r.inactiveTabIconColor ?? co;
    }
    const h = f(() => {
      const c = r.tabs.findIndex((p) => p.id === r.modelValue);
      return c >= 0 ? c : 0;
    });
    function C(c, p) {
      const k = c.getBoundingClientRect(), j = p.getBoundingClientRect();
      return {
        leftPx: j.left - k.left,
        widthPx: j.width
      };
    }
    const m = f(() => {
      const c = i.value, p = a.value[h.value];
      if (!c || !p)
        return { left: "0px", width: "0px" };
      const { leftPx: k, widthPx: j } = C(c, p);
      return {
        left: `${k}px`,
        width: `${j}px`
      };
    });
    return (c, p) => (l(), s("div", {
      ref_key: "containerRef",
      ref: i,
      role: "tablist",
      class: "relative inline-flex shrink-0 items-center gap-1 border border-grey-100 bg-grey-50 p-ecx-segmented-p rounded-ecx-segmented"
    }, [
      o("div", {
        class: "pointer-events-none absolute rounded-lg bg-royal-400 shadow-ecx-segmented-active transition-all duration-300 ease-out top-ecx-segmented-p bottom-ecx-segmented-p",
        style: a1(m.value),
        "aria-hidden": "true"
      }, null, 4),
      (l(!0), s(n1, null, u1(e.tabs, (k, j) => (l(), s("button", {
        id: `${e.tabIdPrefix}-${k.id}`,
        key: k.id,
        ref_for: !0,
        ref: (H) => d(j, H),
        type: "button",
        role: "tab",
        "aria-selected": e.modelValue === k.id ? "true" : "false",
        class: v([
          "relative z-10 flex items-center justify-center gap-1.5 rounded-lg px-2 py-1.5 font-be-vietnam text-sm font-normal leading-normal tracking-status-badge transition-colors duration-300 ease-out",
          e.modelValue === k.id ? "text-white" : "text-grey-700 hover:bg-grey-100/80"
        ]),
        onClick: (H) => n("update:modelValue", k.id)
      }, [
        (l(), W(f1(k.icon), {
          active: e.modelValue === k.id,
          color: u(k.id),
          class: v([e.iconClass, "shrink-0"])
        }, null, 8, ["active", "color", "class"])),
        o("span", null, M(k.label), 1)
      ], 10, uo))), 128))
    ], 512));
  }
}), ho = ["onClick"], po = { key: 0 }, Sw = /* @__PURE__ */ I({
  __name: "EcxToggleSwitch",
  props: {
    modelValue: {},
    options: {},
    containerClass: {},
    optionClass: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = t;
    return (n, i) => (l(), s("div", {
      class: v(["inline-flex gap-1 p-1.5 bg-[#F6F6F9] border border-[#ECEEF3] rounded-[10px]", e.containerClass])
    }, [
      (l(!0), s(n1, null, u1(e.options, (a) => (l(), s("button", {
        key: a.value,
        type: "button",
        class: v(["flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-normal transition-all", [
          e.modelValue === a.value ? "bg-[#3342FF] text-white shadow-[0px_1px_3px_0px_rgba(172,178,255,0.91)]" : "bg-transparent text-[#585B79] hover:bg-gray-100",
          e.optionClass
        ]]),
        onClick: (d) => r("update:modelValue", a.value)
      }, [
        G(n.$slots, `icon-${a.value}`, {
          selected: e.modelValue === a.value
        }, () => [
          a.icon ? (l(), W(f1(a.icon), {
            key: 0,
            class: v(["w-5 h-5", e.modelValue === a.value ? "text-white" : "text-[#767BA2]"])
          }, null, 8, ["class"])) : x("", !0)
        ]),
        a.label ? (l(), s("span", po, M(a.label), 1)) : x("", !0)
      ], 10, ho))), 128))
    ], 2));
  }
}), fo = {}, Co = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  "aria-hidden": "true"
};
function go(e, t) {
  return l(), s("svg", Co, [...t[0] || (t[0] = [
    o("path", {
      d: "M3.96797 12.8317L1.72797 11.2317L4.63997 7.35969L-2.92063e-05 5.91969L0.831971 3.26369L5.43997 4.83169L5.34397 -0.000312805H8.12797L8.06397 4.83169L12.672 3.26369L13.504 5.91969L8.89597 7.35969L11.808 11.2317L9.53597 12.8317L6.75197 8.92769L3.96797 12.8317Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const vo = /* @__PURE__ */ g(fo, [["render", go]]), mo = { class: "flex flex-col gap-2" }, xo = {
  key: 0,
  class: "pointer-events-none absolute inset-0 z-0 flex items-center justify-center",
  "aria-hidden": "true"
}, wo = ["value", "disabled", "onBeforeinput", "onInput", "onKeydown", "onFocus"], ko = ["value", "disabled", "onBeforeinput", "onInput", "onKeydown", "onFocus"], yo = {
  key: 0,
  class: "text-xs text-error text-center"
}, zw = /* @__PURE__ */ I({
  __name: "EcxPinInput",
  props: {
    modelValue: {},
    length: { default: 6 },
    error: { default: "" },
    size: { default: "md" },
    masked: { type: Boolean, default: !1 },
    maskCharacter: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    gap: { default: 8 },
    containerClass: { default: "" },
    inputClass: { default: "" }
  },
  emits: ["update:modelValue", "complete"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E([]);
    r1(
      () => n.length,
      ($) => {
        const B = a.value;
        a.value = Array.from({ length: $ }, (y, b) => B[b]);
      },
      { immediate: !0 }
    );
    function d($, B) {
      if ($ instanceof HTMLInputElement) {
        a.value[B] = $;
        return;
      }
      $ === null && (a.value[B] = void 0);
    }
    const u = E(Array(n.length).fill("")), h = f(() => ({
      sm: "w-10 h-12 text-lg font-semibold",
      md: "w-12 h-14 text-xl font-semibold",
      lg: "w-14 h-16 text-2xl font-semibold"
    })[n.size]), C = f(() => ({
      sm: "w-10 h-10",
      md: "w-12 h-12",
      lg: "w-14 h-14"
    })[n.size]), m = f(() => ({
      sm: "h-4 w-4 shrink-0",
      md: "h-5 w-5 shrink-0",
      lg: "h-6 w-6 shrink-0"
    })[n.size]), c = f(
      () => Array.from({ length: n.length }, ($, B) => B)
    );
    function p($) {
      const B = u.value[$];
      return B ? n.masked ? n.maskCharacter : B : "";
    }
    function k($) {
      return n.disabled ? "border-grey-200 bg-grey-100 text-grey-400 cursor-not-allowed" : n.error ? "border-error bg-red-50/50 text-error" : u.value[$] ? "border-royal-500 bg-royal-50/50 text-grey-950" : "border-grey-200 bg-white text-grey-950 hover:border-grey-400 focus:border-royal-500 focus:ring-2 focus:ring-royal-500/10";
    }
    function j($) {
      return n.disabled ? "border-grey-200 bg-grey-100" : n.error ? "border-error bg-red-50/50" : u.value[$] ? "border-royal-500 bg-royal-500" : "border-grey-200 bg-white hover:border-grey-400";
    }
    function H($) {
      return n.disabled ? "cursor-not-allowed caret-grey-400" : n.error ? "caret-error focus:ring-2 focus:ring-error/20" : u.value[$] ? "caret-white focus:ring-2 focus:ring-white/30" : "caret-royal-500 focus:ring-2 focus:ring-royal-500/10";
    }
    function L($) {
      return u.value[$] ? n.disabled ? "text-grey-400" : n.error ? "text-error" : "text-white" : "";
    }
    r1(
      [() => n.modelValue, () => n.length],
      ([$]) => {
        const B = String($).split("");
        u.value = Array(n.length).fill("").map((y, b) => B[b] || "");
      },
      { immediate: !0 }
    ), r1(u, ($) => {
      const B = $.join("");
      i("update:modelValue", B), B.length === n.length && !B.includes("") && i("complete", B);
    }, { deep: !0 });
    function F($) {
      var b;
      if (n.masked) {
        const S = ((b = $.data) == null ? void 0 : b.replace(/\D/g, "")) ?? "";
        if (S !== "")
          return S.slice(-1);
        const X = $.target.value.replace(/\D/g, "");
        return X !== "" ? X.slice(-1) : "";
      }
      const y = $.target.value.replace(/\D/g, "");
      return y !== "" ? y[0] : "";
    }
    function P($) {
      const B = a.value[$];
      if (B === void 0)
        return;
      const y = p($);
      B.value !== y && (B.value = y);
    }
    function Z($, B) {
      if (n.disabled || $.inputType === "insertFromPaste" || !["insertText", "insertCompositionText", "insertReplacementText"].includes($.inputType))
        return;
      const y = $.data;
      if (y == null || y === "") return;
      [...y].every((V) => V >= "0" && V <= "9") || $.preventDefault();
    }
    const T = ($, B) => {
      if (n.disabled) return;
      const y = F($);
      if (y !== "") {
        u.value[B] = y, B < n.length - 1 && s1(() => {
          var b;
          (b = a.value[B + 1]) == null || b.focus();
        });
        return;
      }
      s1(() => {
        P(B);
      });
    };
    function R($) {
      return $.altKey ? !1 : $.ctrlKey || $.metaKey ? ["v", "V", "c", "C", "x", "X", "a", "A"].includes($.key) : $.key.length === 1 && /[0-9]/.test($.key) ? !0 : ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"].includes($.key);
    }
    const A = ($, B) => {
      var y, b;
      if (!n.disabled) {
        if (!R($)) {
          $.preventDefault();
          return;
        }
        $.key === "Backspace" ? !u.value[B] && B > 0 ? (u.value[B - 1] = "", s1(() => {
          var V;
          (V = a.value[B - 1]) == null || V.focus();
        })) : u.value[B] = "" : $.key === "ArrowLeft" && B > 0 ? (y = a.value[B - 1]) == null || y.focus() : $.key === "ArrowRight" && B < n.length - 1 && ((b = a.value[B + 1]) == null || b.focus());
      }
    }, _ = ($) => {
      var V;
      if (n.disabled) return;
      $.preventDefault();
      const y = (((V = $.clipboardData) == null ? void 0 : V.getData("text").replace(/\D/g, "")) || "").slice(0, n.length).split("");
      u.value = Array(n.length).fill("").map((S, z) => y[z] || "");
      const b = Math.min(y.length, n.length) - 1;
      s1(() => {
        var S;
        (S = a.value[Math.max(0, b)]) == null || S.focus();
      });
    }, w = ($) => {
      var B;
      (B = a.value[$]) == null || B.select();
    };
    return t({
      focus: () => {
        var $;
        return ($ = a.value[0]) == null ? void 0 : $.focus();
      },
      clear: () => {
        u.value = Array(n.length).fill(""), s1(() => {
          var $;
          return ($ = a.value[0]) == null ? void 0 : $.focus();
        });
      }
    }), ($, B) => (l(), s("div", mo, [
      o("div", {
        class: v(["flex items-center justify-center", e.containerClass]),
        style: a1({ gap: `${e.gap}px` })
      }, [
        (l(!0), s(n1, null, u1(c.value, (y) => (l(), s(n1, { key: y }, [
          e.masked ? (l(), s("div", {
            key: 0,
            class: v([
              "relative shrink-0 rounded-xl border transition-all duration-200",
              C.value,
              j(y)
            ])
          }, [
            u.value[y] ? (l(), s("div", xo, [
              J(vo, {
                class: v([m.value, L(y)])
              }, null, 8, ["class"])
            ])) : x("", !0),
            o("input", {
              ref_for: !0,
              ref: (b) => d(b, y),
              type: "tel",
              inputmode: "numeric",
              pattern: "[0-9]*",
              maxlength: "1",
              autocomplete: "one-time-code",
              value: p(y),
              disabled: e.disabled,
              class: v([
                "absolute inset-0 z-10 box-border h-full w-full appearance-none rounded-xl border-0 bg-transparent text-center text-transparent outline-none transition-all duration-200",
                H(y),
                e.inputClass
              ]),
              onBeforeinput: (b) => Z(b),
              onInput: (b) => T(b, y),
              onKeydown: (b) => A(b, y),
              onPaste: _,
              onFocus: (b) => w(y)
            }, null, 42, wo)
          ], 2)) : (l(), s("input", {
            key: 1,
            ref_for: !0,
            ref: (b) => d(b, y),
            type: "tel",
            inputmode: "numeric",
            pattern: "[0-9]*",
            maxlength: "1",
            autocomplete: "one-time-code",
            value: p(y),
            disabled: e.disabled,
            class: v([
              "box-border appearance-none text-center rounded-xl border transition-all duration-200 outline-none",
              h.value,
              e.inputClass,
              k(y)
            ]),
            onBeforeinput: (b) => Z(b),
            onInput: (b) => T(b, y),
            onKeydown: (b) => A(b, y),
            onPaste: _,
            onFocus: (b) => w(y)
          }, null, 42, ko))
        ], 64))), 128))
      ], 6),
      J(p1, {
        "enter-active-class": "transition-all duration-200",
        "leave-active-class": "transition-all duration-150",
        "enter-from-class": "opacity-0 -translate-y-1",
        "leave-to-class": "opacity-0 -translate-y-1"
      }, {
        default: Y(() => [
          e.error ? (l(), s("span", yo, M(e.error), 1)) : x("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), Dw = /* @__PURE__ */ I({
  __name: "EcxPageContainer",
  props: {
    paddingTop: { type: Boolean, default: !0 },
    paddingBottom: { default: "default" },
    gap: { default: "default" },
    flex: { type: Boolean, default: !1 },
    justify: { default: "start" },
    grid: { type: Boolean, default: !1 },
    maxWidth: { default: "default" }
  },
  setup(e) {
    const t = e, r = f(() => {
      const n = ["mx-auto", "px-14"];
      return t.maxWidth === "narrow" ? n.push("max-w-5xl") : t.maxWidth === "wide" ? n.push("max-w-7xl") : t.maxWidth === "super-wide" ? n.push("max-w-screen-2xl") : n.push("max-w-7xl"), t.paddingTop && n.push("pt-6"), t.paddingBottom === "default" ? n.push("pb-14") : t.paddingBottom === "large" ? n.push("pb-28") : t.paddingBottom === "small" && n.push("pb-4"), t.flex ? (n.push("flex", "flex-col"), t.gap === "default" ? n.push("gap-y-14") : t.gap === "large" ? n.push("gap-y-10") : t.gap === "small" && n.push("gap-y-3"), t.justify === "between" ? n.push("justify-between") : t.justify === "start" ? n.push("justify-start") : t.justify === "end" ? n.push("justify-end") : t.justify === "center" && n.push("justify-center")) : (t.grid && n.push("grid"), t.gap === "default" ? n.push("gap-y-8") : t.gap === "large" ? n.push("gap-y-14") : t.gap === "small" && n.push("gap-y-3")), n.join(" ");
    });
    return (n, i) => (l(), s("div", {
      class: v(r.value)
    }, [
      G(n.$slots, "default")
    ], 2));
  }
}), bo = {}, _o = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.997",
  height: "7.639",
  viewBox: "0 0 15.997 7.639"
};
function Mo(e, t) {
  return l(), s("svg", _o, [...t[0] || (t[0] = [
    o("path", {
      id: "Caminho_707",
      "data-name": "Caminho 707",
      d: "M-1830.641-14658.525h0l1.2-1.2-1.777-1.783h12.76v-1.67h-12.76l1.777-1.783-1.2-1.2-3.816,3.816,3.815,3.822Z",
      transform: "translate(1834.457 14666.164)",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Lo = /* @__PURE__ */ g(bo, [["render", Mo]]), $o = ["innerHTML"], Vo = {
  key: 1,
  class: "ml-auto"
}, Tw = /* @__PURE__ */ I({
  __name: "EcxPageHeader",
  props: {
    title: {},
    subtitle: {},
    backRoute: {},
    titleAlign: { default: "left" },
    showBackButton: { type: Boolean, default: !0 }
  },
  emits: ["back"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = Et(), a = () => {
      n("back"), r.backRoute ? i.push(r.backRoute) : i.back();
    };
    return (d, u) => (l(), s("div", {
      class: v(["flex items-center gap-x-3", e.titleAlign === "center" ? "justify-center" : "justify-start"])
    }, [
      e.showBackButton ? (l(), s("button", {
        key: 0,
        onClick: a,
        class: "h-10 w-10 outline outline-1 outline-border-gray rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors flex-shrink-0",
        "aria-label": "Voltar"
      }, [
        J(Lo)
      ])) : x("", !0),
      o("div", {
        class: v(["flex flex-col", e.titleAlign === "center" ? "items-center" : "items-start"])
      }, [
        o("h1", {
          class: v(["text-default-black text-2xl font-semibold font-be-vietnam", e.titleAlign === "center" ? "text-center" : "text-left"])
        }, M(e.title), 3),
        e.subtitle ? (l(), s("h2", {
          key: 0,
          class: v(["text-subtitle-gray text-base pt-2 max-w-3xl font-be-vietnam", e.titleAlign === "center" ? "text-center" : "text-left"]),
          innerHTML: e.subtitle
        }, null, 10, $o)) : x("", !0)
      ], 2),
      d.$slots.actions ? (l(), s("div", Vo, [
        G(d.$slots, "actions")
      ])) : x("", !0)
    ], 2));
  }
}), Bo = { class: "flex justify-between items-center self-stretch pt-5 pb-2.5" }, Ho = { class: "flex flex-col gap-y-1" }, Fo = { class: "font-mont text-xl font-bold leading-5 tracking-title-sm text-royal-950" }, Ao = {
  key: 0,
  class: "text-sm tracking-status-badge text-grey-600"
}, jo = { key: 0 }, Io = {
  key: 1,
  class: "flex items-center gap-2"
}, Ow = /* @__PURE__ */ I({
  __name: "EcxPageTitleHeader",
  props: {
    title: {},
    subtitle: {},
    actionLabel: {},
    actionIcon: {},
    actionButtonVariant: { default: "solid" },
    actionDisabled: { type: Boolean, default: !1 },
    actionTitle: {}
  },
  emits: ["action-click"],
  setup(e, { emit: t }) {
    const r = t;
    return (n, i) => (l(), s("header", Bo, [
      o("div", Ho, [
        o("h1", Fo, M(e.title), 1),
        e.subtitle ? (l(), s("p", Ao, M(e.subtitle), 1)) : x("", !0)
      ]),
      n.$slots.actions || e.actionLabel || n.$slots.actionsStart ? (l(), s("div", jo, [
        n.$slots.actions ? G(n.$slots, "actions", { key: 0 }) : (l(), s("div", Io, [
          G(n.$slots, "actionsStart"),
          e.actionLabel ? (l(), W(V1, {
            key: 0,
            variant: e.actionButtonVariant === "outline" ? "outline" : "primary",
            size: "sm",
            class: "items-center !py-2 !pl-2.5 !pr-3.5",
            disabled: e.actionDisabled,
            title: e.actionTitle,
            onClick: i[0] || (i[0] = (a) => r("action-click"))
          }, ve({
            default: Y(() => [
              h1(" " + M(e.actionLabel), 1)
            ]),
            _: 2
          }, [
            e.actionIcon ? {
              name: "iconLeft",
              fn: Y(() => [
                (l(), W(f1(e.actionIcon), { class: "w-5 h-5" }))
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["variant", "disabled", "title"])) : x("", !0)
        ]))
      ])) : x("", !0)
    ]));
  }
}), Pw = /* @__PURE__ */ I({
  __name: "EcxContentContainer",
  props: {
    paddingTop: { type: Boolean, default: !0 },
    paddingBottom: { default: "default" },
    gap: { default: "default" },
    flex: { type: Boolean, default: !0 },
    justify: { default: "start" },
    maxWidth: { default: "default" }
  },
  setup(e) {
    const t = e, r = f(() => {
      const n = ["px-8"];
      return t.maxWidth === "narrow" ? n.push("max-w-5xl", "mx-auto", "w-full") : t.maxWidth === "wide" ? n.push("max-w-7xl", "mx-auto", "w-full") : n.push("w-full"), t.paddingTop && n.push("pt-6"), t.paddingBottom === "default" ? n.push("pb-4") : t.paddingBottom === "small" && n.push("pb-2"), t.flex ? (n.push("flex", "flex-col"), t.gap === "default" ? n.push("gap-y-3") : t.gap === "small" ? n.push("gap-y-2") : t.gap === "none" && n.push("gap-y-0"), t.justify === "between" ? n.push("justify-between") : t.justify === "start" ? n.push("justify-start") : t.justify === "end" ? n.push("justify-end") : t.justify === "center" && n.push("justify-center")) : t.gap === "default" ? n.push("gap-y-3") : t.gap === "small" && n.push("gap-y-2"), n.join(" ");
    });
    return (n, i) => (l(), s("div", {
      class: v(r.value)
    }, [
      G(n.$slots, "default")
    ], 2));
  }
}), Zo = ["role", "aria-modal", "tabindex"], Eo = {
  key: 0,
  class: "ecx-drawer-header flex-shrink-0"
}, So = { class: "flex items-center justify-between self-stretch py-7 px-6" }, zo = { class: "flex items-center gap-3 flex-1" }, Do = {
  key: 0,
  class: "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 border-2 border-white shadow-[0_0_0_1px_#C7CBFF] bg-royal-25"
}, To = { class: "flex-1 min-w-0" }, Oo = { class: "text-xl font-mont text-royal-950" }, Po = {
  key: 0,
  class: "text-base text-form-description mt-1"
}, Ro = { class: "ecx-drawer-content flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-visible ecx-drawer-scroll" }, No = {
  key: 1,
  class: "ecx-drawer-footer flex-shrink-0 border-t border-grey-100 border-solid bg-white px-6 py-4"
}, Go = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', Uo = /* @__PURE__ */ I({
  __name: "EcxDrawer",
  props: {
    open: { type: Boolean },
    title: {},
    subtitle: {},
    icon: {},
    side: { default: "right" },
    size: { default: "lg" },
    showHeader: { type: Boolean, default: !0 },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEsc: { type: Boolean, default: !0 },
    lockBodyScroll: { type: Boolean, default: !0 },
    rounded: { type: Boolean, default: !0 },
    withMargin: { type: Boolean, default: !0 },
    contentPadding: { default: "lg" },
    trapFocus: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:open"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(!1);
    r1(() => r.open, (w) => {
      i.value = w;
    }, { immediate: !0 });
    const a = f(() => "transition-transform duration-300 ease-out"), d = f(() => "transition-transform duration-300 ease-in"), u = f(
      () => r.side === "right" ? "translate-x-full" : "-translate-x-full"
    ), h = f(() => "translate-x-0"), C = f(() => "translate-x-0"), m = f(
      () => r.side === "right" ? "translate-x-full" : "-translate-x-full"
    ), c = f(() => {
      const w = r.withMargin ? "m-4" : "";
      return r.side === "right" ? `right-0 ${w}` : `left-0 ${w}`;
    }), p = f(() => {
      const w = r.withMargin ? "h-[calc(100vh-32px)]" : "h-screen";
      return {
        sm: `w-full max-w-sm ${w}`,
        md: `w-full max-w-md ${w}`,
        "md-fixed": `w-full max-w-[600px] ${w}`,
        cashback: `w-full max-w-[500px] ${w}`,
        lg: `w-full max-w-[750px] ${w}`,
        xl: `w-full max-w-[900px] ${w}`,
        full: `w-full ${w}`
      }[r.size];
    }), k = f(
      () => r.rounded ? "rounded-2xl" : ""
    ), j = f(() => ({
      none: "",
      sm: "px-4 py-4 pb-16",
      md: "px-6 py-6 pb-20",
      lg: "px-6 py-6 pb-20"
    })[r.contentPadding]), H = () => {
      n("close"), n("update:open", !1);
    }, L = () => {
      r.closeOnBackdrop && H();
    }, F = (w) => {
      w.key === "Escape" && i.value && r.closeOnEsc && H();
    };
    r1(() => i.value, (w) => {
      r.lockBodyScroll && (w ? document.body.style.overflow = "hidden" : document.body.style.overflow = ""), r.closeOnEsc && (w ? document.addEventListener("keydown", F) : document.removeEventListener("keydown", F));
    }), y1(() => {
      document.body.style.overflow = "", document.removeEventListener("keydown", F), A();
    });
    const P = E(null);
    let Z = null;
    function T() {
      return P.value ? Array.from(P.value.querySelectorAll(Go)) : [];
    }
    async function R() {
      var O;
      await s1(), await s1();
      const [w] = T();
      (O = w ?? P.value) == null || O.focus();
    }
    function A() {
      Z == null || Z.focus(), Z = null;
    }
    const _ = (w) => {
      if (!r.trapFocus || w.key !== "Tab") return;
      const O = T();
      if (O.length === 0) return;
      const U = O[0], $ = O[O.length - 1];
      w.shiftKey && document.activeElement === U ? (w.preventDefault(), $.focus()) : !w.shiftKey && document.activeElement === $ && (w.preventDefault(), U.focus());
    };
    return r1(() => i.value, (w) => {
      r.trapFocus && (w ? (Z = document.activeElement, R()) : A());
    }), (w, O) => (l(), W(g1, { to: "body" }, [
      J(p1, {
        "enter-active-class": "transition-opacity duration-300 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition-opacity duration-300 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: Y(() => [
          i.value ? (l(), s("div", {
            key: 0,
            class: "ecx-drawer-backdrop fixed inset-0 bg-black bg-opacity-25 z-[9998]",
            onClick: L
          })) : x("", !0)
        ]),
        _: 1
      }),
      J(p1, {
        "enter-active-class": a.value,
        "enter-from-class": u.value,
        "enter-to-class": h.value,
        "leave-active-class": d.value,
        "leave-from-class": C.value,
        "leave-to-class": m.value
      }, {
        default: Y(() => [
          i.value ? (l(), s("aside", {
            key: 0,
            ref_key: "drawerRef",
            ref: P,
            role: e.trapFocus ? "dialog" : void 0,
            "aria-modal": e.trapFocus ? "true" : void 0,
            tabindex: e.trapFocus ? "-1" : void 0,
            class: v([
              "ecx-drawer fixed top-0 bg-white z-[9999] flex flex-col overflow-hidden",
              c.value,
              p.value,
              k.value
            ]),
            onClick: O[0] || (O[0] = o1(() => {
            }, ["stop"])),
            onKeydown: _
          }, [
            e.showHeader ? (l(), s("div", Eo, [
              o("div", So, [
                o("div", zo, [
                  w.$slots.icon || e.icon ? (l(), s("div", Do, [
                    G(w.$slots, "icon", {}, () => [
                      e.icon ? (l(), W(f1(e.icon), {
                        key: 0,
                        class: "w-6 h-6"
                      })) : x("", !0)
                    ], !0)
                  ])) : x("", !0),
                  o("div", To, [
                    o("h2", Oo, M(e.title), 1),
                    e.subtitle ? (l(), s("p", Po, M(e.subtitle), 1)) : x("", !0)
                  ])
                ]),
                e.showCloseButton ? (l(), s("button", {
                  key: 0,
                  class: "w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0",
                  onClick: H,
                  "aria-label": "Fechar"
                }, [...O[1] || (O[1] = [
                  o("svg", {
                    class: "w-5 h-5 text-form-label",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])])) : x("", !0)
              ]),
              O[2] || (O[2] = o("div", { class: "border-b border-solid border-grey-200" }, null, -1))
            ])) : x("", !0),
            o("div", Ro, [
              o("div", {
                class: v(["flex min-h-0 w-full min-w-0 flex-1 flex-col", j.value])
              }, [
                G(w.$slots, "default", {}, void 0, !0)
              ], 2)
            ]),
            w.$slots.footer ? (l(), s("div", No, [
              G(w.$slots, "footer", {}, void 0, !0)
            ])) : x("", !0)
          ], 42, Zo)) : x("", !0)
        ]),
        _: 3
      }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class"])
    ]));
  }
}), Rw = /* @__PURE__ */ g(Uo, [["__scopeId", "data-v-2dd838de"]]), Wo = {}, Yo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10"
};
function qo(e, t) {
  return l(), s("svg", Yo, [...t[0] || (t[0] = [
    o("g", {
      id: "Grupo_2813",
      "data-name": "Grupo 2813",
      transform: "translate(21383 16505)"
    }, [
      o("path", {
        id: "ic_name",
        d: "M2.846-3312A3.846,3.846,0,0,1-1-3315.846v-2.307A3.846,3.846,0,0,1,2.846-3322H5.154A3.846,3.846,0,0,1,9-3318.153v2.307A3.846,3.846,0,0,1,5.154-3312Zm-3.077-6.153v2.307a3.081,3.081,0,0,0,3.077,3.077H5.154a3.081,3.081,0,0,0,3.077-3.077v-2.307a3.081,3.081,0,0,0-3.077-3.077H2.846A3.081,3.081,0,0,0-.231-3318.153Z",
        transform: "translate(-21382 -13183)",
        fill: "#020203"
      }),
      o("path", {
        id: "Caminho_884",
        "data-name": "Caminho 884",
        d: "M188.1,214.363a.342.342,0,0,0-.243.1l-1.623,1.623a.115.115,0,0,1-.162,0l-.487-.487a.344.344,0,0,0-.487.487l1.055,1.055,2.191-2.191a.344.344,0,0,0-.244-.588Z",
        transform: "translate(-21564.727 -16715.754)",
        fill: "#020203"
      })
    ], -1)
  ])]);
}
const Nw = /* @__PURE__ */ g(Wo, [["render", qo]]), Ko = {}, Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.432",
  height: "24",
  viewBox: "0 0 19.432 24"
};
function Xo(e, t) {
  return l(), s("svg", Qo, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_colaboradores2",
      d: "M17.53-2197.8a1.1,1.1,0,0,1-1.1-1.1c0-4.7-3.371-8.516-7.514-8.516S1.4-2203.6,1.4-2198.9a1.1,1.1,0,0,1-1.1,1.1,1.1,1.1,0,0,1-1.1-1.1c0-5.91,4.359-10.718,9.716-10.718s9.716,4.808,9.716,10.718A1.1,1.1,0,0,1,17.53-2197.8ZM8.916-2210.98a5.422,5.422,0,0,1-5.408-5.41,5.415,5.415,0,0,1,5.408-5.41,5.415,5.415,0,0,1,5.408,5.41A5.415,5.415,0,0,1,8.916-2210.98Zm0-8.617a3.217,3.217,0,0,0-3.206,3.206,3.209,3.209,0,0,0,3.206,3.2,3.208,3.208,0,0,0,3.2-3.2A3.209,3.209,0,0,0,8.916-2219.6Z",
      transform: "translate(0.8 2221.799)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const Gw = /* @__PURE__ */ g(Ko, [["render", Xo]]), Jo = ["width", "height"], Uw = /* @__PURE__ */ I({
  __name: "AddFileIcon",
  props: {
    width: {
      type: String,
      default: "20"
    },
    height: {
      type: String,
      default: "24"
    }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.width,
      height: e.height,
      viewBox: "0 0 20 24"
    }, [...r[0] || (r[0] = [
      o("path", {
        id: "File",
        d: "M115.991,73a.992.992,0,0,0-.284-.707l-8-8a.989.989,0,0,0-.707-.285V64h-6a5.006,5.006,0,0,0-5,5V83a5.006,5.006,0,0,0,5,5h10a5.006,5.006,0,0,0,5-5V73ZM108,67.414,112.586,72H111a3,3,0,0,1-3-3ZM111,86H101a3,3,0,0,1-3-3V69a3,3,0,0,1,3-3h5v3a5.006,5.006,0,0,0,5,5h3v9A3,3,0,0,1,111,86Zm0-3.625a1,1,0,0,1-1,1h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,111,82.375Zm-10-4a1,1,0,0,1,1-1h2a1,1,0,1,1,0,2h-2A1,1,0,0,1,101,78.375Z",
        transform: "translate(-96 -64)",
        fill: "#000ec6"
      }, null, -1)
    ])], 8, Jo));
  }
}), e6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.58",
  height: "17.666",
  viewBox: "0 0 17.58 17.666"
}, t6 = ["fill"], Ww = /* @__PURE__ */ I({
  __name: "AdvanceIcon",
  props: {
    focus: { type: Boolean }
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : "#7A7786";
    return (n, i) => (l(), s("svg", e6, [
      o("path", {
        id: "refund",
        d: "M17.28,8.635a8.625,8.625,0,1,1-17.25,0,.576.576,0,0,1,1.152,0,7.48,7.48,0,1,0,.777-3.327h1.2a.576.576,0,0,1,0,1.152H.576A.576.576,0,0,1,0,5.884V3.133a.576.576,0,1,1,1.152,0V4.375A8.622,8.622,0,0,1,17.28,8.635Zm-9.216,2.81V9.165a2.506,2.506,0,0,1-2.3-2.258,2.506,2.506,0,0,1,2.3-2.258V4.027a.576.576,0,1,1,1.152,0V4.65a2.506,2.506,0,0,1,2.3,2.258.576.576,0,0,1-1.152,0c0-.49-.489-.92-1.152-1.082V8.106a2.506,2.506,0,0,1,2.3,2.258,2.506,2.506,0,0,1-2.3,2.258v.622a.576.576,0,1,1-1.152,0v-.622a2.506,2.506,0,0,1-2.3-2.258.576.576,0,1,1,1.152,0C6.912,10.854,7.4,11.283,8.064,11.445ZM9.216,9.281v2.164c.663-.162,1.152-.592,1.152-1.082s-.489-.92-1.152-1.082ZM8.064,7.989V5.825c-.663.162-1.152.592-1.152,1.082S7.4,7.827,8.064,7.989Z",
        transform: "translate(0.15 0.256)",
        fill: r(),
        stroke: "#fff",
        "stroke-width": "0.3"
      }, null, 8, t6)
    ]));
  }
}), Yw = /* @__PURE__ */ I({
  inheritAttrs: !1,
  __name: "ApplePayIcon",
  setup(e) {
    return (t, r) => (l(), s("svg", {
      class: v([t.$attrs.class]),
      viewBox: "0 0 39 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet"
    }, [...r[0] || (r[0] = [
      o("g", { "clip-path": "url(#apple-pay-clip)" }, [
        o("path", {
          fill: "currentColor",
          d: "M7.12953 2.06233C6.6725 2.60277 5.94125 3.02903 5.21 2.96813C5.11859 2.2374 5.4766 1.461 5.89555 0.981454C6.35258 0.425793 7.15238 0.0299794 7.79984 -0.000467789C7.87602 0.760712 7.57894 1.50667 7.12953 2.06233ZM7.79223 3.11276C6.73344 3.05186 5.82699 3.71409 5.32426 3.71409C4.81391 3.71409 4.04457 3.1432 3.20668 3.15843C2.11742 3.17365 1.10434 3.79021 0.548282 4.77213C-0.594296 6.73597 0.251212 9.64368 1.3557 11.2422C1.89652 12.0338 2.54398 12.9015 3.39711 12.8711C4.20453 12.8406 4.52445 12.3459 5.49945 12.3459C6.48207 12.3459 6.76391 12.8711 7.61703 12.8559C8.50062 12.8406 9.05668 12.0642 9.5975 11.2726C10.2145 10.3744 10.4659 9.49906 10.4811 9.45339C10.4659 9.43816 8.77484 8.79116 8.75961 6.84254C8.74437 5.21361 10.0926 4.43721 10.1536 4.39154C9.39184 3.26499 8.20355 3.14321 7.79223 3.11276ZM13.9088 0.905336V12.7721H15.7522V8.71504H18.3039C20.6348 8.71504 22.2725 7.11656 22.2725 4.80258C22.2725 2.48859 20.6653 0.905336 18.3649 0.905336H13.9088ZM15.7522 2.45814H17.8774C19.477 2.45814 20.3911 3.31066 20.3911 4.81019C20.3911 6.30971 19.477 7.16985 17.8698 7.16985H15.7522V2.45814ZM25.6393 12.8635C26.7971 12.8635 27.8711 12.2774 28.3586 11.3487H28.3967V12.7721H30.103V6.86537C30.103 5.15272 28.7319 4.04901 26.6219 4.04901C24.6643 4.04901 23.217 5.16794 23.1637 6.70553H24.8243C24.9614 5.97479 25.6393 5.49525 26.5686 5.49525C27.6959 5.49525 28.3282 6.02047 28.3282 6.98716V7.64178L26.0278 7.77879C23.8873 7.90819 22.7295 8.78355 22.7295 10.3059C22.7295 11.8435 23.9254 12.8635 25.6393 12.8635ZM26.1344 11.4553C25.1518 11.4553 24.5272 10.9834 24.5272 10.2602C24.5272 9.51428 25.1289 9.08041 26.2791 9.0119L28.3282 8.8825V9.55234C28.3282 10.6637 27.3836 11.4553 26.1344 11.4553ZM32.3805 15.9995C34.1782 15.9995 35.0237 15.3145 35.7625 13.2364L38.9998 4.16319H37.126L34.9551 11.1737H34.917L32.7461 4.16319H30.819L33.942 12.8026L33.7744 13.3278C33.4926 14.2184 33.0356 14.5609 32.2205 14.5609C32.0758 14.5609 31.794 14.5457 31.6797 14.5305V15.9539C31.7864 15.9843 32.2434 15.9995 32.3805 15.9995Z"
        })
      ], -1),
      o("defs", null, [
        o("clipPath", { id: "apple-pay-clip" }, [
          o("rect", {
            width: "39",
            height: "16",
            fill: "white"
          })
        ])
      ], -1)
    ])], 2));
  }
}), o6 = {}, n6 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function r6(e, t) {
  return l(), s("svg", n6, [...t[0] || (t[0] = [
    o("path", {
      d: "M40.32 0H7.68C3.43845 0 0 3.43845 0 7.68V40.32C0 44.5615 3.43845 48 7.68 48H40.32C44.5615 48 48 44.5615 48 40.32V7.68C48 3.43845 44.5615 0 40.32 0Z",
      fill: "#FFB71A"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.8193 12.1978C22.5272 12.0678 23.2561 12 24 12C30.6274 12 36 17.3726 36 24C36 30.6274 30.6274 36 24 36C23.2561 36 22.5272 35.9322 21.8193 35.8022C21.2761 35.7024 20.9167 35.1812 21.0164 34.638C21.1162 34.0948 21.6375 33.7353 22.1807 33.8351C22.7699 33.9433 23.3779 34 24 34C29.5228 34 34 29.5228 34 24C34 18.4771 29.5228 14 24 14C23.3779 14 22.7699 14.0567 22.1807 14.1649C21.6375 14.2647 21.1162 13.9052 21.0164 13.362C20.9167 12.8188 21.2761 12.2976 21.8193 12.1978ZM19.3656 13.9709C19.6421 14.4489 19.4788 15.0607 19.0007 15.3372C17.6365 16.1263 16.4755 17.2289 15.6166 18.5462C15.315 19.0088 14.6954 19.1393 14.2328 18.8377C13.7701 18.536 13.6396 17.9165 13.9413 17.4538C14.9711 15.8744 16.3627 14.5527 17.9993 13.606C18.4773 13.3294 19.0891 13.4928 19.3656 13.9709ZM13.5117 20.526C14.0496 20.651 14.3844 21.1884 14.2594 21.7264C14.0899 22.4558 14 23.2168 14 24C14 24.7832 14.0899 25.5442 14.2594 26.2736C14.3844 26.8116 14.0496 27.349 13.5117 27.474C12.9738 27.5991 12.4363 27.2643 12.3113 26.7264C12.1075 25.8495 12 24.9367 12 24C12 23.0633 12.1075 22.1505 12.3113 21.2736C12.4363 20.7357 12.9738 20.4009 13.5117 20.526ZM14.2328 29.1623C14.6954 28.8607 15.315 28.9912 15.6166 29.4538C16.4755 30.7711 17.6365 31.8736 19.0007 32.6628C19.4788 32.9393 19.6421 33.5511 19.3656 34.0291C19.0891 34.5072 18.4773 34.6705 17.9993 34.394C16.3627 33.4473 14.9711 32.1256 13.9413 30.5462C13.6396 30.0835 13.7701 29.464 14.2328 29.1623Z",
      fill: "black"
    }, null, -1),
    o("path", {
      d: "M24 25.586V20C24 19.7348 23.8946 19.4804 23.7071 19.2929C23.5196 19.1054 23.2652 19 23 19C22.7348 19 22.4804 19.1054 22.2929 19.2929C22.1054 19.4804 22 19.7348 22 20V26C22.0001 26.2652 22.1055 26.5195 22.293 26.707L25.293 29.707C25.4816 29.8892 25.7342 29.99 25.9964 29.9877C26.2586 29.9854 26.5094 29.8802 26.6948 29.6948C26.8802 29.5094 26.9854 29.2586 26.9877 28.9964C26.99 28.7342 26.8892 28.4816 26.707 28.293L24 25.586Z",
      fill: "black"
    }, null, -1)
  ])]);
}
const qw = /* @__PURE__ */ g(o6, [["render", r6]]), l6 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, s6 = ["fill"], i6 = ["fill"], a6 = ["id"], d6 = ["stop-color"], u6 = ["stop-color"], c6 = ["id"], h6 = ["stop-color"], p6 = ["stop-color"], Kw = /* @__PURE__ */ I({
  __name: "AnteciPayGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", l6, [
      o("path", {
        d: "M8.00016 4.19039C8.26112 4.19039 8.47266 4.3851 8.47266 4.62527V5.00579H8.68922C9.71129 5.00579 10.5398 5.76837 10.5398 6.70906C10.5398 6.94923 10.3283 7.14394 10.0673 7.14394C9.80639 7.14394 9.59485 6.94923 9.59485 6.70906C9.59485 6.24872 9.18938 5.87554 8.68922 5.87554H7.40954C6.85501 5.87554 6.40548 6.28928 6.40548 6.79966C6.40548 7.31003 6.85501 7.72377 7.40954 7.72377H8.59079C9.66722 7.72377 10.5398 8.52692 10.5398 9.51764C10.5398 10.5084 9.66722 11.3115 8.59079 11.3115H8.47266V11.692C8.47266 11.9322 8.26112 12.1269 8.00016 12.1269C7.73921 12.1269 7.52766 11.9322 7.52766 11.692V11.3115H7.3111C6.28903 11.3115 5.46048 10.5489 5.46048 9.60824C5.46048 9.36806 5.67203 9.17336 5.93298 9.17336C6.19393 9.17336 6.40548 9.36806 6.40548 9.60824C6.40548 10.0686 6.81094 10.4418 7.3111 10.4418H8.59079C9.14531 10.4418 9.59485 10.028 9.59485 9.51764C9.59485 9.00727 9.14531 8.59353 8.59079 8.59353H7.40954C6.3331 8.59353 5.46048 7.79038 5.46048 6.79966C5.46048 5.80893 6.3331 5.00579 7.40954 5.00579H7.52766V4.62527C7.52766 4.3851 7.73921 4.19039 8.00016 4.19039Z",
        fill: `url(#paint0_linear_4912_13400_${D(r)})`
      }, null, 8, s6),
      o("path", {
        d: "M14.3188 10.1272C13.8141 11.6258 12.7915 12.8953 11.4383 13.7107C10.0829 14.5261 8.48292 14.8347 6.92256 14.579C5.36221 14.3234 3.9429 13.5212 2.91809 12.3156C1.89549 11.1101 1.3335 9.58063 1.3335 8.00044C1.3335 7.72496 1.55609 7.50457 1.82937 7.50457C2.10265 7.50457 2.32525 7.72496 2.32525 8.00044C2.32525 9.34481 2.80349 10.6473 3.67403 11.6743C4.54677 12.6991 5.7545 13.3823 7.08125 13.6005C8.41019 13.8165 9.7722 13.5564 10.927 12.8622C12.0797 12.168 12.948 11.0859 13.3778 9.80983C13.8075 8.53599 13.7701 7.14754 13.272 5.89794C12.7739 4.64834 11.8461 3.61472 10.656 2.98441C9.46806 2.3541 8.09283 2.16897 6.77931 2.45768C5.79858 2.67366 4.9016 3.14309 4.1699 3.81307H4.96992C5.2432 3.81307 5.46579 4.03346 5.46579 4.30894C5.46579 4.44558 5.4107 4.569 5.32034 4.65936C5.22998 4.74972 5.10656 4.80482 4.96992 4.80482H2.98641C2.71313 4.80482 2.49054 4.58222 2.49054 4.30894V2.32545C2.49054 2.04996 2.71313 1.82958 2.98641 1.82958C3.2597 1.82958 3.48229 2.04996 3.48229 2.32545V3.09681C4.34401 2.30121 5.40629 1.74362 6.56553 1.49018C8.10826 1.14858 9.72371 1.36896 11.121 2.10947C12.5182 2.84997 13.607 4.06211 14.1932 5.52989C14.7772 6.99988 14.8235 8.62855 14.3188 10.1272Z",
        fill: `url(#paint1_linear_4912_13400_${D(r)})`
      }, null, 8, i6),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13400_${D(r)}`,
          x1: "1.93953",
          y1: "13",
          x2: "14.6647",
          y2: "5.37862",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, d6),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, u6)
        ], 8, a6),
        o("linearGradient", {
          id: `paint1_linear_4912_13400_${D(r)}`,
          x1: "1.93953",
          y1: "13",
          x2: "14.6647",
          y2: "5.37862",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, h6),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, p6)
        ], 8, c6)
      ])
    ]));
  }
}), f6 = {}, C6 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function g6(e, t) {
  return l(), s("svg", C6, [...t[0] || (t[0] = [
    o("path", {
      d: "M40.32 0H7.68C3.43845 0 0 3.43845 0 7.68V40.32C0 44.5615 3.43845 48 7.68 48H40.32C44.5615 48 48 44.5615 48 40.32V7.68C48 3.43845 44.5615 0 40.32 0Z",
      fill: "#00A110"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.7868 14.8358C18.9119 14.947 14.9771 18.864 14.8372 23.7318C14.8346 23.8209 14.8333 23.9103 14.8333 24C14.8333 24.0897 14.8346 24.1792 14.8372 24.2683C14.9753 29.074 18.8123 32.953 23.6009 33.1582C23.7332 33.1638 23.8662 33.1667 24 33.1667C24.1187 33.1667 24.2368 33.1644 24.3543 33.1599C29.1179 32.9789 32.9505 29.1628 33.1578 24.406C33.1637 24.2714 33.1667 24.136 33.1667 24C33.1667 23.9209 33.1657 23.842 33.1637 23.7634C33.0404 18.8986 29.127 14.9756 24.266 14.8371C24.1776 14.8346 24.089 14.8333 24 14.8333C23.9287 14.8333 23.8576 14.8341 23.7868 14.8358ZM24 13C21.1309 13 18.5183 14.0985 16.5599 15.8978C14.3715 17.9084 13 20.794 13 24C13 26.6782 13.9571 29.1328 15.548 31.0405C15.9487 31.5211 16.3897 31.967 16.8658 32.373C18.7264 33.9598 21.1223 34.9374 23.7449 34.9971C23.8297 34.999 23.9148 35 24 35C24.1647 35 24.3285 34.9964 24.4915 34.9892C27.1457 34.8725 29.5557 33.8152 31.3961 32.1424C31.777 31.7963 32.1334 31.4238 32.4626 31.0279C33.9908 29.1897 34.9315 26.8456 34.9964 24.2839C34.9988 24.1896 35 24.0949 35 24C35 23.8427 34.9967 23.6862 34.9902 23.5306C34.8784 20.8676 33.8198 18.4494 32.1424 16.6038C31.8132 16.2416 31.4601 15.9015 31.0857 15.5858C29.1716 13.9723 26.6994 13 24 13ZM29.2496 21.8797C29.5973 21.5117 29.5809 20.9316 29.213 20.5838C28.845 20.2361 28.2649 20.2524 27.9171 20.6203L22.2812 26.5833L20.0829 24.2573C19.7351 23.8894 19.1549 23.873 18.787 24.2207C18.4191 24.5685 18.4027 25.1487 18.7505 25.5166L21.2099 28.1188C21.7954 28.7382 22.7671 28.7382 23.3526 28.1188L29.2496 21.8797Z",
      fill: "white"
    }, null, -1)
  ])]);
}
const Qw = /* @__PURE__ */ g(f6, [["render", g6]]), v6 = {}, m6 = {
  class: "h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
};
function x6(e, t) {
  return l(), s("svg", m6, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Xw = /* @__PURE__ */ g(v6, [["render", x6]]), w6 = {}, k6 = {
  class: "fill-[#000ec6]",
  xmlns: "http://www.w3.org/2000/svg",
  width: "6.154",
  height: "10",
  viewBox: "0 0 6.154 10"
};
function y6(e, t) {
  return l(), s("svg", k6, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_arrow",
      d: "M10.588,18.412a1.154,1.154,0,0,1,0-1.632l3.03-3.03-3.03-3.03A1.154,1.154,0,0,1,12.22,9.088l3.846,3.846a1.154,1.154,0,0,1,0,1.632L12.22,18.412A1.154,1.154,0,0,1,10.588,18.412Z",
      transform: "translate(-10.25 -8.75)",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Jw = /* @__PURE__ */ g(w6, [["render", y6]]), b6 = {}, _6 = {
  class: "h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
};
function M6(e, t) {
  return l(), s("svg", _6, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const ek = /* @__PURE__ */ g(b6, [["render", M6]]), L6 = {}, $6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.74",
  height: "15.895",
  viewBox: "0 0 19.74 15.895"
};
function V6(e, t) {
  return l(), s("svg", $6, [...t[0] || (t[0] = [
    o("path", {
      id: "Icon_Arrow_Right",
      "data-name": "Icon Arrow Right",
      d: "M18,991.31a1,1,0,0,0,.224.575L24.582,999a.768.768,0,0,0,1.124.033.9.9,0,0,0,.031-1.183l-5.1-5.7H36.945a.838.838,0,0,0,0-1.673H20.633l5.1-5.7a.91.91,0,0,0-.031-1.183.768.768,0,0,0-1.124.033l-6.358,7.111A.765.765,0,0,0,18,991.31Z",
      transform: "translate(37.74 999.257) rotate(180)",
      fill: "#fff"
    }, null, -1)
  ])]);
}
const tk = /* @__PURE__ */ g(L6, [["render", V6]]), B6 = {}, H6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "inline-block shrink-0"
};
function F6(e, t) {
  return l(), s("svg", H6, [...t[0] || (t[0] = [
    o("path", {
      d: "M15.8334 10.0013L4.16669 10.0013",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.6658 5.83297L15.8333 10.0005L11.6658 14.168",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ok = /* @__PURE__ */ g(B6, [["render", F6]]), A6 = {}, j6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": "true"
};
function I6(e, t) {
  return l(), s("svg", j6, [...t[0] || (t[0] = [
    o("path", {
      d: "M5 15L15 5M15 5H8.5M15 5V11.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const nk = /* @__PURE__ */ g(A6, [["render", I6]]), Z6 = ["width", "height"], E6 = ["stroke"], S6 = ["stroke"], z6 = ["stroke"], D6 = ["stroke"], rk = /* @__PURE__ */ I({
  __name: "ArrowsExchangeIcon",
  props: {
    size: { default: 20 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M13.4199 8.994L15.8341 6.58067L13.4199 4.1665",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, E6),
      o("path", {
        d: "M4.16602 6.58317H15.8327",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, S6),
      o("path", {
        d: "M6.58018 11.0059L4.16602 13.4192L6.58018 15.8334",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, z6),
      o("path", {
        d: "M15.8327 13.4167H4.16602",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, D6)
    ], 8, Z6));
  }
}), T6 = {}, O6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function P6(e, t) {
  return l(), s("svg", O6, [...t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#00087A"
    }, null, -1),
    o("path", {
      d: "M14.6916 17.0013L7.24219 8.35156H9.55221L17.0016 17.0013H14.6916Z",
      fill: "white"
    }, null, -1),
    o("path", {
      d: "M7 17L7.23007 16.8338C7.4999 16.6386 7.76446 16.4406 8.01765 16.2453C9.81165 14.9041 11.3997 13.3173 12.733 11.5334C13.7604 10.0695 14.0814 8.96136 13.635 8.4083C13.4989 8.27006 13.3323 8.16413 13.148 8.0986C12.9637 8.03307 12.7665 8.00967 12.5715 8.03018C12.1437 8.04074 11.719 8.10528 11.308 8.22222L11.2674 8.23335C11.2426 8.24051 11.2162 8.24101 11.1911 8.23478C11.166 8.22856 11.143 8.21584 11.1246 8.19797C11.0981 8.17138 11.0833 8.13571 11.0833 8.09857C11.0833 8.06143 11.0981 8.02575 11.1246 7.99917C11.1334 7.99068 11.1433 7.98345 11.1542 7.9777L11.1615 7.97372L11.2252 7.9439C12.2784 7.40554 13.4339 7.08686 14.619 7.00796C14.8836 6.98272 15.1506 7.01771 15.3991 7.11019C15.6476 7.20267 15.871 7.35016 16.0518 7.54114C16.6032 8.2262 16.333 9.46193 15.291 11.0205C14.0998 12.8032 12.6213 14.3847 10.9132 15.7034C10.3244 16.1583 9.71781 16.5897 9.10997 16.9845L9.08644 17H7Z",
      fill: "#FFB71A"
    }, null, -1)
  ])]);
}
const lk = /* @__PURE__ */ g(T6, [["render", P6]]), R6 = {}, N6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function G6(e, t) {
  return l(), s("svg", N6, [...t[0] || (t[0] = [
    N('<g id="ic_name" transform="translate(-336 -385.252)"><g id="Rectangle_55" data-name="Rectangle 55" transform="translate(336 385.252)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="40" height="40" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="none"></rect></g><path id="Path_99" data-name="Path 99" d="M11.3-104a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h3.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-5,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H5.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Z" transform="translate(348.499 517.252)" fill="#020203"></path></g>', 1)
  ])]);
}
const sk = /* @__PURE__ */ g(R6, [["render", G6]]), U6 = {}, W6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Y6(e, t) {
  return l(), s("svg", W6, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 2C7.24 2 5 4.24 5 7V11.59L3.29 13.29C3.11 13.47 3 13.72 3 14C3 14.55 3.45 15 4 15H16C16.55 15 17 14.55 17 14C17 13.72 16.89 13.47 16.71 13.29L15 11.59V7C15 4.24 12.76 2 10 2ZM10 18C8.9 18 8 17.1 8 16H12C12 17.1 11.1 18 10 18Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const ik = /* @__PURE__ */ g(U6, [["render", Y6]]), q6 = {}, K6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Q6(e, t) {
  return l(), s("svg", K6, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 2.5C7.51472 2.5 5.5 4.51472 5.5 7V10.7929L4.14645 12.1464C3.95118 12.3417 3.95118 12.6583 4.14645 12.8536C4.24021 12.9473 4.36739 13 4.5 13H15.5C15.6326 13 15.7598 12.9473 15.8536 12.8536C16.0488 12.6583 16.0488 12.3417 15.8536 12.1464L14.5 10.7929V7C14.5 4.51472 12.4853 2.5 10 2.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8 15C8 16.1046 8.89543 17 10 17C11.1046 17 12 16.1046 12 15",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ak = /* @__PURE__ */ g(q6, [["render", Q6]]), X6 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, J6 = ["fill"], en = ["fill"], tn = ["fill"], on = ["fill"], nn = ["fill"], rn = ["fill"], dk = /* @__PURE__ */ I({
  __name: "BulletListGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", X6, [
      o("path", {
        d: "M3 11.5C3.28 11.5 3.5 11.72 3.5 12C3.5 12.28 3.28 12.5 3 12.5H2.33C2.06 12.5 1.83 12.28 1.83 12C1.83 11.72 2.06 11.5 2.33 11.5H3Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, J6),
      o("path", {
        d: "M13.67 11.5C13.94 11.5 14.17 11.72 14.17 12C14.17 12.28 13.94 12.5 13.67 12.5H5.67C5.39 12.5 5.17 12.28 5.17 12C5.17 11.72 5.39 11.5 5.67 11.5H13.67Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, en),
      o("path", {
        d: "M3 7.5C3.28 7.5 3.5 7.72 3.5 8C3.5 8.28 3.28 8.5 3 8.5H2.33C2.06 8.5 1.83 8.28 1.83 8C1.83 7.72 2.06 7.5 2.33 7.5H3Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, tn),
      o("path", {
        d: "M13.67 7.5C13.94 7.5 14.17 7.72 14.17 8C14.17 8.28 13.94 8.5 13.67 8.5H5.67C5.39 8.5 5.17 8.28 5.17 8C5.17 7.72 5.39 7.5 5.67 7.5H13.67Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, on),
      o("path", {
        d: "M3 3.5C3.28 3.5 3.5 3.72 3.5 4C3.5 4.28 3.28 4.5 3 4.5H2.33C2.06 4.5 1.83 4.28 1.83 4C1.83 3.72 2.06 3.5 2.33 3.5H3Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, nn),
      o("path", {
        d: "M13.67 3.5C13.94 3.5 14.17 3.72 14.17 4C14.17 4.28 13.94 4.5 13.67 4.5H5.67C5.39 4.5 5.17 4.28 5.17 4C5.17 3.72 5.39 3.5 5.67 3.5H13.67Z",
        fill: e.active ? "url(#list_blue)" : "url(#list_gray)"
      }, null, 8, rn),
      r[0] || (r[0] = N('<defs><linearGradient id="list_blue" x1="2.39" y1="11.38" x2="11.95" y2="3.53" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="list_gray" x1="2.39" y1="11.38" x2="11.95" y2="3.53" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), ln = {}, sn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function an(e, t) {
  return l(), s("svg", sn, [...t[0] || (t[0] = [
    o("path", { d: "M9.88668 6.11328L6.11334 9.88661" }, null, -1),
    o("path", { d: "M9.88668 9.88661L6.11334 6.11328" }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 14V14C4.686 14 2 11.314 2 8V8C2 4.686 4.686 2 8 2V2C11.314 2 14 4.686 14 8V8C14 11.314 11.314 14 8 14Z"
    }, null, -1)
  ])]);
}
const uk = /* @__PURE__ */ g(ln, [["render", an]]), dn = {}, un = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "97",
  viewBox: "0 0 88 97",
  fill: "none"
};
function cn(e, t) {
  return l(), s("svg", un, [...t[0] || (t[0] = [
    N('<path d="M76.6531 76.9075C79.1319 77.741 81.817 76.4074 82.6505 73.9287C83.4841 71.45 82.1504 68.7647 79.6717 67.9311C77.1929 67.0976 74.5078 68.4314 73.6743 70.9102C72.8407 73.3889 74.1744 76.0739 76.6531 76.9075Z" fill="white"></path><g filter="url(#filter0_d_4718_40868)"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.9546 4.00924C30.1034 3.11725 30.6004 2.32076 31.3361 1.79592C32.0719 1.2703 32.9863 1.05839 33.8781 1.20714C43.642 2.83585 71.9384 7.5559 81.9827 9.23138C82.9125 9.38648 83.7365 9.9201 84.2588 10.7044C84.782 11.4888 84.9561 12.455 84.7405 13.3725C81.5178 27.1119 69.8644 76.7851 66.6916 90.3097C66.481 91.2072 65.9159 91.9812 65.1251 92.4551C64.3343 92.929 63.3852 93.0624 62.4945 92.8248C53.4255 90.4066 28.7394 83.8236 20.1502 81.5332C18.4525 81.0806 17.3769 79.4116 17.666 77.6785C19.7687 65.0735 27.7595 17.1692 29.9546 4.00924Z" fill="#FFDC92"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M52.1668 15.7442C52.2534 15.225 52.5362 14.7615 52.9754 14.4572C53.3924 14.1491 53.9381 14.0282 54.4494 14.1135C55.6942 14.3211 57.3169 14.5918 58.5618 14.7995C59.0731 14.8848 59.55 15.1763 59.8444 15.603C60.161 16.0334 60.2781 16.5636 60.1915 17.0828C59.8879 18.9029 59.4383 21.5983 59.1347 23.4183C59.048 23.9376 58.7649 24.4028 58.3257 24.7072C57.9088 25.0152 57.363 25.1361 56.8518 25.0509C55.6069 24.8432 53.9842 24.5725 52.7393 24.3649C52.2281 24.2796 51.7511 23.9881 51.4568 23.5614C51.1401 23.131 51.0233 22.599 51.1099 22.0798C51.4136 20.2597 51.8632 17.5643 52.1668 15.7442Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.4357 16.4423C28.3847 16.7478 28.0956 16.9542 27.7903 16.9033C27.4851 16.8524 27.2786 16.5633 27.3296 16.2578L29.3882 3.91628C29.7491 1.75316 31.7946 0.292455 33.957 0.653171L57.4197 4.56694C57.7249 4.61784 57.9313 4.90772 57.8804 5.21244C57.8295 5.51795 57.5403 5.72434 57.2351 5.67343L33.7724 1.75967C32.2208 1.50084 30.7532 2.54869 30.4943 4.10078L28.4357 16.4423Z" fill="#7A5B23"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M83.7319 15.1605C83.8025 14.8591 84.1048 14.672 84.4062 14.7426C84.7069 14.8131 84.8943 15.1153 84.8238 15.4167L67.2244 90.4369C66.9792 91.4821 66.3211 92.3835 65.4002 92.9353C64.4793 93.4872 63.3742 93.6425 62.3369 93.3659L25.1759 83.4564C24.8769 83.3767 24.6989 83.0693 24.7786 82.7703C24.8583 82.4713 25.1658 82.2932 25.4648 82.3729L62.6258 92.2824C63.3701 92.4808 64.1631 92.3694 64.8238 91.9734C65.4845 91.5775 65.9567 90.9308 66.1326 90.1809L83.7319 15.1605Z" fill="#7A5B23"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.5082 80.2019L41.0255 81.8325L34.5764 80.1084C34.1521 79.9949 33.7989 79.7049 33.5868 79.3283C33.3731 78.9512 33.3226 78.5111 33.4494 78.0828L35.0437 72.6973C35.1704 72.269 35.455 71.9184 35.8442 71.7026C36.2319 71.4863 36.6874 71.4305 37.1117 71.5439L43.5608 73.2681L43.0831 74.8819L36.9594 73.2448C36.8477 73.215 36.729 73.2901 36.6998 73.3889L36.2414 74.9372C36.2073 75.0524 36.2723 75.1586 36.384 75.1884L40.5218 76.2946L40.0977 77.7274L35.9599 76.6212C35.8482 76.5913 35.7344 76.65 35.7003 76.7653L35.2419 78.3135C35.2127 78.4123 35.2728 78.5349 35.3845 78.5648L41.5082 80.2019Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M51.0492 82.7527L50.5665 84.3833L44.1174 82.6591C43.6931 82.5457 43.3399 82.2557 43.1278 81.8791C42.9141 81.502 42.8636 81.0618 42.9904 80.6336L44.5847 75.2481C44.7115 74.8198 44.996 74.4692 45.3852 74.2533C45.7729 74.037 46.2284 73.9813 46.6527 74.0947L53.1018 75.8188L52.6241 77.4327L46.5004 75.7956C46.3887 75.7657 46.27 75.8409 46.2408 75.9397L44.783 80.8643C44.7537 80.9631 44.8139 81.0857 44.9255 81.1155L51.0492 82.7527Z" fill="white"></path><path d="M56.2881 76.6664L54.0527 76.0688L58.8423 86.5964L61.0776 87.1939L56.2881 76.6664Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M57.7703 76.8154C57.7703 76.8154 61.2369 75.8539 62.5124 77.158C63.7879 78.4621 61.3102 81.978 53.3426 85.1257L51.0697 84.518C51.0697 84.518 59.3789 81.3855 60.2353 78.1533C60.2353 78.1533 60.744 76.8373 57.7703 76.8154Z" fill="#7A5B23"></path><path d="M17.1057 55.2347C25.4421 57.7992 34.3884 52.7648 37.0878 43.9899C39.7873 35.215 35.2177 26.0226 26.8814 23.458C18.5451 20.8934 9.59875 25.9279 6.89928 34.7028C4.1998 43.4777 8.76939 52.6701 17.1057 55.2347Z" fill="#9D752B"></path><mask id="mask0_4718_40868" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="6" y="22" width="32" height="34"><path d="M17.053 55.1033C25.3893 57.6679 34.3356 52.6334 37.0351 43.8585C39.7346 35.0836 35.165 25.8912 26.8287 23.3267C18.4923 20.7621 9.54602 25.7966 6.84654 34.5714C4.14707 43.3463 8.71665 52.5388 17.053 55.1033Z" fill="white"></path></mask><g mask="url(#mask0_4718_40868)"><path d="M42.0575 31.3996C39.4446 23.3249 32.1928 18.1644 25.8602 19.8733C19.5277 21.5823 16.5123 29.5136 19.1253 37.5883C21.7382 45.6631 28.99 50.8236 35.3226 49.1146C41.6551 47.4056 44.6705 39.4744 42.0575 31.3996Z" fill="#F4AC33"></path></g><path d="M15.2229 54.6546C23.5593 57.2191 32.5056 52.1847 35.205 43.4098C37.9045 34.6349 33.3349 25.4425 24.9986 22.8779C16.6622 20.3134 7.71594 25.3478 5.01647 34.1227C2.31699 42.8976 6.88658 52.09 15.2229 54.6546Z" fill="#FFE8B8"></path><path d="M21.483 35.4092C21.8343 34.961 22.4744 34.876 22.9129 35.2196C23.3513 35.5632 23.4221 36.205 23.0709 36.6533L21.4442 38.7295L23.475 40.3207C23.9134 40.6643 23.9842 41.3062 23.633 41.7544C23.2818 42.2026 22.6416 42.2875 22.2032 41.944L20.1723 40.3529L18.5455 42.4291C18.1943 42.8772 17.5541 42.9621 17.1157 42.6187C16.6772 42.2752 16.6066 41.6333 16.9577 41.185L18.5844 39.1088L16.5536 37.5176C16.1151 37.174 16.0444 36.5322 16.3956 36.0839C16.7468 35.6356 17.3869 35.5507 17.8254 35.8943L19.8563 37.4854L21.483 35.4092Z" fill="#E19924"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.0088 29.7942C24.0353 29.1276 28.5595 32.6723 29.1149 37.7123C29.6702 42.7523 26.0463 47.3776 21.0198 48.0441C15.9933 48.7107 11.4691 45.166 10.9137 40.126C10.3584 35.086 13.9823 30.4607 19.0088 29.7942ZM19.2322 31.8219C15.3226 32.3404 12.5041 35.9377 12.9361 39.8578C13.3681 43.7779 16.8868 46.5348 20.7964 46.0164C24.706 45.4979 27.5245 41.9006 27.0925 37.9805C26.6605 34.0604 23.1418 31.3035 19.2322 31.8219Z" fill="#E19924"></path><path d="M20.984 35.0381C21.3353 34.5899 21.9754 34.505 22.4139 34.8485C22.8523 35.1921 22.923 35.8339 22.5719 36.2822L20.9451 38.3584L22.976 39.9496C23.4144 40.2932 23.4852 40.9351 23.134 41.3833C22.7828 41.8315 22.1426 41.9164 21.7041 41.573L19.6733 39.9818L18.0465 42.058C17.6953 42.5061 17.0551 42.5911 16.6167 42.2476C16.1782 41.9041 16.1076 41.2622 16.4587 40.8139L18.0854 38.7377L16.0545 37.1465C15.6161 36.8029 15.5454 36.1611 15.8966 35.7128C16.2478 35.2645 16.8879 35.1796 17.3264 35.5232L19.3573 37.1144L20.984 35.0381Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.5097 29.4231C23.5362 28.7565 28.0604 32.3012 28.6158 37.3412C29.1712 42.3812 25.5473 47.0065 20.5208 47.673C15.4943 48.3396 10.9701 44.7949 10.4147 39.7549C9.85933 34.7149 13.4832 30.0896 18.5097 29.4231ZM18.7332 31.4508C14.8236 31.9693 12.0051 35.5666 12.4371 39.4867C12.869 43.4068 16.3878 46.1637 20.2974 45.6453C24.2069 45.1268 27.0255 41.5295 26.5935 37.6094C26.1615 33.6893 22.6428 30.9324 18.7332 31.4508Z" fill="white"></path><defs><filter id="filter0_d_4718_40868" x="17.6191" y="1.16064" width="70.2119" height="95.7793" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="3" dy="4"></feOffset><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.94 0 0 0 0 0.963077 0 0 0 0 1 0 0 0 1 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4718_40868"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4718_40868" result="shape"></feBlend></filter></defs>', 17)
  ])]);
}
const ck = /* @__PURE__ */ g(dn, [["render", cn]]), hn = {}, pn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": "true"
};
function fn(e, t) {
  return l(), s("svg", pn, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.1665 17.4987H5.83317C4.91234 17.4987 4.1665 16.7529 4.1665 15.832V9.9987C4.1665 9.07786 4.91234 8.33203 5.83317 8.33203H14.1665C15.0873 8.33203 15.8332 9.07786 15.8332 9.9987V15.832C15.8332 16.7529 15.0873 17.4987 14.1665 17.4987Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.6665 8.33333V5.83333V5.83333C6.6665 3.9925 8.159 2.5 9.99984 2.5V2.5C11.8407 2.5 13.3332 3.9925 13.3332 5.83333V5.83333V8.33333",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const hk = /* @__PURE__ */ g(hn, [["render", fn]]), Cn = {}, gn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "97",
  viewBox: "0 0 88 97",
  fill: "none"
};
function vn(e, t) {
  return l(), s("svg", gn, [...t[0] || (t[0] = [
    N('<path d="M76.4978 76.9075C78.9766 77.741 81.6617 76.4074 82.4953 73.9287C83.3288 71.45 81.9951 68.7647 79.5164 67.9311C77.0376 67.0976 74.3525 68.4314 73.519 70.9102C72.6855 73.3889 74.0191 76.0739 76.4978 76.9075Z" fill="white"></path><g filter="url(#filter0_d_4718_40574)"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.7984 4.00924C29.9472 3.11725 30.4442 2.32076 31.1798 1.79592C31.9156 1.2703 32.8301 1.05839 33.7218 1.20714C43.4858 2.83585 71.7821 7.5559 81.8265 9.23138C82.7563 9.38648 83.5803 9.9201 84.1025 10.7044C84.6258 11.4888 84.7998 12.455 84.5843 13.3725C81.3616 27.1119 69.7081 76.7851 66.5354 90.3097C66.3248 91.2072 65.7596 91.9812 64.9688 92.4551C64.1781 92.929 63.229 93.0624 62.3382 92.8248C53.2692 90.4066 28.5831 83.8236 19.9939 81.5332C18.2962 81.0806 17.2207 79.4116 17.5098 77.6785C19.6124 65.0735 27.6032 17.1692 29.7984 4.00924Z" fill="#FE8DA9"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M52.0105 15.7442C52.0971 15.225 52.38 14.7615 52.8192 14.4572C53.2361 14.1491 53.7818 14.0282 54.2931 14.1135C55.5379 14.3211 57.1607 14.5918 58.4055 14.7995C58.9168 14.8848 59.3937 15.1763 59.6881 15.603C60.0047 16.0334 60.1218 16.5636 60.0352 17.0828C59.7316 18.9029 59.282 21.5983 58.9784 23.4183C58.8918 23.9376 58.6086 24.4028 58.1695 24.7072C57.7525 25.0152 57.2068 25.1361 56.6955 25.0509C55.4507 24.8432 53.8279 24.5725 52.5831 24.3649C52.0718 24.2796 51.5949 23.9881 51.3005 23.5614C50.9839 23.131 50.8671 22.599 50.9537 22.0798C51.2573 20.2597 51.7069 17.5643 52.0105 15.7442Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2794 16.4423C28.2284 16.7478 27.9393 16.9542 27.6341 16.9033C27.3288 16.8524 27.1224 16.5633 27.1733 16.2578L29.232 3.91628C29.5928 1.75316 31.6383 0.292455 33.8008 0.653171L57.2635 4.56694C57.5686 4.61784 57.775 4.90772 57.7242 5.21244C57.6732 5.51795 57.3841 5.72434 57.0789 5.67343L33.6162 1.75967C32.0646 1.50084 30.597 2.54869 30.3381 4.10078L28.2794 16.4423Z" fill="#A21F28"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M83.5757 15.1605C83.6462 14.8591 83.9485 14.672 84.25 14.7426C84.5507 14.8131 84.7381 15.1153 84.6675 15.4167L67.0681 90.4369C66.823 91.4821 66.1649 92.3835 65.244 92.9353C64.3231 93.4872 63.218 93.6425 62.1807 93.3659L25.0196 83.4564C24.7206 83.3767 24.5427 83.0693 24.6224 82.7703C24.7021 82.4713 25.0096 82.2932 25.3085 82.3729L62.4696 92.2824C63.2139 92.4808 64.0069 92.3694 64.6675 91.9734C65.3283 91.5775 65.8005 90.9308 65.9764 90.1809L83.5757 15.1605Z" fill="#A21F28"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.3385 79.1058L40.8516 80.7352L34.4069 78.9946C33.9829 78.8801 33.6305 78.5892 33.4193 78.212C33.2066 77.8344 33.1573 77.3941 33.2851 76.9662L34.8932 71.5847C35.021 71.1568 35.3064 70.8069 35.6962 70.5921C36.0844 70.3768 36.5401 70.3222 36.9641 70.4367L43.4088 72.1773L42.9269 73.7899L36.8074 72.1372C36.6958 72.107 36.577 72.1819 36.5475 72.2806L36.0852 73.8277C36.0508 73.9429 36.1155 74.0492 36.2271 74.0793L40.3621 75.1961L39.9343 76.6277L35.7993 75.511C35.6877 75.4808 35.5738 75.5392 35.5393 75.6544L35.0771 77.2015C35.0476 77.3002 35.1074 77.423 35.219 77.4531L41.3385 79.1058Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.8737 81.681L50.3868 83.3104L43.9421 81.5698C43.5181 81.4553 43.1656 81.1644 42.9545 80.7872C42.7417 80.4096 42.6924 79.9693 42.8203 79.5414L44.4283 74.1599C44.5562 73.732 44.8416 73.3821 45.2314 73.1673C45.6196 72.952 46.0753 72.8974 46.4993 73.0119L52.944 74.7525L52.4621 76.3651L46.3426 74.7124C46.231 74.6822 46.1121 74.7571 46.0826 74.8558L44.6122 79.7767C44.5827 79.8754 44.6426 79.9981 44.7541 80.0283L50.8737 81.681Z" fill="white"></path><path d="M56.1273 75.6082L53.8936 75.0049L58.6562 85.5446L60.89 86.1479L56.1273 75.6082Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M57.6093 75.761C57.6093 75.761 61.0784 74.8084 62.3506 76.1157C63.6227 77.4231 61.1361 80.9327 53.1605 84.06L50.8891 83.4465C50.8891 83.4465 59.2063 80.3352 60.0709 77.1052C60.0709 77.1052 60.583 75.7905 57.6093 75.761Z" fill="#C9244B"></path><path d="M17.0333 55.0771C25.3343 57.6308 34.2426 52.6177 36.9306 43.8801C39.6187 35.1424 35.0685 25.989 26.7675 23.4354C18.4666 20.8817 9.55824 25.8948 6.87022 34.6324C4.18221 43.37 8.73239 52.5235 17.0333 55.0771Z" fill="#A21F28"></path><mask id="mask0_4718_40574" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="6" y="22" width="32" height="34"><path d="M16.9806 54.9463C25.2816 57.4999 34.1899 52.4869 36.8779 43.7492C39.5659 35.0116 35.0157 25.8582 26.7148 23.3045C18.4138 20.7508 9.5055 25.7639 6.81749 34.5015C4.12947 43.2392 8.67966 52.3926 16.9806 54.9463Z" fill="white"></path></mask><g mask="url(#mask0_4718_40574)"><path d="M41.8797 31.3429C39.2778 23.3025 32.0568 18.1639 25.7512 19.8656C19.4455 21.5673 16.4429 29.4649 19.0448 37.5054C21.6466 45.5459 28.8676 50.6845 35.1733 48.9827C41.479 47.281 44.4815 39.3834 41.8797 31.3429Z" fill="#F93365"></path></g><path d="M15.1583 54.499C23.4593 57.0527 32.3676 52.0396 35.0556 43.3019C37.7437 34.5643 33.1935 25.4109 24.8925 22.8572C16.5916 20.3036 7.68324 25.3166 4.99522 34.0543C2.30721 42.7919 6.85739 51.9453 15.1583 54.499Z" fill="#FEB8CA"></path><path d="M23.6839 32.7815C24.0337 32.3352 24.6711 32.2506 25.1077 32.5927C25.5443 32.9349 25.6147 33.574 25.265 34.0203L15.996 45.1476C15.6463 45.5938 15.0088 45.6784 14.5722 45.3364C14.1357 44.9944 14.0653 44.3552 14.4149 43.9088L23.6839 32.7815Z" fill="#E4315B"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9281 29.7446C23.9333 29.0809 28.4383 32.6106 28.9913 37.6291C29.5444 42.6477 25.9358 47.2534 20.9307 47.9171C15.9255 48.5808 11.4205 45.0511 10.8675 40.0325C10.3144 35.014 13.923 30.4083 18.9281 29.7446ZM19.1506 31.7638C15.2577 32.28 12.4511 35.8621 12.8812 39.7655C13.3114 43.6689 16.8152 46.4142 20.7082 45.8979C24.6012 45.3817 27.4077 41.7996 26.9776 37.8962C26.5474 33.9928 23.0436 31.2475 19.1506 31.7638Z" fill="#E4315B"></path><path d="M23.4404 32.1623C23.7902 31.7159 24.4276 31.6313 24.8642 31.9734C25.3008 32.3156 25.3712 32.9547 25.0215 33.4011L15.4707 44.9408C15.1209 45.387 14.4835 45.4716 14.0469 45.1296C13.6103 44.7876 13.54 44.1484 13.8896 43.702L23.4404 32.1623Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4311 29.3745C23.4362 28.7107 27.9412 32.2404 28.4943 37.259C29.0473 42.2776 25.4388 46.8833 20.4336 47.547C15.4284 48.2107 10.9234 44.681 10.3704 39.6624C9.81738 34.6438 13.4259 30.0382 18.4311 29.3745ZM18.6536 31.3936C14.7606 31.9099 11.954 35.4919 12.3842 39.3954C12.8143 43.2988 16.3181 46.0441 20.2111 45.5278C24.1041 45.0116 26.9106 41.4295 26.4805 37.5261C26.0504 33.6226 22.5466 30.8774 18.6536 31.3936Z" fill="white"></path><defs><filter id="filter0_d_4718_40574" x="17.4629" y="1.16064" width="70.2119" height="95.7793" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="3" dy="4"></feOffset><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.94 0 0 0 0 0.953 0 0 0 1 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4718_40574"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4718_40574" result="shape"></feBlend></filter></defs>', 17)
  ])]);
}
const pk = /* @__PURE__ */ g(Cn, [["render", vn]]), mn = {}, xn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "97",
  viewBox: "0 0 88 97",
  fill: "none"
};
function wn(e, t) {
  return l(), s("svg", xn, [...t[0] || (t[0] = [
    N('<path d="M76.4978 76.9075C78.9766 77.741 81.6617 76.4074 82.4953 73.9287C83.3288 71.45 81.9951 68.7647 79.5164 67.9311C77.0376 67.0976 74.3525 68.4314 73.519 70.9102C72.6855 73.3889 74.0191 76.0739 76.4978 76.9075Z" fill="white"></path><g filter="url(#filter0_d_4718_40768)"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.7984 4.00924C29.9472 3.11725 30.4442 2.32076 31.1798 1.79592C31.9156 1.2703 32.8301 1.05839 33.7218 1.20714C43.4858 2.83585 71.7821 7.5559 81.8265 9.23138C82.7563 9.38648 83.5803 9.9201 84.1025 10.7044C84.6258 11.4888 84.7998 12.455 84.5843 13.3725C81.3616 27.1119 69.7081 76.7851 66.5354 90.3097C66.3248 91.2072 65.7596 91.9812 64.9688 92.4551C64.1781 92.929 63.229 93.0624 62.3382 92.8248C53.2692 90.4066 28.5831 83.8236 19.9939 81.5332C18.2962 81.0806 17.2207 79.4116 17.5098 77.6785C19.6124 65.0735 27.6032 17.1692 29.7984 4.00924Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M52.0105 15.7442C52.0971 15.225 52.38 14.7615 52.8192 14.4572C53.2361 14.1491 53.7818 14.0282 54.2931 14.1135C55.5379 14.3211 57.1607 14.5918 58.4055 14.7995C58.9168 14.8848 59.3937 15.1763 59.6881 15.603C60.0047 16.0334 60.1218 16.5636 60.0352 17.0828C59.7316 18.9029 59.282 21.5983 58.9784 23.4183C58.8918 23.9376 58.6086 24.4028 58.1695 24.7072C57.7525 25.0152 57.2068 25.1361 56.6955 25.0509C55.4507 24.8432 53.8279 24.5725 52.5831 24.3649C52.0718 24.2796 51.5949 23.9881 51.3005 23.5614C50.9839 23.131 50.8671 22.599 50.9537 22.0798C51.2573 20.2597 51.7069 17.5643 52.0105 15.7442Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2794 16.4423C28.2284 16.7478 27.9393 16.9542 27.6341 16.9033C27.3288 16.8524 27.1224 16.5633 27.1733 16.2578L29.232 3.91628C29.5928 1.75316 31.6383 0.292455 33.8008 0.653171L57.2635 4.56694C57.5686 4.61784 57.775 4.90772 57.7242 5.21244C57.6732 5.51795 57.3841 5.72434 57.0789 5.67343L33.6162 1.75967C32.0646 1.50084 30.597 2.54869 30.3381 4.10078L28.2794 16.4423Z" fill="#002057"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M83.5757 15.1605C83.6462 14.8591 83.9485 14.672 84.25 14.7426C84.5507 14.8131 84.7381 15.1153 84.6675 15.4167L67.0681 90.4369C66.823 91.4821 66.1649 92.3835 65.244 92.9353C64.3231 93.4872 63.218 93.6425 62.1807 93.3659L25.0196 83.4564C24.7206 83.3767 24.5427 83.0693 24.6224 82.7703C24.7021 82.4713 25.0096 82.2932 25.3085 82.3729L62.4696 92.2824C63.2139 92.4808 64.0069 92.3694 64.6675 91.9734C65.3283 91.5775 65.8005 90.9308 65.9764 90.1809L83.5757 15.1605Z" fill="#002057"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M41.352 80.2019L40.8693 81.8325L34.4201 80.1084C33.9958 79.9949 33.6427 79.7049 33.4305 79.3283C33.2168 78.9512 33.1664 78.5111 33.2931 78.0828L34.8874 72.6973C35.0142 72.269 35.2987 71.9184 35.688 71.7026C36.0756 71.4863 36.5311 71.4305 36.9554 71.5439L43.4046 73.2681L42.9268 74.8819L36.8031 73.2448C36.6914 73.215 36.5728 73.2901 36.5435 73.3889L36.0852 74.9372C36.0511 75.0524 36.1161 75.1586 36.2277 75.1884L40.3655 76.2946L39.9414 77.7274L35.8036 76.6212C35.692 76.5913 35.5781 76.65 35.544 76.7653L35.0857 78.3135C35.0564 78.4123 35.1166 78.5349 35.2283 78.5648L41.352 80.2019Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.893 82.7527L50.4103 84.3833L43.9611 82.6591C43.5368 82.5457 43.1837 82.2557 42.9715 81.8791C42.7578 81.502 42.7074 81.0618 42.8342 80.6336L44.4284 75.2481C44.5552 74.8198 44.8397 74.4692 45.229 74.2533C45.6166 74.037 46.0722 73.9813 46.4965 74.0947L52.9456 75.8188L52.4678 77.4327L46.3441 75.7956C46.2325 75.7657 46.1138 75.8409 46.0845 75.9397L44.6267 80.8643C44.5975 80.9631 44.6576 81.0857 44.7693 81.1155L50.893 82.7527Z" fill="white"></path><path d="M56.1318 76.6664L53.8965 76.0688L58.686 86.5964L60.9213 87.1939L56.1318 76.6664Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M57.614 76.8154C57.614 76.8154 61.0806 75.8539 62.3561 77.158C63.6316 78.4621 61.154 81.978 53.1864 85.1257L50.9134 84.518C50.9134 84.518 59.2227 81.3855 60.079 78.1533C60.079 78.1533 60.5877 76.8373 57.614 76.8154Z" fill="#002057"></path><path d="M17.0333 55.0771C25.3343 57.6308 34.2426 52.6177 36.9306 43.8801C39.6187 35.1424 35.0685 25.989 26.7675 23.4354C18.4666 20.8817 9.55824 25.8948 6.87022 34.6324C4.18221 43.37 8.73239 52.5235 17.0333 55.0771Z" fill="#004DD1"></path><mask id="mask0_4718_40768" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="6" y="22" width="32" height="34"><path d="M16.9806 54.9463C25.2816 57.4999 34.1899 52.4869 36.8779 43.7492C39.5659 35.0116 35.0157 25.8582 26.7148 23.3045C18.4138 20.7508 9.5055 25.7639 6.81749 34.5015C4.12947 43.2392 8.67966 52.3926 16.9806 54.9463Z" fill="white"></path></mask><g mask="url(#mask0_4718_40768)"><path d="M41.8797 31.3429C39.2778 23.3025 32.0568 18.1639 25.7512 19.8656C19.4455 21.5673 16.4429 29.4649 19.0448 37.5054C21.6466 45.5459 28.8676 50.6845 35.1733 48.9827C41.479 47.281 44.4815 39.3834 41.8797 31.3429Z" fill="#6BA1FF"></path></g><path d="M15.1583 54.499C23.4593 57.0527 32.3676 52.0396 35.0556 43.3019C37.7437 34.5643 33.1935 25.4109 24.8925 22.8572C16.5916 20.3036 7.68324 25.3166 4.99522 34.0543C2.30721 42.7919 6.85739 51.9453 15.1583 54.499Z" fill="#CCDFFF"></path><path d="M19.2533 28.2826C19.6891 28.2152 20.0666 28.5169 20.0959 28.957L20.2218 30.8463L21.0926 29.7583C21.38 29.3991 21.8798 29.3215 22.2089 29.5847C22.5379 29.848 22.5714 30.3526 22.284 30.7119L20.3721 33.1007L20.6415 37.1409L23.9713 34.5811L24.5329 31.6378C24.6174 31.1952 25.0335 30.8756 25.4621 30.9238C25.8906 30.9724 26.1696 31.3705 26.0853 31.8132L25.8288 33.1532L27.596 31.7961C27.9589 31.5173 28.4506 31.573 28.694 31.9202C28.9372 32.2675 28.8401 32.7754 28.4775 33.0543L26.7088 34.4124L28.01 34.56C28.4386 34.6086 28.7177 35.0067 28.6333 35.4494C28.5488 35.8921 28.1327 36.2117 27.7041 36.1634L24.8505 35.8412L21.5214 38.3993L25.1214 39.8811L27.8724 38.6879C28.2859 38.5086 28.7355 38.6935 28.8767 39.1011C29.0178 39.5088 28.797 39.9846 28.3837 40.1641L27.1292 40.7077L29.0402 41.4943C29.4322 41.6558 29.5942 42.1234 29.4019 42.5384C29.2092 42.9534 28.7349 43.1586 28.3428 42.9973L26.4318 42.2107L26.8609 43.4472C27.0019 43.8549 26.7812 44.3308 26.3678 44.5103C25.9544 44.6895 25.5047 44.5045 25.3635 44.097L24.424 41.3841L20.8256 39.9028L21.095 43.943L23.2829 45.6949C23.6118 45.9583 23.6457 46.4637 23.3581 46.8229C23.0704 47.1819 22.5706 47.2591 22.2417 46.9957L21.2453 46.1975L21.3713 48.0883C21.4007 48.5284 21.0707 48.9402 20.635 49.0083C20.1991 49.0761 19.8218 48.7742 19.7925 48.3339L19.6663 46.4415L18.7942 47.532C18.5068 47.8912 18.0071 47.9696 17.678 47.7064C17.349 47.4432 17.3154 46.9377 17.6028 46.5784L19.516 44.1871L19.2468 40.1484L15.9162 42.7076L15.3547 45.654C15.2702 46.0965 14.8541 46.4161 14.4256 46.3679C13.9969 46.3195 13.718 45.9213 13.8024 45.4786L14.0579 44.1363L12.2916 45.4941C11.9288 45.773 11.4371 45.7179 11.1936 45.3708C10.9502 45.0234 11.0473 44.5156 11.4101 44.2367L13.1765 42.8781L11.8776 42.7317C11.4489 42.6833 11.17 42.2852 11.2544 41.8424C11.339 41.3997 11.7549 41.08 12.1835 41.1284L15.0348 41.4502L18.3645 38.8904L14.767 37.4097L12.0152 38.6039C11.6018 38.7832 11.1522 38.5982 11.0109 38.1906C10.8698 37.783 11.0905 37.3071 11.504 37.1276L12.7575 36.5826L10.8475 35.7967C10.4553 35.6353 10.2932 35.1677 10.4858 34.7526C10.6784 34.3377 11.1527 34.1316 11.5448 34.2929L13.4533 35.0783L13.0268 33.8445C12.8857 33.4369 13.1064 32.9609 13.5198 32.7815C13.9332 32.6024 14.383 32.7872 14.5241 33.1947L15.4619 35.9048L19.0627 37.3873L18.7934 33.3478L16.6039 31.5955C16.2751 31.3321 16.2414 30.8274 16.5288 30.4683C16.8163 30.1091 17.3161 30.0313 17.645 30.2946L18.6431 31.0934L18.5171 29.2025C18.4877 28.7623 18.8174 28.3504 19.2533 28.2826Z" fill="#002057"></path><path d="M18.7279 28.2826C19.1637 28.2152 19.5412 28.5169 19.5705 28.957L19.6965 30.8463L20.5672 29.7583C20.8546 29.3991 21.3544 29.3215 21.6835 29.5847C22.0125 29.848 22.046 30.3526 21.7586 30.7119L19.8468 33.1007L20.1161 37.1409L23.4459 34.5811L24.0075 31.6378C24.092 31.1952 24.5081 30.8756 24.9367 30.9238C25.3652 30.9724 25.6442 31.3705 25.5599 31.8132L25.3034 33.1532L27.0706 31.7961C27.4335 31.5173 27.9252 31.573 28.1686 31.9202C28.4118 32.2675 28.3147 32.7754 27.9521 33.0543L26.1834 34.4124L27.4847 34.56C27.9132 34.6086 28.1923 35.0067 28.1079 35.4494C28.0234 35.8921 27.6074 36.2117 27.1787 36.1634L24.3251 35.8412L20.996 38.3993L24.596 39.8811L27.347 38.6879C27.7605 38.5086 28.2101 38.6935 28.3513 39.1011C28.4924 39.5088 28.2716 39.9846 27.8583 40.1641L26.6039 40.7077L28.5148 41.4943C28.9068 41.6558 29.0688 42.1234 28.8765 42.5384C28.6838 42.9534 28.2095 43.1586 27.8174 42.9973L25.9064 42.2107L26.3355 43.4472C26.4765 43.8549 26.2558 44.3308 25.8424 44.5103C25.429 44.6895 24.9794 44.5045 24.8381 44.097L23.8986 41.3841L20.3002 39.9028L20.5696 43.943L22.7575 45.6949C23.0865 45.9583 23.1203 46.4637 22.8327 46.8229C22.545 47.1819 22.0453 47.2591 21.7163 46.9957L20.7199 46.1975L20.8459 48.0883C20.8753 48.5284 20.5453 48.9402 20.1097 49.0083C19.6737 49.0761 19.2964 48.7742 19.2671 48.3339L19.1409 46.4415L18.2688 47.532C17.9814 47.8912 17.4817 47.9696 17.1526 47.7064C16.8236 47.4432 16.79 46.9377 17.0774 46.5784L18.9906 44.1871L18.7214 40.1484L15.3908 42.7076L14.8294 45.654C14.7448 46.0965 14.3287 46.4161 13.9002 46.3679C13.4716 46.3195 13.1926 45.9213 13.277 45.4786L13.5326 44.1363L11.7662 45.4941C11.4034 45.773 10.9118 45.7179 10.6682 45.3708C10.4248 45.0234 10.5219 44.5156 10.8847 44.2367L12.6511 42.8781L11.3522 42.7317C10.9235 42.6833 10.6446 42.2852 10.729 41.8424C10.8136 41.3997 11.2295 41.08 11.6582 41.1284L14.5094 41.4502L17.8391 38.8904L14.2416 37.4097L11.4899 38.6039C11.0764 38.7832 10.6268 38.5982 10.4856 38.1906C10.3444 37.783 10.5651 37.3071 10.9786 37.1276L12.2322 36.5826L10.3221 35.7967C9.92988 35.6353 9.76786 35.1677 9.96036 34.7526C10.1531 34.3377 10.6273 34.1316 11.0194 34.2929L12.9279 35.0783L12.5014 33.8445C12.3603 33.4369 12.581 32.9609 12.9944 32.7815C13.4079 32.6024 13.8576 32.7872 13.9987 33.1947L14.9365 35.9048L18.5373 37.3873L18.268 33.3478L16.0785 31.5955C15.7497 31.3321 15.716 30.8274 16.0034 30.4683C16.2909 30.1091 16.7907 30.0313 17.1197 30.2946L18.1177 31.0934L17.9917 29.2025C17.9623 28.7623 18.292 28.3504 18.7279 28.2826Z" fill="white"></path><defs><filter id="filter0_d_4718_40768" x="17.4629" y="1.16064" width="70.2119" height="95.7793" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="3" dy="4"></feOffset><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.94 0 0 0 0 0.963077 0 0 0 0 1 0 0 0 1 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4718_40768"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4718_40768" result="shape"></feBlend></filter></defs>', 15)
  ])]);
}
const fk = /* @__PURE__ */ g(mn, [["render", wn]]), kn = {}, yn = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function bn(e, t) {
  return l(), s("svg", yn, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.4853 7.51562L7.51465 24.4863L24.4853 7.51562Z",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 4V4C9.372 4 4 9.372 4 16V16C4 22.628 9.372 28 16 28V28C22.628 28 28 22.628 28 16V16C28 9.372 22.628 4 16 4Z",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ck = /* @__PURE__ */ g(kn, [["render", bn]]), _n = {}, Mn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9.357",
  height: "10",
  viewBox: "0 0 9.357 10"
};
function Ln(e, t) {
  return l(), s("svg", Mn, [...t[0] || (t[0] = [
    N('<g id="Grupo_3009" data-name="Grupo 3009" transform="translate(17953.357 16444)"><g id="ic_bloquear" transform="translate(-17950.301 -16439.16)"><path id="Caminho_894" data-name="Caminho 894" d="M5.655,1.811V1.505a1.505,1.505,0,1,0-3.01,0v.306A1.075,1.075,0,0,0,2,2.8v1.29A1.076,1.076,0,0,0,3.075,5.16h2.15A1.076,1.076,0,0,0,6.3,4.085V2.8A1.075,1.075,0,0,0,5.655,1.811Zm-2.58-.306a1.075,1.075,0,0,1,2.15,0V1.72H3.075Zm2.8,2.58a.645.645,0,0,1-.645.645H3.075a.645.645,0,0,1-.645-.645V2.8a.645.645,0,0,1,.645-.645h2.15A.645.645,0,0,1,5.87,2.8Z"></path><path id="Caminho_895" data-name="Caminho 895" d="M11.215,14a.215.215,0,0,0-.215.215v.43a.215.215,0,1,0,.43,0v-.43A.215.215,0,0,0,11.215,14Z" transform="translate(-7.065 -10.99)"></path></g><path id="bloquear-usuario" d="M24.186,5.1a2.552,2.552,0,1,0-2.552-2.552A2.555,2.555,0,0,0,24.186,5.1Zm0-4.348a1.8,1.8,0,1,1-1.8,1.8A1.8,1.8,0,0,1,24.186.756Zm.51,5.482a.378.378,0,0,1-.378.378H23.94A2.687,2.687,0,0,0,21.256,9.3a.378.378,0,1,1-.756,0,3.444,3.444,0,0,1,3.44-3.44h.378A.378.378,0,0,1,24.7,6.238Z" transform="translate(-17973.857 -16444)" fill="#020203"></path></g>', 1)
  ])]);
}
const gk = /* @__PURE__ */ g(_n, [["render", Ln]]), $n = {}, Vn = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Bn(e, t) {
  return l(), s("svg", Vn, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 10.9331V7.81641",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99921 13.4368C9.88421 13.4368 9.79088 13.5302 9.79171 13.6452C9.79171 13.7602 9.88504 13.8535 10 13.8535C10.115 13.8535 10.2084 13.7602 10.2084 13.6452C10.2084 13.5302 10.115 13.4368 9.99921 13.4368",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.6908 3.44867L18.0733 14.6187C18.815 15.917 17.8775 17.5328 16.3825 17.5328H3.61751C2.12167 17.5328 1.18417 15.917 1.92667 14.6187L8.30917 3.44867C9.05667 2.13951 10.9433 2.13951 11.6908 3.44867Z",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const vk = /* @__PURE__ */ g($n, [["render", Bn]]), Hn = {}, Fn = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function An(e, t) {
  return l(), s("svg", Fn, [...t[0] || (t[0] = [
    o("rect", {
      width: "28",
      height: "28",
      rx: "8",
      fill: "#F0F1FF"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14 21.5V21.5C9.8575 21.5 6.5 18.1425 6.5 14V14C6.5 9.8575 9.8575 6.5 14 6.5V6.5C18.1425 6.5 21.5 9.8575 21.5 14V14C21.5 18.1425 18.1425 21.5 14 21.5Z",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17.3332 12.333L13.1665 16.4997L10.6665 13.9997",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const mk = /* @__PURE__ */ g(Hn, [["render", An]]), jn = {}, In = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Zn(e, t) {
  return l(), s("svg", In, [...t[0] || (t[0] = [
    o("path", {
      d: "M7.77754 17.5002H3.33337V10.8335H7.77754",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.77747 2.5H12.2216V17.5H7.77747V2.5Z",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.2225 6.6665H16.6667V17.4998H12.2225",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const xk = /* @__PURE__ */ g(jn, [["render", Zn]]), En = {}, Sn = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function zn(e, t) {
  return l(), s("svg", Sn, [...t[0] || (t[0] = [
    N('<defs><linearGradient id="linear-gradient" x1="0.5" x2="0.635" y2="6.328" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#000ec6"></stop><stop offset="1" stop-color="#000657"></stop></linearGradient></defs><g id="ic_name" transform="translate(-336 -369)"><rect id="Retângulo_55" data-name="Retângulo 55" width="40" height="40" rx="8" transform="translate(336 369)" fill="url(#linear-gradient)"></rect><path id="Caminho_99" data-name="Caminho 99" d="M11.3-104a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h3.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-5,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H5.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Z" transform="translate(348.5 501)" fill="#fff"></path></g>', 2)
  ])]);
}
const wk = /* @__PURE__ */ g(En, [["render", zn]]), Dn = {}, Tn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function On(e, t) {
  return l(), s("svg", Tn, [...t[0] || (t[0] = [
    o("rect", {
      width: "20",
      height: "14",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2"
    }, null, -1),
    o("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }, null, -1)
  ])]);
}
const kk = /* @__PURE__ */ g(Dn, [["render", On]]), Pn = {}, Rn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.338",
  height: "20.339",
  viewBox: "0 0 20.338 20.339"
};
function Nn(e, t) {
  return l(), s("svg", Rn, [...t[0] || (t[0] = [
    o("path", {
      id: "União_1",
      "data-name": "União 1",
      d: "M-6789-1644.83a10.182,10.182,0,0,1,10.17-10.17,10.181,10.181,0,0,1,10.168,10.17,10.179,10.179,0,0,1-10.168,10.168A10.181,10.181,0,0,1-6789-1644.83Zm1.849,0a8.331,8.331,0,0,0,8.321,8.32,8.33,8.33,0,0,0,8.32-8.32,8.331,8.331,0,0,0-8.32-8.321A8.331,8.331,0,0,0-6787.151-1644.83Zm6.251,3.6-3.052-3.052a.923.923,0,0,1,0-1.307.923.923,0,0,1,1.307,0l2.4,2.4,5.231-5.231a.926.926,0,0,1,1.307,0,.925.925,0,0,1,0,1.308l-5.883,5.883a.924.924,0,0,1-.654.271A.917.917,0,0,1-6780.9-1641.235Z",
      transform: "translate(6789 1655)",
      fill: "#fff"
    }, null, -1)
  ])]);
}
const yk = /* @__PURE__ */ g(Pn, [["render", Nn]]), bk = /* @__PURE__ */ I({
  __name: "BuildingIcon",
  props: {
    color: {}
  },
  setup(e) {
    const t = e, r = f(() => t.color === "primary" ? "text-primary" : "text-subtitle-gray");
    return (n, i) => (l(), s("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: v(r.value)
    }, [...i[0] || (i[0] = [
      N('<path d="M3.33334 18.3333H16.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.16667 18.3333V10.8333H10.8333V18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.33334 18.3333V4.16667C3.33334 3.24619 4.07952 2.5 5 2.5H8.33334C9.25381 2.5 10 3.24619 10 4.16667V18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 18.3333H16.6667V8.33333C16.6667 7.41286 15.9205 6.66667 15 6.66667H11.6667C10.7462 6.66667 10 7.41286 10 8.33333V18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83334 6.66667H7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83334 10H7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.5 10H14.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
    ])], 2));
  }
}), Gn = {}, Un = {
  class: "h-5 w-5 shrink-0",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function Wn(e, t) {
  return l(), s("svg", Un, [...t[0] || (t[0] = [
    o("path", {
      d: "M15.8334 5.41667H4.16675",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M14.1666 9.58366H5.83325",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5 13.7497H7.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const _k = /* @__PURE__ */ g(Gn, [["render", Wn]]), Yn = {}, qn = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Kn(e, t) {
  return l(), s("svg", qn, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M26.1153 6.66909V35.6478C26.1153 36.2792 25.6028 36.7917 24.9714 36.7917H6.66909C5.9614 36.7917 5.28269 36.511 4.78242 36.0092C4.28064 35.509 4 34.8303 4 34.1226V6.66909C4 5.9614 4.28064 5.28269 4.78242 4.78242C5.28269 4.28064 5.9614 4 6.66909 4H23.4462C24.1539 4 24.8326 4.28064 25.3329 4.78242C25.8347 5.28269 26.1153 5.9614 26.1153 6.66909ZM23.8275 6.66909C23.8275 6.56843 23.7879 6.47081 23.7162 6.39913C23.6445 6.32745 23.5469 6.28779 23.4462 6.28779H6.66909C6.56843 6.28779 6.47081 6.32745 6.39913 6.39913C6.32745 6.47081 6.28779 6.56843 6.28779 6.66909V34.1226C6.28779 34.2232 6.32745 34.3209 6.39913 34.3925C6.47081 34.4642 6.56843 34.5039 6.66909 34.5039H23.8275V6.66909Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.0146 25.7339V35.6476C20.0146 36.2791 19.5021 36.7915 18.8707 36.7915H11.2447C10.6133 36.7915 10.1008 36.2791 10.1008 35.6476V25.7339C10.1008 25.2275 10.3022 24.744 10.6591 24.3856C11.0175 24.0287 11.5025 23.8274 12.0073 23.8274H18.1081C18.6129 23.8274 19.0979 24.0287 19.4564 24.3856C19.8133 24.744 20.0146 25.2275 20.0146 25.7339ZM12.3886 26.1152V34.5037H17.7268V26.1152H12.3886Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M36.7915 15.8202V34.1225C36.7915 35.5974 35.5958 36.7916 34.1225 36.7916H24.9713C24.3399 36.7916 23.8274 36.2792 23.8274 35.6477V14.295C23.8274 13.6636 24.3399 13.1511 24.9713 13.1511H34.1225C35.5958 13.1511 36.7915 14.3453 36.7915 15.8202ZM34.5037 15.8202C34.5037 15.6097 34.3329 15.4389 34.1225 15.4389H26.1152V34.5038H34.1225C34.3329 34.5038 34.5037 34.333 34.5037 34.1225V15.8202Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.33813 8.95679H11.6259V11.2446H9.33813V8.95679Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.33813 14.2952H11.6259V16.583H9.33813V14.2952Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.33813 19.6333H11.6259V21.9211H9.33813V19.6333Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9138 8.95679H16.2016V11.2446H13.9138V8.95679Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9138 14.2952H16.2016V16.583H13.9138V14.2952Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9138 19.6333H16.2016V21.9211H13.9138V19.6333Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4895 8.95679H20.7773V11.2446H18.4895V8.95679Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.1658 18.4895H31.4536V20.7773H29.1658V18.4895Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.1658 23.8274H31.4536V26.1152H29.1658V23.8274Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.1658 29.1658H31.4536V31.4536H29.1658V29.1658Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4895 14.2952H20.7773V16.583H18.4895V14.2952Z" fill="#1A1AC3"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4895 19.6333H20.7773V21.9211H18.4895V19.6333Z" fill="#1A1AC3"></path>', 15)
  ])]);
}
const Mk = /* @__PURE__ */ g(Yn, [["render", Kn]]), Qn = {}, Xn = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Jn(e, t) {
  return l(), s("svg", Xn, [...t[0] || (t[0] = [
    N('<path d="M21.0086 21.008V4.28808C21.0072 3.86699 20.7998 3.47325 20.4534 3.2339C20.1069 2.99455 19.6653 2.9399 19.2709 3.08758L12.8392 5.49558C12.3364 5.68404 12.0037 6.16514 12.0049 6.70209V21.008" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.37742 5.25195H8.62836C9.24994 5.25195 9.75383 5.75584 9.75383 6.37742V8.62836H5.25195V6.37742C5.25195 5.75584 5.75584 5.25195 6.37742 5.25195V5.25195Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.50314 3.00195V5.25289" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.00146 21.0091V9.75437C3.00146 9.1328 3.50535 8.62891 4.12693 8.62891H10.8797C11.5013 8.62891 12.0052 9.1328 12.0052 9.75437V21.0091" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.81543 15.3811H9.19184" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.81543 15.3811H9.19184" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.81543 12.0041H9.19184" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.50314 19.3203V21.008" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.0093 21.008H2.00098" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.0061 9.06055V17.0069" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.0075 9.06055V17.0069" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 11)
  ])]);
}
const Lk = /* @__PURE__ */ g(Qn, [["render", Jn]]), er = {}, tr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function or(e, t) {
  return l(), s("svg", tr, [...t[0] || (t[0] = [
    N('<path d="M3 8H21" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 12H7" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 18H6C4.34315 18 3 16.6569 3 15V7C3 5.34315 4.34315 4 6 4H18C19.6569 4 21 5.34315 21 7V10" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.5" cy="16.5" r="4.5" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M18.9062 16.5H16.0938" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const $k = /* @__PURE__ */ g(er, [["render", or]]), nr = {}, rr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function lr(e, t) {
  return l(), s("svg", rr, [...t[0] || (t[0] = [
    o("path", {
      d: "M17 3H16V2C16 1.45 15.55 1 15 1C14.45 1 14 1.45 14 2V3H6V2C6 1.45 5.55 1 5 1C4.45 1 4 1.45 4 2V3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H17C18.1 19 19 18.1 19 17V5C19 3.9 18.1 3 17 3ZM17 17H3V8H17V17Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Vk = /* @__PURE__ */ g(nr, [["render", lr]]), sr = {}, ir = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
};
function ar(e, t) {
  return l(), s("svg", ir, [...t[0] || (t[0] = [
    N('<circle cx="17.5" cy="16.5" r="4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M7 10H11" stroke="currentColor" stroke-opacity="0.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.5 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.5 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 20H6C4.34315 20 3 18.6569 3 17V6.5C3 4.84315 4.34315 3.5 6 3.5H18C19.6569 3.5 21 4.84315 21 6.5V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 14H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.393 14.9824V16.736L18.7752 17.5792" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const Bk = /* @__PURE__ */ g(sr, [["render", ar]]), dr = {}, ur = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function cr(e, t) {
  return l(), s("svg", ur, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.2427 3.75732L3.75732 12.2427L12.2427 3.75732Z"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 2V2C4.686 2 2 4.686 2 8V8C2 11.314 4.686 14 8 14V14C11.314 14 14 11.314 14 8V8C14 4.686 11.314 2 8 2Z"
    }, null, -1)
  ])]);
}
const Hk = /* @__PURE__ */ g(dr, [["render", cr]]), hr = {}, pr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
};
function fr(e, t) {
  return l(), s("svg", pr, [...t[0] || (t[0] = [
    o("path", { d: "M12.78 4.28a.75.75 0 00-1.06-1.06L8 6.94 4.28 3.22a.75.75 0 00-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 101.06 1.06L8 9.06l3.72 3.72a.75.75 0 101.06-1.06L9.06 8l3.72-3.72z" }, null, -1)
  ])]);
}
const Fk = /* @__PURE__ */ g(hr, [["render", fr]]), Cr = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, gr = ["fill"], vr = ["id"], mr = ["stop-color"], xr = ["stop-color"], Ak = /* @__PURE__ */ I({
  __name: "CardGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", Cr, [
      i[0] || (i[0] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.3332 10.6667H3.33317C2.4127 10.6667 1.6665 9.92056 1.6665 9.00008V4.33341C1.6665 3.41294 2.4127 2.66675 3.33317 2.66675H10.6665C11.587 2.66675 12.3332 3.41294 12.3332 4.33341V5.33341",
        fill: "#E2E4EE"
      }, null, -1)),
      o("rect", {
        x: "3.8335",
        y: "4.83325",
        width: "11",
        height: "9",
        rx: "2.5",
        fill: `url(#paint0_linear_4912_13391_${D(r)})`,
        stroke: "white",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, gr),
      i[1] || (i[1] = o("path", {
        d: "M14.3335 7.5V8.5H4.3335V7.5H14.3335Z",
        fill: "white"
      }, null, -1)),
      i[2] || (i[2] = o("path", {
        d: "M7.99984 10.1667C8.27598 10.1667 8.49984 10.3906 8.49984 10.6667C8.49984 10.9429 8.27598 11.1667 7.99984 11.1667H6.6665C6.39036 11.1667 6.1665 10.9429 6.1665 10.6667C6.1665 10.3906 6.39036 10.1667 6.6665 10.1667H7.99984Z",
        fill: "white"
      }, null, -1)),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13391_${D(r)}`,
          x1: "4.78802",
          y1: "12.3333",
          x2: "13.0979",
          y2: "6.11212",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, mr),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, xr)
        ], 8, vr)
      ])
    ]));
  }
}), wr = {
  width: "16",
  height: "16",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, kr = ["fill"], yr = ["fill"], jk = /* @__PURE__ */ I({
  __name: "CreditCardsStackGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", wr, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.67 8H1.67C0.75 8 0 7.25 0 6.33V1.67C0 0.75 0.75 0 1.67 0H9C9.92 0 10.67 0.75 10.67 1.67V2.67",
        fill: (e.active, "#E2E4EE")
      }, null, 8, kr),
      o("rect", {
        x: "2.17",
        y: "2.17",
        width: "11",
        height: "9",
        rx: "2.5",
        fill: e.active ? "url(#model_blue)" : "url(#model_gray)",
        stroke: "white",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, yr),
      r[0] || (r[0] = N('<path d="M12.67 4.83V5.83H2.67V4.83H12.67Z" fill="white"></path><path d="M6.33 7.5C6.61 7.5 6.83 7.72 6.83 8C6.83 8.28 6.61 8.5 6.33 8.5H5C4.72 8.5 4.5 8.28 4.5 8C4.5 7.72 4.72 7.5 5 7.5H6.33Z" fill="white"></path><defs><linearGradient id="model_blue" x1="3.12" y1="9.67" x2="11.43" y2="3.45" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="model_gray" x1="3.12" y1="9.67" x2="11.43" y2="3.45" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 3))
    ]));
  }
}), br = {
  width: "16",
  height: "16",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, _r = ["fill"], Mr = ["fill"], Ik = /* @__PURE__ */ I({
  __name: "CreditCardSingleGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", br, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.67 4.2L3.54 1.04C3.64 0.68 3.88 0.37 4.21 0.19C4.54 0 4.94 -0.05 5.3 0.05L12.27 1.86C12.64 1.96 12.95 2.19 13.14 2.51C13.33 2.84 13.38 3.22 13.28 3.58L12.17 7.63C11.97 8.36 11.21 8.8 10.45 8.63",
        fill: (e.active, "#E2E4EE")
      }, null, 8, _r),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.67 9.87V5.47C10.67 5.08 10.51 4.7 10.22 4.43C9.93 4.15 9.55 4 9.14 4H1.52C1.12 4 0.73 4.15 0.45 4.43C0.16 4.7 0 5.08 0 5.47V9.87C0 10.26 0.16 10.63 0.45 10.9C0.73 11.18 1.12 11.33 1.52 11.33H9.14C9.98 11.33 10.67 10.68 10.67 9.87Z",
        fill: e.active ? "url(#cards_blue)" : "url(#cards_gray)"
      }, null, 8, Mr),
      r[0] || (r[0] = N('<path d="M10.67 6.33V7.33H0V6.33H10.67Z" fill="white"></path><defs><linearGradient id="cards_blue" x1="0.48" y1="10.42" x2="8.35" y2="3.57" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="cards_gray" x1="0.48" y1="10.42" x2="8.35" y2="3.57" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 2))
    ]));
  }
}), Lr = ["width", "height"], $r = ["stroke"], Vr = ["stroke"], Br = ["stroke"], Hr = ["stroke"], Fr = ["stroke"], Ar = ["stroke"], Zk = /* @__PURE__ */ I({
  __name: "CreditCardTransferSwapIcon",
  props: {
    size: { default: 20 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M2.5 7.50065H17.5",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, $r),
      o("path", {
        d: "M6.66667 15.834H5C3.61929 15.834 2.5 14.7147 2.5 13.334V5.83398C2.5 4.45327 3.61929 3.33398 5 3.33398H15C16.3807 3.33398 17.5 4.45327 17.5 5.83398V10.0007",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Vr),
      o("path", {
        d: "M12.4998 14.1667L10.8332 12.5L9.1665 14.1667",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Br),
      o("path", {
        d: "M10.8332 16.6667V12.5",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Hr),
      o("path", {
        d: "M14.1665 15.834L15.8332 17.5007L17.4998 15.834",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Fr),
      o("path", {
        d: "M15.8332 13.334V17.5007",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Ar)
    ], 8, Lr));
  }
}), jr = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, Ir = ["fill"], Ek = /* @__PURE__ */ I({
  __name: "ChecklistGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", jr, [
      o("path", {
        d: "M10.67 2C12.51 2 14 3.49 14 5.33V10.67C14 12.51 12.51 14 10.67 14H5.33C3.49 14 2 12.51 2 10.67V5.33C2 3.49 3.49 2 5.33 2H10.67Z",
        fill: e.active ? "url(#check_blue)" : "url(#check_gray)"
      }, null, 8, Ir),
      r[0] || (r[0] = N('<path d="M6.15 8.92C6.35 8.73 6.67 8.75 6.86 8.96C7.04 9.16 7.02 9.48 6.82 9.66L5.58 10.77C5.39 10.95 5.1 10.94 4.91 10.77L4.3 10.22C4.1 10.04 4.08 9.72 4.26 9.51C4.45 9.31 4.77 9.29 4.97 9.48L5.25 9.73L6.15 8.92Z" fill="white"></path><path d="M11.31 9.53C11.58 9.53 11.81 9.76 11.81 10.03C11.81 10.31 11.58 10.53 11.31 10.53H8.64C8.36 10.53 8.14 10.31 8.14 10.03C8.14 9.76 8.36 9.53 8.64 9.53H11.31Z" fill="white"></path><path d="M6.15 5.58C6.35 5.4 6.67 5.42 6.85 5.62C7.04 5.83 7.02 6.14 6.82 6.33L5.58 7.44C5.39 7.61 5.1 7.61 4.91 7.44L4.3 6.89C4.1 6.7 4.08 6.38 4.26 6.18C4.45 5.97 4.77 5.96 4.97 6.14L5.25 6.39L6.15 5.58Z" fill="white"></path><path d="M11.31 6.2C11.58 6.2 11.81 6.42 11.81 6.7C11.81 6.97 11.58 7.2 11.31 7.2H8.64C8.36 7.2 8.14 6.97 8.14 6.7C8.14 6.42 8.36 6.2 8.64 6.2H11.31Z" fill="white"></path><defs><linearGradient id="check_blue" x1="2.55" y1="12.51" x2="14" y2="5.64" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="check_gray" x1="2.55" y1="12.51" x2="14" y2="5.64" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 5))
    ]));
  }
}), Zr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.001",
  height: "16",
  viewBox: "0 0 12.001 16"
}, Er = ["fill"], Sk = /* @__PURE__ */ I({
  __name: "cardIcon",
  props: {
    focus: { type: Boolean },
    fillColor: {}
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : t.fillColor ? t.fillColor : "#7A7786";
    return (n, i) => (l(), s("svg", Zr, [
      o("path", {
        id: "ic_card",
        d: "M3-13612a3,3,0,0,1-3-3v-10a3,3,0,0,1,3-3H9a3,3,0,0,1,3,3v10a3,3,0,0,1-3,3Zm-2-13v10a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2v-10a2,2,0,0,0-2-2H3A2,2,0,0,0,1-13625Zm6.2,2a.2.2,0,0,1-.2-.2v-1.6a.2.2,0,0,1,.2-.2h.6a.2.2,0,0,1,.2.2v1.6a.2.2,0,0,1-.2.2Z",
        transform: "translate(0 13628.001)",
        fill: r()
      }, null, 8, Er)
    ]));
  }
}), Sr = {}, zr = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function Dr(e, t) {
  return l(), s("svg", zr, [...t[0] || (t[0] = [
    o("path", {
      d: "M12 3.33333V12.6667C12 13.403 11.403 14 10.6667 14H5.33333C4.59695 14 4 13.403 4 12.6667V3.33333C4 2.59695 4.59695 2 5.33333 2H10.6667C11.403 2 12 2.59695 12 3.33333",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.66667 12H9.33333",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zk = /* @__PURE__ */ g(Sr, [["render", Dr]]), Tr = {}, Or = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function Pr(e, t) {
  return l(), s("svg", Or, [...t[0] || (t[0] = [
    o("path", {
      d: "M2 5.33333H14",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2 8.66667V4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V9.33333C14 10.4379 13.1046 11.3333 12 11.3333H10",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.3333 8.66667H9.33333",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.66667 14C4.66667 12.5272 3.47276 11.3333 2 11.3333C3.47276 11.3333 4.66667 10.1394 4.66667 8.66667C4.66667 10.1394 5.86057 11.3333 7.33333 11.3333C5.86057 11.3333 4.66667 12.5272 4.66667 14Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Dk = /* @__PURE__ */ g(Tr, [["render", Pr]]), Rr = {
  viewBox: "0 0 57 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-auto w-full max-h-14",
  "aria-hidden": "true"
}, Tk = /* @__PURE__ */ I({
  __name: "CardTemplateEmptyIcon",
  setup(e) {
    const r = `card-template-empty-mask-${Xe().replace(/[^a-zA-Z0-9]/g, "")}`, n = `url(#${r})`;
    return (i, a) => (l(), s("svg", Rr, [
      a[2] || (a[2] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M54.5177 27.5072C55.3282 28.7501 55.5526 30.3533 54.9886 31.8459L45.7591 56.2708C45.2798 57.5391 44.3172 58.5656 43.0823 59.1243C41.8507 59.6745 40.4436 59.7245 39.1772 59.2459L5.76134 46.6189C5.49654 46.5189 5.24673 46.3948 5.01113 46.2565C4.9714 46.2316 4.93167 46.2068 4.89194 46.1819L3.37601 45.264L3.66381 45.0769C2.65955 43.7904 2.3298 42.0291 2.94923 40.3898L12.2766 15.7061C13.2187 13.2127 16.0087 11.9499 18.5053 12.8933L52.1352 25.6012L52.3877 24.7797L53.9976 26.8374C54.1901 27.0482 54.3641 27.2717 54.5177 27.5072Z",
        fill: "#000CAD"
      }, null, -1)),
      a[3] || (a[3] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M49.5067 22.9792C52.4033 23.9681 53.9472 27.1265 52.9608 30.0156C50.7705 36.431 47.0843 47.2281 44.894 53.6435C43.9047 56.5413 40.7547 58.0875 37.8581 57.0986C29.6512 54.2967 13.8655 48.9073 5.65858 46.1054C2.76198 45.1165 1.21521 41.9667 2.20456 39.0689C4.39483 32.6535 8.08104 21.8564 10.2713 15.4411C11.2577 12.552 14.4106 10.9971 17.3073 11.986C25.5142 14.7879 41.2998 20.1773 49.5067 22.9792Z",
        fill: "#C7CBFF"
      }, null, -1)),
      a[4] || (a[4] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M49.2812 39.7824C49.3378 39.6166 49.5238 39.5241 49.6948 39.5825C49.8658 39.6409 49.9574 39.8281 49.9008 39.9939L45.2044 53.7499C44.1584 56.8135 40.8215 58.4519 37.7539 57.4046L5.55438 46.4114C2.48677 45.3641 0.849379 42.0275 1.89534 38.9638L4.36571 31.728C4.42233 31.5621 4.60832 31.4697 4.77931 31.5281C4.95031 31.5865 5.04186 31.7737 4.98524 31.9395L2.51488 39.1753C1.58513 41.8986 3.04036 44.8611 5.76597 45.7916L37.9655 56.7848C40.6911 57.7154 43.6551 56.2616 44.5848 53.5384L49.2812 39.7824Z",
        fill: "#000CAD"
      }, null, -1)),
      a[5] || (a[5] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M51.2897 29.1121L42.9181 53.6329C42.3426 55.3185 40.4991 56.2283 38.8071 55.6506L5.80369 44.383C4.11173 43.8053 3.2094 41.9581 3.7849 40.2724L12.1565 15.7516C12.7347 14.0581 14.5756 13.1562 16.2675 13.7339L49.271 25.0015C50.9629 25.5792 51.8679 27.4185 51.2897 29.1121Z",
        fill: "#000CAD"
      }, null, -1)),
      o("mask", {
        id: r,
        "mask-type": "luminance",
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "13",
        width: "49",
        height: "43"
      }, [...a[0] || (a[0] = [
        o("path", {
          d: "M51.2897 29.1121L42.9181 53.6329C42.3426 55.3185 40.4991 56.2283 38.8071 55.6506L5.80369 44.383C4.11173 43.8053 3.2094 41.9581 3.7849 40.2724L12.1565 15.7516C12.7347 14.0581 14.5756 13.1562 16.2675 13.7339L49.271 25.0015C50.9629 25.5792 51.8679 27.4185 51.2897 29.1121Z",
          fill: "white"
        }, null, -1)
      ])]),
      o("g", { mask: n }, [...a[1] || (a[1] = [
        o("path", {
          d: "M47.7834 43.2446L6.41504 29.1211L1.33266 44.0076L42.701 58.1311L47.7834 43.2446Z",
          fill: "#C7CBFF"
        }, null, -1)
      ])]),
      a[6] || (a[6] = N('<path fill-rule="evenodd" clip-rule="evenodd" d="M52.5761 19.3405C53.075 19.5129 53.485 19.8765 53.7162 20.3513C53.947 20.826 53.9799 21.3731 53.8075 21.872C52.201 26.5204 48.0586 38.507 46.4522 43.1553C46.2797 43.6543 45.9161 44.0643 45.4414 44.2952C44.9664 44.5259 44.4195 44.5588 43.9205 44.3864C37.6633 42.224 17.5938 35.2882 11.3365 33.1257C10.8376 32.9533 10.4276 32.5896 10.1967 32.115C9.96577 31.6402 9.93293 31.0933 10.1054 30.5943C11.7118 25.946 15.8543 13.9593 17.4607 9.31095C17.6331 8.81202 17.9967 8.40199 18.4714 8.17112C18.9462 7.94024 19.4931 7.9074 19.9921 8.07983C26.2493 10.2423 46.3189 17.1781 52.5761 19.3405Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.0552 12.5911C50.5749 12.6836 51.0365 12.9788 51.3389 13.4118C51.6408 13.8447 51.7586 14.38 51.6661 14.8997C50.804 19.7417 48.581 32.2276 47.7189 37.0695C47.6264 37.5893 47.3311 38.0509 46.8982 38.353C46.465 38.655 45.9299 38.7728 45.4102 38.6802C38.8923 37.5198 17.9868 33.7977 11.4689 32.6372C10.9492 32.5447 10.4875 32.2494 10.1854 31.8166C9.88334 31.3836 9.76562 30.8485 9.85819 30.3287C10.7203 25.4867 12.9433 13.0008 13.8054 8.15885C13.8979 7.63913 14.1931 7.17743 14.6261 6.87537C15.059 6.5733 15.5942 6.45558 16.1139 6.54812C22.6318 7.70858 43.5373 11.4307 50.0552 12.5911Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.4323 12.3338C50.9711 12.4298 51.4493 12.7357 51.7624 13.1843C52.0755 13.6331 52.1975 14.1878 52.1016 14.7264L48.065 37.3982C47.9691 37.9369 47.6631 38.4155 47.2144 38.7285C46.7657 39.0416 46.2113 39.1633 45.6725 39.0674L11.2292 32.935C10.6906 32.8391 10.212 32.5335 9.899 32.0848C9.58592 31.6361 9.46393 31.0813 9.55984 30.5426L13.5964 7.87082C13.6923 7.33218 13.9983 6.85368 14.447 6.5406C14.8956 6.22755 15.4503 6.10554 15.989 6.20145L50.4323 12.3338ZM50.3175 12.9784L15.8742 6.84605C15.5065 6.78058 15.1279 6.86388 14.8216 7.07759C14.5153 7.29126 14.3065 7.61791 14.241 7.9856L10.2045 30.6574C10.139 31.0251 10.2223 31.4037 10.436 31.7098C10.6497 32.0162 10.9763 32.2253 11.344 32.2907L45.7872 38.4231C46.155 38.4886 46.5335 38.405 46.8399 38.1913C47.1462 37.9777 47.3549 37.6511 47.4204 37.2834L51.4569 14.6116C51.5224 14.2439 51.4393 13.8653 51.2255 13.559C51.0118 13.2527 50.6853 13.0439 50.3175 12.9784Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8096 35.4307C9.71116 35.4786 8.7819 34.6271 8.73398 33.5289C8.51527 28.5161 7.9433 15.4066 7.72459 10.3939C7.67668 9.29565 8.52825 8.36649 9.6267 8.31857C16.3605 8.02477 38.2604 7.06927 44.9945 6.77546C46.0928 6.72754 47.022 7.579 47.0699 8.67726C47.2886 13.69 47.8605 26.7994 48.0793 31.8122C48.1272 32.9105 47.2757 33.8396 46.1775 33.8875C39.4433 34.1814 17.5434 35.1369 10.8096 35.4307Z" fill="#0012FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M40.1884 28.9512C39.9333 28.9624 39.6849 28.8745 39.4963 28.6963C39.3082 28.529 39.1959 28.2817 39.1849 28.0299C39.1582 27.4169 39.1233 26.6177 39.0966 26.0047C39.0856 25.753 39.1759 25.4967 39.3488 25.3137C39.5211 25.1197 39.7609 25.0106 40.016 24.9995C40.9101 24.9605 42.2343 24.9027 43.1285 24.8637C43.3835 24.8526 43.6328 24.9404 43.8214 25.1186C44.0095 25.2858 44.1218 25.5332 44.1328 25.785C44.1595 26.398 44.1944 27.1971 44.2212 27.8101C44.2321 28.0619 44.1418 28.3181 43.969 28.5012C43.7966 28.6951 43.5559 28.8043 43.3009 28.8154C42.4067 28.8544 41.0825 28.9122 40.1884 28.9512Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43.5659 51.727L4.43297 38.3667L7.94782 28.0716L12.7858 29.7233C13.7085 30.0383 14.7171 29.9429 15.5432 29.4598L16.5743 28.8532C17.4032 28.3622 18.4125 28.2671 19.3344 28.5818L37.7603 34.8726C38.6822 35.1873 39.4226 35.8798 39.7774 36.7749L40.2231 37.8857C40.5805 38.7729 41.3209 39.4655 42.2428 39.7802L47.0808 41.4319L43.5659 51.727Z" fill="#C7CBFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6783 30.0378C12.5074 29.9794 12.4173 29.7904 12.4765 29.6171C12.5329 29.4517 12.7198 29.3572 12.8908 29.4156C13.7219 29.6993 14.632 29.6142 15.3783 29.1742L16.4095 28.5676C17.3182 28.0335 18.426 27.928 19.4395 28.274L37.8653 34.5648C38.8779 34.9105 39.6908 35.6717 40.0824 36.6497L40.528 37.7606C40.8486 38.5648 41.5167 39.1887 42.3478 39.4725L46.9031 41.0277C47.074 41.086 47.1649 41.2753 47.1085 41.4408C47.0493 41.614 46.8616 41.7083 46.6906 41.6499L42.1354 40.0947C41.1228 39.749 40.3126 38.9798 39.9211 38.0018L39.4753 36.8911C39.1521 36.0947 38.4867 35.4629 37.6556 35.1792L19.2297 28.8884C18.3985 28.6046 17.4858 28.6976 16.7422 29.1298L15.7111 29.7363C14.8024 30.2704 13.6918 30.3838 12.6783 30.0378Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43.6422 50.4872C43.7012 50.3143 43.8867 50.2233 44.0579 50.2817C44.229 50.3401 44.321 50.5259 44.262 50.6988L43.4946 52.9464C42.7125 55.2372 40.2195 56.4612 37.927 55.6785L24.4788 51.0872C24.3076 51.0287 24.2165 50.8432 24.2726 50.679C24.3316 50.5061 24.5171 50.415 24.6883 50.4735L38.1365 55.0648C40.0867 55.7306 42.2078 54.6884 42.8748 52.7348L43.6422 50.4872Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M23.5348 35.6935C24.0327 35.4409 24.6362 35.6421 24.8829 36.143C25.1209 36.62 25.4141 37.1992 25.652 37.6762C25.9008 38.1709 25.6977 38.7799 25.2018 39.0263C24.7252 39.265 24.1431 39.5523 23.6665 39.7911C23.1685 40.0437 22.5651 39.8425 22.3184 39.3416C22.0804 38.8646 21.7872 38.2854 21.5493 37.8083C21.3004 37.3137 21.5035 36.7046 21.9994 36.4583C22.476 36.2196 23.0582 35.9322 23.5348 35.6935Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M27.3759 15.399L26.3848 15.4602L26.1449 11.5711C26.1291 11.3152 26.2242 11.0631 26.3932 10.8711C26.5622 10.6782 26.7963 10.5624 27.0565 10.5463L30.3298 10.3444C30.5901 10.3284 30.8366 10.4145 31.028 10.5852C31.2194 10.755 31.3345 10.9941 31.3503 11.25L31.5902 15.1391L30.6093 15.1996L30.3815 11.5068C30.3773 11.4394 30.3138 11.3892 30.2538 11.3929L29.3128 11.451C29.2427 11.4553 29.1961 11.5123 29.2002 11.5796L29.3541 14.0749L28.4833 14.1286L28.3294 11.6333C28.3252 11.566 28.2717 11.5152 28.2017 11.5195L27.2607 11.5776C27.2006 11.5813 27.1439 11.6389 27.1481 11.7062L27.3759 15.399Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M27.7306 21.153L26.7396 21.2141L26.4997 17.325C26.4839 17.0691 26.5789 16.817 26.7479 16.625C26.9169 16.4321 27.151 16.3163 27.4113 16.3002L30.6846 16.0983C30.9448 16.0823 31.1914 16.1685 31.3828 16.3391C31.5741 16.5089 31.6892 16.748 31.705 17.0039L31.9449 20.893L30.964 20.9535L30.7362 17.2607C30.7321 17.1933 30.6686 17.1431 30.6085 17.1468L27.6154 17.3315C27.5553 17.3352 27.4987 17.3928 27.5028 17.4601L27.7306 21.153Z" fill="white"></path><path d="M32.0658 22.8128L31.9827 21.4648L27.0471 26.2041L27.1302 27.5521L32.0658 22.8128Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M32.2574 23.6564C32.2574 23.6564 33.4306 25.3689 32.9454 26.3309C32.4603 27.2928 30.0575 26.6351 26.8425 22.8867L26.7579 21.516C26.7579 21.516 30.0278 25.4551 31.9737 25.2788C31.9737 25.2788 32.7956 25.2949 32.2574 23.6564Z" fill="#C7CBFF"></path>', 13))
    ]));
  }
}), Nr = {
  width: "16",
  height: "16",
  viewBox: "1.5 2.5 13.5 11.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 shrink-0"
}, Gr = ["fill"], Ok = /* @__PURE__ */ I({
  __name: "CardsNavGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Nr, [
      r[0] || (r[0] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.3332 10.668H3.33317C2.4127 10.668 1.6665 9.92178 1.6665 9.0013V4.33464C1.6665 3.41416 2.4127 2.66797 3.33317 2.66797H10.6665C11.587 2.66797 12.3332 3.41416 12.3332 4.33464V5.33464",
        fill: "#E2E4EE"
      }, null, -1)),
      o("rect", {
        x: "3.83301",
        y: "4.83594",
        width: "11",
        height: "9",
        rx: "2.5",
        fill: e.active ? "url(#cards_nav_blue)" : "url(#cards_nav_gray)",
        stroke: "white",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Gr),
      r[1] || (r[1] = N('<path d="M14.333 7.5V8.5H4.33301V7.5H14.333Z" fill="white"></path><path d="M7.99984 10.168C8.27598 10.168 8.49984 10.3918 8.49984 10.668C8.49984 10.9441 8.27598 11.168 7.99984 11.168H6.6665C6.39036 11.168 6.1665 10.9441 6.1665 10.668C6.1665 10.3918 6.39036 10.168 6.6665 10.168H7.99984Z" fill="white"></path><defs><linearGradient id="cards_nav_blue" x1="4.78753" y1="12.336" x2="13.0974" y2="6.11481" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="cards_nav_gray" x1="4.78753" y1="12.336" x2="13.0974" y2="6.11481" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 3))
    ]));
  }
}), Ur = {}, Wr = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Yr(e, t) {
  return l(), s("svg", Wr, [...t[0] || (t[0] = [
    N('<path d="M21.3346 19.2441H8.05054C7.56148 19.2463 7.08799 19.0723 6.71682 18.7538C6.34566 18.4353 6.10166 17.9938 6.02953 17.5101L3.63352 1.93703C3.60811 1.76973 3.52346 1.61712 3.39498 1.50699C3.2665 1.39686 3.10273 1.33655 2.93351 1.33703H0.668503C0.491205 1.33703 0.321169 1.2666 0.1958 1.14123C0.0704314 1.01586 0 0.845822 0 0.668524C0 0.491226 0.0704314 0.32119 0.1958 0.195821C0.321169 0.0704524 0.491205 2.10188e-05 0.668503 2.10188e-05H2.93151C3.42057 -0.00220126 3.89406 0.171862 4.26523 0.490322C4.6364 0.808781 4.8804 1.25031 4.95252 1.73403L7.35253 17.3071C7.37794 17.4744 7.46259 17.627 7.59107 17.7371C7.71956 17.8473 7.88332 17.9076 8.05254 17.9071H21.3346C21.5116 17.9071 21.6814 17.9774 21.8066 18.1026C21.9318 18.2278 22.0021 18.3976 22.0021 18.5746C22.0021 18.7516 21.9318 18.9214 21.8066 19.0466C21.6814 19.1718 21.5116 19.2421 21.3346 19.2421" fill="currentColor"></path><path d="M6.47524 16.6875C6.31433 16.6879 6.15871 16.6301 6.03706 16.5247C5.91542 16.4194 5.83594 16.2737 5.81329 16.1144C5.79063 15.9551 5.82633 15.7929 5.9138 15.6579C6.00126 15.5228 6.13461 15.4239 6.28924 15.3795L20.6693 11.1864V4.77641H7.55924C7.38221 4.77641 7.21243 4.70609 7.08725 4.58091C6.96207 4.45573 6.89174 4.28595 6.89174 4.10891C6.89174 3.93188 6.96207 3.7621 7.08725 3.63692C7.21243 3.51174 7.38221 3.44141 7.55924 3.44141H21.3363C21.5132 3.44141 21.6829 3.51168 21.808 3.63677C21.933 3.76185 22.0033 3.93151 22.0033 4.10841V11.6854C22.0034 11.83 21.9566 11.9706 21.8698 12.0862C21.7831 12.2018 21.6611 12.2861 21.5223 12.3264L6.66424 16.6595C6.60351 16.6773 6.54054 16.6864 6.47724 16.6865" fill="currentColor"></path><path d="M9.62313 22.0002C9.21867 22.0002 8.82329 21.8802 8.48699 21.6555C8.15069 21.4308 7.88858 21.1114 7.7338 20.7377C7.57902 20.3641 7.53851 19.9529 7.61742 19.5562C7.69633 19.1595 7.8911 18.7951 8.1771 18.5091C8.4631 18.2231 8.82748 18.0284 9.22418 17.9495C9.62087 17.8705 10.0321 17.911 10.4057 18.0658C10.7794 18.2206 11.0988 18.4827 11.3235 18.819C11.5482 19.1553 11.6681 19.5507 11.6681 19.9552C11.6676 20.4974 11.452 21.0172 11.0686 21.4006C10.6852 21.784 10.1653 21.9996 9.62313 22.0002ZM9.62313 19.2442C9.48271 19.2442 9.34544 19.2858 9.22868 19.3638C9.11192 19.4418 9.02091 19.5527 8.96717 19.6825C8.91343 19.8122 8.89937 19.955 8.92677 20.0927C8.95416 20.2304 9.02179 20.3569 9.12109 20.4562C9.22038 20.5555 9.34689 20.6231 9.48461 20.6505C9.62234 20.6779 9.7651 20.6638 9.89483 20.6101C10.0246 20.5564 10.1355 20.4654 10.2135 20.3486C10.2915 20.2318 10.3331 20.0946 10.3331 19.9542C10.3329 19.7659 10.258 19.5855 10.1249 19.4524C9.9918 19.3193 9.81136 19.2444 9.62313 19.2442Z" fill="currentColor"></path><path d="M17.8907 22.0002C17.4862 22.0002 17.0909 21.8802 16.7546 21.6555C16.4183 21.4308 16.1562 21.1114 16.0014 20.7377C15.8466 20.3641 15.8061 19.9529 15.885 19.5562C15.9639 19.1595 16.1587 18.7951 16.4447 18.5091C16.7307 18.2231 17.0951 18.0284 17.4918 17.9495C17.8884 17.8705 18.2996 17.911 18.6733 18.0658C19.047 18.2206 19.3664 18.4827 19.5911 18.819C19.8158 19.1553 19.9357 19.5507 19.9357 19.9552C19.9352 20.4974 19.7196 21.0172 19.3362 21.4006C18.9528 21.784 18.4329 21.9996 17.8907 22.0002ZM17.8907 19.2442C17.7503 19.2442 17.613 19.2858 17.4963 19.3638C17.3795 19.4418 17.2885 19.5527 17.2348 19.6825C17.181 19.8122 17.167 19.955 17.1944 20.0927C17.2218 20.2304 17.2894 20.3569 17.3887 20.4562C17.488 20.5555 17.6145 20.6231 17.7522 20.6505C17.8899 20.6779 18.0327 20.6638 18.1624 20.6101C18.2922 20.5564 18.4031 20.4654 18.4811 20.3486C18.5591 20.2318 18.6007 20.0946 18.6007 19.9542C18.6005 19.7659 18.5256 19.5855 18.3925 19.4524C18.2594 19.3193 18.0789 19.2444 17.8907 19.2442Z" fill="currentColor"></path><path d="M8.93653 12.3542C8.75963 12.3542 8.58998 12.284 8.46489 12.1589C8.3398 12.0338 8.26953 11.8641 8.26953 11.6872V7.55422C8.26953 7.37718 8.33985 7.2074 8.46503 7.08222C8.59021 6.95703 8.76 6.88672 8.93703 6.88672C9.11406 6.88672 9.28385 6.95703 9.40903 7.08222C9.53421 7.2074 9.60453 7.37718 9.60453 7.55422V11.6872C9.60453 11.8641 9.53426 12.0338 9.40917 12.1589C9.28408 12.284 9.11443 12.3542 8.93753 12.3542" fill="currentColor"></path><path d="M13.0654 11.6652C12.8885 11.6652 12.7189 11.595 12.5938 11.4699C12.4687 11.3448 12.3984 11.1751 12.3984 10.9982V7.55422C12.3984 7.37718 12.4688 7.2074 12.5939 7.08222C12.7191 6.95703 12.8889 6.88672 13.0659 6.88672C13.243 6.88672 13.4128 6.95703 13.538 7.08222C13.6631 7.2074 13.7335 7.37718 13.7335 7.55422V10.9982C13.7335 11.1751 13.6632 11.3448 13.5381 11.4699C13.413 11.595 13.2434 11.6652 13.0665 11.6652" fill="currentColor"></path><path d="M17.2002 10.2882C17.0233 10.2882 16.8537 10.218 16.7286 10.0929C16.6035 9.96779 16.5332 9.79813 16.5332 9.62123V7.55422C16.5332 7.37718 16.6035 7.20741 16.7287 7.08223C16.8539 6.95705 17.0237 6.88672 17.2007 6.88672C17.3778 6.88672 17.5475 6.95705 17.6727 7.08223C17.7979 7.20741 17.8682 7.37718 17.8682 7.55422V9.62123C17.8682 9.79813 17.7979 9.96779 17.6729 10.0929C17.5478 10.218 17.3771 10.2882 17.2002 10.2882Z" fill="currentColor"></path>', 7)
  ])]);
}
const Pk = /* @__PURE__ */ g(Ur, [["render", Yr]]), qr = {}, Kr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Qr(e, t) {
  return l(), s("svg", Kr, [...t[0] || (t[0] = [
    o("path", {
      d: "M6 16H5C3.61929 16 2.5 14.8807 2.5 13.5V6.5C2.5 5.11929 3.61929 4 5 4H16C17.3807 4 18.5 5.11929 18.5 6.5V8",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("rect", {
      x: "6.5",
      y: "8",
      width: "15",
      height: "12",
      rx: "2.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.5 12H21.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12 16H10",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Rk = /* @__PURE__ */ g(qr, [["render", Qr]]), Xr = {}, Jr = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function el(e, t) {
  return l(), s("svg", Jr, [...t[0] || (t[0] = [
    N('<g clip-path="url(#clip0_change)"><path d="M13.5021 1.93126C13.2013 1.90384 12.9353 2.12546 12.9079 2.42624L12.8354 3.22109C11.6061 1.29046 9.47204 0 6.99937 0C4.33934 0 1.99514 1.51818 0.831441 3.79679C0.694066 4.06577 0.800761 4.39518 1.06974 4.53255C1.33878 4.66993 1.66813 4.56326 1.80551 4.29425C2.79035 2.36586 4.76804 1.09375 6.99937 1.09375C9.03312 1.09375 10.8685 2.1528 11.92 3.81194L11.1402 3.25503C10.8944 3.07951 10.5529 3.13644 10.3773 3.3822C10.2018 3.628 10.2587 3.96952 10.5045 4.14507L12.8691 5.83384C13.2156 6.08089 13.6936 5.85473 13.7315 5.43848L13.997 2.52555C14.0245 2.22474 13.8029 1.95869 13.5021 1.93126Z" fill="currentColor"></path><path d="M12.9296 9.46788C12.6606 9.33053 12.3312 9.4372 12.1938 9.70618C11.209 11.6346 9.2313 12.9067 6.99997 12.9067C4.96622 12.9067 3.13086 11.8476 2.07938 10.1885L2.85914 10.7454C3.10494 10.9209 3.44646 10.864 3.622 10.6182C3.79752 10.3724 3.7406 10.0309 3.49483 9.85537L1.13028 8.16659C0.787962 7.92203 0.306111 8.14141 0.26783 8.56195L0.00229435 11.4749C-0.0251314 11.7757 0.19649 12.0417 0.497244 12.0691C0.798408 12.0965 1.06411 11.8747 1.09151 11.5742L1.16397 10.7793C2.39329 12.71 4.5273 14.0004 6.99997 14.0004C9.66 14.0004 12.0042 12.4823 13.1679 10.2036C13.3053 9.93466 13.1986 9.60525 12.9296 9.46788Z" fill="currentColor"></path></g><defs><clipPath id="clip0_change"><rect width="14" height="14" fill="white"></rect></clipPath></defs>', 2)
  ])]);
}
const Nk = /* @__PURE__ */ g(Xr, [["render", el]]), tl = {}, ol = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function nl(e, t) {
  return l(), s("svg", ol, [...t[0] || (t[0] = [
    o("circle", {
      cx: "20",
      cy: "20",
      r: "20",
      transform: "matrix(0 -1 -1 0 40 40)",
      fill: "#FFB71A"
    }, null, -1),
    o("path", {
      d: "M13.3334 20.6845H22.9061C23.3163 20.6845 23.5898 20.958 23.5898 21.3683C23.5898 21.7786 23.3163 22.0521 22.9061 22.0521H14.9745L16.5471 23.6247C16.8206 23.8982 16.8206 24.3085 16.5471 24.582C16.2736 24.8555 15.8633 24.8555 15.5898 24.582L12.8548 21.8469C12.6497 21.6418 12.5813 21.3683 12.718 21.0948C12.7864 20.8213 13.0599 20.6845 13.3334 20.6845Z",
      fill: "#020203"
    }, null, -1),
    o("path", {
      d: "M22.9066 15.2138C23.1117 15.2138 23.2484 15.2822 23.3852 15.419L26.1202 18.154C26.3254 18.3591 26.3937 18.6326 26.257 18.9061C26.1202 19.1797 25.9151 19.3164 25.6416 19.3164H16.0689C15.6587 19.3164 15.3852 19.0429 15.3852 18.6326C15.3852 18.2224 15.6587 17.9489 16.0689 17.9489H24.0006L22.4279 16.3762C22.1544 16.1027 22.1544 15.6925 22.4279 15.419C22.5647 15.2822 22.7014 15.2138 22.9066 15.2138Z",
      fill: "#020203"
    }, null, -1)
  ])]);
}
const Gk = /* @__PURE__ */ g(tl, [["render", nl]]), rl = {
  viewBox: "8 8 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, ll = ["fill"], sl = ["id"], il = ["stop-color"], al = ["stop-color"], Uk = /* @__PURE__ */ I({
  __name: "ChargeGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", rl, [
      o("path", {
        d: "M14.8716 9.59937C18.4066 8.97638 21.7786 11.3366 22.4019 14.8718L22.4507 15.2029C22.8752 18.6149 20.5531 21.7981 17.1294 22.4021C13.5944 23.0253 10.2227 20.6646 9.59912 17.1296C8.97585 13.5944 11.3362 10.2227 14.8716 9.59937ZM15.9995 12.8337C15.7236 12.8339 15.4996 13.0578 15.4995 13.3337V13.5056C14.7542 13.5586 14.1666 14.1785 14.1665 14.9363C14.1666 15.5945 14.6148 16.1691 15.2534 16.3298L16.5034 16.6433L16.5728 16.6667C16.7279 16.7351 16.8324 16.8909 16.8325 17.0662C16.8323 17.307 16.6366 17.5017 16.396 17.5017H16.0386C16.0259 17.5008 16.0124 17.4998 15.9995 17.4998C15.987 17.4998 15.9747 17.5008 15.9624 17.5017H15.6655C15.5062 17.5016 15.3639 17.4177 15.271 17.2654C15.1272 17.0299 14.8191 16.9558 14.5835 17.0994C14.348 17.2432 14.2739 17.5512 14.4175 17.7869C14.6427 18.1558 15.0254 18.4378 15.4995 18.4919V18.6667C15.4995 18.9428 15.7235 19.1665 15.9995 19.1667C16.2757 19.1667 16.4995 18.9429 16.4995 18.6667V18.4968C17.2438 18.4438 17.8324 17.8249 17.8325 17.0662C17.8323 16.4492 17.4386 15.9049 16.8628 15.7078L16.7456 15.6736L15.4956 15.3591C15.3022 15.3098 15.1666 15.1358 15.1665 14.9363C15.1666 14.6956 15.3622 14.4998 15.603 14.4998H16.3335C16.4922 14.4999 16.6347 14.5847 16.728 14.7371C16.8721 14.9726 17.1799 15.0461 17.4155 14.9021C17.651 14.7581 17.7254 14.4511 17.5815 14.2156C17.3566 13.8479 16.9741 13.5649 16.4995 13.5105V13.3337C16.4994 13.0577 16.2756 12.8337 15.9995 12.8337Z",
        fill: `url(#paint0_linear_4912_13381_${D(r)})`
      }, null, 8, ll),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13381_${D(r)}`,
          x1: "10.0895",
          y1: "20.8758",
          x2: "22.4982",
          y2: "13.4445",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, il),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, al)
        ], 8, sl)
      ])
    ]));
  }
}), dl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, ul = ["fill"], Wk = /* @__PURE__ */ I({
  __name: "chargeIcon",
  props: {
    focus: { type: Boolean },
    fillColor: {}
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : t.fillColor ? t.fillColor : "#7A7786";
    return (n, i) => (l(), s("svg", dl, [
      o("path", {
        id: "ic_carga",
        d: "M.8-2206a1.8,1.8,0,0,1-1.8-1.8v-8.4a1.8,1.8,0,0,1,1.554-1.781l-.173-.473a1.171,1.171,0,0,1,.038-.9,1.17,1.17,0,0,1,.665-.611l5.4-1.965a1.165,1.165,0,0,1,.4-.072,1.171,1.171,0,0,1,.5.112,1.171,1.171,0,0,1,.61.669l.361,1h2.9a1.181,1.181,0,0,1,1.179,1.18v1.051a1.79,1.79,0,0,1,1.636,1.79v1.781a1.185,1.185,0,0,1,.926,1.152v2.47a1.186,1.186,0,0,1-.926,1.152v1.843a1.8,1.8,0,0,1-1.8,1.8Zm-.673-10.2v8.4a.674.674,0,0,0,.673.674H12.278a.674.674,0,0,0,.673-.674v-1.815h-1.6a2.417,2.417,0,0,1-2.413-2.415,2.416,2.416,0,0,1,2.413-2.414h1.6v-1.754a.675.675,0,0,0-.673-.674H.8A.675.675,0,0,0,.123-2216.2Zm9.939,4.168a1.292,1.292,0,0,0,1.29,1.291h2.469a.056.056,0,0,0,.056-.055v-2.47a.056.056,0,0,0-.056-.056H11.352A1.292,1.292,0,0,0,10.062-2212.028Zm-3.024-7.009v1.044h4.278v-1.044a.056.056,0,0,0-.056-.056H7.093A.056.056,0,0,0,7.037-2219.037Zm-.171-1.835-5.4,1.965a.051.051,0,0,0-.032.028.059.059,0,0,0,0,.044l.309.842H5.913v-1.044a1.182,1.182,0,0,1,1.179-1.18h.068l-.224-.621a.055.055,0,0,0-.029-.032.07.07,0,0,0-.025,0A.046.046,0,0,0,6.867-2220.872Zm3.924,8.844a.563.563,0,0,1,.562-.562.562.562,0,0,1,.562.562.562.562,0,0,1-.562.563A.563.563,0,0,1,10.79-2212.028Z",
        transform: "translate(1 2222)",
        fill: r()
      }, null, 8, ul)
    ]));
  }
}), cl = {}, hl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function pl(e, t) {
  return l(), s("svg", hl, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.0753 2.65283C23.4851 2.75537 23.8079 3.06055 23.9393 3.46826C24.0705 3.87598 23.9861 4.31592 23.7146 4.64356L22.4872 6.12402L22.621 8.05176C22.65 8.47998 22.4631 8.88525 22.1208 9.13721C21.7777 9.38867 21.3397 9.44385 20.9474 9.28223L19.1781 8.55811L17.4078 9.28223C17.3554 9.30371 17.3024 9.32178 17.2489 9.33545C17.1498 9.36133 17.0495 9.37402 16.9497 9.37402C16.6968 9.37402 16.447 9.29297 16.2344 9.13672C15.892 8.88428 15.7052 8.479 15.7351 8.05176L15.8689 6.12402L14.6415 4.64453C14.3693 4.31592 14.2854 3.87598 14.4159 3.46826C14.5463 3.06055 14.8701 2.75537 15.2802 2.65283L17.1324 2.18555L18.144 0.546387C18.5917 -0.181152 19.7627 -0.183105 20.2114 0.546387L21.2227 2.18555L23.0753 2.65283ZM21.0207 5.93115C21.007 5.74072 21.0675 5.55273 21.1883 5.40674L22.3681 3.98633L20.5899 3.53711C20.4079 3.49121 20.2507 3.37549 20.1509 3.21387L19.1795 1.64063L18.2084 3.21387C18.1093 3.37549 17.9514 3.49023 17.7694 3.53711L15.9911 3.98633L17.1696 5.40674C17.2894 5.55273 17.3499 5.74121 17.3369 5.93115L17.2089 7.78272L18.9073 7.08691C18.9599 7.06543 19.0141 7.05029 19.0693 7.04199C19.1057 7.03613 19.1424 7.0332 19.1788 7.0332C19.2706 7.0332 19.3632 7.05127 19.4503 7.08691L21.1494 7.78272L21.0207 5.93115Z",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      d: "M20.0212 10.46C19.621 10.46 19.2964 10.7891 19.2964 11.1943V17.1304C19.2964 18.2412 18.4042 19.145 17.3072 19.145H12.4589C12.3018 19.145 12.1489 19.1963 12.0233 19.2925L7.83705 22.4805C7.73073 22.5615 7.63068 22.5278 7.58077 22.5C7.55449 22.4868 7.51954 22.4629 7.49229 22.4248C7.46674 22.3896 7.44793 22.3418 7.44962 22.2783L7.53014 19.9053C7.53665 19.7061 7.46336 19.5127 7.32715 19.3701C7.19117 19.2266 7.00264 19.146 6.80616 19.146H3.43888C2.34193 19.146 1.44966 18.2432 1.44966 17.1313V7.42627C1.44966 6.31152 2.34193 5.4043 3.43888 5.4043H12.3702C12.7707 5.4043 13.0952 5.07568 13.0952 4.67041C13.0952 4.47119 13.0168 4.29053 12.8895 4.1582C12.7994 4.06445 12.6848 3.99512 12.5561 3.96094C12.4968 3.94482 12.4346 3.93652 12.3702 3.93652H3.43888C1.54296 3.93652 0 5.50244 0 7.42725V17.1313C0 19.0513 1.54296 20.6147 3.43888 20.6147H6.05541L6.00068 22.231C5.98959 22.6167 6.10242 22.9819 6.31337 23.2803C6.4655 23.4956 6.6685 23.6763 6.91248 23.8042C7.16128 23.9355 7.42937 24 7.69529 24C7.90407 24 8.11165 23.96 8.30838 23.8813C8.44773 23.8252 8.58177 23.75 8.70665 23.6558L12.7005 20.6147H17.3063C19.2022 20.6147 20.7451 19.0522 20.7451 17.1313V11.1948C20.7456 10.957 20.6342 10.7451 20.4611 10.6108C20.3392 10.5161 20.1868 10.46 20.0212 10.46Z",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      d: "M14.5207 9.68555C14.6888 9.68555 14.8433 9.74365 14.9663 9.84082C15.1362 9.9751 15.2454 10.1841 15.2454 10.4194C15.2454 10.8247 14.9209 11.1533 14.5207 11.1533H6.54747C6.14726 11.1533 5.82276 10.8247 5.82276 10.4194C5.82276 10.3394 5.83554 10.2622 5.85892 10.1899C5.88882 10.0981 5.93607 10.0137 5.99707 9.94189C6.06891 9.85693 6.15956 9.78906 6.2625 9.74463C6.35002 9.70654 6.44645 9.68555 6.54747 9.68555H14.5207Z",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      d: "M5.82107 14.126C5.82107 13.7207 6.14558 13.3921 6.54578 13.3921H10.7733C11.1735 13.3921 11.498 13.7207 11.498 14.126C11.498 14.5312 11.1735 14.8599 10.7733 14.8599H6.54578C6.14558 14.8599 5.82107 14.5312 5.82107 14.126Z",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const Yk = /* @__PURE__ */ g(cl, [["render", pl]]), qk = /* @__PURE__ */ I({
  __name: "MessageOutlineIcon",
  props: {
    active: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = f(
      () => t.color != null && t.color !== "" ? { color: t.color } : void 0
    );
    return (n, i) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      class: "block h-5 w-5 shrink-0",
      "aria-hidden": "true",
      style: a1(r.value)
    }, [...i[0] || (i[0] = [
      o("path", {
        d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M8 9h8",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M8 13h6",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])], 4));
  }
}), fl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.231",
  height: "10.435",
  viewBox: "0 0 14.231 10.435"
}, Cl = ["fill"], Kk = /* @__PURE__ */ I({
  __name: "CheckIcon",
  props: {
    fill: {
      type: String,
      default: "#000ec6"
    }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", fl, [
      o("path", {
        id: "Path_882",
        d: "M102.171,157.14a2.259,2.259,0,0,1-1.607-.669l-2.857-2.852a1.435,1.435,0,0,1,0-2.029h0a1.435,1.435,0,0,1,2.029,0l2.435,2.434,6.9-6.9a1.435,1.435,0,0,1,2.029,0h0a1.435,1.435,0,0,1,0,2.029h0l-7.321,7.321A2.257,2.257,0,0,1,102.171,157.14Z",
        transform: "translate(-97.286 -146.705)",
        fill: e.fill
      }, null, 8, Cl)
    ]));
  }
}), gl = {}, vl = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ml(e, t) {
  return l(), s("svg", vl, [...t[0] || (t[0] = [
    o("path", {
      d: "M6.25 10.4167L8.75 12.9167L13.75 7.08333",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "10",
      cy: "10",
      r: "7.5",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1)
  ])]);
}
const Qk = /* @__PURE__ */ g(gl, [["render", ml]]), xl = {}, wl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function kl(e, t) {
  return l(), s("svg", wl, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
    }, null, -1)
  ])]);
}
const Xk = /* @__PURE__ */ g(xl, [["render", kl]]), yl = {}, bl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function _l(e, t) {
  return l(), s("svg", bl, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Ml = /* @__PURE__ */ g(yl, [["render", _l]]), Ll = {}, $l = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Vl(e, t) {
  return l(), s("svg", $l, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 16L14 12L10 8",
      stroke: "#5763FF",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Jk = /* @__PURE__ */ g(Ll, [["render", Vl]]), Bl = {}, Hl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function Fl(e, t) {
  return l(), s("svg", Hl, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Al = /* @__PURE__ */ g(Bl, [["render", Fl]]), jl = {}, Il = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Zl(e, t) {
  return l(), s("svg", Il, [...t[0] || (t[0] = [
    N('<path d="M5.625 6.875H2.5V3.75" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.22253 16.6016C6.97253 17.0357 7.80337 17.3432 8.68837 17.4982" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.90161 12.6445C3.20661 13.4812 3.64828 14.2504 4.20994 14.9195" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.3116 17.4982C12.1966 17.3432 13.0266 17.0357 13.7775 16.6016" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.79 14.9195C16.3517 14.2504 16.7934 13.4812 17.0984 12.6445" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5 10C17.5 5.8575 14.1425 2.5 10 2.5C6.97502 2.5 4.37419 4.295 3.18835 6.875" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const ey = /* @__PURE__ */ g(jl, [["render", Zl]]), El = {}, Sl = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zl(e, t) {
  return l(), s("svg", Sl, [...t[0] || (t[0] = [
    N('<path d="M15.8332 5.41667H4.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.4165 9.58301H4.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.33317 13.7497H4.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.5 11.667L14.857 14.024" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.857 11.667L12.5 14.024" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const ty = /* @__PURE__ */ g(El, [["render", zl]]), Dl = {}, Tl = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ol(e, t) {
  return l(), s("svg", Tl, [...t[0] || (t[0] = [
    N('<path d="M10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.43757 17.0409C6.60757 16.7384 5.84424 16.3001 5.18091 15.7434" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.18091 4.25673C5.84424 3.69923 6.60757 3.2609 7.43757 2.95923" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.62012 8.69828C2.77428 7.82078 3.07928 6.99661 3.50928 6.25244" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.62012 11.3008C2.77428 12.1783 3.07928 13.0024 3.50928 13.7466" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.76489 6.65503V10.5309L12.8116 12.3884" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const oy = /* @__PURE__ */ g(Dl, [["render", Ol]]), Pl = {}, Rl = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Nl(e, t) {
  return l(), s("svg", Rl, [...t[0] || (t[0] = [
    N('<path d="M5.3125 10L3.4375 11.875L1.5625 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.4375 10C3.4375 10.5783 3.50917 11.1383 3.63333 11.6792" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.4375 10C18.4375 5.8575 15.08 2.5 10.9375 2.5C6.795 2.5 3.4375 5.8575 3.4375 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.9375 17.5C15.08 17.5 18.4375 14.1425 18.4375 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.795 14.2958C6.15083 16.2317 8.39417 17.5 10.9375 17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.7467 12.3925L10.7033 10.5817V6.65417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const ny = /* @__PURE__ */ g(Pl, [["render", Nl]]), Gl = {}, Ul = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
};
function Wl(e, t) {
  return l(), s("svg", Ul, [...t[0] || (t[0] = [
    o("path", {
      d: "M16.0663 12.1193H11.4143",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "12.0168",
      cy: "11.5164",
      r: "9.00375",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.4144 12.1192V6.51465",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ry = /* @__PURE__ */ g(Gl, [["render", Wl]]), Yl = /* @__PURE__ */ I({
  __name: "CloseIcon",
  props: {
    className: {}
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      class: v(e.className),
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [...r[0] || (r[0] = [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      }, null, -1)
    ])], 2));
  }
}), ql = {}, Kl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ql(e, t) {
  return l(), s("svg", Kl, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.97124 2.04691C9.14198 2.21644 8.32053 2.49322 7.52528 2.8835C7.13877 3.07319 6.76968 3.28417 6.41874 3.51435C4.14173 5.01538 2.5048 7.4085 2.00556 10.1961C1.90082 10.7809 1.84615 11.3831 1.84615 11.998C1.84615 13.0834 2.01646 14.1291 2.3318 15.1096C2.48057 15.57 2.66409 16.0253 2.88347 16.4723C2.97253 16.6537 3.06627 16.8314 3.1645 17.0051C4.11053 18.6708 5.51403 20.0428 7.20418 20.9502C8.16447 21.4635 9.2023 21.8203 10.2751 22.006C10.8357 22.1019 11.412 22.1519 12 22.1519C12.8717 22.1519 13.7177 22.042 14.525 21.8354C15.1846 21.6653 15.8368 21.4259 16.4722 21.1141C16.8597 20.9239 17.2294 20.7126 17.5807 20.4821C20.3357 18.6662 22.1538 15.5444 22.1538 11.998C22.1538 11.1566 22.0517 10.3401 21.8594 9.5599C21.8541 9.54316 21.8493 9.52618 21.8449 9.50896C21.6744 8.83777 21.4321 8.17332 21.1141 7.52531C19.4898 4.21559 16.3037 2.18356 12.8809 1.88183C12.5908 1.85692 12.297 1.8442 12 1.8442C11.3052 1.8442 10.6268 1.91398 9.97124 2.04691ZM14.5571 0.274183C18.0079 1.02949 21.0941 3.29435 22.7714 6.71194C23.0405 7.26041 23.2642 7.81995 23.4436 8.38613C23.453 8.40943 23.4614 8.43331 23.4689 8.45772C23.8144 9.57799 24 10.7672 24 11.998C24 15.4146 22.5722 18.4976 20.2808 20.683C20.2647 20.7008 20.2477 20.7181 20.2299 20.7349C19.7575 21.1797 19.2446 21.5898 18.6935 21.9593C17.5648 22.7192 16.3 23.2924 14.9433 23.6345C13.3072 24.0502 11.6338 24.1059 10.0254 23.8364C8.67261 23.6124 7.39617 23.1622 6.23631 22.5258C4.37348 21.5082 2.76369 19.9888 1.63252 18.0447C1.16918 17.252 0.79415 16.4013 0.520941 15.5063C-0.0432449 13.6681 -0.1421 11.7671 0.173863 9.95125C0.419476 8.52203 0.917872 7.17921 1.62137 5.97049C2.5328 4.39819 3.80868 3.01895 5.40077 1.97396C6.6419 1.15523 8.04407 0.560811 9.54954 0.248446C10.7554 -0.00379781 11.9758 -0.0638518 13.1703 0.0544478C13.6152 0.0975488 14.0533 0.164977 14.4831 0.255438C14.5082 0.260727 14.5329 0.266991 14.5571 0.274183ZM12 3.69035C12.5098 3.69035 12.9231 4.10363 12.9231 4.61343V6.17936H12.9561C14.8496 6.17936 16.3846 7.71439 16.3846 9.60789C16.3846 10.1178 15.9713 10.531 15.4615 10.531C14.9518 10.531 14.5385 10.1178 14.5385 9.60789C14.5385 8.734 13.83 8.02552 12.9561 8.02552H12.9231V11.0915H13.022C14.8791 11.0915 16.3846 12.5969 16.3846 14.454C16.3846 16.3113 14.8791 17.8168 13.022 17.8168H12.9231V19.3827C12.9231 19.8924 12.5098 20.3057 12 20.3057C11.4902 20.3057 11.0769 19.8924 11.0769 19.3827V17.8168H10.978C9.12089 17.8168 7.61538 16.3113 7.61538 14.454C7.61538 13.9443 8.02866 13.531 8.53846 13.531C9.04826 13.531 9.46154 13.9443 9.46154 14.454C9.46154 15.2916 10.1404 15.9706 10.978 15.9706H11.0769V12.9376H10.9945C9.12827 12.9376 7.61538 11.4248 7.61538 9.55854C7.61538 7.69225 9.12827 6.17936 10.9945 6.17936H11.0769V4.61343C11.0769 4.10363 11.4902 3.69035 12 3.69035ZM11.0769 8.02552H10.9945C10.1478 8.02552 9.46154 8.71186 9.46154 9.55854C9.46154 10.4051 10.1478 11.0915 10.9945 11.0915H11.0769V8.02552ZM12.9231 12.9376V15.9706H13.022C13.8594 15.9706 14.5385 15.2916 14.5385 14.454C14.5385 13.6165 13.8596 12.9376 13.022 12.9376H12.9231Z",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const ly = /* @__PURE__ */ g(ql, [["render", Ql]]), Xl = {}, Jl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "32",
  viewBox: "0 0 12.955 16"
};
function e7(e, t) {
  return l(), s("svg", Jl, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_colaboradores",
      d: "M11.42-2205.8a.735.735,0,0,1-.734-.735c0-3.131-2.247-5.677-5.009-5.677s-5.009,2.547-5.009,5.677a.735.735,0,0,1-.734.735.735.735,0,0,1-.735-.735c0-3.94,2.906-7.146,6.477-7.146s6.477,3.206,6.477,7.146A.735.735,0,0,1,11.42-2205.8Zm-5.743-8.787a3.615,3.615,0,0,1-3.606-3.606,3.61,3.61,0,0,1,3.606-3.607,3.61,3.61,0,0,1,3.606,3.607A3.61,3.61,0,0,1,5.677-2214.586Zm0-5.745a2.144,2.144,0,0,0-2.137,2.137,2.139,2.139,0,0,0,2.137,2.136,2.139,2.139,0,0,0,2.136-2.136A2.139,2.139,0,0,0,5.677-2220.331Z",
      transform: "translate(0.8 2221.8)",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const sy = /* @__PURE__ */ g(Xl, [["render", e7]]), t7 = {}, o7 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n7(e, t) {
  return l(), s("svg", o7, [...t[0] || (t[0] = [
    o("path", {
      d: "M32 0H8C3.58172 0 0 3.58172 0 8V32C0 36.4183 3.58172 40 8 40H32C36.4183 40 40 36.4183 40 32V8C40 3.58172 36.4183 0 32 0Z",
      fill: "white"
    }, null, -1),
    o("path", {
      d: "M32 0.5H8C3.85786 0.5 0.5 3.85786 0.5 8V32C0.5 36.1421 3.85786 39.5 8 39.5H32C36.1421 39.5 39.5 36.1421 39.5 32V8C39.5 3.85786 36.1421 0.5 32 0.5Z",
      stroke: "#EEEFF1"
    }, null, -1),
    o("path", {
      d: "M25.2974 27.3792C25.1178 27.3789 24.9456 27.3073 24.8187 27.1802C24.6917 27.0531 24.6204 26.8808 24.6204 26.7012C24.6204 23.8132 22.5474 21.4631 19.9994 21.4631C17.4514 21.4631 15.3784 23.8132 15.3784 26.7012C15.3784 26.8808 15.3071 27.0531 15.1802 27.1802C15.0533 27.3073 14.8811 27.3789 14.7014 27.3792C14.5217 27.3789 14.3494 27.3075 14.2223 27.1804C14.0952 27.0533 14.0237 26.8809 14.0234 26.7012C14.0234 23.0662 16.7044 20.1091 19.9994 20.1091C23.2944 20.1091 25.9754 23.0662 25.9754 26.7012C25.9752 26.8809 25.9037 27.0533 25.7766 27.1804C25.6495 27.3075 25.4772 27.3789 25.2974 27.3792ZM19.9974 19.2732C19.1159 19.2708 18.2711 18.9196 17.6479 18.2961C17.0246 17.6727 16.6735 16.8278 16.6714 15.9463C16.6722 15.0643 17.0229 14.2187 17.6464 13.595C18.27 12.9712 19.1155 12.6202 19.9974 12.6191C20.8794 12.6202 21.7249 12.9712 22.3485 13.595C22.972 14.2187 23.3226 15.0643 23.3234 15.9463C23.3224 16.8278 22.9719 17.673 22.3489 18.2966C21.7258 18.9202 20.881 19.2713 19.9994 19.2732H19.9974ZM19.9974 13.9731C19.4749 13.9747 18.9743 14.183 18.6048 14.5525C18.2353 14.922 18.027 15.4228 18.0254 15.9453C18.026 16.4681 18.2339 16.9691 18.6037 17.3386C18.9734 17.7082 19.4747 17.916 19.9974 17.9163C20.52 17.9157 21.021 17.7079 21.3906 17.3384C21.7601 16.9689 21.9679 16.4679 21.9684 15.9453C21.9679 15.423 21.7604 14.9221 21.3913 14.5525C21.0223 14.1829 20.5218 13.9745 19.9994 13.9731H19.9974Z",
      fill: "#020203"
    }, null, -1)
  ])]);
}
const iy = /* @__PURE__ */ g(t7, [["render", n7]]), r7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.955",
  height: "16",
  viewBox: "0 0 12.955 16"
}, l7 = ["fill"], ay = /* @__PURE__ */ I({
  __name: "collaboratorsIcon",
  props: {
    focus: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = () => t.color ? t.color : t.focus ? "#0012FA" : "#7A7786";
    return (n, i) => (l(), s("svg", r7, [
      o("path", {
        id: "ic_colaboradores",
        d: "M11.42-2205.8a.735.735,0,0,1-.734-.735c0-3.131-2.247-5.677-5.009-5.677s-5.009,2.547-5.009,5.677a.735.735,0,0,1-.734.735.735.735,0,0,1-.735-.735c0-3.94,2.906-7.146,6.477-7.146s6.477,3.206,6.477,7.146A.735.735,0,0,1,11.42-2205.8Zm-5.743-8.787a3.615,3.615,0,0,1-3.606-3.606,3.61,3.61,0,0,1,3.606-3.607,3.61,3.61,0,0,1,3.606,3.607A3.61,3.61,0,0,1,5.677-2214.586Zm0-5.745a2.144,2.144,0,0,0-2.137,2.137,2.139,2.139,0,0,0,2.137,2.136,2.139,2.139,0,0,0,2.136-2.136A2.139,2.139,0,0,0,5.677-2220.331Z",
        transform: "translate(0.8 2221.8)",
        fill: r()
      }, null, 8, l7)
    ]));
  }
}), s7 = {}, i7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor"
};
function a7(e, t) {
  return l(), s("svg", i7, [...t[0] || (t[0] = [
    o("path", { d: "M15 4a1 1 0 1 0 0 2V4zm0 11v-1a1 1 0 0 0-1 1h1zm0 4l-.707.707A1 1 0 0 0 16 19h-1zm-4-4l.707-.707A1 1 0 0 0 11 14v1zm-4.707-1.293a1 1 0 0 0-1.414 1.414l1.414-1.414zm-.707.707l-.707-.707.707.707zM9 11v-1a1 1 0 0 0-.707.293L9 11zm-4 0h1a1 1 0 0 0-1-1v1zm0 4H4a1 1 0 0 0 1.707.707L5 15zm10-9h2V4h-2v2zm2 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2zm1 1v6h2V7h-2zm0 6a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2zm-1 1h-2v2h2v-2zm-3 1v4h2v-4h-2zm1.707 3.293l-4-4-1.414 1.414 4 4 1.414-1.414zM11 14H7v2h4v-2zm-4 0c-.276 0-.525-.111-.707-.293l-1.414 1.414C5.42 15.663 6.172 16 7 16v-2zm-.707 1.121l3.414-3.414-1.414-1.414-3.414 3.414 1.414 1.414zM9 12h4v-2H9v2zm4 0a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2zm3-3V3h-2v6h2zm0-6a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2zm-3-3H3v2h10V0zM3 0a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V0zM0 3v6h2V3H0zm0 6a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1H0zm3 3h2v-2H3v2zm1-1v4h2v-4H4zm1.707 4.707l.586-.586-1.414-1.414-.586.586 1.414 1.414z" }, null, -1)
  ])]);
}
const dy = /* @__PURE__ */ g(s7, [["render", a7]]), d7 = {}, u7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function c7(e, t) {
  return l(), s("svg", u7, [...t[0] || (t[0] = [
    o("path", {
      d: "M10.6667 12H12.0001C12.7365 12 13.3334 11.403 13.3334 10.6667V3.33333C13.3334 2.59695 12.7365 2 12.0001 2H6.00008C5.2637 2 4.66675 2.59695 4.66675 3.33333V4.66667",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.2396 6.31369L9.01981 5.09388C8.74632 4.82039 8.37539 4.66675 7.98861 4.66675H4.00008C3.2637 4.66675 2.66675 5.2637 2.66675 6.00008V12.6667C2.66675 13.4031 3.2637 14.0001 4.00008 14.0001H9.33341C10.0698 14.0001 10.6667 13.4031 10.6667 12.6667V7.34488C10.6667 6.95811 10.5131 6.58718 10.2396 6.31369Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.6667 7.66675H8.66675C8.11446 7.66675 7.66675 7.21903 7.66675 6.66675V4.66675",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const uy = /* @__PURE__ */ g(d7, [["render", c7]]), h7 = {}, p7 = {
  class: "w-5 h-5",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function f7(e, t) {
  return l(), s("svg", p7, [...t[0] || (t[0] = [
    o("path", {
      d: "M10.6667 12H12.0001C12.7365 12 13.3334 11.403 13.3334 10.6667V3.33333C13.3334 2.59695 12.7365 2 12.0001 2H6.00008C5.2637 2 4.66675 2.59695 4.66675 3.33333V4.66667",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.2396 6.31344L9.01981 5.09364C8.74632 4.82015 8.37539 4.6665 7.98861 4.6665H4.00008C3.2637 4.6665 2.66675 5.26346 2.66675 5.99984V12.6665C2.66675 13.4029 3.2637 13.9998 4.00008 13.9998H9.33341C10.0698 13.9998 10.6667 13.4029 10.6667 12.6665V7.34464C10.6667 6.95786 10.5131 6.58693 10.2396 6.31344Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.6667 7.6665H8.66675C8.11446 7.6665 7.66675 7.21879 7.66675 6.6665V4.6665",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const cy = /* @__PURE__ */ g(h7, [["render", f7]]), C7 = ["width", "height"], g7 = ["stroke"], v7 = ["stroke"], m7 = ["stroke"], x7 = ["stroke"], w7 = ["stroke"], k7 = ["stroke"], hy = /* @__PURE__ */ I({
  __name: "CreditCardAddIcon",
  props: {
    size: { default: 20 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.size,
      height: e.size,
      viewBox: "0 0 20 20",
      fill: "none"
    }, [
      o("path", {
        d: "M2.5 6.66667H17.5",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, g7),
      o("path", {
        d: "M7.49976 10.0007H5.39893",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, v7),
      o("path", {
        d: "M8.33333 15.0007H5C3.61929 15.0007 2.5 13.8814 2.5 12.5007V5.83398C2.5 4.45327 3.61929 3.33398 5 3.33398H15C16.3807 3.33398 17.5 4.45327 17.5 5.83398V8.33398",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, m7),
      o("circle", {
        cx: "14.5835",
        cy: "13.75",
        r: "3.75",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, x7),
      o("path", {
        d: "M15.7554 13.7507H13.4116",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, w7),
      o("path", {
        d: "M14.5832 12.5781V14.9219",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, k7)
    ], 8, C7));
  }
}), y7 = ["width", "height"], b7 = ["stroke"], _7 = ["stroke"], M7 = ["stroke"], py = /* @__PURE__ */ I({
  __name: "CreditCardIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("rect", {
        x: "2",
        y: "5",
        width: "20",
        height: "14",
        rx: "2",
        stroke: e.color,
        "stroke-width": "1.5"
      }, null, 8, b7),
      o("path", {
        d: "M2 10H22",
        stroke: e.color,
        "stroke-width": "1.5"
      }, null, 8, _7),
      o("path", {
        d: "M6 15H10",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, M7)
    ], 8, y7));
  }
}), L7 = ["width", "height"], $7 = ["stroke"], V7 = ["stroke"], B7 = ["stroke"], H7 = ["stroke"], F7 = ["stroke"], fy = /* @__PURE__ */ I({
  __name: "CreditCardSearchIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M3 8H21",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, $7),
      o("path", {
        d: "M7 12.9102H10",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, V7),
      o("path", {
        d: "M11 17H5C3.895 17 3 16.105 3 15V6C3 4.895 3.895 4 5 4H19C20.105 4 21 4.895 21 6V11",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, B7),
      o("path", {
        d: "M20.12 14.879C21.292 16.051 21.292 17.95 20.12 19.122C18.948 20.294 17.049 20.294 15.877 19.122C14.705 17.95 14.705 16.051 15.877 14.879C17.049 13.707 18.949 13.707 20.12 14.879",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, H7),
      o("path", {
        d: "M22.0001 21.0001L20.1211 19.1221",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, F7)
    ], 8, L7));
  }
}), A7 = {}, j7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 20 24"
};
function I7(e, t) {
  return l(), s("svg", j7, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_history_report",
      d: "M115.991,73a.992.992,0,0,0-.284-.707l-8-8a.989.989,0,0,0-.707-.285V64h-6a5.006,5.006,0,0,0-5,5V83a5.006,5.006,0,0,0,5,5h10a5.006,5.006,0,0,0,5-5V73ZM108,67.414,112.586,72H111a3,3,0,0,1-3-3ZM111,86H101a3,3,0,0,1-3-3V69a3,3,0,0,1,3-3h5v3a5.006,5.006,0,0,0,5,5h3v9A3,3,0,0,1,111,86Zm0-3.625a1,1,0,0,1-1,1h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,111,82.375Zm-10-4a1,1,0,0,1,1-1h2a1,1,0,0,1,0,2h-2A1,1,0,0,1,101,78.375Z",
      transform: "translate(-96 -64)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const Cy = /* @__PURE__ */ g(A7, [["render", I7]]), Z7 = {}, E7 = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function S7(e, t) {
  return l(), s("svg", E7, [...t[0] || (t[0] = [
    N('<g filter="url(#filter0_d_4239_79618)"><rect x="1.11401" y="1.13672" width="23.0476" height="29.7931" rx="4.6581" fill="white"></rect><rect x="1.02613" y="1.04883" width="23.2234" height="29.9689" rx="4.74599" stroke="#F2F3F7" stroke-width="0.175777"></rect></g><rect x="9.42847" y="22.0703" width="12.5714" height="6.62069" rx="1.74182" fill="#20A569"></rect><path d="M11.5249 26.8773V26.3771H11.9594V26.8773H11.5249Z" fill="#F9F9FB"></path><path d="M13.5085 26.9339C12.7917 26.9339 12.2496 26.363 12.2496 25.6033C12.2496 24.8436 12.7917 24.2773 13.5085 24.2773C14.0864 24.2773 14.5388 24.636 14.6867 25.1928H14.3059C14.167 24.8625 13.8669 24.6643 13.5085 24.6643C13.0112 24.6643 12.6394 25.0748 12.6394 25.6033C12.6394 26.1365 13.0157 26.547 13.5085 26.547C13.8624 26.547 14.158 26.3488 14.3059 26.0091H14.6912C14.5433 26.5706 14.0819 26.9339 13.5085 26.9339Z" fill="#F9F9FB"></path><path d="M15.852 26.9339C15.2785 26.9339 14.9067 26.6131 14.8843 26.0987H15.2606C15.2785 26.4007 15.5249 26.5659 15.8654 26.5659C16.1969 26.5659 16.4343 26.4149 16.4343 26.1695C16.4343 25.8675 16.1342 25.8109 15.8072 25.7543C15.395 25.6788 14.9291 25.5891 14.9291 25.0134C14.9291 24.5746 15.2965 24.2773 15.843 24.2773C16.3895 24.2773 16.739 24.5841 16.7524 25.0654H16.394C16.3806 24.787 16.1745 24.636 15.834 24.636C15.507 24.636 15.3009 24.7775 15.3009 24.9993C15.3009 25.2683 15.5787 25.3202 15.9012 25.3721C16.3179 25.4428 16.8107 25.5278 16.8107 26.1506C16.8107 26.6272 16.4254 26.9339 15.852 26.9339Z" fill="#F9F9FB"></path><path d="M18.8851 24.3292H19.2749L18.258 26.8773H17.9085L16.8647 24.3292H17.259L18.0833 26.3582L18.8851 24.3292Z" fill="#F9F9FB"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.9514 18.6052C20.9514 19.2995 20.3885 19.8623 19.6942 19.8623H5.4466C4.75229 19.8623 4.18945 19.2995 4.18945 18.6052L4.18945 5.67121C4.18945 4.9769 4.7523 4.41406 5.4466 4.41406L19.6942 4.41406C20.3885 4.41406 20.9514 4.9769 20.9514 5.67121V18.6052ZM5.23707 18.4446C5.23707 18.6182 5.37778 18.7589 5.55136 18.7589H7.01802C7.1916 18.7589 7.33231 18.6182 7.33231 18.4446L7.33231 16.8663C7.33231 16.6927 7.1916 16.552 7.01802 16.552H5.55136C5.37778 16.552 5.23707 16.6927 5.23707 16.8663V18.4446ZM8.37993 18.4446C8.37993 18.6182 8.52064 18.7589 8.69421 18.7589H10.1609C10.3345 18.7589 10.4752 18.6182 10.4752 18.4446V16.8663C10.4752 16.6927 10.3345 16.552 10.1609 16.552H8.69421C8.52064 16.552 8.37993 16.6927 8.37993 16.8663V18.4446ZM11.5228 18.4446C11.5228 18.6182 11.6635 18.7589 11.8371 18.7589H13.3037C13.4773 18.7589 13.618 18.6182 13.618 18.4446V16.8663C13.618 16.6927 13.4773 16.552 13.3037 16.552H11.8371C11.6635 16.552 11.5228 16.6927 11.5228 16.8663V18.4446ZM14.6656 18.4446C14.6656 18.6182 14.8064 18.7589 14.9799 18.7589H16.4466C16.6202 18.7589 16.7609 18.6182 16.7609 18.4446V16.8663C16.7609 16.6927 16.6202 16.552 16.4466 16.552H14.9799C14.8064 16.552 14.6656 16.6927 14.6656 16.8663V18.4446ZM17.8085 18.4446C17.8085 18.6182 17.9492 18.7589 18.1228 18.7589H19.5895C19.763 18.7589 19.9037 18.6182 19.9037 18.4446V16.8663C19.9037 16.6927 19.763 16.552 19.5895 16.552H18.1228C17.9492 16.552 17.8085 16.6927 17.8085 16.8663V18.4446ZM5.23707 15.1343C5.23707 15.3078 5.37778 15.4485 5.55136 15.4485H7.01802C7.1916 15.4485 7.33231 15.3078 7.33231 15.1343V13.5559C7.33231 13.3824 7.1916 13.2416 7.01802 13.2416H5.55136C5.37778 13.2416 5.23707 13.3824 5.23707 13.5559L5.23707 15.1343ZM8.37993 15.1343C8.37993 15.3078 8.52064 15.4485 8.69421 15.4485H10.1609C10.3345 15.4485 10.4752 15.3078 10.4752 15.1343V13.5559C10.4752 13.3824 10.3345 13.2416 10.1609 13.2416H8.69421C8.52064 13.2416 8.37993 13.3824 8.37993 13.5559V15.1343ZM11.5228 15.1343C11.5228 15.3078 11.6635 15.4485 11.8371 15.4485H13.3037C13.4773 15.4485 13.618 15.3078 13.618 15.1343V13.5559C13.618 13.3824 13.4773 13.2416 13.3037 13.2416H11.8371C11.6635 13.2416 11.5228 13.3824 11.5228 13.5559V15.1343ZM14.6656 15.1343C14.6656 15.3078 14.8064 15.4485 14.9799 15.4485H16.4466C16.6202 15.4485 16.7609 15.3078 16.7609 15.1343V13.5559C16.7609 13.3824 16.6202 13.2416 16.4466 13.2416H14.9799C14.8064 13.2416 14.6656 13.3824 14.6656 13.5559V15.1343ZM17.8085 15.1343C17.8085 15.3078 17.9492 15.4485 18.1228 15.4485L19.5895 15.4485C19.763 15.4485 19.9037 15.3078 19.9037 15.1343V13.5559C19.9037 13.3824 19.763 13.2416 19.5895 13.2416L18.1228 13.2416C17.9492 13.2416 17.8085 13.3824 17.8085 13.5559V15.1343ZM5.23707 11.8239C5.23707 11.9975 5.37778 12.1382 5.55136 12.1382H7.01802C7.1916 12.1382 7.33231 11.9975 7.33231 11.8239V10.2456C7.33231 10.072 7.1916 9.9313 7.01802 9.9313H5.55136C5.37778 9.9313 5.23707 10.072 5.23707 10.2456V11.8239ZM8.37993 11.8239C8.37993 11.9975 8.52064 12.1382 8.69421 12.1382H10.1609C10.3345 12.1382 10.4752 11.9975 10.4752 11.8239V10.2456C10.4752 10.072 10.3345 9.9313 10.1609 9.9313H8.69421C8.52064 9.9313 8.37993 10.072 8.37993 10.2456V11.8239ZM11.5228 11.8239C11.5228 11.9975 11.6635 12.1382 11.8371 12.1382H13.3037C13.4773 12.1382 13.618 11.9975 13.618 11.8239V10.2456C13.618 10.072 13.4773 9.9313 13.3037 9.9313H11.8371C11.6635 9.9313 11.5228 10.072 11.5228 10.2456V11.8239ZM14.6656 11.8239C14.6656 11.9975 14.8064 12.1382 14.9799 12.1382H16.4466C16.6202 12.1382 16.7609 11.9975 16.7609 11.8239V10.2456C16.7609 10.072 16.6202 9.9313 16.4466 9.9313H14.9799C14.8064 9.9313 14.6656 10.072 14.6656 10.2456V11.8239ZM17.8085 11.8239C17.8085 11.9975 17.9492 12.1382 18.1228 12.1382H19.5895C19.763 12.1382 19.9037 11.9975 19.9037 11.8239V10.2456C19.9037 10.072 19.763 9.9313 19.5895 9.9313H18.1228C17.9492 9.9313 17.8085 10.072 17.8085 10.2456V11.8239ZM5.55103 6.61848C5.37759 6.61866 5.23707 6.75932 5.23707 6.93277V8.51357C5.23707 8.68714 5.37778 8.82786 5.55136 8.82786H19.5895C19.763 8.82786 19.9037 8.68714 19.9037 8.51357V6.91833C19.9037 6.74463 19.7628 6.60386 19.5891 6.60404L5.55103 6.61848Z" fill="#E2E4EE"></path><defs><filter id="filter0_d_4239_79618" x="0.152518" y="0.960938" width="24.9706" height="31.716" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.785714"></feOffset><feGaussianBlur stdDeviation="0.392857"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4239_79618"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4239_79618" result="shape"></feBlend></filter></defs>', 8)
  ])]);
}
const gy = /* @__PURE__ */ g(Z7, [["render", S7]]), z7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, D7 = ["fill"], vy = /* @__PURE__ */ I({
  __name: "dashboardIcon",
  props: {
    focus: { type: Boolean }
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : "#7A7786";
    return (n, i) => (l(), s("svg", z7, [
      o("path", {
        id: "ic_dashboard",
        d: "M-17.509,998A2.5,2.5,0,0,1-20,995.527v-8.092a2.467,2.467,0,0,1,1.308-2.16L-13.2,982.3a2.519,2.519,0,0,1,1.191-.3,2.518,2.518,0,0,1,1.191.3l5.509,2.959A2.469,2.469,0,0,1-4,987.419v8.109A2.494,2.494,0,0,1-6.5,998Zm5.5-14.8a1.3,1.3,0,0,0-.609.153l-5.509,2.964a1.269,1.269,0,0,0-.661,1.117v8.093A1.278,1.278,0,0,0-17.5,996.8h11a1.278,1.278,0,0,0,1.277-1.27v-8.092a1.267,1.267,0,0,0-.671-1.118l-5.5-2.958a1.292,1.292,0,0,0-.612-.158l0-.078Zm-2.372,12.549a.6.6,0,0,1-.607-.6.6.6,0,0,1,.607-.6h4.748a.6.6,0,0,1,.607.6.6.6,0,0,1-.607.6Z",
        transform: "translate(20 -982)",
        fill: r()
      }, null, 8, D7)
    ]));
  }
}), T7 = {}, O7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20.0083 20.0083",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function P7(e, t) {
  return l(), s("svg", O7, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9566 17.5073H7.05175C6.07158 17.5073 5.25667 16.7527 5.18149 15.7754L4.37682 5.31471H15.6315L14.8268 15.7754C14.7517 16.7527 13.9368 17.5073 12.9566 17.5073V17.5073Z"></path><path d="M16.6736 5.31471H3.33472"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.65944 2.50104H12.3489C12.8669 2.50104 13.2868 2.92095 13.2868 3.43893V5.31471H6.72155V3.43893C6.72155 2.92095 7.14146 2.50104 7.65944 2.50104Z"></path><path d="M11.6455 9.06628V13.7557"></path><path d="M8.36286 9.06628V13.7557"></path>', 5)
  ])]);
}
const my = /* @__PURE__ */ g(T7, [["render", P7]]), R7 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, N7 = ["fill"], G7 = ["fill"], U7 = ["fill"], W7 = ["fill"], xy = /* @__PURE__ */ I({
  __name: "GridSquaresGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", R7, [
      o("rect", {
        x: "2",
        y: "2",
        width: "4.67",
        height: "4.67",
        rx: "1",
        fill: e.active ? "url(#dash_blue_a)" : "url(#dash_gray_a)"
      }, null, 8, N7),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.67 8.84C6.5 8.84 7.17 9.51 7.17 10.34V13C7.17 13.83 6.5 14.5 5.67 14.5H3C2.17 14.5 1.5 13.83 1.5 13V10.34C1.5 9.51 2.17 8.84 3 8.84H5.67ZM3 9.84C2.72 9.84 2.5 10.06 2.5 10.34V13C2.5 13.28 2.72 13.5 3 13.5H5.67C5.95 13.5 6.17 13.28 6.17 13V10.34C6.17 10.06 5.95 9.84 5.67 9.84H3Z",
        fill: e.active ? "url(#dash_blue_b)" : "url(#dash_gray_b)"
      }, null, 8, G7),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13 1.5C13.83 1.5 14.5 2.17 14.5 3V5.67C14.5 6.5 13.83 7.17 13 7.17H10.34C9.51 7.17 8.84 6.5 8.84 5.67V3C8.84 2.17 9.51 1.5 10.34 1.5H13ZM10.34 2.5C10.06 2.5 9.84 2.72 9.84 3V5.67C9.84 5.95 10.06 6.17 10.34 6.17H13C13.28 6.17 13.5 5.95 13.5 5.67V3C13.5 2.72 13.28 2.5 13 2.5H10.34Z",
        fill: e.active ? "url(#dash_blue_b)" : "url(#dash_gray_b)"
      }, null, 8, U7),
      o("rect", {
        x: "9.34",
        y: "9.34",
        width: "4.67",
        height: "4.67",
        rx: "1",
        fill: e.active ? "url(#dash_blue_c)" : "url(#dash_gray_c)"
      }, null, 8, W7),
      r[0] || (r[0] = N('<defs><linearGradient id="dash_blue_a" x1="2.21" y1="6.09" x2="6.67" y2="3.42" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="dash_blue_b" x1="2.09" y1="12.88" x2="14.5" y2="5.45" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="dash_blue_c" x1="9.55" y1="13.42" x2="14" y2="10.75" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="dash_gray_a" x1="2.21" y1="6.09" x2="6.67" y2="3.42" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient><linearGradient id="dash_gray_b" x1="2.09" y1="12.88" x2="14.5" y2="5.45" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient><linearGradient id="dash_gray_c" x1="9.55" y1="13.42" x2="14" y2="10.75" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Y7 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, q7 = ["fill"], wy = /* @__PURE__ */ I({
  __name: "PackageGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Y7, [
      o("path", {
        d: "M10.83 14H3.33C2.6 14 2 13.4 2 12.67V5.37H10.83V14ZM14 10C14 10.29 13.91 10.57 13.73 10.8C13.11 11.63 11.83 13.32 11.83 13.32V5.09L14 3V10ZM5.33 6.83C5.06 6.83 4.83 7.06 4.83 7.33C4.83 7.61 5.06 7.83 5.33 7.83H8C8.28 7.83 8.5 7.61 8.5 7.33C8.5 7.06 8.28 6.83 8 6.83H5.33ZM6.72 4.37H2.63C2.69 4.32 2.74 4.28 2.8 4.23L5.25 2.4C5.59 2.14 6.01 2 6.44 2H9.43L6.72 4.37ZM11.13 4.37H8.24L10.52 2.38L10.96 2H13.67L11.13 4.37Z",
        fill: e.active ? "url(#delivery_blue)" : "url(#delivery_gray)"
      }, null, 8, q7),
      r[0] || (r[0] = N('<defs><linearGradient id="delivery_blue" x1="2.55" y1="12.5" x2="14" y2="5.64" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="delivery_gray" x1="2.55" y1="12.5" x2="14" y2="5.64" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), K7 = {}, Q7 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X7(e, t) {
  return l(), s("svg", Q7, [...t[0] || (t[0] = [
    N('<path d="M12.4693 12.1962C12.882 12.6089 12.882 13.2776 12.4693 13.6896C12.0567 14.1022 11.388 14.1022 10.976 13.6896C10.5633 13.2769 10.5633 12.6082 10.976 12.1962C11.3887 11.7836 12.0573 11.7836 12.4693 12.1962" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.13608 12.196C5.54875 12.6086 5.54875 13.2773 5.13608 13.6893C4.72341 14.102 4.05475 14.102 3.64275 13.6893C3.23075 13.2766 3.23008 12.608 3.64275 12.196C4.05541 11.784 4.72341 11.7833 5.13608 12.196" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66683 2.66602H9.3335C9.7015 2.66602 10.0002 2.96468 10.0002 3.33268V9.99935H1.3335" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 4.66602H12.882C13.1547 4.66602 13.4 4.83202 13.5007 5.08535L14.5713 7.76135C14.634 7.91868 14.6667 8.08668 14.6667 8.25602V12.2213C14.6667 12.5893 14.368 12.888 14 12.888H12.7793" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.6668 12.9466H5.44678" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.6667 9.33268H12V6.66602H14.1333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.3335 2.66536H4.66683" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.3335 4.66536H3.3335" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.00016 6.66536H1.3335" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>', 9)
  ])]);
}
const ky = /* @__PURE__ */ g(K7, [["render", X7]]), J7 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, e8 = ["stroke"], t8 = ["stroke"], o8 = ["stroke"], n8 = ["stroke"], yy = /* @__PURE__ */ I({
  __name: "DigitalAccountGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", J7, [
      o("path", {
        d: "M7.99984 4V5",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        stroke: e.active ? "url(#da_p0_blue)" : "url(#da_p0_gray)"
      }, null, 8, e8),
      o("path", {
        d: "M12.2426 3.75736C14.5858 6.10051 14.5858 9.89949 12.2426 12.2426C9.89948 14.5858 6.10049 14.5858 3.75736 12.2426C1.41421 9.89948 1.41421 6.10049 3.75736 3.75736C6.10051 1.41421 9.89949 1.41421 12.2426 3.75736",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        stroke: e.active ? "url(#da_p1_blue)" : "url(#da_p1_gray)"
      }, null, 8, t8),
      o("path", {
        d: "M7.99984 12V11",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        stroke: e.active ? "url(#da_p2_blue)" : "url(#da_p2_gray)"
      }, null, 8, o8),
      o("path", {
        d: "M6 9.50333V9.50333C6 10.332 6.67133 11.0033 7.5 11.0033H8.59533C9.37067 11.0033 10 10.3747 10 9.59867V9.59867C10 8.95467 9.562 8.39333 8.93733 8.23667L7.06267 7.76667C6.438 7.61 6 7.04867 6 6.40467V6.40467C6 5.62867 6.62867 5 7.40467 5H8.5C9.32867 5 10 5.67133 10 6.5V6.5",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        stroke: e.active ? "url(#da_p3_blue)" : "url(#da_p3_gray)"
      }, null, 8, n8),
      r[0] || (r[0] = N('<defs><linearGradient id="da_p0_blue" x1="7.68183" y1="4.10714" x2="8.38671" y2="4.15162" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF"></stop><stop offset="1" stop-color="#C7CBFF"></stop></linearGradient><linearGradient id="da_p0_gray" x1="7.68183" y1="4.10714" x2="8.38671" y2="4.15162" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient><linearGradient id="da_p1_blue" x1="2.27586" y1="3.28571" x2="14.9011" y2="4.4808" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF"></stop><stop offset="1" stop-color="#C7CBFF"></stop></linearGradient><linearGradient id="da_p1_gray" x1="2.27586" y1="3.28571" x2="14.9011" y2="4.4808" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient><linearGradient id="da_p2_blue" x1="7.68183" y1="11.1071" x2="8.38671" y2="11.1516" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF"></stop><stop offset="1" stop-color="#C7CBFF"></stop></linearGradient><linearGradient id="da_p2_gray" x1="7.68183" y1="11.1071" x2="8.38671" y2="11.1516" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient><linearGradient id="da_p3_blue" x1="6.09195" y1="5.64321" x2="10.3212" y2="5.90996" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF"></stop><stop offset="1" stop-color="#C7CBFF"></stop></linearGradient><linearGradient id="da_p3_gray" x1="6.09195" y1="5.64321" x2="10.3212" y2="5.90996" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), r8 = {}, l8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17",
  fill: "currentColor"
};
function s8(e, t) {
  return l(), s("svg", l8, [...t[0] || (t[0] = [
    o("path", { d: "M11 2.253a1 1 0 1 0-2 0h2zm-2 13a1 1 0 1 0 2 0H9zm.447-12.167a1 1 0 1 0 1.107-1.666L9.447 3.086zM1 2.253L.447 1.42A1 1 0 0 0 0 2.253h1zm0 13H0a1 1 0 0 0 1.553.833L1 15.253zm8.447.833a1 1 0 1 0 1.107-1.666l-1.107 1.666zm0-14.666a1 1 0 1 0 1.107 1.666L9.447 1.42zM19 2.253h1a1 1 0 0 0-.447-.833L19 2.253zm0 13l-.553.833A1 1 0 0 0 20 15.253h-1zm-9.553-.833a1 1 0 1 0 1.107 1.666L9.447 14.42zM9 2.253v13h2v-13H9zm1.553-.833C9.203.523 7.42 0 5.5 0v2c1.572 0 2.961.431 3.947 1.086l1.107-1.666zM5.5 0C3.58 0 1.797.523.447 1.42l1.107 1.666C2.539 2.431 3.928 2 5.5 2V0zM0 2.253v13h2v-13H0zm1.553 13.833C2.539 15.431 3.928 15 5.5 15v-2c-1.92 0-3.703.523-5.053 1.42l1.107 1.666zM5.5 15c1.572 0 2.961.431 3.947 1.086l1.107-1.666C9.203 13.523 7.42 13 5.5 13v2zm5.053-11.914C11.539 2.431 12.928 2 14.5 2V0c-1.92 0-3.703.523-5.053 1.42l1.107 1.666zM14.5 2c1.573 0 2.961.431 3.947 1.086l1.107-1.666C18.203.523 16.421 0 14.5 0v2zm3.5.253v13h2v-13h-2zm1.553 12.167C18.203 13.523 16.421 13 14.5 13v2c1.573 0 2.961.431 3.947 1.086l1.107-1.666zM14.5 13c-1.92 0-3.703.523-5.053 1.42l1.107 1.666C11.539 15.431 12.928 15 14.5 15v-2z" }, null, -1)
  ])]);
}
const by = /* @__PURE__ */ g(r8, [["render", s8]]), i8 = {}, a8 = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d8(e, t) {
  return l(), s("svg", a8, [...t[0] || (t[0] = [
    N('<rect x="0.5" y="0.5" width="25" height="25" rx="5.5" fill="white"></rect><rect x="0.5" y="0.5" width="25" height="25" rx="5.5" stroke="#ECEEF3"></rect><path d="M16.0013 19.6695C14.3439 19.6695 13 18.3256 13 16.6682C13 15.0109 14.3439 13.667 16.0013 13.667C17.6593 13.667 19.0025 15.0109 19.0025 16.6682C19.0025 18.3256 17.6593 19.6695 16.0013 19.6695" stroke="#20A569" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.0023 11.6657V10.2171C17.0023 9.8636 16.8615 9.52412 16.6114 9.27402L14.7253 7.3879C14.4752 7.1378 14.1357 6.99707 13.7823 6.99707H8.99893C8.26195 6.99707 7.66504 7.59399 7.66504 8.33096V17.6682C7.66504 18.4052 8.26195 19.0021 8.99893 19.0021H11.6667" stroke="#20A569" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.0017 10.3318H14.3339C13.9658 10.3318 13.667 10.033 13.667 9.66485V6.99707" stroke="#20A569" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.1067 16.1162L15.7248 17.4981L14.8965 16.6684" stroke="#20A569" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const _y = /* @__PURE__ */ g(i8, [["render", d8]]), u8 = {}, c8 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h8(e, t) {
  return l(), s("svg", c8, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.3453 5.345L12.9887 2.98833C12.6762 2.67583 12.252 2.5 11.8103 2.5H5.83366C4.91283 2.5 4.16699 3.24583 4.16699 4.16667V15.8333C4.16699 16.7542 4.91283 17.5 5.83366 17.5H14.167C15.0878 17.5 15.8337 16.7542 15.8337 15.8333V6.52333C15.8337 6.08167 15.6578 5.6575 15.3453 5.345V5.345Z",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.8337 6.66667H12.5003C12.0403 6.66667 11.667 6.29333 11.667 5.83333V2.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.2469 9.76326C12.1168 10.6332 12.1168 12.0435 11.2469 12.9134C10.377 13.7833 8.96665 13.7833 8.09675 12.9134C7.22686 12.0435 7.22686 10.6332 8.09675 9.76326C8.96665 8.89337 10.377 8.89337 11.2469 9.76326",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5 14.1665L11.25 12.9165",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const My = /* @__PURE__ */ g(u8, [["render", h8]]), p8 = ["width", "height"], f8 = ["stroke"], C8 = ["stroke"], g8 = ["stroke"], v8 = ["stroke"], Ly = /* @__PURE__ */ I({
  __name: "DocumentWithMagnifierIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }, [
      o("rect", {
        x: "4",
        y: "2",
        width: "14",
        height: "18",
        rx: "2",
        stroke: e.color,
        "stroke-width": "1.5"
      }, null, 8, f8),
      o("path", {
        d: "M8 7h6M8 9.5h4M8 12h5",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, C8),
      o("circle", {
        cx: "10",
        cy: "15",
        r: "2",
        stroke: e.color,
        "stroke-width": "1.25"
      }, null, 8, g8),
      o("path", {
        d: "M7.5 18.5c0-1.2 1.1-2.2 2.5-2.2s2.5 1 2.5 2.2",
        stroke: e.color,
        "stroke-width": "1.25",
        "stroke-linecap": "round"
      }, null, 8, v8)
    ], 8, p8));
  }
}), m8 = {}, x8 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function w8(e, t) {
  return l(), s("svg", x8, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M15.345 5.345L12.9883 2.98833C12.6758 2.67583 12.2517 2.5 11.81 2.5H5.83333C4.9125 2.5 4.16667 3.24583 4.16667 4.16667V15.8333C4.16667 16.7542 4.9125 17.5 5.83333 17.5H14.1667C15.0875 17.5 15.8333 16.7542 15.8333 15.8333V6.52333C15.8333 6.08167 15.6575 5.6575 15.345 5.345Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.8333 6.66667H12.5C12.04 6.66667 11.6667 6.29333 11.6667 5.83333V2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 9.16667V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66667 12.0833H13.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 15H7.5C7.04 15 6.66667 14.6267 6.66667 14.1667V10C6.66667 9.54 7.04 9.16667 7.5 9.16667H12.5C12.96 9.16667 13.3333 9.54 13.3333 10V14.1667C13.3333 14.6267 12.96 15 12.5 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const $y = /* @__PURE__ */ g(m8, [["render", w8]]), k8 = {}, y8 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function b8(e, t) {
  return l(), s("svg", y8, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M15.345 5.345L12.9883 2.98833C12.6758 2.67583 12.2517 2.5 11.81 2.5H5.83333C4.9125 2.5 4.16667 3.24583 4.16667 4.16667V15.8333C4.16667 16.7542 4.9125 17.5 5.83333 17.5H14.1667C15.0875 17.5 15.8333 16.7542 15.8333 15.8333V6.52333C15.8333 6.08167 15.6575 5.6575 15.345 5.345Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.8333 6.66667H12.5C12.04 6.66667 11.6667 6.29333 11.6667 5.83333V2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66667 9.16667H11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66667 11.6667H11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66667 14.1667H10.275" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const Vy = /* @__PURE__ */ g(k8, [["render", b8]]), _8 = {}, M8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function L8(e, t) {
  return l(), s("svg", M8, [...t[0] || (t[0] = [
    o("path", {
      d: "M0 11.9775C0.00180273 10.8951 0.149979 9.81833 0.441048 8.77588C0.496358 8.59641 0.619202 8.4454 0.783686 8.35484C0.948171 8.26429 1.14197 8.24091 1.32314 8.29018C1.50432 8.33945 1.65885 8.45714 1.75485 8.61853C1.85086 8.77992 1.88061 8.97247 1.83746 9.15524C1.12507 11.6853 1.37385 14.3892 2.53567 16.7468C3.69749 19.1044 5.68989 20.9491 8.12994 21.9249C10.57 22.9007 13.2847 22.9385 15.7513 22.0319C18.2179 21.1254 20.2621 19.3379 21.49 17.014C22.7178 14.6901 23.0423 11.9946 22.4015 9.44551C21.7607 6.8964 20.1997 4.6743 18.019 3.20761C15.8384 1.74092 13.1928 1.1331 10.5909 1.5012C7.98896 1.86931 5.61481 3.18734 3.92633 5.20141L4.39755 5.16477C4.49355 5.15304 4.59053 5.1609 4.68344 5.18776C4.77636 5.21461 4.86278 5.25954 4.93773 5.32068C5.01268 5.38181 5.07447 5.45778 5.11946 5.54341C5.16446 5.62904 5.19208 5.72289 5.19991 5.81931C5.20775 5.91573 5.19601 6.01277 5.16543 6.10455C5.13486 6.19632 5.08587 6.2807 5.02177 6.35314C4.95767 6.42558 4.87927 6.48478 4.79191 6.5263C4.70455 6.56781 4.60984 6.59061 4.5132 6.59455L2.24187 6.77705H2.18441C2.01287 6.77663 1.84709 6.71666 1.71535 6.60677C1.64295 6.54614 1.58351 6.47149 1.54008 6.38763C1.49664 6.30377 1.47026 6.21232 1.4625 6.1182L1.27861 3.86502C1.2632 3.6736 1.32442 3.48391 1.44885 3.33766C1.57328 3.1914 1.75024 3.10088 1.94162 3.08547C2.13299 3.07005 2.32264 3.13129 2.46886 3.25575C2.61508 3.3802 2.7063 3.55793 2.72171 3.74935L2.76984 4.33779C4.57321 2.16381 7.08568 0.695546 9.86468 0.192123C12.6437 -0.311301 15.5112 0.181995 17.9623 1.58527C20.4134 2.98854 22.2914 5.21237 23.2649 7.86412C24.2384 10.5159 24.2451 13.4258 23.2843 16.0822C22.3236 18.7385 20.4569 20.9704 18.0126 22.3854C15.5682 23.8005 12.7028 24.3082 9.92143 23.8181C7.14004 23.328 4.62097 21.8715 2.80719 19.7062C0.993417 17.5409 0.00114015 14.8052 0.00574656 11.9803L0 11.9775ZM11.3969 18.2491V17.2188H9.08099C8.8904 17.2188 8.70791 17.1431 8.57314 17.0083C8.43837 16.8735 8.36267 16.691 8.36267 16.5003C8.36267 16.3097 8.43837 16.1264 8.57314 15.9916C8.70791 15.8568 8.8904 15.7811 9.08099 15.7811H11.9011C12.0451 15.7384 12.1989 15.7384 12.3429 15.7811H12.8838C13.2934 15.7811 13.6867 15.6182 13.9763 15.3285C14.266 15.0387 14.4289 14.6461 14.4289 14.2364C14.4289 13.8266 14.266 13.4333 13.9763 13.1436C13.6867 12.8538 13.2934 12.6909 12.8838 12.6909H11.3645C10.9735 12.6909 10.5865 12.6143 10.2253 12.4646C9.86402 12.3149 9.53563 12.0952 9.25914 11.8187C8.98265 11.5421 8.763 11.2136 8.61337 10.8523C8.46373 10.491 8.3871 10.1039 8.3871 9.71278C8.3871 9.32168 8.46373 8.9346 8.61337 8.57326C8.763 8.21193 8.98265 7.88345 9.25914 7.6069C9.53563 7.33035 9.86402 7.11137 10.2253 6.9617C10.5865 6.81203 10.9735 6.73466 11.3645 6.73466H11.3997V5.66196C11.3997 5.46976 11.4758 5.28558 11.6116 5.14968C11.7475 5.01377 11.9324 4.93701 12.1245 4.93701C12.3167 4.93701 12.5008 5.01377 12.6367 5.14968C12.7725 5.28558 12.8486 5.46976 12.8486 5.66196V6.73466H15.163C15.2573 6.73466 15.3503 6.75318 15.4374 6.78926C15.5245 6.82535 15.6035 6.8785 15.6701 6.94517C15.7368 7.01185 15.7899 7.09084 15.826 7.17796C15.8621 7.26508 15.8806 7.35813 15.8806 7.45243C15.8806 7.54672 15.8621 7.64048 15.826 7.72761C15.7899 7.81473 15.7368 7.89372 15.6701 7.96039C15.6035 8.02707 15.5245 8.08022 15.4374 8.11631C15.3503 8.15239 15.2573 8.17091 15.163 8.17091H11.3645C10.9549 8.17091 10.5617 8.33381 10.272 8.62356C9.98228 8.91331 9.81943 9.30589 9.81943 9.71566C9.81943 10.1254 9.98228 10.5187 10.272 10.8085C10.5617 11.0982 10.9549 11.2611 11.3645 11.2611H12.8838C13.6735 11.2611 14.4315 11.5748 14.9899 12.1334C15.5483 12.6919 15.8619 13.4494 15.8619 14.2392C15.8619 15.0291 15.5483 15.7866 14.9899 16.3451C14.4315 16.9037 13.6735 17.2174 12.8838 17.2174H12.8486V18.2477C12.8486 18.4399 12.7725 18.6241 12.6367 18.76C12.5008 18.8959 12.3167 18.9719 12.1245 18.9719C11.9324 18.9719 11.7475 18.8959 11.6116 18.76C11.4758 18.6241 11.3997 18.4399 11.3997 18.2477L11.3969 18.2491Z",
      fill: "white"
    }, null, -1)
  ])]);
}
const By = /* @__PURE__ */ g(_8, [["render", L8]]), $8 = {}, V8 = {
  class: "h-4 w-4 shrink-0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
};
function B8(e, t) {
  return l(), s("svg", V8, [...t[0] || (t[0] = [
    o("path", {
      d: "M7.99824 11.6682C7.81483 11.6682 7.66477 11.8183 7.66677 12.0017C7.66677 12.1851 7.81683 12.3352 8.00024 12.3352C8.18365 12.3352 8.33371 12.1851 8.33371 12.0017C8.33371 11.8183 8.18365 11.6682 7.99824 11.6682",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.99824 7.6665C7.81483 7.6665 7.66477 7.81657 7.66677 7.99998C7.66677 8.18339 7.81683 8.33345 8.00024 8.33345C8.18365 8.33345 8.33371 8.18339 8.33371 7.99998C8.33371 7.81657 8.18365 7.6665 7.99824 7.6665",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.99824 3.66479C7.81483 3.66479 7.66477 3.81486 7.66677 3.99827C7.66677 4.18168 7.81683 4.33174 8.00024 4.33174C8.18365 4.33174 8.33371 4.18168 8.33371 3.99827C8.33371 3.81486 8.18365 3.66479 7.99824 3.66479",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const H8 = /* @__PURE__ */ g($8, [["render", B8]]), F8 = ["width", "height"], Hy = /* @__PURE__ */ I({
  __name: "ExcelFileIcon",
  props: {
    size: { default: 20 }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [...r[0] || (r[0] = [
      N('<path d="M5.83576 5.83576V4.1684C5.83576 3.24754 6.58227 2.50104 7.50313 2.50104H15.8399C16.7608 2.50104 17.5073 3.24754 17.5073 4.1684V15.8399C17.5073 16.7608 16.7608 17.5073 15.8399 17.5073H7.50313C6.58227 17.5073 5.83576 16.7608 5.83576 15.8399V14.1726" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><rect x="3.33472" y="5.83576" width="8.33681" height="8.33681" rx="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M17.5073 7.56982H11.6715" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5073 12.5052H11.6715" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.6715 2.50104V17.5073" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.8095 11.4631L6.30846 8.54523" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.30846 11.4631L8.8095 8.54523" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
    ])], 8, F8));
  }
}), A8 = ["width", "height"], Fy = /* @__PURE__ */ I({
  __name: "DownloadFileIcon",
  props: {
    width: {
      type: String,
      default: "23.996"
    },
    height: {
      type: String,
      default: "24"
    }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [...r[0] || (r[0] = [
      o("path", {
        d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 15L12 18M12 18L15 15M12 18L12 12M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
        stroke: "#000EC6",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])], 8, A8));
  }
}), j8 = {}, I8 = {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Z8(e, t) {
  return l(), s("svg", I8, [...t[0] || (t[0] = [
    N('<path d="M10.004 13.3384V6.66895" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.505 10.8379L10.004 13.3389L7.50293 10.8379" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.94409 2.50098C14.088 2.50098 17.4472 5.86024 17.4472 10.0041C17.4472 14.148 14.088 17.5072 9.94409 17.5072" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.38041 17.048C6.55797 16.7503 5.79392 16.311 5.1228 15.75" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.1228 4.258C5.79352 3.69646 6.55767 3.2571 7.38041 2.95996" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.56104 8.70228C2.71168 7.84 3.01278 7.01093 3.45057 6.25293" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.56104 11.3057C2.71158 12.1682 3.01268 12.9976 3.45057 13.7559" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const Ay = /* @__PURE__ */ g(j8, [["render", Z8]]), E8 = {}, S8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function z8(e, t) {
  return l(), s("svg", S8, [...t[0] || (t[0] = [
    o("rect", {
      width: "20",
      height: "16",
      x: "2",
      y: "4",
      rx: "2"
    }, null, -1),
    o("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }, null, -1)
  ])]);
}
const jy = /* @__PURE__ */ g(E8, [["render", z8]]), D8 = {}, T8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function O8(e, t) {
  return l(), s("svg", T8, [...t[0] || (t[0] = [
    o("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }, null, -1),
    o("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, -1)
  ])]);
}
const Iy = /* @__PURE__ */ g(D8, [["render", O8]]), P8 = {}, R8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function N8(e, t) {
  return l(), s("svg", R8, [...t[0] || (t[0] = [
    o("path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24" }, null, -1),
    o("path", { d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" }, null, -1),
    o("path", { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" }, null, -1),
    o("line", {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, -1)
  ])]);
}
const Zy = /* @__PURE__ */ g(P8, [["render", N8]]), G8 = {}, U8 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
};
function W8(e, t) {
  return l(), s("svg", U8, [...t[0] || (t[0] = [
    o("rect", {
      x: "2.5",
      y: "2.5",
      width: "15",
      height: "15",
      rx: "3",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.75016 2.5V17.5",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M5.8335 12.9167V7.5",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ey = /* @__PURE__ */ g(G8, [["render", W8]]), Y8 = {}, q8 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function K8(e, t) {
  return l(), s("svg", q8, [...t[0] || (t[0] = [
    o("rect", {
      x: "2.5",
      y: "2.5",
      width: "6.66667",
      height: "15",
      rx: "2",
      fill: "#0012FA"
    }, null, -1),
    o("rect", {
      x: "2.5",
      y: "2.5",
      width: "15",
      height: "15",
      rx: "3",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.74992 2.5V17.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M5.83325 12.9167V7.5",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Sy = /* @__PURE__ */ g(Y8, [["render", K8]]), Q8 = {}, X8 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
};
function J8(e, t) {
  return l(), s("svg", X8, [...t[0] || (t[0] = [
    o("rect", {
      x: "2.5",
      y: "2.5",
      width: "15",
      height: "15",
      rx: "3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.75016 2.5V17.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M5.8335 12.9167V7.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const e9 = /* @__PURE__ */ g(Q8, [["render", J8]]), t9 = {}, o9 = {
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n9(e, t) {
  return l(), s("svg", o9, [...t[0] || (t[0] = [
    N('<path d="M0.842773 8.5006H2.50019C3.23657 8.5006 3.83353 7.90365 3.83353 7.16727V5.83394C3.83353 5.09756 4.43048 4.5006 5.16686 4.5006H6.50019C7.23657 4.5006 7.83353 3.90365 7.83353 3.16727V0.650391" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 11.4993C11.7414 11.4993 12.1688 9.33214 13.1667 8.75634C12.4295 7.74637 11.2503 7.15421 10 7.16619" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.0002 11.4993C8.80355 11.4993 7.8335 10.5293 7.8335 9.33268C7.8335 8.13607 8.80355 7.16602 10.0002 7.16602" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.1601 9.17773C8.92462 9.38442 7.83577 10.1079 7.1665 11.1668" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.3464 5.16684C11.6876 2.27267 9.01097 0.295629 6.05102 0.516866C3.09107 0.738103 0.738103 3.09107 0.516866 6.05102C0.295629 9.01097 2.27267 11.6876 5.16684 12.3464" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const zy = /* @__PURE__ */ g(t9, [["render", n9]]), r9 = {}, l9 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  fill: "currentColor"
};
function s9(e, t) {
  return l(), s("svg", l9, [...t[0] || (t[0] = [
    o("path", { d: "M11.447 8.894a1 1 0 1 0-.894-1.789l.894 1.789zm-2.894-.789a1 1 0 1 0 .894 1.789l-.894-1.789zm0 1.789a1 1 0 1 0 .894-1.789l-.894 1.789zM7.447 7.106a1 1 0 1 0-.894 1.789l.894-1.789zM10 9a1 1 0 1 0-2 0h2zm-2 2.5a1 1 0 1 0 2 0H8zm9.447-5.606a1 1 0 1 0-.894-1.789l.894 1.789zm-2.894-.789a1 1 0 1 0 .894 1.789l-.894-1.789zm2 .789a1 1 0 1 0 .894-1.789l-.894 1.789zm-1.106-2.789a1 1 0 1 0-.894 1.789l.894-1.789zM18 5a1 1 0 1 0-2 0h2zm-2 2.5a1 1 0 1 0 2 0h-2zm-5.447-4.606a1 1 0 1 0 .894-1.789l-.894 1.789zM9 1l.447-.894a1 1 0 0 0-.894 0L9 1zm-2.447.106a1 1 0 1 0 .894 1.789l-.894-1.789zm-6 3a1 1 0 1 0 .894 1.789L.553 4.106zm2.894.789a1 1 0 1 0-.894-1.789l.894 1.789zm-2-.789a1 1 0 1 0-.894 1.789l.894-1.789zm1.106 2.789a1 1 0 1 0 .894-1.789l-.894 1.789zM2 5a1 1 0 1 0-2 0h2zM0 7.5a1 1 0 1 0 2 0H0zm8.553 12.394a1 1 0 1 0 .894-1.789l-.894 1.789zm-1.106-2.789a1 1 0 1 0-.894 1.789l.894-1.789zm1.106 1a1 1 0 1 0 .894 1.789l-.894-1.789zm2.894.789a1 1 0 1 0-.894-1.789l.894 1.789zM8 19a1 1 0 1 0 2 0H8zm2-2.5a1 1 0 1 0-2 0h2zm-7.447.394a1 1 0 1 0 .894-1.789l-.894 1.789zM1 15H0a1 1 0 0 0 .553.894L1 15zm1-2.5a1 1 0 1 0-2 0h2zm12.553 2.606a1 1 0 1 0 .894 1.789l-.894-1.789zM17 15l.447.894A1 1 0 0 0 18 15h-1zm1-2.5a1 1 0 1 0-2 0h2zm-7.447-5.394l-2 1 .894 1.789 2-1-.894-1.789zm-1.106 1l-2-1-.894 1.789 2 1 .894-1.789zM8 9v2.5h2V9H8zm8.553-4.894l-2 1 .894 1.789 2-1-.894-1.789zm.894 0l-2-1-.894 1.789 2 1 .894-1.789zM16 5v2.5h2V5h-2zm-4.553-3.894l-2-1-.894 1.789 2 1 .894-1.789zm-2.894-1l-2 1 .894 1.789 2-1L8.553.106zM1.447 5.894l2-1-.894-1.789-2 1 .894 1.789zm-.894 0l2 1 .894-1.789-2-1-.894 1.789zM0 5v2.5h2V5H0zm9.447 13.106l-2-1-.894 1.789 2 1 .894-1.789zm0 1.789l2-1-.894-1.789-2 1 .894 1.789zM10 19v-2.5H8V19h2zm-6.553-3.894l-2-1-.894 1.789 2 1 .894-1.789zM2 15v-2.5H0V15h2zm13.447 1.894l2-1-.894-1.789-2 1 .894 1.789zM18 15v-2.5h-2V15h2z" }, null, -1)
  ])]);
}
const Dy = /* @__PURE__ */ g(r9, [["render", s9]]), i9 = {}, a9 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function d9(e, t) {
  return l(), s("svg", a9, [...t[0] || (t[0] = [
    N('<path d="M4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4Z" fill="currentColor" opacity="0.1"></path><path d="M4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4ZM3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V4Z" fill="currentColor"></path><line x1="6" y1="6" x2="6" y2="14" stroke="currentColor" stroke-width="1" opacity="0.3"></line><line x1="10" y1="6" x2="10" y2="14" stroke="currentColor" stroke-width="1" opacity="0.3"></line><line x1="14" y1="6" x2="14" y2="14" stroke="currentColor" stroke-width="1" opacity="0.3"></line><line x1="4" y1="8" x2="16" y2="8" stroke="currentColor" stroke-width="1" opacity="0.3"></line><line x1="4" y1="11" x2="16" y2="11" stroke="currentColor" stroke-width="1" opacity="0.3"></line><path d="M13.5 5.5L14.5 4.5C14.7761 4.22386 15.2239 4.22386 15.5 4.5C15.7761 4.77614 15.7761 5.22386 15.5 5.5L14.5 6.5L13.5 5.5Z" fill="currentColor"></path><path d="M12.5 6.5L13.5 7.5L10.5 10.5L9.5 9.5L12.5 6.5Z" fill="currentColor"></path>', 9)
  ])]);
}
const Ty = /* @__PURE__ */ g(i9, [["render", d9]]), u9 = {}, c9 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
};
function h9(e, t) {
  return l(), s("svg", c9, [...t[0] || (t[0] = [
    o("g", {
      id: "Grupo_3175",
      "data-name": "Grupo 3175",
      transform: "translate(-24 -24)"
    }, [
      o("rect", {
        id: "Retângulo_55",
        "data-name": "Retângulo 55",
        width: "48",
        height: "48",
        rx: "8",
        transform: "translate(24 24)",
        fill: "#d2dffd"
      }),
      o("path", {
        id: "Editar_limite_de_crédito",
        "data-name": "Editar limite de crédito",
        d: "M-6762.395,6143.363a1.622,1.622,0,0,1-1.605-1.636V6127a1.622,1.622,0,0,1,1.605-1.636h8.829a.811.811,0,0,1,.8.818.81.81,0,0,1-.8.818h-8.829v3.273h8.829a.81.81,0,0,1,.8.818.81.81,0,0,1-.8.817h-8.829v9.82h22.473V6136a.811.811,0,0,1,.8-.818.811.811,0,0,1,.8.818v5.728a1.622,1.622,0,0,1-1.605,1.636Zm2.408-6.546a.811.811,0,0,1-.8-.818.811.811,0,0,1,.8-.818h3.21a.811.811,0,0,1,.8.818.811.811,0,0,1-.8.818Zm11.385-2.455a.692.692,0,0,1-.686-.7V6132.1a3.688,3.688,0,0,1,1.05-2.591l4.644-4.733a2.571,2.571,0,0,1,1.9-.771,2.588,2.588,0,0,1,1.8.778,2.719,2.719,0,0,1,0,3.785l-4.638,4.728a3.545,3.545,0,0,1-2.542,1.071Zm1.335-3.869a2.284,2.284,0,0,0-.649,1.6v.867h.851a2.194,2.194,0,0,0,1.573-.663l3.061-3.119-1.773-1.809Zm4.637-4.726-.605.617,1.773,1.808.605-.618a1.3,1.3,0,0,0,0-1.808,1.236,1.236,0,0,0-.887-.374A1.238,1.238,0,0,0-6742.63,6125.768Z",
        transform: "translate(6799.158 -6085.682)",
        fill: "#000ec6",
        stroke: "#000ec6",
        "stroke-width": "0.2"
      })
    ], -1)
  ])]);
}
const Oy = /* @__PURE__ */ g(u9, [["render", h9]]), Py = /* @__PURE__ */ I({
  __name: "EditIcon",
  props: {
    className: {}
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      class: v(e.className),
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [...r[0] || (r[0] = [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
      }, null, -1)
    ])], 2));
  }
}), p9 = {}, f9 = {
  class: "w-5 h-5",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function C9(e, t) {
  return l(), s("svg", f9, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 9.5L9.5 3.5C9.75 3.25 10.125 3.25 10.375 3.5L12.5 5.625C12.75 5.875 12.75 6.25 12.5 6.5L6.5 12.5C6.375 12.625 6.1875 12.75 6 12.75H3.5V10.25C3.5 10.0625 3.5625 9.875 3.6875 9.75L3.5 9.5Z",
      stroke: "#9DA1C3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.5 4.5L11.5 6.5",
      stroke: "#9DA1C3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ry = /* @__PURE__ */ g(p9, [["render", C9]]), g9 = {}, v9 = {
  class: "w-5 h-5",
  viewBox: "0 0 107 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function m9(e, t) {
  return l(), s("svg", v9, [...t[0] || (t[0] = [
    o("g", { filter: "url(#filter0_d_4192_60624)" }, [
      o("path", {
        d: "M8.05981 28.4216C8.05981 25.9487 10.0645 23.944 12.5374 23.944H55.6677C56.7302 23.944 57.758 23.5661 58.5676 22.878L65.0147 17.398C65.8243 16.7099 66.8521 16.332 67.9146 16.332H93.5822C96.0551 16.332 98.0598 18.3367 98.0598 20.8096V85.735C98.0598 88.2079 96.0551 90.2126 93.5822 90.2126H12.5374C10.0645 90.2126 8.05981 88.2079 8.05981 85.735V28.4216Z",
        fill: "#5763FF"
      }),
      o("path", {
        d: "M67.9143 16.5557H93.5823C95.9315 16.5557 97.8361 18.4604 97.8362 20.8096V85.7354C97.836 88.0844 95.9314 89.9882 93.5823 89.9883H12.5374C10.1882 89.9882 8.28363 88.0844 8.28345 85.7354V28.4219C8.28345 26.0726 10.1881 24.168 12.5374 24.168H55.6672C56.7827 24.168 57.8622 23.7712 58.7122 23.0488L65.1594 17.5684C65.9284 16.9147 66.9051 16.5557 67.9143 16.5557Z",
        stroke: "#1627FF",
        "stroke-opacity": "0.4",
        "stroke-width": "0.447761"
      }),
      o("rect", {
        x: "74.7756",
        y: "21.7021",
        width: "8.95522",
        height: "1.79104",
        rx: "0.447761",
        fill: "#5763FF"
      }),
      o("rect", {
        x: "85.9702",
        y: "21.7021",
        width: "5.8209",
        height: "1.79104",
        rx: "0.447761",
        fill: "#000FCC"
      }),
      o("g", { "clip-path": "url(#clip0_4192_60624)" }, [
        o("rect", {
          x: "14.5605",
          y: "17.5781",
          width: "52.388",
          height: "69.8507",
          rx: "4.47761",
          transform: "rotate(-15 14.5605 17.5781)",
          fill: "white"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M26.2985 24.2018C26.9116 23.1399 28.2691 22.7762 29.331 23.3892L29.4287 23.4486C30.4147 24.0867 30.7374 25.3931 30.1435 26.4217C29.5305 27.4835 28.1729 27.8471 27.111 27.2342C26.0492 26.6212 25.6854 25.2637 26.2985 24.2018ZM28.8081 24.0004C28.1441 23.7021 27.3489 23.9495 26.977 24.5935C26.5803 25.2806 26.8157 26.159 27.5028 26.5557C28.1899 26.9522 29.0683 26.717 29.465 26.0299C29.8368 25.3859 29.6533 24.5736 29.0631 24.1476L28.9392 24.0678L28.8081 24.0004Z",
          fill: "#0012FA"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M24.0909 23.8136C25.4973 21.3776 28.6126 20.5429 31.0487 21.9493L31.2724 22.0863C33.5347 23.5501 34.2755 26.5472 32.913 28.9071C31.5066 31.3431 28.3913 32.1779 25.9552 30.7714C23.5193 29.3649 22.6845 26.2496 24.0909 23.8136ZM27.8788 29.0962C27.5931 29.1728 27.3464 29.3549 27.1882 29.6055L27.1876 29.6052L27.1653 29.6423L27.1642 29.6442C27.0748 29.7863 27.0138 29.9445 26.9848 30.11L26.9744 30.1814L26.9504 30.3817C28.692 31.0562 30.6835 30.5228 31.8551 29.0685L31.7345 28.906L31.7338 28.9056C31.6195 28.752 31.4721 28.6257 31.3021 28.5359L31.2621 28.515L31.2609 28.5142C31.0319 28.3933 30.7701 28.3518 30.5169 28.3946L30.4091 28.4182L27.8788 29.0962ZM30.4618 22.5222C28.432 21.4838 25.9223 22.2085 24.7694 24.2053C23.6067 26.2193 24.2551 28.781 26.2079 30.0076C26.2518 29.7313 26.3501 29.4664 26.4994 29.2287L26.5238 29.1899L26.5253 29.1874C26.7883 28.7706 27.1991 28.4672 27.676 28.3393L30.2063 27.6613L30.296 27.6394C30.7463 27.5413 31.2181 27.6053 31.6271 27.8214L31.6664 27.842L31.6671 27.8424C31.9159 27.9736 32.1352 28.1542 32.312 28.3731C33.3563 26.3994 32.7152 23.9534 30.846 22.744L30.6569 22.6278L30.4618 22.5222Z",
          fill: "#0012FA"
        }),
        o("rect", {
          x: "41.8167",
          y: "17.2305",
          width: "20.597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 41.8167 17.2305)",
          fill: "#E2E4EE"
        }),
        o("rect", {
          x: "42.9749",
          y: "21.5566",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 42.9749 21.5566)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "26.989",
          y: "39.7461",
          width: "16.5672",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 26.989 39.7461)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "59.7366",
          y: "49.5127",
          width: "5.37313",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 59.7366 49.5127)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "31.6248",
          y: "57.0449",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 31.6248 57.0449)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "49.3572",
          y: "52.2939",
          width: "8.0597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 49.3572 52.2939)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "44.1343",
          y: "25.8789",
          width: "10.2985",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 44.1343 25.8789)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "28.1472",
          y: "44.0703",
          width: "32.2388",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 28.1472 44.0703)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "67.1997",
          y: "66.9805",
          width: "8.95522",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 67.1997 66.9805)",
          fill: "#99A0FF"
        }),
        o("rect", {
          x: "36.4919",
          y: "75.2119",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 36.4919 75.2119)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "50.7595",
          y: "19.4697",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 50.7595 19.4697)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "29.3066",
          y: "48.3965",
          width: "23.2836",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 29.3066 48.3965)",
          fill: "#ECEEF3"
        })
      ]),
      o("g", { "clip-path": "url(#clip1_4192_60624)" }, [
        o("rect", {
          x: "36.9648",
          y: "1.79102",
          width: "52.388",
          height: "69.8507",
          rx: "4.47761",
          transform: "rotate(6.70628 36.9648 1.79102)",
          fill: "white"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M45.4218 12.284C46.3842 11.5242 47.7799 11.6883 48.5398 12.6506L48.6087 12.742C49.2887 13.6995 49.1053 15.0326 48.1732 15.7686C47.2109 16.5284 45.8151 16.3642 45.0552 15.402C44.2954 14.4396 44.4595 13.0439 45.4218 12.284ZM47.828 13.0251C47.3213 12.5024 46.4911 12.4381 45.9074 12.8989C45.2847 13.3906 45.1785 14.2938 45.6701 14.9164C46.1618 15.539 47.065 15.6453 47.6876 15.1537C48.2713 14.6928 48.4012 13.8702 48.0104 13.2562L47.9249 13.1362L47.828 13.0251Z",
          fill: "#0012FA"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M43.5143 11.1069C45.722 9.36377 48.9251 9.74049 50.6683 11.9481L50.8254 12.1582C52.3859 14.3548 51.9658 17.4134 49.8271 19.102C47.6194 20.8452 44.4163 20.4686 42.6732 18.2609C40.9301 16.0531 41.3067 12.85 43.5143 11.1069ZM45.0799 17.4158C44.7861 17.3814 44.4896 17.4593 44.2499 17.6336L44.2494 17.6331L44.215 17.6593L44.2133 17.6607C44.0776 17.7596 43.9625 17.8841 43.8743 18.0271L43.8382 18.0896L43.7419 18.2668C45.1106 19.5376 47.158 19.7786 48.7845 18.8608L48.7325 18.6651L48.7321 18.6646C48.6827 18.4796 48.5924 18.3077 48.4676 18.1614L48.4383 18.1272L48.4374 18.126C48.2694 17.929 48.0415 17.7936 47.7904 17.7397L47.6815 17.7218L45.0799 17.4158ZM49.9111 12.2633C48.4094 10.5478 45.8095 10.293 43.9999 11.7218C42.1747 13.1629 41.8297 15.7828 43.1904 17.6447C43.3333 17.4042 43.5227 17.1944 43.7493 17.0288L43.7864 17.0018L43.7886 17C44.1872 16.71 44.681 16.58 45.1714 16.6376L47.773 16.9435L47.8645 16.9564C48.3192 17.0318 48.7338 17.2658 49.0339 17.6178L49.0628 17.6515L49.0633 17.6521C49.2459 17.866 49.3829 18.1149 49.4662 18.3836C51.1664 16.9362 51.4754 14.4265 50.186 12.6115L50.0534 12.4336L49.9111 12.2633Z",
          fill: "#0012FA"
        }),
        o("rect", {
          x: "62.4187",
          y: "11.5459",
          width: "20.597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 62.4187 11.5459)",
          fill: "#E2E4EE"
        }),
        o("rect", {
          x: "61.896",
          y: "15.9922",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 61.896 15.9922)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "40.3149",
          y: "26.9805",
          width: "16.5672",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 40.3149 26.9805)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "67.1279",
          y: "48.1699",
          width: "5.37313",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 67.1279 48.1699)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "38.2231",
          y: "44.7695",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 38.2231 44.7695)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "56.4565",
          y: "46.9131",
          width: "8.0597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 56.4565 46.9131)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "61.373",
          y: "20.4443",
          width: "10.2985",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 61.373 20.4443)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "39.7922",
          y: "31.4268",
          width: "32.2388",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 39.7922 31.4268)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "67.6011",
          y: "67.1572",
          width: "8.95522",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 67.6011 67.1572)",
          fill: "#99A0FF"
        }),
        o("rect", {
          x: "36.0273",
          y: "63.4473",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 36.0273 63.4473)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "69.8997",
          y: "16.9336",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 69.8997 16.9336)",
          fill: "#ECEEF3"
        }),
        o("rect", {
          x: "39.2688",
          y: "35.876",
          width: "23.2836",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 39.2688 35.876)",
          fill: "#ECEEF3"
        })
      ]),
      o("foreignObject", {
        x: "4.02996",
        y: "24.394",
        width: "98.0597",
        height: "69.8507"
      }, [
        o("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: { "backdrop-filter": "blur(2.01px)", "clip-path": "url(#bgblur_2_4192_60624_clip_path)", height: "100%", width: "100%" }
        })
      ]),
      o("g", { "data-figma-bg-blur-radius": "4.02985" }, [
        o("path", {
          d: "M8.05981 32.9014C8.05981 30.4285 10.0645 28.4238 12.5374 28.4238H32.3265C34.1638 28.4238 35.9567 28.989 37.462 30.0426L44.0308 34.6408C45.536 35.6945 47.3289 36.2596 49.1663 36.2596H93.5822C96.0551 36.2596 98.0598 38.2643 98.0598 40.7373V85.7373C98.0598 88.2102 96.0551 90.2149 93.5822 90.2149H12.5374C10.0645 90.2149 8.05981 88.2102 8.05981 85.7373V32.9014Z",
          fill: "#000CAD",
          "fill-opacity": "0.4"
        }),
        o("path", {
          d: "M12.5374 28.6475H32.3264C34.1177 28.6475 35.8657 29.1985 37.3333 30.2256L43.9026 34.8242C45.4454 35.9042 47.283 36.4834 49.1663 36.4834H93.5823C95.9315 36.4834 97.8362 38.3881 97.8362 40.7373V85.7373C97.8362 88.0865 95.9315 89.9912 93.5823 89.9912H12.5374C10.1881 89.9912 8.28347 88.0865 8.28345 85.7373V32.9014C8.28349 30.5522 10.1881 28.6475 12.5374 28.6475Z",
          stroke: "#1627FF",
          "stroke-opacity": "0.4",
          "stroke-width": "0.447761"
        })
      ]),
      o("path", {
        d: "M25.8992 83.3257L15.5591 71.4678H18.7655L29.1055 83.3257H25.8992Z",
        fill: "#F0F1FF"
      }),
      o("path", {
        d: "M15.2236 83.3242L15.543 83.0964C15.9175 82.8287 16.2847 82.5573 16.6362 82.2897C19.1263 80.451 21.3305 78.2756 23.1813 75.8301C24.6074 73.8232 25.0529 72.3041 24.4333 71.5459C24.2443 71.3564 24.0131 71.2111 23.7572 71.1213C23.5014 71.0315 23.2277 70.9994 22.9571 71.0275C22.3633 71.042 21.7738 71.1305 21.2033 71.2908L21.147 71.306C21.1125 71.3159 21.0759 71.3165 21.041 71.308C21.0061 71.2995 20.9743 71.282 20.9487 71.2575C20.912 71.2211 20.8914 71.1722 20.8914 71.1213C20.8914 71.0703 20.912 71.0214 20.9487 70.985C20.9609 70.9734 20.9748 70.9634 20.9898 70.9556L21 70.9501L21.0884 70.9092C22.5502 70.1712 24.1542 69.7343 25.7991 69.6261C26.1664 69.5915 26.537 69.6395 26.8819 69.7663C27.2269 69.8931 27.5369 70.0953 27.7878 70.3571C28.5533 71.2962 28.1782 72.9903 26.7318 75.127C25.0784 77.5709 23.0262 79.739 20.6553 81.5467C19.8381 82.1703 18.996 82.7617 18.1524 83.3029L18.1197 83.3242H15.2236Z",
        fill: "#C7CBFF"
      }),
      o("path", {
        d: "M24.4818 78.0115C23.94 78.6168 23.3709 79.1982 22.7747 79.7556L23.8797 81.0047L24.5922 78.145L24.4846 78.0088H24.4818",
        fill: "#000657"
      })
    ], -1),
    N('<defs><filter id="filter0_d_4192_60624" x="-0.000131607" y="-2.95639e-05" width="106.12" height="104.543" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="6.26866"></feOffset><feGaussianBlur stdDeviation="4.02985"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4192_60624"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4192_60624" result="shape"></feBlend></filter><clipPath id="bgblur_2_4192_60624_clip_path" transform="translate(-4.02996 -24.394)"><path d="M8.05981 32.9014C8.05981 30.4285 10.0645 28.4238 12.5374 28.4238H32.3265C34.1638 28.4238 35.9567 28.989 37.462 30.0426L44.0308 34.6408C45.536 35.6945 47.3289 36.2596 49.1663 36.2596H93.5822C96.0551 36.2596 98.0598 38.2643 98.0598 40.7373V85.7373C98.0598 88.2102 96.0551 90.2149 93.5822 90.2149H12.5374C10.0645 90.2149 8.05981 88.2102 8.05981 85.7373V32.9014Z"></path></clipPath><clipPath id="clip0_4192_60624"><rect x="14.5605" y="17.5781" width="52.388" height="69.8507" rx="4.47761" transform="rotate(-15 14.5605 17.5781)" fill="white"></rect></clipPath><clipPath id="clip1_4192_60624"><rect x="36.9648" y="1.79102" width="52.388" height="69.8507" rx="4.47761" transform="rotate(6.70628 36.9648 1.79102)" fill="white"></rect></clipPath></defs>', 1)
  ])]);
}
const Ny = /* @__PURE__ */ g(g9, [["render", m9]]), x9 = {}, w9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57 44",
  fill: "none",
  class: "w-full h-full"
};
function k9(e, t) {
  return l(), s("svg", w9, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M56.2497 1.51466C56.2927 1.55565 56.3358 1.59665 56.3767 1.63763C56.7948 2.06795 57.0191 2.65193 56.9976 3.25642L55.7253 40.3228C55.6593 42.2457 54.0264 43.7278 52.108 43.5795C41.3211 42.7462 8.88216 40.2399 2.16808 39.7207C1.41297 39.6592 0.749087 39.1981 0.433521 38.5014C0.257296 38.1223 0.102539 37.774 0.102539 37.774L24.477 0.961459H54.5592L54.9475 0.397949L56.1954 1.47374C56.2139 1.48399 56.2313 1.50442 56.2497 1.51466Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M53.7446 0.357734C54.4536 0.347402 54.8614 0.760762 54.9341 0.83309C55.0048 0.905417 55.4156 1.31866 55.3869 2.01093C54.846 14.6682 54.306 27.3255 53.7661 39.9829C53.762 40.0965 53.7354 40.7062 53.1964 41.1815C53.1155 41.2538 52.6576 41.6671 51.927 41.6258C35.2164 40.6648 18.5057 39.7142 1.79508 38.7636C1.14243 38.7223 0.783858 38.2987 0.720335 38.2263C0.657837 38.154 0.300234 37.7407 0.356585 37.0795C1.35349 25.4761 2.34938 13.883 3.34628 2.28993C3.35448 2.18661 3.40059 1.64932 3.88828 1.20502C4.37597 0.750389 4.91487 0.75045 5.0122 0.75045C21.2567 0.616127 37.5001 0.481724 53.7446 0.357734Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.9195 0.826759C29.7433 0.826759 29.5988 0.682144 29.5968 0.506492C29.5957 0.330839 29.7382 0.186124 29.9144 0.186124L53.7109 0.000159141C54.5572 -0.0101734 55.0439 0.485786 55.131 0.568446C55.216 0.651106 55.7108 1.14709 55.676 1.98402L54.0552 39.9662C54.05 40.0902 54.0193 40.8135 53.379 41.3921C53.2837 41.4748 52.7417 41.9604 51.878 41.9087L1.74707 39.0363C0.956102 38.995 0.522717 38.4887 0.446899 38.3957C0.371082 38.313 -0.0612885 37.8068 0.00735731 37.0112L2.99705 2.22165C3.00627 2.10799 3.05953 1.46737 3.64046 0.930084C4.22036 0.392794 4.86379 0.392774 4.97854 0.392774L10.0696 0.351504C10.2468 0.341172 10.3913 0.485827 10.3923 0.661479C10.3944 0.837132 10.252 0.981706 10.0747 0.992038L4.98365 1.03341C4.90578 1.03341 4.47038 1.03341 4.0749 1.39505C3.68044 1.76702 3.64148 2.20098 3.6343 2.27331L0.645659 37.0731C0.600578 37.5898 0.884388 37.9204 0.933567 37.9824C0.982746 38.0444 1.26655 38.3751 1.78294 38.4061L51.9148 41.2682C52.5122 41.2992 52.8871 40.9685 52.9527 40.9065C53.3902 40.5242 53.4117 40.0179 53.4158 39.9352L55.0357 1.95304C55.0592 1.40542 54.7334 1.07478 54.6771 1.02312C54.6187 0.961121 54.2887 0.630461 53.717 0.640794L29.9195 0.826759Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M51.0339 5.32104C51.7682 5.32104 52.383 5.92946 52.3499 6.66294C51.8923 16.8399 51.4355 27.0252 50.9778 37.2022C50.9429 37.9607 50.2554 38.5524 49.5055 38.5191C34.4444 37.7273 19.3843 36.9355 4.32408 36.1436C3.65043 36.1103 3.099 35.5018 3.15873 34.7934C3.94635 25.3832 4.73485 15.9814 5.52246 6.57129C5.58036 5.88782 6.21086 5.32935 6.87256 5.32935C21.5936 5.32101 36.3138 5.32104 51.0339 5.32104Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M51.8213 2.13282C52.2115 2.131 52.54 2.43871 52.5215 2.84207V2.84243C52.5039 3.24505 52.1482 3.55679 51.7564 3.55788C38.5591 3.59658 25.3617 3.63564 12.1643 3.67433C11.8094 3.67542 11.5154 3.38887 11.545 3.00961V3.00925C11.5747 2.63254 11.9111 2.34125 12.2692 2.33942C25.453 2.27043 38.6376 2.20181 51.8213 2.13282Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.55324 2.36957C6.89976 2.35525 7.20904 2.69894 7.1804 3.04261C7.15176 3.38627 6.78664 3.7299 6.44011 3.7299C6.09502 3.7299 5.78571 3.38627 5.81434 3.04261C5.84298 2.69894 6.20814 2.36957 6.55324 2.36957Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33685 2.3551C8.68481 2.3551 8.99559 2.68447 8.96696 3.02814C8.93975 3.38612 8.57315 3.71543 8.2252 3.71543C7.87867 3.71543 7.56792 3.38606 7.59656 3.0424C7.62377 2.69874 7.99033 2.3551 8.33685 2.3551Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1286 2.3407C10.478 2.3407 10.7902 2.68447 10.763 3.02813C10.7358 3.3718 10.3692 3.71543 10.0198 3.71543C9.67042 3.71543 9.35824 3.3718 9.38544 3.02813C9.41408 2.68447 9.78065 2.3407 10.1286 2.3407Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M48.0602 10.8429C48.3782 10.8429 48.5708 11.0421 48.5927 11.0655C48.8073 11.2882 48.7947 11.5577 48.7916 11.5987C48.79 11.6397 48.7775 11.9092 48.541 12.126C48.5175 12.1494 48.3061 12.3486 47.9866 12.3428C38.8216 12.2432 29.6566 12.1377 20.4916 12.0381C20.1909 12.0322 20.0139 11.8448 19.9936 11.8214C19.7978 11.6104 19.815 11.3526 19.8182 11.3116C19.8213 11.2706 19.8401 11.0128 20.0672 10.8077C20.0891 10.7843 20.2927 10.5968 20.5934 10.6027C29.749 10.6847 38.9046 10.7609 48.0602 10.8429Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M40.0247 13.8336C40.0787 13.8336 40.3373 13.8336 40.5477 14.0563C40.758 14.2789 40.7442 14.5425 40.7408 14.5894C40.7397 14.6304 40.7247 14.8941 40.4914 15.1109C40.2569 15.3218 39.9982 15.3218 39.9431 15.3218C33.3887 15.2163 26.8355 15.1109 20.2811 15.0054C20.2282 15.0054 19.9811 14.9995 19.7834 14.7827C19.5857 14.5718 19.604 14.3141 19.6075 14.2731C19.6098 14.232 19.6282 13.9742 19.8558 13.7692C20.0834 13.5582 20.3305 13.5641 20.3834 13.5641C26.9297 13.652 33.4772 13.7399 40.0247 13.8336Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M35.8217 19.47C35.8736 19.47 36.1347 19.4758 36.343 19.6984C36.5513 19.9211 36.5362 20.1847 36.5343 20.2316C36.5314 20.2726 36.5164 20.5362 36.2826 20.753C36.0489 20.9639 35.7869 20.9581 35.736 20.9581C30.4523 20.8233 25.1686 20.6886 19.8839 20.5539C19.8349 20.5539 19.5823 20.548 19.3844 20.3312C19.1865 20.1144 19.2044 19.8566 19.2082 19.8098C19.211 19.7688 19.2289 19.5109 19.457 19.3059C19.6851 19.1008 19.9367 19.1067 19.9867 19.1067C25.2647 19.2239 30.5437 19.3469 35.8217 19.47Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M47.6287 19.7395C47.9485 19.7453 48.1304 19.9387 48.1648 19.9738C48.3805 20.2023 48.368 20.4718 48.3655 20.5187C48.3635 20.5656 48.3506 20.8292 48.1134 21.046C48.0761 21.0811 47.8758 21.2628 47.5554 21.2569C44.9069 21.1866 42.2583 21.1222 39.6097 21.0519C39.2948 21.046 39.1175 20.8585 39.0841 20.8234C38.8739 20.5949 38.8883 20.3312 38.8908 20.2843C38.8938 20.2375 38.9082 19.9797 39.1424 19.7629C39.1788 19.7278 39.3771 19.552 39.6914 19.5579C42.337 19.6165 44.9831 19.6809 47.6287 19.7395Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M47.1084 24.2817C47.7026 24.2928 48.1627 24.8032 48.136 25.3691C47.9905 28.4318 47.845 31.4833 47.6985 34.546C47.6719 35.1119 47.1596 35.6001 46.5613 35.5668C33.4386 34.9343 20.316 34.3018 7.19236 33.6693C6.6473 33.6471 6.23643 33.1588 6.27946 32.6262C6.51204 29.7744 6.74357 26.9116 6.97615 24.0598C7.01918 23.5271 7.50281 23.0832 8.04378 23.1054C21.065 23.4938 34.0872 23.8822 47.1084 24.2817Z" fill="#BBD5FF"></path><path d="M13.0621 14.9427C14.3378 14.9645 15.4232 13.9954 15.4862 12.7779C15.5493 11.5605 14.5662 10.5558 13.2904 10.5339C12.0146 10.512 10.9294 11.4813 10.8663 12.6987C10.8032 13.9162 11.7863 14.9208 13.0621 14.9427Z" fill="#BBD5FF"></path><path d="M12.7687 15.5256C10.5098 15.4868 8.5882 17.2031 8.47656 19.3587L16.6567 19.499C16.7684 17.3434 15.0276 15.5643 12.7687 15.5256Z" fill="#BBD5FF"></path>', 15)
  ])]);
}
const Gy = /* @__PURE__ */ g(x9, [["render", k9]]), y9 = {}, b9 = {
  width: "57",
  height: "44",
  viewBox: "0 0 57 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _9(e, t) {
  return l(), s("svg", b9, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M56.2497 1.51418C56.2927 1.55516 56.3358 1.59616 56.3767 1.63714C56.7948 2.06746 57.0191 2.65144 56.9976 3.25593L55.7253 40.3223C55.6593 42.2453 54.0264 43.7273 52.108 43.5791C41.3211 42.7457 8.88216 40.2394 2.16808 39.7202C1.41297 39.6587 0.749087 39.1976 0.433521 38.5009C0.257296 38.1218 0.102539 37.7735 0.102539 37.7735L24.477 0.960971H54.5592L54.9475 0.397461L56.1954 1.47325C56.2139 1.4835 56.2313 1.50393 56.2497 1.51418Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M53.7446 0.357612C54.4536 0.34728 54.8614 0.76064 54.9341 0.832968C55.0048 0.905295 55.4156 1.31853 55.3869 2.01081C54.846 14.6681 54.306 27.3254 53.7661 39.9827C53.762 40.0964 53.7354 40.7061 53.1964 41.1814C53.1155 41.2537 52.6576 41.667 51.927 41.6256C35.2164 40.6647 18.5057 39.7141 1.79508 38.7635C1.14243 38.7222 0.783858 38.2985 0.720335 38.2262C0.657837 38.1539 0.300234 37.7406 0.356585 37.0793C1.35349 25.476 2.34938 13.8829 3.34628 2.28981C3.35448 2.18648 3.40059 1.64919 3.88828 1.2049C4.37597 0.750267 4.91487 0.750328 5.0122 0.750328C21.2567 0.616005 37.5001 0.481602 53.7446 0.357612Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.9195 0.826759C29.7433 0.826759 29.5988 0.682144 29.5968 0.506492C29.5957 0.330839 29.7382 0.186124 29.9144 0.186124L53.7109 0.000159141C54.5572 -0.0101734 55.0439 0.485786 55.131 0.568446C55.216 0.651106 55.7108 1.14709 55.676 1.98402L54.0552 39.9662C54.05 40.0902 54.0193 40.8135 53.379 41.3921C53.2837 41.4748 52.7417 41.9604 51.878 41.9087L1.74707 39.0363C0.956102 38.995 0.522717 38.4887 0.446899 38.3957C0.371082 38.313 -0.0612885 37.8068 0.00735731 37.0112L2.99705 2.22165C3.00627 2.10799 3.05953 1.46737 3.64046 0.930084C4.22036 0.392794 4.86379 0.392774 4.97854 0.392774L10.0696 0.351504C10.2468 0.341172 10.3913 0.485827 10.3923 0.661479C10.3944 0.837132 10.252 0.981706 10.0747 0.992038L4.98365 1.03341C4.90578 1.03341 4.47038 1.03341 4.0749 1.39505C3.68044 1.76702 3.64148 2.20098 3.6343 2.27331L0.645659 37.0731C0.600578 37.5898 0.884388 37.9204 0.933567 37.9824C0.982746 38.0444 1.26655 38.3751 1.78294 38.4061L51.9148 41.2682C52.5122 41.2992 52.8871 40.9685 52.9527 40.9065C53.3902 40.5242 53.4117 40.0179 53.4158 39.9352L55.0357 1.95304C55.0592 1.40542 54.7334 1.07478 54.6771 1.02312C54.6187 0.961121 54.2887 0.630461 53.717 0.640794L29.9195 0.826759Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M51.0339 5.32129C51.7682 5.32129 52.383 5.92971 52.3499 6.66318C51.8923 16.8401 51.4355 27.0255 50.9778 37.2024C50.9429 37.9609 50.2554 38.5527 49.5055 38.5193C34.4444 37.7275 19.3843 36.9357 4.32408 36.1439C3.65043 36.1105 3.099 35.5021 3.15873 34.7936C3.94635 25.3835 4.73485 15.9817 5.52246 6.57153C5.58036 5.88806 6.21086 5.32959 6.87256 5.32959C21.5936 5.32126 36.3138 5.32129 51.0339 5.32129Z" fill="white"></path><path d="M15.537 15.9634C16.6472 15.9785 17.5888 15.1318 17.6399 14.0722C17.6911 13.0125 16.8325 12.1412 15.7222 12.126C14.6119 12.1109 13.6704 12.9577 13.6193 14.0174C13.5682 15.077 14.4267 15.9482 15.537 15.9634Z" fill="#BBD5FF"></path><path d="M15.2831 16.4724C13.3172 16.4456 11.6502 17.9449 11.5597 19.8212L18.6787 19.9182C18.7692 18.042 17.249 16.4992 15.2831 16.4724Z" fill="#BBD5FF"></path><path d="M20.2523 14.0667C20.9423 14.0761 21.5274 13.5499 21.5591 12.8915C21.5909 12.233 21.0574 11.6915 20.3674 11.6821C19.6775 11.6727 19.0924 12.1989 19.0606 12.8574C19.0288 13.5159 19.5624 14.0573 20.2523 14.0667Z" fill="#BBD5FF"></path><path d="M20.0938 14.3827C18.8721 14.366 17.8362 15.2978 17.7799 16.4638L22.2039 16.5241C22.2602 15.3581 21.3155 14.3993 20.0938 14.3827Z" fill="#BBD5FF"></path><path d="M10.68 14.0989C11.37 14.1083 11.9551 13.5822 11.9869 12.9237C12.0187 12.2652 11.4851 11.7237 10.7951 11.7143C10.1052 11.7049 9.52013 12.2311 9.48835 12.8896C9.45656 13.5481 9.99009 14.0895 10.68 14.0989Z" fill="#BBD5FF"></path><path d="M10.5225 14.4149C9.30085 14.3983 8.26492 15.33 8.20864 16.496L12.6326 16.5563C12.6889 15.3903 11.7442 14.4316 10.5225 14.4149Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M51.8213 2.13282C52.2115 2.131 52.54 2.43871 52.5215 2.84207V2.84243C52.5039 3.24505 52.1482 3.55679 51.7564 3.55788C38.5591 3.59658 25.3617 3.63564 12.1643 3.67433C11.8094 3.67542 11.5154 3.38887 11.545 3.00961V3.00925C11.5747 2.63254 11.9111 2.34125 12.2692 2.33942C25.453 2.27043 38.6376 2.20181 51.8213 2.13282Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.55324 2.36957C6.89976 2.35525 7.20904 2.69894 7.1804 3.04261C7.15176 3.38627 6.78664 3.7299 6.44011 3.7299C6.09502 3.7299 5.78571 3.38627 5.81434 3.04261C5.84298 2.69894 6.20814 2.36957 6.55324 2.36957Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33685 2.35547C8.68481 2.35547 8.99559 2.68484 8.96696 3.0285C8.93975 3.38648 8.57315 3.7158 8.2252 3.7158C7.87867 3.7158 7.56792 3.38643 7.59656 3.04277C7.62377 2.6991 7.99033 2.35547 8.33685 2.35547Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1286 2.34082C10.478 2.34082 10.7902 2.68459 10.763 3.02826C10.7358 3.37192 10.3692 3.71555 10.0198 3.71555C9.67042 3.71555 9.35824 3.37192 9.38544 3.02826C9.41408 2.68459 9.78065 2.34082 10.1286 2.34082Z" fill="#BBD5FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M48.1623 10.8304C48.4356 10.8302 48.6013 11.0292 48.6202 11.0526C48.8048 11.2751 48.7942 11.5446 48.7916 11.5856C48.7903 11.6266 48.7798 11.8962 48.5767 12.1131C48.5565 12.1366 48.375 12.3359 48.1004 12.3303C40.2237 12.238 32.347 12.1397 24.4702 12.0473C24.2118 12.0417 24.0596 11.8544 24.0421 11.831C23.8736 11.6202 23.8882 11.3624 23.8908 11.3214C23.8935 11.2804 23.9094 11.0225 24.1044 10.8173C24.1232 10.7938 24.298 10.6062 24.5564 10.6118C32.425 10.6866 40.2937 10.7556 48.1623 10.8304Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M40.4267 14.266C40.4702 14.266 40.6782 14.266 40.8474 14.4889C41.0165 14.7119 41.0055 14.9758 41.0027 15.0228C41.0018 15.0638 40.9898 15.3279 40.8021 15.5449C40.6135 15.7561 40.4055 15.7561 40.3611 15.7561C35.0895 15.6505 29.8189 15.5449 24.5473 15.4393C24.5048 15.4393 24.306 15.4334 24.147 15.2164C23.988 15.0052 24.0028 14.7471 24.0055 14.706C24.0074 14.6649 24.0222 14.4068 24.2052 14.2014C24.3883 13.9902 24.587 13.9961 24.6296 13.9961C29.8947 14.0841 35.1607 14.1721 40.4267 14.266Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M36.4687 19.3591C36.5075 19.3591 36.7034 19.3649 36.8597 19.5874C37.0159 19.8098 37.0046 20.0733 37.0032 20.1202C37.0011 20.1611 36.9898 20.4246 36.8144 20.6412C36.6391 20.8519 36.4425 20.8461 36.4043 20.8461C32.4406 20.7114 28.4769 20.5768 24.5124 20.4422C24.4757 20.4422 24.2862 20.4363 24.1377 20.2196C23.9892 20.003 24.0027 19.7455 24.0055 19.6986C24.0076 19.6577 24.021 19.4 24.1921 19.1951C24.3632 18.9902 24.552 18.9961 24.5895 18.9961C28.549 19.1132 32.5092 19.2362 36.4687 19.3591Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M47.6287 19.7394C47.9485 19.7452 48.1304 19.9386 48.1648 19.9737C48.3805 20.2022 48.368 20.4717 48.3655 20.5186C48.3635 20.5654 48.3506 20.8291 48.1134 21.0459C48.0761 21.081 47.8758 21.2627 47.5554 21.2568C44.9069 21.1865 42.2583 21.1221 39.6097 21.0518C39.2948 21.0459 39.1175 20.8584 39.0841 20.8232C38.8739 20.5948 38.8883 20.3311 38.8908 20.2842C38.8938 20.2374 38.9082 19.9796 39.1424 19.7628C39.1788 19.7277 39.3771 19.5519 39.6914 19.5578C42.337 19.6163 44.9831 19.6808 47.6287 19.7394Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M47.1084 24.2816C47.7026 24.2927 48.1627 24.8031 48.136 25.369C47.9905 28.4317 47.845 31.4832 47.6985 34.5459C47.6719 35.1118 47.1596 35.5999 46.5613 35.5667C33.4386 34.9342 20.316 34.3017 7.19236 33.6692C6.6473 33.647 6.23643 33.1587 6.27946 32.6261C6.51204 29.7743 6.74357 26.9115 6.97615 24.0597C7.01918 23.527 7.50281 23.0831 8.04378 23.1053C21.065 23.4937 34.0872 23.8821 47.1084 24.2816Z" fill="#BBD5FF"></path>', 19)
  ])]);
}
const Uy = /* @__PURE__ */ g(y9, [["render", _9]]), M9 = {}, L9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function $9(e, t) {
  return l(), s("svg", L9, [...t[0] || (t[0] = [
    N('<path d="M3 8H21" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 12H7" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 18H6C4.34315 18 3 16.6569 3 15V7C3 5.34315 4.34315 4 6 4H18C19.6569 4 21 5.34315 21 7V10" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.5" cy="16.5" r="4.5" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M18.9062 16.5H16.0938" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const Wy = /* @__PURE__ */ g(M9, [["render", $9]]), V9 = {}, B9 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 50",
  class: "h-full w-full shrink-0",
  "aria-hidden": "true"
};
function H9(e, t) {
  return l(), s("svg", B9, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M35.2852 41.4366V13.2539H54.9938V41.4366C54.9938 42.9447 50.5789 44.2014 45.141 44.2014C39.7002 44.2014 35.2852 42.9447 35.2852 41.4366Z" fill="#99A0FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M34.9321 41.4347V13.252C34.9321 13.0635 35.0893 12.9062 35.285 12.9062H54.9936C55.1893 12.9062 55.3464 13.0635 55.3464 13.252V41.4347C55.3464 42.0003 54.9135 42.5658 54.0625 43.0057C52.3873 43.9168 49.022 44.545 45.1408 44.545C41.2596 44.545 37.8912 43.9168 36.2189 43.0057C35.365 42.5658 34.9321 42.0003 34.9321 41.4347ZM35.6378 41.4347C35.6378 41.5918 35.7148 41.7173 35.8364 41.8744C35.9995 42.0629 36.2457 42.2202 36.5541 42.3773C38.1641 43.257 41.4078 43.8225 45.1408 43.8225C48.8738 43.8225 52.1175 43.257 53.7275 42.3773C54.0359 42.2202 54.279 42.0629 54.4451 41.8744C54.5666 41.7173 54.6408 41.5918 54.6408 41.4347V13.5975H35.6378V41.4347Z" fill="#000CAD"></path><path d="M45.1408 16.0123C50.5834 16.0123 54.9954 14.7794 54.9954 13.2583C54.9954 11.7372 50.5834 10.5039 45.1408 10.5039C39.6983 10.5039 35.2861 11.7372 35.2861 13.2583C35.2861 14.7794 39.6983 16.0123 45.1408 16.0123Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M42.315 10.9652C42.1223 10.9966 41.9504 10.8395 41.9356 10.651C41.9178 10.4625 42.0631 10.3057 42.2558 10.2742C43.1691 10.2114 44.1386 10.1484 45.1408 10.1484C49.022 10.1484 52.3873 10.7769 54.0626 11.6881C54.9135 12.1594 55.3464 12.6935 55.3464 13.259C55.3464 13.8246 54.9135 14.3901 54.0626 14.83C52.3873 15.7411 49.022 16.3693 45.1408 16.3693C42.4426 16.3693 39.9935 16.0551 38.1937 15.5838C38.0069 15.521 37.8943 15.3327 37.9447 15.1441C37.998 14.9556 38.1907 14.8611 38.3775 14.8926C40.1299 15.3638 42.5138 15.678 45.1408 15.678C48.8738 15.678 52.1175 15.0813 53.7275 14.2016C54.0359 14.0445 54.279 13.8872 54.4451 13.6987C54.5666 13.5416 54.6408 13.4161 54.6408 13.259C54.6408 13.1019 54.5666 12.9761 54.4451 12.819C54.279 12.6619 54.0359 12.4736 53.7275 12.3165C52.1175 11.4367 48.8738 10.871 45.1408 10.871C44.1564 10.871 43.2105 10.9024 42.315 10.9652Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.5706 44.129V24.4609H38.2792V44.129C38.2792 45.6685 33.8643 46.8938 28.4264 46.8938C22.9856 46.8938 18.5706 45.6685 18.5706 44.129Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.218 44.131V24.463C18.218 24.2745 18.3751 24.1172 18.5708 24.1172H38.2795C38.4752 24.1172 38.6323 24.2745 38.6323 24.463V44.131C38.6323 44.6966 38.1994 45.2621 37.3484 45.702C35.6732 46.6131 32.3079 47.2416 28.4267 47.2416C24.5455 47.2416 21.1771 46.6131 19.5048 45.702C18.6509 45.2621 18.218 44.6966 18.218 44.131ZM18.9237 44.131C18.9237 44.2881 19.0007 44.4139 19.1223 44.571C19.2854 44.7595 19.5316 44.9167 19.84 45.1052C21.45 45.9535 24.6937 46.5503 28.4267 46.5503C32.1597 46.5503 35.4034 45.9535 37.0134 45.1052C37.3218 44.9167 37.5649 44.7595 37.7309 44.571C37.8525 44.4139 37.9267 44.2881 37.9267 44.131V24.8085H18.9237V44.131Z" fill="#000CAD"></path><path d="M28.4265 27.2233C33.869 27.2233 38.281 25.9903 38.281 24.4692C38.281 22.9481 33.869 21.7148 28.4265 21.7148C22.9839 21.7148 18.5718 22.9481 18.5718 24.4692C18.5718 25.9903 22.9839 27.2233 28.4265 27.2233Z" fill="#E0E3FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M33.1767 22.426C32.984 22.3946 32.8534 22.2058 32.8831 22.0173C32.9127 21.8288 33.0936 21.7031 33.2863 21.7031C35.1483 22.0173 36.6487 22.4572 37.553 23.0228C38.2735 23.4312 38.6323 23.9655 38.6323 24.4682C38.6323 25.0338 38.1994 25.5993 37.3484 26.0392C35.6732 26.9503 32.3079 27.5785 28.4267 27.5785C24.5455 27.5785 21.1771 26.9503 19.5048 26.0392C18.6509 25.5993 18.218 25.0338 18.218 24.4682C18.218 24.154 18.4196 23.8082 18.817 23.4941C19.5226 22.9285 20.8836 22.363 22.1201 21.986C22.3068 21.9546 22.5025 22.0488 22.5558 22.2373C22.6122 22.4258 22.5055 22.6145 22.3187 22.6773C21.3343 22.9601 20.258 23.4 19.5582 23.8398C19.3477 23.9655 19.1728 24.1226 19.0512 24.2482C18.98 24.3111 18.9237 24.4054 18.9237 24.4682C18.9237 24.6253 19.0007 24.7508 19.1223 24.9079C19.2854 25.0964 19.5316 25.2537 19.84 25.4108C21.45 26.2905 24.6937 26.8872 28.4267 26.8872C32.1597 26.8872 35.4034 26.2905 37.0134 25.4108C37.3218 25.2537 37.5649 25.0964 37.7309 24.9079C37.8525 24.7508 37.9267 24.6253 37.9267 24.4682C37.9267 24.3425 37.8673 24.2168 37.7694 24.0911C37.636 23.934 37.4374 23.7769 37.1883 23.6199C36.3403 23.1172 34.9261 22.6774 33.1767 22.426Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0.352783 46.8884V35.6719H20.0614V46.8884C20.0614 48.3965 15.6465 49.6532 10.2086 49.6532C4.76779 49.6532 0.352783 48.3965 0.352783 46.8884Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 46.8905V35.6739C0 35.4854 0.15713 35.3281 0.352822 35.3281H20.0615C20.2572 35.3281 20.4143 35.4854 20.4143 35.6739V46.8905C20.4143 47.456 19.9814 48.0216 19.1304 48.4614C17.4552 49.3726 14.0899 50.0008 10.2087 50.0008C6.32744 50.0008 2.95906 49.3726 1.28678 48.4614C0.432849 48.0216 0 47.456 0 46.8905ZM0.705644 46.8905C0.705644 47.0476 0.782712 47.1731 0.904278 47.3302C1.06736 47.5187 1.31357 47.676 1.62194 47.833C3.23195 48.7128 6.47569 49.3095 10.2087 49.3095C13.9417 49.3095 17.1854 48.7128 18.7954 47.833C19.1038 47.676 19.3469 47.5187 19.5129 47.3302C19.6345 47.1731 19.7087 47.0476 19.7087 46.8905V36.0194H0.705644V46.8905Z" fill="#000CAD"></path><path d="M10.2089 38.4342C15.6515 38.4342 20.0635 37.2012 20.0635 35.6801C20.0635 34.1591 15.6515 32.9258 10.2089 32.9258C4.7664 32.9258 0.354248 34.1591 0.354248 35.6801C0.354248 37.2012 4.7664 38.4342 10.2089 38.4342Z" fill="#99A0FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.8955 33.7941C15.7028 33.7627 15.5783 33.574 15.6168 33.3854C15.6554 33.1969 15.8421 33.0714 16.0319 33.1029C17.5796 33.4171 18.8013 33.8569 19.5336 34.3596C20.1237 34.7681 20.4143 35.208 20.4143 35.6793C20.4143 36.2448 19.9814 36.8103 19.1304 37.2502C17.4552 38.1613 14.0899 38.7895 10.2087 38.7895C6.32744 38.7895 2.95906 38.1613 1.28678 37.2502C0.432849 36.8103 0 36.2448 0 35.6793C0 35.208 0.311381 34.7366 0.942934 34.2967C1.72274 33.794 3.0273 33.3542 4.66993 33.04C4.86266 33.0085 5.04653 33.1343 5.08211 33.3229C5.11769 33.5114 4.9931 33.6998 4.80038 33.7312C3.27338 34.014 2.05476 34.4225 1.32833 34.8938C0.951771 35.1451 0.705644 35.3965 0.705644 35.6793C0.705644 35.8364 0.782712 35.9618 0.904278 36.1189C1.06736 36.3075 1.31357 36.4647 1.62194 36.6218C3.23195 37.5016 6.47569 38.0983 10.2087 38.0983C13.9417 38.0983 17.1854 37.5016 18.7954 36.6218C19.1038 36.4647 19.3469 36.3075 19.5129 36.1189C19.6345 35.9618 19.7087 35.8364 19.7087 35.6793C19.7087 35.3965 19.4833 35.1764 19.1364 34.9251C18.4603 34.4852 17.3247 34.0769 15.8955 33.7941Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43.4401 6.09491L45.136 7.65356L46.0757 0L38.2826 1.86103L39.8948 3.37311L27.9075 18.3079L19.8213 16.0048L6.70801 32.3585L10.1743 35.2898L21.7614 20.9597L29.7825 23.2163L43.4401 6.09491Z" fill="#E0E3FF"></path>', 13)
  ])]);
}
const Yy = /* @__PURE__ */ g(V9, [["render", H9]]), F9 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 57 62",
  class: "h-full w-full shrink-0",
  "aria-hidden": "true"
}, A9 = ["id"], j9 = ["mask"], qy = /* @__PURE__ */ I({
  __name: "EmptyWalletIcon",
  setup(e) {
    const t = Xe();
    return (r, n) => (l(), s("svg", F9, [
      n[2] || (n[2] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M54.5177 27.5111C55.3282 28.754 55.5526 30.3572 54.9886 31.8498L45.7591 56.2747C45.2798 57.543 44.3172 58.5695 43.0823 59.1282C41.8507 59.6784 40.4436 59.7284 39.1772 59.2498L5.76134 46.6228C5.49654 46.5228 5.24673 46.3987 5.01113 46.2604C4.9714 46.2355 4.93167 46.2107 4.89194 46.1858L3.37601 45.2679L3.66381 45.0808C2.65955 43.7943 2.3298 42.033 2.94923 40.3937L12.2766 15.71C13.2187 13.2166 16.0087 11.9538 18.5053 12.8972L52.1352 25.6051L52.3877 24.7836L53.9976 26.8413C54.1901 27.0521 54.3641 27.2756 54.5177 27.5111Z",
        fill: "#000CAD"
      }, null, -1)),
      n[3] || (n[3] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M49.507 22.9831C52.4036 23.972 53.9474 27.1304 52.961 30.0195C50.7708 36.4349 47.0846 47.232 44.8943 53.6474C43.9049 56.5452 40.7549 58.0914 37.8583 57.1025C29.6514 54.3006 13.8657 48.9112 5.65883 46.1093C2.76222 45.1204 1.21546 41.9706 2.2048 39.0728C4.39507 32.6574 8.08129 21.8604 10.2716 15.445C11.2579 12.5559 14.4109 11.001 17.3075 11.9899C25.5144 14.7918 41.3001 20.1812 49.507 22.9831Z",
        fill: "#C7CBFF"
      }, null, -1)),
      n[4] || (n[4] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M49.2812 39.7863C49.3378 39.6205 49.5238 39.528 49.6948 39.5864C49.8658 39.6448 49.9574 39.832 49.9008 39.9978L45.2044 53.7538C44.1584 56.8175 40.8215 58.4558 37.7539 57.4085L5.55438 46.4153C2.48677 45.368 0.849379 42.0314 1.89534 38.9677L4.36571 31.7319C4.42233 31.566 4.60832 31.4736 4.77931 31.532C4.95031 31.5904 5.04186 31.7776 4.98524 31.9434L2.51488 39.1792C1.58513 41.9025 3.04036 44.865 5.76597 45.7955L37.9655 56.7887C40.6911 57.7193 43.6551 56.2655 44.5848 53.5423L49.2812 39.7863Z",
        fill: "#000CAD"
      }, null, -1)),
      n[5] || (n[5] = o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M51.2897 29.116L42.9181 53.6368C42.3426 55.3224 40.4991 56.2322 38.8071 55.6545L5.80369 44.3869C4.11173 43.8092 3.2094 41.962 3.7849 40.2764L12.1565 15.7556C12.7347 14.062 14.5756 13.1601 16.2675 13.7378L49.271 25.0055C50.9629 25.5831 51.8679 27.4224 51.2897 29.116Z",
        fill: "#000CAD"
      }, null, -1)),
      o("mask", {
        id: D(t),
        style: { "mask-type": "luminance" },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "13",
        width: "49",
        height: "43"
      }, [...n[0] || (n[0] = [
        o("path", {
          d: "M51.2897 29.116L42.9181 53.6368C42.3426 55.3224 40.4991 56.2322 38.8071 55.6545L5.80369 44.3869C4.11173 43.8092 3.2094 41.962 3.7849 40.2764L12.1565 15.7556C12.7347 14.062 14.5756 13.1601 16.2675 13.7378L49.271 25.0055C50.9629 25.5831 51.8679 27.4224 51.2897 29.116Z",
          fill: "white"
        }, null, -1)
      ])], 8, A9),
      o("g", {
        mask: `url(#${D(t)})`
      }, [...n[1] || (n[1] = [
        o("path", {
          d: "M47.7834 43.2485L6.41504 29.125L1.33266 44.0115L42.701 58.135L47.7834 43.2485Z",
          fill: "#C7CBFF"
        }, null, -1)
      ])], 8, j9),
      n[6] || (n[6] = N('<path fill-rule="evenodd" clip-rule="evenodd" d="M52.5764 19.3444C53.0753 19.5168 53.4852 19.8804 53.7164 20.3552C53.9472 20.8299 53.9801 21.377 53.8077 21.8759C52.2013 26.5243 48.0588 38.5109 46.4524 43.1593C46.28 43.6582 45.9163 44.0682 45.4417 44.2991C44.9667 44.5298 44.4197 44.5627 43.9208 44.3903C37.6635 42.2279 17.594 35.2921 11.3368 33.1296C10.8378 32.9572 10.4278 32.5936 10.1969 32.1189C9.96602 31.6441 9.93317 31.0972 10.1056 30.5982C11.7121 25.9499 15.8545 13.9632 17.4609 9.31486C17.6333 8.81592 17.9969 8.40589 18.4717 8.17503C18.9464 7.94415 19.4934 7.9113 19.9923 8.08374C26.2496 10.2462 46.3191 17.182 52.5764 19.3444Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.0552 12.595C50.5749 12.6876 51.0365 12.9827 51.3389 13.4157C51.6408 13.8487 51.7586 14.3839 51.6661 14.9036C50.804 19.7456 48.581 32.2315 47.7189 37.0735C47.6264 37.5932 47.3311 38.0548 46.8982 38.3569C46.465 38.6589 45.9299 38.7767 45.4102 38.6841C38.8923 37.5237 17.9868 33.8016 11.4689 32.6411C10.9492 32.5486 10.4875 32.2533 10.1854 31.8205C9.88334 31.3875 9.76562 30.8524 9.85819 30.3326C10.7203 25.4906 12.9433 13.0047 13.8054 8.16275C13.8979 7.64304 14.1931 7.18134 14.6261 6.87928C15.059 6.57721 15.5942 6.45949 16.1139 6.55202C22.6318 7.71248 43.5373 11.4346 50.0552 12.595Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M50.4323 12.3377C50.9711 12.4337 51.4493 12.7396 51.7624 13.1883C52.0755 13.637 52.1975 14.1917 52.1016 14.7303L48.065 37.4021C47.9691 37.9408 47.6631 38.4194 47.2144 38.7324C46.7657 39.0455 46.2113 39.1672 45.6725 39.0713L11.2292 32.9389C10.6906 32.843 10.212 32.5374 9.899 32.0887C9.58592 31.64 9.46393 31.0852 9.55984 30.5465L13.5964 7.87473C13.6923 7.33609 13.9983 6.85758 14.447 6.5445C14.8956 6.23146 15.4503 6.10945 15.989 6.20535L50.4323 12.3377ZM50.3175 12.9823L15.8742 6.84995C15.5065 6.78449 15.1279 6.86778 14.8216 7.0815C14.5153 7.29517 14.3065 7.62182 14.241 7.9895L10.2045 30.6613C10.139 31.029 10.2223 31.4076 10.436 31.7137C10.6497 32.0201 10.9763 32.2292 11.344 32.2946L45.7872 38.427C46.155 38.4925 46.5335 38.4089 46.8399 38.1952C47.1462 37.9816 47.3549 37.655 47.4204 37.2873L51.4569 14.6155C51.5224 14.2478 51.4393 13.8692 51.2255 13.563C51.0118 13.2567 50.6853 13.0478 50.3175 12.9823Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8096 35.4346C9.71116 35.4825 8.7819 34.631 8.73398 33.5328C8.51527 28.52 7.9433 15.4105 7.72459 10.3978C7.67668 9.29956 8.52825 8.3704 9.6267 8.32247C16.3605 8.02868 38.2604 7.07318 44.9945 6.77936C46.0928 6.73144 47.022 7.58291 47.0699 8.68116C47.2886 13.6939 47.8605 26.8033 48.0793 31.8161C48.1272 32.9144 47.2757 33.8435 46.1775 33.8914C39.4433 34.1853 17.5434 35.1408 10.8096 35.4346Z" fill="#0012FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M40.1884 28.9551C39.9333 28.9663 39.6849 28.8784 39.4963 28.7002C39.3082 28.5329 39.1959 28.2856 39.1849 28.0338C39.1582 27.4208 39.1233 26.6217 39.0966 26.0086C39.0856 25.7569 39.1759 25.5006 39.3488 25.3176C39.5211 25.1237 39.7609 25.0145 40.016 25.0034C40.9101 24.9644 42.2343 24.9066 43.1285 24.8676C43.3835 24.8565 43.6328 24.9443 43.8214 25.1225C44.0095 25.2898 44.1218 25.5371 44.1328 25.7889C44.1595 26.4019 44.1944 27.201 44.2212 27.8141C44.2321 28.0658 44.1418 28.322 43.969 28.5051C43.7966 28.699 43.5559 28.8082 43.3009 28.8193C42.4067 28.8583 41.0825 28.9161 40.1884 28.9551Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43.5662 51.7309L4.43321 38.3706L7.94806 28.0755L12.786 29.7272C13.7087 30.0422 14.7173 29.9468 15.5435 29.4637L16.5746 28.8571C17.4034 28.3661 18.4128 28.271 19.3347 28.5857L37.7605 34.8765C38.6824 35.1912 39.4229 35.8838 39.7776 36.7788L40.2233 37.8896C40.5807 38.7768 41.3212 39.4694 42.2431 39.7841L47.081 41.4358L43.5662 51.7309Z" fill="#C7CBFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6783 30.0417C12.5074 29.9833 12.4173 29.7943 12.4765 29.621C12.5329 29.4556 12.7198 29.3611 12.8908 29.4195C13.7219 29.7032 14.632 29.6181 15.3783 29.1781L16.4095 28.5715C17.3182 28.0374 18.426 27.9319 19.4395 28.2779L37.8653 34.5687C38.8779 34.9144 39.6908 35.6756 40.0824 36.6536L40.528 37.7645C40.8486 38.5687 41.5167 39.1926 42.3478 39.4764L46.9031 41.0316C47.074 41.0899 47.1649 41.2792 47.1085 41.4447C47.0493 41.618 46.8616 41.7122 46.6906 41.6538L42.1354 40.0986C41.1228 39.7529 40.3126 38.9838 39.9211 38.0058L39.4753 36.895C39.1521 36.0986 38.4867 35.4668 37.6556 35.1831L19.2297 28.8923C18.3985 28.6085 17.4858 28.7015 16.7422 29.1337L15.7111 29.7402C14.8024 30.2743 13.6918 30.3877 12.6783 30.0417Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43.6422 50.4911C43.7012 50.3182 43.8867 50.2272 44.0579 50.2856C44.229 50.344 44.321 50.5298 44.262 50.7027L43.4946 52.9503C42.7125 55.2411 40.2195 56.4651 37.927 55.6824L24.4788 51.0911C24.3076 51.0326 24.2165 50.8471 24.2726 50.6829C24.3316 50.51 24.5171 50.4189 24.6883 50.4774L38.1365 55.0687C40.0867 55.7345 42.2078 54.6923 42.8748 52.7387L43.6422 50.4911Z" fill="#000CAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M23.5348 35.6974C24.0327 35.4448 24.6362 35.646 24.8829 36.1469C25.1209 36.6239 25.4141 37.2031 25.652 37.6802C25.9008 38.1748 25.6977 38.7839 25.2018 39.0302C24.7252 39.2689 24.1431 39.5563 23.6665 39.795C23.1685 40.0476 22.5651 39.8464 22.3184 39.3455C22.0804 38.8685 21.7872 38.2893 21.5493 37.8123C21.3004 37.3176 21.5035 36.7086 21.9994 36.4622C22.476 36.2235 23.0582 35.9362 23.5348 35.6974Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M27.3761 15.4069L26.3851 15.468L26.1452 11.5789C26.1294 11.323 26.2244 11.0709 26.3934 10.8789C26.5624 10.686 26.7965 10.5702 27.0568 10.5541L30.3301 10.3522C30.5903 10.3362 30.8369 10.4224 31.0283 10.5931C31.2196 10.7628 31.3347 11.0019 31.3505 11.2578L31.5904 15.1469L30.6095 15.2074L30.3817 11.5146C30.3776 11.4472 30.3141 11.397 30.254 11.4008L29.313 11.4588C29.2429 11.4631 29.1963 11.5201 29.2004 11.5874L29.3544 14.0827L28.4835 14.1364L28.3296 11.6411C28.3255 11.5738 28.272 11.523 28.2019 11.5273L27.2609 11.5854C27.2008 11.5891 27.1442 11.6467 27.1483 11.714L27.3761 15.4069Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M27.7309 21.1608L26.7398 21.2219L26.4999 17.3328C26.4841 17.0769 26.5792 16.8248 26.7482 16.6328C26.9172 16.4399 27.1512 16.3241 27.4115 16.308L30.6848 16.1061C30.9451 16.0901 31.1916 16.1763 31.383 16.347C31.5744 16.5167 31.6895 16.7559 31.7053 17.0117L31.9451 20.9008L30.9643 20.9613L30.7365 17.2685C30.7323 17.2011 30.6688 17.151 30.6088 17.1547L27.6156 17.3393C27.5556 17.343 27.4989 17.4006 27.5031 17.4679L27.7309 21.1608Z" fill="white"></path><path d="M32.0658 22.8207L31.9827 21.4727L27.0471 26.2119L27.1302 27.5599L32.0658 22.8207Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M32.2574 23.6642C32.2574 23.6642 33.4306 25.3767 32.9454 26.3387C32.4603 27.3007 30.0575 26.6429 26.8425 22.8945L26.7579 21.5238C26.7579 21.5238 30.0278 25.4629 31.9737 25.2866C31.9737 25.2866 32.7956 25.3027 32.2574 23.6642Z" fill="#C7CBFF"></path>', 13))
    ]));
  }
}), I9 = {}, Z9 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function E9(e, t) {
  return l(), s("svg", Z9, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.86333 4.2041H16.1358C16.8892 4.2041 17.5 4.81493 17.5 5.56827V14.4316C17.5 15.1849 16.8892 15.7949 16.1367 15.7949H3.86333C3.11083 15.7958 2.5 15.1849 2.5 14.4316V5.56827C2.5 4.81493 3.11083 4.2041 3.86333 4.2041Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2.59912 5.06245L9.01079 9.64828C9.58995 10.0624 10.3683 10.0633 10.9483 9.64995L17.3966 5.05078",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ky = /* @__PURE__ */ g(I9, [["render", E9]]), S9 = {}, z9 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function D9(e, t) {
  return l(), s("svg", z9, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M12.3025 17.961L16.0058 17.1377C16.6842 16.9877 17.1667 16.3861 17.1667 15.6919V5.26605C17.1667 4.57188 16.6842 3.97022 16.0067 3.82022L12.3033 2.99688C11.3775 2.79105 10.5 3.49522 10.5 4.44355V16.5152C10.5 17.4627 11.3775 18.1669 12.3025 17.961V17.961Z" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.9997 9.61133V11.278" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.83301 13.7949V15.4966C3.83301 16.4174 4.57884 17.1633 5.49967 17.1633H7.99967" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.83301 7.12826V5.46159C3.83301 4.54076 4.57884 3.79492 5.49967 3.79492H7.99967" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.83301 10.4616H7.99967" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.33301 12.1283L7.99967 10.4616L6.33301 8.79492" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const T9 = /* @__PURE__ */ g(S9, [["render", D9]]), O9 = {}, P9 = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R9(e, t) {
  return l(), s("svg", P9, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.6675 6.6614C6.6675 7.06108 6.93415 7.32753 7.33412 7.32753C7.73409 7.32753 8.00073 7.06108 8.00073 6.6614V0.666139C8.00073 0.266456 7.73409 0 7.33412 0H1.33458C0.934615 0 0.667969 0.266456 0.667969 0.666139C0.667969 1.06582 0.934615 1.33228 1.33458 1.33228H5.73427L0.199985 6.86756C-0.0666615 7.13402 -0.0666615 7.5337 0.199985 7.80016C0.333308 7.93339 0.466631 8 0.666615 8C0.8666 8 0.999923 7.93339 1.13325 7.80016L6.6675 2.2649V6.6614Z",
      fill: "black"
    }, null, -1)
  ])]);
}
const Qy = /* @__PURE__ */ g(O9, [["render", R9]]), N9 = {}, G9 = {
  class: "w-5 h-5",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function U9(e, t) {
  return l(), s("svg", G9, [...t[0] || (t[0] = [
    o("path", {
      d: "M4.6665 4.66667V3.33333C4.6665 2.59695 5.26346 2 5.99984 2H12.6665C13.4029 2 13.9998 2.59695 13.9998 3.33333V8",
      stroke: "#9DA1C3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14 12.666V7.99935C14 7.26297 13.403 6.66602 12.6667 6.66602H8.35679C8.13389 6.66602 7.92574 6.55461 7.80209 6.36915L6.86459 4.96288C6.74094 4.77742 6.53279 4.66602 6.30989 4.66602H3.33333C2.59695 4.66602 2 5.26297 2 5.99935V12.666C1.9999 13.0197 2.14035 13.3589 2.39042 13.6089C2.64049 13.859 2.97968 13.9994 3.33333 13.9993H12.6667C13.0203 13.9994 13.3595 13.859 13.6096 13.6089C13.8597 13.3589 14.0001 13.0197 14 12.666Z",
      stroke: "#9DA1C3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.3335 4.33333H11.3335",
      stroke: "#9DA1C3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Xy = /* @__PURE__ */ g(N9, [["render", U9]]), W9 = {}, Y9 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function q9(e, t) {
  return l(), s("svg", Y9, [...t[0] || (t[0] = [
    N('<path d="M10.0042 13.3413V6.67188" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.5053 10.8398L10.0042 13.3409L7.50317 10.8398" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.94434 2.5C14.0882 2.5 17.4475 5.85926 17.4475 10.0031C17.4475 14.147 14.0882 17.5062 9.94434 17.5062" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.38065 17.048C6.55821 16.7503 5.79417 16.311 5.12305 15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.12305 4.25898C5.79376 3.69743 6.55791 3.25808 7.38065 2.96094" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.56128 8.70326C2.71192 7.84098 3.01302 7.0119 3.45082 6.25391" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.56128 11.3047C2.71183 12.1673 3.01293 12.9966 3.45082 13.7549" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const Jy = /* @__PURE__ */ g(W9, [["render", q9]]), K9 = {}, Q9 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X9(e, t) {
  return l(), s("svg", Q9, [...t[0] || (t[0] = [
    o("path", {
      d: "M2.5 5H17.5M5 10H15M7.5 15H12.5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const eb = /* @__PURE__ */ g(K9, [["render", X9]]), J9 = {}, es = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ts(e, t) {
  return l(), s("svg", es, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.167 0c.375 0 .679.304.679.679v6.848l4.843-4.842a.679.679 0 0 1 .96.96l-4.843 4.843h6.848a.679.679 0 0 1 0 1.358h-6.848l4.843 4.842a.679.679 0 1 1-.96.96l-4.843-4.842v6.848a.679.679 0 0 1-1.358 0v-6.848l-4.843 4.842a.679.679 0 1 1-.96-.96l4.843-4.842H.68a.679.679 0 0 1 0-1.358h6.848L2.685 2.645a.679.679 0 1 1 .96-.96l4.843 4.842V.68c0-.375.304-.679.679-.679z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const tb = /* @__PURE__ */ g(J9, [["render", ts]]), os = {}, ns = {
  width: "189",
  height: "277",
  viewBox: "0 0 189 277",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function rs(e, t) {
  return l(), s("svg", ns, [...t[0] || (t[0] = [
    o("g", { filter: "url(#filter0_d_4322_74851)" }, [
      o("path", {
        d: "M14.3281 141.453C14.3281 137.057 17.892 133.493 22.2883 133.493H98.9643C100.853 133.493 102.681 132.822 104.12 131.598L115.581 121.856C117.021 120.633 118.848 119.961 120.737 119.961H166.368C170.764 119.961 174.328 123.525 174.328 127.921V243.344C174.328 247.74 170.764 251.304 166.368 251.304H22.2883C17.892 251.304 14.3281 247.74 14.3281 243.344V141.453Z",
        fill: "#000652"
      }),
      o("path", {
        d: "M120.736 120.359H166.368C170.544 120.359 173.93 123.745 173.93 127.921V243.344C173.93 247.52 170.545 250.906 166.368 250.906H22.2881C18.1117 250.906 14.7266 247.52 14.7266 243.344V141.453C14.7267 137.277 18.1118 133.892 22.2881 133.892H98.9639C100.947 133.892 102.867 133.186 104.378 131.901L115.839 122.159C117.206 120.997 118.942 120.359 120.736 120.359Z",
        stroke: "#000CAD",
        "stroke-opacity": "0.4",
        "stroke-width": "0.79602"
      }),
      o("rect", {
        x: "132.934",
        y: "129.512",
        width: "15.9204",
        height: "3.18408",
        rx: "0.79602",
        fill: "#5763FF"
      }),
      o("rect", {
        x: "152.835",
        y: "129.512",
        width: "10.3483",
        height: "3.18408",
        rx: "0.79602",
        fill: "#5763FF"
      }),
      o("g", { filter: "url(#filter1_d_4322_74851)" }, [
        o("g", { "clip-path": "url(#clip0_4322_74851)" }, [
          o("rect", {
            x: "156.417",
            y: "3.18359",
            width: "93.1343",
            height: "124.179",
            rx: "7.9602",
            transform: "rotate(90 156.417 3.18359)",
            fill: "white"
          }),
          o("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M139.647 20.2935C141.188 21.8349 141.188 24.3334 139.647 25.8747L139.5 26.0153C137.95 27.4148 135.559 27.3678 134.065 25.8747C132.524 24.3335 132.524 21.8349 134.065 20.2935C135.607 18.7522 138.105 18.7522 139.647 20.2935ZM138.838 24.6957C139.655 23.6926 139.597 22.2134 138.662 21.2784C137.664 20.2811 136.048 20.2811 135.05 21.2784C134.053 22.2758 134.053 23.8926 135.05 24.8898C135.985 25.8246 137.465 25.8833 138.468 25.0658L138.662 24.8898L138.838 24.6957Z",
            fill: "#99A0FF"
          }),
          o("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M141.329 16.6813C144.865 20.2173 144.865 25.9509 141.329 29.487L140.991 29.8081C137.436 33.0194 131.949 32.9125 128.523 29.487C124.987 25.9509 124.987 20.2173 128.523 16.6813C132.059 13.1454 137.793 13.1452 141.329 16.6813ZM130.515 20.7552C130.515 20.2293 130.316 19.7219 129.958 19.3349L129.959 19.334L129.905 19.2787L129.903 19.276C129.7 19.057 129.456 18.8795 129.185 18.7536L129.067 18.7028L128.735 18.5695C126.775 21.2499 126.775 24.9149 128.733 27.5961L129.067 27.4637L129.068 27.4628C129.385 27.3371 129.669 27.1421 129.902 26.8914L129.956 26.8324L129.958 26.8306C130.271 26.4931 130.463 26.0627 130.506 25.6081L130.515 25.4122L130.515 20.7552ZM140.615 28.2155C143.332 25.2079 143.243 20.5646 140.344 17.6662C137.421 14.7428 132.723 14.6776 129.719 17.4666C130.173 17.669 130.583 17.9598 130.922 18.3255L130.977 18.3854L130.981 18.389C131.576 19.0325 131.908 19.8774 131.908 20.7552L131.908 25.4122L131.904 25.5764C131.865 26.3947 131.538 27.1755 130.979 27.7784L130.926 27.8364L130.925 27.8373C130.585 28.2042 130.174 28.4978 129.717 28.7007C132.625 31.402 137.121 31.4266 140.057 28.7733L140.344 28.5021L140.615 28.2155Z",
            fill: "#99A0FF"
          }),
          o("rect", {
            x: "144.478",
            y: "50.1504",
            width: "36.6169",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 144.478 50.1504)",
            fill: "#E2E4EE"
          }),
          o("rect", {
            x: "136.517",
            y: "50.1504",
            width: "11.1443",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 136.517 50.1504)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "112.636",
            y: "14.3281",
            width: "29.4527",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 112.636 14.3281)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "80.7959",
            y: "66.0684",
            width: "9.55224",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 80.7959 66.0684)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "80.7959",
            y: "14.3281",
            width: "27.0647",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 80.7959 14.3281)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "80.7959",
            y: "46.9648",
            width: "14.3284",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 80.7959 46.9648)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "128.557",
            y: "50.1504",
            width: "18.3085",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 128.557 50.1504)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "104.676",
            y: "14.3281",
            width: "57.3134",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 104.676 14.3281)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "47.3633",
            y: "70.8438",
            width: "15.9204",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 47.3633 70.8438)",
            fill: "#99A0FF"
          }),
          o("rect", {
            x: "47.3633",
            y: "14.3281",
            width: "27.0647",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 47.3633 14.3281)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "136.517",
            y: "64.4766",
            width: "11.1443",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 136.517 64.4766)",
            fill: "#ECEEF3"
          }),
          o("rect", {
            x: "96.7168",
            y: "14.3281",
            width: "41.393",
            height: "4.77612",
            rx: "0.79602",
            transform: "rotate(90 96.7168 14.3281)",
            fill: "#ECEEF3"
          })
        ])
      ]),
      o("foreignObject", {
        x: "7.16395",
        y: "134.289",
        width: "174.328",
        height: "124.18"
      }, [
        o("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: { "backdrop-filter": "blur(3.58px)", "clip-path": "url(#bgblur_1_4322_74851_clip_path)", height: "100%", width: "100%" }
        })
      ]),
      o("g", { "data-figma-bg-blur-radius": "7.16418" }, [
        o("path", {
          d: "M14.3281 149.413C14.3281 145.017 17.892 141.453 22.2883 141.453H57.4689C60.7353 141.453 63.9227 142.458 66.5986 144.331L78.2765 152.506C80.9525 154.379 84.1399 155.383 87.4063 155.383H166.368C170.764 155.383 174.328 158.947 174.328 163.344V243.344C174.328 247.74 170.764 251.304 166.368 251.304H22.2883C17.892 251.304 14.3281 247.74 14.3281 243.344V149.413Z",
          fill: "#000CAD",
          "fill-opacity": "0.4"
        }),
        o("path", {
          d: "M22.2881 141.852H57.4688C60.6535 141.852 63.7611 142.831 66.3701 144.657L78.0479 152.832C80.7907 154.752 84.0582 155.781 87.4062 155.781H166.368C170.545 155.781 173.93 159.167 173.93 163.344V243.344C173.93 247.52 170.545 250.906 166.368 250.906H22.2881C18.1117 250.906 14.7266 247.52 14.7266 243.344V149.413C14.7267 145.237 18.1118 141.852 22.2881 141.852Z",
          stroke: "#000CAD",
          "stroke-opacity": "0.4",
          "stroke-width": "0.79602"
        })
      ]),
      o("path", {
        d: "M46.0415 239.057L27.6592 217.977H33.3594L51.7418 239.057H46.0415Z",
        fill: "#F0F1FF"
      }),
      o("path", {
        d: "M27.064 239.059L27.6317 238.654C28.2975 238.178 28.9504 237.696 29.5752 237.22C34.0021 233.951 37.9207 230.084 41.2109 225.736C43.7462 222.168 44.5382 219.468 43.4368 218.12C43.1007 217.783 42.6897 217.525 42.2348 217.365C41.78 217.205 41.2935 217.148 40.8124 217.198C39.7567 217.224 38.7087 217.381 37.6945 217.666L37.5943 217.693C37.533 217.711 37.4679 217.712 37.4059 217.697C37.344 217.682 37.2873 217.651 37.2419 217.607C37.1766 217.542 37.14 217.455 37.14 217.365C37.14 217.274 37.1766 217.187 37.2419 217.123C37.2636 217.102 37.2882 217.084 37.315 217.07L37.333 217.061L37.4902 216.988C40.089 215.676 42.9404 214.899 45.8648 214.707C46.5178 214.645 47.1765 214.731 47.7898 214.956C48.403 215.181 48.9542 215.541 49.4003 216.006C50.7611 217.676 50.0942 220.688 47.523 224.486C44.5836 228.831 40.9353 232.685 36.7202 235.899C35.2674 237.008 33.7705 238.059 32.2706 239.021L32.2125 239.059H27.064Z",
        fill: "#C7CBFF"
      }),
      o("path", {
        d: "M43.5222 229.612C42.5589 230.688 41.5473 231.722 40.4873 232.713L42.4518 234.934L43.7184 229.85L43.5272 229.607H43.5222",
        fill: "#000657"
      })
    ], -1),
    N('<defs><filter id="filter0_d_4322_74851" x="-0.000232697" y="-0.000486374" width="188.657" height="276.778" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="11.1443"></feOffset><feGaussianBlur stdDeviation="7.16418"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4322_74851"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4322_74851" result="shape"></feBlend></filter><filter id="filter1_d_4322_74851" x="31.3494" y="3.18359" width="125.957" height="94.9125" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.888889"></feOffset><feGaussianBlur stdDeviation="0.444444"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4322_74851"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4322_74851" result="shape"></feBlend></filter><clipPath id="bgblur_1_4322_74851_clip_path" transform="translate(-7.16395 -134.289)"><path d="M14.3281 149.413C14.3281 145.017 17.892 141.453 22.2883 141.453H57.4689C60.7353 141.453 63.9227 142.458 66.5986 144.331L78.2765 152.506C80.9525 154.379 84.1399 155.383 87.4063 155.383H166.368C170.764 155.383 174.328 158.947 174.328 163.344V243.344C174.328 247.74 170.764 251.304 166.368 251.304H22.2883C17.892 251.304 14.3281 247.74 14.3281 243.344V149.413Z"></path></clipPath><clipPath id="clip0_4322_74851"><rect x="156.417" y="3.18359" width="93.1343" height="124.179" rx="7.9602" transform="rotate(90 156.417 3.18359)" fill="white"></rect></clipPath></defs>', 1)
  ])]);
}
const ob = /* @__PURE__ */ g(os, [["render", rs]]), nb = /* @__PURE__ */ I({
  __name: "FolderIcon",
  props: {
    color: {}
  },
  setup(e) {
    const t = e, r = f(() => t.color === "primary" ? "text-primary" : "text-subtitle-gray");
    return (n, i) => (l(), s("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: v(r.value)
    }, [...i[0] || (i[0] = [
      o("path", {
        d: "M13 8H3",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M21 17.7521V10C21 8.89543 20.1046 8 19 8H13L10.9271 4.8906C10.5561 4.33421 9.9317 4.00001 9.263 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])], 2));
  }
}), ls = {}, ss = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function is(e, t) {
  return l(), s("svg", ss, [...t[0] || (t[0] = [
    o("path", { d: "M2.66669 12.6667L5.33335 10" }, null, -1),
    o("path", { d: "M5.33331 12V10H3.33331" }, null, -1),
    o("path", { d: "M7.33333 13.3332H12.6667C13.403 13.3332 14 12.7362 14 11.9998V5.95984C14 5.22346 13.403 4.6265 12.6667 4.6265H8.35276C8.13209 4.6265 7.92571 4.51731 7.80157 4.33486L6.86491 2.95815C6.74077 2.77569 6.53438 2.66649 6.31369 2.6665H3.33333C2.59695 2.6665 2 3.26346 2 3.99984V7.99984" }, null, -1)
  ])]);
}
const rb = /* @__PURE__ */ g(ls, [["render", is]]), as = {}, ds = {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function us(e, t) {
  return l(), s("svg", ds, [...t[0] || (t[0] = [
    N('<path d="M16.8745 12.5051L17.714 9.64304C17.8632 9.13858 17.7655 8.59333 17.4505 8.17201C17.1356 7.75068 16.6402 7.5027 16.1142 7.50298H7.90994C7.17335 7.50293 6.52401 7.98621 6.31261 8.69181L4.37263 15.1587C4.25128 15.5636 3.87828 15.8406 3.45558 15.8398C3.2022 15.8396 2.95928 15.7387 2.78026 15.5594C2.60124 15.38 2.5008 15.1369 2.50102 14.8836V4.16826C2.50102 3.2474 3.24752 2.5009 4.16838 2.5009H7.89077C8.16961 2.50104 8.42991 2.64058 8.58439 2.87272L9.75404 4.63095C9.9092 4.86351 10.1706 5.00282 10.4502 5.00194H14.1725C15.0934 5.00194 15.8399 5.74844 15.8399 6.6693V7.50298" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.7557 18.3408C12.2383 18.3408 10.8704 17.4268 10.2897 16.0249C9.70905 14.6231 10.03 13.0095 11.103 11.9365C12.1759 10.8636 13.7895 10.5426 15.1914 11.1233C16.5932 11.7039 17.5073 13.0719 17.5073 14.5893C17.5073 16.6612 15.8276 18.3408 13.7557 18.3408" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.2184 15.8398H3.45642" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.8712 13.7047L14.6402 15.4738" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.8712 15.4738L14.6402 13.7047" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const lb = /* @__PURE__ */ g(as, [["render", us]]), cs = {}, hs = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ps(e, t) {
  return l(), s("svg", hs, [...t[0] || (t[0] = [
    o("path", {
      d: "M19.8498 18.6847C20.9995 18.6847 22.1235 18.3438 23.0794 17.705C24.0354 17.0662 24.7804 16.1583 25.2204 15.096C25.6603 14.0338 25.7754 12.8649 25.551 11.7373C25.3266 10.6097 24.7728 9.5739 23.9598 8.761C23.1467 7.94809 22.1108 7.39455 20.9831 7.17039C19.8555 6.94623 18.6866 7.06151 17.6245 7.50166C16.5623 7.94181 15.6545 8.68705 15.016 9.64314C14.3774 10.5992 14.0366 11.7232 14.0369 12.873C14.0387 14.414 14.6518 15.8913 15.7416 16.9808C16.8313 18.0704 18.3088 18.6832 19.8498 18.6847ZM19.8498 9.41296C20.5341 9.41296 21.2031 9.61588 21.7721 9.99607C22.3411 10.3763 22.7846 10.9166 23.0464 11.5489C23.3083 12.1811 23.3768 12.8768 23.2433 13.548C23.1098 14.2191 22.7803 14.8357 22.2964 15.3195C21.8125 15.8034 21.196 16.133 20.5248 16.2665C19.8536 16.4 19.158 16.3315 18.5257 16.0696C17.8935 15.8077 17.3531 15.3642 16.9729 14.7952C16.5927 14.2262 16.3898 13.5573 16.3898 12.873C16.3911 11.9557 16.756 11.0764 17.4046 10.4277C18.0532 9.77914 18.9325 9.4142 19.8498 9.41296Z",
      fill: "#1A1AC3"
    }, null, -1),
    o("path", {
      d: "M8.86854 22.1013C9.75274 22.1013 10.6171 21.8391 11.3523 21.3479C12.0874 20.8567 12.6605 20.1585 12.9988 19.3416C13.3372 18.5247 13.4257 17.6258 13.2532 16.7586C13.0807 15.8914 12.6549 15.0948 12.0297 14.4696C11.4045 13.8443 10.6079 13.4186 9.74071 13.2461C8.8735 13.0736 7.97461 13.1621 7.15772 13.5005C6.34082 13.8388 5.64261 14.4118 5.15138 15.147C4.66014 15.8822 4.39795 16.7465 4.39795 17.6307C4.39795 18.8164 4.86896 19.9535 5.70735 20.7919C6.54575 21.6303 7.68286 22.1013 8.86854 22.1013ZM8.86854 15.5131C9.28737 15.5131 9.69679 15.6373 10.045 15.87C10.3933 16.1027 10.6647 16.4334 10.825 16.8204C10.9853 17.2073 11.0272 17.6331 10.9455 18.0439C10.8638 18.4547 10.6621 18.832 10.3659 19.1281C10.0698 19.4243 9.69245 19.626 9.28167 19.7077C8.87089 19.7894 8.4451 19.7475 8.05815 19.5872C7.6712 19.4269 7.34047 19.1555 7.10778 18.8072C6.87509 18.459 6.75089 18.0496 6.75089 17.6307C6.75089 17.0691 6.974 16.5305 7.37113 16.1333C7.76827 15.7362 8.3069 15.5131 8.86854 15.5131Z",
      fill: "#1A1AC3"
    }, null, -1),
    o("path", {
      d: "M30.8297 22.1013C31.7139 22.1013 32.5783 21.8391 33.3134 21.3479C34.0486 20.8567 34.6216 20.1585 34.96 19.3416C35.2984 18.5247 35.3869 17.6258 35.2144 16.7586C35.0419 15.8914 34.6161 15.0948 33.9909 14.4696C33.3657 13.8443 32.5691 13.4186 31.7019 13.2461C30.8347 13.0736 29.9358 13.1621 29.1189 13.5005C28.302 13.8388 27.6038 14.4118 27.1126 15.147C26.6213 15.8822 26.3591 16.7465 26.3591 17.6307C26.3591 18.8164 26.8301 19.9535 27.6685 20.7919C28.5069 21.6303 29.644 22.1013 30.8297 22.1013ZM30.8297 15.5131C31.2486 15.5131 31.658 15.6373 32.0062 15.87C32.3545 16.1027 32.6259 16.4334 32.7862 16.8204C32.9465 17.2073 32.9884 17.6331 32.9067 18.0439C32.825 18.4547 32.6233 18.832 32.3271 19.1281C32.031 19.4243 31.6536 19.626 31.2429 19.7077C30.8321 19.7894 30.4063 19.7475 30.0193 19.5872C29.6324 19.4269 29.3016 19.1555 29.069 18.8072C28.8363 18.459 28.7121 18.0496 28.7121 17.6307C28.7121 17.0691 28.9352 16.5305 29.3323 16.1333C29.7295 15.7362 30.2681 15.5131 30.8297 15.5131Z",
      fill: "#1A1AC3"
    }, null, -1),
    o("path", {
      d: "M30.9864 24.461C29.9551 24.4678 28.9417 24.7318 28.0382 25.2292C27.1792 23.8693 25.9953 22.7446 24.5931 21.9566C23.1909 21.1685 21.6146 20.7419 20.0064 20.7151C18.3982 20.7419 16.8219 21.1685 15.4197 21.9566C14.0176 22.7446 12.8336 23.8693 11.9747 25.2292C11.0711 24.7318 10.0578 24.4678 9.02641 24.461C7.1757 24.5513 5.43588 25.3701 4.18677 26.7387C2.93766 28.1073 2.28071 29.9144 2.35936 31.7657C2.35936 32.0777 2.4833 32.3769 2.70394 32.5976C2.92457 32.8182 3.22381 32.9421 3.53583 32.9421C3.84785 32.9421 4.14709 32.8182 4.36772 32.5976C4.58835 32.3769 4.7123 32.0777 4.7123 31.7657C4.63519 30.5387 5.04484 29.3308 5.85243 28.4038C6.66001 27.4769 7.80043 26.9056 9.02641 26.8139C9.67655 26.8189 10.3148 26.9885 10.8817 27.3069C10.3273 28.7042 10.0434 30.1941 10.0452 31.6974C10.0452 32.0095 10.1692 32.3087 10.3898 32.5293C10.6104 32.75 10.9097 32.8739 11.2217 32.8739C11.5337 32.8739 11.833 32.75 12.0536 32.5293C12.2742 32.3087 12.3982 32.0095 12.3982 31.6974C12.3982 26.9386 15.8099 23.068 20.0064 23.068C24.2029 23.068 27.6146 26.9386 27.6146 31.6974C27.6146 32.0095 27.7386 32.3087 27.9592 32.5293C28.1799 32.75 28.4791 32.8739 28.7911 32.8739C29.1031 32.8739 29.4024 32.75 29.623 32.5293C29.8436 32.3087 29.9676 32.0095 29.9676 31.6974C29.9694 30.1941 29.6856 28.7042 29.1311 27.3069C29.698 26.9885 30.3363 26.8189 30.9864 26.8139C32.2124 26.9056 33.3528 27.4769 34.1604 28.4038C34.968 29.3308 35.3776 30.5387 35.3005 31.7657C35.3005 32.0777 35.4245 32.3769 35.6451 32.5976C35.8657 32.8182 36.165 32.9421 36.477 32.9421C36.789 32.9421 37.0883 32.8182 37.3089 32.5976C37.5295 32.3769 37.6535 32.0777 37.6535 31.7657C37.7321 29.9144 37.0752 28.1073 35.8261 26.7387C34.5769 25.3701 32.8371 24.5513 30.9864 24.461Z",
      fill: "#1A1AC3"
    }, null, -1)
  ])]);
}
const sb = /* @__PURE__ */ g(cs, [["render", ps]]), fs = {}, Cs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function gs(e, t) {
  return l(), s("svg", Cs, [...t[0] || (t[0] = [
    N('<g id="ic_name" transform="translate(-336 -369)"><g id="Retângulo_55" data-name="Retângulo 55" transform="translate(336 369)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="40" height="40" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="none"></rect></g><path id="ic_name-2" data-name="ic_name" d="M3.615-3310A4.615,4.615,0,0,1-1-3314.615v-2.769A4.615,4.615,0,0,1,3.615-3322h2.77A4.615,4.615,0,0,1,11-3317.384v2.769A4.615,4.615,0,0,1,6.385-3310Zm-3.692-7.384v2.769a3.7,3.7,0,0,0,3.692,3.692h2.77a3.7,3.7,0,0,0,3.692-3.692v-2.769a3.7,3.7,0,0,0-3.692-3.693H3.615A3.7,3.7,0,0,0-.077-3317.384Zm3.231,3.692a.462.462,0,0,1-.462-.462.462.462,0,0,1,.462-.461H5a.462.462,0,0,1,.462.461.462.462,0,0,1-.462.462Zm0-1.846a.462.462,0,0,1-.462-.462.461.461,0,0,1,.462-.461H6.846a.461.461,0,0,1,.462.461.462.462,0,0,1-.462.462Zm0-1.846a.462.462,0,0,1-.462-.462.462.462,0,0,1,.462-.462H5.923a.462.462,0,0,1,.462.462.462.462,0,0,1-.462.462Z" transform="translate(351 3705)" fill="#020203"></path></g>', 1)
  ])]);
}
const ib = /* @__PURE__ */ g(fs, [["render", gs]]), ab = /* @__PURE__ */ I({
  inheritAttrs: !1,
  __name: "GooglePayIcon",
  setup(e) {
    return (t, r) => (l(), s("svg", {
      class: v([t.$attrs.class]),
      viewBox: "0 0 44.9881 17.7189",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet"
    }, [...r[0] || (r[0] = [
      N('<g class="fill-current"><path d="M24.1957 6.66126C25.0905 6.66126 25.7683 7.32321 25.7683 8.21272C25.7683 9.09533 25.0972 9.75729 24.1957 9.75729H23.0908V11.488H22.4943V6.66126H24.1957ZM24.1686 9.17118C24.7447 9.17118 25.165 8.76435 25.165 8.21272C25.165 7.66109 24.7447 7.24736 24.1686 7.24736H23.0908V9.17118H24.1686Z"></path><path d="M29.649 7.76452H30.1031V11.488H29.6286L29.5676 10.9295C29.2287 11.3294 28.7271 11.5708 28.1306 11.5708C27.046 11.5708 26.2326 10.7364 26.2326 9.63317C26.2326 8.51612 27.046 7.68867 28.1306 7.68867C28.7271 7.68867 29.2355 7.93001 29.5744 8.33684L29.649 7.76452ZM28.1712 11.0054C28.9508 11.0054 29.5134 10.4192 29.5134 9.62628C29.5134 8.8402 28.9508 8.25409 28.1712 8.25409C27.3985 8.25409 26.8223 8.8471 26.8223 9.62628C26.8223 10.4124 27.3985 11.0054 28.1712 11.0054Z"></path><path d="M33.9413 7.76452H34.5581L32.8093 11.6466C32.4161 12.5292 32.0704 12.8188 31.379 12.8188H31.0333V12.2879H31.3248C31.8196 12.2879 31.9891 12.1362 32.2873 11.5156L32.4161 11.2398L30.7892 7.76452H31.4129L32.7144 10.5847L33.9413 7.76452Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2981 8.98588C12.2981 8.67979 12.3473 8.38633 12.4351 8.11108L10.8988 6.89827C10.5994 7.52674 10.4307 8.23489 10.4307 8.98588C10.4307 9.73623 10.5991 10.444 10.8981 11.072L12.4336 9.85682C12.3467 9.58286 12.2981 9.29048 12.2981 8.98588Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9955 6.20125C15.6388 6.20125 16.2197 6.43688 16.6762 6.82244L18.0042 5.45155C17.195 4.72326 16.1575 4.27344 14.9955 4.27344C13.1916 4.27344 11.6412 5.33995 10.8988 6.89827L12.4351 8.11108C12.789 7.00023 13.7981 6.20125 14.9955 6.20125Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9955 11.7705C13.7981 11.7705 12.789 10.9715 12.4351 9.86068L10.8988 11.0733C11.6412 12.6318 13.1916 13.6983 14.9955 13.6983C16.1089 13.6983 17.1719 13.2896 17.9697 12.5239L16.5115 11.3584C16.1 11.6263 15.5819 11.7705 14.9955 11.7705Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.3529 8.98588C19.3529 8.70742 19.3114 8.40753 19.2491 8.12907H14.9955V9.94979H17.4439C17.3215 10.5705 16.9883 11.0478 16.5115 11.3584L17.9697 12.5239C18.8078 11.7197 19.3529 10.5219 19.3529 8.98588Z"></path></g>', 1)
    ])], 2));
  }
}), vs = {}, ms = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21.825",
  height: "16",
  viewBox: "0 0 21.825 16"
};
function xs(e, t) {
  return l(), s("svg", ms, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_grupos",
      d: "M46.362-2688.727a2.886,2.886,0,0,0-2.667-3.062,2.409,2.409,0,0,0-1.147.3,7.327,7.327,0,0,1,.517,2.715.726.726,0,0,1-.727.727.726.726,0,0,1-.727-.727c0-2.941-2.109-5.336-4.7-5.336s-4.7,2.395-4.7,5.336a.726.726,0,0,1-.727.727.726.726,0,0,1-.727-.727,7.327,7.327,0,0,1,.517-2.715,2.406,2.406,0,0,0-1.147-.3,2.887,2.887,0,0,0-2.667,3.063.726.726,0,0,1-.727.727.726.726,0,0,1-.727-.727,4.334,4.334,0,0,1,4.122-4.516,3.856,3.856,0,0,1,1.822.473,6,6,0,0,1,4.965-2.789,5.994,5.994,0,0,1,4.965,2.789,3.859,3.859,0,0,1,1.823-.473,4.334,4.334,0,0,1,4.121,4.516.726.726,0,0,1-.727.727A.726.726,0,0,1,46.362-2688.727Zm-5.527-8.738a2.764,2.764,0,0,1,2.763-2.766,2.764,2.764,0,0,1,2.763,2.766A2.764,2.764,0,0,1,43.6-2694.7,2.764,2.764,0,0,1,40.835-2697.465Zm1.454,0a1.309,1.309,0,0,0,1.309,1.309,1.309,1.309,0,0,0,1.309-1.309,1.309,1.309,0,0,0-1.309-1.309A1.309,1.309,0,0,0,42.289-2697.465Zm-15.031,0a2.765,2.765,0,0,1,2.764-2.766,2.764,2.764,0,0,1,2.763,2.766,2.764,2.764,0,0,1-2.763,2.762A2.764,2.764,0,0,1,27.259-2697.465Zm1.455,0a1.309,1.309,0,0,0,1.309,1.309,1.309,1.309,0,0,0,1.309-1.309,1.309,1.309,0,0,0-1.309-1.309A1.309,1.309,0,0,0,28.714-2697.465Zm4.5-2.941A3.594,3.594,0,0,1,36.81-2704a3.594,3.594,0,0,1,3.594,3.594,3.594,3.594,0,0,1-3.593,3.594A3.6,3.6,0,0,1,33.217-2700.406Zm1.454,0a2.138,2.138,0,0,0,2.139,2.137,2.138,2.138,0,0,0,2.139-2.137,2.139,2.139,0,0,0-2.139-2.141A2.145,2.145,0,0,0,34.672-2700.406Z",
      transform: "translate(-25.995 2704)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const db = /* @__PURE__ */ g(vs, [["render", xs]]), ws = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.733",
  height: "13",
  viewBox: "0 0 17.733 13"
}, ks = ["fill"], ub = /* @__PURE__ */ I({
  __name: "groupsIcon",
  props: {
    focus: { type: Boolean }
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : "#7A7786";
    return (n, i) => (l(), s("svg", ws, [
      o("path", {
        id: "ic_grupos",
        d: "M42.543-2691.591a2.346,2.346,0,0,0-2.167-2.488,1.933,1.933,0,0,0-.932.248,5.953,5.953,0,0,1,.42,2.2.591.591,0,0,1-.591.591.591.591,0,0,1-.591-.591,4.106,4.106,0,0,0-3.821-4.334,4.106,4.106,0,0,0-3.822,4.334.591.591,0,0,1-.591.591.591.591,0,0,1-.591-.591,5.953,5.953,0,0,1,.42-2.2,1.931,1.931,0,0,0-.932-.248,2.347,2.347,0,0,0-2.167,2.488.59.59,0,0,1-.591.591.59.59,0,0,1-.591-.591,3.524,3.524,0,0,1,3.349-3.669,3.113,3.113,0,0,1,1.481.386,4.868,4.868,0,0,1,4.034-2.267,4.867,4.867,0,0,1,4.034,2.267,3.115,3.115,0,0,1,1.481-.386,3.523,3.523,0,0,1,3.348,3.669.59.59,0,0,1-.591.591A.59.59,0,0,1,42.543-2691.591Zm-4.491-7.1a2.245,2.245,0,0,1,2.245-2.245,2.245,2.245,0,0,1,2.245,2.245,2.245,2.245,0,0,1-2.245,2.245A2.245,2.245,0,0,1,38.052-2698.691Zm1.182,0a1.064,1.064,0,0,0,1.064,1.064,1.064,1.064,0,0,0,1.064-1.064,1.064,1.064,0,0,0-1.064-1.064A1.063,1.063,0,0,0,39.234-2698.691Zm-12.212,0a2.246,2.246,0,0,1,2.246-2.245,2.245,2.245,0,0,1,2.245,2.245,2.245,2.245,0,0,1-2.245,2.245A2.245,2.245,0,0,1,27.022-2698.691Zm1.182,0a1.064,1.064,0,0,0,1.064,1.064,1.064,1.064,0,0,0,1.064-1.064,1.064,1.064,0,0,0-1.064-1.064A1.063,1.063,0,0,0,28.2-2698.691Zm3.659-2.39A2.919,2.919,0,0,1,34.782-2704a2.919,2.919,0,0,1,2.92,2.919,2.92,2.92,0,0,1-2.92,2.92A2.922,2.922,0,0,1,31.863-2701.081Zm1.182,0a1.738,1.738,0,0,0,1.738,1.737,1.738,1.738,0,0,0,1.738-1.737,1.738,1.738,0,0,0-1.738-1.738A1.74,1.74,0,0,0,33.045-2701.08Z",
        transform: "translate(-25.995 2704.001)",
        fill: r()
      }, null, 8, ks)
    ]));
  }
}), ys = {
  width: "16",
  height: "16",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, bs = ["fill"], cb = /* @__PURE__ */ I({
  __name: "GasStationGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", ys, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.83 0C8.85 0 9.67 0.82 9.67 1.83V8H10.5C11.14 8 11.67 8.52 11.67 9.17V10.17C11.67 10.44 11.89 10.67 12.17 10.67C12.44 10.67 12.67 10.44 12.67 10.17V7H11.92C11.22 7 10.68 6.39 10.76 5.69L10.93 4.36C11 3.77 11.5 3.33 12.09 3.33H12.57C12.53 3.26 12.48 3.19 12.42 3.13L11.48 2.19C11.28 1.99 11.28 1.68 11.48 1.48C11.68 1.28 11.99 1.28 12.19 1.48L13.13 2.42C13.47 2.77 13.67 3.23 13.67 3.72V10.17C13.67 10.99 12.99 11.67 12.17 11.67C12.15 11.67 12.13 11.67 12.11 11.66C11.31 11.64 10.67 10.98 10.67 10.17V9.17C10.67 9.07 10.59 9 10.5 9H9.67V12H9.83C10.11 12 10.33 12.22 10.33 12.5C10.33 12.78 10.11 13 9.83 13H0.5C0.22 13 0 12.78 0 12.5C0 12.22 0.22 12 0.5 12H0.67V1.83C0.67 0.82 1.49 0 2.5 0H7.83ZM3.83 7.86C3.56 7.86 3.33 8.09 3.33 8.36C3.33 8.64 3.56 8.86 3.83 8.86H6.5C6.78 8.86 7 8.64 7 8.36C7 8.09 6.78 7.86 6.5 7.86H3.83ZM3.17 2.5C2.89 2.5 2.67 2.72 2.67 3V5.67C2.67 5.94 2.89 6.17 3.17 6.17H7.17C7.44 6.17 7.67 5.94 7.67 5.67V3C7.67 2.72 7.44 2.5 7.17 2.5H3.17ZM12.09 4.33C12.01 4.33 11.95 4.38 11.93 4.45L11.92 4.48L11.76 5.81C11.74 5.91 11.82 6 11.92 6H12.67V4.33H12.09Z",
        fill: e.active ? "url(#gas_blue)" : "url(#gas_gray)"
      }, null, 8, bs),
      r[0] || (r[0] = N('<defs><linearGradient id="gas_blue" x1="0.62" y1="11.38" x2="13.31" y2="3.38" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="gas_gray" x1="0.62" y1="11.38" x2="13.31" y2="3.38" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), _s = {}, Ms = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": ""
};
function Ls(e, t) {
  return l(), s("svg", Ms, [...t[0] || (t[0] = [
    o("path", {
      d: "M14.5375 10.6483L16.4817 8.70416C17.9133 7.2725 17.9133 4.95083 16.4817 3.51833V3.51833C15.05 2.08666 12.7283 2.08666 11.2958 3.51833L9.35167 5.4625",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.40834 12.5917L12.5917 7.40833",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M5.4625 9.35168L3.51833 11.2959C2.08666 12.7275 2.08666 15.0492 3.51833 16.4817V16.4817C4.95 17.9134 7.27166 17.9134 8.70416 16.4817L10.6483 14.5375",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const hb = /* @__PURE__ */ g(_s, [["render", Ls]]), $s = {}, Vs = {
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Bs(e, t) {
  return l(), s("svg", Vs, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.49992 5.46484H7.16659C7.53325 5.46484 7.83325 5.76484 7.83325 6.13151V8.16684C7.83325 8.53484 7.53459 8.83351 7.16659 8.83351H4.49992C4.13192 8.83351 3.83325 8.53484 3.83325 8.16684V6.13151C3.83325 5.76351 4.13192 5.46484 4.49992 5.46484Z",
      stroke: "#5763FF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M4.71069 5.46467V4.62267C4.71069 4.00267 5.21336 3.5 5.83336 3.5C6.45336 3.5 6.95603 4.00267 6.95603 4.62267V5.46333",
      stroke: "#5763FF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.81533 1.87783L5.37667 0.5805C5.67133 0.473167 5.99467 0.473167 6.28933 0.5805L9.85067 1.87783C10.6413 2.16583 11.1667 2.9165 11.1667 3.75717V7.00517C11.1667 9.3925 9.948 10.3718 6.49667 12.3258C6.08533 12.5585 5.58133 12.5585 5.17 12.3258C1.71867 10.3718 0.5 9.3925 0.5 7.00517V3.75717C0.5 2.9165 1.02533 2.16583 1.81533 1.87783Z",
      stroke: "#5763FF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const pb = /* @__PURE__ */ g($s, [["render", Bs]]), Hs = {}, Fs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 50 50"
};
function As(e, t) {
  return l(), s("svg", Fs, [...t[0] || (t[0] = [
    N('<g id="ic_help" transform="translate(-24 -44)"><g id="Retângulo_34" data-name="Retângulo 34" transform="translate(24 44)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="50" height="50" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="49" height="49" rx="7.5" fill="none"></rect></g><path id="Caminho_734" data-name="Caminho 734" d="M-382.086,170.765a8.062,8.062,0,0,1-5.748-6.085,8.069,8.069,0,0,1,2.925-7.97,8.052,8.052,0,0,1,4.925-1.673,7.989,7.989,0,0,1,3.558.833A8.073,8.073,0,0,1-372,163.033a8.067,8.067,0,0,1-3.095,6.324,8.057,8.057,0,0,1-4.928,1.679A7.933,7.933,0,0,1-382.086,170.765Zm-2.068-13.083a6.829,6.829,0,0,0-2.476,6.746,6.821,6.821,0,0,0,4.863,5.148,6.724,6.724,0,0,0,1.743.229h0a6.823,6.823,0,0,0,4.172-1.419,6.827,6.827,0,0,0,2.619-5.352,6.832,6.832,0,0,0-3.745-6.062,6.751,6.751,0,0,0-3.007-.7A6.813,6.813,0,0,0-384.154,157.681Zm3.511,9.143a.612.612,0,0,1-.181-.437.611.611,0,0,1,.181-.434.637.637,0,0,1,.868,0,.611.611,0,0,1,.181.434.627.627,0,0,1-.178.437.626.626,0,0,1-.437.179A.619.619,0,0,1-380.643,166.824Zm.429-1.667a.616.616,0,0,1-.61-.622l0-.308a.484.484,0,0,1,0-.053,2.948,2.948,0,0,1,1.157-1.886c.162-.15.315-.291.446-.439a.834.834,0,0,0,.147-.991,1.359,1.359,0,0,0-1.494-.536,1.144,1.144,0,0,0-.831.872.616.616,0,0,1-.754.436.616.616,0,0,1-.435-.754,2.335,2.335,0,0,1,1.746-1.754,2.561,2.561,0,0,1,2.849,1.145,2.057,2.057,0,0,1-.306,2.4,7.351,7.351,0,0,1-.532.526c-.442.408-.718.681-.764,1.075l0,.278a.615.615,0,0,1-.615.611Z" transform="translate(429.001 -94.036)" fill="#020203"></path></g>', 1)
  ])]);
}
const fb = /* @__PURE__ */ g(Hs, [["render", As]]), js = {}, Is = { class: "opacity-50 rounded-full w-3 h-3 outline outline-1 outline-default-black text-default-black flex items-center justify-center text-xs cursor-default" };
function Zs(e, t) {
  return l(), s("span", Is, " i ");
}
const Cb = /* @__PURE__ */ g(js, [["render", Zs]]), Es = {}, Ss = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "24",
  viewBox: "0 0 20 24"
};
function zs(e, t) {
  return l(), s("svg", Ss, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_history_report",
      d: "M115.991,73a.992.992,0,0,0-.284-.707l-8-8a.989.989,0,0,0-.707-.285V64h-6a5.006,5.006,0,0,0-5,5V83a5.006,5.006,0,0,0,5,5h10a5.006,5.006,0,0,0,5-5V73ZM108,67.414,112.586,72H111a3,3,0,0,1-3-3ZM111,86H101a3,3,0,0,1-3-3V69a3,3,0,0,1,3-3h5v3a5.006,5.006,0,0,0,5,5h3v9A3,3,0,0,1,111,86Zm0-3.625a1,1,0,0,1-1,1h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,111,82.375Zm-10-4a1,1,0,0,1,1-1h2a1,1,0,0,1,0,2h-2A1,1,0,0,1,101,78.375Z",
      transform: "translate(-96 -64)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const gb = /* @__PURE__ */ g(Es, [["render", zs]]), Ds = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, Ts = ["fill"], Os = ["fill"], Ps = ["id"], Rs = ["stop-color"], Ns = ["stop-color"], Gs = ["id"], Us = ["stop-color"], Ws = ["stop-color"], vb = /* @__PURE__ */ I({
  __name: "HomeGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", Ds, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.228 5.53259L9.228 2.42126C8.506 1.85926 7.49467 1.85926 6.772 2.42126L2.772 5.53259C2.28467 5.91126 2 6.49392 2 7.11126V11.9999C2 13.1046 2.89533 13.9999 4 13.9999H12C13.1047 13.9999 14 13.1046 14 11.9999V7.11126C14 6.49392 13.7153 5.91126 13.228 5.53259Z",
        fill: `url(#paint0_linear_4912_13361_${D(r)})`
      }, null, 8, Ts),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 11.3333H10Z",
        fill: `url(#paint1_linear_4912_13361_${D(r)})`
      }, null, 8, Os),
      i[0] || (i[0] = o("path", {
        d: "M6 11.3333H10",
        stroke: "white",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13361_${D(r)}`,
          x1: "2.54543",
          y1: "12.5",
          x2: "13.9982",
          y2: "5.64078",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, Rs),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, Ns)
        ], 8, Ps),
        o("linearGradient", {
          id: `paint1_linear_4912_13361_${D(r)}`,
          x1: "6.18181",
          y1: "11.5833",
          x2: "6.55461",
          y2: "10.2437",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, Us),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, Ws)
        ], 8, Gs)
      ])
    ]));
  }
}), Ys = {}, qs = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ks(e, t) {
  return l(), s("svg", qs, [...t[0] || (t[0] = [
    N('<rect x="1.5" y="1.5" width="13" height="13" rx="5.5" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M7.99984 4.66602V4.33268" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.0002 5.33398L10.3335 5.00065" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.3335 13.8478V8.66732C4.3335 7.93094 4.93045 7.33398 5.66683 7.33398H10.3335C11.0699 7.33398 11.6668 7.93094 11.6668 8.66732V13.8479" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.3335 7.33398H9.66683V8.66732C9.66683 8.85141 9.51759 9.00065 9.3335 9.00065H6.66683C6.48273 9.00065 6.3335 8.85141 6.3335 8.66732V7.33398Z" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 5.33398L5.66667 5.00065" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const mb = /* @__PURE__ */ g(Ys, [["render", Ks]]), Qs = {}, Xs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
};
function Js(e, t) {
  return l(), s("svg", Xs, [...t[0] || (t[0] = [
    o("g", {
      id: "Grupo_3219",
      "data-name": "Grupo 3219",
      transform: "translate(-24 -24)"
    }, [
      o("rect", {
        id: "Retângulo_55",
        "data-name": "Retângulo 55",
        width: "48",
        height: "48",
        rx: "8",
        transform: "translate(24 24)",
        fill: "#d2dffd"
      }),
      o("path", {
        id: "inativar_colaborador",
        "data-name": "inativar colaborador",
        d: "M-6745.335,6143.769l-1.986-1.986-1.988,1.986a.77.77,0,0,1-.552.23.764.764,0,0,1-.55-.23.775.775,0,0,1,0-1.1l1.986-1.987-1.986-1.986a.777.777,0,0,1,0-1.105.78.78,0,0,1,1.1,0l1.988,1.986,1.986-1.986a.782.782,0,0,1,1.1,0,.782.782,0,0,1,0,1.105l-1.985,1.986,1.985,1.987a.779.779,0,0,1,0,1.1.774.774,0,0,1-.553.23A.772.772,0,0,1-6745.335,6143.769Zm-16.293.23a2.36,2.36,0,0,1-1.838-.875,2.377,2.377,0,0,1-.483-1.988,10.19,10.19,0,0,1,3.5-5.772,10.169,10.169,0,0,1,3.274-1.8,5.3,5.3,0,0,1-2.136-4.253A5.318,5.318,0,0,1-6754,6124a5.317,5.317,0,0,1,5.312,5.311,5.309,5.309,0,0,1-2.131,4.251,10.068,10.068,0,0,1,2.744,1.4.78.78,0,0,1,.179,1.088.781.781,0,0,1-1.091.179,8.54,8.54,0,0,0-4.8-1.609c-.067,0-.138,0-.208,0s-.138,0-.208,0a8.628,8.628,0,0,0-8.211,6.835.811.811,0,0,0,.165.684.8.8,0,0,0,.626.3h8.058a.782.782,0,0,1,.78.782.782.782,0,0,1-.78.782Zm3.879-14.687a3.751,3.751,0,0,0,3.56,3.743h.378a3.753,3.753,0,0,0,3.56-3.743,3.753,3.753,0,0,0-3.749-3.75A3.752,3.752,0,0,0-6757.75,6129.313Z",
        transform: "translate(6802.002 -6085.998)",
        fill: "#000ec6",
        stroke: "#000ec6",
        "stroke-width": "0.2"
      })
    ], -1)
  ])]);
}
const xb = /* @__PURE__ */ g(Qs, [["render", Js]]), ei = {}, ti = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10"
};
function oi(e, t) {
  return l(), s("svg", ti, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_inativar",
      d: "M2.846-3312A3.846,3.846,0,0,1-1-3315.846v-2.307A3.846,3.846,0,0,1,2.846-3322H5.154A3.846,3.846,0,0,1,9-3318.153v2.307A3.846,3.846,0,0,1,5.154-3312Zm-3.077-6.153v2.307a3.081,3.081,0,0,0,3.077,3.077H5.154a3.081,3.081,0,0,0,3.077-3.077v-2.307a3.081,3.081,0,0,0-3.077-3.077H2.846A3.081,3.081,0,0,0-.231-3318.153Zm2.74,1.569a.385.385,0,0,1-.385-.385.384.384,0,0,1,.385-.384H5.586a.384.384,0,0,1,.385.384.385.385,0,0,1-.385.385Z",
      transform: "translate(1 3322)",
      fill: "#020203"
    }, null, -1)
  ])]);
}
const wb = /* @__PURE__ */ g(ei, [["render", oi]]), ni = {}, ri = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": ""
};
function li(e, t) {
  return l(), s("svg", ri, [...t[0] || (t[0] = [
    o("path", {
      d: "M12.3592 7.6416L7.64258 12.3583",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.3592 12.3583L7.64258 7.6416",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const kb = /* @__PURE__ */ g(ni, [["render", li]]), si = {}, ii = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ai(e, t) {
  return l(), s("svg", ii, [...t[0] || (t[0] = [
    o("path", {
      d: "M19.7732 12.2266L12.2266 19.7732",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M19.7732 19.7732L12.2266 12.2266",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 28V28C9.372 28 4 22.628 4 16V16C4 9.372 9.372 4 16 4V4C22.628 4 28 9.372 28 16V16C28 22.628 22.628 28 16 28Z",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const yb = /* @__PURE__ */ g(si, [["render", ai]]), di = {}, ui = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ci(e, t) {
  return l(), s("svg", ui, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 10.9331V7.81641",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99921 13.4368C9.88421 13.4368 9.79088 13.5302 9.79171 13.6452C9.79171 13.7602 9.88504 13.8535 10 13.8535C10.115 13.8535 10.2084 13.7602 10.2084 13.6452C10.2084 13.5302 10.115 13.4368 9.99921 13.4368",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.6908 3.44867L18.0733 14.6187C18.815 15.917 17.8775 17.5328 16.3825 17.5328H3.61751C2.12167 17.5328 1.18417 15.917 1.92667 14.6187L8.30917 3.44867C9.05667 2.13951 10.9433 2.13951 11.6908 3.44867Z",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const bb = /* @__PURE__ */ g(di, [["render", ci]]), hi = {}, pi = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fi(e, t) {
  return l(), s("svg", pi, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10 14.1667V10H9.16669",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.79084 6.66732C9.67584 6.66732 9.5825 6.76065 9.58334 6.87565C9.58334 6.99065 9.67667 7.08398 9.79167 7.08398C9.90667 7.08398 10 6.99065 10 6.87565C10 6.76065 9.90667 6.66732 9.79084 6.66732",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const _b = /* @__PURE__ */ g(hi, [["render", fi]]), Ci = {}, gi = { class: "rounded-full w-5 h-5 outline outline-1 outline-error flex items-center justify-center text-xs" };
function vi(e, t) {
  return l(), s("span", gi, " i ");
}
const Mb = /* @__PURE__ */ g(Ci, [["render", vi]]), mi = {}, xi = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20.0083 20.0083",
  fill: "none",
  class: "shrink-0"
};
function wi(e, t) {
  return l(), s("svg", xi, [...t[0] || (t[0] = [
    N('<rect x="2.50105" y="2.5009" width="15.0062" height="15.0062" rx="3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="5.83577" y="5.83562" width="8.33681" height="2.50104" rx="0.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M12.5052 11.2545H5.83577" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83577 14.1724H9.1705" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5894 12.9738L13.0258 14.5374L12.0884 13.5992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const Lb = /* @__PURE__ */ g(mi, [["render", wi]]), ki = ["width", "height"], $b = /* @__PURE__ */ I({
  __name: "InformationIcon",
  props: {
    width: {
      type: Number,
      default: 36
    },
    height: {
      type: Number,
      default: 36
    }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24"
    }, [...r[0] || (r[0] = [
      o("path", {
        d: "M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, ki));
  }
}), yi = {}, bi = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _i(e, t) {
  return l(), s("svg", bi, [...t[0] || (t[0] = [
    o("path", {
      d: "M9.99933 6.66732C9.88433 6.66732 9.791 6.76065 9.79183 6.87565C9.79183 6.99065 9.88517 7.08398 10.0002 7.08398C10.1152 7.08398 10.2085 6.99065 10.2085 6.87565C10.2085 6.76065 10.1152 6.66732 9.99933 6.66732",
      stroke: "#5763FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z",
      stroke: "#5763FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.0002 10V14.1667",
      stroke: "#5763FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Vb = /* @__PURE__ */ g(yi, [["render", _i]]), Mi = {}, Li = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-3 h-3 shrink-0 aspect-square"
};
function $i(e, t) {
  return l(), s("svg", Li, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 10.5V10.5C3.5145 10.5 1.5 8.4855 1.5 6V6C1.5 3.5145 3.5145 1.5 6 1.5V1.5C8.4855 1.5 10.5 3.5145 10.5 6V6C10.5 8.4855 8.4855 10.5 6 10.5Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6 8.5V6H5.5",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M5.8745 4C5.8055 4 5.7495 4.056 5.75 4.125C5.75 4.194 5.806 4.25 5.875 4.25C5.944 4.25 6 4.194 6 4.125C6 4.056 5.944 4 5.8745 4",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ke = /* @__PURE__ */ g(Mi, [["render", $i]]), Vi = {
  width: "16",
  height: "16",
  viewBox: "0 0 11 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, Bi = ["fill"], Bb = /* @__PURE__ */ I({
  __name: "InvoiceGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Vi, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.02 0.07C9.21 -0.02 9.43 -0.02 9.62 0.07L10.28 0.4C10.5 0.51 10.64 0.74 10.64 1V10.98C10.64 11.23 10.5 11.46 10.28 11.57L9.62 11.9C9.43 12 9.21 12 9.02 11.9L7.98 11.39L6.95 11.9C6.77 12 6.54 12 6.36 11.9L5.32 11.39L4.28 11.9C4.1 12 3.88 12 3.69 11.9L2.66 11.39L1.62 11.9C1.43 12 1.21 12 1.03 11.9L0.37 11.57C0.14 11.46 0 11.23 0 10.98V1C0 0.74 0.14 0.51 0.37 0.4L1.03 0.07C1.21 -0.02 1.43 -0.02 1.62 0.07L2.66 0.59L3.69 0.07C3.88 -0.02 4.1 -0.02 4.28 0.07L5.32 0.59L6.36 0.07C6.54 -0.02 6.77 -0.02 6.95 0.07L7.98 0.59L9.02 0.07ZM2.66 7.81C2.39 7.81 2.16 8.04 2.16 8.31C2.16 8.59 2.39 8.81 2.66 8.81H5.32C5.6 8.81 5.82 8.59 5.82 8.31C5.82 8.04 5.6 7.81 5.32 7.81H2.66ZM7.32 7.78C7.04 7.78 6.82 8 6.82 8.28C6.82 8.55 7.04 8.78 7.32 8.78H7.98C8.26 8.78 8.48 8.55 8.48 8.28C8.48 8 8.26 7.78 7.98 7.78H7.32ZM2.66 5.49C2.38 5.49 2.16 5.71 2.16 5.99C2.16 6.26 2.38 6.49 2.66 6.49H5.32C5.6 6.49 5.82 6.26 5.82 5.99C5.82 5.71 5.6 5.49 5.32 5.49H2.66ZM7.32 5.49C7.04 5.49 6.82 5.71 6.82 5.99C6.82 6.26 7.04 6.49 7.32 6.49H7.98C8.26 6.49 8.48 6.26 8.48 5.99C8.48 5.71 8.26 5.49 7.98 5.49H7.32ZM2.66 3.16C2.39 3.16 2.16 3.38 2.16 3.66C2.16 3.93 2.39 4.16 2.66 4.16H7.98C8.26 4.16 8.48 3.93 8.48 3.66C8.48 3.38 8.26 3.16 7.98 3.16H2.66Z",
        fill: e.active ? "url(#invoice_blue)" : "url(#invoice_gray)"
      }, null, 8, Bi),
      r[0] || (r[0] = N('<defs><linearGradient id="invoice_blue" x1="0.48" y1="10.48" x2="11.24" y2="4.75" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="invoice_gray" x1="0.48" y1="10.48" x2="11.24" y2="4.75" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Hi = {}, Fi = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ai(e, t) {
  return l(), s("svg", Fi, [...t[0] || (t[0] = [
    o("path", {
      d: "M8.55687 2.38913H2.79878C2.38801 2.38913 2.05409 2.0553 2.05409 1.64456C2.05409 1.23383 2.38801 0.9 2.79878 0.9H10.3573C10.7678 0.9 11.1021 1.23365 11.1 1.64475M8.55687 2.38913L11 9.19962C11 9.55511 10.7109 9.84418 10.3553 9.84418C9.99975 9.84418 9.71062 9.55511 9.71062 9.19962V3.34271L9.61061 3.44271M8.55687 2.38913L1.11831 9.82816M8.55687 2.38913L1.11831 9.82816M11.1 1.64475C11.1 1.64487 11.1 1.64499 11.1 1.64511L11 1.64456H11.1V1.64475ZM11.1 1.64475V9.19962C11.1 9.61035 10.7661 9.94418 10.3553 9.94418C9.94454 9.94418 9.61061 9.61035 9.61061 9.19962V3.44271M9.61061 3.44271L2.17206 10.8817L2.17205 10.8817C1.88098 11.1728 1.40937 11.1728 1.11831 10.8817C0.827231 10.5907 0.827231 10.1192 1.11831 9.82816M9.61061 3.44271V3.30129L1.11831 9.82816M1.11831 9.82816L1.1183 9.82817L1.18897 9.89883L1.11831 9.82816Z",
      fill: "#000EC6",
      stroke: "#000EC6",
      "stroke-width": "0.2"
    }, null, -1)
  ])]);
}
const Hb = /* @__PURE__ */ g(Hi, [["render", Ai]]), ji = {}, Ii = {
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Zi(e, t) {
  return l(), s("svg", Ii, [...t[0] || (t[0] = [
    o("path", {
      d: "M3 12.8314H7",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.99929 10.2712V10.9819H2.99929V10.2712C2.99929 9.56656 2.67262 8.90856 2.12929 8.45923C1.18862 7.6799 0.569956 6.52656 0.505289 5.22523C0.381956 2.73123 2.43196 0.538562 4.92862 0.500562C7.44662 0.461229 9.49996 2.4899 9.49996 4.99856C9.49996 6.3999 8.85796 7.64923 7.85262 8.47323C7.31329 8.91523 6.99929 9.5739 6.99929 10.2712Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2.69336 9.13216H7.30003",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Fb = /* @__PURE__ */ g(ji, [["render", Zi]]), Ei = {}, Si = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zi(e, t) {
  return l(), s("svg", Si, [...t[0] || (t[0] = [
    o("rect", {
      x: "2.5",
      y: "2.5",
      width: "5",
      height: "5",
      rx: "1",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    o("rect", {
      x: "2.5",
      y: "12.5",
      width: "5",
      height: "5",
      rx: "1",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    o("line", {
      x1: "10.5",
      y1: "5",
      x2: "17.5",
      y2: "5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    o("line", {
      x1: "10.5",
      y1: "15",
      x2: "17.5",
      y2: "15",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const Ab = /* @__PURE__ */ g(Ei, [["render", zi]]), Di = {}, Ti = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Oi(e, t) {
  return l(), s("svg", Ti, [...t[0] || (t[0] = [
    N('<path d="M10.1341 11.9921C10.1886 12.0467 10.2049 12.1287 10.1754 12.2C10.1459 12.2712 10.0764 12.3177 9.99923 12.3177C9.9221 12.3177 9.85257 12.2712 9.82306 12.2C9.79354 12.1287 9.80986 12.0467 9.8644 11.9921C9.93894 11.9179 10.0595 11.9179 10.1341 11.9921" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.9996 17.1293H3.99668C3.46598 17.1294 2.95698 16.9187 2.58172 16.5434C2.20646 16.1682 1.9957 15.6591 1.99585 15.1284V9.12595C1.9957 8.59525 2.20646 8.08624 2.58172 7.71098C2.95698 7.33572 3.46598 7.12497 3.99668 7.12511H10.9996" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.13236 11.9921C6.1869 12.0467 6.20321 12.1287 6.1737 12.2C6.14418 12.2712 6.07465 12.3177 5.99752 12.3177C5.9204 12.3177 5.85086 12.2712 5.82135 12.2C5.79183 12.1287 5.80815 12.0467 5.86269 11.9921C5.93723 11.9179 6.05782 11.9179 6.13236 11.9921" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><rect x="14.001" y="10.6266" width="8.00333" height="6.50271" rx="1.65" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M15.531 10.6266V8.59632C15.531 7.23128 16.6376 6.1247 18.0026 6.1247V6.1247C18.6581 6.1247 19.2868 6.3851 19.7503 6.84862C20.2138 7.31214 20.4742 7.9408 20.4742 8.59632V8.59632V10.6435" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const jb = /* @__PURE__ */ g(Di, [["render", Oi]]), Pi = {}, Ri = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function Ni(e, t) {
  return l(), s("svg", Ri, [...t[0] || (t[0] = [
    N('<g id="ic_leave" transform="translate(-24 -44)"><g id="Retângulo_34" data-name="Retângulo 34" transform="translate(24 44)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="40" height="40" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="none"></rect></g><path id="ic_leave-2" data-name="ic_leave" d="M9.022-18720.02l-5.182-.818a1.713,1.713,0,0,1-1.039-.58,1.73,1.73,0,0,1-.409-1.113v-2.49H3.431v2.49a.679.679,0,0,0,.57.67l5.186.818a.815.815,0,0,0,.1,0,.685.685,0,0,0,.442-.158.676.676,0,0,0,.24-.518v-9.568a.669.669,0,0,0-.24-.516.674.674,0,0,0-.439-.16c-.034,0-.071,0-.109.008l-5.182.816a.664.664,0,0,0-.57.672v2.49H2.392v-2.49a1.741,1.741,0,0,1,.409-1.117,1.72,1.72,0,0,1,1.039-.578l5.182-.82a1.733,1.733,0,0,1,.27-.021,1.7,1.7,0,0,1,1.114.416,1.7,1.7,0,0,1,.6,1.3v9.568a1.719,1.719,0,0,1-.6,1.307,1.724,1.724,0,0,1-1.114.408A1.718,1.718,0,0,1,9.022-18720.02Zm-4.485-3.719a.529.529,0,0,1,0-.736l1.507-1.5H.517A.518.518,0,0,1,0-18726.5a.518.518,0,0,1,.517-.518H6.045l-1.507-1.506a.527.527,0,0,1,0-.734.514.514,0,0,1,.367-.15.508.508,0,0,1,.367.15l2.392,2.395a.515.515,0,0,1,0,.73l-2.392,2.395a.5.5,0,0,1-.367.152A.517.517,0,0,1,4.537-18723.738Z" transform="translate(38.497 18790.5)" fill="#020203"></path></g>', 1)
  ])]);
}
const Ib = /* @__PURE__ */ g(Pi, [["render", Ni]]), Gi = {}, Ui = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function Wi(e, t) {
  return l(), s("svg", Ui, [...t[0] || (t[0] = [
    o("path", {
      d: "M12 21C16 16.8667 20 13.919 20 10C20 6.13401 16.866 3 12 3C7.13401 3 4 6.13401 4 10C4 13.919 8 16.8667 12 21Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "12",
      cy: "10",
      r: "3",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1)
  ])]);
}
const Zb = /* @__PURE__ */ g(Gi, [["render", Wi]]), Yi = {}, qi = {
  class: "w-6 h-6",
  fill: "currentColor",
  version: "1.1",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 490.4 490.4",
  "xml:space": "preserve"
};
function Ki(e, t) {
  return l(), s("svg", qi, [...t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M484.1,454.796l-110.5-110.6c29.8-36.3,47.6-82.8,47.6-133.4c0-116.3-94.3-210.6-210.6-210.6S0,94.496,0,210.796
      s94.3,210.6,210.6,210.6c50.8,0,97.4-18,133.8-48l110.5,110.5c12.9,11.8,25,4.2,29.2,0C492.5,475.596,492.5,463.096,484.1,454.796z
      M41.1,210.796c0-93.6,75.9-169.5,169.5-169.5s169.6,75.9,169.6,169.5s-75.9,169.5-169.5,169.5S41.1,304.396,41.1,210.796z` })
    ], -1)
  ])]);
}
const Eb = /* @__PURE__ */ g(Yi, [["render", Ki]]), Qi = {}, Xi = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ji(e, t) {
  return l(), s("svg", Xi, [...t[0] || (t[0] = [
    o("path", {
      d: "M12.5258 7.78546C12.5258 7.61296 12.3858 7.47379 12.2133 7.47379C12.0408 7.47463 11.9008 7.61463 11.9008 7.78713C11.9008 7.95963 12.0408 8.09963 12.2133 8.09879C12.3858 8.09879 12.5258 7.95879 12.5258 7.78629",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.4159 12.321L9.55758 13.181H8.03091V14.4051H6.81008V15.9351L5.66508 17.0835H2.91675V14.3293L7.68591 9.54928C7.01425 7.80428 7.37425 5.75262 8.77841 4.34512C10.6784 2.44095 13.7592 2.44095 15.6592 4.34512C17.5592 6.24928 17.5592 9.33678 15.6592 11.2418C14.2409 12.6618 12.1676 13.0201 10.4159 12.321Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Sb = /* @__PURE__ */ g(Qi, [["render", Ji]]), ea = ["width", "height"], zb = /* @__PURE__ */ I({
  __name: "MarketplaceIcon",
  props: {
    width: {
      type: Number,
      default: 36
    },
    height: {
      type: Number,
      default: 36
    }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.0",
      preserveAspectRatio: "xMidYMid meet",
      width: e.width,
      height: e.height,
      viewBox: "735.92 690.46 576.24 667.37"
    }, [...r[0] || (r[0] = [
      o("g", {
        transform: "translate(0.000000,2048.000000) scale(0.100000,-0.100000)",
        fill: "#000EC6",
        stroke: "none"
      }, [
        o("path", { d: "M10099 13570 c-421 -53 -795 -348 -944 -744 -50 -134 -67 -229 -72 -418 l-6 -178 -514 0 c-489 0 -516 -1 -552 -19 -57 -30 -98 -82 -110 -143 -7 -29 -133 -1160 -281 -2513 -215 -1963 -268 -2467 -260 -2496 16 -56 51 -101 100 -129 l45 -25 2714 -3 c1795 -1 2726 1 2751 8 78 21 133 78 151 157 10 48 -94 1019 -117 1080 -30 83 -130 143 -217 129 -53 -9 -88 -28 -125 -70 -59 -67 -59 -78 -18 -464 21 -191 40 -366 43 -389 l6 -43 -2452 0 c-1468 0 -2451 4 -2451 9 0 5 110 1013 245 2239 135 1227 245 2238 245 2246 0 14 43 16 400 16 l400 0 0 -386 c0 -268 4 -399 12 -426 49 -163 293 -185 372 -33 20 38 21 57 24 443 l3 402 749 0 750 0 0 -389 c0 -263 4 -399 11 -422 48 -144 234 -186 339 -77 20 20 42 54 48 76 8 27 12 158 12 426 l0 386 400 0 c374 0 400 -1 400 -17 0 -10 65 -609 145 -1332 139 -1261 145 -1315 170 -1357 83 -141 298 -126 362 25 8 19 14 57 14 85 0 67 -297 2775 -312 2844 -12 61 -53 113 -110 143 -36 18 -63 19 -552 19 l-514 0 -6 178 c-5 189 -22 284 -72 418 -163 432 -577 731 -1038 748 -67 3 -152 1 -188 -4z m229 -410 c97 -13 218 -53 298 -101 75 -44 210 -179 253 -251 80 -138 110 -260 111 -455 l0 -123 -750 0 -750 0 0 123 c1 149 18 248 59 349 114 272 368 447 676 467 11 0 58 -4 103 -9z" })
      ], -1)
    ])], 8, ea));
  }
}), ta = {}, oa = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function na(e, t) {
  return l(), s("svg", oa, [...t[0] || (t[0] = [
    N('<path d="M5.83594 5.8357V4.16834C5.83594 3.24748 6.58244 2.50098 7.5033 2.50098H15.8401C16.761 2.50098 17.5075 3.24748 17.5075 4.16834V15.8399C17.5075 16.7607 16.761 17.5072 15.8401 17.5072H7.5033C6.58244 17.5072 5.83594 16.7607 5.83594 15.8399V14.1725" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><rect x="3.33472" y="5.83594" width="8.33681" height="8.33681" rx="2" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M17.5074 7.57016H11.6716" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5074 12.5047H11.6716" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.6717 2.50098V17.5072" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.80964 11.4628L6.30859 8.54492" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.30859 11.4628L8.80964 8.54492" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const Db = /* @__PURE__ */ g(ta, [["render", na]]), ra = {}, la = {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function sa(e, t) {
  return l(), s("svg", la, [...t[0] || (t[0] = [
    o("path", {
      d: "M17.7615 0.102113C18.2204 0.336881 18.4031 0.901301 18.1697 1.36278L17.2043 3.27109C16.9709 3.73257 16.4097 3.91635 15.9508 3.68158C15.4919 3.44682 15.3092 2.8824 15.5426 2.42092L16.508 0.512606C16.7414 0.0511282 17.3026 -0.132656 17.7615 0.102113Z",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.54351 0.274787C8.90755 -0.0913277 9.49778 -0.0913287 9.86183 0.274784L11.1649 1.58521C11.1753 1.59521 11.1854 1.60544 11.1953 1.61587L20.3941 10.8668C20.4039 10.8763 20.4135 10.886 20.423 10.8959L21.7268 12.2071C22.0908 12.5732 22.0908 13.1668 21.7268 13.5329C21.3627 13.899 20.7725 13.899 20.4084 13.5329L19.5527 12.6723L11.4195 16.5074L14.0722 19.1752C14.5911 19.6847 14.9151 20.3989 14.9151 21.1875C14.9151 22.7407 13.6631 24 12.1185 24C11.3342 24 10.6242 23.6741 10.1175 23.1523L7.18467 20.2028L6.09245 21.3012C5.00031 22.3996 3.2296 22.3996 2.13746 21.3012L0.819102 19.9754C-0.273034 18.8771 -0.273034 17.0963 0.819102 15.9979L5.09134 11.7014L9.39924 2.46119L8.54351 1.6006C8.17946 1.23449 8.17946 0.640901 8.54351 0.274787ZM6.53097 18.2086C6.52914 18.2104 6.52731 18.2122 6.52549 18.2141C6.52367 18.2159 6.52185 18.2177 6.52005 18.2196L4.77413 19.9754C4.41008 20.3415 3.81983 20.3415 3.45578 19.9754L2.13743 18.6496C1.77338 18.2835 1.77338 17.6899 2.13743 17.3237L5.86601 13.574L8.50272 16.2257L6.53097 18.2086ZM8.503 18.877L11.4401 21.8308C11.4433 21.834 11.4465 21.8373 11.4496 21.8405C11.6202 22.0171 11.856 22.125 12.1185 22.125C12.6334 22.125 13.0507 21.7053 13.0507 21.1875C13.0507 20.9236 12.9434 20.6864 12.7679 20.5149C12.7652 20.5123 12.7626 20.5097 12.76 20.5071L12.7582 20.5053L9.82104 17.5515L8.503 18.877ZM10.0176 15.0975L18.1509 11.2625L10.8011 3.87101L6.98775 12.0505L10.0176 15.0975Z",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      d: "M21.4903 5.52324C21.9492 5.28847 22.1319 4.72405 21.8985 4.26257C21.665 3.8011 21.1038 3.61731 20.6449 3.85208L18.7474 4.8229C18.2885 5.05767 18.1058 5.62209 18.3392 6.08357C18.5727 6.54504 19.1339 6.72883 19.5928 6.49406L21.4903 5.52324Z",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const Tb = /* @__PURE__ */ g(ra, [["render", sa]]), ia = {}, aa = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function da(e, t) {
  return l(), s("svg", aa, [...t[0] || (t[0] = [
    N('<g clip-path="url(#clip0_menu_arrow)"><path d="M5.15431 0.21808C5.41306 0.27433 5.58743 0.42808 5.66056 0.688705C5.74118 0.97558 5.65306 1.2137 5.44868 1.4162C4.66118 2.20183 3.87181 2.98558 3.08244 3.77121C2.68868 4.16496 2.29681 4.56246 1.86368 4.99746L5.45244 8.58621C5.75244 8.88621 5.76931 9.31371 5.50681 9.59121C5.24243 9.86871 4.79431 9.87246 4.49993 9.57996C3.13868 8.22621 1.77931 6.86683 0.42556 5.50558C0.131185 5.20933 0.123685 4.79496 0.41431 4.50058C1.77368 3.13183 3.13681 1.7687 4.50368 0.40933C4.68368 0.23308 4.90493 0.16183 5.15431 0.21808Z" fill="currentColor"></path><path d="M9.26369 0.218058C9.52056 0.274308 9.69494 0.428058 9.76806 0.688683C9.84869 0.977433 9.76056 1.21368 9.55619 1.41618C8.76869 2.20181 7.97931 2.98556 7.18994 3.77118C6.79619 4.16493 6.40431 4.56243 5.97119 4.99743L9.56181 8.58618C9.86181 8.88618 9.87869 9.31368 9.61619 9.59118C9.35181 9.86868 8.90369 9.87243 8.60931 9.57993C7.24806 8.22618 5.88869 6.86681 4.53494 5.50556C4.24056 5.20931 4.23306 4.79493 4.52369 4.50056C5.88119 3.13556 7.24431 1.77056 8.61306 0.411183C8.79119 0.233058 9.01244 0.161808 9.26369 0.218058Z" fill="currentColor"></path></g><defs><clipPath id="clip0_menu_arrow"><rect width="9.6" height="9.6" fill="white" transform="matrix(-1 0 0 1 9.80078 0.199219)"></rect></clipPath></defs>', 2)
  ])]);
}
const Ob = /* @__PURE__ */ g(ia, [["render", da]]), ua = {}, ca = {
  class: "w-6 h-6",
  "aria-hidden": "true",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function ha(e, t) {
  return l(), s("svg", ca, [...t[0] || (t[0] = [
    o("path", { d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" }, null, -1)
  ])]);
}
const Pb = /* @__PURE__ */ g(ua, [["render", ha]]), pa = {}, fa = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ca(e, t) {
  return l(), s("svg", fa, [...t[0] || (t[0] = [
    N('<path d="M10.8333 15.8334H5C3.61929 15.8334 2.5 14.7141 2.5 13.3334V6.66675C2.5 5.28604 3.61929 4.16675 5 4.16675H10.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3333 15.8334H14.9999C16.3806 15.8334 17.4999 14.7141 17.4999 13.3334V6.66675C17.4999 5.28604 16.3806 4.16675 14.9999 4.16675H13.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3334 1.66675V18.3334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83341 9.16675V10.8334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.16667 9.16675V10.8334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const Rb = /* @__PURE__ */ g(pa, [["render", Ca]]), ga = {}, va = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ma(e, t) {
  return l(), s("svg", va, [...t[0] || (t[0] = [
    o("path", {
      d: "M3.3335 15.8333L6.66683 12.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.6665 15V12.5H4.1665",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.16667 16.6654H15.8333C16.7538 16.6654 17.5 15.9192 17.5 14.9987V7.4487C17.5 6.52822 16.7538 5.78203 15.8333 5.78203H10.441C10.1651 5.78203 9.90714 5.64553 9.75197 5.41747L8.58113 3.69659C8.42596 3.46852 8.16797 3.33202 7.89212 3.33203H4.16667C3.24619 3.33203 2.5 4.07822 2.5 4.9987V9.9987",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Nb = /* @__PURE__ */ g(ga, [["render", ma]]), xa = {}, wa = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function ka(e, t) {
  return l(), s("svg", wa, [...t[0] || (t[0] = [
    o("path", { d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" }, null, -1),
    o("polyline", { points: "12 11 12 17" }, null, -1),
    o("polyline", { points: "9 14 12 11 15 14" }, null, -1)
  ])]);
}
const Gb = /* @__PURE__ */ g(xa, [["render", ka]]), ya = {}, ba = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _a(e, t) {
  return l(), s("svg", ba, [...t[0] || (t[0] = [
    N('<path d="M9.33467 11.6719C9.15126 11.6719 9.00119 11.8219 9.00319 12.0053C9.00319 12.1888 9.15326 12.3388 9.33667 12.3388C9.52008 12.3388 9.67014 12.1888 9.67014 12.0053C9.67014 11.8219 9.52008 11.6719 9.33467 11.6719" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.33467 7.66797C9.15126 7.66797 9.00119 7.81803 9.00319 8.00144C9.00319 8.18485 9.15326 8.33491 9.33667 8.33491C9.52008 8.33491 9.67014 8.18485 9.67014 8.00144C9.67014 7.81803 9.52008 7.66797 9.33467 7.66797" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.33467 3.66797C9.15126 3.66797 9.00119 3.81803 9.00319 4.00144C9.00319 4.18485 9.15326 4.33491 9.33667 4.33491C9.52008 4.33491 9.67014 4.18485 9.67014 4.00144C9.67014 3.81803 9.52008 3.66797 9.33467 3.66797" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.33485 11.6719C6.15144 11.6719 6.00138 11.8219 6.00338 12.0053C6.00338 12.1888 6.15344 12.3388 6.33685 12.3388C6.52026 12.3388 6.67032 12.1888 6.67032 12.0053C6.67032 11.8219 6.52026 11.6719 6.33485 11.6719" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.33485 7.66797C6.15144 7.66797 6.00138 7.81803 6.00338 8.00144C6.00338 8.18485 6.15344 8.33491 6.33685 8.33491C6.52026 8.33491 6.67032 8.18485 6.67032 8.00144C6.67032 7.81803 6.52026 7.66797 6.33485 7.66797" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.33485 3.66797C6.15144 3.66797 6.00138 3.81803 6.00338 4.00144C6.00338 4.18485 6.15344 4.33491 6.33685 4.33491C6.52026 4.33491 6.67032 4.18485 6.67032 4.00144C6.67032 3.81803 6.52026 3.66797 6.33485 3.66797" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const Ub = /* @__PURE__ */ g(ya, [["render", _a]]), Ma = {
  width: "16",
  height: "16",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, La = ["fill"], $a = ["fill"], Wb = /* @__PURE__ */ I({
  __name: "PieChartGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Ma, [
      o("path", {
        d: "M4.5 2C4.78 1.97 5 2.2 5 2.48V6.48C5 6.75 5.22 6.98 5.5 6.98H9.5C9.78 6.98 10 7.2 9.98 7.48C9.72 10 7.59 11.98 5 11.98C2.24 11.98 0 9.74 0 6.98C0 4.38 1.97 2.25 4.5 2Z",
        fill: e.active ? "url(#pie_blue)" : "url(#pie_gray)"
      }, null, 8, La),
      o("path", {
        d: "M7.83 0C10.01 0.23 11.74 1.97 11.97 4.14C12 4.42 11.78 4.64 11.5 4.64H7.83C7.56 4.64 7.33 4.42 7.33 4.14V0.48C7.33 0.2 7.56 -0.03 7.83 0Z",
        fill: e.active ? "url(#pie_blue)" : "url(#pie_gray)"
      }, null, 8, $a),
      r[0] || (r[0] = N('<defs><linearGradient id="pie_blue" x1="0.54" y1="10.48" x2="11.97" y2="3.63" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="pie_gray" x1="0.54" y1="10.48" x2="11.97" y2="3.63" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Va = {}, Ba = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "8.8 7.2 13.2 13.4",
  class: "inline-block h-4 w-4 shrink-0",
  "aria-hidden": "true"
};
function Ha(e, t) {
  return l(), s("svg", Ba, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.48 7.55803C19.6654 7.88669 21.3934 9.61403 21.7214 11.7994C21.7814 12.1987 21.46 12.5567 21.056 12.5567H17.3887C17.0207 12.5567 16.722 12.258 16.722 11.89V8.22269C16.722 7.81869 17.0807 7.49803 17.48 7.55803V7.55803Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.7893 17.726C21.2686 17.0787 21.5966 16.3127 21.7213 15.48C21.7813 15.0807 21.46 14.7227 21.056 14.7227H18.3313C17.7373 14.7227 17.44 15.4407 17.86 15.8607L19.7873 17.788C20.0713 18.0713 20.55 18.0487 20.7893 17.726V17.726Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.806 10.4444C11.0507 10.8538 9.02068 13.4864 9.59868 16.4591C9.98335 18.4371 11.582 20.0284 13.5613 20.4051C15.062 20.6904 16.474 20.3124 17.556 19.5131C17.88 19.2738 17.9047 18.7938 17.62 18.5091L14.7507 15.6398C14.6253 15.5144 14.5553 15.3451 14.5553 15.1684V11.1084C14.5553 10.7078 14.2027 10.3858 13.806 10.4444V10.4444Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Yb = /* @__PURE__ */ g(Va, [["render", Ha]]), Fa = {}, Aa = {
  width: "107",
  height: "125",
  viewBox: "0 0 107 125",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ja(e, t) {
  return l(), s("svg", Aa, [...t[0] || (t[0] = [
    o("g", { filter: "url(#filter0_d_5048_55650)" }, [
      o("path", {
        d: "M8.05957 48.4235C8.05957 45.9506 10.0643 43.9459 12.5372 43.9459H55.6674C56.7299 43.9459 57.7578 43.5681 58.5674 42.88L65.0145 37.3999C65.824 36.7118 66.8519 36.334 67.9144 36.334H93.582C96.0549 36.334 98.0596 38.3387 98.0596 40.8116V105.737C98.0596 108.21 96.0549 110.215 93.582 110.215H12.5372C10.0643 110.215 8.05957 108.21 8.05957 105.737V48.4235Z",
        fill: "#5763FF"
      }),
      o("path", {
        d: "M67.9141 36.5576H93.582C95.9312 36.5577 97.8359 38.4623 97.8359 40.8115V105.737C97.8358 108.086 95.9312 109.99 93.582 109.99H12.5371C10.188 109.99 8.28338 108.086 8.2832 105.737V48.4238C8.2832 46.0746 10.1879 44.17 12.5371 44.1699H55.667C56.7825 44.1699 57.8619 43.7731 58.7119 43.0508L65.1592 37.5703C65.9282 36.9167 66.9048 36.5577 67.9141 36.5576Z",
        stroke: "#1627FF",
        "stroke-opacity": "0.4",
        "stroke-width": "0.447761"
      }),
      o("rect", {
        x: "74.7754",
        y: "41.7031",
        width: "8.95522",
        height: "1.79104",
        rx: "0.447761",
        fill: "#5763FF"
      }),
      o("rect", {
        x: "85.9697",
        y: "41.7031",
        width: "5.8209",
        height: "1.79104",
        rx: "0.447761",
        fill: "#000FCC"
      }),
      o("g", { "clip-path": "url(#clip0_5048_55650)" }, [
        o("rect", {
          x: "14.5601",
          y: "17.5781",
          width: "52.388",
          height: "69.8507",
          rx: "4.47761",
          transform: "rotate(-15 14.5601 17.5781)",
          fill: "white"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M26.2978 24.2008C26.9108 23.1389 28.2683 22.7752 29.3302 23.3883L29.428 23.4476C30.4139 24.0857 30.7366 25.3921 30.1428 26.4207C29.5297 27.4825 28.1722 27.8462 27.1103 27.2333C26.0484 26.6202 25.6847 25.2627 26.2978 24.2008ZM28.8074 23.9994C28.1433 23.7011 27.3481 23.9485 26.9763 24.5925C26.5796 25.2797 26.815 26.158 27.5021 26.5547C28.1891 26.9513 29.0676 26.716 29.4642 26.029C29.836 25.385 29.6526 24.5726 29.0623 24.1466L28.9385 24.0668L28.8074 23.9994Z",
          fill: "#0012FA"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M24.0902 23.8126C25.4966 21.3766 28.6119 20.5419 31.048 21.9483L31.2716 22.0853C33.5339 23.5491 34.2748 26.5462 32.9123 28.9061C31.5058 31.3422 28.3906 32.1769 25.9545 30.7704C23.5185 29.3639 22.6837 26.2486 24.0902 23.8126ZM27.878 29.0952C27.5924 29.1718 27.3457 29.3539 27.1874 29.6045L27.1868 29.6042L27.1646 29.6413L27.1635 29.6432C27.074 29.7853 27.0131 29.9435 26.9841 30.109L26.9736 30.1805L26.9497 30.3807C28.6913 31.0552 30.6827 30.5218 31.8544 29.0675L31.7337 28.905L31.7331 28.9046C31.6188 28.751 31.4714 28.6247 31.3013 28.535L31.2614 28.514L31.2601 28.5133C31.0312 28.3923 30.7694 28.3508 30.5161 28.3936L30.4084 28.4172L27.878 29.0952ZM30.461 22.5212C28.4313 21.4828 25.9216 22.2076 24.7687 24.2044C23.6059 26.2183 24.2543 28.78 26.2072 30.0066C26.251 29.7304 26.3494 29.4654 26.4986 29.2277L26.5231 29.1889L26.5246 29.1864C26.7876 28.7696 27.1984 28.4662 27.6752 28.3383L30.2056 27.6603L30.2953 27.6384C30.7456 27.5403 31.2174 27.6044 31.6264 27.8204L31.6657 27.8411L31.6663 27.8414C31.9151 27.9726 32.1345 28.1532 32.3113 28.3721C33.3556 26.3984 32.7145 23.9525 30.8453 22.743L30.6562 22.6268L30.461 22.5212Z",
          fill: "#0012FA"
        }),
        o("rect", {
          x: "41.8164",
          y: "17.2305",
          width: "20.597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 41.8164 17.2305)",
          fill: "#E2E4EE"
        }),
        o("rect", {
          x: "42.9746",
          y: "21.5566",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 42.9746 21.5566)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "26.9883",
          y: "39.7461",
          width: "16.5672",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 26.9883 39.7461)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "59.7358",
          y: "49.5117",
          width: "5.37313",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 59.7358 49.5117)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "31.624",
          y: "57.0449",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 31.624 57.0449)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "49.3564",
          y: "52.2949",
          width: "8.0597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 49.3564 52.2949)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "44.1338",
          y: "25.8789",
          width: "10.2985",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 44.1338 25.8789)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "28.147",
          y: "44.0703",
          width: "32.2388",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 28.147 44.0703)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "67.1992",
          y: "66.9805",
          width: "8.95522",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 67.1992 66.9805)",
          fill: "#99A0FF"
        }),
        o("rect", {
          x: "36.4912",
          y: "75.2109",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 36.4912 75.2109)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "50.7593",
          y: "19.4688",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 50.7593 19.4688)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "29.3062",
          y: "48.3965",
          width: "23.2836",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(-15 29.3062 48.3965)",
          fill: "#F2F3F7"
        })
      ]),
      o("g", { "clip-path": "url(#clip1_5048_55650)" }, [
        o("rect", {
          x: "36.9644",
          y: "1.79102",
          width: "52.388",
          height: "69.8507",
          rx: "4.47761",
          transform: "rotate(6.70628 36.9644 1.79102)",
          fill: "white"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M45.4214 12.284C46.3837 11.5242 47.7795 11.6883 48.5393 12.6506L48.6082 12.742C49.2882 13.6995 49.1049 15.0326 48.1727 15.7686C47.2104 16.5284 45.8146 16.3642 45.0547 15.402C44.2949 14.4396 44.459 13.0439 45.4214 12.284ZM47.8275 13.0251C47.3208 12.5024 46.4906 12.4381 45.9069 12.8989C45.2842 13.3906 45.178 14.2938 45.6697 14.9164C46.1613 15.539 47.0645 15.6453 47.6871 15.1537C48.2708 14.6928 48.4007 13.8702 48.0099 13.2562L47.9244 13.1362L47.8275 13.0251Z",
          fill: "#0012FA"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M43.5139 11.1069C45.7215 9.36377 48.9246 9.74049 50.6678 11.9481L50.8249 12.1582C52.3855 14.3548 51.9653 17.4134 49.8266 19.102C47.6189 20.8452 44.4158 20.4686 42.6727 18.2609C40.9296 16.0531 41.3062 12.85 43.5139 11.1069ZM45.0794 17.4158C44.7856 17.3814 44.4891 17.4593 44.2494 17.6336L44.2489 17.6331L44.2145 17.6593L44.2128 17.6607C44.0772 17.7596 43.962 17.8841 43.8739 18.0271L43.8377 18.0896L43.7414 18.2668C45.1101 19.5376 47.1576 19.7786 48.784 18.8608L48.732 18.6651L48.7316 18.6646C48.6822 18.4796 48.5919 18.3077 48.4671 18.1614L48.4378 18.1272L48.4369 18.126C48.2689 17.929 48.0411 17.7936 47.7899 17.7397L47.6811 17.7218L45.0794 17.4158ZM49.9106 12.2633C48.4089 10.5478 45.809 10.293 43.9994 11.7218C42.1742 13.1629 41.8292 15.7828 43.1899 17.6447C43.3328 17.4042 43.5222 17.1944 43.7488 17.0288L43.7859 17.0018L43.7881 17C44.1867 16.71 44.6805 16.58 45.1709 16.6376L47.7726 16.9435L47.864 16.9564C48.3187 17.0318 48.7334 17.2658 49.0334 17.6178L49.0623 17.6515L49.0628 17.6521C49.2454 17.866 49.3824 18.1149 49.4658 18.3836C51.1659 16.9362 51.4749 14.4265 50.1856 12.6115L50.0529 12.4336L49.9106 12.2633Z",
          fill: "#0012FA"
        }),
        o("rect", {
          x: "62.4185",
          y: "11.5469",
          width: "20.597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 62.4185 11.5469)",
          fill: "#E2E4EE"
        }),
        o("rect", {
          x: "61.8955",
          y: "15.9922",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 61.8955 15.9922)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "40.3145",
          y: "26.9805",
          width: "16.5672",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 40.3145 26.9805)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "67.1274",
          y: "48.1699",
          width: "5.37313",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 67.1274 48.1699)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "38.2227",
          y: "44.7695",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 38.2227 44.7695)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "56.4561",
          y: "46.9121",
          width: "8.0597",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 56.4561 46.9121)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "61.3726",
          y: "20.4434",
          width: "10.2985",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 61.3726 20.4434)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "39.7915",
          y: "31.4258",
          width: "32.2388",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 39.7915 31.4258)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "67.6006",
          y: "67.1562",
          width: "8.95522",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 67.6006 67.1562)",
          fill: "#99A0FF"
        }),
        o("rect", {
          x: "36.0269",
          y: "63.4473",
          width: "15.2239",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 36.0269 63.4473)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "69.8989",
          y: "16.9336",
          width: "6.26866",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 69.8989 16.9336)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "39.2681",
          y: "35.877",
          width: "23.2836",
          height: "2.68657",
          rx: "0.447761",
          transform: "rotate(6.70628 39.2681 35.877)",
          fill: "#F2F3F7"
        })
      ]),
      o("foreignObject", {
        x: "4.02972",
        y: "44.394",
        width: "98.0597",
        height: "69.8507"
      }, [
        o("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: { "backdrop-filter": "blur(2.01px)", "clip-path": "url(#bgblur_2_5048_55650_clip_path)", height: "100%", width: "100%" }
        })
      ]),
      o("g", { "data-figma-bg-blur-radius": "4.02985" }, [
        o("path", {
          d: "M8.05957 52.9014C8.05957 50.4285 10.0643 48.4238 12.5372 48.4238H32.3262C34.1636 48.4238 35.9565 48.989 37.4617 50.0426L44.0306 54.6408C45.5358 55.6945 47.3287 56.2596 49.166 56.2596H93.582C96.0549 56.2596 98.0596 58.2643 98.0596 60.7373V105.737C98.0596 108.21 96.0549 110.215 93.582 110.215H12.5372C10.0643 110.215 8.05957 108.21 8.05957 105.737V52.9014Z",
          fill: "#000CAD",
          "fill-opacity": "0.4"
        }),
        o("path", {
          d: "M12.5371 48.6475H32.3262C34.1174 48.6475 35.8655 49.1985 37.333 50.2256L43.9023 54.8242C45.4452 55.9042 47.2828 56.4834 49.166 56.4834H93.582C95.9313 56.4834 97.8359 58.3881 97.8359 60.7373V105.737C97.8359 108.087 95.9313 109.991 93.582 109.991H12.5371C10.1879 109.991 8.28323 108.087 8.2832 105.737V52.9014C8.28324 50.5522 10.1879 48.6475 12.5371 48.6475Z",
          stroke: "#1627FF",
          "stroke-opacity": "0.4",
          "stroke-width": "0.447761"
        })
      ]),
      o("path", {
        d: "M25.8987 103.327L15.5586 91.4688H18.765L29.1051 103.327H25.8987Z",
        fill: "#FAFAFF"
      }),
      o("path", {
        d: "M15.2231 103.326L15.5425 103.098C15.917 102.831 16.2842 102.559 16.6357 102.292C19.1258 100.453 21.3301 98.2775 23.1808 95.832C24.6069 93.8251 25.0524 92.306 24.4328 91.5478C24.2438 91.3583 24.0126 91.2131 23.7568 91.1233C23.5009 91.0334 23.2273 91.0013 22.9567 91.0295C22.3628 91.0439 21.7733 91.1324 21.2028 91.2927L21.1465 91.308C21.112 91.3178 21.0754 91.3185 21.0405 91.3099C21.0056 91.3014 20.9738 91.284 20.9482 91.2595C20.9115 91.223 20.8909 91.1741 20.8909 91.1232C20.8909 91.0723 20.9115 91.0234 20.9482 90.9869C20.9604 90.9753 20.9743 90.9654 20.9893 90.9575L20.9995 90.9521L21.0879 90.9112C22.5497 90.1731 24.1537 89.7363 25.7986 89.6281C26.1659 89.5935 26.5365 89.6415 26.8814 89.7682C27.2264 89.895 27.5364 90.0972 27.7874 90.359C28.5528 91.2982 28.1777 92.9922 26.7313 95.1289C25.0779 97.5728 23.0257 99.7409 20.6548 101.549C19.8376 102.172 18.9956 102.764 18.1519 103.305L18.1192 103.326H15.2231Z",
        fill: "#C7CBFF"
      }),
      o("path", {
        d: "M24.481 98.0144C23.9392 98.6198 23.3702 99.2011 22.7739 99.7585L23.879 101.008L24.5914 98.148L24.4838 98.0117H24.481",
        fill: "#000657"
      })
    ], -1),
    N('<defs><filter id="filter0_d_5048_55650" x="-0.000619888" y="-2.95639e-05" width="106.12" height="124.543" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="6.26866"></feOffset><feGaussianBlur stdDeviation="4.02985"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5048_55650"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5048_55650" result="shape"></feBlend></filter><clipPath id="bgblur_2_5048_55650_clip_path" transform="translate(-4.02972 -44.394)"><path d="M8.05957 52.9014C8.05957 50.4285 10.0643 48.4238 12.5372 48.4238H32.3262C34.1636 48.4238 35.9565 48.989 37.4617 50.0426L44.0306 54.6408C45.5358 55.6945 47.3287 56.2596 49.166 56.2596H93.582C96.0549 56.2596 98.0596 58.2643 98.0596 60.7373V105.737C98.0596 108.21 96.0549 110.215 93.582 110.215H12.5372C10.0643 110.215 8.05957 108.21 8.05957 105.737V52.9014Z"></path></clipPath><clipPath id="clip0_5048_55650"><rect x="14.5601" y="17.5781" width="52.388" height="69.8507" rx="4.47761" transform="rotate(-15 14.5601 17.5781)" fill="white"></rect></clipPath><clipPath id="clip1_5048_55650"><rect x="36.9644" y="1.79102" width="52.388" height="69.8507" rx="4.47761" transform="rotate(6.70628 36.9644 1.79102)" fill="white"></rect></clipPath></defs>', 1)
  ])]);
}
const qb = /* @__PURE__ */ g(Fa, [["render", ja]]), Ia = {}, Za = {
  width: "16",
  height: "16",
  viewBox: "0 0 15.6667 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ea(e, t) {
  return l(), s("svg", Za, [...t[0] || (t[0] = [
    N('<path d="M11.1667 12.5V1.16667C11.1667 0.798667 10.868 0.5 10.5 0.5H5.16667C4.79867 0.5 4.5 0.798667 4.5 1.16667V12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.5 4.5H1.83333C1.46533 4.5 1.16667 4.79867 1.16667 5.16667V12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5 12.5V5.16667C14.5 4.79867 14.2013 4.5 13.8333 4.5H11.1667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.16667 9.83333H9.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.83333 9.83333V12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.83333 12.5V9.83333" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.5 5.5H9.16667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.5 7.5H9.16667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.5 3.5H9.16667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.16667 7.5H4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.16667 9.83333H4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.1667 7.5H12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.1667 9.83333H12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.1667 12.5H0.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>', 14)
  ])]);
}
const Kb = /* @__PURE__ */ g(Ia, [["render", Ea]]), Sa = {}, za = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.123",
  height: "10",
  viewBox: "0 0 11.123 10"
};
function Da(e, t) {
  return l(), s("svg", za, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_transferência",
      d: "M1.127,2.2a.513.513,0,0,1-.362-.152.51.51,0,0,1,0-.724l.817-.81H-2.8A.51.51,0,0,1-3.31,0a.511.511,0,0,1,.51-.51H1.581L.765-1.317a.507.507,0,0,1-.15-.362.509.509,0,0,1,.15-.362.507.507,0,0,1,.362-.15.507.507,0,0,1,.362.15L3.172-.358A.513.513,0,0,1,3.322,0a.514.514,0,0,1-.151.362L1.488,2.049A.513.513,0,0,1,1.127,2.2ZM-5.047.511H-7.29A.51.51,0,0,1-7.8,0a.51.51,0,0,1,.51-.51h2.244a.51.51,0,0,1,.51.51A.51.51,0,0,1-5.047.511ZM-5.6-3.41a.515.515,0,0,1-.362-.151L-7.649-5.244A.512.512,0,0,1-7.8-5.6a.513.513,0,0,1,.151-.362L-5.966-7.65A.507.507,0,0,1-5.6-7.8a.508.508,0,0,1,.362.15.513.513,0,0,1,0,.725l-.817.81H2.809a.511.511,0,0,1,.51.511.51.51,0,0,1-.51.51H-6.059l.817.81a.515.515,0,0,1,.151.362.515.515,0,0,1-.152.362A.514.514,0,0,1-5.6-3.41Z",
      transform: "translate(7.801 7.801)",
      fill: "#00c6b7"
    }, null, -1)
  ])]);
}
const Qb = /* @__PURE__ */ g(Sa, [["render", Da]]), Ta = {}, Oa = {
  width: "169",
  height: "190",
  viewBox: "0 0 169 190",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Pa(e, t) {
  return l(), s("svg", Oa, [...t[0] || (t[0] = [
    o("g", { filter: "url(#filter0_d_5048_26263)" }, [
      o("path", {
        d: "M12.7637 68.7801C12.7637 64.8639 15.9384 61.6893 19.8545 61.6893H88.1569C89.8395 61.6893 91.4672 61.0909 92.7493 60.0012L102.959 51.3228C104.241 50.2331 105.869 49.6348 107.552 49.6348H148.199C152.116 49.6348 155.29 52.8095 155.29 56.7256V159.543C155.29 163.46 152.116 166.634 148.199 166.634H19.8545C15.9384 166.634 12.7637 163.46 12.7637 159.543V68.7801Z",
        fill: "#5763FF"
      }),
      o("path", {
        d: "M107.552 49.9893H148.199C151.92 49.9893 154.936 53.0052 154.936 56.7256V159.543C154.936 163.263 151.92 166.279 148.199 166.279H19.8545C16.1341 166.279 13.1182 163.263 13.1182 159.543V68.7803C13.1182 65.0599 16.1341 62.044 19.8545 62.0439H88.1572C89.9237 62.0439 91.6325 61.4155 92.9785 60.2715L103.188 51.5928C104.406 50.5575 105.953 49.9893 107.552 49.9893Z",
        stroke: "#1627FF",
        "stroke-opacity": "0.4",
        "stroke-width": "0.709088"
      }),
      o("rect", {
        x: "118.417",
        y: "58.1426",
        width: "14.1818",
        height: "2.83635",
        rx: "0.709088",
        fill: "#5763FF"
      }),
      o("rect", {
        x: "136.145",
        y: "58.1426",
        width: "9.21814",
        height: "2.83635",
        rx: "0.709088",
        fill: "#000FCC"
      }),
      o("g", { "clip-path": "url(#clip0_5048_26263)" }, [
        o("rect", {
          x: "120.462",
          y: "2.83594",
          width: "82.9632",
          height: "110.618",
          rx: "7.09088",
          transform: "rotate(73.2499 120.462 2.83594)",
          fill: "white"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M110.548 21.7354C112.259 22.6545 112.9 24.7856 111.981 26.4961L111.892 26.6538C110.93 28.2453 108.877 28.8192 107.22 27.929C105.51 27.0099 104.869 24.8787 105.788 23.1682C106.707 21.4577 108.838 20.8163 110.548 21.7354ZM110.988 25.6981C111.428 24.6325 110.998 23.3858 109.961 22.8284C108.854 22.2337 107.475 22.6487 106.88 23.7555C106.286 24.8622 106.701 26.2413 107.808 26.836C108.845 27.3934 110.122 27.0636 110.768 26.1088L110.888 25.9089L110.988 25.6981Z",
          fill: "#0012FA"
        }),
        o("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M111.056 18.2222C114.98 20.3307 116.452 25.2215 114.343 29.1455L114.137 29.5062C111.93 33.1579 107.222 34.4756 103.42 32.433C99.4961 30.3246 98.0242 25.4338 100.133 21.5098C102.241 17.5859 107.132 16.1138 111.056 18.2222ZM102.877 24.4735C102.742 24.025 102.442 23.6433 102.038 23.405L102.038 23.404L101.978 23.3705L101.975 23.3689C101.746 23.2342 101.493 23.1454 101.229 23.1075L101.116 23.0944L100.798 23.0662C99.8143 25.8556 100.755 28.982 103.113 30.7663L103.365 30.5674L103.365 30.5664C103.603 30.378 103.796 30.1386 103.93 29.8651L103.961 29.8008L103.962 29.7988C104.142 29.4306 104.196 29.0142 104.115 28.6154L104.073 28.446L102.877 24.4735ZM113.408 28.2441C114.954 24.9811 113.685 21.0435 110.469 19.3152C107.225 17.5721 103.201 18.7224 101.354 21.8729C101.793 21.9289 102.217 22.0717 102.601 22.2965L102.664 22.3333L102.668 22.3355C103.34 22.7317 103.84 23.3672 104.066 24.1159L105.261 28.0883L105.3 28.2293C105.477 28.9373 105.399 29.6873 105.076 30.3451L105.046 30.4083L105.045 30.4093C104.85 30.8095 104.574 31.1655 104.236 31.4559C107.411 33.0134 111.252 31.8804 113.076 28.8631L113.25 28.5582L113.408 28.2441Z",
          fill: "#0012FA"
        }),
        o("rect", {
          x: "122.333",
          y: "45.9648",
          width: "32.618",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 122.333 45.9648)",
          fill: "#E2E4EE"
        }),
        o("rect", {
          x: "115.544",
          y: "48.0078",
          width: "9.92723",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 115.544 48.0078)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "85.9775",
          y: "23.582",
          width: "26.2362",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 85.9775 23.582)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "72.1006",
          y: "75.8906",
          width: "8.50905",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 72.1006 75.8906)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "58.8169",
          y: "31.7559",
          width: "24.109",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 58.8169 31.7559)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "67.1968",
          y: "59.5957",
          width: "12.7636",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 67.1968 59.5957)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "108.753",
          y: "50.0508",
          width: "16.309",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 108.753 50.0508)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "79.187",
          y: "25.625",
          width: "51.0543",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 79.187 25.625)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "44.8096",
          y: "88.5469",
          width: "14.1818",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 44.8096 88.5469)",
          fill: "#99A0FF"
        }),
        o("rect", {
          x: "30.2998",
          y: "40.3398",
          width: "24.109",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 30.2998 40.3398)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "119.222",
          y: "60.2285",
          width: "9.92723",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 119.222 60.2285)",
          fill: "#F2F3F7"
        }),
        o("rect", {
          x: "72.3979",
          y: "27.668",
          width: "36.8726",
          height: "4.25453",
          rx: "0.709088",
          transform: "rotate(73.2499 72.3979 27.668)",
          fill: "#F2F3F7"
        })
      ]),
      o("foreignObject", {
        x: "6.38188",
        y: "62.3975",
        width: "155.29",
        height: "110.617"
      }, [
        o("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: { "backdrop-filter": "blur(3.19px)", "clip-path": "url(#bgblur_1_5048_26263_clip_path)", height: "100%", width: "100%" }
        })
      ]),
      o("g", { "data-figma-bg-blur-radius": "6.38179" }, [
        o("path", {
          d: "M12.7637 75.8702C12.7637 71.954 15.9384 68.7793 19.8545 68.7793H51.1931C54.1028 68.7793 56.9421 69.6743 59.3258 71.3429L69.7284 78.6247C72.1121 80.2933 74.9514 81.1883 77.8611 81.1883H148.199C152.116 81.1883 155.29 84.363 155.29 88.2792V159.543C155.29 163.459 152.116 166.633 148.199 166.633H19.8545C15.9384 166.633 12.7637 163.459 12.7637 159.543V75.8702Z",
          fill: "#000CAD",
          "fill-opacity": "0.4"
        }),
        o("path", {
          d: "M19.8545 69.1338H51.1934C54.0302 69.1338 56.798 70.007 59.1221 71.6338L69.5254 78.915C71.9687 80.6253 74.879 81.543 77.8613 81.543H148.199C151.92 81.543 154.936 84.5589 154.936 88.2793V159.543C154.935 163.263 151.919 166.279 148.199 166.279H19.8545C16.1343 166.279 13.1184 163.263 13.1182 159.543V75.8701C13.1182 72.1498 16.1342 69.1338 19.8545 69.1338Z",
          stroke: "#1627FF",
          "stroke-opacity": "0.4",
          "stroke-width": "0.709088"
        })
      ]),
      o("path", {
        d: "M41.014 155.726L24.6392 136.947H29.7169L46.0917 155.726H41.014Z",
        fill: "#FAFAFF"
      }),
      o("path", {
        d: "M24.1089 155.728L24.6146 155.367C25.2077 154.943 25.7893 154.513 26.3458 154.089C30.2893 151.177 33.78 147.732 36.7109 143.86C38.9692 140.681 39.6747 138.276 38.6936 137.075C38.3943 136.775 38.0281 136.545 37.623 136.403C37.2178 136.26 36.7844 136.21 36.3559 136.254C35.4154 136.277 34.4819 136.417 33.5784 136.671L33.4893 136.695C33.4346 136.711 33.3767 136.712 33.3214 136.698C33.2662 136.685 33.2157 136.657 33.1753 136.618C33.1171 136.561 33.0845 136.483 33.0845 136.403C33.0845 136.322 33.1171 136.244 33.1753 136.187C33.1946 136.168 33.2165 136.153 33.2404 136.14L33.2565 136.132L33.3965 136.067C35.7114 134.898 38.2515 134.206 40.8565 134.035C41.4382 133.98 42.025 134.056 42.5713 134.257C43.1176 134.458 43.6085 134.778 44.0059 135.192C45.2181 136.68 44.624 139.362 42.3336 142.746C39.7152 146.616 36.4653 150.05 32.7106 152.913C31.4164 153.9 30.083 154.837 28.7469 155.694L28.6952 155.728H24.1089Z",
        fill: "#C7CBFF"
      }),
      o("path", {
        d: "M38.7693 147.313C37.9113 148.272 37.0102 149.192 36.0659 150.075L37.8159 152.053L38.9442 147.524L38.7738 147.309H38.7693",
        fill: "#000657"
      })
    ], -1),
    N('<defs><filter id="filter0_d_5048_26263" x="9.44138e-05" y="-0.000412941" width="168.054" height="189.326" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="9.92723"></feOffset><feGaussianBlur stdDeviation="6.38179"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5048_26263"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5048_26263" result="shape"></feBlend></filter><clipPath id="bgblur_1_5048_26263_clip_path" transform="translate(-6.38188 -62.3975)"><path d="M12.7637 75.8702C12.7637 71.954 15.9384 68.7793 19.8545 68.7793H51.1931C54.1028 68.7793 56.9421 69.6743 59.3258 71.3429L69.7284 78.6247C72.1121 80.2933 74.9514 81.1883 77.8611 81.1883H148.199C152.116 81.1883 155.29 84.363 155.29 88.2792V159.543C155.29 163.459 152.116 166.633 148.199 166.633H19.8545C15.9384 166.633 12.7637 163.459 12.7637 159.543V75.8702Z"></path></clipPath><clipPath id="clip0_5048_26263"><rect x="120.462" y="2.83594" width="82.9632" height="110.618" rx="7.09088" transform="rotate(73.2499 120.462 2.83594)" fill="white"></rect></clipPath></defs>', 1)
  ])]);
}
const Xb = /* @__PURE__ */ g(Ta, [["render", Pa]]), Ra = {}, Na = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ga(e, t) {
  return l(), s("svg", Na, [...t[0] || (t[0] = [
    o("path", {
      d: "M3 9H21",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.57 13H7",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18 19H6C4.343 19 3 17.657 3 16V8C3 6.343 4.343 5 6 5H18C19.657 5 21 6.343 21 8V16C21 17.657 19.657 19 18 19Z",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Jb = /* @__PURE__ */ g(Ra, [["render", Ga]]), Ua = {}, Wa = { class: "outline outline-1 outline-border-gray rounded-md p-3 w-10" };
function Ya(e, t) {
  return l(), s("div", Wa, [...t[0] || (t[0] = [
    N('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g id="Group_2738" data-name="Group 2738" transform="translate(-420 -501)"><g id="Group_2737" data-name="Group 2737" transform="translate(0.455 0.869)"><g id="Group_2733" data-name="Group 2733" transform="translate(425.516 505.295)"><path id="Path_868" data-name="Path 868" d="M613.927,588.314h-2.048a.39.39,0,0,1,0-.781h2.048a.838.838,0,1,0,0-1.677h-.819a1.619,1.619,0,0,1,0-3.238h2.048a.39.39,0,0,1,0,.781h-2.048a.838.838,0,1,0,0,1.677h.819a1.619,1.619,0,0,1,0,3.238Z" transform="translate(-611.489 -582.618)" fill="#020203"></path></g><g id="Group_2734" data-name="Group 2734" transform="translate(427.154 504.321)"><path id="Path_869" data-name="Path 869" d="M669.629,550.055a.39.39,0,0,1-.39-.39v-.97a.39.39,0,1,1,.781,0v.97A.39.39,0,0,1,669.629,550.055Z" transform="translate(-669.239 -548.304)" fill="#020203"></path></g><g id="Group_2735" data-name="Group 2735" transform="translate(427.154 510.191)"><path id="Path_870" data-name="Path 870" d="M669.629,756.963a.39.39,0,0,1-.39-.39v-.97a.39.39,0,0,1,.781,0v.97A.39.39,0,0,1,669.629,756.963Z" transform="translate(-669.239 -755.212)" fill="#020203"></path></g></g><g id="Ellipse_16" data-name="Ellipse 16" transform="translate(420 501)" fill="none" stroke="#020203" stroke-width="1"><circle cx="8" cy="8" r="8" stroke="none"></circle><circle cx="8" cy="8" r="7.5" fill="none"></circle></g></g></svg>', 1)
  ])]);
}
const e_ = /* @__PURE__ */ g(Ua, [["render", Ya]]), qa = {}, Ka = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function Qa(e, t) {
  return l(), s("svg", Ka, [...t[0] || (t[0] = [
    N('<g id="ic_name" transform="translate(-336 -385.252)"><g id="Rectangle_55" data-name="Rectangle 55" transform="translate(336 385.252)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="40" height="40" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="none"></rect></g><path id="Path_99" data-name="Path 99" d="M11.3-104a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h3.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3h.4a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-5,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H5.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Zm-3,0a.3.3,0,0,1-.3-.3v-15.4a.3.3,0,0,1,.3-.3H.7a.3.3,0,0,1,.3.3v15.4a.3.3,0,0,1-.3.3Z" transform="translate(348.499 517.252)" fill="#020203"></path></g>', 1)
  ])]);
}
const t_ = /* @__PURE__ */ g(qa, [["render", Qa]]), Xa = {}, Ja = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function ed(e, t) {
  return l(), s("svg", Ja, [...t[0] || (t[0] = [
    N('<g id="Group_2736" data-name="Group 2736" transform="translate(-408 -633)"><g id="Rectangle_55" data-name="Rectangle 55" transform="translate(408 633)" fill="#fff" stroke="#eeeff1" stroke-width="1"><rect width="40" height="40" rx="8" stroke="none"></rect><rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="none"></rect></g><g id="Group_2731" data-name="Group 2731" transform="translate(-11.195 213.771)"><g id="Group_2728" data-name="Group 2728" transform="translate(434.014 431.229)"><path id="Path_863" data-name="Path 863" d="M525.129,438.423a.438.438,0,0,1-.309-.128L522.53,436a1.307,1.307,0,0,0-1.838-.006.437.437,0,0,1-.617-.62l3.512-3.512a2.182,2.182,0,0,1,3.082,0l3.52,3.52a.437.437,0,1,1-.618.618,1.306,1.306,0,0,0-1.845,0l-2.289,2.29A.438.438,0,0,1,525.129,438.423Zm-3.211-3.651a2.166,2.166,0,0,1,1.23.614l1.981,1.981,1.98-1.981a2.169,2.169,0,0,1,1.23-.615l-2.287-2.287a1.307,1.307,0,0,0-1.846,0Z" transform="translate(-519.947 -431.229)" fill="#020203"></path></g><g id="Group_2729" data-name="Group 2729" transform="translate(434.005 440.034)"><path id="Path_864" data-name="Path 864" d="M524.847,715.559a2.173,2.173,0,0,1-1.541-.637l-3.522-3.522h0a.437.437,0,0,1,.618-.618h0a1.305,1.305,0,0,0,1.846,0l2.29-2.289a.437.437,0,0,1,.618,0l2.289,2.289a1.3,1.3,0,0,0,1.845,0,.437.437,0,1,1,.618.618l-3.52,3.522A2.174,2.174,0,0,1,524.847,715.559Zm-3.21-3.542,2.287,2.287a1.307,1.307,0,0,0,1.846,0l2.286-2.287a2.162,2.162,0,0,1-1.229-.616l-1.98-1.98-1.981,1.98A2.164,2.164,0,0,1,521.638,712.016Z" transform="translate(-519.656 -708.365)" fill="#020203"></path></g><g id="Group_2730" data-name="Group 2730" transform="translate(431.194 434.749)"><path id="Path_865" data-name="Path 865" d="M442.717,550.981a2.165,2.165,0,0,1-1.541-.638l-1.98-1.98-1.981,1.98a2.18,2.18,0,0,1-3.082,0l-2.3-2.3a2.179,2.179,0,0,1,0-3.082l2.3-2.3.023-.021a2.184,2.184,0,0,1,3.06.021l1.981,1.981,1.98-1.981a2.181,2.181,0,0,1,3.081,0l2.3,2.3a2.18,2.18,0,0,1,0,3.082l-2.3,2.3A2.165,2.165,0,0,1,442.717,550.981Zm-3.52-3.674a.436.436,0,0,1,.309.128l2.289,2.289a1.3,1.3,0,0,0,1.844,0l2.3-2.3h0a1.305,1.305,0,0,0,0-1.846l-2.3-2.3a1.306,1.306,0,0,0-1.845,0l-2.289,2.29a.45.45,0,0,1-.618,0l-2.29-2.29a1.307,1.307,0,0,0-1.838-.006l-.019.018-2.289,2.289a1.305,1.305,0,0,0,0,1.846l2.3,2.3a1.305,1.305,0,0,0,1.846,0l2.29-2.289A.436.436,0,0,1,439.2,547.307Z" transform="translate(-431.194 -542.021)" fill="#020203"></path></g></g></g>', 1)
  ])]);
}
const o_ = /* @__PURE__ */ g(Xa, [["render", ed]]), td = {}, od = {
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function nd(e, t) {
  return l(), s("svg", od, [...t[0] || (t[0] = [
    N('<g filter="url(#filter0_d_4239_79612)"><rect x="1.11401" y="1.13672" width="23.0476" height="29.7931" rx="4.6581" fill="white"></rect><rect x="1.02613" y="1.04883" width="23.2234" height="29.9689" rx="4.74599" stroke="#F2F3F7" stroke-width="0.175777"></rect></g><rect x="3.14282" y="3.30859" width="6.28571" height="6.62069" rx="1.31833" fill="#E2E4EE"></rect><rect x="11.5249" y="4.41406" width="10.4762" height="2.2069" rx="0.878886" fill="#E2E4EE"></rect><rect x="11.5249" y="7.72266" width="10.4762" height="2.2069" rx="0.878886" fill="#E2E4EE"></rect><rect x="3.14282" y="13.2422" width="18.8571" height="2.2069" rx="0.878886" fill="#E2E4EE"></rect><rect x="3.14282" y="16.5508" width="18.8571" height="2.2069" rx="0.878886" fill="#E2E4EE"></rect><rect x="9.49609" y="22.1016" width="12.5714" height="6.62069" rx="1.74182" fill="#F93365"></rect><path d="M11.5249 26.7203V26.2201H11.9594V26.7203H11.5249Z" fill="#F9F9FB"></path><path d="M13.8024 24.1203C14.5236 24.1203 15.0433 24.6865 15.0433 25.4462C15.0433 26.2059 14.5236 26.7769 13.8024 26.7769C13.4395 26.7769 13.1214 26.6306 12.8974 26.3805V27.631H12.5166V24.1722H12.7809L12.8571 24.5639C13.0811 24.2855 13.4126 24.1203 13.8024 24.1203ZM13.7755 26.39C14.2862 26.39 14.6625 25.9889 14.6625 25.4462C14.6625 24.9083 14.2862 24.5072 13.7755 24.5072C13.2603 24.5072 12.884 24.913 12.884 25.4462C12.884 25.9842 13.2603 26.39 13.7755 26.39Z" fill="#F9F9FB"></path><path d="M17.4416 23.2662H17.8224V26.725H17.5267L17.4775 26.3617C17.2535 26.6212 16.9264 26.7769 16.5456 26.7769C15.8199 26.7769 15.2958 26.2059 15.2958 25.451C15.2958 24.6865 15.8199 24.1203 16.5456 24.1203C16.904 24.1203 17.2176 24.2619 17.4416 24.4978V23.2662ZM16.5725 26.39C17.0877 26.39 17.464 25.9842 17.464 25.451C17.464 24.913 17.0877 24.5072 16.5725 24.5072C16.0618 24.5072 15.6855 24.9083 15.6855 25.451C15.6855 25.9889 16.0618 26.39 16.5725 26.39Z" fill="#F9F9FB"></path><path d="M19.7505 24.1911V24.5261H19.0068V26.7203H18.626V24.5261H18.1512V24.1911H18.626V23.9835C18.626 23.4408 18.8635 23.1719 19.4055 23.1719H19.746V23.4975H19.4727C19.1322 23.4975 18.9978 23.6343 18.9978 23.9929V24.1911H19.7505Z" fill="#F9F9FB"></path><defs><filter id="filter0_d_4239_79612" x="0.152518" y="0.960938" width="24.9706" height="31.716" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.785714"></feOffset><feGaussianBlur stdDeviation="0.392857"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4239_79612"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4239_79612" result="shape"></feBlend></filter></defs>', 12)
  ])]);
}
const n_ = /* @__PURE__ */ g(td, [["render", nd]]), rd = {}, ld = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "shrink-0"
};
function sd(e, t) {
  return l(), s("svg", ld, [...t[0] || (t[0] = [
    o("path", {
      d: "M14.125 14.125L5.875 5.875",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M14.125 8.23047V14.1246L8.23169 14.1238",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const r_ = /* @__PURE__ */ g(rd, [["render", sd]]), id = {}, ad = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function dd(e, t) {
  return l(), s("svg", ad, [...t[0] || (t[0] = [
    o("path", {
      d: "M3.33325 13.3337C3.33325 11.6671 4.66659 10.4004 6.26659 10.4004H9.66659C11.3333 10.4004 12.5999 11.7337 12.5999 13.3337",
      stroke: "#0012FA",
      "stroke-width": "1.4824",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99999 3.46602C11.1333 4.59935 11.1333 6.39935 9.99999 7.46602C8.86666 8.53268 7.06666 8.59935 5.99999 7.46602C4.93333 6.33268 4.86666 4.53268 5.99999 3.46602C7.13333 2.39935 8.86666 2.39935 9.99999 3.46602",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const l_ = /* @__PURE__ */ g(id, [["render", dd]]), ud = {
  viewBox: "-2 -2 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, cd = ["fill"], hd = ["fill"], pd = ["id"], fd = ["stop-color"], Cd = ["stop-color"], gd = ["id"], vd = ["stop-color"], md = ["stop-color"], s_ = /* @__PURE__ */ I({
  __name: "PersonGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", ud, [
      o("path", {
        d: "M8.13054 7.16092C10.319 7.16098 11.9999 8.82442 12 10.8383C12 10.9452 11.9133 11.0319 11.8065 11.0319C8.24359 11.0319 3.98202 11.0319 0.193548 11.0319C0.0866546 11.0319 0 10.9452 0 10.8383C0.000105875 8.73967 1.77045 7.16098 3.86946 7.16092H8.13054Z",
        fill: `url(#paint0_linear_4912_13376_${D(r)})`
      }, null, 8, cd),
      o("path", {
        d: "M3.80746 0.878916C5.00306 -0.256271 6.81476 -0.291841 8.04889 0.772313L8.16683 0.878916L8.17137 0.882696L8.28327 1.0014C9.4023 2.2488 9.37012 4.14552 8.16683 5.28819C6.94071 6.45245 4.97488 6.53918 3.7999 5.27987C2.64684 4.04375 2.5605 2.06331 3.80746 0.878916Z",
        fill: `url(#paint1_linear_4912_13376_${D(r)})`
      }, null, 8, hd),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13376_${D(r)}`,
          x1: "0.545454",
          y1: "9.65324",
          x2: "11.4701",
          y2: "2.53594",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, fd),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, Cd)
        ], 8, pd),
        o("linearGradient", {
          id: `paint1_linear_4912_13376_${D(r)}`,
          x1: "0.545454",
          y1: "9.65324",
          x2: "11.4701",
          y2: "2.53594",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, vd),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, md)
        ], 8, gd)
      ])
    ]));
  }
}), xd = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, i_ = /* @__PURE__ */ I({
  __name: "PersonIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", xd, [...r[0] || (r[0] = [
      o("circle", {
        cx: "13.9587",
        cy: "14.7917",
        r: "3.54167",
        stroke: "#9DA1C3",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M15.1493 14.0903L13.6618 15.5769L12.7676 14.6853",
        stroke: "#9DA1C3",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M8.33333 12.5H5.83333C3.99238 12.5 2.5 13.9924 2.5 15.8333V16.6667",
        stroke: "#9DA1C3",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("circle", {
        cx: "9.16634",
        cy: "5.83333",
        r: "3.33333",
        stroke: "#9DA1C3",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
}), wd = ["width", "height"], kd = ["stroke"], yd = ["stroke"], bd = ["stroke"], a_ = /* @__PURE__ */ I({
  __name: "PersonWithCheckIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" },
    checkColor: { default: "currentColor" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }, [
      o("circle", {
        cx: "12",
        cy: "8",
        r: "4",
        stroke: e.color,
        "stroke-width": "1.5"
      }, null, 8, kd),
      o("path", {
        d: "M5 20C5 16.134 8.13401 13 12 13C15.866 13 19 16.134 19 20",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, yd),
      o("path", {
        d: "M16 18l2.5 2.5 4-4",
        stroke: e.checkColor,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, bd)
    ], 8, wd));
  }
}), _d = {}, Md = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ld(e, t) {
  return l(), s("svg", Md, [...t[0] || (t[0] = [
    o("path", {
      d: "M13.3076 28.2181L3.78212 18.6948C3.06791 17.9802 2.66669 17.011 2.66669 16.0004C2.66669 14.9899 3.06791 14.0207 3.78212 13.306L7.54412 9.54266L7.58411 9.50488L13.3076 3.78046C14.0225 3.06681 14.9912 2.66602 16.0011 2.66602C17.0111 2.66602 17.9798 3.06681 18.6946 3.78046L28.2179 13.306C28.9321 14.0207 29.3334 14.9899 29.3334 16.0004C29.3334 17.011 28.9321 17.9802 28.2179 18.6948L18.7013 28.2181C17.9862 28.9319 17.0174 29.3327 16.0072 29.3327C14.9971 29.3327 14.0282 28.9319 13.3132 28.2181H13.3076ZM12.9411 22.4537L12.9355 22.4593L12.9 22.4948L12.89 22.5026L12.8211 22.5693C12.8211 22.5693 12.8211 22.5693 12.8156 22.5748C12.8122 22.5765 12.8095 22.5793 12.8078 22.5826L12.6679 22.707L12.6379 22.8082H12.5379C12.1534 23.0979 11.7173 23.3117 11.2528 23.4382L14.6672 26.8604C14.8425 27.0359 15.0507 27.1752 15.2799 27.2702C15.5091 27.3652 15.7547 27.4141 16.0028 27.4141C16.2509 27.4141 16.4965 27.3652 16.7257 27.2702C16.9549 27.1752 17.1631 27.0359 17.3384 26.8604L20.755 23.4415C20.1569 23.2793 19.6082 22.9717 19.1578 22.5459H19.1023L19.0534 22.4459L16 19.3926L12.9411 22.4537ZM16.3088 17.1204C16.4493 17.1677 16.5767 17.2472 16.6809 17.3526L20.424 21.0959C20.7712 21.4466 21.2425 21.6462 21.7358 21.6515H21.7857C22.2779 21.6454 22.7479 21.4458 23.0942 21.0959L26.854 17.336C27.0296 17.1605 27.1689 16.9522 27.264 16.7228C27.3591 16.4935 27.408 16.2476 27.408 15.9993C27.408 15.751 27.3591 15.5051 27.264 15.2758C27.1689 15.0464 27.0296 14.8381 26.854 14.6626L23.0931 10.8993C22.9849 10.7922 22.8645 10.6982 22.7343 10.6193C22.373 10.401 21.9491 10.3101 21.5301 10.3611C21.1112 10.412 20.7213 10.6019 20.4229 10.9004L16.682 14.6471C16.5018 14.8272 16.2575 14.9284 16.0028 14.9284C15.7481 14.9284 15.5038 14.8272 15.3236 14.6471L11.5783 10.8993C11.2256 10.5472 10.7481 10.3487 10.2498 10.3473C9.75147 10.3458 9.2728 10.5414 8.91808 10.8915L8.88143 10.9249L5.14608 14.6626C4.97044 14.8381 4.8311 15.0464 4.73602 15.2758C4.64095 15.5051 4.59202 15.751 4.59202 15.9993C4.59202 16.2476 4.64095 16.4935 4.73602 16.7228C4.8311 16.9522 4.97044 17.1605 5.14608 17.336L8.90809 21.0982C9.25511 21.449 9.72651 21.6486 10.2198 21.6537H10.2687C10.7612 21.6476 11.2315 21.448 11.5783 21.0982L15.3225 17.3537C15.3907 17.2856 15.4685 17.228 15.5535 17.1826C15.6905 17.1104 15.8429 17.0722 15.9978 17.0715C16.1036 17.072 16.2086 17.0896 16.3088 17.1237V17.1204ZM14.6672 5.14268L11.2461 8.55822C11.8476 8.72169 12.3996 9.03079 12.8534 9.45822H12.8622L12.9567 9.55822L16 12.6093L19.09 9.51599C19.1111 9.4971 19.13 9.47822 19.15 9.46044V9.45488C19.3412 9.27569 19.5504 9.1167 19.7742 8.98044L19.782 8.97155L19.8809 8.91822L19.8909 8.91266C20.1615 8.76097 20.4499 8.64341 20.7494 8.56267L17.3329 5.14157C16.978 4.7884 16.4978 4.59015 15.9972 4.59015C15.4967 4.59015 15.0165 4.7884 14.6616 5.14157L14.6672 5.14268Z",
      fill: "#0012FA"
    }, null, -1)
  ])]);
}
const d_ = /* @__PURE__ */ g(_d, [["render", Ld]]), $d = {}, Vd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "63",
  viewBox: "0 0 47 63",
  fill: "none"
};
function Bd(e, t) {
  return l(), s("svg", Vd, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M35.9119 24.4992C36.098 24.5997 36.2747 24.7127 36.4422 24.8381L44.3575 30.7626C45.8152 31.8537 46.1132 33.9253 45.0221 35.383L39.0976 43.2983C38.1379 44.4382 37.1586 44.557 37.1539 44.5632C36.2088 44.7269 34.7905 44.3331 34.7672 44.3253C34.0852 44.1633 34.5593 43.9954 33.9079 43.5079L26.5882 38.0291C25.1304 36.938 24.834 34.8772 25.9251 33.4195L29.217 29.0214C30.3418 28.7212 31.437 28.2538 32.4808 27.6221C32.5877 27.5569 32.6883 27.4871 32.7999 27.4157C33.5138 26.9532 34.1626 26.4225 34.7432 25.8408C34.709 25.7184 34.6469 25.5945 34.5755 25.483C34.4203 25.2507 34.2171 25.0695 33.9845 24.9535C33.438 25.5026 32.8295 26.0053 32.162 26.4445C32.0397 26.5175 31.9235 26.5952 31.8011 26.6681C31.3628 26.9304 30.9198 27.1602 30.4613 27.359L31.8496 25.5042C32.3882 24.7847 32.4731 24.4127 33.3021 24.2879C33.3067 24.2817 33.9 24.0192 33.9 24.0192C34.2099 24.0189 34.4904 24.0451 34.757 24.0897C35.1832 24.1668 35.563 24.3058 35.9119 24.4992Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.50961 61.3516L3.91683 60.9469L4.1669 60.653L2.58905 56.8776C2.46299 56.5785 2.47536 56.2421 2.60496 55.9446L3.34681 54.2416C3.41832 54.0775 3.5309 53.9312 3.69159 53.8425L6.48318 52.1413C6.68673 52.0102 6.7895 51.7743 6.74683 51.536L6.0715 48.2391C6.05016 48.1199 6.06401 48.004 6.1087 47.9014L6.70312 46.5368C6.75228 46.4239 6.82777 46.3348 6.92507 46.2796L8.53688 45.2973C8.74044 45.1662 8.84771 44.92 8.80057 44.6919L8.6379 43.8887C8.58498 43.6459 8.68778 43.4099 8.9016 43.2834L9.60056 42.8555C9.79964 42.7347 9.90689 42.4885 9.85976 42.2604L9.4814 40.4112C9.46007 40.2921 9.47394 40.176 9.5231 40.0632L13 32.0815C13.0492 31.9686 13.1247 31.8794 13.2265 31.8139L14.8383 30.8316C15.0374 30.7108 15.1447 30.4645 15.0975 30.2365L14.7192 28.3873C14.6978 28.2681 14.7117 28.1521 14.7609 28.0392L15.9765 25.2487L22.9426 28.2832L9.55322 59.0202C9.43703 59.287 9.21815 59.509 8.9441 59.6337L4.93382 61.4143C4.84098 61.4593 4.71603 61.4659 4.6237 61.4257C4.58266 61.4078 4.54618 61.3797 4.50961 61.3516Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.9715 53.4481C2.87419 53.5034 2.79421 53.6028 2.74505 53.7157C2.57075 54.1158 2.12834 55.1314 1.90042 55.6546C1.81551 55.8496 1.81258 56.0802 1.89364 56.2864C2.28921 57.2277 3.45404 60.0176 3.81039 60.8808C3.83934 60.9545 3.89203 61.0019 3.96385 61.0331C4.0254 61.06 4.11054 61.0604 4.17392 61.027C5.00186 60.6675 7.58179 59.5088 8.44366 59.1275C8.63513 59.0522 8.77718 58.8944 8.85763 58.7097C10.2252 55.5703 22.3051 27.8393 22.3051 27.8393L15.339 24.8048C15.339 24.8048 14.3334 27.1132 14.101 27.6467C14.0653 27.7287 14.0589 27.7992 14.0732 27.8786C14.143 28.2508 14.3786 29.391 14.4915 29.9162C14.52 30.0751 14.4485 30.2393 14.3128 30.3266C13.8512 30.6016 12.8558 31.2055 12.5358 31.4079C12.4679 31.4516 12.4206 31.5042 12.3849 31.5863L8.86325 39.6706C8.83197 39.7424 8.82116 39.8232 8.83538 39.9026C8.90518 40.2748 9.14078 41.4149 9.25375 41.9402C9.28219 42.0991 9.21069 42.2632 9.07498 42.3506C8.81251 42.5048 8.40994 42.7565 8.14747 42.9107C8.01176 42.9981 7.94471 43.152 7.97315 43.3109C8.03898 43.6081 8.12873 44.0745 8.19456 44.3717C8.22301 44.5305 8.1515 44.6947 8.0158 44.782C7.55424 45.057 6.55892 45.6609 6.23886 45.8632C6.17101 45.9069 6.11925 45.9698 6.08796 46.0416C5.95389 46.3494 5.58292 47.201 5.44885 47.5088C5.41756 47.5806 5.40676 47.6613 5.42098 47.7408C5.52948 48.2763 5.98093 50.4625 6.13657 51.2261C6.16948 51.3747 6.098 51.5388 5.9623 51.6261C5.31638 52.0161 3.5201 53.1134 2.9715 53.4481Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.22617 42.0798C9.33821 42.0188 9.47016 42.0518 9.53121 42.1638C9.59673 42.2656 9.56361 42.3977 9.46183 42.4632L8.30122 43.1661C8.24809 43.2039 8.2168 43.2758 8.22523 43.3405L8.44689 44.4012C8.49535 44.6543 8.38361 44.9108 8.1698 45.0373L6.39261 46.1185C6.35869 46.1404 6.33517 46.1667 6.32176 46.1975L5.68264 47.6646C5.66924 47.6954 5.66598 47.7306 5.67756 47.76L6.39314 51.2453C6.4416 51.4984 6.32988 51.7548 6.1116 51.8917L3.12529 53.7033C3.07217 53.7412 3.01013 53.7997 2.97885 53.8715L2.13421 55.8105C2.07165 55.9541 2.07502 56.1143 2.14318 56.266L4.05543 60.8708C4.06122 60.8855 4.07158 60.8899 4.08184 60.8944C4.0921 60.8989 4.10671 60.893 4.12144 60.8872L8.39694 59.0024C8.52371 58.9355 8.63317 58.8246 8.69127 58.6912L22.0494 28.026L15.4834 25.1658L14.3348 27.8025C14.3214 27.8333 14.3181 27.8685 14.3252 27.9082L14.7438 29.9459C14.7967 30.1887 14.6806 30.4553 14.4668 30.5819L12.5878 31.7287C12.4758 31.7897 12.3437 31.7566 12.2781 31.6548C12.2126 31.553 12.2502 31.4107 12.352 31.3452L14.2309 30.1984C14.2943 30.165 14.3211 30.1035 14.3024 30.0343L13.884 27.9967C13.8627 27.8776 13.881 27.7513 13.9347 27.6282L15.1726 24.7863C15.2218 24.6735 15.3441 24.6169 15.4672 24.6705L22.4333 27.705C22.5462 27.7542 22.5983 27.8868 22.5491 27.9996L9.10164 58.87C8.99885 59.1059 8.81841 59.2959 8.57828 59.3988L4.30855 61.2983C4.18625 61.3549 4.04088 61.3526 3.91329 61.3092C3.79018 61.2556 3.69528 61.1655 3.64316 61.0329L1.72621 56.4384C1.61752 56.1836 1.62233 55.8926 1.73406 55.6362L2.57869 53.6972C2.64573 53.5433 2.75369 53.4072 2.89965 53.3243L5.87574 51.5082C5.93912 51.4748 5.97041 51.4029 5.95172 51.3338L5.23634 47.8485C5.215 47.7294 5.23333 47.6032 5.28249 47.4903L5.9216 46.0231C5.97076 45.9103 6.05071 45.8109 6.15695 45.7352L7.92949 44.6641C7.99287 44.6307 8.02416 44.5588 8.00547 44.4897L7.79423 43.4334C7.74578 43.1804 7.85749 42.924 8.07578 42.7871L9.22617 42.0798Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M35.453 24.6369L43.3829 30.5418C44.8434 31.6293 45.1465 33.7001 44.059 35.1606L38.1542 43.0904C37.6174 43.8113 36.8347 44.2526 36.0061 44.3795L35.9843 44.3827C35.1587 44.4925 34.2888 44.2986 33.5617 43.7572L25.6317 37.8523C24.1713 36.7648 23.8697 34.7048 24.9572 33.2444L27.905 29.2857C29.4817 29.0493 31.0342 28.4954 32.4724 27.6149C32.2953 27.5024 32.129 27.3494 32.0059 27.1515C31.9062 27 31.8375 26.8329 31.7966 26.6672C30.8904 27.2096 29.9309 27.6158 28.9555 27.8749L30.8621 25.3145C31.3989 24.5936 32.1815 24.1523 33.0039 24.0209L33.0256 24.0177C33.5693 23.9492 34.1305 23.9999 34.6535 24.2057C34.9343 24.3086 35.2044 24.4518 35.453 24.6369Z" fill="#1B12FA"></path><mask id="mask0_4466_36468" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="24" y="23" width="21" height="22"><path d="M35.453 24.6369L43.383 30.5418C44.8434 31.6293 45.1465 33.7001 44.0591 35.1606L38.1542 43.0904C37.6174 43.8113 36.8348 44.2526 36.0062 44.3795L35.9844 44.3827C35.1588 44.4925 34.2888 44.2986 33.5617 43.7572L25.6318 37.8523C24.1713 36.7648 23.8698 34.7048 24.9573 33.2444L27.905 29.2857C29.4818 29.0493 31.0343 28.4954 32.4724 27.6149C32.2954 27.5024 32.1291 27.3494 32.0059 27.1515C31.9062 27 31.8375 26.8329 31.7967 26.6672C30.8904 27.2096 29.931 27.6158 28.9556 27.8749L30.8621 25.3145C31.3989 24.5936 32.1816 24.1523 33.004 24.0209L33.0257 24.0177C33.5694 23.9492 34.1306 23.9999 34.6535 24.2057C34.9344 24.3086 35.2045 24.4518 35.453 24.6369Z" fill="white"></path></mask><g mask="url(#mask0_4466_36468)"><path d="M25.6595 40.6046C25.6595 40.6046 28.2351 40.2276 29.6249 40.0242C30.1765 39.9434 30.6754 39.654 31.024 39.2166C31.7368 38.328 32.9816 36.7704 33.7946 35.7473C34.2449 35.1868 35.0484 35.0692 35.6362 35.4777C36.7082 36.2249 38.3516 37.3597 39.2849 38.0074C39.7442 38.3265 40.3094 38.4602 40.861 38.3795C42.1076 38.197 44.2705 37.8804 44.2705 37.8804" stroke="white" stroke-width="1.0921" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M24.2041 30.6395C24.2041 30.6395 26.7797 30.2625 28.1695 30.0591C28.7211 29.9784 29.282 30.1127 29.7413 30.4318C30.6789 31.0789 32.318 32.2143 33.39 32.9615C33.9821 33.3694 34.7856 33.2517 35.2316 32.6919C36.0445 31.6689 37.2938 30.1106 38.0023 29.2226C38.3508 28.7852 38.854 28.4951 39.4056 28.4144L42.8151 27.9153" stroke="white" stroke-width="1.0921" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.1727 44.951C24.7025 44.951 29.996 39.6575 29.996 33.1277C29.996 26.5979 24.7025 21.3044 18.1727 21.3044C11.6429 21.3044 6.3494 26.5979 6.3494 33.1277C6.3494 39.6575 11.6429 44.951 18.1727 44.951Z" fill="#1912D1"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M14.2477 39.9635C13.9383 39.8287 13.5813 39.9683 13.4479 40.2746L6.2929 56.6998C6.15946 57.0061 6.30038 57.3625 6.6098 57.4973C6.91923 57.6321 7.27604 57.4925 7.40948 57.1862L14.5645 40.761C14.6979 40.4547 14.5572 40.0983 14.2477 39.9635Z" fill="#AECDFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M28.8957 29.1015C29.1873 30.4846 29.2079 31.9396 28.9172 33.4211C27.7853 39.1905 22.2932 42.9786 16.6359 41.8687C10.9905 40.7611 7.3249 35.1763 8.45684 29.4068C9.58878 23.6374 15.0929 19.8514 20.7383 20.959C24.5452 21.7059 27.441 24.4755 28.5922 27.966C28.7146 28.3402 28.8133 28.7101 28.8957 29.1015Z" fill="#1B12FA"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M27.9161 28.0897C27.9614 28.2517 27.9935 28.4051 28.0279 28.5694C28.0738 28.7885 28.1197 29.0075 28.1437 29.2312C28.9809 34.9211 25.2484 40.3561 19.542 41.5511C13.6274 42.7898 7.81207 38.9884 6.57113 33.0629C5.399 27.466 8.7379 21.9534 14.1134 20.3246C14.447 21.5353 14.9691 22.7179 15.6924 23.8241C15.8949 24.1361 16.1084 24.4458 16.3392 24.729C16.558 24.4088 16.8429 24.1319 17.1745 23.9138C16.999 23.6762 16.8235 23.4385 16.6676 23.1853C16.0133 22.1904 15.5408 21.1346 15.2457 20.0531C20.9399 18.9635 26.4851 22.5127 27.9161 28.0897Z" fill="#AECDFF"></path><mask id="mask1_4466_36468" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="6" y="19" width="23" height="23"><path d="M27.9162 28.0902C27.9615 28.2522 27.9936 28.4056 28.028 28.5699C28.0739 28.789 28.1198 29.008 28.1438 29.2316C28.981 34.9216 25.2485 40.3566 19.5421 41.5516C13.6275 42.7903 7.81216 38.9889 6.57122 33.0634C5.39909 27.4665 8.73799 21.9539 14.1135 20.3251C14.4471 21.5358 14.9692 22.7184 15.6925 23.8246C15.895 24.1366 16.1085 24.4463 16.3393 24.7295C16.5581 24.4093 16.843 24.1324 17.1746 23.9143C16.9991 23.6767 16.8236 23.439 16.6677 23.1858C16.0134 22.1909 15.5409 21.1351 15.2458 20.0536C20.94 18.964 26.4852 22.5132 27.9162 28.0902Z" fill="white"></path></mask><g mask="url(#mask1_4466_36468)"><path d="M12.3285 18.8559L6.06552 22.2886L19.7867 47.3227L26.0497 43.89L12.3285 18.8559Z" fill="#DAE9FF"></path><path d="M14.8138 15.7423L12.8366 16.8259L26.5578 41.8601L28.5349 40.7764L14.8138 15.7423Z" fill="#DAE9FF"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M16.3589 24.752C15.9063 25.4085 15.7151 26.2438 15.8911 27.0842C16.2336 28.7197 17.8387 29.7689 19.4712 29.427C20.1544 29.2839 20.7344 28.9194 21.1552 28.4274C19.3211 27.6407 17.6604 26.4012 16.3589 24.752Z" fill="#1912D1"></path><mask id="mask2_4466_36468" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="15" y="24" width="7" height="6"><path d="M16.3588 24.752C15.9062 25.4085 15.7151 26.2438 15.8911 27.0842C16.2336 28.7197 17.8387 29.7689 19.4711 29.427C20.1543 29.2839 20.7344 28.9194 21.1552 28.4274C19.3211 27.6407 17.6604 26.4012 16.3588 24.752Z" fill="white"></path></mask><g mask="url(#mask2_4466_36468)"><path d="M19.7327 28.9028C21.472 28.9028 22.882 27.4928 22.882 25.7535C22.882 24.0142 21.472 22.6042 19.7327 22.6042C17.9934 22.6042 16.5834 24.0142 16.5834 25.7535C16.5834 27.4928 17.9934 28.9028 19.7327 28.9028Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7268 27.4054C21.8895 26.9169 21.9259 26.3823 21.8132 25.8442C21.4707 24.2087 19.8656 23.1595 18.2301 23.502C17.8522 23.5812 17.5016 23.7303 17.1963 23.93C18.4136 25.5085 19.9877 26.6809 21.7268 27.4054Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M31.7951 26.6669C31.9154 26.5939 32.0362 26.5187 32.1552 26.4408C32.8263 26.0021 33.4369 25.5021 33.9807 24.9543C33.5068 24.7151 32.9228 24.7271 32.4479 25.0376C31.8958 25.3985 31.6536 26.0592 31.7951 26.6669Z" fill="#1912D1"></path><mask id="mask3_4466_36468" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="31" y="24" width="3" height="3"><path d="M31.7949 26.6669C31.9152 26.5939 32.036 26.5187 32.155 26.4408C32.8261 26.0021 33.4367 25.5021 33.9805 24.9543C33.5066 24.7151 32.9226 24.7271 32.4477 25.0376C31.8956 25.3985 31.6534 26.0592 31.7949 26.6669Z" fill="white"></path></mask><g mask="url(#mask3_4466_36468)"><path d="M33.9805 27.2668C34.8208 27.2668 35.502 26.5856 35.502 25.7452C35.502 24.9049 34.8208 24.2236 33.9805 24.2236C33.1401 24.2236 32.4589 24.9049 32.4589 25.7452C32.4589 26.5856 33.1401 27.2668 33.9805 27.2668Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M32.4746 27.6179C32.966 27.924 33.6101 27.938 34.1242 27.6019C34.7182 27.2136 34.9523 26.4835 34.7413 25.8409C34.1583 26.42 33.5076 26.95 32.7933 27.417C32.6873 27.4863 32.5818 27.5534 32.4746 27.6179Z" fill="#1912D1"></path><mask id="mask4_4466_36468" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="32" y="25" width="3" height="3"><path d="M32.4744 27.6179C32.9659 27.924 33.6099 27.938 34.1241 27.6019C34.718 27.2136 34.9522 26.4835 34.7412 25.8409C34.1581 26.42 33.5074 26.95 32.7931 27.417C32.6872 27.4863 32.5816 27.5534 32.4744 27.6179Z" fill="white"></path></mask><g mask="url(#mask4_4466_36468)"><path d="M33.9806 27.2668C34.8209 27.2668 35.5021 26.5856 35.5021 25.7452C35.5021 24.9049 34.8209 24.2236 33.9806 24.2236C33.1402 24.2236 32.459 24.9049 32.459 25.7452C32.459 26.5856 33.1402 27.2668 33.9806 27.2668Z" fill="white"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M29.2242 29.027C29.1141 29.056 29.0138 29.0785 28.9036 29.1075C28.8205 28.7171 28.7239 28.3499 28.5941 27.9757C28.7209 27.9502 28.841 27.9146 28.9678 27.8891C29.4653 27.7504 29.9698 27.5784 30.4646 27.3697C30.9226 27.1707 31.371 26.9349 31.8062 26.679C31.9268 26.6002 32.0474 26.5213 32.158 26.4491C32.8313 26.0089 33.4487 25.5049 33.9863 24.9669C34.2152 25.0755 34.42 25.2573 34.5711 25.4885C34.6499 25.6091 34.7123 25.7261 34.7479 25.8463C34.1665 26.4272 33.5189 26.9509 32.7953 27.424C32.6948 27.4897 32.5944 27.5553 32.4838 27.6276C31.449 28.2611 30.3459 28.7241 29.2242 29.027ZM34.7668 24.098C37.7139 20.4211 38.1212 15.1197 35.4076 10.969C32.0305 5.80326 25.0899 4.35875 19.9241 7.73588C15.7534 10.4626 14.0029 15.5088 15.2607 20.066C15.5707 21.1545 16.034 22.2144 16.6845 23.2094C16.8487 23.4607 17.023 23.7055 17.2008 23.9335C18.4155 25.5064 19.9902 26.686 21.7388 27.4078C21.6089 27.7796 21.4161 28.1209 21.1602 28.4316C19.3223 27.6391 17.6648 26.3987 16.3608 24.7551C16.137 24.4567 15.9132 24.1584 15.7095 23.8468C14.9868 22.7413 14.4713 21.5578 14.1358 20.3425C12.759 15.318 14.6939 9.76363 19.2868 6.76101C24.9952 3.02907 32.6573 4.63321 36.3826 10.3316C39.3064 14.8039 38.9523 20.4724 35.9221 24.5048C35.5642 24.3084 35.1858 24.1684 34.7668 24.098Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.3763 20.3025C19.2528 20.2783 19.1758 20.1478 19.2 20.0244C19.2242 19.9009 19.3448 19.8094 19.4683 19.8336C25.5407 21.025 29.4991 26.9157 28.3077 32.9882C27.62 36.4934 25.3659 39.2939 22.4039 40.8021C22.1183 40.9511 21.8227 41.0854 21.5173 41.2049C21.3917 41.2572 21.2608 41.2058 21.2086 41.0802C21.1563 40.9546 21.2199 40.8262 21.3332 40.7715C21.6263 40.6495 21.907 40.5251 22.1902 40.3884C25.0265 38.9325 27.1801 36.2533 27.8387 32.8962C28.9793 27.0829 25.1895 21.443 19.3763 20.3025Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.1246 23.7502C17.9994 23.7832 17.8687 23.7085 17.8363 23.5825C17.8007 23.4579 17.8752 23.3262 18.0005 23.2932C19.5178 22.8877 21.1446 23.6401 21.7955 25.1302C22.2118 26.0833 22.1399 27.1284 21.6865 27.9827C21.6438 28.0662 21.5933 28.1494 21.5414 28.2294C21.4712 28.3365 21.326 28.3669 21.2166 28.2979C21.1073 28.229 21.076 28.0797 21.1462 27.9726C21.1914 27.9032 21.232 27.832 21.2695 27.7622C21.655 27.0291 21.7209 26.1347 21.3643 25.3182C20.8092 24.0473 19.4181 23.4025 18.1246 23.7502Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.1461 27.9726C21.2149 27.8623 21.3633 27.8305 21.4741 27.9026C21.5803 27.973 21.6133 28.1177 21.5413 28.2294C21.4425 28.3834 21.3269 28.5334 21.2012 28.669C20.909 28.9849 20.5497 29.251 20.1326 29.4366C18.4926 30.166 16.5736 29.4184 15.8534 27.7695C15.5967 27.1817 15.5286 26.5593 15.6167 25.9662C15.6369 25.8396 15.7603 25.7505 15.886 25.7705C16.0148 25.7891 16.1047 25.9085 16.0859 26.0382C16.0084 26.5432 16.0684 27.0781 16.2876 27.5801C16.9024 28.9876 18.5395 29.6253 19.9393 29.0027C20.2964 28.8438 20.6026 28.6204 20.854 28.3492C20.9617 28.233 21.0607 28.1055 21.1461 27.9726Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.3332 40.7718C21.4588 40.7195 21.5996 40.7855 21.6395 40.9087C21.6942 41.022 21.6405 41.1652 21.5173 41.2052C20.9311 41.449 20.3177 41.6362 19.6867 41.7815C18.2424 42.0878 16.7107 42.1207 15.1555 41.8155C9.09542 40.6266 5.137 34.7358 6.32596 28.6757C6.97977 25.3433 9.04686 22.6471 11.789 21.083C11.9023 21.0284 12.0503 21.0573 12.1174 21.173C12.172 21.2863 12.1308 21.4319 12.0274 21.5013C9.40334 22.986 7.40971 25.5686 6.78253 28.7653C5.64442 34.5662 9.44423 40.2206 15.2451 41.3587C16.7262 41.6493 18.1938 41.6168 19.5863 41.3132C20.1878 41.1877 20.7741 41.0081 21.3332 40.7718Z" fill="#1912D1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6195 42.326C13.6724 42.2127 13.8083 42.1523 13.9292 42.2052C14.0501 42.258 14.1029 42.4015 14.05 42.5148L9.08725 53.906C9.03437 54.0269 8.89836 54.0797 8.7775 54.0268C8.65664 53.974 8.60379 53.838 8.65667 53.7172L13.6195 42.326Z" fill="#1912D1"></path>', 28)
  ])]);
}
const u_ = /* @__PURE__ */ g($d, [["render", Bd]]), Hd = {}, Fd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": ""
};
function Ad(e, t) {
  return l(), s("svg", Fd, [...t[0] || (t[0] = [
    o("path", {
      d: "M12.5258 7.78497C12.5258 7.61247 12.3858 7.47331 12.2133 7.47331C12.0408 7.47414 11.9008 7.61414 11.9008 7.78664C11.9008 7.95914 12.0408 8.09914 12.2133 8.09831C12.3858 8.09831 12.5258 7.95831 12.5258 7.78581",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.4159 12.3208L9.55758 13.1808H8.03091V14.405H6.81008V15.935L5.66508 17.0833H2.91675V14.3292L7.68591 9.54916C7.01425 7.80416 7.37425 5.7525 8.77841 4.345C10.6784 2.44083 13.7592 2.44083 15.6592 4.345C17.5592 6.24916 17.5592 9.33666 15.6592 11.2417C14.2409 12.6617 12.1676 13.02 10.4159 12.3208Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const c_ = /* @__PURE__ */ g(Hd, [["render", Ad]]), jd = {}, Id = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Zd(e, t) {
  return l(), s("svg", Id, [...t[0] || (t[0] = [
    N('<path d="M8.40908 6.79917C9.14131 7.53141 9.14131 8.71859 8.40908 9.45082C7.67684 10.1831 6.48966 10.1831 5.75743 9.45082C5.02519 8.71859 5.02519 7.53141 5.75743 6.79917C6.48966 6.06694 7.67684 6.06694 8.40908 6.79917" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M1.66675 15.4167V4.61758C1.66675 3.67841 2.42841 2.91675 3.36758 2.91675H16.6667C17.5876 2.91675 18.3334 3.66258 18.3334 4.58341V15.4167C18.3334 16.3376 17.5876 17.0834 16.6667 17.0834H3.33341C2.41258 17.0834 1.66675 16.3376 1.66675 15.4167Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.5 7.91667H15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5 11.2499H12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.0791 13.7499C9.93324 13.3841 9.70824 13.0558 9.41907 12.7883V12.7883C8.9299 12.3349 8.28824 12.0833 7.62157 12.0833H6.5449C5.87824 12.0833 5.23657 12.3349 4.7474 12.7883V12.7883C4.45824 13.0558 4.23324 13.3841 4.0874 13.7499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const h_ = /* @__PURE__ */ g(jd, [["render", Zd]]), Ed = {}, Sd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20.0083 20.0083",
  fill: "none",
  class: "shrink-0"
};
function zd(e, t) {
  return l(), s("svg", Sd, [...t[0] || (t[0] = [
    o("path", {
      d: "M10.0042 9.17034H14.1726",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.0042 11.6714H14.1726",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.0042 14.1724H14.1726",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.66945 5.00194H15.8399C16.7608 5.00194 17.5073 5.74844 17.5073 6.6693V15.8398C17.5073 16.7606 16.7608 17.5071 15.8399 17.5071H4.16841C3.24755 17.5071 2.50105 16.7606 2.50105 15.8398V15.8398C2.50105 14.9189 3.24755 14.1724 4.16841 14.1724H5.00209C5.92295 14.1724 6.66945 13.4259 6.66945 12.5051V4.5851C6.66945 3.43403 5.73632 2.5009 4.58525 2.5009V2.5009C3.43418 2.5009 2.50105 3.43403 2.50105 4.5851V15.8398",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const p_ = /* @__PURE__ */ g(Ed, [["render", zd]]), Dd = {}, Td = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Od(e, t) {
  return l(), s("svg", Td, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.86333 4.2041H16.1358C16.8892 4.2041 17.5 4.81493 17.5 5.56827V14.4316C17.5 15.1849 16.8892 15.7949 16.1367 15.7949H3.86333C3.11083 15.7958 2.5 15.1849 2.5 14.4316V5.56827C2.5 4.81493 3.11083 4.2041 3.86333 4.2041Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2.59912 5.06245L9.01079 9.64828C9.58995 10.0624 10.3683 10.0633 10.9483 9.64995L17.3966 5.05078",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const f_ = /* @__PURE__ */ g(Dd, [["render", Od]]), Pd = {}, Rd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Nd(e, t) {
  return l(), s("svg", Rd, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.04671 10.9533C8.07171 9.97831 7.33671 8.88664 6.84837 7.77914C6.74504 7.54497 6.80587 7.27081 6.98671 7.08997L7.66921 6.40831C8.22837 5.84914 8.22837 5.05831 7.74004 4.56997L6.76171 3.59164C6.11087 2.94081 5.05587 2.94081 4.40504 3.59164L3.86171 4.13497C3.24421 4.75247 2.98671 5.64331 3.15337 6.52664C3.56504 8.70414 4.83004 11.0883 6.87087 13.1291C8.91171 15.17 11.2959 16.435 13.4734 16.8466C14.3567 17.0133 15.2475 16.7558 15.865 16.1383L16.4075 15.5958C17.0584 14.945 17.0584 13.89 16.4075 13.2391L15.43 12.2616C14.9417 11.7733 14.15 11.7733 13.6625 12.2616L12.91 13.015C12.7292 13.1958 12.455 13.2566 12.2209 13.1533C11.1134 12.6641 10.0217 11.9283 9.04671 10.9533Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const C_ = /* @__PURE__ */ g(Pd, [["render", Nd]]), Gd = {}, Ud = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Wd(e, t) {
  return l(), s("svg", Ud, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.6666 9.31843C16.6666 13.1026 13.8224 16.6409 9.99992 17.5001C6.17742 16.6409 3.33325 13.1026 3.33325 9.31843V6.34593C3.33325 5.66926 3.74242 5.05926 4.36909 4.80343L8.53575 3.09843C9.47409 2.71426 10.5258 2.71426 11.4641 3.09843L15.6308 4.80343C16.2574 5.06009 16.6666 5.66926 16.6666 6.34593V9.31843V9.31843Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.7083 8.4375L9.58325 11.5625L7.70825 9.6875",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const g_ = /* @__PURE__ */ g(Gd, [["render", Wd]]), Yd = {}, qd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Kd(e, t) {
  return l(), s("svg", qd, [...t[0] || (t[0] = [
    o("path", {
      d: "M16.6668 5.41675L7.50016 14.5834L3.3335 10.4167",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const v_ = /* @__PURE__ */ g(Yd, [["render", Kd]]), Qd = {}, Xd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Jd(e, t) {
  return l(), s("svg", Xd, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9523 17.5031H7.04748C6.06732 17.5031 5.2524 16.7485 5.17723 15.7712L4.37256 5.31055H15.6272L14.8226 15.7712C14.7474 16.7485 13.9325 17.5031 12.9523 17.5031V17.5031Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.669 5.31064H3.33008" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.65518 2.49683H12.3446C12.8626 2.49683 13.2825 2.91673 13.2825 3.43472V5.3105H6.71729V3.43472C6.71729 2.91673 7.13719 2.49683 7.65518 2.49683Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.641 9.06201V13.7515" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.35825 9.06201V13.7515" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const m_ = /* @__PURE__ */ g(Qd, [["render", Jd]]), eu = {}, tu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
function ou(e, t) {
  return l(), s("svg", tu, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.5 12.5C8.39543 12.5 7.5 11.6046 7.5 10.5V4.5C7.5 3.39543 8.39543 2.5 9.5 2.5H15.5C16.6046 2.5 17.5 3.39543 17.5 4.5V10.5C17.5 11.6046 16.6046 12.5 15.5 12.5L9.5 12.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5 15V15.8333C12.5 16.7538 11.7538 17.5 10.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V9.16667C2.5 8.24619 3.24619 7.5 4.16667 7.5H5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const x_ = /* @__PURE__ */ g(eu, [["render", ou]]), nu = {}, ru = {
  width: "110",
  height: "15",
  viewBox: "0 0 110 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function lu(e, t) {
  return l(), s("svg", ru, [...t[0] || (t[0] = [
    N('<path d="M2.71095 3.54353C4.13998 3.54353 5.22226 4.58378 5.22226 5.98128C5.22226 7.36828 4.15049 8.40853 2.71095 8.40853H1.19786V10.8988H0V3.54353H2.71095ZM2.65841 7.2632C3.44648 7.2632 3.99287 6.71681 3.99287 5.98128C3.99287 5.23524 3.44648 4.68885 2.65841 4.68885H1.19786V7.2632H2.65841Z" fill="white"></path><path d="M8.59913 11.0459C6.85487 11.0459 5.56244 9.77451 5.56244 8.06178C5.56244 6.34905 6.85487 5.08814 8.59913 5.08814C10.3329 5.08814 11.6253 6.35955 11.6253 8.06178C11.6253 9.77451 10.3329 11.0459 8.59913 11.0459ZM8.59913 9.93212C9.6709 9.93212 10.4379 9.15456 10.4379 8.06178C10.4379 6.9795 9.6709 6.20194 8.59913 6.20194C7.51685 6.20194 6.74979 6.9795 6.74979 8.06178C6.74979 9.15456 7.51685 9.93212 8.59913 9.93212Z" fill="white"></path><path d="M19.2274 5.22474H20.3937L18.5023 10.8988H17.5567L16.0856 7.45234L14.6356 10.8988H13.6899L11.788 5.22474H12.9859L14.2678 9.04949L15.8965 5.28778H16.2747L17.9244 9.08101L19.2274 5.22474Z" fill="white"></path><path d="M26.3604 8.08279C26.3604 8.20888 26.3498 8.33498 26.3288 8.46107H21.7265C21.8736 9.38573 22.5356 9.95314 23.4603 9.95314C24.1433 9.95314 24.6896 9.63791 24.9944 9.11253H26.2238C25.7719 10.3104 24.7317 11.0459 23.4603 11.0459C21.8001 11.0459 20.5497 9.764 20.5497 8.06178C20.5497 6.37006 21.8001 5.08814 23.4603 5.08814C25.2045 5.08814 26.3604 6.43311 26.3604 8.08279ZM23.4603 6.1494C22.5881 6.1494 21.9472 6.67478 21.758 7.51539H25.1835C24.9734 6.65377 24.3324 6.1494 23.4603 6.1494Z" fill="white"></path><path d="M30.005 5.19321H30.5094V6.29651H29.8894C28.9227 6.29651 28.4499 6.85341 28.4499 7.88315V10.8988H27.2835V5.22474H28.0716L28.2607 6.0023C28.6705 5.46641 29.2274 5.19321 30.005 5.19321Z" fill="white"></path><path d="M36.3401 8.08279C36.3401 8.20888 36.3296 8.33498 36.3086 8.46107H31.7062C31.8533 9.38573 32.5153 9.95314 33.44 9.95314C34.123 9.95314 34.6694 9.63791 34.9741 9.11253H36.2035C35.7517 10.3104 34.7114 11.0459 33.44 11.0459C31.7798 11.0459 30.5294 9.764 30.5294 8.06178C30.5294 6.37006 31.7798 5.08814 33.44 5.08814C35.1842 5.08814 36.3401 6.43311 36.3401 8.08279ZM33.44 6.1494C32.5679 6.1494 31.9269 6.67478 31.7378 7.51539H35.1632C34.9531 6.65377 34.3121 6.1494 33.44 6.1494Z" fill="white"></path><path d="M41.6659 3.19678H42.8323V10.9093H41.9496L41.792 10.2579C41.2877 10.7517 40.5836 11.0459 39.7956 11.0459C38.0723 11.0459 36.843 9.764 36.843 8.07229C36.843 6.35955 38.0723 5.08814 39.7956 5.08814C40.5206 5.08814 41.1616 5.32981 41.6659 5.75012V3.19678ZM39.8796 9.93212C40.9514 9.93212 41.7395 9.12304 41.7395 8.06178C41.7395 7.00051 40.9514 6.20194 39.8796 6.20194C38.8184 6.20194 38.0303 7.00051 38.0303 8.06178C38.0303 9.13355 38.8184 9.93212 39.8796 9.93212Z" fill="white"></path><path d="M49.5406 5.08814C51.2638 5.08814 52.4932 6.35955 52.4932 8.07229C52.4932 9.764 51.2638 11.0459 49.5406 11.0459C48.7525 11.0459 48.0485 10.7517 47.5442 10.2579L47.3971 10.9093H46.5144V3.19678H47.6808V5.75012C48.1746 5.32981 48.8156 5.08814 49.5406 5.08814ZM49.4566 9.92162C50.5283 9.92162 51.3059 9.13355 51.3059 8.06178C51.3059 7.00051 50.5283 6.20194 49.4566 6.20194C48.3848 6.20194 47.5967 7.00051 47.5967 8.06178C47.5967 9.12304 48.3848 9.92162 49.4566 9.92162Z" fill="white"></path><path d="M57.2839 5.22474H58.5238L55.9179 11.0039C55.2769 12.4329 54.7095 12.9373 53.5537 12.9373H52.9758V11.8865H53.4696C54.2157 11.8865 54.4468 11.6659 54.8671 10.7622L54.9932 10.489L52.5239 5.22474H53.7848L55.5921 9.18609L57.2839 5.22474Z" fill="white"></path><path d="M71.9074 14.1321C71.2754 14.1314 70.6695 13.89 70.2227 13.4609C69.7758 13.0318 69.5245 12.4501 69.5239 11.8433V4.38235C69.5246 3.77567 69.776 3.19403 70.2228 2.76504C70.6697 2.33604 71.2755 2.09474 71.9074 2.09406H81.1028V4.50187H72.2561C72.1923 4.50187 72.1312 4.52618 72.0861 4.56945C72.041 4.61272 72.0157 4.67141 72.0157 4.73261V6.67946C72.0157 6.74065 72.041 6.79934 72.0861 6.84262C72.1312 6.88589 72.1923 6.9102 72.2561 6.9102H78.1066V9.3144H72.2561C72.1923 9.3144 72.1312 9.33871 72.0861 9.38198C72.041 9.42526 72.0157 9.48395 72.0157 9.54514V11.4961C72.0158 11.5572 72.0412 11.6158 72.0863 11.659C72.1313 11.7021 72.1924 11.7264 72.2561 11.7264H81.1028V14.1342L71.9074 14.1321Z" fill="white"></path><path d="M85.5924 14.1326C84.9603 14.1319 84.3544 13.8902 83.9075 13.4605C83.4605 13.0309 83.2092 12.4483 83.2085 11.8406V4.38603C83.2092 3.77837 83.4605 3.1958 83.9075 2.76612C84.3544 2.33644 84.9603 2.09474 85.5924 2.09406H94.7874V4.50519H85.9405C85.8768 4.50533 85.8158 4.52973 85.7709 4.57305C85.7259 4.61637 85.7007 4.67506 85.7007 4.73625V11.492C85.7007 11.5532 85.7259 11.6119 85.7709 11.6552C85.8158 11.6985 85.8768 11.7229 85.9405 11.723H94.7874V14.1342L85.5924 14.1326Z" fill="white"></path><path d="M106.285 14.1342L95.8398 2.09406H99.0788L109.524 14.1342H106.285Z" fill="white"></path><path d="M104.509 8.37787C104.039 9.01235 103.283 9.62293 102.765 10.2079L103.55 10.9931L104.606 8.51887L104.514 8.37573L104.509 8.37787Z" fill="#020A79"></path><path d="M95.3135 14.1341L95.6375 13.8993C96.0177 13.6235 96.391 13.3441 96.7477 13.0677C99.2769 11.1721 101.516 8.92949 103.396 6.40848C104.845 4.34141 105.296 2.77233 104.67 1.9912C104.478 1.79613 104.243 1.64661 103.984 1.55404C103.724 1.46146 103.447 1.42826 103.172 1.45697C102.569 1.4718 101.97 1.56291 101.391 1.72803L101.333 1.74379C101.29 1.75618 101.243 1.75403 101.201 1.7377C101.159 1.72137 101.124 1.69177 101.101 1.65356C101.078 1.61536 101.069 1.57072 101.074 1.52666C101.08 1.48261 101.1 1.44165 101.132 1.41022C101.145 1.39821 101.159 1.38795 101.174 1.37975L101.184 1.3745L101.274 1.33247C102.758 0.572314 104.387 0.122483 106.057 0.0113343C106.43 -0.0243766 106.807 0.0250255 107.157 0.155689C107.507 0.286353 107.822 0.494746 108.077 0.764618C108.855 1.73275 108.474 3.47886 107.005 5.68198C105.325 8.20161 103.241 10.4369 100.833 12.3008C100.002 12.9438 99.1472 13.5531 98.2905 14.1115L98.2573 14.1331L95.3135 14.1341Z" fill="#FFB71B"></path>', 14)
  ])]);
}
const w_ = /* @__PURE__ */ g(nu, [["render", lu]]), su = {}, iu = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function au(e, t) {
  return l(), s("svg", iu, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M2.8335 2.83203H5.50016V5.4987H2.8335V2.83203Z" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.8335 8.16602H5.50016V10.8327H2.8335V8.16602Z" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8335 5.5H8.16683V2.83333L10.8335 2.83333V5.5Z" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.5239 9.47578C9.53691 9.4888 9.53691 9.5099 9.5239 9.52292C9.51088 9.53594 9.48977 9.53594 9.47675 9.52292C9.46374 9.5099 9.46374 9.4888 9.47675 9.47578C9.48977 9.46276 9.51088 9.46276 9.5239 9.47578" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.1904 8.14179C8.20342 8.15481 8.20342 8.17592 8.1904 8.18893C8.17738 8.20195 8.15628 8.20195 8.14326 8.18893C8.13024 8.17592 8.13024 8.15481 8.14326 8.14179C8.15628 8.12878 8.17738 8.12878 8.1904 8.14179" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.1904 10.8098C8.20342 10.8228 8.20342 10.8439 8.1904 10.8569C8.17738 10.8699 8.15628 10.8699 8.14326 10.8569C8.13024 10.8439 8.13024 10.8228 8.14326 10.8098C8.15628 10.7967 8.17738 10.7967 8.1904 10.8098" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8569 10.8098C10.8699 10.8228 10.8699 10.8439 10.8569 10.8569C10.8439 10.8699 10.8228 10.8699 10.8098 10.8569C10.7967 10.8439 10.7967 10.8228 10.8098 10.8098C10.8228 10.7967 10.8439 10.7967 10.8569 10.8098" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.1666 4.152V1.83333C13.1666 1.09667 12.57 0.5 11.8333 0.5H9.51465" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.152 0.5H1.83333C1.09667 0.5 0.5 1.09667 0.5 1.83333V4.152" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M0.5 9.51367V11.8323C0.5 12.569 1.09667 13.1657 1.83333 13.1657H4.152" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.51465 13.1657H11.8333C12.57 13.1657 13.1666 12.569 13.1666 11.8323V9.51367" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8569 8.14179C10.8699 8.15481 10.8699 8.17592 10.8569 8.18893C10.8439 8.20195 10.8228 8.20195 10.8098 8.18893C10.7967 8.17592 10.7967 8.15481 10.8098 8.14179C10.8228 8.12878 10.8439 8.12878 10.8569 8.14179" stroke="#3342FF" stroke-linecap="round" stroke-linejoin="round"></path>', 12)
  ])]);
}
const k_ = /* @__PURE__ */ g(su, [["render", au]]), du = {}, uu = {
  width: "9",
  height: "14",
  viewBox: "0 0 9 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cu(e, t) {
  return l(), s("svg", uu, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.42028 12.8693C3.41979 12.8667 3.41845 12.8582 3.42115 12.8416C3.42356 12.8268 3.42536 12.8119 3.42654 12.7969L3.76149 8.54533C3.77347 8.39333 3.72143 8.24322 3.61793 8.13125C3.51443 8.01928 3.36888 7.95561 3.21641 7.95561H1.76165C1.2087 7.95561 0.915848 7.36129 1.22089 6.9359C1.22917 6.92436 1.23699 6.9125 1.24434 6.90036L4.74882 1.1094C4.75441 1.1031 4.75838 1.10018 4.76007 1.09904C4.76266 1.09727 4.7647 1.09644 4.7671 1.09584C4.77304 1.09437 4.78772 1.0934 4.80676 1.10121C4.82581 1.10903 4.83518 1.11986 4.83799 1.12448C4.8391 1.12629 4.83982 1.12798 4.84036 1.1307C4.84085 1.13323 4.8422 1.14176 4.83952 1.15834C4.83739 1.17148 4.83575 1.18468 4.83459 1.19794L4.46046 5.47608C4.4471 5.62879 4.49847 5.7801 4.60204 5.89312C4.70561 6.00614 4.85186 6.07049 5.00516 6.07049H6.44239C7.00467 6.07049 7.28281 6.65149 6.98314 7.06941C6.97415 7.08194 6.96569 7.09486 6.9578 7.10811L3.5111 12.8914C3.50589 12.8972 3.50219 12.8999 3.50058 12.901C3.49798 12.9027 3.49594 12.9036 3.49355 12.9042C3.48761 12.9056 3.47292 12.9066 3.45387 12.8988C3.43481 12.8909 3.42545 12.8801 3.42264 12.8755C3.42154 12.8737 3.42082 12.872 3.42028 12.8693ZM2.33791 12.6914C2.16829 13.8768 3.71042 14.4913 4.40873 13.5175C4.41773 13.5049 4.42618 13.492 4.43408 13.4788L7.8863 7.6862C8.70675 6.51044 7.84125 4.97694 6.44239 4.97694H5.60184L5.92247 1.31053C6.09393 0.123666 4.55053 -0.491692 3.85192 0.482521C3.84365 0.494061 3.83583 0.505917 3.82847 0.518066L0.318877 6.31747C-0.498217 7.48631 0.352868 9.04916 1.76165 9.04916H2.62486L2.33791 12.6914Z",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const y_ = /* @__PURE__ */ g(du, [["render", cu]]), hu = {}, pu = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fu(e, t) {
  return l(), s("svg", pu, [...t[0] || (t[0] = [
    N('<path d="M5.12207 6.35547V10.0037H8.76892" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.4109 10.0101C24.2722 6.29084 20.3095 3.99747 16.0191 3.99609C11.7288 3.99472 7.76458 6.28554 5.62354 10.0035" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M27.9128 14.5039C28.3542 17.9238 27.2998 21.368 25.0196 23.9547C22.7394 26.5414 19.4548 28.0196 16.0065 28.0109V28.0109C12.5581 28.0201 9.27318 26.542 6.99289 23.9552C4.7126 21.3683 3.65839 17.9239 4.10021 14.5039" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M21.3423 21.3425C21.1872 20.9522 20.9465 20.6017 20.638 20.3168V20.3168C20.1181 19.8336 19.4349 19.5648 18.7252 19.5645H13.2896C12.5795 19.5649 11.8958 19.8336 11.3754 20.3168V20.3168C11.0676 20.6023 10.8271 20.9527 10.6711 21.3425" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="16.0066" cy="13.6712" r="3.00125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle>', 5)
  ])]);
}
const b_ = /* @__PURE__ */ g(hu, [["render", fu]]), Cu = {}, gu = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};
function vu(e, t) {
  return l(), s("svg", gu, [...t[0] || (t[0] = [
    N('<defs><linearGradient id="linear-gradient" x1="0.5" x2="0.635" y2="6.328" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#000ec6"></stop><stop offset="1" stop-color="#000657"></stop></linearGradient></defs><g id="ic_name" transform="translate(-336 -369)"><rect id="Retângulo_55" data-name="Retângulo 55" width="40" height="40" rx="8" transform="translate(336 369)" fill="url(#linear-gradient)"></rect><path id="File" d="M109.327,70a.661.661,0,0,0-.189-.471L103.8,64.2a.66.66,0,0,0-.471-.19V64h-4A3.337,3.337,0,0,0,96,67.333v9.333A3.337,3.337,0,0,0,99.333,80H106a3.337,3.337,0,0,0,3.333-3.333V70ZM104,66.276l3.057,3.057H106a2,2,0,0,1-2-2Zm2,12.391H99.333a2,2,0,0,1-2-2V67.333a2,2,0,0,1,2-2h3.333v2A3.337,3.337,0,0,0,106,70.667h2v6A2,2,0,0,1,106,78.667Z" transform="translate(253.333 317)" fill="#fff"></path></g>', 2)
  ])]);
}
const __ = /* @__PURE__ */ g(Cu, [["render", vu]]), mu = {}, xu = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function wu(e, t) {
  return l(), s("svg", xu, [...t[0] || (t[0] = [
    o("path", {
      d: "M11.2966 9.1665L9.6766 10.7865L8.7041 9.814",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.5 13.3332H12.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M16.7071 17.5002V3.93091C16.7071 3.7808 16.6263 3.64229 16.4957 3.56833C16.3651 3.49437 16.2047 3.4964 16.076 3.57363L14.9001 4.27916C14.6362 4.43751 14.3065 4.43751 14.0426 4.27916L12.6644 3.45225C12.4005 3.29391 12.0708 3.29391 11.8069 3.45225L10.4288 4.27916C10.1649 4.43751 9.83517 4.43751 9.57127 4.27916L8.19309 3.45225C7.92918 3.29391 7.59949 3.29391 7.33559 3.45225L5.9574 4.27916C5.6935 4.43751 5.36381 4.43751 5.0999 4.27916L3.92401 3.57363C3.79529 3.4964 3.63498 3.49437 3.50435 3.56833C3.37372 3.64229 3.29297 3.7808 3.29297 3.93091V17.5002",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17.5 17.5002H2.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const M_ = /* @__PURE__ */ g(mu, [["render", wu]]), ku = {}, yu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  class: "shrink-0"
};
function bu(e, t) {
  return l(), s("svg", yu, [...t[0] || (t[0] = [
    N('<path d="M13.3334 14V2.99835C13.3334 2.74631 13.1913 2.51583 12.9661 2.40267L12.3061 2.07099C12.1191 1.97702 11.8988 1.97631 11.7112 2.06907L10.6629 2.58747L9.63564 2.07142C9.4481 1.97721 9.22715 1.97681 9.03927 2.07034L8.00008 2.58767L6.96091 2.07034C6.77303 1.97681 6.55207 1.97721 6.36453 2.07142L5.33727 2.58747L4.28895 2.06907C4.10135 1.97631 3.88109 1.97702 3.69409 2.07099L3.03409 2.40267C2.80889 2.51582 2.66675 2.74631 2.66675 2.99835V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.99927 10.6668L10.6659 10.6669" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.6667 8.33335L10 8.33332" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.33325 10.6668H7.99992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.99992 8.33333H5.33325" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.6666 5.99984H5.33325" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.6666 13.9998H1.33325" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const L_ = /* @__PURE__ */ g(ku, [["render", bu]]), _u = {}, Mu = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Lu(e, t) {
  return l(), s("svg", Mu, [...t[0] || (t[0] = [
    o("path", {
      d: "M5.625 6.875H2.5V3.75",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17.5 10C17.5 5.8575 14.1425 2.5 10 2.5C6.97502 2.5 4.37419 4.295 3.18835 6.875",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M14.375 13.125H17.5V16.25",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2.5 10C2.5 14.1425 5.8575 17.5 10 17.5C13.025 17.5 15.6258 15.705 16.8117 13.125",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const $_ = /* @__PURE__ */ g(_u, [["render", Lu]]), $u = {}, Vu = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Bu(e, t) {
  return l(), s("svg", Vu, [...t[0] || (t[0] = [
    N('<rect width="28" height="28" rx="8" fill="#FEFCE8"></rect><g transform="translate(14, 14) scale(1.16667) translate(-12, -12)"><path d="M12 12.33V9" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.999 14.833C11.907 14.833 11.832 14.908 11.833 15C11.833 15.092 11.908 15.167 12 15.167C12.092 15.167 12.167 15.092 12.167 15C12.167 14.908 12.092 14.833 11.999 14.833" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.654 17.6544C16.206 19.1014 14.209 20.0004 12 20.0004C7.582 20.0004 4 16.4184 4 12.0004C4 11.3924 4.074 10.8024 4.202 10.2334" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2 12L4 10L6 12" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22 12L20 14L18 12" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.34277 6.343C7.79077 4.896 9.79077 4 11.9998 4C16.4178 4 19.9998 7.582 19.9998 12C19.9998 12.608 19.9258 13.198 19.7978 13.767" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g>', 2)
  ])]);
}
const V_ = /* @__PURE__ */ g($u, [["render", Bu]]), Hu = {}, Fu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "11.521",
  viewBox: "0 0 12 11.521"
};
function Au(e, t) {
  return l(), s("svg", Fu, [...t[0] || (t[0] = [
    o("path", {
      id: "Caminho_742",
      "data-name": "Caminho 742",
      d: "M17.645-6070.279a.658.658,0,0,1-.619-.435.638.638,0,0,1-.034-.2.6.6,0,0,1,.423-.571l.373-.119-.154-.113a6.17,6.17,0,0,1-2.128-2.832,5.625,5.625,0,0,1-.306-1.842,5.538,5.538,0,0,1,.587-2.5,5.792,5.792,0,0,1,3.35-2.848.635.635,0,0,1,.191-.029.654.654,0,0,1,.618.435.608.608,0,0,1,.036.2.6.6,0,0,1-.423.571,4.555,4.555,0,0,0-2.63,2.238,4.381,4.381,0,0,0-.461,1.973,4.389,4.389,0,0,0,.235,1.431,4.864,4.864,0,0,0,1.516,2.1l.219.176-.158-.681a.63.63,0,0,1-.015-.138.6.6,0,0,1,.49-.589.61.61,0,0,1,.124-.012.656.656,0,0,1,.637.5l.463,2a.623.623,0,0,1,.015.139.6.6,0,0,1-.422.571l-1.738.549A.638.638,0,0,1,17.645-6070.279Zm5.426-.023a.655.655,0,0,1-.618-.436.6.6,0,0,1-.036-.2.6.6,0,0,1,.423-.572,4.545,4.545,0,0,0,2.629-2.237,4.366,4.366,0,0,0,.462-1.973,4.392,4.392,0,0,0-.235-1.431,4.86,4.86,0,0,0-1.516-2.1l-.221-.176.158.682a.623.623,0,0,1,.016.138.6.6,0,0,1-.49.589.658.658,0,0,1-.125.012.654.654,0,0,1-.636-.5l-.463-2a.627.627,0,0,1-.016-.139.6.6,0,0,1,.423-.571l1.738-.549a.638.638,0,0,1,.191-.029.654.654,0,0,1,.618.435.6.6,0,0,1,.036.2.6.6,0,0,1-.423.571l-.374.119.155.113a6.136,6.136,0,0,1,2.127,2.832,5.59,5.59,0,0,1,.307,1.842,5.554,5.554,0,0,1-.587,2.5,5.8,5.8,0,0,1-3.35,2.848A.639.639,0,0,1,23.071-6070.3Z",
      transform: "translate(-15.2 6081.8)",
      fill: "#000ec0"
    }, null, -1)
  ])]);
}
const B_ = /* @__PURE__ */ g(Hu, [["render", Au]]), ju = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, Iu = ["fill"], Zu = ["fill"], Eu = ["id"], Su = ["stop-color"], zu = ["stop-color"], Du = ["id"], Tu = ["stop-color"], Ou = ["stop-color"], H_ = /* @__PURE__ */ I({
  __name: "ReportGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", ju, [
      o("path", {
        d: "M6.50065 4.02492C6.77545 3.99767 7 4.22403 7 4.50018V8.50018C7.00004 8.77629 7.22388 9.00018 7.5 9.00018H11.5C11.7761 9.00018 12.0025 9.22473 11.9753 9.49953C11.7246 12.0264 9.59278 14.0002 7 14.0002C4.23869 14.0002 2.00004 11.7615 2 9.00018C2 6.40738 3.97376 4.2755 6.50065 4.02492Z",
        fill: `url(#paint0_linear_4912_13405_${D(r)})`
      }, null, 8, Iu),
      o("path", {
        d: "M9.83268 2.02622C12.0112 2.25794 13.7416 3.98899 13.9733 6.16749C14.0025 6.44209 13.7761 6.66684 13.5 6.66684H9.83333C9.55721 6.66684 9.33337 6.44296 9.33333 6.16684V2.50018C9.33333 2.22403 9.55809 1.99702 9.83268 2.02622Z",
        fill: `url(#paint1_linear_4912_13405_${D(r)})`
      }, null, 8, Zu),
      o("defs", null, [
        o("linearGradient", {
          id: `paint0_linear_4912_13405_${D(r)}`,
          x1: "2.54433",
          y1: "12.5032",
          x2: "13.9743",
          y2: "5.65792",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, Su),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, zu)
        ], 8, Eu),
        o("linearGradient", {
          id: `paint1_linear_4912_13405_${D(r)}`,
          x1: "2.54433",
          y1: "12.5032",
          x2: "13.9743",
          y2: "5.65792",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, Tu),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, Ou)
        ], 8, Du)
      ])
    ]));
  }
}), Pu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.333",
  height: "16",
  viewBox: "0 0 13.333 16"
}, Ru = ["fill"], F_ = /* @__PURE__ */ I({
  __name: "ReportIcon",
  props: {
    focus: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = () => t.focus ? "#0012FA" : "#7A7786";
    return (n, i) => (l(), s("svg", Pu, [
      o("path", {
        id: "ic_name",
        d: "M109.327,70a.661.661,0,0,0-.189-.471L103.8,64.2a.66.66,0,0,0-.471-.19V64h-4A3.337,3.337,0,0,0,96,67.333v9.333A3.337,3.337,0,0,0,99.333,80H106a3.337,3.337,0,0,0,3.333-3.333V70ZM104,66.276l3.057,3.057H106a2,2,0,0,1-2-2Zm2,12.391H99.333a2,2,0,0,1-2-2V67.333a2,2,0,0,1,2-2h3.333v2A3.337,3.337,0,0,0,106,70.667h2v6A2,2,0,0,1,106,78.667Zm0-2.417a.666.666,0,0,1-.667.667H100a.667.667,0,0,1,0-1.333h5.333A.666.666,0,0,1,106,76.25Zm-6.667-2.667a.666.666,0,0,1,.667-.667h1.333a.667.667,0,1,1,0,1.333H100A.666.666,0,0,1,99.333,73.583Z",
        transform: "translate(-96 -64)",
        fill: r()
      }, null, 8, Ru)
    ]));
  }
}), Nu = {}, Gu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 16 16"
};
function Uu(e, t) {
  return l(), s("svg", Gu, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_name",
      d: "M5.154-3306A6.153,6.153,0,0,1-1-3312.153v-3.692A6.153,6.153,0,0,1,5.154-3322H8.847A6.153,6.153,0,0,1,15-3315.845v3.692A6.153,6.153,0,0,1,8.847-3306Zm-4.923-9.845v3.692a4.929,4.929,0,0,0,4.923,4.923H8.847a4.929,4.929,0,0,0,4.923-4.923v-3.692a4.929,4.929,0,0,0-4.923-4.924H5.154A4.929,4.929,0,0,0,.231-3315.845Zm4.308,4.923a.616.616,0,0,1-.616-.616.616.616,0,0,1,.616-.615H7a.616.616,0,0,1,.616.615.616.616,0,0,1-.616.616Zm0-2.461a.616.616,0,0,1-.616-.616.615.615,0,0,1,.616-.615H9.461a.615.615,0,0,1,.616.615.616.616,0,0,1-.616.616Zm0-2.461a.616.616,0,0,1-.616-.616.616.616,0,0,1,.616-.616H8.231a.616.616,0,0,1,.616.616.616.616,0,0,1-.616.616Z",
      transform: "translate(1 3322)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const A_ = /* @__PURE__ */ g(Nu, [["render", Uu]]), Wu = {}, Yu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.334",
  height: "16",
  viewBox: "0 0 13.334 16"
};
function qu(e, t) {
  return l(), s("svg", Yu, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_doc_pdf",
      d: "M3.334,16A3.338,3.338,0,0,1,0,12.667V3.334A3.338,3.338,0,0,1,3.334,0h4V.005A.66.66,0,0,1,7.8.2l5.333,5.333A.663.663,0,0,1,13.327,6h.006v6.666A3.338,3.338,0,0,1,10,16Zm-2-12.667v9.333a2,2,0,0,0,2,2H10a2,2,0,0,0,2-2v-6H10A3.337,3.337,0,0,1,6.666,3.334v-2H3.334A2,2,0,0,0,1.334,3.334ZM8,3.334a2,2,0,0,0,2,2h1.058L8,2.276Zm.634,9.237V10.436A.4.4,0,0,1,9.068,10h1.394a.373.373,0,1,1,0,.745H9.451v.426h1.012a.374.374,0,1,1,0,.746H9.451v.653a.409.409,0,1,1-.817,0Zm-6.164,0V10.436A.4.4,0,0,1,2.9,10H4.041a.93.93,0,0,1,1.065,1.007.934.934,0,0,1-1.065,1.016H3.286v.546a.388.388,0,0,1-.408.43A.389.389,0,0,1,2.47,12.57Zm.816-1.292h.661c.209,0,.324-.094.324-.271s-.115-.262-.324-.262H3.286Zm2.557,1.695a.4.4,0,0,1-.436-.435v-2.1A.4.4,0,0,1,5.843,10H6.62c1.047,0,1.646.541,1.646,1.486s-.6,1.487-1.646,1.487Zm.382-.745h.435a.689.689,0,0,0,.772-.742.689.689,0,0,0-.772-.741H6.224Z",
      fill: "#0047ba"
    }, null, -1)
  ])]);
}
const j_ = /* @__PURE__ */ g(Wu, [["render", qu]]), Ku = {}, Qu = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Xu(e, t) {
  return l(), s("svg", Qu, [...t[0] || (t[0] = [
    N('<path d="M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z" fill="#D2DFFD"></path><path d="M32.8235 25.7647C32.8225 24.6192 32.4037 23.5135 31.6456 22.6547C30.8876 21.796 29.8424 21.2432 28.7059 21.1V18.7059C28.7059 18.6209 28.6875 18.537 28.6519 18.4598C28.6164 18.3826 28.5646 18.3141 28.5 18.2588L24.3824 14.7294C24.2758 14.6383 24.1402 14.5882 24 14.5882H16.8C16.2139 14.5898 15.6522 14.8233 15.2378 15.2378C14.8233 15.6522 14.5898 16.2139 14.5882 16.8V31.2C14.5898 31.7861 14.8233 32.3478 15.2378 32.7622C15.6522 33.1767 16.2139 33.4102 16.8 33.4118H26.4941C27.0802 33.4102 27.6419 33.1767 28.0564 32.7622C28.4708 32.3478 28.7043 31.7861 28.7059 31.2V30.4294C29.8424 30.2862 30.8876 29.7334 31.6456 28.8747C32.4037 28.0159 32.8225 26.9102 32.8235 25.7647ZM24.5882 16.4529L26.5294 18.1176H24.5882V16.4529ZM26.4941 32.2353H16.8C16.664 32.2353 16.5294 32.2085 16.4038 32.1565C16.2782 32.1045 16.1641 32.0282 16.0679 31.9321C15.9718 31.8359 15.8955 31.7218 15.8435 31.5962C15.7915 31.4706 15.7647 31.336 15.7647 31.2V16.8C15.7647 16.5254 15.8738 16.2621 16.0679 16.0679C16.2621 15.8738 16.5254 15.7647 16.8 15.7647H23.4118V18.7059C23.4118 18.8619 23.4737 19.0115 23.5841 19.1218C23.6944 19.2321 23.844 19.2941 24 19.2941H27.5294V21.1C26.3989 21.2505 25.3615 21.8065 24.6102 22.6645C23.8589 23.5225 23.4447 24.6242 23.4447 25.7647C23.4447 26.9052 23.8589 28.0069 24.6102 28.8649C25.3615 29.7229 26.3989 30.2789 27.5294 30.4294V31.2C27.5294 31.336 27.5026 31.4706 27.4506 31.5962C27.3986 31.7218 27.3223 31.8359 27.2262 31.9321C27.13 32.0282 27.0159 32.1045 26.8903 32.1565C26.7647 32.2085 26.6301 32.2353 26.4941 32.2353ZM28.1176 29.2941C27.4196 29.2941 26.7372 29.0871 26.1568 28.6993C25.5764 28.3115 25.124 27.7603 24.8569 27.1154C24.5898 26.4704 24.5199 25.7608 24.6561 25.0762C24.7922 24.3915 25.1284 23.7626 25.622 23.269C26.1156 22.7754 26.7445 22.4393 27.4291 22.3031C28.1137 22.1669 28.8234 22.2368 29.4683 22.504C30.1132 22.7711 30.6644 23.2235 31.0522 23.8039C31.4401 24.3843 31.6471 25.0667 31.6471 25.7647C31.6471 26.7008 31.2752 27.5985 30.6133 28.2604C29.9514 28.9223 29.0537 29.2941 28.1176 29.2941Z" fill="#000EC6"></path><path d="M29.8824 25.1765H28.7059V24C28.7059 23.844 28.6439 23.6944 28.5336 23.5841C28.4233 23.4737 28.2737 23.4118 28.1176 23.4118C27.9616 23.4118 27.812 23.4737 27.7017 23.5841C27.5914 23.6944 27.5294 23.844 27.5294 24V25.1765H26.3529C26.1969 25.1765 26.0473 25.2384 25.937 25.3488C25.8267 25.4591 25.7647 25.6087 25.7647 25.7647C25.7647 25.9207 25.8267 26.0703 25.937 26.1807C26.0473 26.291 26.1969 26.3529 26.3529 26.3529H27.5294V27.5294C27.5294 27.6854 27.5914 27.835 27.7017 27.9454C27.812 28.0557 27.9616 28.1176 28.1176 28.1176C28.2737 28.1176 28.4233 28.0557 28.5336 27.9454C28.6439 27.835 28.7059 27.6854 28.7059 27.5294V26.3529H29.8824C30.0384 26.3529 30.188 26.291 30.2983 26.1807C30.4086 26.0703 30.4706 25.9207 30.4706 25.7647C30.4706 25.6087 30.4086 25.4591 30.2983 25.3488C30.188 25.2384 30.0384 25.1765 29.8824 25.1765Z" fill="#000EC6"></path><path d="M18.1176 21.6471H24C24.156 21.6471 24.3056 21.5851 24.4159 21.4748C24.5263 21.3645 24.5882 21.2148 24.5882 21.0588C24.5882 20.9028 24.5263 20.7532 24.4159 20.6429C24.3056 20.5326 24.156 20.4706 24 20.4706H18.1176C17.9616 20.4706 17.812 20.5326 17.7017 20.6429C17.5914 20.7532 17.5294 20.9028 17.5294 21.0588C17.5294 21.2148 17.5914 21.3645 17.7017 21.4748C17.812 21.5851 17.9616 21.6471 18.1176 21.6471Z" fill="#000EC6"></path><path d="M21.6471 22.8235H18.1176C17.9616 22.8235 17.812 22.8855 17.7017 22.9958C17.5914 23.1061 17.5294 23.2558 17.5294 23.4118C17.5294 23.5678 17.5914 23.7174 17.7017 23.8277C17.812 23.938 17.9616 24 18.1176 24H21.6471C21.8031 24 21.9527 23.938 22.063 23.8277C22.1733 23.7174 22.2353 23.5678 22.2353 23.4118C22.2353 23.2558 22.1733 23.1061 22.063 22.9958C21.9527 22.8855 21.8031 22.8235 21.6471 22.8235Z" fill="#000EC6"></path><path d="M21.6471 25.1765H18.1176C17.9616 25.1765 17.812 25.2384 17.7017 25.3488C17.5914 25.4591 17.5294 25.6087 17.5294 25.7647C17.5294 25.9207 17.5914 26.0703 17.7017 26.1807C17.812 26.291 17.9616 26.3529 18.1176 26.3529H21.6471C21.8031 26.3529 21.9527 26.291 22.063 26.1807C22.1733 26.0703 22.2353 25.9207 22.2353 25.7647C22.2353 25.6087 22.1733 25.4591 22.063 25.3488C21.9527 25.2384 21.8031 25.1765 21.6471 25.1765Z" fill="#000EC6"></path><path d="M21.6471 27.5294H18.1176C17.9616 27.5294 17.812 27.5914 17.7017 27.7017C17.5914 27.812 17.5294 27.9616 17.5294 28.1176C17.5294 28.2737 17.5914 28.4233 17.7017 28.5336C17.812 28.6439 17.9616 28.7059 18.1176 28.7059H21.6471C21.8031 28.7059 21.9527 28.6439 22.063 28.5336C22.1733 28.4233 22.2353 28.2737 22.2353 28.1176C22.2353 27.9616 22.1733 27.812 22.063 27.7017C21.9527 27.5914 21.8031 27.5294 21.6471 27.5294Z" fill="#000EC6"></path>', 7)
  ])]);
}
const I_ = /* @__PURE__ */ g(Ku, [["render", Xu]]), Ju = {}, ec = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.334",
  height: "17",
  viewBox: "0 0 14.334 17"
};
function tc(e, t) {
  return l(), s("svg", ec, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_doc_xls",
      d: "M3.334,16A3.338,3.338,0,0,1,0,12.667V3.334A3.338,3.338,0,0,1,3.334,0h4V.005A.66.66,0,0,1,7.8.2l5.333,5.333A.663.663,0,0,1,13.327,6h.006v6.666A3.338,3.338,0,0,1,10,16Zm-2-12.667v9.333a2,2,0,0,0,2,2H10a2,2,0,0,0,2-2v-6H10A3.337,3.337,0,0,1,6.666,3.334v-2H3.334A2,2,0,0,0,1.334,3.334ZM8,3.334a2,2,0,0,0,2,2h1.058L8,2.276Zm.231,9.3a.372.372,0,0,1-.122-.285.342.342,0,0,1,.35-.363.43.43,0,0,1,.281.1,1.054,1.054,0,0,0,.7.225c.32,0,.467-.083.467-.26,0-.13-.121-.194-.558-.2-.868-.009-1.2-.285-1.2-.86,0-.614.493-.99,1.292-.99a1.7,1.7,0,0,1,.951.25.386.386,0,0,1,.182.337.342.342,0,0,1-.35.363.473.473,0,0,1-.268-.095,1.041,1.041,0,0,0-.58-.165c-.272,0-.436.1-.436.251,0,.121.125.185.544.19.878.009,1.215.294,1.215.877,0,.644-.454.99-1.3.99A1.662,1.662,0,0,1,8.231,12.629Zm-3.735.19-.649-.825-.661.839a.374.374,0,0,1-.3.142A.364.364,0,0,1,2.5,12.59a.445.445,0,0,1,.1-.277l.709-.825-.671-.782a.433.433,0,0,1-.1-.281.372.372,0,0,1,.4-.4.4.4,0,0,1,.311.156l.614.782.626-.8a.375.375,0,0,1,.3-.142.364.364,0,0,1,.389.384.44.44,0,0,1-.1.276l-.675.788.7.821a.433.433,0,0,1,.1.281.372.372,0,0,1-.4.4A.4.4,0,0,1,4.5,12.819Zm1.456.131a.39.39,0,0,1-.423-.424V10.446a.4.4,0,1,1,.795,0v1.777H7.609a.364.364,0,1,1,0,.726Z",
      transform: "translate(0.5 0.5)",
      fill: "#0047ba",
      stroke: "rgba(0,0,0,0)",
      "stroke-width": "1"
    }, null, -1)
  ])]);
}
const Z_ = /* @__PURE__ */ g(Ju, [["render", tc]]), oc = {
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "shrink-0",
  "aria-hidden": "true"
}, nc = ["id"], rc = ["filter"], E_ = /* @__PURE__ */ I({
  __name: "ReprovedNotificationIcon",
  setup(e) {
    const t = E(`reproved-notification-filter-${Math.random().toString(36).slice(2, 11)}`);
    return (r, n) => (l(), s("svg", oc, [
      o("defs", null, [
        o("filter", {
          id: t.value,
          x: "0",
          y: "0",
          width: "42",
          height: "42",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, [...n[0] || (n[0] = [
          N('<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow"></feMorphology><feOffset></feOffset><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.976471 0 0 0 0 0.2 0 0 0 0 0.394118 0 0 0 1 0" result="dropShadowColor"></feColorMatrix><feBlend mode="normal" in="dropShadowColor" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>', 8)
        ])], 8, nc)
      ]),
      o("g", {
        filter: `url(#${t.value})`
      }, [...n[1] || (n[1] = [
        N('<rect x="3" y="3" width="36" height="36" rx="8" fill="#FFF0F3"></rect><rect x="2" y="2" width="38" height="38" rx="9" stroke="#F93365" stroke-width="2" fill="none"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M26.3451 16.345L23.9884 13.9883C23.6759 13.6758 23.2517 13.5 22.8101 13.5H16.8334C15.9126 13.5 15.1667 14.2458 15.1667 15.1667V26.8333C15.1667 27.7542 15.9126 28.5 16.8334 28.5H25.1667C26.0876 28.5 26.8334 27.7542 26.8334 26.8333V17.5233C26.8334 17.0817 26.6576 16.6575 26.3451 16.345V16.345Z" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><path d="M26.8334 17.6667H23.5001C23.0401 17.6667 22.6667 17.2933 22.6667 16.8333V13.5" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.9999 22.6666V20.1666" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.9991 24.9792C20.8841 24.9792 20.7908 25.0725 20.7916 25.1875C20.7916 25.3025 20.8849 25.3959 20.9999 25.3959C21.1149 25.3959 21.2083 25.3025 21.2083 25.1875C21.2083 25.0725 21.1149 24.9792 20.9991 24.9792" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
      ])], 8, rc)
    ]));
  }
}), lc = {}, sc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.501",
  height: "25.999",
  viewBox: "0 0 19.501 25.999"
};
function ic(e, t) {
  return l(), s("svg", sc, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_card",
      d: "M4.874-13602A4.873,4.873,0,0,1,0-13606.878v-16.249A4.878,4.878,0,0,1,4.874-13628h9.748a4.879,4.879,0,0,1,4.879,4.875v16.249a4.874,4.874,0,0,1-4.879,4.875Zm-3.251-21.124v16.249a3.254,3.254,0,0,0,3.251,3.25h9.748a3.251,3.251,0,0,0,3.251-3.25v-16.249a3.251,3.251,0,0,0-3.251-3.246H4.874A3.255,3.255,0,0,0,1.623-13623.127Zm10.075,3.252a.323.323,0,0,1-.322-.322v-2.6a.326.326,0,0,1,.322-.328h.978a.326.326,0,0,1,.322.328v2.6a.323.323,0,0,1-.322.322Z",
      transform: "translate(0 13628.002)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const S_ = /* @__PURE__ */ g(lc, [["render", ic]]), ac = {}, dc = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function uc(e, t) {
  return l(), s("svg", dc, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.25 15.75V15.75C4.1075 15.75 0.75 12.3925 0.75 8.25V8.25C0.75 4.1075 4.1075 0.75 8.25 0.75V0.75C12.3925 0.75 15.75 4.1075 15.75 8.25V8.25C15.75 12.3925 12.3925 15.75 8.25 15.75Z",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.5837 6.58301L7.41699 10.7497L4.91699 8.24967",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const z_ = /* @__PURE__ */ g(ac, [["render", uc]]), cc = {}, hc = {
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function pc(e, t) {
  return l(), s("svg", hc, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.1667 5.7065C11.1667 8.73383 8.89133 11.5645 5.83333 12.2518C2.77533 11.5645 0.5 8.73383 0.5 5.7065V3.3285C0.5 2.78717 0.827333 2.29917 1.32867 2.0945L4.662 0.7305C5.41267 0.423167 6.254 0.423167 7.00467 0.7305L10.338 2.0945C10.8393 2.29983 11.1667 2.78717 11.1667 3.3285V5.7065V5.7065Z",
      stroke: "#3342FF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8 5.00195L5.5 7.50195L4 6.00195",
      stroke: "#3342FF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const D_ = /* @__PURE__ */ g(cc, [["render", pc]]), T_ = /* @__PURE__ */ I({
  inheritAttrs: !1,
  __name: "SamsungPayIcon",
  setup(e) {
    return (t, r) => (l(), s("svg", {
      class: v([t.$attrs.class]),
      viewBox: "0 0 45 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet"
    }, [...r[0] || (r[0] = [
      N('<g clip-path="url(#samsung-pay-clip)"><path fill="currentColor" d="M2.27202 14.3592H1.29244V11.8511H2.27202C3.03488 11.8511 3.55299 12.4107 3.55299 13.1004C3.55299 13.7999 3.03488 14.3592 2.27202 14.3592ZM2.36614 10.6766H0.0114746V17.4824H1.29244V15.5339H2.3567C3.7883 15.5339 4.84326 14.4525 4.84326 13.1004C4.84326 11.7581 3.7883 10.6766 2.36614 10.6766Z"></path><path fill="currentColor" d="M8.1029 16.4414C7.16109 16.4414 6.43614 15.6956 6.43614 14.7448C6.43614 13.8032 7.16109 13.0667 8.1029 13.0667C9.04471 13.0667 9.75121 13.8217 9.75121 14.7448C9.75121 15.6864 9.04471 16.4414 8.1029 16.4414ZM9.68541 12.6844C9.28975 12.2183 8.63975 11.9196 7.9148 11.9196C6.52068 11.9196 5.18335 12.9547 5.18335 14.7633C5.18335 16.5442 6.56774 17.5977 7.89577 17.5977C8.62101 17.5977 9.28031 17.2806 9.68541 16.7772V17.4857H10.9568V12.0317H9.68541V12.6844Z"></path><path fill="currentColor" d="M14.3578 15.7039L12.8227 12.0308H11.4663L13.7269 17.2143L12.5682 20.002H13.8587L17.1458 12.0308H15.8083L14.3578 15.7039Z"></path><path fill="currentColor" d="M37.2475 5.20066H37.2121L35.7341 0.203584H33.3469V6.50391H34.9287L34.8399 1.33437H34.8752L36.4629 6.50391H38.7529V0.203584H37.1602L37.2475 5.20066Z"></path><path fill="currentColor" d="M8.31109 0.794321L8.34699 0.793754L9.2044 6.57031H10.9321L9.74669 0.204572H6.8855L5.69336 6.57031H7.43164L8.31109 0.794321Z"></path><path fill="currentColor" d="M16.6033 0.204572L15.8101 5.07222H15.7735L14.9815 0.204572H12.3583L12.2166 6.57031H13.8262L13.8664 0.847702H13.9019L14.9762 6.57031H16.608L17.6827 0.848269L17.7182 0.847702L17.7584 6.57031H19.3671L19.2253 0.204572H16.6033Z"></path><path fill="currentColor" d="M2.33736 6.82031C3.50103 6.82031 4.45772 6.42752 4.61063 5.3647C4.68888 4.81531 4.63138 4.45537 4.60377 4.32142C4.33227 2.98829 1.89235 2.59069 1.71025 1.84519C1.67964 1.71591 1.68708 1.58182 1.70338 1.5106C1.74887 1.30627 1.88863 1.08312 2.29073 1.08312C2.66751 1.08312 2.88823 1.31307 2.88823 1.65998V2.05433H4.49319V1.60589C4.49319 0.21938 3.23482 0.00259686 2.32463 0.00259686C1.1817 0.00259686 0.24661 0.377543 0.0762431 1.41573C0.0296104 1.69963 0.0233163 1.95379 0.0909767 2.27437C0.369915 3.57549 2.65535 3.95143 2.98664 4.77552C3.04958 4.92944 3.02956 5.12682 2.99937 5.24633C2.94702 5.45844 2.8014 5.6748 2.37283 5.6748C1.97073 5.6748 1.7267 5.44428 1.7267 5.09751L1.72513 4.48058H0.000572139L0 4.97121C0 6.39142 1.12877 6.82031 2.33736 6.82031Z"></path><path fill="currentColor" d="M22.6323 1.86126C22.6011 1.73411 22.609 1.60157 22.6243 1.53078C22.6699 1.32858 22.8085 1.10754 23.2059 1.10754C23.5799 1.10754 23.798 1.33438 23.798 1.6786V2.06827H25.3872V1.62508C25.3872 0.252304 24.141 0.0379272 23.2398 0.0379272C22.109 0.0379272 21.1829 0.408201 21.0146 1.43647C20.9681 1.71768 20.9616 1.9693 21.0295 2.28619C21.3047 3.57514 23.5679 3.94711 23.8959 4.76313C23.9574 4.91606 23.9383 5.11047 23.9081 5.22941C23.8563 5.43897 23.7124 5.6525 23.288 5.6525C22.8895 5.6525 22.6476 5.42524 22.6476 5.08116L22.6466 4.47102H20.9389L20.9385 4.95698C20.9385 6.36289 22.0567 6.78711 23.2531 6.78711C24.405 6.78711 25.3523 6.39857 25.5035 5.34609C25.5807 4.80236 25.5242 4.44624 25.4966 4.31272C25.2274 2.99261 22.8118 2.5994 22.6323 1.86126Z"></path><path fill="currentColor" d="M31.5546 0.203296H29.9269V4.91278C29.9274 4.99449 29.9251 5.08723 29.9115 5.15591C29.8796 5.31251 29.7422 5.61723 29.295 5.61723H29.2949C28.8473 5.61723 28.7091 5.31251 28.6779 5.15591C28.6642 5.08723 28.6609 4.99449 28.6625 4.91278V0.203296H27.0359V4.76765C27.0328 4.88503 27.0451 5.12447 27.0508 5.18663C27.1635 6.37477 28.1123 6.75977 29.295 6.75977C30.4771 6.75977 31.426 6.37477 31.5381 5.18663C31.5445 5.12447 31.5567 4.88503 31.5546 4.76765V0.203296Z"></path><path fill="currentColor" d="M42.7217 2.99625V3.92442H43.381V4.8489C43.3822 4.92947 43.379 5.01853 43.3657 5.09032C43.3367 5.26066 43.1742 5.55249 42.7084 5.55249C42.2434 5.55249 42.081 5.26066 42.0508 5.09046C42.0385 5.01867 42.0354 4.92961 42.0358 4.8489V1.93867C42.0358 1.83502 42.0434 1.72118 42.0619 1.63735C42.0973 1.48032 42.2349 1.17547 42.7026 1.17547C43.1943 1.17547 43.3165 1.49703 43.3455 1.63735C43.3647 1.72911 43.3663 1.88048 43.3657 1.87991V2.23673H44.9877V2.02462C44.9866 2.02462 44.9934 1.80826 44.9728 1.6055C44.8542 0.411698 43.8558 0.0325031 42.7154 0.0325031C41.5744 0.0325031 40.6014 0.41538 40.458 1.6055C40.4447 1.71183 40.4308 1.91148 40.4308 2.02462L40.4304 4.70277C40.4308 4.8227 40.4341 4.91021 40.4527 5.1219C40.5602 6.28157 41.5744 6.69531 42.7149 6.69531C43.8546 6.69531 44.8703 6.28143 44.9765 5.1219C44.996 4.91021 44.9987 4.8227 44.9999 4.70277V2.99625H42.7217Z"></path></g><defs><clipPath id="samsung-pay-clip"><rect width="45" height="20" fill="white"></rect></clipPath></defs>', 2)
    ])], 2));
  }
}), fc = {}, Cc = {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gc(e, t) {
  return l(), s("svg", Cc, [...t[0] || (t[0] = [
    o("path", {
      d: "M16.6667 16.6662L13.647 13.6465",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M3.33325 9.37467C3.33325 12.7114 6.0382 15.4163 9.37492 15.4163C12.7116 15.4163 15.4166 12.7114 15.4166 9.37467C15.4166 6.03795 12.7116 3.33301 9.37492 3.33301V3.33301C6.0383 3.33325 3.3335 6.03805 3.33325 9.37467",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const O_ = /* @__PURE__ */ g(fc, [["render", gc]]), vc = {}, mc = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  width: "20px",
  height: "20px"
};
function xc(e, t) {
  return l(), s("svg", mc, [...t[0] || (t[0] = [
    o("path", { d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" }, null, -1)
  ])]);
}
const P_ = /* @__PURE__ */ g(vc, [["render", xc]]), wc = {}, kc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
};
function yc(e, t) {
  return l(), s("svg", kc, [...t[0] || (t[0] = [
    o("g", {
      id: "Grupo_3220",
      "data-name": "Grupo 3220",
      transform: "translate(-24 -24)"
    }, [
      o("rect", {
        id: "Retângulo_55",
        "data-name": "Retângulo 55",
        width: "48",
        height: "48",
        rx: "8",
        transform: "translate(24 24)",
        fill: "#d2dffd"
      }),
      o("path", {
        id: "segmentar_benefício",
        "data-name": "segmentar benefício",
        d: "M-7763.7,5545.809a2.178,2.178,0,0,1-2.144-2.213.88.88,0,0,1,.88-.878.879.879,0,0,1,.877.878.438.438,0,0,0,.386.456h13.279a.438.438,0,0,0,.386-.456v-2.179h-2.229a2.161,2.161,0,0,1-2.161-2.16v-2.705a2.161,2.161,0,0,1,2.161-2.161h2.229v-2.177a.438.438,0,0,0-.386-.457H-7763.7a.438.438,0,0,0-.386.457.879.879,0,0,1-.877.877.88.88,0,0,1-.88-.877A2.179,2.179,0,0,1-7763.7,5530h13.279a2.179,2.179,0,0,1,2.144,2.214v2.177h.474a2.161,2.161,0,0,1,2.161,2.161v2.705a2.161,2.161,0,0,1-2.161,2.16h-.474v2.179a2.178,2.178,0,0,1-2.144,2.213Zm15.9-6.148a.413.413,0,0,0,.4-.4v-2.705a.412.412,0,0,0-.4-.4h-4.461a.414.414,0,0,0-.406.4v2.705a.415.415,0,0,0,.406.4h4.461Zm-16.907,2.38a.876.876,0,0,1-.259-.624.875.875,0,0,1,.259-.623l.258-.255h-6.66a.877.877,0,0,1-.877-.878.876.876,0,0,1,.877-.877h6.66l-.258-.256a.883.883,0,0,1,0-1.246.882.882,0,0,1,1.249,0l1.755,1.755a.886.886,0,0,1,.261.624.887.887,0,0,1-.261.625l-1.755,1.755a.889.889,0,0,1-.625.255A.888.888,0,0,1-7764.714,5542.041Zm-4.646-4.137a.875.875,0,0,1-.623-.253l-1.757-1.757a.877.877,0,0,1-.259-.623.881.881,0,0,1,.259-.624l1.757-1.755a.88.88,0,0,1,1.247,0,.883.883,0,0,1,0,1.246l-.256.254h6.657a.88.88,0,0,1,.88.879.88.88,0,0,1-.88.878h-6.658l.256.253a.885.885,0,0,1,.259.625.884.884,0,0,1-.259.624.877.877,0,0,1-.617.253Z",
        transform: "translate(7806.823 -5489.904)",
        fill: "#000ec6"
      })
    ], -1)
  ])]);
}
const R_ = /* @__PURE__ */ g(wc, [["render", yc]]), bc = {}, _c = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6.154",
  viewBox: "0 0 10 6.154"
};
function Mc(e, t) {
  return l(), s("svg", _c, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_arrow",
      d: "M.338,9.662a1.154,1.154,0,0,1,0-1.632L3.368,5,.338,1.97A1.154,1.154,0,1,1,1.97.338L5.816,4.184a1.154,1.154,0,0,1,0,1.632L1.97,9.662A1.154,1.154,0,0,1,.338,9.662Z",
      transform: "translate(10) rotate(90)",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const N_ = /* @__PURE__ */ g(bc, [["render", Mc]]), Lc = {}, $c = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
};
function Vc(e, t) {
  return l(), s("svg", $c, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_carga",
      d: "M1.021-2204A2.024,2.024,0,0,1-1-2206.022v-9.448a2.024,2.024,0,0,1,1.748-2l-.195-.532a1.317,1.317,0,0,1,.043-1.016,1.316,1.316,0,0,1,.749-.687l6.072-2.211a1.308,1.308,0,0,1,.454-.081,1.317,1.317,0,0,1,.562.126,1.317,1.317,0,0,1,.686.753l.406,1.127h3.268a1.329,1.329,0,0,1,1.326,1.328v1.182a2.013,2.013,0,0,1,1.84,2.014v2a1.333,1.333,0,0,1,1.042,1.3v2.779a1.334,1.334,0,0,1-1.042,1.3v2.073A2.024,2.024,0,0,1,13.937-2204Zm-.758-11.47v9.448a.759.759,0,0,0,.758.758H13.937a.759.759,0,0,0,.758-.758v-2.042H12.9a2.719,2.719,0,0,1-2.715-2.717A2.718,2.718,0,0,1,12.9-2213.5h1.8v-1.973a.759.759,0,0,0-.758-.758H1.021A.759.759,0,0,0,.264-2215.47Zm11.181,4.689a1.453,1.453,0,0,0,1.451,1.452h2.778a.062.062,0,0,0,.063-.062v-2.779a.063.063,0,0,0-.063-.063H12.9A1.454,1.454,0,0,0,11.445-2210.781Zm-3.4-7.885v1.174h4.813v-1.174a.063.063,0,0,0-.063-.063H8.1A.063.063,0,0,0,8.042-2218.666Zm-.192-2.065-6.072,2.211a.058.058,0,0,0-.036.032.066.066,0,0,0,0,.049l.348.947h4.69v-1.174a1.329,1.329,0,0,1,1.326-1.328h.077l-.252-.7a.063.063,0,0,0-.033-.036.083.083,0,0,0-.028,0A.047.047,0,0,0,7.85-2220.731Zm4.414,9.95a.633.633,0,0,1,.632-.632.633.633,0,0,1,.632.632.633.633,0,0,1-.632.633A.634.634,0,0,1,12.264-2210.781Z",
      transform: "translate(1 2222)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const G_ = /* @__PURE__ */ g(Lc, [["render", Vc]]), Bc = {}, Hc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.889",
  height: "16",
  viewBox: "0 0 14.889 16"
};
function Fc(e, t) {
  return l(), s("svg", Hc, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_settings",
      d: "M155.844-11133a1.716,1.716,0,0,1-1.714-1.713v-.348a1.129,1.129,0,0,0-.571-.988,1.125,1.125,0,0,0-1.143,0l-.3.172a1.715,1.715,0,0,1-2.341-.627l-.572-.99a1.716,1.716,0,0,1,.628-2.344l.3-.17a1.136,1.136,0,0,0,.571-.99,1.139,1.139,0,0,0-.571-.992l-.3-.172a1.714,1.714,0,0,1-.627-2.342l.571-.99a1.719,1.719,0,0,1,2.342-.629l.3.176a1.13,1.13,0,0,0,1.143,0,1.133,1.133,0,0,0,.571-.99v-.348a1.717,1.717,0,0,1,1.714-1.715h1.143a1.717,1.717,0,0,1,1.714,1.715v.348a1.134,1.134,0,0,0,.572.99,1.13,1.13,0,0,0,1.143,0l.3-.176a1.718,1.718,0,0,1,2.341.629l.572.99a1.716,1.716,0,0,1-.628,2.342l-.3.172a1.136,1.136,0,0,0-.571.992,1.133,1.133,0,0,0,.571.99l.3.17a1.717,1.717,0,0,1,.628,2.344l-.572.99a1.715,1.715,0,0,1-2.341.627l-.3-.172a1.125,1.125,0,0,0-1.143,0,1.129,1.129,0,0,0-.572.988v.348a1.716,1.716,0,0,1-1.714,1.713Zm-1.714-4.041a2.262,2.262,0,0,1,1.143,1.98v.348a.572.572,0,0,0,.571.57h1.143a.572.572,0,0,0,.572-.57v-.348a2.264,2.264,0,0,1,1.142-1.98,2.269,2.269,0,0,1,2.286,0l.3.174a.571.571,0,0,0,.78-.207l.572-.99a.572.572,0,0,0-.209-.781l-.3-.174a2.261,2.261,0,0,1-1.143-1.979,2.26,2.26,0,0,1,1.143-1.98l.3-.174a.573.573,0,0,0,.209-.781l-.572-.988a.566.566,0,0,0-.78-.209l-.3.174a2.269,2.269,0,0,1-2.286,0,2.266,2.266,0,0,1-1.142-1.98v-.348a.574.574,0,0,0-.572-.572h-1.143a.574.574,0,0,0-.571.572v.348a2.264,2.264,0,0,1-1.143,1.98,2.266,2.266,0,0,1-2.285,0l-.3-.174a.569.569,0,0,0-.78.209l-.572.988a.573.573,0,0,0,.209.781l.3.174a2.263,2.263,0,0,1,1.143,1.98,2.264,2.264,0,0,1-1.143,1.979l-.3.174a.571.571,0,0,0-.209.781l.572.99a.57.57,0,0,0,.78.207l.3-.174a2.272,2.272,0,0,1,1.142-.309A2.272,2.272,0,0,1,154.13-11137.041Zm-.571-3.957a2.861,2.861,0,0,1,2.857-2.857,2.861,2.861,0,0,1,2.857,2.857,2.863,2.863,0,0,1-2.857,2.857A2.863,2.863,0,0,1,153.559-11141Zm1.143,0a1.716,1.716,0,0,0,1.714,1.713,1.716,1.716,0,0,0,1.714-1.713,1.719,1.719,0,0,0-1.714-1.719A1.719,1.719,0,0,0,154.7-11141Z",
      transform: "translate(-148.972 11149)",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const U_ = /* @__PURE__ */ g(Bc, [["render", Fc]]), Ac = {}, jc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
};
function Ic(e, t) {
  return l(), s("svg", jc, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.755 8.91521C3.10795 8.18557 3.00039 7.12374 3.48797 6.27917L3.52163 6.22083C4.00923 5.37628 4.98255 4.93848 5.93796 5.13397H5.93805C6.3297 5.21412 6.73713 5.148 7.08333 4.94812C7.42953 4.74824 7.6905 4.42845 7.81692 4.04922C8.12531 3.12404 8.99113 2.5 9.96635 2.5H10.0337C11.0089 2.5 11.8747 3.12404 12.1831 4.04922C12.3095 4.42845 12.5705 4.74823 12.9167 4.94811C13.2629 5.148 13.6703 5.21412 14.062 5.13398H14.0621C15.0174 4.93851 15.9907 5.3763 16.4783 6.22083L16.512 6.27917C16.9996 7.12375 16.8921 8.18559 16.245 8.91525C15.9798 9.21435 15.8333 9.60025 15.8333 10C15.8333 10.3998 15.9798 10.7857 16.245 11.0848C16.8921 11.8145 16.9996 12.8763 16.512 13.7209L16.4784 13.7792C15.9908 14.6238 15.0175 15.0615 14.0621 14.8661L14.0618 14.866C13.6702 14.7859 13.2628 14.852 12.9167 15.0518C12.5705 15.2517 12.3095 15.5715 12.1831 15.9507C11.8747 16.8759 11.0088 17.5 10.0336 17.5H9.96644C8.99117 17.5 8.12532 16.8759 7.81691 15.9507C7.6905 15.5715 7.42953 15.2517 7.08333 15.0518C6.73718 14.852 6.3298 14.7859 5.93821 14.866L5.93796 14.866C4.98256 15.0615 4.00926 14.6237 3.52167 13.7792L3.488 13.7208C3.00039 12.8763 3.10793 11.8144 3.75498 11.0847C4.02021 10.7857 4.16666 10.3998 4.16667 10C4.16668 9.60024 4.02023 9.21432 3.755 8.91521Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "10",
      cy: "10",
      r: "2.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const W_ = /* @__PURE__ */ g(Ac, [["render", Ic]]), Zc = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, Ec = ["stroke"], Sc = ["fill"], zc = ["stroke"], Dc = ["stroke"], Tc = ["fill"], Oc = ["stroke"], Pc = ["stroke"], Rc = ["fill"], Nc = ["stroke"], Y_ = /* @__PURE__ */ I({
  __name: "SlidersHorizontalGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Zc, [
      o("path", {
        d: "M1 3.5H5",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, Ec),
      o("circle", {
        cx: "6.5",
        cy: "3.5",
        r: "1.5",
        fill: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)"
      }, null, 8, Sc),
      o("path", {
        d: "M8 3.5H15",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, zc),
      o("path", {
        d: "M1 8H9",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, Dc),
      o("circle", {
        cx: "10.5",
        cy: "8",
        r: "1.5",
        fill: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)"
      }, null, 8, Tc),
      o("path", {
        d: "M12 8H15",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, Oc),
      o("path", {
        d: "M1 12.5H3",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, Pc),
      o("circle", {
        cx: "4.5",
        cy: "12.5",
        r: "1.5",
        fill: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)"
      }, null, 8, Rc),
      o("path", {
        d: "M6 12.5H15",
        stroke: e.active ? "url(#sliders_blue)" : "url(#sliders_gray)",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, 8, Nc),
      r[0] || (r[0] = N('<defs><linearGradient id="sliders_blue" x1="1" y1="12" x2="15" y2="4" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="sliders_gray" x1="1" y1="12" x2="15" y2="4" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Gc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "w-5 h-5"
}, Uc = ["stroke"], Wc = ["stroke"], Yc = ["stroke"], qc = ["stroke"], Kc = ["stroke"], Qc = ["stroke"], q_ = /* @__PURE__ */ I({
  __name: "SlidersHorizontalOutlineIcon",
  props: {
    active: { type: Boolean, default: !1 },
    color: {}
  },
  setup(e) {
    const t = e, r = f(() => t.color ? t.color : t.active ? "#5B61FA" : "#767BA2");
    return (n, i) => (l(), s("svg", Gc, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.6663 11.667H13.333C13.793 11.667 14.1663 12.0403 14.1663 12.5003V15.8337C14.1663 16.2937 13.793 16.667 13.333 16.667H11.6663C11.2063 16.667 10.833 16.2937 10.833 15.8337V12.5003C10.833 12.0403 11.2063 11.667 11.6663 11.667Z",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Uc),
      o("path", {
        d: "M17.5003 14.1667H14.167",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Wc),
      o("path", {
        d: "M10.8333 14.1667H2.5",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Yc),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.33301 8.33398H6.66634C6.20634 8.33398 5.83301 7.96065 5.83301 7.50065V4.16732C5.83301 3.70732 6.20634 3.33398 6.66634 3.33398H8.33301C8.79301 3.33398 9.16634 3.70732 9.16634 4.16732V7.50065C9.16634 7.96065 8.79301 8.33398 8.33301 8.33398Z",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, qc),
      o("path", {
        d: "M2.5 5.83366H5.83333",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Kc),
      o("path", {
        d: "M9.16699 5.83366H17.5003",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Qc)
    ]));
  }
}), Xc = {}, Jc = {
  width: "451",
  height: "451",
  viewBox: "0 0 451 451",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function eh(e, t) {
  return l(), s("svg", Jc, [...t[0] || (t[0] = [
    o("g", {
      style: { "mix-blend-mode": "hard-light" },
      filter: "url(#filter0_f_2288_20731)"
    }, [
      o("circle", {
        cx: "225.5",
        cy: "225.5",
        r: "61.5",
        fill: "#C7CBFF"
      })
    ], -1),
    o("foreignObject", {
      x: "108.114",
      y: "144.363",
      width: "205.61",
      height: "175.805"
    }, [
      o("div", {
        xmlns: "http://www.w3.org/1999/xhtml",
        style: { "backdrop-filter": "blur(22.66px)", "clip-path": "url(#bgblur_0_2288_20731_clip_path)", height: "100%", width: "100%" }
      })
    ], -1),
    o("g", {
      filter: "url(#filter1_d_2288_20731)",
      "data-figma-bg-blur-radius": "45.3125"
    }, [
      o("rect", {
        x: "152.821",
        y: "202.33",
        width: "107.963",
        height: "73.6891",
        rx: "5.25802",
        transform: "rotate(-7.05501 152.821 202.33)",
        fill: "#99A0FF",
        "fill-opacity": "0.3",
        "shape-rendering": "crispEdges"
      }),
      o("rect", {
        x: "153.108",
        y: "202.554",
        width: "107.449",
        height: "73.175",
        rx: "5.00096",
        transform: "rotate(-7.05501 153.108 202.554)",
        stroke: "url(#paint0_linear_2288_20731)",
        "stroke-width": "0.51411",
        "shape-rendering": "crispEdges"
      })
    ], -1),
    o("foreignObject", {
      x: "104.91",
      y: "130.91",
      width: "212.021",
      height: "188.264"
    }, [
      o("div", {
        xmlns: "http://www.w3.org/1999/xhtml",
        style: { "backdrop-filter": "blur(22.66px)", "clip-path": "url(#bgblur_1_2288_20731_clip_path)", height: "100%", width: "100%" }
      })
    ], -1),
    N('<g filter="url(#filter2_d_2288_20731)" data-figma-bg-blur-radius="45.3125"><rect x="149" y="204.127" width="107.963" height="73.6891" rx="5.25802" transform="rotate(-15.6516 149 204.127)" fill="#FAFAFF"></rect><rect x="149.317" y="204.305" width="107.449" height="73.175" rx="5.00096" transform="rotate(-15.6516 149.317 204.305)" stroke="url(#paint1_linear_2288_20731)" stroke-width="0.51411"></rect></g><g filter="url(#filter3_i_2288_20731)"><path fill-rule="evenodd" clip-rule="evenodd" d="M209.279 214.179V214.179C215.392 212.541 221.674 216.168 223.312 222.281V222.281C224.949 228.394 221.323 234.675 215.21 236.313V236.313C209.097 237.951 202.815 234.324 201.177 228.212V228.212C199.539 222.099 203.166 215.817 209.279 214.179Z" stroke="#1223FF" stroke-opacity="0.7" stroke-width="1.90959" stroke-linecap="round" stroke-linejoin="round"></path></g><path d="M212.409 225.861L210.761 219.712" stroke="#1223FF" stroke-opacity="0.7" stroke-width="1.90959" stroke-linecap="round" stroke-linejoin="round"></path><g filter="url(#filter4_i_2288_20731)"><path d="M213.561 230.164C213.392 230.21 213.291 230.385 213.337 230.554C213.383 230.724 213.558 230.824 213.727 230.779C213.897 230.734 213.998 230.559 213.952 230.389C213.907 230.22 213.732 230.119 213.561 230.164" stroke="#1223FF" stroke-opacity="0.7" stroke-width="1.90959" stroke-linecap="round" stroke-linejoin="round"></path></g><path d="M150.419 209.19C149.635 206.394 151.267 203.492 154.063 202.708L247.897 176.418C250.693 175.635 253.595 177.267 254.378 180.063L254.649 181.03L150.689 210.157L150.419 209.19Z" fill="#EBECFF"></path>', 5),
    o("foreignObject", {
      x: "238",
      y: "180",
      width: "72.3623",
      height: "86.1953"
    }, [
      o("div", {
        xmlns: "http://www.w3.org/1999/xhtml",
        style: { "backdrop-filter": "blur(5px)", "clip-path": "url(#bgblur_2_2288_20731_clip_path)", height: "100%", width: "100%" }
      })
    ], -1),
    N('<g filter="url(#filter5_d_2288_20731)" data-figma-bg-blur-radius="10"><rect x="248" y="190" width="52.3627" height="66.1944" rx="5.25802" fill="#000652" fill-opacity="0.6" shape-rendering="crispEdges"></rect><rect x="248.4" y="190.4" width="51.5627" height="65.3944" rx="4.85802" stroke="#000A87" stroke-width="0.8" shape-rendering="crispEdges"></rect><rect x="273" y="193" width="3" height="3" rx="1.5" fill="black" fill-opacity="0.49"></rect></g><path d="M154.938 205.926C155.087 206.387 154.836 206.881 154.375 207.031C153.915 207.18 153.421 206.929 153.271 206.468C153.121 206.008 153.373 205.514 153.833 205.364C154.294 205.214 154.788 205.466 154.938 205.926Z" fill="#D7DAF9"></path><path d="M158.022 204.844C158.171 205.304 157.92 205.799 157.459 205.948C156.999 206.098 156.505 205.846 156.355 205.386C156.205 204.926 156.457 204.431 156.917 204.282C157.378 204.132 157.872 204.384 158.022 204.844Z" fill="#D7DAF9"></path><path d="M161.101 203.834C161.251 204.295 160.999 204.789 160.538 204.939C160.078 205.088 159.584 204.837 159.434 204.376C159.284 203.916 159.536 203.422 159.996 203.272C160.457 203.122 160.951 203.374 161.101 203.834Z" fill="#D7DAF9"></path><defs><filter id="filter0_f_2288_20731" x="0" y="0" width="451" height="451" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feGaussianBlur stdDeviation="82" result="effect1_foregroundBlur_2288_20731"></feGaussianBlur></filter><filter id="filter1_d_2288_20731" x="108.114" y="144.363" width="205.61" height="175.805" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2.05063"></feOffset><feGaussianBlur stdDeviation="3.50535"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0414008 0 0 0 0 0.550631 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2288_20731"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2288_20731" result="shape"></feBlend></filter><clipPath id="bgblur_0_2288_20731_clip_path" transform="translate(-108.114 -144.363)"><rect x="152.821" y="202.33" width="107.963" height="73.6891" rx="5.25802" transform="rotate(-7.05501 152.821 202.33)"></rect></clipPath><filter id="filter2_d_2288_20731" x="104.91" y="130.91" width="212.021" height="188.264" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2.05063"></feOffset><feGaussianBlur stdDeviation="3.50535"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0414008 0 0 0 0 0.550631 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2288_20731"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2288_20731" result="shape"></feBlend></filter><clipPath id="bgblur_1_2288_20731_clip_path" transform="translate(-104.91 -130.91)"><rect x="149" y="204.127" width="107.963" height="73.6891" rx="5.25802" transform="rotate(-15.6516 149 204.127)"></rect></clipPath><filter id="filter3_i_2288_20731" x="199.829" y="212.83" width="24.8311" height="25.1376" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.305534"></feOffset><feGaussianBlur stdDeviation="0.305534"></feGaussianBlur><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.8 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow_2288_20731"></feBlend></filter><filter id="filter4_i_2288_20731" x="212.371" y="229.199" width="2.54688" height="2.85046" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.305534"></feOffset><feGaussianBlur stdDeviation="0.305534"></feGaussianBlur><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.8 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow_2288_20731"></feBlend></filter><filter id="filter5_d_2288_20731" x="238" y="180" width="72.3623" height="86.1953" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2.43"></feOffset><feGaussianBlur stdDeviation="2.5"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0414008 0 0 0 0 0.550631 0 0 0 0.47 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2288_20731"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2288_20731" result="shape"></feBlend></filter><clipPath id="bgblur_2_2288_20731_clip_path" transform="translate(-238 -180)"><rect x="248" y="190" width="52.3627" height="66.1944" rx="5.25802"></rect></clipPath><linearGradient id="paint0_linear_2288_20731" x1="206.803" y1="218.497" x2="206.803" y2="276.019" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF" stop-opacity="0"></stop><stop offset="1" stop-color="#5763FF"></stop></linearGradient><linearGradient id="paint1_linear_2288_20731" x1="202.982" y1="220.294" x2="202.982" y2="277.816" gradientUnits="userSpaceOnUse"><stop stop-color="#5763FF" stop-opacity="0"></stop><stop offset="1" stop-color="#5763FF"></stop></linearGradient></defs>', 5)
  ])]);
}
const th = /* @__PURE__ */ g(Xc, [["render", eh]]), oh = {}, nh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.041",
  height: "26.805",
  viewBox: "0 0 24.041 26.805"
};
function rh(e, t) {
  return l(), s("svg", nh, [...t[0] || (t[0] = [
    o("path", {
      id: "ic_add_report",
      d: "M5.041,26.8a4.885,4.885,0,0,1-5-4.75L0,8.84A5,5,0,0,1,5.041,4h5a1,1,0,1,1,0,2l-5,0A2.959,2.959,0,0,0,2,8.84l.041,13.214a2.931,2.931,0,0,0,3,2.85h10a2.931,2.931,0,0,0,3-2.85v-7.84a1,1,0,0,1,2,0h0v7.84a4.886,4.886,0,0,1-5,4.75Zm1-4.395a.952.952,0,1,1,0-1.9h8a.952.952,0,1,1,0,1.9Zm0-3.8a.952.952,0,1,1,0-1.9h2a.952.952,0,1,1,0,1.9ZM18.041,9V6h-3a1,1,0,0,1,0-2h3V1a1,1,0,0,1,2,0V4h3a1,1,0,0,1,0,2h-3V9a1,1,0,0,1-2,0Z",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const K_ = /* @__PURE__ */ g(oh, [["render", rh]]), lh = {}, sh = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ih(e, t) {
  return l(), s("svg", sh, [...t[0] || (t[0] = [
    o("path", {
      d: "M8 4L4 8H7V12H9V8H12L8 4Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const ah = /* @__PURE__ */ g(lh, [["render", ih]]), dh = {}, uh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "inline-block shrink-0"
};
function ch(e, t) {
  return l(), s("svg", uh, [...t[0] || (t[0] = [
    o("path", { d: "M6.66699 5.33203L4.66699 3.33203L2.66699 5.33203" }, null, -1),
    o("path", { d: "M4.66732 12.6654V3.33203" }, null, -1),
    o("path", { d: "M9.33398 10.6641L11.334 12.6641L13.334 10.6641" }, null, -1),
    o("path", { d: "M11.3333 3.33203V12.6654" }, null, -1)
  ])]);
}
const Q_ = /* @__PURE__ */ g(dh, [["render", ch]]), hh = {}, ph = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function fh(e, t) {
  return l(), s("svg", ph, [...t[0] || (t[0] = [
    N('<path d="M8.00002 2V14"></path><path d="M9.44535 2.94727L8.00002 4.39327L6.55469 2.94727"></path><path d="M13.3334 4.91992L2.66669 11.0799"></path><path d="M13.098 6.7255L11.124 6.19683L11.6527 4.22217"></path><path d="M2.90198 9.2749L4.87598 9.80357L4.34731 11.7782"></path><path d="M2.66669 4.91992L13.3334 11.0799"></path><path d="M2.90198 6.7255L4.87598 6.19683L4.34731 4.22217"></path><path d="M13.098 9.2749L11.124 9.80357L11.6527 11.7782"></path><path d="M6.55469 13.0524L8.00002 11.6064L9.44535 13.0524"></path>', 9)
  ])]);
}
const X_ = /* @__PURE__ */ g(hh, [["render", fh]]), Ch = {}, gh = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function vh(e, t) {
  return l(), s("svg", gh, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M15.3451 5.345L12.9884 2.98833C12.6759 2.67583 12.2517 2.5 11.8101 2.5H5.83341C4.91258 2.5 4.16675 3.24583 4.16675 4.16667V15.8333C4.16675 16.7542 4.91258 17.5 5.83341 17.5H14.1667C15.0876 17.5 15.8334 16.7542 15.8334 15.8333V6.52333C15.8334 6.08167 15.6576 5.6575 15.3451 5.345V5.345Z" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.8334 6.66667H12.5001C12.0401 6.66667 11.6667 6.29333 11.6667 5.83333V2.5" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.99992 9.16699V15.0003" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66675 12.0837H13.3334" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5001 15.0003H7.50008C7.04008 15.0003 6.66675 14.627 6.66675 14.167V10.0003C6.66675 9.54033 7.04008 9.16699 7.50008 9.16699H12.5001C12.9601 9.16699 13.3334 9.54033 13.3334 10.0003V14.167C13.3334 14.627 12.9601 15.0003 12.5001 15.0003Z" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const J_ = /* @__PURE__ */ g(Ch, [["render", vh]]), mh = {}, xh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
};
function wh(e, t) {
  return l(), s("svg", xh, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1727 17.5071H5.83586C3.99415 17.5071 2.50114 16.0141 2.50114 14.1724V7.50298C2.50114 6.58212 3.24765 5.83562 4.1685 5.83562H15.84C16.7609 5.83562 17.5074 6.58212 17.5074 7.50298V14.1724C17.5074 16.0141 16.0144 17.5071 14.1727 17.5071Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66955 5.83562V4.16826C6.66955 3.2474 7.41605 2.5009 8.33691 2.5009H11.6716C12.5925 2.5009 13.339 3.2474 13.339 4.16826V5.83562" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><rect x="8.33691" y="9.17034" width="3.33472" height="2.50104" rx="0.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M11.6716 10.4209H14.5895C16.201 10.4209 17.5074 9.11448 17.5074 7.50298V7.50298" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.33691 10.4209H5.41902C3.80752 10.4209 2.50114 9.11448 2.50114 7.50298V7.50298" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const eM = /* @__PURE__ */ g(mh, [["render", wh]]), kh = {}, yh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "19.2",
  viewBox: "0 0 16 19.2"
};
function bh(e, t) {
  return l(), s("svg", yh, [...t[0] || (t[0] = [
    o("path", {
      id: "File",
      d: "M111.993,71.2a.794.794,0,0,0-.227-.566l-6.4-6.4a.792.792,0,0,0-.566-.228V64H100a4,4,0,0,0-4,4V79.2a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4v-8ZM105.6,66.731l3.669,3.669H108a2.4,2.4,0,0,1-2.4-2.4ZM108,81.6h-8a2.4,2.4,0,0,1-2.4-2.4V68a2.4,2.4,0,0,1,2.4-2.4h4V68a4,4,0,0,0,4,4h2.4v7.2A2.4,2.4,0,0,1,108,81.6Zm0-2.9a.8.8,0,0,1-.8.8h-6.4a.8.8,0,0,1,0-1.6h6.4A.8.8,0,0,1,108,78.7Zm-8-3.2a.8.8,0,0,1,.8-.8h1.6a.8.8,0,1,1,0,1.6h-1.6A.8.8,0,0,1,100,75.5Z",
      transform: "translate(-96 -64)",
      fill: "#000ec6"
    }, null, -1)
  ])]);
}
const tM = /* @__PURE__ */ g(kh, [["render", bh]]), _h = {}, Mh = {
  class: "w-5 h-5",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Lh(e, t) {
  return l(), s("svg", Mh, [...t[0] || (t[0] = [
    N('<path d="M4.6665 7.83333H5.33317" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.6665 10.3333H5.33317" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3333 6V3.03994C13.3333 2.78791 13.1912 2.55742 12.966 2.44426L12.2232 2.07099C12.0362 1.97702 11.8159 1.97631 11.6283 2.06907L10.4959 2.62907L9.3858 2.07142C9.19826 1.97721 8.97731 1.97681 8.78943 2.07034L7.66667 2.62929L6.54389 2.07034C6.35601 1.97681 6.13506 1.97721 5.94752 2.07142L4.83743 2.62907L3.70497 2.06907C3.51738 1.97631 3.29711 1.97702 3.11011 2.07099L2.36733 2.44426C2.14213 2.55742 2 2.78791 2 3.03994V12.6667C2 13.403 2.59695 14 3.33333 14H5.33333" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.3335 10.3333H14.6668" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.8335 14H13.1668C13.9953 14 14.6668 13.3284 14.6668 12.5V9.5C14.6668 8.67157 13.9953 8 13.1668 8H8.8335C8.00507 8 7.3335 8.67157 7.3335 9.5V12.5C7.3335 12.8978 7.49153 13.2794 7.77284 13.5607C8.05414 13.842 8.43567 14 8.8335 14V14Z" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.6665 5.33333H10.6665" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const oM = /* @__PURE__ */ g(_h, [["render", Lh]]), $h = {}, Vh = {
  class: "w-5 h-5",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Bh(e, t) {
  return l(), s("svg", Vh, [...t[0] || (t[0] = [
    N('<path d="M10.6668 4.66732H7.3335" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.3335 7.33333H10.6668" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.3335 9.99935H10.6668" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.6665 3.18533V13C2.6665 13.4953 3.18784 13.818 3.63117 13.596L4.14517 13.3387C4.33317 13.2447 4.55384 13.2447 4.74117 13.3387L5.92317 13.9293C6.1105 14.0233 6.33184 14.0233 6.51917 13.9293L7.70117 13.3387C7.8885 13.2447 8.10984 13.2447 8.29717 13.3387L9.47917 13.9293C9.66717 14.0233 9.88784 14.0233 10.0758 13.9293L11.2565 13.3387C11.4445 13.2447 11.6652 13.2447 11.8532 13.3387L12.3678 13.596C12.8118 13.818 13.3332 13.4953 13.3332 13V3.18533C13.3332 2.53067 12.8025 2 12.1478 2H3.85184C3.19717 2 2.6665 2.53067 2.6665 3.18533Z" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.24917 4.58398C5.20384 4.58398 5.16584 4.62132 5.16651 4.66732C5.16651 4.71332 5.20384 4.75065 5.24984 4.75065C5.29584 4.75065 5.33317 4.71332 5.33317 4.66732C5.33317 4.62132 5.29584 4.58398 5.24917 4.58398" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.24917 7.25C5.20317 7.25 5.16584 7.28733 5.16651 7.33333C5.16651 7.37933 5.20384 7.41667 5.24984 7.41667C5.29584 7.41667 5.33317 7.37933 5.33317 7.33333C5.33317 7.28733 5.29584 7.25 5.24917 7.25" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.24917 9.91602C5.20317 9.91602 5.16584 9.95335 5.16651 9.99935C5.16651 10.0453 5.20384 10.0827 5.24984 10.0827C5.29584 10.0827 5.33317 10.0453 5.33317 9.99935C5.33317 9.95335 5.29584 9.91602 5.24917 9.91602" stroke="#9DA1C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const nM = /* @__PURE__ */ g($h, [["render", Bh]]), Hh = {}, Fh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor"
};
function Ah(e, t) {
  return l(), s("svg", Fh, [...t[0] || (t[0] = [
    o("path", { d: "M10 3.22l-.61-.6a5.5 5.5 0 0 0-7.666.105 5.5 5.5 0 0 0-.114 7.665L10 18.78l8.39-8.4a5.5 5.5 0 0 0-.114-7.665 5.5 5.5 0 0 0-7.666-.105l-.61.61z" }, null, -1)
  ])]);
}
const rM = /* @__PURE__ */ g(Hh, [["render", Ah]]), jh = {}, Ih = {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Zh(e, t) {
  return l(), s("svg", Ih, [...t[0] || (t[0] = [
    o("path", {
      d: "M17.5 9.16667V5C17.5 3.61929 16.3807 2.5 15 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H9.16667",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.2443 17.2562L18.0893 14.4111C18.4147 14.0857 18.4147 13.5582 18.0893 13.2328L16.7676 11.911C16.4422 11.5857 15.9147 11.5857 15.5893 11.911L12.7442 14.7561C12.5878 14.9124 12.5 15.1245 12.5 15.3456V17.0837C12.5 17.3138 12.6865 17.5003 12.9167 17.5003H14.6548C14.8759 17.5003 15.0879 17.4125 15.2443 17.2562Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5 2.5V10.8333",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.49992 2.5V17.5",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const lM = /* @__PURE__ */ g(jh, [["render", Zh]]), Eh = {
  width: "16",
  height: "16",
  viewBox: "0 0 22 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, Sh = ["fill"], zh = ["fill"], Dh = ["fill"], Th = ["fill"], Oh = ["fill"], Ph = ["fill"], sM = /* @__PURE__ */ I({
  __name: "UsersGroupGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Eh, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19.79 4.52C20.58 5.31 20.58 6.6 19.79 7.39C19 8.18 17.72 8.18 16.93 7.39C16.14 6.6 16.14 5.31 16.93 4.52C17.72 3.73 19 3.73 19.79 4.52Z",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, Sh),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.2 0.91C14.42 2.13 14.42 4.1 13.2 5.32C11.99 6.53 10.01 6.53 8.8 5.32C7.58 4.1 7.58 2.13 8.8 0.91C10.01 -0.3 11.99 -0.3 13.2 0.91Z",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, zh),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.07 4.52C5.86 5.31 5.86 6.6 5.07 7.39C4.28 8.18 3 8.18 2.21 7.39C1.42 6.6 1.42 5.31 2.21 4.52C3 3.73 4.28 3.73 5.07 4.52Z",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, Dh),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.25 14H0V12.91C0 11.53 1.12 10.41 2.5 10.41H4.25",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, Th),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.75 14H22V12.91C22 11.53 20.88 10.41 19.5 10.41H17.75",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, Oh),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.34 14V12.4C16.34 10.47 14.77 8.9 12.84 8.9H9.16C7.23 8.9 5.66 10.47 5.66 12.4V14",
        fill: e.active ? "url(#team_blue)" : "url(#team_gray)"
      }, null, 8, Ph),
      r[0] || (r[0] = N('<defs><linearGradient id="team_blue" x1="1" y1="12.25" x2="16.13" y2="-1.99" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="team_gray" x1="1" y1="12.25" x2="16.13" y2="-1.99" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Rh = {}, Nh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.315",
  height: "18.315",
  viewBox: "0 0 18.315 18.315"
};
function Gh(e, t) {
  return l(), s("svg", Nh, [...t[0] || (t[0] = [
    o("g", {
      id: "clock",
      transform: "translate(-1 -1)"
    }, [
      o("path", {
        id: "Caminho_869",
        "data-name": "Caminho 869",
        d: "M10.158,1a9.158,9.158,0,1,0,9.158,9.158A9.158,9.158,0,0,0,10.158,1Zm0,16.65a7.493,7.493,0,1,1,7.493-7.493A7.493,7.493,0,0,1,10.158,17.65Z",
        fill: "#000ec6"
      }),
      o("path", {
        id: "Caminho_870",
        "data-name": "Caminho 870",
        d: "M12.665,10.483V5.833a.833.833,0,0,0-1.665,0v5a.832.832,0,0,0,.244.588l2.5,2.5a.832.832,0,1,0,1.177-1.177Z",
        transform: "translate(-1.675 -0.67)",
        fill: "#000ec6"
      })
    ], -1)
  ])]);
}
const iM = /* @__PURE__ */ g(Rh, [["render", Gh]]), Uh = {}, Wh = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi",
  width: "24",
  height: "24",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
function Yh(e, t) {
  return l(), s("svg", Wh, [...t[0] || (t[0] = [
    o("path", {
      d: "M20 18v-4h-3v1h-2v-1H9v1H7v-1H4v4h16M6.33 8l-1.74 4H7v-1h2v1h6v-1h2v1h2.41l-1.74-4H6.33M9 5v1h6V5H9m12.84 7.61c.1.22.16.48.16.8V18c0 .53-.21 1-.6 1.41c-.4.4-.85.59-1.4.59H4c-.55 0-1-.19-1.4-.59C2.21 19 2 18.53 2 18v-4.59c0-.32.06-.58.16-.8L4.5 7.22C4.84 6.41 5.45 6 6.33 6H7V5c0-.55.18-1 .57-1.41C7.96 3.2 8.44 3 9 3h6c.56 0 1.04.2 1.43.59c.39.41.57.86.57 1.41v1h.67c.88 0 1.49.41 1.83 1.22l2.34 5.39z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const aM = /* @__PURE__ */ g(Uh, [["render", Yh]]), qh = {}, Kh = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
};
function Qh(e, t) {
  return l(), s("svg", Kh, [...t[0] || (t[0] = [
    o("path", {
      d: "M12.5052 7.50313H14.1725C15.0934 7.50313 15.8399 8.24963 15.8399 9.17049V15.8399C15.8399 16.7608 15.0934 17.5073 14.1725 17.5073H5.83574C4.91488 17.5073 4.16838 16.7608 4.16838 15.8399V9.17049C4.16838 8.24963 4.91488 7.50313 5.83574 7.50313H7.5031",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.0041 2.50104V12.5052",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5052 10.0042L10.0041 12.5052L7.5031 10.0042",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const dM = /* @__PURE__ */ g(qh, [["render", Qh]]), Xh = {}, Jh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21.162",
  height: "26",
  viewBox: "0 0 21.162 26"
};
function ep(e, t) {
  return l(), s("svg", Jh, [...t[0] || (t[0] = [
    o("g", {
      id: "pin",
      transform: "translate(-6.5 -2.5)"
    }, [
      o("path", {
        id: "Caminho_832",
        "data-name": "Caminho 832",
        d: "M16.458,28.252a.906.906,0,0,0,1.246,0c.405-.387,9.958-9.5,9.958-15.17a10.581,10.581,0,1,0-21.162,0C6.5,18.747,16.053,27.865,16.458,28.252Zm.623-23.938a8.774,8.774,0,0,1,8.767,8.767c0,3.767-5.841,10.339-8.767,13.248-2.926-2.908-8.767-9.475-8.767-13.248A8.774,8.774,0,0,1,17.081,4.314Z",
        fill: "#000ec6"
      }),
      o("path", {
        id: "Caminho_833",
        "data-name": "Caminho 833",
        d: "M25.316,16.908a4.408,4.408,0,1,0-4.408,4.408A4.409,4.409,0,0,0,25.316,16.908Zm-7.053,0a2.645,2.645,0,1,1,2.645,2.645A2.649,2.649,0,0,1,18.263,16.908Z",
        transform: "translate(-3.827 -3.863)",
        fill: "#000ec6"
      })
    ], -1)
  ])]);
}
const uM = /* @__PURE__ */ g(Xh, [["render", ep]]), tp = {}, op = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function np(e, t) {
  return l(), s("svg", op, [...t[0] || (t[0] = [
    o("path", {
      d: "M13.4192 8.99547L15.8334 6.58214L13.4192 4.16797",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M4.16675 6.58464H15.8334",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.58091 11.0039L4.16675 13.4172L6.58091 15.8314",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.8334 13.4167H4.16675",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const cM = /* @__PURE__ */ g(tp, [["render", np]]), rp = {}, lp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8.333",
  height: "10",
  viewBox: "0 0 8.333 10"
};
function sp(e, t) {
  return l(), s("svg", lp, [...t[0] || (t[0] = [
    o("g", {
      id: "trash",
      transform: "translate(-2)"
    }, [
      o("path", {
        id: "Caminho_746",
        "data-name": "Caminho 746",
        d: "M9.917,1.667H8.625A2.087,2.087,0,0,0,6.583,0H5.75A2.087,2.087,0,0,0,3.708,1.667H2.417a.417.417,0,1,0,0,.833h.417V7.917A2.086,2.086,0,0,0,4.917,10h2.5A2.086,2.086,0,0,0,9.5,7.917V2.5h.417a.417.417,0,0,0,0-.833ZM5.75.833h.833a1.252,1.252,0,0,1,1.179.833H4.571A1.253,1.253,0,0,1,5.75.833ZM8.667,7.917a1.25,1.25,0,0,1-1.25,1.25h-2.5a1.25,1.25,0,0,1-1.25-1.25V2.5h5Z",
        fill: "#f01a1a"
      }),
      o("path", {
        id: "Caminho_747",
        "data-name": "Caminho 747",
        d: "M9.417,13.333a.417.417,0,0,0,.417-.417v-2.5a.417.417,0,0,0-.833,0v2.5A.417.417,0,0,0,9.417,13.333Z",
        transform: "translate(-4.083 -5.833)",
        fill: "#f01a1a"
      }),
      o("path", {
        id: "Caminho_748",
        "data-name": "Caminho 748",
        d: "M13.417,13.333a.417.417,0,0,0,.417-.417v-2.5a.417.417,0,0,0-.833,0v2.5A.417.417,0,0,0,13.417,13.333Z",
        transform: "translate(-6.417 -5.833)",
        fill: "#f01a1a"
      })
    ], -1)
  ])]);
}
const hM = /* @__PURE__ */ g(rp, [["render", sp]]), ip = {}, ap = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function dp(e, t) {
  return l(), s("svg", ap, [...t[0] || (t[0] = [
    o("path", {
      d: "M14.7138 5.28516C17.3172 7.88849 17.3172 12.1102 14.7138 14.7135C12.1105 17.3168 7.88884 17.3168 5.28551 14.7135C2.68217 12.1102 2.68217 7.88849 5.28551 5.28516",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99967 3.33203V9.9987",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const pM = /* @__PURE__ */ g(ip, [["render", dp]]), up = {
  width: "16",
  height: "16",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, cp = ["fill"], fM = /* @__PURE__ */ I({
  __name: "TruckGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", up, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.21 0H2.57C2.14 0 1.76 0 1.45 0.04C1.11 0.09 0.76 0.19 0.48 0.47C0.19 0.76 0.09 1.1 0.04 1.44C0 1.75 0 2.13 0 2.55V7.8C0 8.08 0 8.34 0.02 8.55C0.04 8.77 0.09 9.01 0.22 9.24C0.36 9.48 0.57 9.69 0.81 9.83C1.04 9.96 1.5 10.02 1.72 10.04C2 10.98 2.87 11.67 3.91 11.67C4.94 11.67 5.81 10.98 6.09 10.05H8.24C8.52 10.98 9.39 11.67 10.42 11.67C11.46 11.67 12.33 10.98 12.61 10.04C12.84 10.02 13.29 9.96 13.52 9.83C13.77 9.69 13.97 9.48 14.12 9.24C14.25 9.01 14.29 8.77 14.31 8.55C14.33 8.34 14.33 8.08 14.33 7.8V6C14.33 5.78 14.33 5.56 14.27 5.35C14.21 5.13 14.1 4.94 13.99 4.76L12.84 2.86C12.71 2.65 12.6 2.45 12.48 2.29C12.35 2.12 12.2 1.95 11.98 1.83C11.76 1.71 11.54 1.66 11.32 1.64C11.12 1.62 10.89 1.62 10.65 1.62H9.75C9.7 1.28 9.58 0.76 9.3 0.47C9.01 0.19 8.66 0.09 8.33 0.04C8.02 0 7.63 0 7.21 0ZM9.77 7.22C9.98 7.16 10.2 7.13 10.42 7.13C11.46 7.13 12.33 7.81 12.61 8.74C12.91 8.74 13.03 8.55 13.03 8.43V5.69L11.34 2.92H9.77V7.22ZM3.91 8.43C3.37 8.43 2.93 8.86 2.93 9.4C2.93 9.94 3.37 10.37 3.91 10.37C4.45 10.37 4.89 9.94 4.89 9.4C4.89 8.86 4.45 8.43 3.91 8.43ZM9.45 9.4C9.45 8.86 9.88 8.43 10.42 8.43C10.96 8.43 11.4 8.86 11.4 9.4C11.4 9.94 10.96 10.37 10.42 10.37C9.88 10.37 9.45 9.94 9.45 9.4Z",
        fill: e.active ? "url(#truck_blue)" : "url(#truck_gray)"
      }, null, 8, cp),
      r[0] || (r[0] = N('<defs><linearGradient id="truck_blue" x1="0.65" y1="10.21" x2="12.71" y2="1.34" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="truck_gray" x1="0.65" y1="10.21" x2="12.71" y2="1.34" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#767BA2"></stop></linearGradient></defs>', 1))
    ]));
  }
}), hp = {}, pp = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fp(e, t) {
  return l(), s("svg", pp, [...t[0] || (t[0] = [
    o("path", {
      d: "M5.3335 6.66602L8.00016 9.33268L10.6668 6.66602",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const CM = /* @__PURE__ */ g(hp, [["render", fp]]), Cp = {}, gp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function vp(e, t) {
  return l(), s("svg", gp, [...t[0] || (t[0] = [
    o("path", {
      d: "M17.0726 33.8367H9.1835C8.64112 33.8367 8.19736 33.3949 8.19736 32.8505V7.21108C8.19736 6.66674 8.64112 6.22495 9.1835 6.22495H20.031V11.1556C20.031 12.7867 21.3583 14.114 22.9894 14.114H27.92V15.1001C27.92 15.6445 28.3618 16.0863 28.9061 16.0863C29.4505 16.0863 29.8923 15.6445 29.8923 15.1001V13.9464C29.8923 13.1575 29.5846 12.4139 29.0265 11.8538L22.2912 5.11851C21.7409 4.56825 20.9776 4.25269 20.2006 4.25269H9.1835C7.55243 4.25269 6.2251 5.58002 6.2251 7.21108V32.8505C6.2251 34.4816 7.55243 35.8089 9.1835 35.8089H17.0726C17.6169 35.8089 18.0587 35.3671 18.0587 34.8228C18.0587 34.2784 17.6169 33.8367 17.0726 33.8367ZM26.5256 12.1417H22.9894C22.447 12.1417 22.0032 11.7 22.0032 11.1556V7.61934L26.5256 12.1417Z",
      fill: "#1A1AC3"
    }, null, -1),
    o("path", {
      d: "M24.9614 18.0586C20.0682 18.0586 16.0862 22.0406 16.0862 26.9338C16.0862 31.827 20.0682 35.809 24.9614 35.809C29.8546 35.809 33.8366 31.827 33.8366 26.9338C33.8366 22.0406 29.8546 18.0586 24.9614 18.0586ZM24.9614 33.8367C21.1549 33.8367 18.0584 30.7403 18.0584 26.9338C18.0584 23.1273 21.1549 20.0309 24.9614 20.0309C28.7678 20.0309 31.8643 23.1273 31.8643 26.9338C31.8643 30.7403 28.7678 33.8367 24.9614 33.8367Z",
      fill: "#1A1AC3"
    }, null, -1),
    o("path", {
      d: "M25.6598 22.2911C25.2752 21.9065 24.65 21.9065 24.2654 22.2911L21.307 25.2495C20.9224 25.6341 20.9224 26.2593 21.307 26.6439C21.6916 27.0285 22.3168 27.0285 22.7014 26.6439L23.9755 25.3698V30.8784C23.9755 31.4227 24.4173 31.8645 24.9616 31.8645C25.506 31.8645 25.9477 31.4227 25.9477 30.8784V25.3698L27.2218 26.6439C27.4151 26.8372 27.6676 26.9338 27.92 26.9338C28.1725 26.9338 28.4249 26.8372 28.6182 26.6459C29.0028 26.2613 29.0028 25.6361 28.6182 25.2515L25.6598 22.2911Z",
      fill: "#1A1AC3"
    }, null, -1)
  ])]);
}
const gM = /* @__PURE__ */ g(Cp, [["render", vp]]), mp = {}, xp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function wp(e, t) {
  return l(), s("svg", xp, [...t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#000EC6"
    }, null, -1),
    o("path", {
      d: "M14.6916 16.9993L7.24219 8.34961H9.55221L17.0016 16.9993H14.6916Z",
      fill: "white"
    }, null, -1),
    o("path", {
      d: "M7 17L7.23007 16.8338C7.4999 16.6386 7.76446 16.4406 8.01765 16.2453C9.81165 14.9041 11.3997 13.3173 12.733 11.5334C13.7604 10.0695 14.0814 8.96136 13.635 8.4083C13.4989 8.27006 13.3323 8.16413 13.148 8.0986C12.9637 8.03307 12.7665 8.00967 12.5715 8.03018C12.1437 8.04074 11.719 8.10528 11.308 8.22222L11.2674 8.23335C11.2426 8.24051 11.2162 8.24101 11.1911 8.23478C11.166 8.22856 11.143 8.21584 11.1246 8.19797C11.0981 8.17138 11.0833 8.13571 11.0833 8.09857C11.0833 8.06143 11.0981 8.02575 11.1246 7.99917C11.1334 7.99068 11.1433 7.98345 11.1542 7.9777L11.1615 7.97372L11.2252 7.9439C12.2784 7.40554 13.4339 7.08686 14.619 7.00796C14.8836 6.98272 15.1506 7.01771 15.3991 7.11019C15.6476 7.20267 15.871 7.35016 16.0518 7.54114C16.6032 8.2262 16.333 9.46193 15.291 11.0205C14.0998 12.8032 12.6213 14.3847 10.9132 15.7034C10.3244 16.1583 9.71781 16.5897 9.10997 16.9845L9.08644 17H7Z",
      fill: "#FFB71A"
    }, null, -1)
  ])]);
}
const vM = /* @__PURE__ */ g(mp, [["render", wp]]), kp = {
  viewBox: "0 0 15 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
}, yp = ["fill"], bp = ["fill"], _p = ["fill"], Mp = ["fill"], Lp = ["fill"], $p = ["fill"], Vp = ["id"], Bp = ["stop-color"], Hp = ["stop-color"], mM = /* @__PURE__ */ I({
  __name: "UserGroupGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, r = Math.random().toString(36).substr(2, 9);
    return (n, i) => (l(), s("svg", kp, [
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.1954 3.01611C13.7221 3.5428 13.7221 4.39672 13.1954 4.92341C12.6687 5.4501 11.8148 5.4501 11.2881 4.92341C10.7614 4.39672 10.7614 3.5428 11.2881 3.01611C11.8148 2.48942 12.6687 2.48942 13.1954 3.01611Z",
        fill: `url(#paint0_linear_4912_13370_${D(r)})`
      }, null, 8, yp),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.80193 0.60824C9.61292 1.41923 9.61292 2.7341 8.80193 3.54509C7.99094 4.35608 6.67607 4.35608 5.86508 3.54509C5.05409 2.73411 5.05409 1.41923 5.86508 0.60824C6.67606 -0.202747 7.99094 -0.202747 8.80193 0.60824Z",
        fill: `url(#paint1_linear_4912_13370_${D(r)})`
      }, null, 8, bp),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.37898 3.01611C3.90566 3.5428 3.90566 4.39672 3.37898 4.92341C2.85229 5.4501 1.99836 5.4501 1.47168 4.92341C0.944988 4.39672 0.944988 3.5428 1.47168 3.01611C1.99836 2.48942 2.85229 2.48942 3.37898 3.01611Z",
        fill: `url(#paint2_linear_4912_13370_${D(r)})`
      }, null, 8, _p),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.8335 9.33539H0V8.60472C0 7.68405 0.746 6.93805 1.66667 6.93805H2.8335",
        fill: `url(#paint3_linear_4912_13370_${D(r)})`
      }, null, 8, Mp),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.8335 9.33539H14.667V8.60472C14.667 7.68405 13.921 6.93805 13.0003 6.93805H11.8335",
        fill: `url(#paint4_linear_4912_13370_${D(r)})`
      }, null, 8, Lp),
      o("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.8928 9.33537V8.26803C10.8928 6.97937 9.8481 5.9347 8.55944 5.9347H6.10677C4.8181 5.9347 3.77344 6.97937 3.77344 8.26803V9.33537",
        fill: `url(#paint5_linear_4912_13370_${D(r)})`
      }, null, 8, $p),
      o("defs", null, [
        (l(), s(n1, null, u1(6, (a) => o("linearGradient", {
          key: a,
          id: `paint${a - 1}_linear_4912_13370_${D(r)}`,
          x1: "0.666651",
          y1: "8.16851",
          x2: "10.7541",
          y2: "-1.3235",
          gradientUnits: "userSpaceOnUse"
        }, [
          o("stop", {
            "stop-color": t.active ? "#C7CBFF" : "#D3D5E4"
          }, null, 8, Bp),
          o("stop", {
            offset: "1",
            "stop-color": t.active ? "#0012FA" : "#585B79"
          }, null, 8, Hp)
        ], 8, Vp)), 64))
      ])
    ]));
  }
}), Fp = {}, Ap = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function jp(e, t) {
  return l(), s("svg", Ap, [...t[0] || (t[0] = [
    N('<g id="Group"><g id="Group_2"><path id="Path" d="M17.3271 7.93627C17.9854 8.59463 17.9854 9.66203 17.3271 10.3204C16.6687 10.9788 15.6013 10.9788 14.943 10.3204C14.2846 9.66203 14.2846 8.59463 14.943 7.93627C15.6013 7.27791 16.6687 7.27791 17.3271 7.93627" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path id="Path_2" d="M11.8355 4.92697C12.8492 5.9407 12.8492 7.58429 11.8355 8.59803C10.8218 9.61177 9.17817 9.61177 8.16443 8.59803C7.1507 7.5843 7.1507 5.94071 8.16443 4.92697C9.17817 3.91323 10.8218 3.91323 11.8355 4.92697" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path id="Path_3" d="M5.05707 7.93627C5.71543 8.59463 5.71543 9.66203 5.05707 10.3204C4.39871 10.9788 3.3313 10.9788 2.67294 10.3204C2.01458 9.66203 2.01458 8.59463 2.67294 7.93627C3.3313 7.27791 4.39871 7.27791 5.05707 7.93627" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path id="Path_4" d="M19.1667 15.8333V14.92C19.1667 13.7692 18.2342 12.8367 17.0833 12.8367H16.4158" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path id="Path_5" d="M0.833333 15.8333V14.92C0.833333 13.7692 1.76583 12.8367 2.91667 12.8367H3.58417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path id="Path_6" d="M14.4492 15.8333V14.4992C14.4492 12.8883 13.1433 11.5825 11.5325 11.5825H8.46667C6.85583 11.5825 5.55 12.8883 5.55 14.4992V15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><g id="Path_7"></g></g>', 1)
  ])]);
}
const xM = /* @__PURE__ */ g(Fp, [["render", jp]]), Ip = {}, Zp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ep(e, t) {
  return l(), s("svg", Zp, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M19.062 12.5044C19.734 11.8324 20.824 11.8314 21.496 12.5044V12.5044C22.168 13.1764 22.168 14.2664 21.495 14.9384L15.721 20.7074C15.534 20.8944 15.28 20.9994 15.015 20.9994H13V18.9844C13 18.7194 13.105 18.4654 13.293 18.2774L19.062 12.5044V12.5044Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 9H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 13H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 17H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.22 16.2193L17.78 13.7793" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19 9V6C19 4.895 18.105 4 17 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15 3V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11 3V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 3V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 9)
  ])]);
}
const wM = /* @__PURE__ */ g(Ip, [["render", Ep]]), Sp = {}, zp = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Dp(e, t) {
  return l(), s("svg", zp, [...t[0] || (t[0] = [
    o("circle", {
      cx: "8",
      cy: "5",
      r: "3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "none"
    }, null, -1),
    o("path", {
      d: "M2 16.5C2 13.5 4.5 11 8 11C9.5 11 10.8 11.5 11.8 12.3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    o("path", {
      d: "M15 12V18M12 15H18",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const kM = /* @__PURE__ */ g(Sp, [["render", Dp]]), Tp = {
  width: "16",
  height: "16",
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4"
}, Op = ["fill"], Pp = ["fill"], yM = /* @__PURE__ */ I({
  __name: "UserSingleGradientIcon",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", Tp, [
      o("path", {
        d: "M8.13 7.16C10.32 7.16 12 8.82 12 10.84C12 10.95 11.91 11.03 11.81 11.03C8.24 11.03 3.98 11.03 0.19 11.03C0.09 11.03 0 10.95 0 10.84C0 8.74 1.77 7.16 3.87 7.16H8.13Z",
        fill: e.active ? "url(#user_blue)" : "url(#user_gray)"
      }, null, 8, Op),
      o("path", {
        d: "M3.81 0.88C5 -0.26 6.81 -0.29 8.05 0.77L8.17 0.88L8.17 0.88L8.28 1C9.4 2.25 9.37 4.15 8.17 5.29C6.94 6.45 4.97 6.54 3.8 5.28C2.65 4.04 2.56 2.06 3.81 0.88Z",
        fill: e.active ? "url(#user_blue)" : "url(#user_gray)"
      }, null, 8, Pp),
      r[0] || (r[0] = N('<defs><linearGradient id="user_blue" x1="0.55" y1="9.65" x2="11.47" y2="2.54" gradientUnits="userSpaceOnUse"><stop stop-color="#C7CBFF"></stop><stop offset="1" stop-color="#0012FA"></stop></linearGradient><linearGradient id="user_gray" x1="0.55" y1="9.65" x2="11.47" y2="2.54" gradientUnits="userSpaceOnUse"><stop stop-color="#D3D5E4"></stop><stop offset="1" stop-color="#585B79"></stop></linearGradient></defs>', 1))
    ]));
  }
}), Rp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6"
}, Np = ["stroke"], Gp = ["stroke"], bM = /* @__PURE__ */ I({
  __name: "UserOutlineIcon",
  props: {
    active: { type: Boolean, default: !1 },
    color: {}
  },
  setup(e) {
    const t = e, r = f(() => t.color ? t.color : t.active ? "#5B61FA" : "#A3A6B7");
    return (n, i) => (l(), s("svg", Rp, [
      o("circle", {
        cx: "12",
        cy: "7",
        r: "4",
        stroke: r.value,
        "stroke-width": "1.5",
        fill: "none"
      }, null, 8, Np),
      o("path", {
        d: "M5.5 21C5.5 17.134 8.41015 14 12 14C15.5899 14 18.5 17.134 18.5 21",
        stroke: r.value,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        fill: "none"
      }, null, 8, Gp)
    ]));
  }
}), Up = ["width", "height"], Wp = ["stroke"], Yp = ["stroke"], _M = /* @__PURE__ */ I({
  __name: "UserProfileInputIcon",
  props: {
    size: { default: 24 },
    color: { default: "#585B79" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M5 20C5 17.5 7 15.6 9.4 15.6H14.5C17 15.6 18.9 17.6 18.9 20",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Wp),
      o("path", {
        d: "M15 5.2C16.7 6.9 16.7 9.6 15 11.2C13.3 12.8 10.6 12.9 9 11.2C7.4 9.5 7.3 6.8 9 5.2C10.7 3.6 13.3 3.6 15 5.2",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Yp)
    ], 8, Up));
  }
}), qp = ["width", "height"], Kp = ["stroke"], Qp = ["stroke"], Xp = ["stroke"], Jp = ["stroke"], ef = ["stroke"], tf = ["stroke"], MM = /* @__PURE__ */ I({
  __name: "UsersGroupInputIcon",
  props: {
    size: { default: 24 },
    color: { default: "#585B79" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M20.7925 9.52352C21.5825 10.3136 21.5825 11.5944 20.7925 12.3845C20.0025 13.1745 18.7216 13.1745 17.9316 12.3845C17.1415 11.5944 17.1415 10.3136 17.9316 9.52352C18.7216 8.73349 20.0025 8.73349 20.7925 9.52352",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Kp),
      o("path", {
        d: "M14.2026 5.91236C15.4191 7.12884 15.4191 9.10115 14.2026 10.3176C12.9861 11.5341 11.0138 11.5341 9.79732 10.3176C8.58084 9.10116 8.58084 7.12885 9.79732 5.91236C11.0138 4.69588 12.9861 4.69588 14.2026 5.91236",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Qp),
      o("path", {
        d: "M6.06848 9.52352C6.85851 10.3136 6.85851 11.5944 6.06848 12.3845C5.27845 13.1745 3.99756 13.1745 3.20753 12.3845C2.4175 11.5944 2.4175 10.3136 3.20753 9.52352C3.99756 8.73349 5.27845 8.73349 6.06848 9.52352",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Xp),
      o("path", {
        d: "M23 19V17.904C23 16.523 21.881 15.404 20.5 15.404H19.699",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Jp),
      o("path", {
        d: "M1 19V17.904C1 16.523 2.119 15.404 3.5 15.404H4.301",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, ef),
      o("path", {
        d: "M17.339 19V17.399C17.339 15.466 15.772 13.899 13.839 13.899H10.16C8.227 13.899 6.66 15.466 6.66 17.399V19",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, tf)
    ], 8, qp));
  }
}), of = ["width", "height"], nf = ["stroke"], LM = /* @__PURE__ */ I({
  __name: "ToastCheckIcon",
  props: {
    size: { default: 20 },
    color: { default: "#1DC37B" }
  },
  setup(e) {
    return (t, r) => (l(), s("svg", {
      width: e.size,
      height: e.size,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      o("path", {
        d: "M16.6667 5.41667L7.5 14.5833L3.33333 10.4167",
        stroke: e.color,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, nf)
    ], 8, of));
  }
}), $M = /* @__PURE__ */ I({
  __name: "VehicleAssetSliderEquipmentIcon",
  props: {
    active: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = f(
      () => t.color != null && t.color !== "" ? { color: t.color } : void 0
    );
    return (n, i) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      class: "block h-5 w-5 shrink-0",
      "aria-hidden": "true",
      style: a1(r.value)
    }, [...i[0] || (i[0] = [
      N('<path d="M0.833415 7.5V14.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.99992 2.5V5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.5 2.50016H12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.6666 7.50016V9.16683H14.9999L13.3333 5.8335H6.66659L4.99992 7.50016H3.33325V14.1668H5.83325L7.26992 17.0393C7.41075 17.3218 7.69909 17.5002 8.01492 17.5002H13.3333C13.7933 17.5002 14.1666 17.1268 14.1666 16.6668V14.1668H16.6666V15.8335H18.3333C18.7933 15.8335 19.1666 15.4602 19.1666 15.0002V8.3335C19.1666 7.8735 18.7933 7.50016 18.3333 7.50016H16.6666Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.33325 10.8332H0.833252" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
    ])], 4));
  }
}), rf = {}, lf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function sf(e, t) {
  return l(), s("svg", lf, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.41018 13.0157L13.0152 4.41074C13.3402 4.08574 13.8677 4.08574 14.1927 4.41074L15.5893 5.80741C15.9143 6.13241 15.9143 6.65991 15.5893 6.98491L6.98352 15.5891C6.82768 15.7457 6.61602 15.8332 6.39518 15.8332H4.16602V13.6041C4.16602 13.3832 4.25352 13.1716 4.41018 13.0157Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.459 5.96655L14.034 8.54155",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const VM = /* @__PURE__ */ g(rf, [["render", sf]]), af = {}, df = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function uf(e, t) {
  return l(), s("svg", df, [...t[0] || (t[0] = [
    o("path", {
      d: "M14.7148 5.28589C17.3182 7.88922 17.3182 12.1109 14.7148 14.7142C12.1115 17.3176 7.88982 17.3176 5.28648 14.7142C2.68315 12.1109 2.68315 7.88922 5.28648 5.28589",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.0007 3.33325V9.99992",
      stroke: "#F4AC33",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const BM = /* @__PURE__ */ g(af, [["render", uf]]), cf = {}, hf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function pf(e, t) {
  return l(), s("svg", hf, [...t[0] || (t[0] = [
    o("path", {
      d: "M2.5 6.66667H17.5",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M2.5 10.8333V5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V11.6667C17.5 13.0474 16.3807 14.1667 15 14.1667H12.5",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M14.166 10.8334H11.666",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.83333 17.4999C5.83333 15.659 4.34095 14.1666 2.5 14.1666C4.34095 14.1666 5.83333 12.6742 5.83333 10.8333C5.83333 12.6742 7.32572 14.1666 9.16667 14.1666C7.32572 14.1666 5.83333 15.659 5.83333 17.4999Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const HM = /* @__PURE__ */ g(cf, [["render", pf]]), ff = {}, Cf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function gf(e, t) {
  return l(), s("svg", Cf, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10Z",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.11716 7.54827L12.3522 9.4616C12.7613 9.70327 12.7613 10.2958 12.3522 10.5374L9.11716 12.4508C8.70049 12.6974 8.17383 12.3966 8.17383 11.9124V8.0866C8.17383 7.60244 8.70049 7.3016 9.11716 7.54827V7.54827Z",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const FM = /* @__PURE__ */ g(ff, [["render", gf]]), vf = {}, mf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function xf(e, t) {
  return l(), s("svg", mf, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.2082 16.9967L15.3832 17.4113C15.1494 17.5287 14.8741 17.5296 14.6396 17.4137L13.3292 16.7657L12.0451 17.4107C11.8107 17.5285 11.5345 17.529 11.2996 17.4121L10.0007 16.7654L8.70168 17.4121C8.46684 17.529 8.19064 17.5285 7.95622 17.4107L6.67213 16.7657L5.36173 17.4137C5.12724 17.5296 4.85191 17.5287 4.61817 17.4113L3.79317 16.9967C3.51166 16.8552 3.33399 16.5671 3.33398 16.2521V3.74793C3.33399 3.43289 3.51165 3.14478 3.79315 3.00333L4.61815 2.58873C4.85189 2.47127 5.12723 2.47038 5.36172 2.58634L6.67212 3.23433L7.9562 2.58927C8.19062 2.47151 8.46682 2.47101 8.70167 2.58792L10.0007 3.23459L11.2996 2.58792C11.5345 2.47101 11.8107 2.47151 12.0451 2.58927L13.3292 3.23433L14.6396 2.58634C14.8741 2.47038 15.1494 2.47127 15.3831 2.58873L16.2081 3.00333C16.4896 3.14478 16.6673 3.43289 16.6673 3.74793V16.2521C16.6673 16.5671 16.4896 16.8552 16.2082 16.9967Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13.3327 7.49992H6.66602",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13.3327 9.99992H6.66602",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10.8327 12.4999H6.66602",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const AM = /* @__PURE__ */ g(vf, [["render", xf]]), wf = {}, kf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function yf(e, t) {
  return l(), s("svg", kf, [...t[0] || (t[0] = [
    o("path", {
      d: "M11.7674 8.23337C12.7433 9.2092 12.7433 10.7934 11.7674 11.7709C10.7916 12.7467 9.20742 12.7467 8.22992 11.7709C7.25409 10.795 7.25409 9.21087 8.22992 8.23337C9.20742 7.25587 10.7908 7.25587 11.7674 8.23337",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 10.0001C2.5 9.45091 2.62667 8.90758 2.87167 8.40675V8.40675C4.13417 5.82591 6.92417 4.16675 10 4.16675C13.0758 4.16675 15.8658 5.82591 17.1283 8.40675V8.40675C17.3733 8.90758 17.5 9.45091 17.5 10.0001C17.5 10.5492 17.3733 11.0926 17.1283 11.5934V11.5934C15.8658 14.1742 13.0758 15.8334 10 15.8334C6.92417 15.8334 4.13417 14.1742 2.87167 11.5934V11.5934C2.62667 11.0926 2.5 10.5492 2.5 10.0001Z",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const jM = /* @__PURE__ */ g(wf, [["render", yf]]), bf = {}, _f = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Mf(e, t) {
  return l(), s("svg", _f, [...t[0] || (t[0] = [
    o("path", {
      d: "M12.3592 7.6416L7.64258 12.3583",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.3592 12.3583L7.64258 7.6416",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z",
      stroke: "#F93365",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const IM = /* @__PURE__ */ g(bf, [["render", Mf]]), Lf = {}, $f = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Vf(e, t) {
  return l(), s("svg", $f, [...t[0] || (t[0] = [
    o("path", {
      d: "M15 16.6667V16.0417C15 14.0857 13.4143 12.5 11.4583 12.5H5.20833C3.25232 12.5 1.66667 14.0857 1.66667 16.0417V16.6667",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "8.33333",
      cy: "5.83333",
      r: "3.33333",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.8333 7.5V10.8333",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17.5 9.16667H14.1667",
      stroke: "#767BA2",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ZM = /* @__PURE__ */ g(Lf, [["render", Vf]]), Bf = {}, Hf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20.0083 20.0083",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Ff(e, t) {
  return l(), s("svg", Hf, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9566 17.5073H7.05175C6.07158 17.5073 5.25667 16.7527 5.18149 15.7754L4.37682 5.31471H15.6315L14.8268 15.7754C14.7517 16.7527 13.9368 17.5073 12.9566 17.5073V17.5073Z" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.6736 5.31471H3.33472" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.65944 2.50104H12.3489C12.8669 2.50104 13.2868 2.92095 13.2868 3.43893V5.31471H6.72155V3.43893C6.72155 2.92095 7.14146 2.50104 7.65944 2.50104Z" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.6455 9.06628V13.7557" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.36286 9.06628V13.7557" stroke="#F93365" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const EM = /* @__PURE__ */ g(Bf, [["render", Ff]]), Af = {}, jf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function If(e, t) {
  return l(), s("svg", jf, [...t[0] || (t[0] = [
    N('<path d="M6.66675 6.66659H3.99133C3.16766 6.66659 2.50008 7.33417 2.50008 8.15784C2.50008 8.65267 2.74591 9.11934 3.15675 9.39175L8.11808 12.7559C9.25425 13.5251 10.7467 13.5251 11.8828 12.7559L16.8431 9.39242C17.2548 9.11917 17.5001 8.65292 17.5001 8.15825V8.15742C17.5001 7.33375 16.8325 6.66617 16.0088 6.66617H13.3334" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.50008 8.16992V15.8333C2.50008 16.7533 3.24675 17.5 4.16675 17.5H15.8334C16.7534 17.5 17.5001 16.7533 17.5001 15.8333V8.16992" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.96387 17.0115L7.56842 12.4069" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.4308 12.4062L17.0353 16.0108" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.99925 2.5V8.28833" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.666 4.16667L9.99933 2.5L8.33268 4.16667" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const SM = /* @__PURE__ */ g(Af, [["render", If]]), Zf = {}, Ef = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Sf(e, t) {
  return l(), s("svg", Ef, [...t[0] || (t[0] = [
    o("circle", {
      cx: "13.9584",
      cy: "14.7917",
      r: "3.54167",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.1492 14.0903L13.6617 15.5769L12.7675 14.6853",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.33333 12.5H5.83333C3.99238 12.5 2.5 13.9924 2.5 15.8333V16.6667",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "9.16665",
      cy: "5.83333",
      r: "3.33333",
      stroke: "#1DC37B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zM = /* @__PURE__ */ g(Zf, [["render", Sf]]), zf = {}, Df = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Tf(e, t) {
  return l(), s("svg", Df, [...t[0] || (t[0] = [
    N('<path d="M15.0021 11.667C16.8438 11.667 18.3368 13.16 18.3368 15.0017C18.3368 16.8434 16.8438 18.3364 15.0021 18.3364C13.1604 18.3364 11.6674 16.8434 11.6674 15.0017C11.6674 13.16 13.1604 11.667 15.0021 11.667" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.1259 14.4409L14.722 15.849L13.8783 15.002" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.93538 9.55893H5.16965" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.0459 9.55893H12.2801" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.9287 6.91021L16.6936 6.02734" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.28679 6.91021L2.52106 6.02734" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.7353 2.49658C5.91484 2.49667 5.20243 3.06162 5.01542 3.86048L4.26511 7.06182L5.01542 3.86048C5.20243 3.06162 5.91484 2.49667 6.7353 2.49658H12.4802C13.3006 2.49644 14.0129 3.06158 14.1992 3.86048L14.9496 7.06182" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.6936 9.99992V9.34131C16.6936 8.03822 15.6382 6.98133 14.3351 6.97949H4.88371C4.25717 6.97927 3.65622 7.22801 3.21311 7.67096C2.77001 8.11391 2.52106 8.71477 2.52106 9.34131V13.3346C2.52106 13.7951 2.89431 14.1683 3.35474 14.1683H5.21885C5.67928 14.1683 6.05253 13.7951 6.05253 13.3346V12.2067H10" stroke="#000652" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 8)
  ])]);
}
const DM = /* @__PURE__ */ g(zf, [["render", Tf]]), Of = {}, Pf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Rf(e, t) {
  return l(), s("svg", Pf, [...t[0] || (t[0] = [
    N('<path d="M9.99997 2.49707V4.53125" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3347 6.66553L11.1671 8.8331" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.98413 8.33252C10.905 8.33252 11.6515 9.07902 11.6515 9.99988C11.6515 10.9207 10.905 11.6672 9.98413 11.6672C9.06328 11.6672 8.31677 10.9207 8.31677 9.99988C8.31677 9.07902 9.06328 8.33252 9.98413 8.33252" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.93286 12.501C3.98924 15.4985 6.82173 17.5036 9.99997 17.5036C13.1782 17.5036 16.0107 15.4985 17.0671 12.501" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.16419 10.0002H2.49683C2.49683 7.31959 3.92691 4.8426 6.24839 3.5023C8.56986 2.16199 11.43 2.16199 13.7515 3.5023C16.073 4.8426 17.5031 7.31959 17.5031 10.0002H15.8357" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.69775 4.69775L5.87324 5.87324" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const TM = /* @__PURE__ */ g(Of, [["render", Rf]]), Nf = {}, Gf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Uf(e, t) {
  return l(), s("svg", Gf, [...t[0] || (t[0] = [
    N('<rect x="8.75" y="5.4165" width="5.83333" height="2.49999" rx="1.25" stroke="#5763FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M13.75 2.5H8.88075C7.9967 2.5 7.14885 2.85119 6.52373 3.47631L4.30968 5.69036C3.68456 6.31548 3.33337 7.16332 3.33337 8.04737V15.8333C3.33337 17.214 4.45266 18.3333 5.83337 18.3333H15C16.3808 18.3333 17.5 17.214 17.5 15.8333V6.25C17.5 4.17893 15.8211 2.5 13.75 2.5Z" stroke="#5763FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66663 15.0002H13.3333" stroke="#5763FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66663 12.5002H9.16663" stroke="#5763FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.24947 5.7549L3.1588 4.66422C3.00374 4.50917 2.91663 4.29887 2.91663 4.07958C2.91663 3.8603 3.00374 3.65 3.1588 3.49494L4.32807 2.32567C4.48313 2.17061 4.69343 2.0835 4.91271 2.0835C5.132 2.0835 5.3423 2.17061 5.49735 2.32567L6.5859 3.41422" stroke="#5763FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const OM = /* @__PURE__ */ g(Nf, [["render", Uf]]), Wf = {}, Yf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function qf(e, t) {
  return l(), s("svg", Yf, [...t[0] || (t[0] = [
    o("path", {
      d: "M9.99998 5V6.25",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.3033 4.6967C18.2323 7.62563 18.2323 12.3744 15.3033 15.3033C12.3744 18.2322 7.62568 18.2322 4.69676 15.3033C1.76783 12.3743 1.76783 7.62562 4.69676 4.6967C7.62569 1.76777 12.3744 1.76777 15.3033 4.6967",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99998 15V13.75",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.5 11.8792V11.8792C7.5 12.915 8.33917 13.7542 9.375 13.7542H10.7442C11.7133 13.7542 12.5 12.9683 12.5 11.9983V11.9983C12.5 11.1933 11.9525 10.4917 11.1717 10.2958L8.82833 9.70833C8.0475 9.5125 7.5 8.81083 7.5 8.00583V8.00583C7.5 7.03583 8.28583 6.25 9.25583 6.25H10.625C11.6608 6.25 12.5 7.08917 12.5 8.125V8.125",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const PM = /* @__PURE__ */ g(Wf, [["render", qf]]), Kf = {}, Qf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function Xf(e, t) {
  return l(), s("svg", Qf, [...t[0] || (t[0] = [
    o("path", {
      d: "M11.2967 9.1665L9.67666 10.7865L8.70416 9.814",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7.5 13.3332H12.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M16.7071 17.5002V3.93091C16.7071 3.7808 16.6263 3.64229 16.4957 3.56833C16.3651 3.49437 16.2047 3.4964 16.076 3.57363L14.9001 4.27916C14.6362 4.43751 14.3065 4.43751 14.0426 4.27916L12.6644 3.45225C12.4005 3.29391 12.0708 3.29391 11.8069 3.45225L10.4288 4.27916C10.1649 4.43751 9.83517 4.43751 9.57127 4.27916L8.19309 3.45225C7.92918 3.29391 7.59949 3.29391 7.33559 3.45225L5.9574 4.27916C5.6935 4.43751 5.36381 4.43751 5.0999 4.27916L3.92401 3.57363C3.79529 3.4964 3.63498 3.49437 3.50435 3.56833C3.37372 3.64229 3.29297 3.7808 3.29297 3.93091V17.5002",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17.5 17.5002H2.5",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const RM = /* @__PURE__ */ g(Kf, [["render", Xf]]), Jf = {}, eC = {
  width: "72",
  height: "64",
  viewBox: "0 0 72 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function tC(e, t) {
  return l(), s("svg", eC, [...t[0] || (t[0] = [
    N('<g clip-path="url(#clip0_4234_42663)"><path fill-rule="evenodd" clip-rule="evenodd" d="M55.9589 2.03705L55.9724 2.0178L55.9052 1.5383L54.4235 2.09553C54.401 2.102 54.3783 2.10918 54.3562 2.11667C51.7217 2.99416 50.7768 7.49446 52.2479 12.1598C53.7196 16.8254 57.0531 19.9018 59.6876 19.0243C62.3228 18.1471 63.267 13.6465 61.7959 8.98113C60.6115 5.22559 58.2204 2.49981 55.9589 2.03705Z" fill="#C29725"></path><mask id="mask0_4234_42663" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="51" y="1" width="12" height="19"><path d="M55.9597 2.03705L55.9731 2.0178L55.9059 1.5383L54.4242 2.09553C54.4018 2.102 54.379 2.10918 54.3569 2.11667C51.7224 2.99416 50.7776 7.49446 52.2486 12.1598C53.7204 16.8254 57.0539 19.9018 59.6883 19.0243C62.3235 18.1471 63.2677 13.6465 61.7966 8.98113C60.6123 5.22559 58.2212 2.49981 55.9597 2.03705Z" fill="white"></path></mask><g mask="url(#mask0_4234_42663)"><path d="M56.4307 10.5976C54.0659 14.0804 50.0446 15.4813 47.4489 13.7266C44.8533 11.972 44.6662 7.72628 47.031 4.24355C49.3959 0.760814 53.4172 -0.64009 56.0128 1.11454C58.6085 2.86918 58.7956 7.1149 56.4307 10.5976Z" fill="#0F0DAD"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M59.4198 19.0999L61.4322 18.4234L61.7552 17.1502L58.6171 17.4257L59.4198 19.0999Z" fill="#1B12FA"></path><path d="M61.3654 18.4466C58.7184 19.3279 55.3762 16.2483 53.9004 11.5681C52.4246 6.88793 53.3741 2.37943 56.0211 1.49811C58.6681 0.616793 62.0103 3.69639 63.4861 8.37659C64.9619 13.0568 64.0125 17.5653 61.3654 18.4466Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M55.8358 2.48026C55.9025 2.4471 55.971 2.41746 56.0413 2.39156C58.1193 1.6259 60.9745 4.33301 62.4133 8.43293C63.8521 12.5328 63.3332 16.4831 61.2551 17.2488C61.1848 17.2747 61.1136 17.2965 61.0416 17.3147C62.9472 16.3701 63.3846 12.5485 61.9945 8.58723C60.6044 4.62598 57.892 1.96487 55.8358 2.48026Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M61.0951 13.6642L54.9041 7.57049L56.2135 7.21041L62.5438 13.4413L61.2344 13.8013L60.9936 13.7022L61.0951 13.6642Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M57.4255 6.22276C57.9046 5.67948 58.6996 4.9836 59.4136 5.31926C60.5279 5.84312 60.6687 9.40636 58.0121 14.6867L56.6804 15.0529L56.4412 14.9527C56.4412 14.9527 56.7788 14.8591 56.7828 14.8509C57.2827 13.8468 59.414 9.34241 58.6908 6.90084C58.6908 6.90084 58.4355 5.7194 56.9878 6.78374L56.7472 6.68464L56.9105 6.56518L57.4255 6.22276Z" fill="#0F0DAD"></path><path d="M55.9727 7.10959L54.6631 7.46973L60.9933 13.7006L62.3029 13.3404L55.9727 7.10959Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M56.7476 6.68466C56.7476 6.68466 58.059 4.69624 59.1733 5.22007C60.2877 5.74393 60.4284 9.30717 57.7718 14.5875L56.4401 14.9537C56.4401 14.9537 59.2679 9.56059 58.4505 6.80165C58.4505 6.80165 58.1952 5.62013 56.7476 6.68466Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M70.0609 22.0364C70.7039 22.1993 71.2535 22.6163 71.5839 23.192C71.9137 23.7675 71.9964 24.4526 71.8118 25.0899C69.7076 32.3675 63.4742 53.9291 61.3259 61.3593C61.1359 62.0158 60.6803 62.5635 60.0683 62.8694C59.457 63.1748 58.7451 63.211 58.1062 62.9685C48.7194 59.4113 15.4797 46.8126 6.57151 43.4363C5.33845 42.969 4.69698 41.6091 5.12057 40.3603C7.23633 34.1228 13.1793 16.602 15.2552 10.4818C15.6655 9.27215 16.9368 8.58117 18.175 8.89478C27.1015 11.1557 60.6709 19.6581 70.0609 22.0364Z" fill="#0F0DAD"></path><mask id="mask1_4234_42663" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="4" y="8" width="68" height="56"><path d="M70.0599 22.0364C70.7029 22.1993 71.2525 22.6163 71.5829 23.192C71.9127 23.7675 71.9955 24.4526 71.8109 25.0899C69.7066 32.3675 63.4732 53.9291 61.3249 61.3593C61.1349 62.0158 60.6793 62.5635 60.0673 62.8694C59.4561 63.1748 58.7442 63.211 58.1052 62.9685C48.7184 59.4113 15.4787 46.8126 6.57054 43.4363C5.33748 42.969 4.696 41.6091 5.1196 40.3603C7.23535 34.1228 13.1783 16.602 15.2542 10.4818C15.6645 9.27215 16.9358 8.58117 18.1741 8.89478C27.1005 11.1557 60.6699 19.6581 70.0599 22.0364Z" fill="white"></path></mask><g mask="url(#mask1_4234_42663)"><path d="M71.3694 30.0915L12.5466 14.958L11.1775 20.2799L70.0002 35.4133L71.3694 30.0915Z" fill="#80AEFF"></path></g><path d="M48.5513 54.0772C50.3317 54.6759 52.2603 53.718 52.859 51.9377C53.4577 50.1573 52.4998 48.2286 50.7194 47.6299C48.939 47.0312 47.0105 47.9893 46.4118 49.7696C45.8131 51.55 46.771 53.4785 48.5513 54.0772Z" fill="white"></path><path d="M53.2237 55.6475C55.004 56.2462 56.9326 55.2883 57.5313 53.508C58.13 51.7276 57.1721 49.7989 55.3918 49.2002C53.6114 48.6015 51.6828 49.5596 51.0841 51.3399C50.4855 53.1203 51.4433 55.0488 53.2237 55.6475Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M56.2578 10.3861C56.9043 10.3235 57.5493 10.5203 58.0502 10.9331C58.5516 11.3459 58.8686 11.9409 58.9312 12.5872C59.6163 19.664 61.6019 40.1727 62.3067 47.4527C62.3719 48.1266 62.1549 48.7975 61.7079 49.3056C61.2609 49.8145 60.6229 50.1148 59.9463 50.1358C49.8152 50.4541 13.1868 51.6033 3.214 51.9163C2.55216 51.9371 1.91013 51.6888 1.43434 51.2283C0.958554 50.7678 0.689571 50.1341 0.688812 49.472C0.680664 42.7306 0.658664 24.3802 0.650999 17.9955C0.649436 16.7335 1.60736 15.6771 2.86348 15.5555C11.9994 14.671 46.7197 11.3096 56.2578 10.3861Z" fill="#1B12FA"></path><mask id="mask2_4234_42663" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="0" y="10" width="63" height="42"><path d="M56.2586 10.3861C56.9051 10.3235 57.55 10.5203 58.0509 10.9331C58.5524 11.3459 58.8694 11.9409 58.9319 12.5872C59.6171 19.664 61.6026 40.1727 62.3074 47.4527C62.3727 48.1266 62.1556 48.7975 61.7086 49.3056C61.2616 49.8145 60.6237 50.1148 59.9471 50.1358C49.8159 50.4541 13.1875 51.6033 3.21474 51.9163C2.55289 51.9371 1.91086 51.6888 1.43507 51.2283C0.959287 50.7678 0.690303 50.1341 0.689544 49.472C0.681397 42.7306 0.659396 24.3802 0.651731 17.9955C0.650168 16.7335 1.60809 15.6771 2.86421 15.5555C12.0002 14.671 46.7205 11.3096 56.2586 10.3861Z" fill="white"></path></mask><g mask="url(#mask2_4234_42663)"><path d="M30.4258 63.1243C36.4927 63.1243 40.4076 58.352 39.17 52.465C37.9324 46.578 32.0109 41.8057 25.944 41.8057C19.8771 41.8057 15.9623 46.578 17.1999 52.465C18.4375 58.352 24.3589 63.1243 30.4258 63.1243Z" fill="#1912D1"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M52.2421 27.9776C52.6184 27.9411 52.9925 28.0512 53.2853 28.2993C53.5766 28.5313 53.7619 28.8875 53.7978 29.258C53.8851 30.1603 53.999 31.3364 54.0863 32.2386C54.1222 32.6092 54.0086 32.9943 53.7673 33.2778C53.5276 33.5775 53.1815 33.7573 52.8052 33.7937C51.486 33.9215 49.5324 34.1106 48.2133 34.2383C47.837 34.2747 47.4615 34.1648 47.1687 33.9167C46.8775 33.6847 46.6922 33.3285 46.6563 32.958C46.5689 32.0557 46.4551 30.8796 46.3677 29.9773C46.3319 29.6068 46.4454 29.2217 46.6867 28.9382C46.9265 28.6385 47.2739 28.4586 47.6502 28.4221C48.9694 28.2944 50.9229 28.1053 52.2421 27.9776Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M47.3463 11.6447C47.1248 11.6661 46.9279 11.5039 46.9065 11.2827C46.8851 11.0614 47.0472 10.8645 47.2687 10.843L56.2136 9.97702C57.7814 9.82523 59.175 10.9728 59.3268 12.5401L60.9731 29.5455C60.9945 29.7667 60.8318 29.9638 60.611 29.9852C60.3895 30.0066 60.1926 29.8443 60.1712 29.6231L58.5248 12.6178C58.4159 11.4932 57.4161 10.6698 56.2912 10.7787L47.3463 11.6447Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M58.5153 49.7693C58.7375 49.7622 58.9235 49.9371 58.9305 50.1594C58.9375 50.3811 58.7627 50.5673 58.5405 50.5744L3.22167 52.3104C2.45095 52.3346 1.7033 52.0456 1.14924 51.5093C0.595186 50.973 0.282009 50.2351 0.281068 49.4641L0.247902 21.8405C0.247635 21.6183 0.427827 21.4376 0.650091 21.4374C0.872349 21.4371 1.05303 21.6173 1.05329 21.8395L1.08646 49.4631C1.08716 50.0163 1.31189 50.5458 1.70941 50.9305C2.10694 51.3153 2.64339 51.5227 3.19636 51.5053L58.5153 49.7693Z" fill="#0F0DAD"></path><path d="M22.3056 62.6799C27.5805 64.3027 33.2413 61.1171 34.9494 55.5647C36.6575 50.0123 33.7661 44.1958 28.4912 42.573C23.2163 40.9503 17.5555 44.1359 15.8474 49.6882C14.1393 55.2406 17.0307 61.0572 22.3056 62.6799Z" fill="#1B12FA"></path><mask id="mask3_4234_42663" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="15" y="42" width="21" height="22"><path d="M22.3063 62.6809C27.5812 64.3037 33.242 61.1181 34.9502 55.5657C36.6583 50.0133 33.7668 44.1967 28.4919 42.574C23.2171 40.9512 17.5562 44.1368 15.8481 49.6892C14.14 55.2416 17.0314 61.0582 22.3063 62.6809Z" fill="white"></path></mask><g mask="url(#mask3_4234_42663)"><path d="M38.1277 47.6823C36.4744 42.573 31.8857 39.3076 27.8788 40.389C23.8718 41.4703 21.9638 46.4889 23.6172 51.5983C25.2705 56.7076 29.8591 59.973 33.8661 58.8916C37.8731 57.8103 39.7811 52.7917 38.1277 47.6823Z" fill="#0F0DAD"></path></g><path d="M21.1144 62.3128C26.3893 63.9355 32.0502 60.7499 33.7583 55.1975C35.4664 49.6451 32.5749 43.8286 27.3001 42.2058C22.0252 40.5831 16.3643 43.7687 14.6562 49.321C12.9481 54.8734 15.8395 60.69 21.1144 62.3128Z" fill="#80AEFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2643 47.6208L23.5138 47.8877L23.3244 47.9301L23.1262 47.7122L23.2643 47.6208Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M26.6551 43.5515C26.5202 43.5003 26.383 43.4531 26.2435 43.4102C22.1203 42.1418 17.5803 44.9887 16.1114 49.7637C14.6424 54.5386 16.7972 59.4451 20.9204 60.7135C21.0598 60.7564 21.1998 60.7945 21.3401 60.8283C17.4866 59.3691 15.5231 54.6327 16.9423 50.0193C18.3616 45.4059 22.6478 42.5921 26.6551 43.5515Z" fill="#0F0DAD"></path><path d="M23.5134 47.8879L21.5129 47.2725L25.4964 57.6533L27.4969 58.2687L23.5134 47.8879Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M25.495 57.6523L25.2458 57.386L25.4872 57.4429L25.495 57.6523Z" fill="#C29725"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.8475 48.0536C24.8475 48.0536 28.0117 47.1575 29.1217 48.4525C30.2316 49.7475 27.8774 53.1601 20.5741 56.1388L18.5399 55.513L18.2929 55.2464C18.2929 55.2464 18.8091 55.4043 18.8203 55.3997C20.2021 54.8295 26.2526 52.1906 27.0313 49.3976C27.0313 49.3976 27.5341 48.1146 24.8475 48.0536Z" fill="#0F0DAD"></path><path d="M23.2656 47.6203L21.2651 47.0049L25.2486 57.3857L27.2491 58.0011L23.2656 47.6203Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.6012 47.7863L24.8509 48.0527C25.301 48.018 25.7518 48.0462 26.2035 48.108L26.3768 47.8812L24.9036 47.7935L24.6012 47.7863Z" fill="#0F0DAD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5998 47.7863C24.5998 47.7863 27.7641 46.8902 28.8741 48.1852C29.984 49.4803 27.6298 52.8929 20.3264 55.8715L18.2923 55.2457C18.2923 55.2457 25.9039 52.2864 26.7836 49.1303C26.7836 49.1303 27.2865 47.8474 24.5998 47.7863Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.217 24.0957L10.2706 25.316L5.48771 25.6535C5.17303 25.6757 4.86537 25.5613 4.63323 25.3552C4.3999 25.1491 4.2627 24.862 4.24863 24.5415L4.07171 20.5113C4.05765 20.1908 4.16887 19.8862 4.38272 19.6485C4.59538 19.411 4.89168 19.2666 5.20636 19.2444L9.98922 18.9069L10.0422 20.1146L5.50072 20.4351C5.41791 20.4409 5.35488 20.5197 5.35813 20.5937L5.40899 21.7523C5.41278 21.8385 5.48176 21.8954 5.56457 21.8896L8.63328 21.673L8.68035 22.7452L5.61163 22.9617C5.52882 22.9676 5.46526 23.034 5.46904 23.1203L5.51991 24.2789C5.52315 24.3529 5.59267 24.4221 5.67548 24.4162L10.217 24.0957Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.2934 23.5957L17.347 24.816L12.5641 25.1535C12.2494 25.1757 11.9418 25.0613 11.7096 24.8552C11.4763 24.6491 11.3391 24.362 11.3251 24.0415L11.1481 20.0113C11.1341 19.6908 11.2453 19.3862 11.4591 19.1485C11.6718 18.911 11.9681 18.7666 12.2828 18.7444L17.0656 18.4069L17.1187 19.6146L12.5771 19.9351C12.4943 19.9409 12.4313 20.0197 12.4345 20.0937L12.5963 23.7789C12.5996 23.8529 12.6691 23.9221 12.7519 23.9162L17.2934 23.5957Z" fill="white"></path><path d="M19.4302 18.2385L17.7725 18.3555L23.4873 24.3845L25.145 24.2675L19.4302 18.2385Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4716 17.9929C20.4716 17.9929 22.6009 16.5292 23.7721 17.1165C24.9433 17.7038 24.083 20.671 19.4084 24.6721L17.7227 24.791C17.7227 24.791 22.6329 20.7203 22.4585 18.325C22.4585 18.325 22.4962 17.3123 20.4716 17.9929Z" fill="#80AEFF"></path></g><defs><clipPath id="clip0_4234_42663"><rect width="72" height="64" fill="white"></rect></clipPath></defs>', 2)
  ])]);
}
const NM = /* @__PURE__ */ g(Jf, [["render", tC]]), oC = {}, nC = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function rC(e, t) {
  return l(), s("svg", nC, [...t[0] || (t[0] = [
    o("path", {
      d: "M3.75 10H7.5L9.375 6.25L12.5 13.75L14.375 10H16.25",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M3.75 14.375H6.25",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    o("path", {
      d: "M13.75 14.375H16.25",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const GM = /* @__PURE__ */ g(oC, [["render", rC]]), lC = {}, sC = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
};
function iC(e, t) {
  return l(), s("svg", sC, [...t[0] || (t[0] = [
    o("path", {
      d: "M6.875 5.625V4.375C6.875 3.89175 7.26675 3.5 7.75 3.5H11.25C11.7332 3.5 12.125 3.89175 12.125 4.375V5.625",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M6.25 5.625H13.75V14.375C13.75 15.4105 12.9105 16.25 11.875 16.25H8.125C7.08947 16.25 6.25 15.4105 6.25 14.375V5.625Z",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.75 8.75H11.25",
      stroke: "#000A85",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const UM = /* @__PURE__ */ g(lC, [["render", iC]]), aC = {}, dC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function uC(e, t) {
  return l(), s("svg", dC, [...t[0] || (t[0] = [
    o("path", {
      d: "M21.4286 0H2.57143C1.15371 0 0 1.15371 0 2.57143V14.5714C0 15.9891 1.15371 17.1429 2.57143 17.1429H21.4286C22.8463 17.1429 24 15.9891 24 14.5714V2.57143C24 1.15371 22.8463 0 21.4286 0ZM22.2857 14.5714C22.2857 15.0446 21.9009 15.4286 21.4286 15.4286H2.57143C2.09914 15.4286 1.71429 15.0446 1.71429 14.5714V2.57143C1.71429 2.09914 2.09914 1.71429 2.57143 1.71429H21.4286C21.9009 1.71429 22.2857 2.09914 22.2857 2.57143V14.5714ZM23.1429 20.5714H6.69943C6.34457 19.5763 5.40171 18.8571 4.28571 18.8571C3.16971 18.8571 2.22686 19.5763 1.872 20.5714H0.857143C0.384 20.5714 0 20.9546 0 21.4286C0 21.9026 0.384 22.2857 0.857143 22.2857H1.872C2.22686 23.2809 3.16971 24 4.28571 24C5.40171 24 6.34457 23.2809 6.69943 22.2857H23.1429C23.616 22.2857 24 21.9026 24 21.4286C24 20.9546 23.616 20.5714 23.1429 20.5714ZM4.28571 22.2857C3.81343 22.2857 3.42857 21.9017 3.42857 21.4286C3.42857 20.9554 3.81343 20.5714 4.28571 20.5714C4.758 20.5714 5.14286 20.9554 5.14286 21.4286C5.14286 21.9017 4.758 22.2857 4.28571 22.2857ZM10.2857 12.9043C9.99857 12.9043 9.71143 12.8331 9.45171 12.6883C8.90914 12.3857 8.57229 11.8123 8.57229 11.1909V5.95371C8.57229 5.33229 8.91 4.758 9.45171 4.45629C9.99429 4.15371 10.6603 4.16914 11.1874 4.49571L15.4209 7.11429C15.93 7.42971 16.2334 7.974 16.2334 8.57229C16.2334 9.17057 15.93 9.71486 15.4217 10.0303L11.1883 12.6497C10.9131 12.8203 10.5994 12.9051 10.2866 12.9051L10.2857 12.9043ZM10.2814 5.95029L10.2857 11.19L14.5191 8.57143L10.2814 5.95029Z",
      fill: "#000EC6"
    }, null, -1)
  ])]);
}
const WM = /* @__PURE__ */ g(aC, [["render", uC]]), cC = {}, hC = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function pC(e, t) {
  return l(), s("svg", hC, [...t[0] || (t[0] = [
    o("rect", {
      x: "2",
      y: "2",
      width: "6",
      height: "6",
      stroke: "currentColor",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    o("rect", {
      x: "12",
      y: "2",
      width: "6",
      height: "6",
      stroke: "currentColor",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    o("rect", {
      x: "2",
      y: "12",
      width: "6",
      height: "6",
      stroke: "currentColor",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    o("rect", {
      x: "12",
      y: "12",
      width: "6",
      height: "6",
      stroke: "currentColor",
      "stroke-width": "2",
      fill: "none"
    }, null, -1)
  ])]);
}
const YM = /* @__PURE__ */ g(cC, [["render", pC]]), fC = {}, CC = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gC(e, t) {
  return l(), s("svg", CC, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.2356 1.33398H21.7515C22.8569 1.33398 23.7477 1.33398 24.476 1.39268C25.2238 1.45137 25.887 1.5818 26.5048 1.89483C27.4801 2.39045 28.267 3.17955 28.7611 4.15124C29.0733 4.76425 29.2033 5.42943 29.2683 6.17288C29.2878 6.42069 29.3008 6.68807 29.3138 6.98153C29.3269 7.04022 29.3334 7.10544 29.3334 7.17065C29.3334 7.2163 29.3334 7.26195 29.3269 7.3076C29.3334 7.77714 29.3334 8.30538 29.3334 8.88578V19.0331C29.3334 20.1352 29.3334 21.0287 29.2748 21.7525C29.2163 22.5025 29.0863 23.1612 28.7676 23.7742C28.2865 24.7133 27.5387 25.4828 26.6088 25.9784V28.5218C26.6088 28.6848 26.6088 28.8674 26.5958 29.0304C26.5828 29.213 26.5438 29.4543 26.4137 29.7021C26.2447 30.0347 25.9716 30.3021 25.6399 30.4717C25.3864 30.6021 25.1458 30.6347 24.9637 30.6543C24.8076 30.6673 24.6191 30.6673 24.4565 30.6673H20.7436C20.581 30.6673 20.3924 30.6673 20.2364 30.6543C20.0543 30.6412 19.8137 30.6021 19.5601 30.4717C19.2285 30.3021 18.9554 30.0347 18.7863 29.7021C18.6563 29.4478 18.6238 29.2065 18.6043 29.0304C18.5913 28.8739 18.5913 28.6913 18.5913 28.5218V26.5914H13.2917V28.5218C13.2917 28.6848 13.2917 28.8674 13.2787 29.0304C13.2657 29.213 13.2267 29.4543 13.0967 29.7021C12.9276 30.0347 12.6545 30.3021 12.3229 30.4717C12.0693 30.6021 11.8287 30.6347 11.6466 30.6543C11.4906 30.6673 11.302 30.6673 11.1394 30.6673H7.52404C7.36148 30.6673 7.17291 30.6673 7.01685 30.6543C6.83478 30.6412 6.59418 30.6021 6.34059 30.4717C6.00896 30.3021 5.73586 30.0347 5.56679 29.7021C5.43674 29.4478 5.40423 29.2065 5.38472 29.0304C5.37172 28.8739 5.37172 28.6913 5.37172 28.5218V25.9784C4.44837 25.4828 3.69408 24.7133 3.2129 23.7742C2.90078 23.1612 2.77073 22.496 2.7057 21.7525C2.66669 21.0352 2.66669 20.1418 2.66669 19.0396V8.89231C2.66669 8.30538 2.66669 7.78367 2.67319 7.31412C2.66669 7.26847 2.66669 7.22282 2.66669 7.17717C2.66669 7.11196 2.66669 7.04675 2.68619 6.98805C2.6927 6.69459 2.7057 6.42721 2.73171 6.1794C2.79023 5.42943 2.92028 4.77077 3.23891 4.15776C3.73309 3.18607 4.5264 2.39698 5.49527 1.90135C6.113 1.58832 6.77625 1.45789 7.52404 1.3992C8.23931 1.33398 9.13665 1.33398 10.2356 1.33398ZM4.84502 8.25973C4.84502 8.47494 4.84502 8.69666 4.84502 8.93796V14.9181H27.155V8.93796C27.155 8.69666 27.155 8.46841 27.155 8.25973H4.84502ZM4.92305 6.0881C4.97507 5.63812 5.0596 5.3577 5.17014 5.13597C5.45625 4.57513 5.91793 4.11863 6.47714 3.83169C6.73724 3.70126 7.08187 3.60996 7.6931 3.55779C8.31734 3.50562 9.12365 3.50562 10.2876 3.50562H21.7124C22.8699 3.50562 23.6762 3.50562 24.3069 3.55779C24.9182 3.60996 25.2628 3.70126 25.5229 3.83169C26.0886 4.11863 26.5438 4.57513 26.8299 5.13597C26.9404 5.35118 27.025 5.6316 27.077 6.0881H4.92305ZM4.84502 17.0962V19.0005C4.84502 20.1613 4.84502 20.9634 4.89704 21.5895C4.94906 22.2025 5.04009 22.5482 5.17014 22.8025C5.45625 23.3633 5.91793 23.8198 6.47714 24.1068C6.73724 24.2372 7.08187 24.3285 7.6931 24.3807C8.31734 24.4328 9.12365 24.4328 10.2876 24.4328H21.7124C22.8699 24.4328 23.6762 24.4328 24.3069 24.3807C24.9182 24.3285 25.2628 24.2372 25.5229 24.1068C26.0886 23.8198 26.5438 23.3633 26.8299 22.8025C26.96 22.5482 27.051 22.2025 27.103 21.5895C27.155 20.9634 27.155 20.1613 27.155 19.0005V17.0962H4.84502ZM20.7761 26.6045V28.5087H24.4305V26.5523C23.7347 26.6045 21.81 26.6045 20.7761 26.6045ZM11.1199 26.6045C10.0795 26.6045 8.25882 26.6045 7.56305 26.5523V28.5087H11.1199V26.6045ZM7.4265 20.7613C7.4265 20.1613 7.91419 19.6722 8.51242 19.6722H10.5542C11.1524 19.6722 11.6401 20.1613 11.6401 20.7613C11.6401 21.3613 11.1524 21.8504 10.5542 21.8504H8.51242C7.91419 21.8504 7.4265 21.3613 7.4265 20.7613ZM20.3469 20.7613C20.3469 20.1613 20.8346 19.6722 21.4328 19.6722H23.4746C24.0729 19.6722 24.5605 20.1613 24.5605 20.7613C24.5605 21.3613 24.0729 21.8504 23.4746 21.8504H21.4328C20.8346 21.8504 20.3469 21.3613 20.3469 20.7613Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const qM = /* @__PURE__ */ g(fC, [["render", gC]]), vC = {}, mC = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function xC(e, t) {
  return l(), s("svg", mC, [...t[0] || (t[0] = [
    o("rect", {
      width: "28",
      height: "28",
      rx: "8",
      fill: "#E0E3FF"
    }, null, -1),
    o("path", {
      d: "M11.707 12.75H12.5407L14.2081 16.0847L15.8754 12.75",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.0023 19.8356H8.99811C7.61682 19.8356 6.49707 18.7158 6.49707 17.3345V10.6651C6.49707 9.28382 7.61682 8.16406 8.99811 8.16406H19.0023C20.3836 8.16406 21.5033 9.28382 21.5033 10.6651V17.3345C21.5033 18.7158 20.3836 19.8356 19.0023 19.8356Z",
      stroke: "#0012FA",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const KM = /* @__PURE__ */ g(vC, [["render", xC]]), wC = {}, kC = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function yC(e, t) {
  return l(), s("svg", kC, [...t[0] || (t[0] = [
    N('<path d="M2.5 7.4987H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 15.8346H5C3.61929 15.8346 2.5 14.7153 2.5 13.3346V6.66797C2.5 5.28726 3.61929 4.16797 5 4.16797H15C16.3807 4.16797 17.5 5.28726 17.5 6.66797V11.668" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.8334 17.5013L17.5 15.8346L15.8334 14.168" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3334 15.8346H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.49996 10.8346H5.41663" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const QM = /* @__PURE__ */ g(wC, [["render", yC]]), bC = {}, _C = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function MC(e, t) {
  return l(), s("svg", _C, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, null, -1),
    o("path", {
      d: "M10 6.667V10M10 13.333h.008",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const XM = /* @__PURE__ */ g(bC, [["render", MC]]), LC = {}, $C = {
  viewBox: "0 0 16.1494 14.7254",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function VC(e, t) {
  return l(), s("svg", $C, [...t[0] || (t[0] = [
    o("path", {
      d: "M8.0749 8.19204V5.42167",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.07416 10.418C7.97193 10.418 7.88897 10.5009 7.88971 10.6031C7.88971 10.7054 7.97267 10.7883 8.0749 10.7883C8.17712 10.7883 8.26008 10.7054 8.26008 10.6031C8.26008 10.5009 8.17712 10.418 8.07416 10.418",
      stroke: "currentColor",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.57786 1.53944L15.2512 11.4683C15.9105 12.6224 15.0771 14.0587 13.7482 14.0587H2.40156C1.07193 14.0587 0.238599 12.6224 0.898599 11.4683L6.57193 1.53944C7.23638 0.375741 8.91341 0.375741 9.57786 1.53944Z",
      stroke: "currentColor",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const JM = /* @__PURE__ */ g(LC, [["render", VC]]), BC = {}, HC = {
  width: "800px",
  height: "800px",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function FC(e, t) {
  return l(), s("svg", HC, [...t[0] || (t[0] = [
    N('<path fill-rule="evenodd" clip-rule="evenodd" d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z" fill="#BFC8D0"></path><path d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" fill="url(#paint0_linear_whatsapp)"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z" fill="white"></path><path d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z" fill="white"></path><defs><linearGradient id="paint0_linear_whatsapp" x1="26.5" y1="7" x2="4" y2="28" gradientUnits="userSpaceOnUse"><stop stop-color="#5BD066"></stop><stop offset="1" stop-color="#27B43E"></stop></linearGradient></defs>', 5)
  ])]);
}
const eL = /* @__PURE__ */ g(BC, [["render", FC]]), tL = /* @__PURE__ */ I({
  __name: "WhatsAppOutlineIcon",
  props: {
    active: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = f(
      () => t.color != null && t.color !== "" ? { color: t.color } : void 0
    );
    return (n, i) => (l(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      class: "block h-5 w-5 shrink-0",
      "aria-hidden": "true",
      style: a1(r.value)
    }, [...i[0] || (i[0] = [
      o("path", {
        d: "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      o("path", {
        d: "M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])], 4));
  }
}), AC = {}, jC = {
  width: "13",
  height: "20",
  viewBox: "0 0 13 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function IC(e, t) {
  return l(), s("svg", jC, [...t[0] || (t[0] = [
    N('<g clip-path="url(#clip0_6209_10390)"><rect x="13" y="5.68249e-07" width="20" height="13" rx="2" transform="rotate(90 13 5.68249e-07)" fill="#0012FA"></rect><path d="M4.83669 6.0004L1.72559 2.43262L2.69032 2.43262L5.80142 6.0004L4.83669 6.0004Z" fill="white"></path><path d="M1.625 5.99973L1.72108 5.93118C1.83377 5.85065 1.94426 5.76898 2.05 5.68846C2.79923 5.13524 3.46244 4.4807 4.01929 3.74491C4.44836 3.14107 4.5824 2.68401 4.39599 2.45589C4.33913 2.39887 4.26955 2.35517 4.19258 2.32814C4.1156 2.30111 4.03326 2.29146 3.95184 2.29992C3.77316 2.30428 3.5958 2.3309 3.42415 2.37913L3.4072 2.38373C3.39682 2.38668 3.38581 2.38688 3.37532 2.38431C3.36483 2.38175 3.35524 2.3765 3.34755 2.36913C3.3365 2.35816 3.33031 2.34345 3.33031 2.32813C3.33031 2.31281 3.3365 2.2981 3.34755 2.28713C3.35122 2.28363 3.35539 2.28065 3.35992 2.27828L3.36297 2.27664L3.38958 2.26434C3.8294 2.04227 4.312 1.91083 4.80693 1.87828C4.91743 1.86787 5.02893 1.8823 5.13272 1.92045C5.23651 1.9586 5.32979 2.01943 5.40529 2.0982C5.63559 2.38077 5.52273 2.89048 5.08756 3.53336C4.59008 4.26867 3.97263 4.921 3.25926 5.46493C3.01338 5.65254 2.76004 5.83048 2.50619 5.99333L2.49636 5.99973H1.625Z" fill="#FFB71A"></path><path d="M4.4106 4.40121C4.24758 4.58334 4.07637 4.75826 3.89697 4.92596L4.22945 5.30181L4.44382 4.44139L4.41145 4.40039H4.4106" fill="#000CAD"></path></g><defs><clipPath id="clip0_6209_10390"><rect x="13" y="5.68249e-07" width="20" height="13" rx="2" transform="rotate(90 13 5.68249e-07)" fill="white"></rect></clipPath></defs>', 2)
  ])]);
}
const oL = /* @__PURE__ */ g(AC, [["render", IC]]), ZC = {}, EC = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function SC(e, t) {
  return l(), s("svg", EC, [...t[0] || (t[0] = [
    o("path", {
      d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const nL = /* @__PURE__ */ g(ZC, [["render", SC]]), zC = {}, DC = {
  viewBox: "0 0 559 556",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-full h-full"
};
function TC(e, t) {
  return l(), s("svg", DC, [...t[0] || (t[0] = [
    o("g", {
      style: { "mix-blend-mode": "soft-light" },
      opacity: "0.3"
    }, [
      o("path", {
        d: "M431.587 556L20.7017 82.3728H148.115L559 556H431.587Z",
        fill: "white"
      }),
      o("path", {
        d: "M361.744 329.562C343.229 354.521 313.495 378.539 293.133 401.551L324.022 432.44L365.541 335.108L361.942 329.478L361.744 329.562Z",
        fill: "white"
      }),
      o("path", {
        d: "M0 555.997L12.747 546.76C27.7036 535.912 42.3878 524.918 56.4189 514.049C155.912 439.481 243.985 351.261 317.94 252.091C374.926 170.778 392.701 109.054 368.047 78.3263C360.503 70.6527 351.278 64.7712 341.071 61.1294C330.864 57.4876 319.946 56.1816 309.147 57.311C285.421 57.8945 261.869 61.4784 239.075 67.9738L236.802 68.5937C235.095 69.0811 233.271 68.9968 231.618 68.3544C229.964 67.7119 228.577 66.5475 227.671 65.0446C226.765 63.5417 226.391 61.7856 226.613 60.0526C226.834 58.3196 227.637 56.7082 228.893 55.4719C229.381 54.9994 229.933 54.5961 230.534 54.2735L230.935 54.0668L234.468 52.4136C292.864 22.511 356.931 4.81578 422.635 0.443461C437.307 -0.961316 452.111 0.982037 465.893 6.12202C479.675 11.262 492.064 19.4596 502.09 30.0757C532.677 68.1596 517.699 136.847 459.913 223.512C393.846 322.628 311.848 410.559 217.114 483.88C184.445 509.173 150.808 533.143 117.108 555.109L115.804 555.956L0 555.997Z",
        fill: "white"
      })
    ], -1)
  ])]);
}
const rL = /* @__PURE__ */ g(zC, [["render", TC]]), OC = {}, PC = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function RC(e, t) {
  return l(), s("svg", PC, [...t[0] || (t[0] = [
    o("path", {
      d: "M13.909 6.95802C14.4843 10.2213 12.305 13.3333 9.04232 13.9087C5.77899 14.484 2.66699 12.3053 2.09165 9.04202C1.51632 5.77868 3.69499 2.66668 6.95832 2.09135C10.2217 1.51602 13.3337 3.69468 13.909 6.95802",
      stroke: "#0012FA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.63028 4.73236C9.791 4.71724 9.95323 4.73795 10.1042 4.7934C10.2552 4.84889 10.3912 4.93754 10.5011 5.05213C10.8361 5.46319 10.6715 6.20491 10.0383 7.14002C9.73846 7.58301 9.40672 8.0035 9.0495 8.40246L11 10.6381H9.59558L8.30704 9.16061C8.01104 9.43748 7.70226 9.70208 7.37793 9.94929C7.02014 10.2222 6.65168 10.4817 6.28229 10.7185L6.26772 10.7276H5L5.13947 10.6277C5.30344 10.5106 5.46439 10.3917 5.61825 10.2746C6.36312 9.72479 7.04732 9.10414 7.6659 8.42604L5.14572 5.53699H6.55013L8.357 7.60823C8.39901 7.55441 8.44278 7.50173 8.48398 7.4473C9.10825 6.569 9.30338 5.90419 9.03215 5.57237C8.94942 5.48947 8.84783 5.42578 8.73586 5.38647C8.62404 5.34728 8.50441 5.3333 8.38615 5.34555C8.12615 5.35188 7.86778 5.39054 7.61802 5.46069L7.59304 5.46763C7.57811 5.47181 7.56232 5.47197 7.54724 5.46832C7.53198 5.46459 7.51749 5.45685 7.5063 5.44613C7.49035 5.4302 7.48132 5.40866 7.48132 5.38647C7.48137 5.36427 7.49028 5.34272 7.5063 5.32682C7.51157 5.32179 7.51784 5.31776 7.52434 5.31433L7.5292 5.31156L7.56806 5.29352C8.20796 4.97062 8.91022 4.77969 9.63028 4.73236Z",
      fill: "#0012FA"
    }, null, -1)
  ])]);
}
const lL = /* @__PURE__ */ g(OC, [["render", RC]]), NC = {}, GC = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function UC(e, t) {
  return l(), s("svg", GC, [...t[0] || (t[0] = [
    o("path", {
      d: "M13.909 6.95802C14.4843 10.2213 12.305 13.3333 9.04232 13.9087C5.77899 14.484 2.66699 12.3053 2.09165 9.04202C1.51632 5.77868 3.69499 2.66668 6.95832 2.09135C10.2217 1.51602 13.3337 3.69468 13.909 6.95802",
      stroke: "#1DC37B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.63028 4.73236C9.791 4.71724 9.95323 4.73795 10.1042 4.7934C10.2552 4.84889 10.3912 4.93754 10.5011 5.05213C10.8361 5.46319 10.6715 6.20491 10.0383 7.14002C9.73846 7.58301 9.40672 8.0035 9.0495 8.40246L11 10.6381H9.59558L8.30704 9.16061C8.01104 9.43748 7.70226 9.70208 7.37793 9.94929C7.02014 10.2222 6.65168 10.4817 6.28229 10.7185L6.26772 10.7276H5L5.13947 10.6277C5.30344 10.5106 5.46439 10.3917 5.61825 10.2746C6.36312 9.72479 7.04732 9.10414 7.6659 8.42604L5.14572 5.53699H6.55013L8.357 7.60823C8.39901 7.55441 8.44278 7.50173 8.48398 7.4473C9.10825 6.569 9.30338 5.90419 9.03215 5.57237C8.94942 5.48947 8.84783 5.42578 8.73586 5.38647C8.62404 5.34728 8.50441 5.3333 8.38615 5.34555C8.12615 5.35188 7.86778 5.39054 7.61802 5.46069L7.59304 5.46763C7.57811 5.47181 7.56232 5.47197 7.54724 5.46832C7.53198 5.46459 7.51749 5.45685 7.5063 5.44613C7.49035 5.4302 7.48132 5.40866 7.48132 5.38647C7.48137 5.36427 7.49028 5.34272 7.5063 5.32682C7.51157 5.32179 7.51784 5.31776 7.52434 5.31433L7.5292 5.31156L7.56806 5.29352C8.20796 4.97062 8.91022 4.77969 9.63028 4.73236Z",
      fill: "#1DC37B"
    }, null, -1)
  ])]);
}
const sL = /* @__PURE__ */ g(NC, [["render", UC]]), WC = {}, YC = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function qC(e, t) {
  return l(), s("svg", YC, [...t[0] || (t[0] = [
    N('<path d="M3.99839 5.499H1.99756V3.49817" stroke="#0012FA" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.97656 13.2849C5.57681 13.6324 6.24176 13.8785 6.95005 14.0025" stroke="#0012FA" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.0498 14.0025C9.7581 13.8785 10.4224 13.6324 11.0233 13.2849" stroke="#0012FA" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.6338 11.937C13.0833 11.4015 13.4368 10.7859 13.6809 10.1163" stroke="#0012FA" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.0024 8.00006C14.0024 4.68468 11.3153 1.99756 7.99994 1.99756C5.57894 1.99756 3.4974 3.43416 2.54834 5.49902" stroke="#0012FA" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.63028 4.73236C9.791 4.71724 9.95323 4.73795 10.1042 4.7934C10.2552 4.84889 10.3912 4.93754 10.5011 5.05213C10.8361 5.46319 10.6715 6.20491 10.0383 7.14002C9.73846 7.58301 9.40672 8.0035 9.0495 8.40246L11 10.6381H9.59558L8.30704 9.16061C8.01104 9.43748 7.70226 9.70208 7.37793 9.94929C7.02014 10.2222 6.65168 10.4817 6.28229 10.7185L6.26772 10.7276H5L5.13947 10.6277C5.30344 10.5106 5.46439 10.3917 5.61825 10.2746C6.36312 9.72479 7.04732 9.10414 7.6659 8.42604L5.14572 5.53699H6.55013L8.357 7.60823C8.39901 7.55441 8.44278 7.50173 8.48398 7.4473C9.10825 6.569 9.30338 5.90419 9.03215 5.57237C8.94942 5.48947 8.84783 5.42578 8.73586 5.38647C8.62404 5.34728 8.50441 5.3333 8.38615 5.34555C8.12615 5.35188 7.86778 5.39054 7.61802 5.46069L7.59304 5.46763C7.57811 5.47181 7.56232 5.47197 7.54724 5.46832C7.53198 5.46459 7.51749 5.45685 7.5063 5.44613C7.49035 5.4302 7.48132 5.40866 7.48132 5.38647C7.48137 5.36427 7.49028 5.34272 7.5063 5.32682C7.51157 5.32179 7.51784 5.31776 7.52434 5.31433L7.5292 5.31156L7.56806 5.29352C8.20796 4.97062 8.91022 4.77969 9.63028 4.73236Z" fill="#0012FA"></path>', 6)
  ])]);
}
const iL = /* @__PURE__ */ g(WC, [["render", qC]]), KC = {}, QC = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function XC(e, t) {
  return l(), s("svg", QC, [...t[0] || (t[0] = [
    N('<g filter="url(#filter0_d_4239_79624)"><rect x="1.11401" y="1.13672" width="23.0476" height="29.7931" rx="4.6581" fill="white"></rect><rect x="1.02613" y="1.04883" width="23.2234" height="29.9689" rx="4.74599" stroke="#F2F3F7" stroke-width="0.175777"></rect></g><rect x="9.42847" y="22.0703" width="12.5714" height="6.62069" rx="1.74182" fill="#1DC37B"></rect><path d="M11.5249 26.646V26.1429H11.9694V26.646H11.5249Z" fill="#F9F9FB"></path><path d="M14.4688 26.646H14.0335L13.3231 25.5829L12.6128 26.646H12.182L13.0894 25.3171L12.2599 24.0831H12.6953L13.3277 25.0323L13.9693 24.0831H14.4001L13.5568 25.2981L14.4688 26.646Z" fill="#F9F9FB"></path><path d="M14.7516 26.646V23.1719H15.1411V26.646H14.7516Z" fill="#F9F9FB"></path><path d="M16.5704 26.7029C15.9837 26.7029 15.6034 26.3802 15.5805 25.8629H15.9654C15.9837 26.1666 16.2358 26.3327 16.5841 26.3327C16.9232 26.3327 17.1661 26.1808 17.1661 25.9341C17.1661 25.6303 16.8591 25.5734 16.5245 25.5164C16.1029 25.4405 15.6263 25.3503 15.6263 24.7713C15.6263 24.3299 16.0021 24.0309 16.5612 24.0309C17.1203 24.0309 17.4778 24.3394 17.4915 24.8235H17.1249C17.1111 24.5435 16.9003 24.3916 16.552 24.3916C16.2175 24.3916 16.0067 24.534 16.0067 24.757C16.0067 25.0276 16.2908 25.0798 16.6208 25.132C17.047 25.2032 17.5511 25.2886 17.5511 25.9151C17.5511 26.3944 17.157 26.7029 16.5704 26.7029Z" fill="#F9F9FB"></path><path d="M19.9059 26.646H19.4705L18.7601 25.5829L18.0498 26.646H17.619L18.5264 25.3171L17.6969 24.0831H18.1323L18.7647 25.0323L19.4063 24.0831H19.8371L18.9939 25.2981L19.9059 26.646Z" fill="#F9F9FB"></path><path d="M20.6373 15.4485C20.8107 15.4487 20.9512 15.5967 20.9514 15.7794V16.2212C20.9512 16.4038 20.8107 16.5519 20.6373 16.552H4.50353C4.33012 16.5519 4.18956 16.4038 4.18945 16.2212V15.7794C4.18956 15.5967 4.33012 15.4487 4.50353 15.4485L20.6373 15.4485Z" fill="#E2E4EE"></path><path d="M13.3039 12.1382C13.4774 12.1383 13.6179 12.2864 13.618 12.469V12.9108C13.6179 13.0935 13.4774 13.2415 13.3039 13.2416H4.50353C4.33012 13.2415 4.18956 13.0935 4.18945 12.9108L4.18945 12.469C4.18956 12.2864 4.33012 12.1383 4.50353 12.1382H13.3039Z" fill="#E2E4EE"></path><path d="M20.6373 12.1382C20.8107 12.1383 20.9512 12.2864 20.9514 12.469V12.9108C20.9512 13.0935 20.8107 13.2415 20.6373 13.2416L14.9797 13.2416C14.8063 13.2415 14.6658 13.0935 14.6656 12.9108V12.469C14.6658 12.2864 14.8063 12.1383 14.9797 12.1382H20.6373Z" fill="#E2E4EE"></path><path d="M13.3039 8.82786C13.4774 8.82797 13.6179 8.97602 13.618 9.15867V9.60048C13.6179 9.78314 13.4774 9.93119 13.3039 9.9313H4.50353C4.33012 9.93119 4.18956 9.78314 4.18945 9.60048V9.15867C4.18956 8.97602 4.33012 8.82797 4.50353 8.82786H13.3039Z" fill="#E2E4EE"></path><path d="M20.6373 8.82786C20.8107 8.82797 20.9512 8.97602 20.9514 9.15867V9.60048C20.9512 9.78314 20.8107 9.93119 20.6373 9.9313H14.9797C14.8063 9.93119 14.6658 9.78314 14.6656 9.60048V9.15867C14.6658 8.97602 14.8063 8.82797 14.9797 8.82786H20.6373Z" fill="#E2E4EE"></path><path d="M15.3992 4.41406C15.5726 4.41418 15.7132 4.56223 15.7133 4.74488V6.29014C15.7132 6.47279 15.5726 6.62084 15.3992 6.62096H4.50353C4.33012 6.62084 4.18956 6.47279 4.18945 6.29014V4.74488C4.18956 4.56223 4.33012 4.41418 4.50353 4.41406L15.3992 4.41406Z" fill="#E2E4EE"></path><defs><filter id="filter0_d_4239_79624" x="0.152518" y="0.960938" width="24.9706" height="31.716" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="0.785714"></feOffset><feGaussianBlur stdDeviation="0.392857"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0 0.806396 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4239_79624"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4239_79624" result="shape"></feBlend></filter></defs>', 14)
  ])]);
}
const aL = /* @__PURE__ */ g(KC, [["render", XC]]), JC = {
  class: "relative h-[61px] w-[74.309px] shrink-0 shadow-[0px_5.176px_6.655px_0px_rgba(87,99,255,0.4)]",
  "aria-hidden": "true"
}, eg = { class: "absolute left-0 top-0 h-[61px] w-[74.309px]" }, tg = ["src"], og = { class: "absolute left-0 top-[9.98px] h-[51.018px] w-[74.309px]" }, ng = ["src"], rg = { class: "absolute inset-[69.03%_74.64%_7.37%_5.99%] rounded-[inherit] shadow-[inset_0px_0.144px_0.288px_0px_rgba(87,99,255,0.8)]" }, lg = { class: "absolute inset-[9.38%_17.71%_9.36%_17.71%]" }, sg = ["src"], dL = /* @__PURE__ */ I({
  __name: "SpreadsheetFolderEmptyIllustration",
  setup(e) {
    const t = new URL("data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20width='100%25'%20height='100%25'%20overflow='visible'%20style='display:%20block;'%20viewBox='0%200%2074.3091%2061'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Rectangle%2016'%3e%3cpath%20d='M0%209.98181C0%207.94003%201.65519%206.28485%203.69697%206.28485H39.3077C40.185%206.28485%2041.0337%205.9729%2041.7021%205.40475L47.0252%200.880103C47.6936%200.311952%2048.5423%200%2049.4195%200H70.6121C72.6539%200%2074.3091%201.65519%2074.3091%203.69697V57.303C74.3091%2059.3448%2072.6539%2061%2070.6121%2061H3.69697C1.65519%2061%200%2059.3448%200%2057.303V9.98181Z'%20fill='var(--fill-0,%20%235763FF)'/%3e%3cpath%20d='M49.4199%200.18457H70.6123C72.5519%200.184667%2074.124%201.75763%2074.124%203.69727V57.3027C74.124%2059.2424%2072.5519%2060.8153%2070.6123%2060.8154H3.69727C1.75757%2060.8154%200.18457%2059.2424%200.18457%2057.3027V9.98145C0.184769%208.04192%201.7577%206.46973%203.69727%206.46973H39.3076C40.2287%206.46973%2041.1204%206.14246%2041.8223%205.5459L47.1445%201.02051C47.7795%200.480763%2048.5865%200.18457%2049.4199%200.18457Z'%20stroke='var(--stroke-0,%20%231627FF)'%20stroke-opacity='0.4'%20stroke-width='0.369697'/%3e%3c/g%3e%3c/svg%3e", import.meta.url).href, r = new URL("data:image/svg+xml;base64,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", import.meta.url).href, n = new URL("data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20width='100%25'%20height='100%25'%20overflow='visible'%20style='display:%20block;'%20viewBox='0%200%209.29602%2011.6947'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group'%3e%3cg%20id='Union'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.44641%204.79758C7.02587%204.79758%207.49622%205.26794%207.49622%205.84739V8.84604C7.49609%209.42539%207.02579%209.89504%206.44641%209.89504H4.65641C4.65373%209.89509%204.65105%209.89585%204.64835%209.89585C4.64565%209.89585%204.64297%209.89509%204.64029%209.89504H2.84868C2.2693%209.89504%201.79899%209.42539%201.79887%208.84604V5.84739C1.79887%205.26794%202.26922%204.79758%202.84868%204.79758H6.44641ZM5.09827%207.79704V8.99601H6.44641C6.52896%208.99601%206.59626%208.92856%206.59638%208.84604V7.79704H5.09827ZM2.6987%208.84604C2.69883%208.92856%202.76612%208.99601%202.84868%208.99601H4.19843V7.79704H2.6987V8.84604ZM5.09827%206.8972H6.59638V5.84739C6.59638%205.76476%206.52904%205.69742%206.44641%205.69742H5.09827V6.8972ZM2.84868%205.69742C2.76604%205.69742%202.6987%205.76476%202.6987%205.84739V6.8972H4.19843V5.69742H2.84868Z'%20fill='var(--fill-0,%20%23FAFAFF)'%20fill-opacity='0.7'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.95053%206.44966e-05C6.3877%206.601e-05%206.80732%200.174034%207.11645%200.483041L8.81292%202.17951C9.12192%202.48864%209.29589%202.90826%209.29589%203.34543V10.0458C9.2957%2010.9568%208.55717%2011.6947%207.64619%2011.6947H1.6497C0.738721%2011.6947%200.000193881%2010.9568%200%2010.0458V1.64977C0%200.738666%200.738602%206.44966e-05%201.6497%206.44966e-05H5.95053ZM1.6497%200.899901C1.23542%200.899901%200.899837%201.23549%200.899837%201.64977V10.0458C0.90003%2010.4599%201.23554%2010.7949%201.6497%2010.7949H7.64619C8.06035%2010.7949%208.39586%2010.4599%208.39606%2010.0458V3.89855H6.44722C5.86776%203.89855%205.39741%203.4282%205.39741%202.84874V0.899901H1.6497ZM6.29724%202.84874C6.29724%202.93137%206.36458%202.99871%206.44722%202.99871H8.31059C8.27572%202.93191%208.23098%202.86997%208.17674%202.81568L6.48028%201.11922C6.42589%201.06488%206.36417%201.01946%206.29724%200.984563V2.84874Z'%20fill='var(--fill-0,%20%23FAFAFF)'%20fill-opacity='0.7'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", import.meta.url).href;
    return (i, a) => (l(), s("div", JC, [
      o("div", eg, [
        o("img", {
          src: D(t),
          alt: "",
          class: "absolute inset-0 block size-full max-w-none"
        }, null, 8, tg)
      ]),
      a[0] || (a[0] = N('<div class="absolute left-[55.08px] top-[4.43px] h-[1.479px] w-[7.394px] rounded-[0.37px] bg-royal-300"></div><div class="absolute left-[64.33px] top-[4.43px] h-[1.479px] w-[4.806px] rounded-[0.37px] bg-[#000fcc]"></div><div class="absolute flex items-center justify-center inset-[-10.17px_12.23px_4.26px_5.37px]"><div class="h-[57.673px] w-[43.255px] shrink-0 -rotate-[15deg]"><div class="size-full rounded-[3.697px] bg-royal-50"></div></div></div><div class="absolute flex items-center justify-center inset-[-12.01px_7.48px_10.68px_17.13px]"><div class="h-[57.673px] w-[43.255px] shrink-0 rotate-[6.71deg]"><div class="size-full rounded-[3.697px] bg-white"></div></div></div>', 4)),
      o("div", og, [
        o("img", {
          src: D(r),
          alt: "",
          class: "absolute inset-0 block size-full max-w-none"
        }, null, 8, ng)
      ]),
      o("div", rg, [
        o("div", lg, [
          o("img", {
            src: D(n),
            alt: "",
            class: "block size-full max-w-none"
          }, null, 8, sg)
        ])
      ])
    ]));
  }
}), ig = {
  class: "relative h-[74px] w-[90px] shrink-0 shadow-[0px_5.176px_6.655px_0px_#99a0ff]",
  "aria-hidden": "true"
}, ag = { class: "absolute left-[7.85px] top-[12.5px] h-[61px] w-[74.309px]" }, dg = ["src"], ug = { class: "absolute left-[7.85px] top-[22.48px] h-[51.018px] w-[74.309px]" }, cg = ["src"], hg = { class: "absolute inset-[71.62%_63.89%_10.81%_16.11%] rounded-[inherit] shadow-[inset_0px_0.144px_0.288px_0px_#1dc37b]" }, pg = { class: "absolute inset-[7.69%_5.56%_7.69%_5.55%]" }, fg = { class: "absolute inset-[-9.09%_-6.25%]" }, Cg = ["src"], uL = /* @__PURE__ */ I({
  __name: "SpreadsheetFolderSuccessIllustration",
  setup(e) {
    const t = new URL("data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20width='100%25'%20height='100%25'%20overflow='visible'%20style='display:%20block;'%20viewBox='0%200%2074.3091%2061'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Rectangle%2016'%20d='M49.4199%200.18457H70.6123C72.5519%200.184667%2074.124%201.75763%2074.124%203.69727V57.3027C74.124%2059.2424%2072.5519%2060.8153%2070.6123%2060.8154H3.69727C1.75757%2060.8154%200.18457%2059.2424%200.18457%2057.3027V9.98145C0.184769%208.04192%201.7577%206.46973%203.69727%206.46973H39.3076C40.2287%206.46973%2041.1204%206.14246%2041.8223%205.5459L47.1445%201.02051C47.7795%200.480763%2048.5865%200.18457%2049.4199%200.18457Z'%20fill='var(--fill-0,%20%235763FF)'%20stroke='var(--stroke-0,%20%230012FA)'%20stroke-width='0.369697'/%3e%3c/svg%3e", import.meta.url).href, r = new URL("data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgdmlld0JveD0iMCAwIDc0LjMwOTEgNTEuMDE4MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGZvcmVpZ25PYmplY3QgeD0iLTMuMzI3MjciIHk9Ii0zLjMyNzI3IiB3aWR0aD0iODAuOTYzNiIgaGVpZ2h0PSI1Ny42NzI3Ij48ZGl2IHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hodG1sIiBzdHlsZT0iYmFja2Ryb3AtZmlsdGVyOmJsdXIoMS42NnB4KTtjbGlwLXBhdGg6dXJsKCNiZ2JsdXJfMF8wXzZfY2xpcF9wYXRoKTtoZWlnaHQ6MTAwJTt3aWR0aDoxMDAlIj48L2Rpdj48L2ZvcmVpZ25PYmplY3Q+PHBhdGggaWQ9IlJlY3RhbmdsZSAxNyIgZGF0YS1maWdtYS1iZy1ibHVyLXJhZGl1cz0iMy4zMjcyNyIgZD0iTTMuNjk3MjcgMC4xODQ1N0gyMC4wMzYxQzIxLjUxNTIgMC4xODQ2MSAyMi45NTgyIDAuNjQwMTA4IDI0LjE2OTkgMS40ODgyOEwyOS41OTM4IDUuMjg0MThDMzAuODY3NSA2LjE3NTgyIDMyLjM4NDYgNi42NTQyMiAzMy45Mzk1IDYuNjU0M0g3MC42MTIzQzcyLjU1MTkgNi42NTQzOSA3NC4xMjQgOC4yMjczNiA3NC4xMjQgMTAuMTY3VjQ3LjMyMTNDNzQuMTI0IDQ5LjI2MDkgNzIuNTUxOSA1MC44MzI5IDcwLjYxMjMgNTAuODMzSDMuNjk3MjdDMS43NTc2IDUwLjgzMyAwLjE4NDYxMSA0OS4yNjA5IDAuMTg0NTcgNDcuMzIxM1YzLjY5NzI3QzAuMTg0NTcgMS43NTc1NyAxLjc1NzU3IDAuMTg0NTcgMy42OTcyNyAwLjE4NDU3WiIgZmlsbD0idmFyKC0tZmlsbC0wLCAjNTc2M0ZGKSIgZmlsbC1vcGFjaXR5PSIwLjM0IiBzdHJva2U9InZhcigtLXN0cm9rZS0wLCAjMDAxMkZBKSIgc3Ryb2tlLXdpZHRoPSIwLjM2OTY5NyIvPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJiZ2JsdXJfMF8wXzZfY2xpcF9wYXRoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjMyNzI3IDMuMzI3MjcpIj48cGF0aCBkPSJNMy42OTcyNyAwLjE4NDU3SDIwLjAzNjFDMjEuNTE1MiAwLjE4NDYxIDIyLjk1ODIgMC42NDAxMDggMjQuMTY5OSAxLjQ4ODI4TDI5LjU5MzggNS4yODQxOEMzMC44Njc1IDYuMTc1ODIgMzIuMzg0NiA2LjY1NDIyIDMzLjkzOTUgNi42NTQzSDcwLjYxMjNDNzIuNTUxOSA2LjY1NDM5IDc0LjEyNCA4LjIyNzM2IDc0LjEyNCAxMC4xNjdWNDcuMzIxM0M3NC4xMjQgNDkuMjYwOSA3Mi41NTE5IDUwLjgzMjkgNzAuNjEyMyA1MC44MzNIMy42OTcyN0MxLjc1NzYgNTAuODMzIDAuMTg0NjExIDQ5LjI2MDkgMC4xODQ1NyA0Ny4zMjEzVjMuNjk3MjdDMC4xODQ1NyAxLjc1NzU3IDEuNzU3NTcgMC4xODQ1NyAzLjY5NzI3IDAuMTg0NTdaIi8+CjwvY2xpcFBhdGg+PC9kZWZzPgo8L3N2Zz4K", import.meta.url).href, n = new URL("data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20width='100%25'%20height='100%25'%20overflow='visible'%20style='display:%20block;'%20viewBox='0%200%2018%2013'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group'%3e%3cpath%20id='Path'%20d='M17%201L6%2012L1%207'%20stroke='var(--stroke-0,%20white)'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", import.meta.url).href;
    return (i, a) => (l(), s("div", ig, [
      o("div", ag, [
        o("img", {
          src: D(t),
          alt: "",
          class: "absolute inset-0 block size-full max-w-none"
        }, null, 8, dg)
      ]),
      a[0] || (a[0] = N('<div class="absolute left-[62.93px] top-[16.93px] h-[1.479px] w-[7.394px] rounded-[0.37px] bg-royal-300"></div><div class="absolute left-[72.17px] top-[16.93px] h-[1.479px] w-[4.806px] rounded-[0.37px] bg-royal-500"></div><div class="absolute flex items-center justify-center inset-[2.33px_20.08px_4.76px_13.21px]"><div class="h-[57.673px] w-[43.255px] shrink-0 -rotate-[15deg]"><div class="size-full rounded-[3.697px] border-[0.5px] border-solid border-grey-100 bg-white"></div></div></div><div class="absolute flex items-center justify-center inset-[0.49px_15.33px_11.18px_24.98px]"><div class="h-[57.673px] w-[43.255px] shrink-0 rotate-[6.71deg]"><div class="size-full rounded-[3.697px] border-[0.5px] border-solid border-grey-100 bg-white shadow-[-1px_4px_6px_0px_rgba(0,0,0,0.15)]"></div></div></div>', 4)),
      o("div", ug, [
        o("img", {
          src: D(r),
          alt: "",
          class: "absolute inset-0 block size-full max-w-none"
        }, null, 8, cg)
      ]),
      o("div", hg, [
        o("div", pg, [
          o("div", fg, [
            o("img", {
              src: D(n),
              alt: "",
              class: "block size-full max-w-none"
            }, null, 8, Cg)
          ])
        ])
      ])
    ]));
  }
}), gg = { class: "desktop:hidden z-[200] fixed inset-0 bg-gradient-to-br from-royal-500 to-royal-950 flex flex-col items-center justify-start p-9 overflow-y-auto" }, vg = { class: "w-20 h-8" }, mg = ["src"], xg = { class: "relative flex flex-col w-96 h-full items-center justify-start" }, wg = { class: "absolute flex flex-col items-center justify-start bottom-1/7" }, kg = { class: "text-2xl text-white text-center" }, yg = { class: "text-white text-center text-xs mt-2" }, cL = /* @__PURE__ */ I({
  __name: "EcxSmallScreenBanner",
  props: {
    title: { default: "Ops! Tela muito pequena" },
    message: { default: "Detectamos que sua tela é menor que o recomendado. Para uma melhor experiência, acesse em um dispositivo com tela maior." },
    exitButtonText: { default: "Sair" },
    logoSrc: {},
    exitUrl: { default: window.location.href }
  },
  emits: ["exit"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = () => {
      n("exit"), window.close(), window.location.href = r.exitUrl;
    };
    return (a, d) => (l(), s("div", gg, [
      o("div", vg, [
        G(a.$slots, "logo", {}, () => [
          e.logoSrc ? (l(), s("img", {
            key: 0,
            src: e.logoSrc,
            alt: "Logo",
            class: "h-full w-full object-contain"
          }, null, 8, mg)) : x("", !0)
        ])
      ]),
      o("div", xg, [
        J(D(th), { class: "w-full h-3/4" }),
        o("div", wg, [
          o("h1", kg, M(e.title), 1),
          o("p", yg, M(e.message), 1),
          o("button", {
            onClick: i,
            class: "bg-white w-20 px-4 h-14 text-grey-950 text-xs rounded-lg font-medium flex items-center justify-center gap-2 mt-8 hover:bg-grey-50 transition-colors border border-grey-200"
          }, [
            J(D(T9), { class: "w-5 h-5" }),
            h1(" " + M(e.exitButtonText), 1)
          ])
        ])
      ])
    ]));
  }
}), bg = { class: "nav-icon inline-flex size-4 shrink-0 items-center justify-center" }, _g = {
  key: 0,
  class: "nav-label min-w-0 flex-1 truncate"
}, Mg = ["href", "aria-current", "onClick"], Lg = { class: "nav-icon inline-flex size-4 shrink-0 items-center justify-center" }, $g = {
  key: 0,
  class: "nav-label min-w-0 flex-1 truncate"
}, Vg = "bg-royal-25 text-royal-500", Bg = "bg-white text-subtitle-gray hover:bg-border-gray", Hg = "opacity-10 cursor-not-allowed text-white bg-primary", Fg = /* @__PURE__ */ I({
  __name: "EcxNavItem",
  props: {
    to: {},
    label: {},
    query: {},
    disabled: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !0 },
    disabledMessage: {},
    activeOnPathPrefix: { type: Boolean },
    activePathPrefixExclusions: {}
  },
  emits: ["disabled-click"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(null), a = E(!1), d = E({ top: 0, left: 0 }), u = St();
    function h(H) {
      if (r.activeOnPathPrefix && typeof r.to == "string") {
        const L = r.to.replace(/\?.*$/, ""), F = r.activePathPrefixExclusions ?? [];
        for (const P of F) {
          const Z = P.replace(/\?.*$/, "");
          if (u.path === Z || u.path.startsWith(`${Z}/`))
            return !1;
        }
        return u.path === L || u.path.startsWith(`${L}/`);
      }
      return H;
    }
    const C = f(() => typeof r.to == "string" ? { path: r.to, query: r.query } : { ...r.to, query: { ...r.to.query, ...r.query } }), m = f(() => ({
      position: "fixed",
      top: `${d.value.top}px`,
      left: `${d.value.left}px`,
      zIndex: 9999
    })), c = f(() => [
      "flex items-center gap-x-4 rounded-lg text-sm font-medium transition-colors duration-200 self-stretch",
      r.expanded ? "w-full min-w-0 justify-start px-3 py-3" : "w-14 h-14 shrink-0 justify-center"
    ]), p = () => {
      n("disabled-click", r.disabledMessage);
    }, k = () => {
      if (!r.expanded && i.value) {
        const H = i.value.getBoundingClientRect();
        d.value = {
          top: H.top + H.height / 2,
          left: H.right + 8
        }, a.value = !0;
      }
    }, j = () => {
      a.value = !1;
    };
    return (H, L) => (l(), s("div", {
      ref_key: "navItemRef",
      ref: i,
      class: v([
        "ecx-nav-item group relative min-w-0",
        e.expanded ? "w-full" : "flex w-full justify-center"
      ]),
      onMouseenter: k,
      onMouseleave: j
    }, [
      e.disabled ? (l(), s("a", {
        key: 0,
        href: "javascript:void(0)",
        class: v([c.value, Hg]),
        onClick: p,
        "aria-disabled": !0
      }, [
        o("span", bg, [
          G(H.$slots, "default", { isActive: !1 }, void 0, !0)
        ]),
        J(p1, { name: "slide-fade" }, {
          default: Y(() => [
            e.expanded ? (l(), s("span", _g, M(e.label), 1)) : x("", !0)
          ]),
          _: 1
        })
      ], 2)) : (l(), W(D(zt), {
        key: 1,
        to: C.value,
        custom: ""
      }, {
        default: Y(({ isActive: F, href: P, navigate: Z }) => [
          o("a", {
            href: P,
            class: v([c.value, h(F) ? Vg : Bg]),
            "aria-current": h(F) ? "page" : void 0,
            onClick: Z
          }, [
            o("span", Lg, [
              G(H.$slots, "default", {
                isActive: h(F)
              }, void 0, !0)
            ]),
            J(p1, { name: "slide-fade" }, {
              default: Y(() => [
                e.expanded ? (l(), s("span", $g, M(e.label), 1)) : x("", !0)
              ]),
              _: 1
            })
          ], 10, Mg)
        ]),
        _: 3
      }, 8, ["to"])),
      (l(), W(g1, { to: "body" }, [
        J(p1, { name: "tooltip" }, {
          default: Y(() => [
            !e.expanded && e.label && a.value ? (l(), s("div", {
              key: 0,
              class: "ecx-nav-tooltip",
              style: a1(m.value),
              role: "tooltip"
            }, [
              h1(M(e.label) + " ", 1),
              L[0] || (L[0] = o("div", { class: "tooltip-arrow" }, null, -1))
            ], 4)) : x("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), hL = /* @__PURE__ */ g(Fg, [["__scopeId", "data-v-438ab6bc"]]), Ag = ["aria-expanded"], jg = {
  key: 0,
  class: "ecx-sidebar-footer"
}, Ig = /* @__PURE__ */ I({
  __name: "EcxSidebar",
  props: {
    expanded: { type: Boolean, default: !0 }
  },
  setup(e, { expose: t }) {
    return t({
      // Métodos ou refs que queira expor
    }), (r, n) => (l(), s("aside", {
      class: v([
        "ecx-sidebar",
        "flex shrink-0 flex-col bg-white border-r border-border-gray py-2 relative overflow-visible",
        "transition-[width,padding-left,padding-right] duration-300 ease-out",
        e.expanded ? "w-72 px-8" : "w-24 px-2"
      ]),
      "aria-expanded": e.expanded
    }, [
      n[2] || (n[2] = o("div", {
        class: "absolute top-0 right-0 w-px bg-border-gray",
        style: { height: "calc(100% + 8px)", transform: "translateY(-8px)" }
      }, null, -1)),
      o("div", {
        class: v(["ecx-sidebar-header relative", e.expanded ? "-mx-8" : "-mx-2"])
      }, [
        n[1] || (n[1] = o("div", {
          class: "absolute -bottom-2 left-0 h-px bg-border-gray",
          style: { right: "-1px" }
        }, null, -1)),
        o("div", {
          class: v(["flex items-center justify-center", e.expanded ? "px-8" : "px-6"])
        }, [
          G(r.$slots, "logo", { expanded: e.expanded }, () => [
            n[0] || (n[0] = o("div", { class: "w-10 h-10 bg-primary rounded-lg flex items-center justify-center" }, [
              o("span", { class: "text-white font-bold text-lg" }, "E")
            ], -1))
          ], !0)
        ], 2)
      ], 2),
      o("nav", {
        class: v([
          "ecx-sidebar-nav flex-1 flex flex-col gap-y-4 pt-6 overflow-y-auto w-full",
          e.expanded ? "items-stretch" : "items-center"
        ])
      }, [
        G(r.$slots, "default", { expanded: e.expanded }, void 0, !0)
      ], 2),
      r.$slots.footer ? (l(), s("div", jg, [
        G(r.$slots, "footer", { expanded: e.expanded }, void 0, !0)
      ])) : x("", !0)
    ], 10, Ag));
  }
}), pL = /* @__PURE__ */ g(Ig, [["__scopeId", "data-v-0b1b7057"]]), Zg = { class: "ecx-toolbar bg-white sticky top-0 z-[100] relative" }, Eg = { class: "flex items-center justify-between px-4 py-2 h-14" }, Sg = { class: "flex items-center gap-x-3" }, zg = ["aria-label", "aria-expanded"], Dg = {
  key: 0,
  class: "flex-1 flex items-center justify-center px-4"
}, Tg = { class: "flex items-center gap-5" }, Og = {
  key: 0,
  class: "relative shrink-0"
}, Pg = ["aria-expanded", "aria-label"], Rg = { class: "px-4 py-3 border-b border-border-gray" }, Ng = { class: "font-medium text-default-black truncate" }, Gg = { class: "text-sm text-subtitle-gray truncate" }, Ug = {
  key: 0,
  class: "py-1"
}, Wg = /* @__PURE__ */ I({
  __name: "EcxToolbar",
  props: {
    showToggle: { type: Boolean, default: !0 },
    toggleLabel: { default: "Toggle sidebar" },
    sidebarExpanded: { type: Boolean, default: !0 },
    showProfile: { type: Boolean, default: !0 },
    showProfileMenuItems: { type: Boolean, default: !0 },
    userName: { default: "" },
    userEmail: { default: "" },
    avatarUrl: {},
    profileMenuLabel: { default: "Menu do perfil" }
  },
  emits: ["toggle", "logout", "settings"],
  setup(e, { emit: t }) {
    const r = t, n = E(!1), i = () => {
      r("toggle");
    }, a = () => {
      n.value = !n.value;
    }, d = () => {
      n.value = !1, r("settings");
    }, u = () => {
      n.value = !1, r("logout");
    }, h = (C) => {
      C.target.closest(".relative") || (n.value = !1);
    };
    return m1(() => {
      document.addEventListener("click", h);
    }), y1(() => {
      document.removeEventListener("click", h);
    }), (C, m) => (l(), s("header", Zg, [
      m[1] || (m[1] = o("div", { class: "absolute bottom-0 left-0 right-0 h-px bg-border-gray" }, null, -1)),
      o("div", Eg, [
        o("div", Sg, [
          e.showToggle ? (l(), s("button", {
            key: 0,
            onClick: i,
            class: v([
              "flex items-center justify-center w-10 h-10 transition-all duration-200",
              e.sidebarExpanded ? "rounded-xl bg-royal-25 shadow-[inset_0px_2px_1px_0px_rgba(199,203,255,1.00)] outline outline-1 outline-offset-[-1px] outline-royal-50" : "rounded-lg hover:bg-grey-50"
            ]),
            "aria-label": e.toggleLabel,
            "aria-expanded": e.sidebarExpanded
          }, [
            G(C.$slots, "toggle-icon", { expanded: e.sidebarExpanded }, () => [
              J(e9, {
                class: v(["w-5 h-5", e.sidebarExpanded ? "text-primary" : "text-subtitle-gray"])
              }, null, 8, ["class"])
            ], !0)
          ], 10, zg)) : x("", !0),
          G(C.$slots, "left", {}, void 0, !0)
        ]),
        C.$slots.center ? (l(), s("div", Dg, [
          G(C.$slots, "center", {}, void 0, !0)
        ])) : x("", !0),
        o("div", Tg, [
          G(C.$slots, "right", {}, void 0, !0),
          e.showProfile ? (l(), s("div", Og, [
            o("button", {
              type: "button",
              onClick: a,
              class: "flex shrink-0 items-center justify-center rounded-xl transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-200",
              "aria-expanded": n.value,
              "aria-haspopup": "true",
              "aria-label": e.profileMenuLabel
            }, [
              J(ct, {
                name: e.userName,
                src: e.avatarUrl || null,
                size: "sm",
                variant: "default",
                class: "border-2 border-royal-300/20"
              }, null, 8, ["name", "src"])
            ], 8, Pg),
            J(p1, { name: "dropdown" }, {
              default: Y(() => [
                n.value ? (l(), s("div", {
                  key: 0,
                  class: "absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-border-gray py-2 z-50",
                  onClick: m[0] || (m[0] = o1(() => {
                  }, ["stop"]))
                }, [
                  o("div", Rg, [
                    o("p", Ng, M(e.userName), 1),
                    o("p", Gg, M(e.userEmail), 1)
                  ]),
                  e.showProfileMenuItems ? (l(), s("div", Ug, [
                    G(C.$slots, "profile-menu", {}, () => [
                      o("button", {
                        class: "w-full text-left px-4 py-2 text-sm text-subtitle-gray hover:bg-grey-50 transition-colors",
                        onClick: d
                      }, " Configurações ")
                    ], !0)
                  ])) : x("", !0),
                  o("div", {
                    class: v(e.showProfileMenuItems ? "border-t border-border-gray pt-1" : "pt-1")
                  }, [
                    o("button", {
                      class: "w-full text-left px-4 py-2 text-sm text-error hover:bg-red-50 transition-colors",
                      onClick: u
                    }, " Sair ")
                  ], 2)
                ])) : x("", !0)
              ]),
              _: 3
            })
          ])) : x("", !0)
        ])
      ])
    ]));
  }
}), fL = /* @__PURE__ */ g(Wg, [["__scopeId", "data-v-7b6d23ea"]]), Yg = {
  key: 0,
  class: "text-sm text-subtitle-gray"
}, qg = { key: 0 }, Kg = { class: "font-medium text-default-black" }, Qg = { class: "font-medium text-default-black" }, Xg = { class: "font-medium text-default-black" }, Jg = { key: 1 }, ev = { class: "flex items-center gap-1" }, tv = ["disabled"], ov = ["disabled"], nv = {
  key: 0,
  class: "px-2 text-subtitle-gray"
}, rv = ["aria-current", "onClick"], lv = ["disabled"], sv = ["disabled"], iv = {
  key: 1,
  class: "flex items-center gap-2"
}, av = ["value"], dv = ["value"], K1 = "flex items-center justify-center w-8 h-8 rounded-lg text-sm font-medium transition-all", Q1 = "text-subtitle-gray hover:bg-grey-100 hover:text-default-black", uv = "bg-primary text-white", ce = "text-grey-300 cursor-not-allowed", CL = /* @__PURE__ */ I({
  __name: "EcxPagination",
  props: {
    currentPage: {},
    totalItems: {},
    perPage: { default: 10 },
    perPageOptions: { default: () => [10, 25, 50, 100] },
    visiblePagesCount: { default: 5 },
    showInfo: { type: Boolean, default: !0 },
    showFirstLast: { type: Boolean, default: !1 },
    showPerPage: { type: Boolean, default: !1 },
    containerClass: {}
  },
  emits: ["update:currentPage", "update:perPage", "page-change"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = f(() => Math.ceil(r.totalItems / r.perPage) || 1), a = f(() => (r.currentPage - 1) * r.perPage + 1), d = f(() => Math.min(r.currentPage * r.perPage, r.totalItems)), u = f(() => {
      const m = [], c = i.value, p = r.currentPage, k = r.visiblePagesCount;
      if (c <= k)
        for (let j = 1; j <= c; j++)
          m.push(j);
      else {
        const j = Math.floor(k / 2);
        let H = Math.max(1, p - j), L = Math.min(c, H + k - 1);
        L - H + 1 < k && (H = Math.max(1, L - k + 1)), H > 1 && (m.push(1), H > 2 && m.push("..."));
        for (let F = H; F <= L; F++)
          m.push(F);
        L < c && (L < c - 1 && m.push("..."), m.push(c));
      }
      return m;
    }), h = (m) => {
      m >= 1 && m <= i.value && m !== r.currentPage && (n("update:currentPage", m), n("page-change", m));
    }, C = (m) => {
      const c = parseInt(m.target.value);
      n("update:perPage", c), n("update:currentPage", 1), n("page-change", 1);
    };
    return (m, c) => (l(), s("nav", {
      class: v(["ecx-pagination flex items-center justify-between", e.containerClass]),
      "aria-label": "Pagination"
    }, [
      e.showInfo ? (l(), s("div", Yg, [
        e.totalItems > 0 ? (l(), s("span", qg, [
          c[4] || (c[4] = h1(" Mostrando ", -1)),
          o("span", Kg, M(a.value), 1),
          c[5] || (c[5] = h1(" a ", -1)),
          o("span", Qg, M(d.value), 1),
          c[6] || (c[6] = h1(" de ", -1)),
          o("span", Xg, M(e.totalItems), 1),
          c[7] || (c[7] = h1(" resultados ", -1))
        ])) : (l(), s("span", Jg, "Nenhum resultado encontrado"))
      ])) : x("", !0),
      o("div", ev, [
        e.showFirstLast ? (l(), s("button", {
          key: 0,
          type: "button",
          disabled: e.currentPage === 1,
          class: v([K1, e.currentPage === 1 ? ce : Q1]),
          onClick: c[0] || (c[0] = (p) => h(1)),
          "aria-label": "Primeira página"
        }, [...c[8] || (c[8] = [
          o("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
            })
          ], -1)
        ])], 10, tv)) : x("", !0),
        o("button", {
          type: "button",
          disabled: e.currentPage === 1,
          class: v([K1, e.currentPage === 1 ? ce : Q1]),
          onClick: c[1] || (c[1] = (p) => h(e.currentPage - 1)),
          "aria-label": "Página anterior"
        }, [...c[9] || (c[9] = [
          o("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })
          ], -1)
        ])], 10, ov),
        (l(!0), s(n1, null, u1(u.value, (p) => (l(), s(n1, { key: p }, [
          p === "..." ? (l(), s("span", nv, " ... ")) : (l(), s("button", {
            key: 1,
            type: "button",
            class: v([
              K1,
              p === e.currentPage ? uv : Q1
            ]),
            "aria-current": p === e.currentPage ? "page" : void 0,
            onClick: (k) => h(p)
          }, M(p), 11, rv))
        ], 64))), 128)),
        o("button", {
          type: "button",
          disabled: e.currentPage === i.value,
          class: v([K1, e.currentPage === i.value ? ce : Q1]),
          onClick: c[2] || (c[2] = (p) => h(e.currentPage + 1)),
          "aria-label": "Próxima página"
        }, [...c[10] || (c[10] = [
          o("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })
          ], -1)
        ])], 10, lv),
        e.showFirstLast ? (l(), s("button", {
          key: 1,
          type: "button",
          disabled: e.currentPage === i.value,
          class: v([K1, e.currentPage === i.value ? ce : Q1]),
          onClick: c[3] || (c[3] = (p) => h(i.value)),
          "aria-label": "Última página"
        }, [...c[11] || (c[11] = [
          o("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M13 5l7 7-7 7M5 5l7 7-7 7"
            })
          ], -1)
        ])], 10, sv)) : x("", !0)
      ]),
      e.showPerPage ? (l(), s("div", iv, [
        c[12] || (c[12] = o("span", { class: "text-sm text-subtitle-gray" }, "Por página:", -1)),
        o("select", {
          value: e.perPage,
          class: "rounded-lg border border-grey-200 py-1 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary",
          onChange: C
        }, [
          (l(!0), s(n1, null, u1(e.perPageOptions, (p) => (l(), s("option", {
            key: p,
            value: p
          }, M(p), 9, dv))), 128))
        ], 40, av)
      ])) : x("", !0)
    ], 2));
  }
}), cv = 32, gL = /* @__PURE__ */ I({
  __name: "EcxActionBar",
  props: {
    show: { type: Boolean, default: !0 },
    size: { default: "md" },
    position: { default: "bottom" },
    gap: { default: "md" },
    justify: { default: "between" },
    responsive: { type: Boolean, default: !1 },
    teleport: { type: Boolean, default: !0 },
    availableWidth: {},
    measureKey: {}
  },
  emits: ["collapse-change"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = {
      sm: "px-4 py-2",
      md: "px-6 py-3",
      lg: "px-8 py-4"
    }, a = {
      sm: "min-w-[300px]",
      md: "min-w-[500px]",
      lg: "min-w-[800px]"
    }, d = {
      sm: "gap-3",
      md: "gap-4",
      lg: "gap-6"
    }, u = {
      start: "justify-start",
      center: "justify-center",
      between: "justify-between",
      end: "justify-end"
    }, h = {
      bottom: "bottom-8",
      top: "top-8"
    }, C = E(null), m = E(typeof window < "u" ? window.innerWidth : 0), c = E(0), p = E(!1), k = f(() => r.responsive ? `${i[r.size]} w-max` : `${i[r.size]} ${a[r.size]}`), j = f(() => r.teleport ? `fixed z-50 left-1/2 -translate-x-1/2 ${h[r.position]}` : ""), H = f(() => [d[r.gap], u[r.justify]]), L = f(() => r.availableWidth ?? m.value - cv), F = f(
      () => r.responsive && !p.value && c.value > 0 && L.value < c.value
    ), P = f(() => p.value ? !1 : F.value), Z = f(() => !r.responsive || p.value ? {} : { maxWidth: `${L.value}px` });
    async function T() {
      r.responsive && (p.value = !0, await s1(), C.value && (c.value = C.value.offsetWidth), p.value = !1);
    }
    function R() {
      m.value = window.innerWidth;
    }
    return m1(() => {
      r.responsive && window.addEventListener("resize", R), r.show && T();
    }), y1(() => {
      r.responsive && window.removeEventListener("resize", R);
    }), r1(
      () => r.show,
      (A) => {
        A && T();
      }
    ), r1(() => r.availableWidth, T), r1(() => r.measureKey, T), r1(F, (A) => n("collapse-change", A), { immediate: !0 }), (A, _) => (l(), W(g1, {
      to: "body",
      disabled: !e.teleport
    }, [
      J(p1, {
        "enter-active-class": "transition ease-out duration-300",
        "enter-from-class": "transform translate-y-full opacity-0",
        "enter-to-class": "transform translate-y-0 opacity-100",
        "leave-active-class": "transition ease-in duration-200",
        "leave-from-class": "transform translate-y-0 opacity-100",
        "leave-to-class": "transform translate-y-full opacity-0"
      }, {
        default: Y(() => [
          e.show ? (l(), s("div", {
            key: 0,
            class: v(j.value)
          }, [
            o("div", {
              ref_key: "barRef",
              ref: C,
              class: v([
                "bg-white rounded-xl shadow-[0px_8px_32px_0px_rgba(118,123,162,0.35)] border border-grey-100",
                "flex items-center",
                k.value,
                H.value
              ]),
              style: a1(Z.value)
            }, [
              G(A.$slots, "default", { collapsed: P.value })
            ], 6)
          ], 2)) : x("", !0)
        ]),
        _: 3
      })
    ], 8, ["disabled"]));
  }
}), vL = /* @__PURE__ */ I({
  __name: "EcxActionBarButton",
  props: {
    label: {},
    icon: {},
    iconColorClass: { default: "" },
    collapsed: { type: Boolean, default: !1 },
    variant: { default: "icon-action" },
    disabled: { type: Boolean, default: !1 },
    title: {},
    testId: {},
    tooltipPlacement: { default: "top" }
  },
  emits: ["click"],
  setup(e) {
    const t = e, r = f(() => ["w-5 h-5", t.iconColorClass]);
    return (n, i) => e.collapsed ? (l(), W(fe, {
      key: 0,
      content: e.label,
      placement: e.tooltipPlacement
    }, {
      default: Y(() => [
        J(V1, {
          variant: e.variant,
          size: "sm",
          "icon-only": "",
          disabled: e.disabled,
          title: e.title,
          "data-testid": e.testId,
          "aria-label": e.label,
          onClick: i[0] || (i[0] = (a) => n.$emit("click", a))
        }, {
          default: Y(() => [
            (l(), W(f1(e.icon), {
              class: v(r.value)
            }, null, 8, ["class"]))
          ]),
          _: 1
        }, 8, ["variant", "disabled", "title", "data-testid", "aria-label"])
      ]),
      _: 1
    }, 8, ["content", "placement"])) : (l(), W(V1, {
      key: 1,
      variant: e.variant,
      size: "sm",
      text: e.label,
      class: "whitespace-nowrap",
      disabled: e.disabled,
      title: e.title,
      "data-testid": e.testId,
      "aria-label": e.label,
      onClick: i[1] || (i[1] = (a) => n.$emit("click", a))
    }, {
      iconLeft: Y(() => [
        (l(), W(f1(e.icon), {
          class: v(r.value)
        }, null, 8, ["class"]))
      ]),
      _: 1
    }, 8, ["variant", "text", "disabled", "title", "data-testid", "aria-label"]));
  }
}), hv = { class: "ecx-progress-bar w-full" }, pv = {
  key: 0,
  class: "text-center mb-4"
}, fv = {
  key: 0,
  class: "text-2xl font-semibold text-default-black mb-2"
}, Cv = {
  key: 1,
  class: "text-lg text-subtitle-gray"
}, gv = {
  key: 1,
  class: "text-sm text-subtitle-gray mt-2 text-center"
}, mL = /* @__PURE__ */ I({
  __name: "EcxProgressBar",
  props: {
    current: {},
    total: {},
    showInfo: { type: Boolean, default: !1 },
    showCount: { type: Boolean, default: !0 },
    showPercentage: { type: Boolean, default: !0 },
    variant: { default: "primary" },
    size: { default: "md" },
    trackColor: { default: "#ECEEF3" },
    barClass: {},
    label: {},
    gradientFrom: { default: "#EBF0FF" },
    gradientTo: { default: "#3342FF" },
    rounded: { default: "full" }
  },
  setup(e) {
    const t = e, r = f(() => t.total === 0 ? 0 : Math.round(t.current / t.total * 100)), n = f(() => ({
      sm: "h-1",
      md: "h-2",
      lg: "h-2.5",
      xl: "h-3"
    })[t.size]), i = f(() => ({
      full: "rounded-full",
      sm: "rounded-sm",
      none: "rounded-none"
    })[t.rounded]), a = f(() => t.variant === "gradient" || t.variant === "royal-gradient" || t.variant === "royal-fade-gradient" ? "" : {
      primary: "bg-primary",
      success: "bg-success",
      warning: "bg-warning",
      error: "bg-error",
      gradient: "",
      "royal-gradient": "",
      "royal-fade-gradient": ""
    }[t.variant]), d = f(() => t.variant === "gradient" ? {
      background: `linear-gradient(to right, ${t.gradientFrom}, ${t.gradientTo})`
    } : t.variant === "royal-gradient" ? {
      background: "linear-gradient(to right, #5763FF, #3342FF)"
    } : t.variant === "royal-fade-gradient" ? {
      background: `linear-gradient(to right, #5763FF, ${t.trackColor})`
    } : {});
    return (u, h) => (l(), s("div", hv, [
      e.showInfo ? (l(), s("div", pv, [
        e.showCount ? (l(), s("div", fv, M(e.current) + "/" + M(e.total), 1)) : x("", !0),
        e.showPercentage ? (l(), s("div", Cv, M(r.value) + "% ", 1)) : x("", !0)
      ])) : x("", !0),
      o("div", {
        class: v(["relative overflow-hidden", [n.value, i.value, e.barClass]]),
        style: a1({ backgroundColor: e.trackColor })
      }, [
        o("div", {
          class: v(["h-full transition-all duration-300 ease-out", [a.value, i.value]]),
          style: a1({ width: `${r.value}%`, ...d.value })
        }, null, 6)
      ], 6),
      e.label ? (l(), s("div", gv, M(e.label), 1)) : x("", !0)
    ]));
  }
}), xL = /* @__PURE__ */ I({
  __name: "EcxBadge",
  props: {
    text: {},
    variant: { default: "default" },
    size: { default: "md" },
    dismissible: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 },
    pill: { type: Boolean, default: !1 }
  },
  emits: ["dismiss"],
  setup(e) {
    const t = e, r = {
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-1 text-xs",
      lg: "px-3 py-1.5 text-sm"
    }, n = f(() => {
      const a = {
        default: "bg-grey-100 text-subtitle-gray",
        primary: "bg-royal-25 text-primary",
        success: "bg-green-50 text-success",
        warning: "bg-yellow-50 text-warning",
        error: "bg-red-50 text-error",
        info: "bg-blue-50 text-blue-600"
      }, d = {
        default: "border border-grey-200 text-subtitle-gray bg-transparent",
        primary: "border border-primary text-primary bg-transparent",
        success: "border border-success text-success bg-transparent",
        warning: "border border-warning text-warning bg-transparent",
        error: "border border-error text-error bg-transparent",
        info: "border border-blue-600 text-blue-600 bg-transparent"
      };
      return t.outline ? d[t.variant] : a[t.variant];
    }), i = f(() => [
      "inline-flex items-center font-medium",
      r[t.size],
      n.value,
      t.pill ? "rounded-full" : "rounded-md"
    ]);
    return (a, d) => (l(), s("span", {
      class: v(i.value)
    }, [
      G(a.$slots, "icon"),
      G(a.$slots, "default", {}, () => [
        h1(M(e.text), 1)
      ]),
      e.dismissible ? (l(), s("button", {
        key: 0,
        type: "button",
        class: "ml-1 -mr-1 hover:opacity-70 transition-opacity",
        onClick: d[0] || (d[0] = (u) => a.$emit("dismiss"))
      }, [...d[1] || (d[1] = [
        o("svg", {
          class: "w-3 h-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })
        ], -1)
      ])])) : x("", !0)
    ], 2));
  }
}), vv = { class: "flex-1" }, wL = /* @__PURE__ */ I({
  __name: "EcxAlert",
  props: {
    variant: { default: "info" },
    title: {},
    message: {},
    iconComponent: {},
    dismissible: { type: Boolean, default: !1 }
  },
  emits: ["dismiss"],
  setup(e) {
    const t = e, r = f(() => ({
      success: "bg-green-50 border border-green-200",
      error: "bg-red-50 border border-red-200",
      warning: "bg-yellow-50 border border-yellow-200",
      info: "bg-blue-50 border border-blue-200"
    })[t.variant]), n = f(() => ({
      success: "text-green-600",
      error: "text-red-600",
      warning: "text-yellow-600",
      info: "text-blue-600"
    })[t.variant]), i = f(() => ({
      success: "text-green-800",
      error: "text-red-800",
      warning: "text-yellow-800",
      info: "text-blue-800"
    })[t.variant]);
    return (a, d) => (l(), s("div", {
      class: v([
        "ecx-alert rounded-lg p-4 flex items-start gap-3",
        r.value
      ]),
      role: "alert"
    }, [
      e.iconComponent ? (l(), W(f1(e.iconComponent), {
        key: 0,
        class: v(["w-5 h-5 flex-shrink-0 mt-0.5", n.value])
      }, null, 8, ["class"])) : (l(), s(n1, { key: 1 }, [
        e.variant === "success" ? (l(), s("svg", {
          key: 0,
          class: v(["w-5 h-5 flex-shrink-0 mt-0.5", n.value]),
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [...d[1] || (d[1] = [
          o("path", {
            "fill-rule": "evenodd",
            d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            "clip-rule": "evenodd"
          }, null, -1)
        ])], 2)) : e.variant === "error" ? (l(), s("svg", {
          key: 1,
          class: v(["w-5 h-5 flex-shrink-0 mt-0.5", n.value]),
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [...d[2] || (d[2] = [
          o("path", {
            "fill-rule": "evenodd",
            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
            "clip-rule": "evenodd"
          }, null, -1)
        ])], 2)) : e.variant === "warning" ? (l(), s("svg", {
          key: 2,
          class: v(["w-5 h-5 flex-shrink-0 mt-0.5", n.value]),
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [...d[3] || (d[3] = [
          o("path", {
            "fill-rule": "evenodd",
            d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
            "clip-rule": "evenodd"
          }, null, -1)
        ])], 2)) : (l(), s("svg", {
          key: 3,
          class: v(["w-5 h-5 flex-shrink-0 mt-0.5", n.value]),
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [...d[4] || (d[4] = [
          o("path", {
            "fill-rule": "evenodd",
            d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
            "clip-rule": "evenodd"
          }, null, -1)
        ])], 2))
      ], 64)),
      o("div", vv, [
        e.title ? (l(), s("h3", {
          key: 0,
          class: v(["font-semibold mb-1", i.value])
        }, M(e.title), 3)) : x("", !0),
        o("p", {
          class: v(["text-sm", i.value])
        }, [
          G(a.$slots, "default", {}, () => [
            h1(M(e.message), 1)
          ])
        ], 2)
      ]),
      e.dismissible ? (l(), s("button", {
        key: 2,
        type: "button",
        class: v(["flex-shrink-0 hover:opacity-70 transition-opacity", n.value]),
        onClick: d[0] || (d[0] = (u) => a.$emit("dismiss"))
      }, [...d[5] || (d[5] = [
        o("svg", {
          class: "w-4 h-4",
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [
          o("path", {
            "fill-rule": "evenodd",
            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
            "clip-rule": "evenodd"
          })
        ], -1)
      ])], 2)) : x("", !0)
    ], 2));
  }
}), mv = {
  key: 0,
  class: "w-5 h-5 flex-shrink-0 text-green-600",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, xv = {
  key: 1,
  class: "w-5 h-5 flex-shrink-0 text-red-600",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, wv = { class: "flex-1" }, kv = { class: "text-sm font-medium" }, yv = {
  key: 0,
  class: "text-xs opacity-80 mt-0.5"
}, bv = ["onClick"], kL = /* @__PURE__ */ I({
  __name: "EcxToast",
  props: {
    position: { default: "bottom-center" },
    defaultDuration: { default: 4e3 },
    maxVisible: { default: 5 }
  },
  setup(e, { expose: t }) {
    const r = e, n = E([]), i = f(() => n.value.slice(0, r.maxVisible)), a = f(() => ({
      "top-right": "top-0 right-0 items-end",
      "top-left": "top-0 left-0 items-start",
      "bottom-right": "bottom-0 right-0 items-end",
      "bottom-left": "bottom-0 left-0 items-start",
      "top-center": "top-0 left-1/2 -translate-x-1/2 items-center",
      "bottom-center": "bottom-0 left-1/2 -translate-x-1/2 items-center"
    })[r.position]), d = {
      default: "bg-grey-800 text-white",
      success: "bg-white text-grey-800 border border-green-200",
      error: "bg-white text-grey-800 border border-red-200",
      warning: "bg-white text-grey-800 border border-yellow-200",
      info: "bg-white text-grey-800 border border-blue-200"
    }, u = (m) => {
      const c = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, p = { ...m, id: c };
      n.value.push(p);
      const k = m.duration ?? r.defaultDuration;
      return k > 0 && setTimeout(() => h(c), k), c;
    }, h = (m) => {
      const c = n.value.findIndex((p) => p.id === m);
      c > -1 && n.value.splice(c, 1);
    };
    return t({
      addToast: u,
      removeToast: h,
      clearAll: () => {
        n.value = [];
      },
      toasts: n
    }), (m, c) => (l(), W(g1, { to: "body" }, [
      J(me, {
        tag: "div",
        class: v(["ecx-toast-container fixed z-[9999] flex flex-col gap-2 p-4", a.value]),
        name: "toast"
      }, {
        default: Y(() => [
          (l(!0), s(n1, null, u1(i.value, (p) => (l(), s("div", {
            key: p.id,
            class: v([
              "ecx-toast rounded-lg shadow-lg p-4 flex items-center gap-3 min-w-[280px] max-w-md",
              d[p.variant || "default"]
            ])
          }, [
            p.icon ? (l(), W(f1(p.icon), {
              key: 0,
              class: "w-5 h-5 flex-shrink-0"
            })) : (l(), s(n1, { key: 1 }, [
              p.variant === "success" ? (l(), s("svg", mv, [...c[0] || (c[0] = [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])])) : p.variant === "error" ? (l(), s("svg", xv, [...c[1] || (c[1] = [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])])) : x("", !0)
            ], 64)),
            o("div", wv, [
              o("p", kv, M(p.message), 1),
              p.description ? (l(), s("p", yv, M(p.description), 1)) : x("", !0)
            ]),
            o("button", {
              type: "button",
              class: "flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity",
              onClick: (k) => h(p.id)
            }, [...c[2] || (c[2] = [
              o("svg", {
                class: "w-4 h-4",
                fill: "currentColor",
                viewBox: "0 0 20 20"
              }, [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ])], 8, bv)
          ], 2))), 128))
        ]),
        _: 1
      }, 8, ["class"])
    ]));
  }
}), _v = {
  key: 1,
  class: "mb-4 w-16 h-16 rounded-full bg-grey-100 flex items-center justify-center"
}, Mv = {
  key: 2,
  class: "text-lg font-semibold text-default-black mb-2"
}, Lv = {
  key: 3,
  class: "text-sm text-subtitle-gray max-w-md mb-6"
}, $v = {
  key: 4,
  class: "mt-2"
}, yL = /* @__PURE__ */ I({
  __name: "EcxEmptyState",
  props: {
    title: {},
    description: {},
    iconComponent: {},
    containerClass: { default: "py-12 px-4" },
    iconContainerClass: {},
    iconClass: { default: "w-12 h-12 text-grey-400" }
  },
  setup(e) {
    return (t, r) => (l(), s("div", {
      class: v(["ecx-empty-state flex flex-col items-center justify-center text-center", e.containerClass])
    }, [
      e.iconComponent || t.$slots.icon ? (l(), s("div", {
        key: 0,
        class: v(["mb-4", e.iconContainerClass])
      }, [
        G(t.$slots, "icon", {}, () => [
          e.iconComponent ? (l(), W(f1(e.iconComponent), {
            key: 0,
            class: v(e.iconClass)
          }, null, 8, ["class"])) : x("", !0)
        ])
      ], 2)) : (l(), s("div", _v, [...r[0] || (r[0] = [
        o("svg", {
          class: "w-8 h-8 text-grey-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
          })
        ], -1)
      ])])),
      e.title ? (l(), s("h3", Mv, M(e.title), 1)) : x("", !0),
      e.description || t.$slots.default ? (l(), s("p", Lv, [
        G(t.$slots, "default", {}, () => [
          h1(M(e.description), 1)
        ])
      ])) : x("", !0),
      t.$slots.action ? (l(), s("div", $v, [
        G(t.$slots, "action")
      ])) : x("", !0)
    ], 2));
  }
}), Vv = { class: "flex flex-col gap-5" }, Bv = { class: "flex items-center gap-4" }, Hv = {
  key: 0,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Fv = {
  key: 1,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Av = {
  key: 2,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, jv = {
  key: 3,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Iv = { class: "flex-1 font-mont text-lg font-semibold leading-6 text-grey-900 tracking-title-sm" }, Zv = ["onClick"], Ev = {
  key: 0,
  class: "text-sm text-grey-600 tracking-tooltip leading-relaxed"
}, Sv = {
  key: 0,
  class: "flex items-center justify-end gap-5"
}, zv = ["onClick"], Dv = ["onClick"], bL = /* @__PURE__ */ I({
  __name: "EcxFeedbackToast",
  props: {
    defaultDuration: { default: 5e3 },
    maxVisible: { default: 3 }
  },
  setup(e, { expose: t }) {
    const r = e, n = E([]), i = f(() => n.value.slice(0, r.maxVisible)), a = {
      success: "bg-[#ECFDF5] border-[#6EE7B7]",
      error: "bg-[#FEF2F2] border-[#FECACA]",
      warning: "bg-[#FFFBEB] border-[#FCD34D]",
      info: "bg-[#EFF6FF] border-[#93C5FD]"
    }, d = (H) => {
      const L = `feedback-toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, F = { ...H, id: L };
      n.value.push(F);
      const P = H.duration ?? r.defaultDuration;
      return P > 0 && setTimeout(() => u(L), P), L;
    }, u = (H) => {
      const L = n.value.findIndex((F) => F.id === H);
      L > -1 && n.value.splice(L, 1);
    }, h = () => {
      n.value = [];
    }, C = (H) => {
      var L, F;
      (F = (L = H.primaryAction) == null ? void 0 : L.onClick) == null || F.call(L), u(H.id);
    }, m = (H) => {
      var L, F;
      (F = (L = H.secondaryAction) == null ? void 0 : L.onClick) == null || F.call(L), u(H.id);
    };
    return t({
      addToast: d,
      removeToast: u,
      clearAll: h,
      success: (H, L) => d({ title: H, variant: "success", ...L }),
      error: (H, L) => d({ title: H, variant: "error", ...L }),
      warning: (H, L) => d({ title: H, variant: "warning", ...L }),
      info: (H, L) => d({ title: H, variant: "info", ...L }),
      toasts: n
    }), (H, L) => (l(), W(g1, { to: "body" }, [
      J(me, {
        tag: "div",
        class: "fixed flex flex-col gap-3 p-6 bottom-0 right-0 items-end pointer-events-none",
        style: { "z-index": "999999" },
        name: "feedback-toast"
      }, {
        default: Y(() => [
          (l(!0), s(n1, null, u1(i.value, (F) => (l(), s("div", {
            key: F.id,
            class: "bg-white rounded-xl shadow-[0_4px_12px_0_rgba(0,0,0,0.08)] px-3.5 py-4 flex flex-col gap-5 w-[360px] pointer-events-auto"
          }, [
            o("div", Vv, [
              o("div", Bv, [
                o("div", {
                  class: v([
                    "flex items-center justify-center w-8 h-8 rounded-lg border shrink-0",
                    a[F.variant || "success"]
                  ])
                }, [
                  F.icon ? (l(), W(f1(F.icon), {
                    key: 0,
                    class: "w-5 h-5"
                  })) : (l(), s(n1, { key: 1 }, [
                    F.variant === "success" || !F.variant ? (l(), s("svg", Hv, [...L[0] || (L[0] = [
                      o("path", {
                        d: "M16.6667 5.41667L7.5 14.5833L3.33333 10.4167",
                        stroke: "#1DC37B",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ])])) : F.variant === "error" ? (l(), s("svg", Fv, [...L[1] || (L[1] = [
                      o("path", {
                        d: "M6.66667 6.66667L13.3333 13.3333M13.3333 6.66667L6.66667 13.3333",
                        stroke: "#FE5E86",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ])])) : F.variant === "warning" ? (l(), s("svg", Av, [...L[2] || (L[2] = [
                      o("path", {
                        d: "M10 7V10.5M10 13.5V13.51",
                        stroke: "#F59E0B",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1),
                      o("path", {
                        d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
                        stroke: "#F59E0B",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ])])) : F.variant === "info" ? (l(), s("svg", jv, [...L[3] || (L[3] = [
                      o("path", {
                        d: "M10 10V14M10 6V6.01",
                        stroke: "#3B82F6",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1),
                      o("path", {
                        d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
                        stroke: "#3B82F6",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ])])) : x("", !0)
                  ], 64))
                ], 2),
                o("p", Iv, M(F.title), 1),
                o("button", {
                  type: "button",
                  class: "p-2 rounded-lg hover:bg-grey-50 transition-colors shrink-0",
                  onClick: (P) => u(F.id)
                }, [...L[4] || (L[4] = [
                  o("svg", {
                    class: "w-5 h-5 text-grey-800",
                    viewBox: "0 0 20 20",
                    fill: "none"
                  }, [
                    o("path", {
                      d: "M6.66667 6.66667L13.3333 13.3333M13.3333 6.66667L6.66667 13.3333",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ])], 8, Zv)
              ]),
              F.description ? (l(), s("p", Ev, M(F.description), 1)) : x("", !0)
            ]),
            F.primaryAction || F.secondaryAction ? (l(), s("div", Sv, [
              F.secondaryAction ? (l(), s("button", {
                key: 0,
                type: "button",
                class: "h-8 px-3 py-1.5 bg-white border border-grey-200 rounded-lg text-sm text-grey-900 tracking-status-badge hover:bg-grey-50 transition-colors",
                onClick: (P) => m(F)
              }, M(F.secondaryAction.label), 9, zv)) : x("", !0),
              F.primaryAction ? (l(), s("button", {
                key: 1,
                type: "button",
                class: "h-[27px] px-3 py-1.5 bg-royal-500 rounded-md text-xs text-white tracking-status-badge hover:bg-royal-600 transition-colors",
                onClick: (P) => C(F)
              }, M(F.primaryAction.label), 9, Dv)) : x("", !0)
            ])) : x("", !0)
          ]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), oe = E([]), xt = E(5e3), Tv = E(3), Ov = () => `feedback-toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, re = (e) => {
  const t = Ov(), r = { ...e, id: t };
  oe.value.push(r);
  const n = e.duration ?? xt.value;
  return n > 0 && setTimeout(() => wt(t), n), t;
}, wt = (e) => {
  const t = oe.value.findIndex((r) => r.id === e);
  t > -1 && oe.value.splice(t, 1);
}, Pv = () => {
  oe.value = [];
}, Rv = (e, t) => re({ title: e, variant: "success", ...t }), Nv = (e, t) => re({ title: e, variant: "error", ...t }), Gv = (e, t) => re({ title: e, variant: "warning", ...t }), Uv = (e, t) => re({ title: e, variant: "info", ...t });
function Wv() {
  return {
    // State
    toasts: oe,
    defaultDuration: xt,
    maxVisible: Tv,
    // Methods
    addToast: re,
    removeToast: wt,
    clearAll: Pv,
    // Helpers
    success: Rv,
    error: Nv,
    warning: Gv,
    info: Uv
  };
}
const Yv = { class: "flex flex-col gap-5" }, qv = { class: "flex items-center gap-4" }, Kv = {
  key: 0,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Qv = {
  key: 1,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Xv = {
  key: 2,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, Jv = {
  key: 3,
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none"
}, em = { class: "flex-1 font-mont text-lg font-semibold leading-6 text-grey-900 tracking-title-sm" }, tm = ["onClick"], om = {
  key: 0,
  class: "text-sm text-grey-600 tracking-tooltip leading-relaxed"
}, nm = {
  key: 0,
  class: "flex items-center justify-end gap-5"
}, rm = ["onClick"], lm = ["onClick"], _L = /* @__PURE__ */ I({
  __name: "EcxFeedbackToastContainer",
  setup(e) {
    const { toasts: t, maxVisible: r, removeToast: n } = Wv(), i = f(() => t.value.slice(0, r.value)), a = {
      success: "bg-[#ECFDF5] border-[#6EE7B7]",
      error: "bg-[#FEF2F2] border-[#FECACA]",
      warning: "bg-[#FFFBEB] border-[#FCD34D]",
      info: "bg-[#EFF6FF] border-[#93C5FD]"
    }, d = (h) => {
      var C, m;
      (m = (C = h.primaryAction) == null ? void 0 : C.onClick) == null || m.call(C), n(h.id);
    }, u = (h) => {
      var C, m;
      (m = (C = h.secondaryAction) == null ? void 0 : C.onClick) == null || m.call(C), n(h.id);
    };
    return (h, C) => (l(), W(g1, { to: "body" }, [
      J(me, {
        tag: "div",
        class: "fixed z-[999999] flex flex-col gap-3 p-6 bottom-0 right-0 items-end pointer-events-none",
        name: "feedback-toast"
      }, {
        default: Y(() => [
          (l(!0), s(n1, null, u1(i.value, (m) => (l(), s("div", {
            key: m.id,
            class: "bg-white rounded-xl shadow-[0_4px_12px_0_rgba(0,0,0,0.08)] px-3.5 py-4 flex flex-col gap-5 w-[360px] pointer-events-auto"
          }, [
            o("div", Yv, [
              o("div", qv, [
                o("div", {
                  class: v([
                    "flex items-center justify-center w-8 h-8 rounded-lg border shrink-0",
                    a[m.variant || "success"]
                  ])
                }, [
                  m.variant === "success" || !m.variant ? (l(), s("svg", Kv, [...C[0] || (C[0] = [
                    o("path", {
                      d: "M16.6667 5.41667L7.5 14.5833L3.33333 10.4167",
                      stroke: "#1DC37B",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])) : m.variant === "error" ? (l(), s("svg", Qv, [...C[1] || (C[1] = [
                    o("path", {
                      d: "M6.66667 6.66667L13.3333 13.3333M13.3333 6.66667L6.66667 13.3333",
                      stroke: "#FE5E86",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])) : m.variant === "warning" ? (l(), s("svg", Xv, [...C[2] || (C[2] = [
                    o("path", {
                      d: "M10 7V10.5M10 13.5V13.51",
                      stroke: "#F59E0B",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1),
                    o("path", {
                      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
                      stroke: "#F59E0B",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])) : m.variant === "info" ? (l(), s("svg", Jv, [...C[3] || (C[3] = [
                    o("path", {
                      d: "M10 10V14M10 6V6.01",
                      stroke: "#3B82F6",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1),
                    o("path", {
                      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
                      stroke: "#3B82F6",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])) : x("", !0)
                ], 2),
                o("p", em, M(m.title), 1),
                o("button", {
                  type: "button",
                  class: "p-2 rounded-lg hover:bg-grey-50 transition-colors shrink-0",
                  onClick: (c) => D(n)(m.id)
                }, [...C[4] || (C[4] = [
                  o("svg", {
                    class: "w-5 h-5 text-grey-800",
                    viewBox: "0 0 20 20",
                    fill: "none"
                  }, [
                    o("path", {
                      d: "M6.66667 6.66667L13.3333 13.3333M13.3333 6.66667L6.66667 13.3333",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ])], 8, tm)
              ]),
              m.description ? (l(), s("p", om, M(m.description), 1)) : x("", !0)
            ]),
            m.primaryAction || m.secondaryAction ? (l(), s("div", nm, [
              m.secondaryAction ? (l(), s("button", {
                key: 0,
                type: "button",
                class: "h-8 px-3 py-1.5 bg-white border border-grey-200 rounded-lg text-sm text-grey-900 tracking-status-badge hover:bg-grey-50 transition-colors",
                onClick: (c) => u(m)
              }, M(m.secondaryAction.label), 9, rm)) : x("", !0),
              m.primaryAction ? (l(), s("button", {
                key: 1,
                type: "button",
                class: "h-[27px] px-3 py-1.5 bg-royal-500 rounded-md text-xs text-white tracking-status-badge hover:bg-royal-600 transition-colors",
                onClick: (c) => d(m)
              }, M(m.primaryAction.label), 9, lm)) : x("", !0)
            ])) : x("", !0)
          ]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), ML = /* @__PURE__ */ I({
  __name: "EcxHeading",
  props: {
    level: { default: 1 },
    as: {},
    color: { default: "default" }
  },
  setup(e) {
    const t = e, r = f(() => t.as || `h${t.level}`), n = {
      1: "text-4xl font-bold",
      2: "text-3xl font-bold",
      3: "text-2xl font-semibold",
      4: "text-xl font-semibold",
      5: "text-lg font-semibold",
      6: "text-base font-semibold"
    }, i = {
      default: "text-default-black",
      primary: "text-primary",
      secondary: "text-subtitle-gray",
      error: "text-error"
    }, a = f(() => [
      "font-be-vietnam",
      n[t.level],
      i[t.color]
    ]);
    return (d, u) => (l(), W(f1(r.value), {
      class: v(a.value)
    }, {
      default: Y(() => [
        G(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), LL = /* @__PURE__ */ I({
  __name: "EcxText",
  props: {
    size: { default: "base" },
    weight: { default: "normal" },
    color: { default: "default" },
    as: { default: "p" },
    truncate: { type: Boolean, default: !1 },
    lines: {}
  },
  setup(e) {
    const t = e, r = f(() => t.as), n = {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg"
    }, i = {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold"
    }, a = {
      default: "text-default-black",
      secondary: "text-subtitle-gray",
      primary: "text-primary",
      error: "text-error",
      success: "text-success",
      muted: "text-input-outline-gray"
    }, d = f(() => {
      const u = [
        "font-be-vietnam leading-relaxed",
        n[t.size],
        i[t.weight],
        a[t.color]
      ];
      return t.truncate && u.push("truncate"), t.lines && u.push(`line-clamp-${t.lines}`), u;
    });
    return (u, h) => (l(), W(f1(r.value), {
      class: v(d.value)
    }, {
      default: Y(() => [
        G(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), sm = ["for"], im = {
  key: 0,
  class: "text-error ml-1"
}, $L = /* @__PURE__ */ I({
  __name: "EcxLabel",
  props: {
    htmlFor: {},
    size: { default: "base" },
    weight: { default: "medium" },
    color: { default: "default" },
    required: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = {
      sm: "text-xs",
      base: "text-sm"
    }, n = {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold"
    }, i = {
      default: "text-default-black",
      secondary: "text-subtitle-gray",
      error: "text-error"
    }, a = f(() => [
      "font-be-vietnam inline-flex items-center",
      r[t.size],
      n[t.weight],
      i[t.color]
    ]);
    return (d, u) => (l(), s("label", {
      class: v(a.value),
      for: e.htmlFor
    }, [
      G(d.$slots, "default"),
      e.required ? (l(), s("span", im, "*")) : x("", !0)
    ], 10, sm));
  }
}), VL = /* @__PURE__ */ I({
  __name: "EcxCaption",
  props: {
    color: { default: "secondary" }
  },
  setup(e) {
    const t = e, r = {
      default: "text-default-black",
      secondary: "text-subtitle-gray",
      primary: "text-primary",
      error: "text-error",
      success: "text-success"
    }, n = f(() => [
      "text-xs font-normal font-be-vietnam",
      r[t.color]
    ]);
    return (i, a) => (l(), s("span", {
      class: v(n.value)
    }, [
      G(i.$slots, "default")
    ], 2));
  }
}), am = { class: "font-be-vietnam text-tooltip-title font-normal leading-normal tracking-tooltip-title text-grey-600" }, dm = ["data-testid"], BL = /* @__PURE__ */ I({
  __name: "EcxSummaryLabelValue",
  props: {
    label: {},
    valueTestId: {},
    rootClass: {}
  },
  setup(e) {
    return (t, r) => (l(), s("div", {
      class: v(["flex min-w-0 flex-col gap-1", e.rootClass])
    }, [
      o("span", am, M(e.label), 1),
      o("div", {
        class: "min-w-0 font-be-vietnam text-sm font-normal leading-normal tracking-status-badge text-grey-950",
        "data-testid": e.valueTestId
      }, [
        G(t.$slots, "default")
      ], 8, dm)
    ], 2));
  }
}), um = {
  key: 0,
  class: "flex w-full items-center gap-3 border-b border-grey-100 bg-white px-4 py-4"
}, cm = { class: "flex shrink-0 flex-wrap items-center justify-center gap-3" }, hm = { class: "min-w-0 truncate" }, pm = {
  key: 0,
  class: "mb-4 flex items-center justify-between"
}, fm = { class: "flex items-center gap-x-2" }, Cm = ["onClick"], gm = ["onClick"], vm = { key: 3 }, mm = ["disabled", "onClick"], xm = {
  key: 1,
  class: "flex items-end justify-end gap-2.5 border-t border-grey-100 bg-white p-2.5"
}, wm = {
  key: 2,
  class: "flex items-center justify-between border-t border-gray-200 bg-gray-50 px-4 py-3"
}, km = /* @__PURE__ */ I({
  __name: "EcxDateRangePicker",
  props: {
    opened: { type: Boolean },
    buttonRef: {},
    modelValue: {},
    clearText: { default: "Limpar" },
    applyText: { default: "Aplicar" },
    monthNames: { default: () => [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ] },
    weekDays: { default: () => ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"] },
    appearance: { default: "default" }
  },
  emits: ["update:modelValue", "close", "apply"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = f(() => r.appearance === "corp"), a = E(null), d = E({
      top: "-9999px",
      left: "-9999px"
    }), u = /* @__PURE__ */ new Date(), h = E(u.getMonth()), C = E(u.getFullYear()), m = E(!1), c = E(!1), p = E(null), k = E(null), j = f(() => {
      const y = [], b = (/* @__PURE__ */ new Date()).getFullYear();
      for (let V = b + 1; V >= b - 10; V--)
        y.push(V);
      return y;
    }), H = f(() => {
      const y = [], b = new Date(C.value, h.value, 1), V = new Date(C.value, h.value + 1, 0);
      let S = b.getDay() - 1;
      S < 0 && (S = 6);
      for (let z = 0; z < S; z++)
        y.push({ day: null, date: null, isCurrentMonth: !1 });
      for (let z = 1; z <= V.getDate(); z++)
        y.push({
          day: z,
          date: new Date(C.value, h.value, z),
          isCurrentMonth: !0
        });
      return y;
    }), L = (y) => {
      const b = "size-11 inline-flex items-center justify-center text-sm font-normal transition-colors rounded-xl", V = "mx-auto flex h-8 w-8 items-center justify-center rounded-full text-sm transition-colors";
      if (!y.day || !y.date)
        return i.value ? `${b} pointer-events-none invisible cursor-default` : "cursor-default";
      const S = p.value && F(y.date, p.value), z = k.value && F(y.date, k.value), X = P(y.date), c1 = F(y.date, u);
      return S || z ? i.value ? `${b} cursor-pointer bg-primary text-white hover:bg-primary` : `${V} bg-primary text-white hover:bg-primary` : X ? i.value ? `${b} cursor-pointer bg-royal-50 text-royal-950 hover:bg-royal-100` : `${V} bg-royal-100 text-primary hover:bg-royal-200` : c1 ? i.value ? `${b} cursor-pointer border-2 border-primary text-primary hover:bg-grey-50` : `${V} border-2 border-primary text-primary hover:bg-gray-100` : i.value ? `${b} cursor-pointer text-grey-950 hover:bg-grey-50` : `${V} cursor-pointer text-default-black hover:bg-gray-100`;
    }, F = (y, b) => y.getDate() === b.getDate() && y.getMonth() === b.getMonth() && y.getFullYear() === b.getFullYear(), P = (y) => !p.value || !k.value ? !1 : y > p.value && y < k.value, Z = (y) => {
      y && (!p.value || p.value && k.value ? (p.value = y, k.value = null) : y < p.value ? (k.value = p.value, p.value = y) : k.value = y);
    }, T = () => {
      h.value === 0 ? (h.value = 11, C.value--) : h.value--;
    }, R = () => {
      h.value === 11 ? (h.value = 0, C.value++) : h.value++;
    }, A = (y) => {
      h.value = y, m.value = !1;
    }, _ = (y) => {
      C.value = y, c.value = !1;
    }, w = (y) => {
      if (!y) return null;
      const b = y.getFullYear(), V = String(y.getMonth() + 1).padStart(2, "0"), S = String(y.getDate()).padStart(2, "0");
      return `${b}-${V}-${S}`;
    }, O = () => {
      p.value = null, k.value = null;
      const y = { start: null, end: null };
      n("update:modelValue", y), n("apply", y), n("close");
    }, U = () => {
      const y = {
        start: w(p.value),
        end: w(k.value ?? p.value)
      };
      n("update:modelValue", y), n("apply", y), n("close");
    }, $ = () => {
      if (!r.buttonRef || !a.value) {
        s1(() => {
          r.buttonRef && r.opened && $();
        });
        return;
      }
      const y = r.buttonRef.getBoundingClientRect(), b = r.appearance === "corp" ? 448 : 300, V = r.appearance === "corp" ? 440 : 400;
      let S = y.bottom + 8, z = y.left;
      z + b > window.innerWidth - 16 && (z = y.right - b, z < 16 && (z = 16)), S + V > window.innerHeight - 16 && (S = y.top - V - 8), S < 16 && (S = 16), d.value = {
        top: `${S}px`,
        left: `${z}px`
      };
    }, B = (y) => {
      if (!r.opened || !a.value) return;
      const b = y.target;
      a.value.contains(b) || r.buttonRef && r.buttonRef.contains(b) || n("close");
    };
    return r1(() => r.opened, (y) => {
      var b, V;
      y && (s1(() => {
        $();
      }), (b = r.modelValue) != null && b.start && (p.value = /* @__PURE__ */ new Date(r.modelValue.start + "T00:00:00")), (V = r.modelValue) != null && V.end && (k.value = /* @__PURE__ */ new Date(r.modelValue.end + "T00:00:00")));
    }), r1(
      () => r.appearance,
      () => {
        r.opened && s1(() => $());
      }
    ), m1(() => {
      r.opened && s1(() => $()), window.addEventListener("scroll", $, !0), window.addEventListener("resize", $), document.addEventListener("click", B);
    }), y1(() => {
      window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $), document.removeEventListener("click", B);
    }), (y, b) => (l(), W(g1, { to: "body" }, [
      e.opened ? (l(), s("div", {
        key: 0,
        ref_key: "popoverContainer",
        ref: a,
        class: "fixed z-[60]",
        style: a1(d.value),
        onClick: b[6] || (b[6] = o1(() => {
        }, ["stop"]))
      }, [
        o("div", {
          class: v(
            i.value ? "w-full max-w-md overflow-hidden rounded-3xl border border-grey-100 bg-white shadow-xl" : "w-[300px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg"
          )
        }, [
          i.value ? (l(), s("div", um, [
            o("button", {
              type: "button",
              class: "flex size-6 shrink-0 items-center justify-center rounded-lg text-grey-600 transition-colors hover:bg-grey-50",
              "aria-label": "Mês anterior",
              onClick: T
            }, [...b[7] || (b[7] = [
              o("svg", {
                class: "size-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                "aria-hidden": "true"
              }, [
                o("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15.75 19.5 8.25 12l7.5-7.5"
                })
              ], -1)
            ])]),
            b[11] || (b[11] = o("div", {
              class: "h-8 min-w-0 flex-1 shrink",
              "aria-hidden": "true"
            }, null, -1)),
            o("div", cm, [
              o("button", {
                type: "button",
                class: "flex h-8 w-36 items-center justify-between gap-2 rounded-xl border border-grey-100 bg-white py-1.5 pl-3 pr-2 text-sm font-normal leading-tight tracking-tight text-grey-950 transition-colors hover:bg-grey-50",
                onClick: b[0] || (b[0] = o1((V) => {
                  m.value = !m.value, c.value = !1;
                }, ["stop"]))
              }, [
                o("span", hm, M(e.monthNames[h.value]), 1),
                b[8] || (b[8] = o("svg", {
                  class: "size-5 shrink-0 text-grey-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  "aria-hidden": "true"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
                  })
                ], -1))
              ]),
              o("button", {
                type: "button",
                class: "flex h-8 w-28 items-center justify-between gap-2 rounded-xl border border-grey-100 bg-white py-1.5 pl-3 pr-2 text-sm font-normal leading-tight tracking-tight text-grey-950 transition-colors hover:bg-grey-50",
                onClick: b[1] || (b[1] = o1((V) => {
                  c.value = !c.value, m.value = !1;
                }, ["stop"]))
              }, [
                o("span", null, M(C.value), 1),
                b[9] || (b[9] = o("svg", {
                  class: "size-5 shrink-0 text-grey-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  "aria-hidden": "true"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
                  })
                ], -1))
              ])
            ]),
            b[12] || (b[12] = o("div", {
              class: "h-8 min-w-0 flex-1 shrink",
              "aria-hidden": "true"
            }, null, -1)),
            o("button", {
              type: "button",
              class: "flex size-6 shrink-0 items-center justify-center rounded-lg text-grey-600 transition-colors hover:bg-grey-50",
              "aria-label": "Próximo mês",
              onClick: R
            }, [...b[10] || (b[10] = [
              o("svg", {
                class: "size-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                "aria-hidden": "true"
              }, [
                o("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M8.25 4.5 15.75 12l-7.5 7.5"
                })
              ], -1)
            ])])
          ])) : x("", !0),
          o("div", {
            class: v(i.value ? "bg-white px-2 pb-2 pt-1" : "p-4")
          }, [
            i.value ? x("", !0) : (l(), s("div", pm, [
              o("button", {
                type: "button",
                class: "rounded p-1 transition-colors hover:bg-gray-100",
                onClick: T
              }, [...b[13] || (b[13] = [
                o("svg", {
                  class: "h-5 w-5 text-gray-600",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M15.75 19.5L8.25 12l7.5-7.5"
                  })
                ], -1)
              ])]),
              o("div", fm, [
                o("button", {
                  type: "button",
                  class: "rounded px-2 py-1 text-sm font-medium text-default-black transition-colors hover:bg-gray-100",
                  onClick: b[2] || (b[2] = (V) => {
                    m.value = !m.value, c.value = !1;
                  })
                }, M(e.monthNames[h.value]), 1),
                o("button", {
                  type: "button",
                  class: "rounded px-2 py-1 text-sm font-medium text-default-black transition-colors hover:bg-gray-100",
                  onClick: b[3] || (b[3] = (V) => {
                    c.value = !c.value, m.value = !1;
                  })
                }, M(C.value), 1)
              ]),
              o("button", {
                type: "button",
                class: "rounded p-1 transition-colors hover:bg-gray-100",
                onClick: R
              }, [...b[14] || (b[14] = [
                o("svg", {
                  class: "h-5 w-5 text-gray-600",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
                  })
                ], -1)
              ])])
            ])),
            m.value ? (l(), s("div", {
              key: 1,
              class: v(i.value ? "mb-2 grid grid-cols-3 gap-2" : "mb-4 grid grid-cols-3 gap-2"),
              onClick: b[4] || (b[4] = o1(() => {
              }, ["stop"]))
            }, [
              (l(!0), s(n1, null, u1(e.monthNames, (V, S) => (l(), s("button", {
                key: S,
                type: "button",
                class: v(["rounded px-2 py-2 text-sm transition-colors", [
                  h.value === S ? "bg-primary text-white" : i.value ? "text-grey-950 hover:bg-grey-50" : "text-default-black hover:bg-gray-100"
                ]]),
                onClick: o1((z) => A(S), ["stop"])
              }, M(V.substring(0, 3)), 11, Cm))), 128))
            ], 2)) : c.value ? (l(), s("div", {
              key: 2,
              class: v(i.value ? "mb-2 grid max-h-52 grid-cols-4 gap-2 overflow-y-auto" : "mb-4 grid max-h-[200px] grid-cols-4 gap-2 overflow-y-auto"),
              onClick: b[5] || (b[5] = o1(() => {
              }, ["stop"]))
            }, [
              (l(!0), s(n1, null, u1(j.value, (V) => (l(), s("button", {
                key: V,
                type: "button",
                class: v(["rounded px-2 py-2 text-sm transition-colors", [
                  C.value === V ? "bg-primary text-white" : i.value ? "text-grey-950 hover:bg-grey-50" : "text-default-black hover:bg-gray-100"
                ]]),
                onClick: o1((S) => _(V), ["stop"])
              }, M(V), 11, gm))), 128))
            ], 2)) : (l(), s("div", vm, [
              o("div", {
                class: v(
                  i.value ? "mb-2 grid grid-cols-7 gap-0" : "mb-2 grid grid-cols-7 gap-1"
                )
              }, [
                (l(!0), s(n1, null, u1(e.weekDays, (V) => (l(), s("div", {
                  key: V,
                  class: v(
                    i.value ? "py-1 text-center text-xs font-bold leading-tight tracking-tight text-grey-600" : "py-1 text-center text-xs font-medium text-subtitle-gray"
                  )
                }, M(V), 3))), 128))
              ], 2),
              o("div", {
                class: v(i.value ? "grid grid-cols-7 gap-0" : "grid grid-cols-7 gap-1")
              }, [
                (l(!0), s(n1, null, u1(H.value, (V, S) => (l(), s("button", {
                  key: S,
                  type: "button",
                  class: v(L(V)),
                  disabled: !V.day,
                  onClick: (z) => V.day ? Z(V.date) : null
                }, M(V.day || ""), 11, mm))), 128))
              ], 2)
            ]))
          ], 2),
          i.value ? (l(), s("div", xm, [
            o("button", {
              type: "button",
              class: "rounded-lg border border-grey-100 bg-white px-4 py-2 text-sm font-normal tracking-tight text-grey-950 transition-colors hover:bg-grey-50",
              onClick: O
            }, M(e.clearText), 1),
            o("button", {
              type: "button",
              class: "rounded-lg bg-primary px-4 py-2 text-sm font-medium tracking-tight text-white transition-opacity hover:opacity-90",
              onClick: U
            }, M(e.applyText), 1)
          ])) : (l(), s("div", wm, [
            o("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm text-subtitle-gray transition-colors hover:text-default-black",
              onClick: O
            }, M(e.clearText), 1),
            o("button", {
              type: "button",
              class: "rounded-lg bg-primary px-4 py-1.5 text-sm font-medium text-white transition-opacity hover:opacity-90",
              onClick: U
            }, M(e.applyText), 1)
          ]))
        ], 2)
      ], 4)) : x("", !0)
    ]));
  }
}), ym = {
  key: 0,
  class: "w-[260px] rounded-lg bg-white shadow-lg border border-gray-200 overflow-hidden"
}, bm = { class: "p-3" }, _m = ["placeholder"], Mm = { class: "flex items-center justify-between px-3 py-2 border-t border-gray-200 bg-gray-50" }, Lm = {
  key: 1,
  class: "w-[220px] rounded-xl bg-white shadow-xl border border-border-gray overflow-hidden flex flex-col max-h-60"
}, $m = { class: "px-4 py-2.5 border-b bg-grey-50 border-border-gray" }, Vm = { class: "text-sm font-medium text-default-black" }, Bm = {
  key: 0,
  class: "border-b border-border-gray bg-white py-2 px-1"
}, Hm = { class: "flex items-center w-full h-8 py-1.5 pr-2 pl-3 bg-grey-50 rounded-lg gap-1.5" }, Fm = ["placeholder"], Am = { class: "overflow-x-hidden overflow-y-auto flex-1 ecx-filter-badge-scroll" }, jm = {
  key: 0,
  class: "px-4 py-3 text-sm text-subtitle-gray text-center"
}, Im = ["onClick"], Zm = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, Em = ["title"], Sm = {
  key: 2,
  class: "w-[280px] rounded-lg bg-white shadow-lg border border-gray-200 overflow-hidden"
}, zm = { class: "p-4" }, Dm = { class: "flex items-center gap-x-3 mb-4" }, Tm = { class: "flex-1" }, Om = { class: "block text-xs text-subtitle-gray mb-1" }, Pm = ["max"], Rm = { class: "flex-1" }, Nm = { class: "block text-xs text-subtitle-gray mb-1" }, Gm = ["min", "max"], Um = { class: "px-2" }, Wm = ["max"], Ym = ["min", "max"], qm = { class: "flex items-center justify-between px-3 py-2 border-t border-gray-200 bg-gray-50" }, Km = 5, Qm = /* @__PURE__ */ I({
  __name: "EcxFilterBadge",
  props: {
    filterKey: {},
    label: {},
    type: {},
    modelValue: {},
    placeholder: { default: "" },
    selectOptions: {},
    searchable: { type: Boolean, default: void 0 },
    clearText: { default: "Limpar" },
    applyText: { default: "Aplicar" },
    searchPlaceholder: { default: "Pesquisar" },
    noResultsText: { default: "Nenhum resultado encontrado" },
    minLabel: { default: "Mínimo" },
    maxLabel: { default: "Máximo" },
    rangeMax: { default: 120 },
    rangeUnit: { default: "" },
    defaultRangeMin: { default: 18 },
    defaultRangeMax: { default: 65 },
    alwaysShowTrailingDismiss: { type: Boolean, default: !1 },
    hideTrailingDismiss: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "remove"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(null), a = E(null), d = E(null), u = E(null), h = E(!1), C = E(""), m = E({ start: null, end: null }), c = E([]), p = E({ min: r.defaultRangeMin, max: r.defaultRangeMax }), k = E(""), j = f(() => {
      var S;
      return r.searchable === !0 ? !0 : r.searchable === !1 ? !1 : (((S = r.selectOptions) == null ? void 0 : S.length) ?? 0) >= Km;
    }), H = f(() => {
      if (!r.selectOptions) return [];
      if (!k.value.trim()) return r.selectOptions;
      const S = k.value.toLowerCase().trim();
      return r.selectOptions.filter(
        (z) => z.label.toLowerCase().includes(S)
      );
    }), L = E({
      top: "-9999px",
      left: "-9999px"
    }), F = f(() => {
      switch (r.type) {
        case "text":
          return !!r.modelValue && r.modelValue.length > 0;
        case "date":
          const S = r.modelValue;
          return (S == null ? void 0 : S.start) || (S == null ? void 0 : S.end);
        case "select":
          return Array.isArray(r.modelValue) && r.modelValue.length > 0;
        case "range":
          const z = r.modelValue;
          return z && (z.min > 0 || z.max < r.rangeMax);
        default:
          return !1;
      }
    }), P = f(
      () => !r.hideTrailingDismiss && (F.value || !!r.alwaysShowTrailingDismiss)
    ), Z = f(() => {
      var S;
      if (!F.value) return r.label;
      switch (r.type) {
        case "text":
          return r.modelValue;
        case "date":
          const z = r.modelValue;
          return z != null && z.start && (z != null && z.end) ? `${T(z.start)} - ${T(z.end)}` : z != null && z.start ? `A partir de ${T(z.start)}` : z != null && z.end ? `Até ${T(z.end)}` : r.label;
        case "select":
          const X = r.modelValue;
          if (X.length === 1) {
            const H1 = (S = r.selectOptions) == null ? void 0 : S.find((I1) => I1.value === X[0]);
            return (H1 == null ? void 0 : H1.label) || X[0];
          }
          return `${X.length} selecionados`;
        case "range":
          const c1 = r.modelValue, b1 = r.rangeUnit ? ` ${r.rangeUnit}` : "";
          return c1.min === c1.max ? `${c1.min}${b1}` : `${c1.min} - ${c1.max}${b1}`;
        default:
          return r.label;
      }
    }), T = (S) => (/* @__PURE__ */ new Date(S + "T00:00:00")).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" }), R = () => {
      h.value = !h.value, h.value ? s1(() => {
        A(), r.type === "text" && u.value && u.value.focus();
      }) : k.value = "";
    }, A = () => {
      if (!a.value || !d.value) return;
      const S = a.value.getBoundingClientRect(), z = d.value.getBoundingClientRect();
      let X = S.bottom + 8, c1 = S.left;
      c1 + z.width > window.innerWidth - 16 && (c1 = S.right - z.width, c1 < 16 && (c1 = 16)), X + z.height > window.innerHeight - 16 && (X = S.top - z.height - 8), L.value = {
        top: `${X}px`,
        left: `${c1}px`
      };
    }, _ = (S) => c.value.includes(S), w = (S) => {
      const z = c.value.indexOf(S.value);
      z === -1 ? c.value.push(S.value) : c.value.splice(z, 1), n("update:modelValue", c.value.length > 0 ? [...c.value] : null);
    }, O = () => {
      n("update:modelValue", C.value || null), h.value = !1;
    }, U = (S) => {
      m.value = S;
    }, $ = (S) => {
      n("update:modelValue", S);
    }, B = () => {
      n("update:modelValue", { ...p.value }), h.value = !1;
    }, y = () => {
      switch (r.type) {
        case "text":
          C.value = "";
          break;
        case "date":
          m.value = { start: null, end: null };
          break;
        case "select":
          c.value = [];
          break;
        case "range":
          p.value = { min: r.defaultRangeMin, max: r.defaultRangeMax };
          break;
      }
      n("update:modelValue", null), h.value = !1, r.hideTrailingDismiss || n("remove");
    }, b = () => {
      y();
    }, V = (S) => {
      var X, c1;
      if (!h.value) return;
      const z = S.target;
      (X = i.value) != null && X.contains(z) || (c1 = d.value) != null && c1.contains(z) || r.type !== "date" && (h.value = !1);
    };
    return r1(() => r.modelValue, (S) => {
      r.type === "text" && typeof S == "string" ? C.value = S : r.type === "date" && S && typeof S == "object" && "start" in S ? m.value = S : r.type === "select" ? c.value = Array.isArray(S) ? [...S] : [] : r.type === "range" && S && typeof S == "object" && "min" in S && (p.value = { ...S });
    }, { immediate: !0 }), m1(() => {
      document.addEventListener("click", V), window.addEventListener("scroll", A, !0), window.addEventListener("resize", A);
    }), y1(() => {
      document.removeEventListener("click", V), window.removeEventListener("scroll", A, !0), window.removeEventListener("resize", A);
    }), (S, z) => (l(), s("div", {
      class: "relative flex items-center",
      ref_key: "containerRef",
      ref: i
    }, [
      o("button", {
        ref_key: "badgeRef",
        ref: a,
        type: "button",
        onClick: R,
        class: v(["ecx-filter-badge flex items-center justify-between transition-colors", [
          F.value ? "bg-royal-25 border border-royal-25" : "bg-grey-50 border border-transparent hover:bg-grey-50"
        ]])
      }, [
        o("span", {
          class: v(["truncate whitespace-nowrap", F.value ? "text-royal-500" : "text-default-black"])
        }, M(Z.value), 3),
        P.value ? (l(), s("span", {
          key: 0,
          onClick: o1(b, ["stop"]),
          class: "hover:opacity-70 transition-opacity flex shrink-0 cursor-pointer items-center justify-center rounded-sm ml-2"
        }, [
          J(Yl, {
            class: "h-4 w-4 shrink-0 text-grey-600",
            "aria-hidden": "true"
          })
        ])) : (l(), W(vt, {
          key: 1,
          class: "ml-2 h-5 w-5 shrink-0 text-grey-600 pointer-events-none",
          "aria-hidden": "true"
        }))
      ], 2),
      (l(), W(g1, { to: "body" }, [
        h.value && e.type !== "date" ? (l(), s("div", {
          key: 0,
          class: "fixed z-[60]",
          ref_key: "popoverRef",
          ref: d,
          style: a1(L.value)
        }, [
          e.type === "text" ? (l(), s("div", ym, [
            o("div", bm, [
              w1(o("input", {
                ref_key: "textInputRef",
                ref: u,
                "onUpdate:modelValue": z[0] || (z[0] = (X) => C.value = X),
                type: "text",
                placeholder: e.placeholder,
                class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary",
                onKeyup: G1(O, ["enter"])
              }, null, 40, _m), [
                [$1, C.value]
              ])
            ]),
            o("div", Mm, [
              o("button", {
                type: "button",
                onClick: y,
                class: "px-3 py-1.5 text-sm text-subtitle-gray hover:text-default-black transition-colors"
              }, M(e.clearText), 1),
              o("button", {
                type: "button",
                onClick: O,
                class: "px-4 py-1.5 text-sm font-medium bg-primary text-white rounded-lg hover:opacity-90 transition-opacity"
              }, M(e.applyText), 1)
            ])
          ])) : e.type === "select" ? (l(), s("div", Lm, [
            o("div", $m, [
              o("h3", Vm, M(e.label), 1)
            ]),
            j.value ? (l(), s("div", Bm, [
              o("div", Hm, [
                z[9] || (z[9] = o("svg", {
                  class: "w-4 h-4 text-subtitle-gray flex-shrink-0",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                  })
                ], -1)),
                w1(o("input", {
                  "onUpdate:modelValue": z[1] || (z[1] = (X) => k.value = X),
                  type: "text",
                  class: "flex-1 text-sm text-default-black placeholder:text-subtitle-gray focus:outline-none bg-transparent",
                  placeholder: e.searchPlaceholder,
                  onClick: z[2] || (z[2] = o1(() => {
                  }, ["stop"])),
                  onKeydown: z[3] || (z[3] = o1(() => {
                  }, ["stop"]))
                }, null, 40, Fm), [
                  [$1, k.value]
                ])
              ])
            ])) : x("", !0),
            o("div", Am, [
              H.value.length === 0 ? (l(), s("div", jm, M(e.noResultsText), 1)) : x("", !0),
              (l(!0), s(n1, null, u1(H.value, (X) => (l(), s("button", {
                key: X.value,
                type: "button",
                onClick: (c1) => w(X),
                class: v([
                  "w-full text-left transition-colors flex items-center cursor-pointer py-2 px-1 gap-2 mx-1",
                  _(X.value) ? "bg-royal-50 rounded-lg" : "ecx-select-option-hover"
                ])
              }, [
                o("div", {
                  class: v([
                    "w-4 h-4 rounded border-2 border-solid flex items-center justify-center transition-colors flex-shrink-0 ml-1",
                    _(X.value) ? "bg-royal-500 border-royal-500" : "border-grey-600 bg-white"
                  ])
                }, [
                  _(X.value) ? (l(), s("svg", Zm, [...z[10] || (z[10] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "3",
                      d: "M5 13l4 4L19 7"
                    }, null, -1)
                  ])])) : x("", !0)
                ], 2),
                o("span", {
                  class: v([
                    "text-sm truncate min-w-0 flex-1",
                    _(X.value) ? "text-royal-500 font-medium" : "text-default-black"
                  ]),
                  title: X.label
                }, M(X.label), 11, Em)
              ], 10, Im))), 128))
            ])
          ])) : e.type === "range" ? (l(), s("div", Sm, [
            o("div", zm, [
              o("div", Dm, [
                o("div", Tm, [
                  o("label", Om, M(e.minLabel), 1),
                  w1(o("input", {
                    "onUpdate:modelValue": z[4] || (z[4] = (X) => p.value.min = X),
                    type: "number",
                    min: "0",
                    max: p.value.max,
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-primary"
                  }, null, 8, Pm), [
                    [
                      $1,
                      p.value.min,
                      void 0,
                      { number: !0 }
                    ]
                  ])
                ]),
                z[11] || (z[11] = o("span", { class: "text-subtitle-gray mt-5" }, "—", -1)),
                o("div", Rm, [
                  o("label", Nm, M(e.maxLabel), 1),
                  w1(o("input", {
                    "onUpdate:modelValue": z[5] || (z[5] = (X) => p.value.max = X),
                    type: "number",
                    min: p.value.min,
                    max: e.rangeMax,
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-primary"
                  }, null, 8, Gm), [
                    [
                      $1,
                      p.value.max,
                      void 0,
                      { number: !0 }
                    ]
                  ])
                ])
              ]),
              o("div", Um, [
                w1(o("input", {
                  type: "range",
                  "onUpdate:modelValue": z[6] || (z[6] = (X) => p.value.min = X),
                  min: 0,
                  max: p.value.max,
                  class: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer ecx-slider mb-2"
                }, null, 8, Wm), [
                  [
                    $1,
                    p.value.min,
                    void 0,
                    { number: !0 }
                  ]
                ]),
                w1(o("input", {
                  type: "range",
                  "onUpdate:modelValue": z[7] || (z[7] = (X) => p.value.max = X),
                  min: p.value.min,
                  max: e.rangeMax,
                  class: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer ecx-slider"
                }, null, 8, Ym), [
                  [
                    $1,
                    p.value.max,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ]),
            o("div", qm, [
              o("button", {
                type: "button",
                onClick: y,
                class: "px-3 py-1.5 text-sm text-subtitle-gray hover:text-default-black transition-colors"
              }, M(e.clearText), 1),
              o("button", {
                type: "button",
                onClick: B,
                class: "px-4 py-1.5 text-sm font-medium bg-primary text-white rounded-lg hover:opacity-90 transition-opacity"
              }, M(e.applyText), 1)
            ])
          ])) : x("", !0)
        ], 4)) : x("", !0)
      ])),
      e.type === "date" ? (l(), W(km, {
        key: 0,
        opened: h.value,
        "button-ref": a.value,
        "model-value": m.value,
        "clear-text": e.clearText,
        "apply-text": e.applyText,
        "onUpdate:modelValue": U,
        onApply: $,
        onClose: z[8] || (z[8] = (X) => h.value = !1)
      }, null, 8, ["opened", "button-ref", "model-value", "clear-text", "apply-text"])) : x("", !0)
    ], 512));
  }
}), HL = /* @__PURE__ */ g(Qm, [["__scopeId", "data-v-edb944e1"]]), Xm = { class: "relative flex items-center min-w-0" }, Qe = 200, Jm = /* @__PURE__ */ I({
  __name: "EcxScrollableFilters",
  setup(e, { expose: t }) {
    const r = E(null), n = E(!1), i = E(!1), a = () => {
      if (!r.value) return;
      const { scrollLeft: h, scrollWidth: C, clientWidth: m } = r.value;
      n.value = h > 0, i.value = h + m < C - 1;
    }, d = (h) => {
      if (!r.value) return;
      const C = h === "left" ? r.value.scrollLeft - Qe : r.value.scrollLeft + Qe;
      r.value.scrollTo({ left: C, behavior: "smooth" });
    };
    let u = null;
    return m1(() => {
      s1(() => {
        a(), r.value && (u = new ResizeObserver(a), u.observe(r.value));
      });
    }), y1(() => {
      u == null || u.disconnect();
    }), t({ updateScrollState: a }), (h, C) => (l(), s("div", Xm, [
      n.value ? (l(), s("button", {
        key: 0,
        type: "button",
        "data-testid": "scroll-left",
        class: "absolute left-0 z-20 flex items-center justify-center w-7 h-8 bg-gradient-to-r from-white via-white/90 to-transparent cursor-pointer hover:from-gray-50",
        onClick: C[0] || (C[0] = (m) => d("left"))
      }, [
        J(Ml, { class: "w-4 h-4 text-subtitle-gray" })
      ])) : x("", !0),
      o("div", {
        ref_key: "containerRef",
        ref: r,
        "data-testid": "filters-container",
        class: v(["flex items-center gap-x-1.5 overflow-x-auto ecx-scrollable-filters__hide-scrollbar scroll-smooth py-1 px-1", { "pl-7": n.value, "pr-7": i.value }]),
        onScroll: a
      }, [
        G(h.$slots, "default", {}, void 0, !0)
      ], 34),
      i.value ? (l(), s("button", {
        key: 1,
        type: "button",
        "data-testid": "scroll-right",
        class: "absolute right-0 z-20 flex items-center justify-center w-7 h-8 bg-gradient-to-l from-white via-white/90 to-transparent cursor-pointer hover:from-gray-50",
        onClick: C[1] || (C[1] = (m) => d("right"))
      }, [
        J(Al, { class: "w-4 h-4 text-subtitle-gray" })
      ])) : x("", !0)
    ]));
  }
}), FL = /* @__PURE__ */ g(Jm, [["__scopeId", "data-v-7a72fb9f"]]), ex = {
  key: 0,
  class: "mb-4"
}, tx = {
  key: 1,
  class: "mt-4"
}, AL = /* @__PURE__ */ I({
  __name: "EcxCard",
  props: {
    padding: { default: "md" },
    variant: { default: "outlined" },
    fullHeight: { type: Boolean, default: !1 },
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, r = {
      none: "",
      sm: "p-4",
      md: "p-6",
      lg: "p-8"
    }, n = {
      default: "bg-white",
      outlined: "bg-white border border-grey-100",
      elevated: "bg-white shadow-md"
    }, i = f(() => [
      "rounded-xl",
      r[t.padding],
      n[t.variant],
      t.fullHeight ? "h-full flex flex-col" : ""
    ]);
    return (a, d) => (l(), s("div", {
      class: v(i.value)
    }, [
      a.$slots.header ? (l(), s("div", ex, [
        G(a.$slots, "header")
      ])) : x("", !0),
      G(a.$slots, "default"),
      a.$slots.footer ? (l(), s("div", tx, [
        G(a.$slots, "footer")
      ])) : x("", !0)
    ], 2));
  }
}), ox = { class: "flex items-center justify-between" }, nx = { key: 0 }, jL = /* @__PURE__ */ I({
  __name: "EcxCardHeader",
  props: {
    title: {},
    size: { default: "sm" }
  },
  setup(e) {
    const t = e, r = {
      xs: "text-xs font-normal text-grey-600 tracking-tight",
      sm: "text-sm font-normal text-grey-600 tracking-tight",
      md: "text-base font-medium text-grey-800",
      lg: "text-lg font-semibold text-grey-950"
    }, n = f(() => r[t.size]);
    return (i, a) => (l(), s("div", ox, [
      o("span", {
        class: v(n.value)
      }, [
        G(i.$slots, "title", {}, () => [
          h1(M(e.title), 1)
        ])
      ], 2),
      i.$slots.action || i.$slots.default ? (l(), s("div", nx, [
        G(i.$slots, "action", {}, () => [
          G(i.$slots, "default")
        ])
      ])) : x("", !0)
    ]));
  }
}), IL = /* @__PURE__ */ I({
  __name: "EcxStatItem",
  props: {
    value: {},
    label: {},
    sublabel: {},
    color: {},
    size: { default: "md" },
    layout: { default: "vertical" },
    width: {},
    currency: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = f(() => [t.layout === "vertical" ? "flex flex-col gap-0.5 items-start justify-center" : "flex items-center gap-2", (t.width, "")].filter(Boolean)), n = {
      sm: "text-lg font-medium text-grey-950",
      md: "text-2xl font-medium text-grey-950 tracking-tight",
      lg: "text-3xl font-bold text-grey-950 font-mont leading-7"
    }, i = {
      sm: "text-[10px] text-grey-600 font-normal",
      md: "text-[11px] text-grey-600 font-normal tracking-tight",
      lg: "text-xs text-grey-600 font-normal"
    }, a = {
      sm: "w-1 h-1",
      md: "w-1.5 h-1.5",
      lg: "w-2 h-2"
    }, d = {
      sm: "gap-0.5",
      md: "gap-1",
      lg: "gap-1.5"
    }, u = f(() => n[t.size]), h = f(() => i[t.size]), C = f(() => "text-[10px] text-grey-500"), m = f(() => a[t.size]), c = f(() => d[t.size]), p = f(() => t.currency && typeof t.value == "number" ? new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(t.value / 100) : t.value);
    return (k, j) => (l(), s("div", {
      class: v(r.value)
    }, [
      o("span", {
        class: v(u.value)
      }, [
        G(k.$slots, "value", {}, () => [
          h1(M(p.value), 1)
        ])
      ], 2),
      o("div", {
        class: v(["flex items-center", c.value])
      }, [
        e.color ? (l(), s("div", {
          key: 0,
          class: v(["rounded-sm flex-shrink-0", m.value]),
          style: a1({ backgroundColor: e.color })
        }, null, 6)) : x("", !0),
        o("span", {
          class: v(h.value)
        }, [
          G(k.$slots, "label", {}, () => [
            h1(M(e.label), 1)
          ])
        ], 2)
      ], 2),
      e.sublabel || k.$slots.sublabel ? (l(), s("span", {
        key: 0,
        class: v(C.value)
      }, [
        G(k.$slots, "sublabel", {}, () => [
          h1(M(e.sublabel), 1)
        ])
      ], 2)) : x("", !0)
    ], 2));
  }
}), rx = {
  key: 0,
  class: "h-px bg-border-gray"
}, lx = ["disabled"], sx = { class: "flex-1 min-w-0" }, ix = {
  key: 0,
  class: "text-sm text-subtitle-gray mt-0.5"
}, ax = {
  key: 0,
  class: "text-sm text-subtitle-gray mb-4"
}, dx = {
  key: 1,
  class: "h-px bg-border-gray"
}, ZL = /* @__PURE__ */ I({
  __name: "EcxAccordion",
  props: {
    title: {},
    subtitle: {},
    description: {},
    defaultOpen: { type: Boolean },
    modelValue: { type: Boolean },
    size: { default: "md" },
    variant: { default: "default" },
    showDivider: { type: Boolean, default: !1 },
    dividerPosition: { default: "top" },
    disabled: { type: Boolean, default: !1 },
    successBorder: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "toggle"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(n.defaultOpen ?? !1);
    r1(() => n.modelValue, (Z) => {
      Z !== void 0 && (a.value = Z);
    });
    const d = () => {
      n.disabled || (a.value = !a.value, i("update:modelValue", a.value), i("toggle", a.value));
    }, u = {
      sm: {
        header: "py-2",
        title: "text-sm",
        iconContainer: "w-6 h-6",
        icon: "w-4 h-4"
      },
      md: {
        header: "py-4",
        title: "text-lg",
        iconContainer: "w-8 h-8",
        icon: "w-5 h-5"
      },
      lg: {
        header: "py-5",
        title: "text-xl",
        iconContainer: "w-10 h-10",
        icon: "w-6 h-6"
      }
    }, h = {
      default: {
        container: "",
        header: "hover:bg-grey-50",
        iconContainer: "bg-grey-50",
        content: "px-2 pb-4 pt-2"
      },
      bordered: {
        container: "border border-grey-200 rounded-lg",
        header: "hover:bg-grey-50 px-4",
        iconContainer: "bg-grey-100",
        content: "px-4 pb-4 pt-2"
      },
      filled: {
        container: "bg-grey-50 rounded-lg",
        header: "hover:bg-grey-100 px-4",
        iconContainer: "bg-white",
        content: "px-4 pb-4 pt-2"
      }
    }, C = h[n.variant].container, m = n.variant === "bordered" && n.successBorder ? "!border-success" : "", c = h[n.variant].header, p = u[n.size].header, k = u[n.size].title, j = h[n.variant].iconContainer, H = u[n.size].iconContainer, L = u[n.size].icon, F = n.disabled ? "text-grey-300" : "text-default-black", P = h[n.variant].content;
    return t({
      isOpen: a,
      toggle: d,
      open: () => {
        a.value = !0, i("update:modelValue", !0);
      },
      close: () => {
        a.value = !1, i("update:modelValue", !1);
      }
    }), (Z, T) => (l(), s("div", {
      class: v(["ecx-accordion", [D(C), e.successBorder ? D(m) : ""]])
    }, [
      e.showDivider && e.dividerPosition === "top" ? (l(), s("div", rx)) : x("", !0),
      o("button", {
        type: "button",
        class: v(["flex items-center justify-between w-full text-left transition-colors rounded-xl px-2", [D(c), D(p)]]),
        disabled: e.disabled,
        onClick: d
      }, [
        o("div", sx, [
          G(Z.$slots, "header", {}, () => [
            o("h3", {
              class: v(["font-semibold text-default-black", D(k)])
            }, M(e.title), 3),
            e.subtitle ? (l(), s("p", ix, M(e.subtitle), 1)) : x("", !0)
          ])
        ]),
        o("div", {
          class: v([
            "flex items-center justify-center rounded-lg flex-shrink-0 transition-colors",
            D(j),
            D(H)
          ])
        }, [
          (l(), s("svg", {
            class: v([
              "transition-transform duration-200",
              a.value ? "rotate-180" : "",
              D(L),
              D(F)
            ]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...T[0] || (T[0] = [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 2))
        ], 2)
      ], 10, lx),
      J(p1, {
        "enter-from-class": "opacity-0 -translate-y-1.5",
        "enter-active-class": "transition duration-200 ease-out",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition duration-200 ease-in",
        "leave-to-class": "opacity-0 -translate-y-2"
      }, {
        default: Y(() => [
          a.value ? (l(), s("div", {
            key: 0,
            class: v([D(P), "ecx-accordion-content"])
          }, [
            e.description ? (l(), s("p", ax, M(e.description), 1)) : x("", !0),
            G(Z.$slots, "default")
          ], 2)) : x("", !0)
        ]),
        _: 3
      }),
      e.showDivider && e.dividerPosition === "bottom" ? (l(), s("div", dx)) : x("", !0)
    ], 2));
  }
}), EL = /* @__PURE__ */ I({
  __name: "EcxDivider",
  props: {
    orientation: { default: "horizontal" },
    color: { default: "default" },
    spacing: { default: "none" },
    thickness: {},
    class: {}
  },
  setup(e) {
    const t = e, r = f(() => t.orientation === "horizontal" ? "w-full" : "h-full"), n = {
      default: "bg-border-gray",
      light: "bg-grey-100",
      dark: "bg-grey-300",
      primary: "bg-primary"
    }, i = {
      none: "",
      sm: t.orientation === "horizontal" ? "my-2" : "mx-2",
      md: t.orientation === "horizontal" ? "my-4" : "mx-4",
      lg: t.orientation === "horizontal" ? "my-6" : "mx-6"
    }, a = n[t.color], d = i[t.spacing], u = f(() => {
      const h = t.thickness || "1px";
      return t.orientation === "horizontal" ? { height: h } : { width: h };
    });
    return (h, C) => (l(), s("div", {
      class: v([
        "ecx-divider",
        r.value,
        D(a),
        D(d)
      ]),
      style: a1(u.value),
      role: "separator"
    }, null, 6));
  }
}), ux = ["disabled", "title"], SL = /* @__PURE__ */ I({
  __name: "EcxCopyButton",
  props: {
    text: {},
    showText: { type: Boolean, default: !1 },
    buttonText: { default: "Copiar" },
    successText: { default: "Copiado!" },
    tooltip: {},
    size: { default: "md" },
    variant: { default: "ghost" },
    disabled: { type: Boolean, default: !1 },
    successDuration: { default: 2e3 }
  },
  emits: ["copied", "error"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(!1), d = E(!1), u = f(() => d.value ? n.successText : n.tooltip || `Copiar ${n.buttonText}`), h = async () => {
      if (!(n.disabled || a.value)) {
        a.value = !0;
        try {
          await navigator.clipboard.writeText(n.text), d.value = !0, i("copied", n.text), setTimeout(() => {
            d.value = !1;
          }, n.successDuration);
        } catch (H) {
          i("error", H);
        } finally {
          a.value = !1;
        }
      }
    }, C = {
      sm: {
        container: "p-1",
        icon: "w-3.5 h-3.5",
        text: "text-xs"
      },
      md: {
        container: "p-1.5",
        icon: "w-4 h-4",
        text: "text-sm"
      },
      lg: {
        container: "p-2",
        icon: "w-5 h-5",
        text: "text-base"
      }
    }, m = {
      ghost: "text-subtitle-gray hover:bg-grey-100 hover:text-default-black",
      subtle: "bg-grey-50 text-subtitle-gray hover:bg-grey-100 hover:text-default-black",
      outline: "border border-grey-200 text-subtitle-gray hover:bg-grey-50 hover:text-default-black"
    }, c = C[n.size].container, p = C[n.size].icon, k = C[n.size].text, j = m[n.variant];
    return t({
      copied: d,
      handleCopy: h
    }), (H, L) => (l(), s("button", {
      type: "button",
      class: v([
        "inline-flex items-center justify-center rounded transition-all duration-200",
        D(c),
        D(j),
        e.disabled && "opacity-50 cursor-not-allowed"
      ]),
      disabled: e.disabled || a.value,
      title: u.value,
      onClick: o1(h, ["stop"])
    }, [
      d.value ? (l(), s("svg", {
        key: 0,
        class: v(["text-success", D(p)]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...L[0] || (L[0] = [
        o("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        }, null, -1)
      ])], 2)) : (l(), s("svg", {
        key: 1,
        class: v(D(p)),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...L[1] || (L[1] = [
        o("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
        }, null, -1)
      ])], 2)),
      e.showText && !d.value ? (l(), s("span", {
        key: 2,
        class: v(["ml-1.5", D(k)])
      }, M(e.text), 3)) : x("", !0),
      e.showText && d.value ? (l(), s("span", {
        key: 3,
        class: v(["ml-1.5", D(k)])
      }, M(e.successText), 3)) : x("", !0)
    ], 10, ux));
  }
}), zL = /* @__PURE__ */ I({
  __name: "EcxCountBadge",
  props: {
    count: {},
    singularText: { default: "item" },
    pluralText: { default: "itens" },
    icon: {},
    showClose: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: "primary" }
  },
  emits: ["close"],
  setup(e) {
    const t = e, r = f(
      () => t.count === 1 ? t.singularText : t.pluralText
    ), n = {
      sm: {
        container: "px-2 py-1",
        icon: "w-3 h-3",
        close: "w-3 h-3",
        text: "text-xs"
      },
      md: {
        container: "px-2.5 py-1.5",
        icon: "w-4 h-4",
        close: "w-4 h-4",
        text: "text-xs"
      },
      lg: {
        container: "px-3 py-2",
        icon: "w-5 h-5",
        close: "w-4 h-4",
        text: "text-sm"
      }
    }, i = {
      primary: {
        container: "bg-royal-25",
        text: "text-primary",
        icon: "text-primary"
      },
      secondary: {
        container: "bg-grey-100",
        text: "text-default-black",
        icon: "text-default-black"
      },
      success: {
        container: "bg-green-50",
        text: "text-green-700",
        icon: "text-green-600"
      },
      warning: {
        container: "bg-yellow-50",
        text: "text-yellow-700",
        icon: "text-yellow-600"
      },
      danger: {
        container: "bg-red-50",
        text: "text-red-700",
        icon: "text-red-600"
      },
      neutral: {
        container: "bg-grey-50",
        text: "text-subtitle-gray",
        icon: "text-subtitle-gray"
      }
    }, a = n[t.size].container, d = n[t.size].icon, u = n[t.size].close, h = n[t.size].text, C = i[t.variant].container, m = i[t.variant].text, c = i[t.variant].icon;
    return (p, k) => (l(), s("div", {
      class: v([
        "inline-flex items-center gap-2 rounded-lg shadow-sm",
        D(a),
        D(C)
      ])
    }, [
      G(p.$slots, "icon", {}, () => [
        e.icon ? (l(), W(f1(e.icon), {
          key: 0,
          class: v(["flex-shrink-0", D(d), D(c)])
        }, null, 8, ["class"])) : (l(), s("svg", {
          key: 1,
          class: v(["flex-shrink-0", D(d), D(c)]),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [...k[1] || (k[1] = [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          }, null, -1)
        ])], 2))
      ]),
      o("span", {
        class: v(["font-normal whitespace-nowrap", D(h), D(m)])
      }, M(e.count) + " " + M(r.value), 3),
      e.showClose ? (l(), s("button", {
        key: 0,
        type: "button",
        class: "flex-shrink-0 hover:opacity-70 transition-opacity",
        onClick: k[0] || (k[0] = (j) => p.$emit("close"))
      }, [
        (l(), s("svg", {
          class: v(["flex-shrink-0", D(u), D(c)]),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 16 16"
        }, [...k[2] || (k[2] = [
          o("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4L12 12M4 12L12 4"
          }, null, -1)
        ])], 2))
      ])) : x("", !0)
    ], 2));
  }
}), DL = /* @__PURE__ */ I({
  __name: "EcxInfoBadge",
  props: {
    label: {},
    value: {},
    icon: {},
    loading: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e, r = {
      sm: {
        container: "px-2 py-1",
        icon: 16,
        text: "text-xs",
        shimmer: "h-3 w-14"
      },
      md: {
        container: "px-3 py-2",
        icon: 18,
        text: "text-sm",
        shimmer: "h-4 w-16"
      },
      lg: {
        container: "px-4 py-2.5",
        icon: 20,
        text: "text-base",
        shimmer: "h-5 w-20"
      }
    }, n = {
      filled: {
        container: "bg-royal-25",
        label: "text-primary",
        value: "text-primary",
        icon: "text-primary",
        shimmer: "bg-royal-100"
      },
      outlined: {
        container: "border border-solid border-border-gray bg-white",
        label: "text-subtitle-gray",
        value: "text-primary",
        icon: "text-subtitle-gray",
        shimmer: "bg-grey-100"
      }
    }, i = r[t.size].container, a = r[t.size].icon, d = r[t.size].text, u = r[t.size].shimmer, h = n[t.variant].container, C = n[t.variant].label, m = n[t.variant].value, c = n[t.variant].icon, p = n[t.variant].shimmer;
    return (k, j) => (l(), s("div", {
      class: v([
        "inline-flex items-center gap-2 rounded-lg",
        D(i),
        D(h)
      ])
    }, [
      G(k.$slots, "icon", {}, () => [
        e.icon ? (l(), W(f1(e.icon), {
          key: 0,
          size: D(a),
          class: v(["flex-shrink-0", D(c)])
        }, null, 8, ["size", "class"])) : x("", !0)
      ]),
      o("span", {
        class: v(["font-normal", D(d), D(C)])
      }, M(e.label), 3),
      e.loading ? (l(), s("span", {
        key: 0,
        class: v(["rounded animate-pulse", D(p), D(u)])
      }, null, 2)) : (l(), s("span", {
        key: 1,
        class: v(["font-semibold", D(d), D(m)])
      }, M(e.value), 3))
    ], 2));
  }
}), cx = { class: "text-sm font-medium text-default-black" }, hx = 240, X1 = 4, TL = /* @__PURE__ */ I({
  __name: "EcxPopover",
  props: {
    modelValue: { type: Boolean },
    title: {},
    position: { default: "bottom" },
    align: { default: "end" },
    width: { default: "w-64" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    toggleOnClick: { type: Boolean, default: !0 },
    offset: { default: 8 },
    headerClass: { default: "" },
    contentClass: { default: "" },
    footerClass: { default: "" },
    popoverZIndexClass: { default: "z-50" },
    matchTriggerWidth: { type: Boolean, default: !1 },
    autoFlipVertical: { type: Boolean, default: !0 },
    containInScrollParent: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "open", "close"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = E(null), d = E(null), u = E(null), h = E(n.modelValue ?? !1), C = E("bottom"), m = E(null), c = E({
      top: 0,
      left: 0,
      triggerWidthPx: null
    });
    function p(_) {
      let w = _.parentElement, O = null;
      for (; w && w !== document.documentElement; ) {
        if (w.hasAttribute("data-ecx-popover-boundary")) {
          const V = w.getBoundingClientRect();
          return {
            top: V.top,
            bottom: V.bottom,
            left: V.left,
            right: V.right
          };
        }
        const U = window.getComputedStyle(w), $ = U.overflowY, B = U.overflowX;
        if (O === null && ($ === "auto" || $ === "scroll" || $ === "overlay" || (B === "auto" || B === "scroll" || B === "overlay"))) {
          const V = w.getBoundingClientRect();
          O = {
            top: V.top,
            bottom: V.bottom,
            left: V.left,
            right: V.right
          };
        }
        w = w.parentElement;
      }
      return O !== null ? O : {
        top: 0,
        bottom: window.innerHeight,
        left: 0,
        right: window.innerWidth
      };
    }
    function k(_, w, O, U) {
      const $ = U.top + X1, B = U.bottom - X1, y = Math.max(0, B - $), b = Math.min(O, y);
      if (_ === "bottom") {
        let S = w;
        return S = Math.max(S, $), S = Math.min(S, B - b), Math.max(S, $);
      }
      let V = w;
      return V = Math.min(V, B), V = Math.max(V, $ + b), V;
    }
    function j(_, w, O, U) {
      const $ = U.left + X1, B = U.right - X1;
      if (_ === "start")
        return Math.min(Math.max(w, $), B - O);
      if (_ === "center") {
        const y = O / 2;
        return Math.min(
          Math.max(w, $ + y),
          B - y
        );
      }
      return Math.min(Math.max(w, $ + O), B);
    }
    function H(_, w, O, U, $) {
      const B = O.bottom - w.bottom - $, y = w.top - O.top - $;
      return _ === "bottom" ? B >= U ? "bottom" : y >= U || y >= B ? "top" : "bottom" : _ === "top" ? y >= U ? "top" : B >= U ? "bottom" : y >= B ? "top" : "bottom" : "bottom";
    }
    r1(() => n.modelValue, (_) => {
      _ !== void 0 && (h.value = _);
    }), r1(h, async (_) => {
      _ ? (await s1(), Z(), n.autoFlipVertical && requestAnimationFrame(() => {
        h.value && Z();
      }), i("open")) : (m.value = null, i("close")), i("update:modelValue", _);
    });
    const L = () => {
      h.value = !h.value;
    }, F = () => {
      h.value = !0;
    }, P = () => {
      h.value = !1;
    }, Z = () => {
      var S;
      const _ = ((S = d.value) == null ? void 0 : S.firstElementChild) || d.value;
      if (!_) return;
      const w = _.getBoundingClientRect(), O = n.offset;
      m.value = null;
      const $ = (n.position === "bottom" || n.position === "top") && (n.containInScrollParent || n.autoFlipVertical) ? p(_) : null;
      let B = u.value && u.value.offsetHeight > 0 ? u.value.offsetHeight : hx;
      if ($ && n.containInScrollParent && u.value && u.value.offsetHeight > 0) {
        const z = $.bottom - $.top - X1 * 2;
        z > 0 && B > z && (m.value = z, B = z);
      }
      let y = n.position === "top" ? "top" : "bottom";
      n.autoFlipVertical && (n.position === "bottom" || n.position === "top") && $ && (y = H(
        n.position,
        w,
        $,
        B,
        O
      )), C.value = y;
      let b = 0, V = 0;
      switch (n.position) {
        case "bottom":
        case "top":
          b = y === "bottom" ? w.bottom + O : w.top - O;
          break;
        case "left":
          V = w.left - O;
          break;
        case "right":
          V = w.right + O;
          break;
      }
      if (n.position === "bottom" || n.position === "top")
        switch (n.align) {
          case "start":
            V = w.left;
            break;
          case "center":
            V = w.left + w.width / 2;
            break;
          case "end":
            V = w.right;
            break;
        }
      else
        switch (n.align) {
          case "start":
            b = w.top;
            break;
          case "center":
            b = w.top + w.height / 2;
            break;
          case "end":
            b = w.bottom;
            break;
        }
      if ($ && n.containInScrollParent) {
        b = k(y, b, B, $);
        const z = u.value && u.value.offsetWidth > 0 ? u.value.offsetWidth : null;
        z != null && z > 0 && (V = j(n.align, V, z, $));
      }
      c.value = {
        top: b,
        left: V,
        triggerWidthPx: n.matchTriggerWidth ? w.width : null
      };
    }, T = f(() => {
      const _ = {
        top: `${c.value.top}px`
      };
      m.value != null && (_.maxHeight = `${m.value}px`);
      const w = c.value.triggerWidthPx;
      if (n.matchTriggerWidth && w != null && w > 0 && (_.width = `${w}px`), n.position === "bottom" || n.position === "top")
        switch (n.align) {
          case "start":
            _.left = `${c.value.left}px`;
            break;
          case "center":
            _.left = `${c.value.left}px`, _.transform = "translateX(-50%)";
            break;
          case "end":
            _.left = `${c.value.left}px`, _.transform = "translateX(-100%)";
            break;
        }
      return (n.position === "bottom" || n.position === "top") && C.value === "top" && (_.transform = (_.transform || "") + " translateY(-100%)"), _;
    }), R = f(() => n.matchTriggerWidth ? "" : n.width.startsWith("w-") ? n.width : ""), A = (_) => {
      if (!n.closeOnClickOutside || !h.value) return;
      const w = _.target, O = a.value, U = u.value;
      O != null && O.contains(w) || U != null && U.contains(w) || P();
    };
    return m1(() => {
      document.addEventListener("click", A), window.addEventListener("resize", Z), window.addEventListener("scroll", Z, !0);
    }), y1(() => {
      document.removeEventListener("click", A), window.removeEventListener("resize", Z), window.removeEventListener("scroll", Z, !0);
    }), t({
      isOpen: h,
      toggle: L,
      open: F,
      close: P,
      updatePosition: Z
    }), (_, w) => (l(), s("div", {
      class: v([
        "ecx-popover relative",
        e.matchTriggerWidth ? "block w-full min-w-0" : "inline-block"
      ]),
      ref_key: "containerRef",
      ref: a
    }, [
      o("div", {
        ref_key: "triggerRef",
        ref: d,
        onClick: w[0] || (w[0] = (O) => e.toggleOnClick && L())
      }, [
        G(_.$slots, "trigger", {
          isOpen: h.value,
          toggle: L
        })
      ], 512),
      (l(), W(g1, { to: "body" }, [
        J(p1, {
          "enter-active-class": "transition duration-150 ease-out",
          "enter-from-class": "opacity-0 scale-95",
          "enter-to-class": "opacity-100 scale-100",
          "leave-active-class": "transition duration-100 ease-in",
          "leave-from-class": "opacity-100 scale-100",
          "leave-to-class": "opacity-0 scale-95"
        }, {
          default: Y(() => [
            h.value ? (l(), s("div", {
              key: 0,
              ref_key: "popoverRef",
              ref: u,
              class: v([
                "fixed rounded-lg bg-white shadow-lg border border-grey-200",
                m.value != null ? "overflow-x-hidden overflow-y-auto" : "overflow-hidden",
                e.popoverZIndexClass,
                R.value
              ]),
              style: a1(T.value)
            }, [
              e.title || _.$slots.header ? (l(), s("div", {
                key: 0,
                class: v([
                  "px-4 py-3 border-b bg-grey-50 border-grey-100",
                  e.headerClass
                ])
              }, [
                G(_.$slots, "header", {}, () => [
                  o("h3", cx, M(e.title), 1)
                ])
              ], 2)) : x("", !0),
              o("div", {
                class: v(["px-3 py-3", e.contentClass])
              }, [
                G(_.$slots, "default", { close: P })
              ], 2),
              _.$slots.footer ? (l(), s("div", {
                key: 1,
                class: v([
                  "px-4 py-3 border-t bg-grey-50 border-grey-100",
                  e.footerClass
                ])
              }, [
                G(_.$slots, "footer", { close: P })
              ], 2)) : x("", !0)
            ], 6)) : x("", !0)
          ]),
          _: 3
        })
      ]))
    ], 2));
  }
}), px = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, fx = ["aria-label"], Cx = ["onClick"], gx = ["aria-label"], vx = { key: 0 }, mx = {
  key: 0,
  class: "bg-white"
}, xx = { class: "flex items-center gap-x-3" }, wx = {
  key: 0,
  class: "w-5 h-5 rounded bg-gray-200 skeleton-shimmer"
}, kx = {
  key: 0,
  class: "flex justify-end"
}, yx = {
  key: 1,
  class: "bg-white"
}, bx = ["onClick"], _x = { class: "flex items-center gap-x-2" }, Mx = ["onClick"], Lx = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, $x = { class: "text-sm text-default-black" }, Vx = {
  key: 0,
  class: "flex justify-end"
}, Bx = {
  key: 2,
  class: "flex items-center justify-center gap-2 py-4",
  role: "status",
  "aria-live": "polite"
}, Hx = { class: "text-sm text-subtitle-gray" }, Fx = {
  key: 3,
  class: "h-8 bg-white"
}, Ax = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20 px-4 bg-white absolute inset-0 top-[44px]"
}, jx = { class: "text-xl font-semibold text-default-black mb-2" }, Ix = { class: "text-sm text-subtitle-gray mb-8 text-center max-w-md" }, Zx = { class: "text-sm text-primary" }, Ex = /* @__PURE__ */ I({
  __name: "EcxTable",
  props: {
    items: {},
    columns: {},
    itemKey: {},
    selectable: { type: Boolean, default: !1 },
    selectedItems: {},
    sortable: { type: Boolean, default: !0 },
    currentSort: {},
    loading: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    loadingMoreText: { default: "Carregando..." },
    pagination: {},
    hasActions: { type: Boolean, default: !0 },
    skeletonRows: { default: 10 },
    emptyTitle: { default: "Nenhum resultado encontrado" },
    emptyDescription: { default: "Não há dados para exibir no momento." },
    showFooter: { type: Boolean, default: !0 },
    footerInfo: { default: "" },
    customGridTemplate: {},
    scrollContentMinWidth: {},
    stickyHeader: { type: Boolean, default: !0 },
    rowClass: {},
    clickableRows: { type: Boolean, default: !1 },
    headerRowClass: { default: "" },
    flushChrome: { type: Boolean, default: !1 },
    headerFirstCellClass: { default: "" },
    showBodyBottomSpacer: { type: Boolean, default: !0 },
    loadMoreUsesViewport: { type: Boolean, default: !1 }
  },
  emits: ["load-more", "toggle-selection", "select-all", "sort", "row-click"],
  setup(e, { expose: t, emit: r }) {
    const n = e, i = r, a = f(() => n.scrollContentMinWidth ? { minWidth: `max(100%, ${n.scrollContentMinWidth})` } : { minWidth: "100%" }), d = E(null), u = E(null), h = E(null), C = E(0), m = E(0), c = E(0), p = E(0), k = E(!1), j = f(
      () => k.value || n.loadingMore === !0
    );
    let H = !1, L = 0, F = 0, P = null, Z = 0, T = null;
    const R = f(() => {
      if (n.customGridTemplate)
        return n.customGridTemplate;
      const q = n.columns.map((t1) => t1.width || "1fr");
      return n.hasActions && q.push("auto"), q.join(" ");
    }), A = f(() => C.value > m.value), _ = f(() => C.value <= 0 || m.value <= 0 || c.value <= 0 ? 137 : Math.min(240, c.value)), w = f(() => {
      if (C.value <= m.value || c.value <= 0) return 0;
      const q = C.value - m.value, t1 = c.value - _.value;
      return q <= 0 || t1 <= 0 ? 0 : p.value / q * t1;
    }), O = f(() => {
      var q;
      return (((q = n.selectedItems) == null ? void 0 : q.size) || 0) > 0;
    }), U = f(() => !O.value || !n.selectedItems ? !1 : n.items.every((q) => {
      var t1;
      return (t1 = n.selectedItems) == null ? void 0 : t1.has(B(q));
    })), $ = (q, t1) => typeof n.itemKey == "function" ? n.itemKey(q) : n.itemKey && q[n.itemKey] !== void 0 ? q[n.itemKey] : t1, B = (q) => typeof n.itemKey == "function" ? n.itemKey(q) : n.itemKey && q[n.itemKey] !== void 0 ? q[n.itemKey] : "id" in q ? q.id : n.items.indexOf(q), y = (q, t1) => {
      if (!t1) return "";
      const v1 = t1.split(".");
      let e1 = q;
      for (const d1 of v1)
        e1 = e1 == null ? void 0 : e1[d1];
      return e1 ?? "";
    }, b = (q) => n.selectedItems ? n.selectedItems.has(B(q)) : !1, V = (q) => {
      i("toggle-selection", q);
    }, S = () => {
      i("select-all", !U.value);
    }, z = (q) => {
      var e1;
      const t1 = n.columns.find((d1) => d1.id === q), v1 = (t1 == null ? void 0 : t1.sortField) || q;
      return ((e1 = n.currentSort) == null ? void 0 : e1.column) === v1 ? n.currentSort.direction : null;
    }, X = (q) => {
      var d1, _1;
      const t1 = n.columns.find((P1) => P1.id === q), v1 = (t1 == null ? void 0 : t1.sortField) || q;
      if (!(((d1 = n.currentSort) == null ? void 0 : d1.column) === v1)) {
        i("sort", { column: v1, direction: "asc" });
        return;
      }
      if (((_1 = n.currentSort) == null ? void 0 : _1.direction) === "asc") {
        i("sort", { column: v1, direction: "desc" });
        return;
      }
      i("sort", null);
    }, c1 = () => {
      d.value && !H && (p.value = d.value.scrollLeft);
    }, b1 = () => {
      d.value && (c1(), P && clearTimeout(P), P = setTimeout(() => {
        var d1;
        if (n.loadMoreUsesViewport || k.value || n.loadingMore || !((d1 = n.pagination) != null && d1.next) || !d.value)
          return;
        const q = d.value, t1 = q.scrollTop, v1 = q.scrollHeight, e1 = q.clientHeight;
        t1 + e1 >= v1 * 0.8 && H1();
      }, 150));
    };
    function H1() {
      var q;
      k.value || n.loadingMore || !((q = n.pagination) != null && q.next) || (k.value = !0, Z = n.items.length, i("load-more"));
    }
    function I1(q) {
      const t1 = q[0];
      t1 != null && t1.isIntersecting && H1();
    }
    function Y1() {
      T == null || T.disconnect(), T = null;
    }
    function le() {
      Y1(), !(!n.loadMoreUsesViewport || !u.value) && (T = new IntersectionObserver(I1, {
        root: null,
        rootMargin: "200px",
        threshold: 0
      }), T.observe(u.value));
    }
    const we = (q) => {
      H = !0, L = q.clientX, F = p.value, document.addEventListener("mousemove", se), document.addEventListener("mouseup", q1), document.body.style.userSelect = "none";
    }, se = (q) => {
      if (!H || !d.value) return;
      const t1 = q.clientX - L, v1 = C.value - m.value, e1 = c.value - _.value;
      if (e1 <= 0) return;
      const d1 = t1 / e1 * v1, _1 = Math.max(0, Math.min(v1, F + d1));
      d.value.scrollLeft = _1, p.value = _1;
    }, q1 = () => {
      H = !1, document.removeEventListener("mousemove", se), document.removeEventListener("mouseup", q1), document.body.style.userSelect = "";
    }, ke = (q) => {
      if (!h.value || !d.value) return;
      const t1 = h.value.getBoundingClientRect(), v1 = q.clientX - t1.left, e1 = C.value - m.value;
      if (c.value <= 0) return;
      const d1 = Math.max(0, Math.min(e1, v1 / c.value * e1));
      d.value.scrollLeft = d1, p.value = d1;
    }, Z1 = () => {
      if (d.value) {
        const q = d.value.querySelector("[data-ecx-table-scroll-content]");
        q && (C.value = q.scrollWidth, m.value = d.value.clientWidth, c.value = m.value - 32);
      }
    };
    r1(() => n.items.length, (q) => {
      k.value && q > Z && (k.value = !1), Z = q, s1(() => {
        Z1();
      });
    }), r1(() => {
      var q;
      return (q = n.pagination) == null ? void 0 : q.next;
    }, (q) => {
      !q && k.value && (k.value = !1);
    }), r1(
      () => n.loadingMore,
      (q) => {
        q || (k.value = !1);
      }
    ), r1(
      () => {
        var q;
        return [n.loadMoreUsesViewport, n.items.length, n.loading, (q = n.pagination) == null ? void 0 : q.next];
      },
      () => {
        if (!n.loadMoreUsesViewport) {
          Y1();
          return;
        }
        s1(() => {
          le();
        });
      }
    );
    let A1 = null;
    return m1(() => {
      if (d.value) {
        A1 = new ResizeObserver(() => {
          Z1();
        });
        const q = d.value.querySelector("[data-ecx-table-scroll-content]");
        q && A1.observe(q), A1.observe(d.value);
      }
      s1(() => {
        Z1(), setTimeout(Z1, 100), n.loadMoreUsesViewport && le();
      });
    }), y1(() => {
      Y1(), A1 && A1.disconnect(), q1(), P && clearTimeout(P);
    }), t({
      scrollToTop: () => {
        d.value && (d.value.scrollTop = 0);
      },
      updateScrollbar: Z1
    }), (q, t1) => {
      var v1;
      return l(), s("div", {
        class: v([
          "flex min-h-0 flex-col bg-white overflow-hidden h-full",
          e.flushChrome ? "rounded-none border-0" : "rounded-lg border-l border-r border-solid border-gray-200"
        ])
      }, [
        o("div", {
          class: "min-h-0 flex-1 overflow-auto custom-horizontal-scrollbar relative",
          ref_key: "tableBody",
          ref: d,
          onScroll: b1
        }, [
          o("div", {
            class: "w-max",
            "data-ecx-table-scroll-content": "",
            style: a1(a.value)
          }, [
            o("div", {
              class: v(["grid text-subtitle-gray font-medium text-xs uppercase items-center py-2.5 px-4 gap-4 bg-border-gray border-b border-grey-100", [{ "sticky top-0 z-10": e.stickyHeader }, e.headerRowClass]]),
              ref: "tableHeader",
              style: a1({ gridTemplateColumns: R.value })
            }, [
              o("div", {
                class: v(["flex items-center gap-x-2 min-w-0", e.headerFirstCellClass])
              }, [
                e.selectable ? (l(), s("button", {
                  key: 0,
                  type: "button",
                  onClick: S,
                  class: v(["flex items-center justify-center w-5 h-5 rounded border-2 transition-all duration-200 ease-out flex-shrink-0", U.value ? "bg-primary border-primary" : "bg-white border-grey-200"])
                }, [
                  U.value ? (l(), s("svg", px, [...t1[3] || (t1[3] = [
                    o("path", {
                      "fill-rule": "evenodd",
                      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ])])) : x("", !0)
                ], 2)) : x("", !0),
                e.columns[0] ? (l(), s("div", {
                  key: 1,
                  class: v(["flex items-center gap-x-2 transition-colors", [
                    e.columns[0].sortable !== !1 && e.sortable ? "cursor-pointer hover:text-primary" : "",
                    z(e.columns[0].id) ? "text-primary" : ""
                  ]]),
                  onClick: t1[1] || (t1[1] = (e1) => e.columns[0].sortable !== !1 && e.sortable && X(e.columns[0].id))
                }, [
                  o("span", null, M(e.columns[0].label), 1),
                  e.columns[0].helpTooltip ? (l(), W(fe, {
                    key: 0,
                    content: e.columns[0].helpTooltip,
                    placement: "top",
                    "max-width": "20rem"
                  }, {
                    default: Y(() => [
                      o("button", {
                        type: "button",
                        class: "inline-flex shrink-0 cursor-help text-grey-600",
                        "aria-label": e.columns[0].helpTooltipAriaLabel || e.columns[0].helpTooltip,
                        onClick: t1[0] || (t1[0] = o1(() => {
                        }, ["stop"]))
                      }, [
                        J(Ke, { class: "h-3 w-3" })
                      ], 8, fx)
                    ]),
                    _: 1
                  }, 8, ["content"])) : x("", !0),
                  e.columns[0].sortable !== !1 && e.sortable ? (l(), s("svg", {
                    key: 1,
                    class: v(["w-3 h-3 transition-transform duration-200", {
                      "text-primary": z(e.columns[0].id),
                      "rotate-180": z(e.columns[0].id) === "desc"
                    }]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [...t1[4] || (t1[4] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                    }, null, -1)
                  ])], 2)) : x("", !0)
                ], 2)) : x("", !0)
              ], 2),
              (l(!0), s(n1, null, u1(e.columns.slice(1), (e1) => (l(), s("div", {
                key: e1.id,
                class: v(["flex items-center gap-x-2 transition-colors", [
                  e1.align === "center" ? "justify-center" : "",
                  e1.align === "right" ? "justify-end" : "",
                  e1.sortable !== !1 && e.sortable ? "cursor-pointer hover:text-primary" : "",
                  z(e1.id) ? "text-primary" : ""
                ]]),
                onClick: (d1) => e1.sortable !== !1 && e.sortable && X(e1.id)
              }, [
                o("span", null, M(e1.label), 1),
                e1.helpTooltip ? (l(), W(fe, {
                  key: 0,
                  content: e1.helpTooltip,
                  placement: "top",
                  "max-width": "20rem"
                }, {
                  default: Y(() => [
                    o("button", {
                      type: "button",
                      class: "inline-flex shrink-0 cursor-help text-grey-600",
                      "aria-label": e1.helpTooltipAriaLabel || e1.helpTooltip,
                      onClick: t1[2] || (t1[2] = o1(() => {
                      }, ["stop"]))
                    }, [
                      J(Ke, { class: "h-3 w-3" })
                    ], 8, gx)
                  ]),
                  _: 2
                }, 1032, ["content"])) : x("", !0),
                e1.sortable !== !1 && e.sortable ? (l(), s("svg", {
                  key: 1,
                  class: v(["w-3 h-3 transition-transform duration-200", {
                    "text-primary": z(e1.id),
                    "rotate-180": z(e1.id) === "desc"
                  }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...t1[5] || (t1[5] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                  }, null, -1)
                ])], 2)) : x("", !0)
              ], 10, Cx))), 128)),
              e.hasActions ? (l(), s("div", vx)) : x("", !0)
            ], 6),
            e.loading ? (l(), s("div", mx, [
              (l(!0), s(n1, null, u1(e.skeletonRows, (e1) => (l(), s("div", {
                key: `skeleton-${e1}`,
                class: "grid items-center py-3 px-4 gap-4 border-b border-grey-100",
                style: a1({ gridTemplateColumns: R.value })
              }, [
                G(q.$slots, "skeleton-row", { columns: e.columns }, () => [
                  o("div", xx, [
                    e.selectable ? (l(), s("div", wx)) : x("", !0),
                    t1[6] || (t1[6] = N('<div class="flex items-center gap-x-3" data-v-6e0b50ff><div class="w-10 h-10 rounded-full bg-gray-200 skeleton-shimmer" data-v-6e0b50ff></div><div class="flex flex-col gap-y-1" data-v-6e0b50ff><div class="w-32 h-4 rounded bg-gray-200 skeleton-shimmer" data-v-6e0b50ff></div><div class="w-24 h-3 rounded bg-gray-200 skeleton-shimmer" data-v-6e0b50ff></div></div></div>', 1))
                  ]),
                  (l(!0), s(n1, null, u1(e.columns.slice(1), (d1) => (l(), s("div", {
                    key: `skeleton-col-${e1}-${d1.id}`,
                    class: v(["flex items-center", { "justify-center": d1.align === "center" }])
                  }, [
                    o("div", {
                      class: "h-4 rounded bg-gray-200 skeleton-shimmer",
                      style: a1({ width: d1.skeletonWidth || "80px" })
                    }, null, 4)
                  ], 2))), 128)),
                  e.hasActions ? (l(), s("div", kx, [...t1[7] || (t1[7] = [
                    o("div", { class: "w-8 h-8 rounded bg-gray-200 skeleton-shimmer" }, null, -1)
                  ])])) : x("", !0)
                ], !0)
              ], 4))), 128))
            ])) : e.items.length ? (l(), s("div", yx, [
              q.$slots["full-row"] ? (l(!0), s(n1, { key: 0 }, u1(e.items, (e1, d1) => G(q.$slots, "full-row", {
                key: $(e1, d1),
                item: e1,
                index: d1,
                columns: e.columns,
                isSelected: b(e1),
                toggleSelection: () => V(e1),
                gridTemplateColumns: R.value
              }, void 0, !0)), 128)) : (l(!0), s(n1, { key: 1 }, u1(e.items, (e1, d1) => (l(), s("div", {
                key: $(e1, d1),
                class: v(["grid items-center py-3 px-4 gap-4 border-b border-grey-100 hover:bg-gray-50 transition-colors", [
                  e.clickableRows ? "cursor-pointer" : "",
                  e.rowClass ? e.rowClass(e1, d1) : ""
                ]]),
                style: a1({ gridTemplateColumns: R.value }),
                onClick: (_1) => e.clickableRows && i("row-click", e1, d1)
              }, [
                G(q.$slots, "row", {
                  item: e1,
                  index: d1,
                  columns: e.columns,
                  isSelected: b(e1),
                  toggleSelection: () => V(e1),
                  gridTemplateColumns: R.value
                }, () => {
                  var _1, P1;
                  return [
                    o("div", _x, [
                      e.selectable ? (l(), s("button", {
                        key: 0,
                        type: "button",
                        onClick: o1((M1) => V(e1), ["stop"]),
                        class: v(["flex items-center justify-center w-5 h-5 rounded border-2 transition-all duration-200 ease-out flex-shrink-0", b(e1) ? "bg-primary border-primary" : "bg-white border-grey-200"])
                      }, [
                        b(e1) ? (l(), s("svg", Lx, [...t1[8] || (t1[8] = [
                          o("path", {
                            "fill-rule": "evenodd",
                            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ])])) : x("", !0)
                      ], 10, Mx)) : x("", !0),
                      o("span", $x, M(y(e1, ((_1 = e.columns[0]) == null ? void 0 : _1.field) || ((P1 = e.columns[0]) == null ? void 0 : P1.id))), 1)
                    ]),
                    (l(!0), s(n1, null, u1(e.columns.slice(1), (M1) => (l(), s("div", {
                      key: `item-${d1}-${M1.id}`,
                      class: v(["text-sm text-default-black", {
                        "text-center": M1.align === "center",
                        "text-right": M1.align === "right"
                      }])
                    }, M(y(e1, M1.field || M1.id)), 3))), 128)),
                    e.hasActions ? (l(), s("div", Vx, [
                      G(q.$slots, "row-actions", {
                        item: e1,
                        index: d1
                      }, void 0, !0)
                    ])) : x("", !0)
                  ];
                }, !0)
              ], 14, bx))), 128)),
              j.value ? (l(), s("div", Bx, [
                J(mt, {
                  size: "sm",
                  variant: "primary",
                  "container-class": "shrink-0 p-0"
                }),
                o("span", Hx, M(e.loadingMoreText), 1)
              ])) : x("", !0),
              e.showBodyBottomSpacer ? (l(), s("div", Fx)) : x("", !0),
              e.loadMoreUsesViewport && !e.loading && e.items.length && ((v1 = e.pagination) != null && v1.next) ? (l(), s("div", {
                key: 4,
                ref_key: "loadMoreSentinel",
                ref: u,
                class: "h-px w-full shrink-0",
                "aria-hidden": "true"
              }, null, 512)) : x("", !0)
            ])) : x("", !0)
          ], 4),
          !e.loading && !e.items.length ? (l(), s("div", Ax, [
            G(q.$slots, "empty", {}, () => [
              G(q.$slots, "empty-icon", {}, () => [
                t1[9] || (t1[9] = o("svg", {
                  class: "w-24 h-24 text-gray-300 mb-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5",
                    d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                  })
                ], -1))
              ], !0),
              o("h2", jx, M(e.emptyTitle), 1),
              o("p", Ix, M(e.emptyDescription), 1),
              G(q.$slots, "empty-action", {}, void 0, !0)
            ], !0)
          ])) : x("", !0)
        ], 544),
        A.value ? (l(), s("div", {
          key: 0,
          ref_key: "scrollbarTrack",
          ref: h,
          class: "flex-shrink-0 mx-4 mb-2 scrollbar-track cursor-pointer",
          onMousedown: ke
        }, [
          o("div", {
            class: "scrollbar-thumb",
            style: a1({
              width: _.value + "px",
              transform: `translateX(${w.value}px)`
            }),
            onMousedown: o1(we, ["stop"])
          }, null, 36)
        ], 544)) : x("", !0),
        e.showFooter ? (l(), s("div", {
          key: 1,
          class: v(["flex flex-shrink-0 items-center justify-between border-t border-solid border-grey-100 bg-white px-4 py-3", e.flushChrome ? "" : "rounded-b-lg"])
        }, [
          o("div", Zx, [
            G(q.$slots, "footer-info", {}, () => [
              h1(M(e.footerInfo), 1)
            ], !0)
          ]),
          G(q.$slots, "footer-actions", {}, void 0, !0)
        ], 2)) : x("", !0)
      ], 2);
    };
  }
}), OL = /* @__PURE__ */ g(Ex, [["__scopeId", "data-v-6e0b50ff"]]), Sx = { class: "pointer-events-auto w-72 overflow-hidden rounded-lg border border-grey-200 bg-white shadow-lg" }, zx = { class: "flex items-center justify-between border-b border-grey-100 bg-grey-50 px-4 py-2.5" }, Dx = { class: "text-sm font-medium text-grey-950" }, Tx = { class: "max-h-96 overflow-y-auto py-2" }, Ox = {
  key: 0,
  class: "flex flex-col gap-y-1 pb-1"
}, Px = ["id"], Rx = ["for"], Nx = { class: "relative" }, Gx = ["onDragstart", "onDragover", "onDrop"], Ux = ["id", "checked", "onChange"], Wx = ["for"], Yx = 44, qx = /* @__PURE__ */ I({
  __name: "EcxOrganizeTableColumnsPopover",
  props: {
    opened: { type: Boolean },
    columns: {},
    buttonRef: { default: null },
    title: {},
    resetLabel: { default: "" },
    excludeFromListIds: { default: () => [] },
    checkboxDataTestIdPrefix: { default: "" }
  },
  emits: ["update:columns", "close", "reset"],
  setup(e, { emit: t }) {
    const r = e, n = t, i = E(null), a = E({
      top: "-9999px",
      left: "-9999px",
      opacity: 0,
      pointerEvents: "none"
    }), d = E(null), u = E(null), h = f(() => {
      const _ = new Set(r.excludeFromListIds);
      return [...r.columns].filter((w) => w.locked && !_.has(w.id)).sort((w, O) => w.order - O.order);
    }), C = f(() => {
      const _ = new Set(r.excludeFromListIds);
      return [...r.columns].filter((w) => !_.has(w.id) && !w.locked).sort((w, O) => w.order - O.order);
    }), m = f(() => ({
      top: `${(u.value ?? 0) * Yx + 8}px`,
      width: "calc(100% - 32px)"
    }));
    function c(_) {
      return `ecx-organize-column-${_}`;
    }
    function p(_) {
      return r.checkboxDataTestIdPrefix ? {
        "data-testid": `${r.checkboxDataTestIdPrefix}${_}`
      } : {};
    }
    function k(_, w) {
      const O = "mx-2 flex items-center gap-x-3 rounded px-2 py-2.5 transition-all duration-200", U = _.visible ? "border border-royal-500 bg-royal-25" : "border border-transparent", $ = d.value === w ? "scale-95 opacity-50" : "";
      return [O, U, $].filter(Boolean).join(" ");
    }
    function j(_) {
      const w = new Set(r.excludeFromListIds);
      return [...r.columns.filter(($) => w.has($.id) || $.locked).sort(($, B) => $.order - B.order), ..._].map(($, B) => ({ ...$, order: B }));
    }
    function H() {
      if (!r.buttonRef) {
        setTimeout(() => {
          r.buttonRef && r.opened && H();
        }, 10);
        return;
      }
      if (!i.value) {
        s1(() => {
          i.value && r.opened && H();
        });
        return;
      }
      s1(() => {
        !r.buttonRef || !i.value || requestAnimationFrame(() => {
          if (!i.value || !r.buttonRef) return;
          const _ = r.buttonRef.getBoundingClientRect(), w = 288;
          let O = _.bottom + 8, U = _.left;
          U + w > window.innerWidth - 16 && (U = _.right - w, U < 16 && (U = 16));
          const $ = 400;
          O + $ > window.innerHeight - 16 && (O = _.top - $ - 8), O < 16 && (O = 16), a.value = {
            top: `${O}px`,
            left: `${U}px`,
            width: "fit-content",
            height: "fit-content",
            pointerEvents: "none",
            opacity: 1
          };
        });
      });
    }
    function L(_, w) {
      d.value = _, w.dataTransfer && (w.dataTransfer.effectAllowed = "move", w.dataTransfer.setData("text/html", ""));
    }
    function F(_, w) {
      w.preventDefault(), w.dataTransfer && (w.dataTransfer.dropEffect = "move"), d.value !== null && d.value !== _ && (u.value = _);
    }
    function P() {
    }
    function Z(_, w) {
      w.preventDefault();
      const O = u.value;
      if (d.value === null || O === null || d.value === O) {
        u.value = null, d.value = null;
        return;
      }
      const U = [...C.value], $ = U[d.value];
      U.splice(d.value, 1), U.splice(O, 0, $), n("update:columns", j(U)), d.value = null, u.value = null;
    }
    function T() {
      d.value = null, u.value = null;
    }
    function R(_) {
      const w = r.columns.find((U) => U.id === _);
      if (w != null && w.locked) return;
      const O = r.columns.map(
        (U) => U.id === _ ? { ...U, visible: !U.visible } : U
      );
      n("update:columns", O);
    }
    function A(_) {
      if (!r.opened || !i.value) return;
      const w = _.target;
      i.value.contains(w) || r.buttonRef && r.buttonRef.contains(w) || (d.value = null, u.value = null, n("close"));
    }
    return r1(
      () => r.opened,
      (_) => {
        _ && s1(() => {
          requestAnimationFrame(() => {
            s1(() => {
              H();
            });
          });
        });
      }
    ), r1(
      () => r.buttonRef,
      (_) => {
        _ && r.opened && s1(() => {
          H();
        });
      }
    ), m1(() => {
      r.opened && s1(() => {
        setTimeout(() => {
          H();
        }, 0);
      }), window.addEventListener("scroll", H, !0), window.addEventListener("resize", H), document.addEventListener("click", A);
    }), y1(() => {
      window.removeEventListener("scroll", H, !0), window.removeEventListener("resize", H), document.removeEventListener("click", A);
    }), (_, w) => (l(), W(g1, { to: "body" }, [
      e.opened ? (l(), s("div", {
        key: 0,
        ref_key: "popoverContainerRef",
        ref: i,
        class: "pointer-events-none fixed z-50 h-fit w-fit",
        style: a1(a.value)
      }, [
        o("div", Sx, [
          o("div", zx, [
            o("h3", Dx, M(e.title), 1),
            e.resetLabel ? (l(), s("button", {
              key: 0,
              type: "button",
              class: "text-xs text-grey-600 underline transition-colors hover:text-grey-950",
              onClick: w[0] || (w[0] = (O) => n("reset"))
            }, M(e.resetLabel), 1)) : x("", !0)
          ]),
          o("div", Tx, [
            h.value.length ? (l(), s("div", Ox, [
              (l(!0), s(n1, null, u1(h.value, (O) => (l(), s("div", {
                key: O.id,
                class: "mx-2 flex cursor-not-allowed items-center gap-x-3 rounded bg-grey-100 px-2 py-2.5"
              }, [
                o("input", {
                  id: c(O.id),
                  type: "checkbox",
                  checked: "",
                  disabled: "",
                  class: "h-4 w-4 shrink-0 cursor-not-allowed rounded border-grey-200 opacity-50"
                }, null, 8, Px),
                o("label", {
                  for: c(O.id),
                  class: "flex-1 select-none text-sm text-grey-400"
                }, M(O.label), 9, Rx)
              ]))), 128))
            ])) : x("", !0),
            o("div", Nx, [
              u.value !== null && d.value !== null && d.value !== u.value ? (l(), s("div", {
                key: 0,
                class: "absolute z-10 mx-4 h-0.5 bg-primary transition-all",
                style: a1(m.value)
              }, null, 4)) : x("", !0),
              J(me, {
                name: "ecx-organize-cols",
                tag: "div",
                class: "flex flex-col gap-y-1"
              }, {
                default: Y(() => [
                  (l(!0), s(n1, null, u1(C.value, (O, U) => (l(), s("div", {
                    key: O.id,
                    draggable: "true",
                    class: v(k(O, U)),
                    onDragstart: ($) => L(U, $),
                    onDragover: o1(($) => F(U, $), ["prevent"]),
                    onDrop: ($) => Z(U, $),
                    onDragend: T,
                    onDragleave: P
                  }, [
                    w[1] || (w[1] = o("div", { class: "flex-shrink-0 cursor-grab active:cursor-grabbing" }, [
                      o("span", {
                        class: "inline-block text-grey-400",
                        "aria-hidden": "true"
                      }, "⋮⋮")
                    ], -1)),
                    o("input", $e({
                      id: c(O.id),
                      type: "checkbox",
                      checked: O.visible,
                      class: "h-4 w-4 shrink-0 cursor-pointer rounded border-grey-300 text-primary focus:ring-primary"
                    }, { ref_for: !0 }, p(O.id), {
                      onChange: ($) => R(O.id)
                    }), null, 16, Ux),
                    o("label", {
                      for: c(O.id),
                      class: "flex-1 cursor-pointer select-none text-sm text-grey-950"
                    }, M(O.label), 9, Wx)
                  ], 42, Gx))), 128))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 4)) : x("", !0)
    ]));
  }
}), PL = /* @__PURE__ */ g(qx, [["__scopeId", "data-v-118243df"]]), Kx = { class: "flex items-center justify-center w-full" }, Qx = { class: "p-4 flex flex-col items-center gap-3 max-w-xs rounded-[12px] border border-[var(--Primitives-Grey-ECX-100,#ECEEF3)] bg-[var(--Primitives-Base-Write,#FFF)] shadow-[0_12px_18px_0_rgba(1,9,123,0.07)]" }, Xx = { class: "flex-shrink-0 w-14 h-14 flex items-center justify-center [&>svg]:w-full [&>svg]:h-full" }, Jx = { class: "flex flex-col gap-2 items-center text-center" }, ew = { class: "text-base font-normal text-royal-950 tracking-tight" }, tw = { class: "text-xs text-grey-600 tracking-tight" }, RL = /* @__PURE__ */ I({
  __name: "EcxEmptyStateCard",
  props: {
    title: {},
    description: {},
    buttonLabel: {},
    buttonDisabled: { type: Boolean },
    buttonTitle: {},
    iconComponent: {}
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const r = t;
    return (n, i) => (l(), s("div", Kx, [
      o("div", Qx, [
        o("div", Xx, [
          G(n.$slots, "icon", {}, () => [
            e.iconComponent ? (l(), W(f1(e.iconComponent), { key: 0 })) : x("", !0)
          ])
        ]),
        o("div", Jx, [
          o("h3", ew, M(e.title), 1),
          o("p", tw, M(e.description), 1)
        ]),
        G(n.$slots, "action", {}, () => [
          e.buttonLabel ? (l(), W(V1, {
            key: 0,
            variant: "outline",
            size: "sm",
            class: "items-center !py-2 !pl-2.5 !pr-3.5",
            disabled: e.buttonDisabled,
            title: e.buttonTitle,
            onClick: i[0] || (i[0] = (a) => r("action"))
          }, {
            iconLeft: Y(() => [
              (l(), W(f1(gt), { class: "w-5 h-5" }))
            ]),
            default: Y(() => [
              h1(" " + M(e.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "title"])) : x("", !0)
        ])
      ])
    ]));
  }
}), ow = ["aria-label", "aria-expanded", "onKeydown"], nw = ["data-testid", "aria-label", "aria-expanded"], NL = /* @__PURE__ */ I({
  __name: "EcxOptionsMenu",
  props: {
    headerLabel: {},
    ariaLabel: { default: "" },
    menuClass: { default: "w-44" },
    menuAlign: { default: "right" },
    menuVerticalPlacement: { default: "above" },
    triggerTestId: { default: "" },
    labelClass: { default: "text-tooltip-title font-normal text-grey-600 uppercase tracking-wide" },
    bodyClass: { default: "flex flex-col py-1.5" },
    headerSeparator: { type: Boolean, default: !0 },
    showHeaderSortIcon: { type: Boolean, default: !1 }
  },
  setup(e, { expose: t }) {
    const r = e, n = E(null), i = E(null), a = E(null), d = E(!1), u = E(!1), h = E({ top: "0" }), C = f(
      () => u.value ? "overflow-x-hidden overflow-y-auto" : "overflow-hidden"
    ), m = () => {
      d.value = !d.value;
    }, c = () => {
      d.value = !1;
    };
    function p() {
      const L = i.value, F = a.value;
      if (!L || !F) return;
      const P = L.getBoundingClientRect(), Z = F.getBoundingClientRect().height, T = window.innerHeight, R = window.innerWidth, A = 8, _ = 6;
      let w;
      u.value = !1;
      const O = T - A - (P.bottom + _), U = P.top - _ - A, $ = r.menuVerticalPlacement;
      let B = P.bottom + _;
      function y() {
        B = P.top - _ - Z, Z > 0 && B < A ? (B = A, w = `${Math.max(0, P.top - _ - A)}px`, u.value = !0) : Z > 0 && B + Z > T - A && (w = `${T - A - B}px`, u.value = !0);
      }
      function b() {
        B = P.bottom + _, Z > 0 && B + Z > T - A && (w = `${T - A - B}px`, u.value = !0);
      }
      $ === "above" ? y() : $ === "below" ? b() : Z > 0 && Z <= O ? B = P.bottom + _ : Z > 0 && Z <= U ? (B = P.top - _ - Z, B < A && (B = A, w = `${Math.max(0, P.top - _ - A)}px`, u.value = !0)) : Z > 0 ? O >= U ? (B = P.bottom + _, w = `${Math.max(O, 0)}px`, u.value = !0) : (B = A, w = `${Math.max(P.top - _ - A, 0)}px`, u.value = !0) : B = P.bottom + _;
      const V = { top: `${B}px` }, S = F.getBoundingClientRect().width;
      r.menuAlign === "left" ? P.left + S <= R - A || S <= 0 ? V.left = `${P.left}px` : V.right = `${R - P.right}px` : V.right = `${R - P.right}px`, w && (V.maxHeight = w, V.overflowY = "auto", V.overflowX = "hidden"), h.value = V;
    }
    function k() {
      s1(() => {
        p(), requestAnimationFrame(() => p());
      });
    }
    function j() {
      d.value && p();
    }
    r1(d, (L) => {
      L ? (u.value = !1, k(), window.addEventListener("scroll", j, !0), window.addEventListener("resize", j)) : (window.removeEventListener("scroll", j, !0), window.removeEventListener("resize", j));
    });
    const H = (L) => {
      var T, R;
      const F = L.target, P = (T = n.value) == null ? void 0 : T.contains(F), Z = (R = a.value) == null ? void 0 : R.contains(F);
      !P && !Z && c();
    };
    return m1(() => {
      document.addEventListener("click", H, !0);
    }), y1(() => {
      document.removeEventListener("click", H, !0), window.removeEventListener("scroll", j, !0), window.removeEventListener("resize", j);
    }), t({
      closeMenu: c
    }), (L, F) => (l(), s("div", {
      ref_key: "menuRef",
      ref: n,
      class: "relative inline-block"
    }, [
      L.$slots.trigger ? (l(), s("div", {
        key: 0,
        ref_key: "triggerRef",
        ref: i,
        tabindex: "0",
        role: "button",
        class: "inline-flex w-full cursor-pointer rounded-2xl outline-none focus-visible:ring-2 focus-visible:ring-royal-300",
        "aria-label": e.ariaLabel,
        "aria-expanded": d.value,
        onClick: o1(m, ["stop"]),
        onKeydown: [
          G1(o1(m, ["prevent"]), ["enter"]),
          G1(o1(m, ["prevent"]), ["space"])
        ]
      }, [
        G(L.$slots, "trigger")
      ], 40, ow)) : (l(), s("button", {
        key: 1,
        ref_key: "triggerRef",
        ref: i,
        type: "button",
        class: "flex h-7 w-7 flex-shrink-0 items-center justify-center gap-2 rounded-md border border-grey-100 bg-white p-[5px] text-grey-950 transition-colors hover:bg-grey-50",
        "data-testid": e.triggerTestId || void 0,
        "aria-label": e.ariaLabel,
        "aria-expanded": d.value,
        onClick: m
      }, [
        J(D(H8), { class: "h-4 w-4" })
      ], 8, nw)),
      (l(), W(g1, { to: "body" }, [
        J(p1, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: Y(() => [
            d.value ? (l(), s("div", {
              key: 0,
              ref_key: "panelRef",
              ref: a,
              "data-testid": "options-menu-panel",
              class: v([
                "fixed z-[9999] rounded-xl border border-grey-100 bg-white shadow-lg",
                C.value,
                e.menuClass
              ]),
              style: a1(h.value)
            }, [
              o("div", {
                class: v([
                  "flex items-center gap-2 self-stretch bg-grey-50 px-3 py-[9px]",
                  e.headerSeparator ? "border-b border-grey-100" : ""
                ])
              }, [
                o("span", {
                  class: v(e.labelClass)
                }, M(e.headerLabel), 3),
                e.showHeaderSortIcon ? (l(), W(D(ah), {
                  key: 0,
                  class: "h-4 w-4 shrink-0 text-grey-600",
                  "aria-hidden": "true"
                })) : x("", !0)
              ], 2),
              o("div", {
                class: v(e.bodyClass)
              }, [
                G(L.$slots, "default")
              ], 2)
            ], 6)) : x("", !0)
          ]),
          _: 3
        })
      ]))
    ], 512));
  }
});
function GL(e, t) {
  if (!e) return;
  const r = (n) => {
    const i = e.value;
    i && (n.target === i || n.composedPath().includes(i) || t());
  };
  return m1(() => {
    window.addEventListener("click", r);
  }), It(() => {
    window.removeEventListener("click", r);
  }), { listener: r };
}
function UL(e = {}) {
  const { timeout: t = 2e3, onSuccess: r, onError: n } = e, i = E(!1), a = E(null);
  let d = null;
  return {
    copy: async (h) => {
      try {
        return await navigator.clipboard.writeText(h), i.value = !0, a.value = null, d && clearTimeout(d), d = setTimeout(() => {
          i.value = !1;
        }, t), r == null || r(h), !0;
      } catch (C) {
        const m = C instanceof Error ? C : new Error("Falha ao copiar");
        return a.value = m, i.value = !1, n == null || n(m), console.error("Erro ao copiar para a área de transferência:", C), !1;
      }
    },
    copied: i,
    error: a
  };
}
function WL(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function YL(e) {
  return e.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}
function qL(e) {
  return e.replace(/\D/g, "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}
function KL(e) {
  const t = e.replace(/\D/g, "");
  return t.length === 13 ? t.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") : t.length === 12 ? t.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, "+$1 ($2) $3-$4") : t.length === 11 ? t.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") : t.length === 10 ? t.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3") : e;
}
function QL(e) {
  return e.replace(/\D/g, "").replace(/(\d{5})(\d{3})/, "$1-$2");
}
function XL(e, t = "pt-BR", r = "BRL") {
  return new Intl.NumberFormat(t, {
    style: "currency",
    currency: r
  }).format(e);
}
function JL(e, t) {
  return e.length <= t ? e : e.slice(0, t - 3) + "...";
}
function e$(e) {
  return e.toLowerCase().split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
}
function t$(e, t = 2) {
  return e.split(" ").filter((r) => r.length > 0).slice(0, t).map((r) => r.charAt(0).toUpperCase()).join("");
}
const o$ = {
  /**
   * Formats a phone number with country code
   * @param value - Raw phone number (e.g., '5511999999999')
   * @returns Formatted phone (e.g., '+55 (11) 99999-9999')
   */
  phone: (e) => e.replace(/(\d{2})?(\d{2})?(\d{4,5})?(\d{4})/g, "+$1 ($2) $3-$4"),
  /**
   * Formats a CPF number
   * @param value - Raw CPF (e.g., '12345678900')
   * @returns Formatted CPF (e.g., '123.456.789-00')
   */
  cpf: (e) => e.replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/g, "$1.$2.$3-$4"),
  /**
   * Formats a CNPJ number
   * @param value - Raw CNPJ (e.g., '12345678000100')
   * @returns Formatted CNPJ (e.g., '12.345.678/0001-00')
   */
  cnpj: (e) => e.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
  /**
   * Removes slashes from date and rearranges format
   * @param value - Date with slashes (e.g., '01/12/')
   * @returns Rearranged date (e.g., '12/01/')
   */
  removeSlashFromDate: (e) => e.replace(/(\d+[/])(\d+[/])/, "$2$1"),
  /**
   * Formats a date from ISO format to DD/MM/YYYY
   * @param value - ISO date (e.g., '2024-12-01')
   * @returns Formatted date (e.g., '01/12/2024')
   */
  formatDate: (e) => {
    if (!e) return "";
    const [t, r, n] = e.split("-");
    return t && r && n ? `${n.padStart(2, "0")}/${r.padStart(2, "0")}/${t}` : e;
  },
  /**
   * Formats a CEP (Brazilian postal code)
   * @param value - Raw CEP (e.g., '01310100')
   * @returns Formatted CEP (e.g., '01310-100')
   */
  cep: (e) => e.replace(/(\d{5})(\d{3})/, "$1-$2")
}, n$ = {
  /** CPF mask: 000.000.000-00 */
  cpf: "###.###.###-##",
  /** CNPJ mask: 00.000.000/0000-00 */
  cnpj: "##.###.###/####-##",
  /** CEP mask: 00000-000 */
  cep: "#####-###",
  /** Phone mask Brazil: +55 fixo; usuário digita só DDD + número. Valor exibido inclui +55 para onlyDigits(). */
  phone: ["+55 (##) ####-####", "+55 (##) #####-####"],
  /** Mobile phone mask: (00) 00000-0000 */
  mobile: ["(##) ####-####", "(##) #####-####"],
  /** Date mask: 00/00/0000 */
  date: "##/##/####",
  /** Money mask: 0.000.000,00 */
  money: "#.###.###,##",
  /** Credit card mask: 0000 0000 0000 0000 */
  creditCard: "#### #### #### ####",
  /**
   * Percentual 0–100 com até 2 casas decimais (pt-BR).
   * O % é exibido apenas como suffix no EcxInput.
   */
  percentage: {
    mask: "number",
    number: { locale: "pt-BR", fraction: 2, unsigned: !0 }
  }
};
function r$(e) {
  if (e == null || String(e).trim() === "") return 0;
  const t = String(e).trim().replace(/\s/g, "").replace(/R\$\s?/gi, "").replace(/\./g, "").replace(",", ".");
  if (t === "" || t === ".") return 0;
  const r = Number.parseFloat(t);
  return Number.isNaN(r) || r < 0 ? 0 : Math.round(r * 100);
}
function l$(e) {
  if (e == null || !Number.isFinite(e) || e < 0) return "0,00";
  const r = (e / 100).toFixed(2), [n, i] = r.split(".");
  return `${n.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${i}`;
}
const rw = {
  "royal-200": { bg: "bg-royal-200", text: "text-royal-200" },
  "royal-400": { bg: "bg-royal-400", text: "text-royal-400" },
  "royal-700": { bg: "bg-royal-700", text: "text-royal-700" },
  "royal-800": { bg: "bg-royal-800", text: "text-royal-800" },
  "grey-400": { bg: "bg-grey-400", text: "text-grey-400" }
};
function lw(e) {
  return rw[e] ?? { bg: "bg-grey-400", text: "text-grey-400" };
}
function Ce(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function kt(e) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(e);
}
function sw(e) {
  const t = lw(e.colorClass), r = Ce(e.name);
  return `
    <div style="display:flex;align-items:center;gap:4px;">
      <div class="w-0.5 h-5 rounded-sm ${t.bg}" style="flex-shrink:0;"></div>
      <div style="display:flex;flex-direction:column;">
        <p class="text-xs text-grey-600 leading-none">${r}</p>
        <p class="text-sm ${t.text} leading-tight">${kt(e.value)}</p>
      </div>
    </div>
  `;
}
function iw(e, t) {
  return `
    <div style="display:flex;align-items:center;gap:4px;">
      <div class="w-0.5 h-5 rounded-sm bg-royal-800" style="flex-shrink:0;"></div>
      <div style="display:flex;flex-direction:column;">
        <p class="text-xs text-grey-600 leading-none">${Ce(t)}</p>
        <p class="text-sm text-royal-800 leading-tight">${kt(e)}</p>
      </div>
    </div>
  `;
}
function s$(e, t, r, n = "Desempenho do dia", i = "Total Gasto", a) {
  const d = t.map(sw).join(""), h = (a == null ? void 0 : a.showTotal) ?? !0 ? `
      <div style="display:flex;flex-direction:column;gap:8px;">
        ${d}
        <div class="h-px bg-grey-100"></div>
        ${iw(r, i)}
      </div>
    ` : `<div style="display:flex;flex-direction:column;gap:8px;">${d}</div>`;
  return `
    <div class="bg-white border border-royal-50 rounded-xl shadow-tooltip p-4 flex flex-col gap-4 w-48">
      <div style="display:flex;flex-direction:column;">
        <p class="text-sm font-semibold text-royal-950 tracking-tight">${Ce(e)}</p>
        <p class="text-xs text-grey-600 tracking-tight">${Ce(n)}</p>
      </div>
      ${h}
    </div>
  `;
}
export {
  Nw as ActivateIcon,
  Gw as AddCollaboratorsIcon,
  Uw as AddFileIcon,
  gt as AddIcon,
  Ww as AdvanceIcon,
  qw as AnalysisNotificationIcon,
  Kw as AnteciPayGradientIcon,
  Yw as ApplePayIcon,
  Qw as ApprovalNotificationIcon,
  Xw as ArrowBack,
  Xw as ArrowBackIcon,
  Jw as ArrowIcon,
  ek as ArrowNext,
  ek as ArrowNextIcon,
  tk as ArrowRightIcon,
  ok as ArrowRightStrokeIcon,
  nk as ArrowUpRightIcon,
  rk as ArrowsExchangeIcon,
  vo as AsteriskIcon,
  lk as AvailableCashbackIcon,
  Lo as BackIcon,
  sk as BankSlipIcon,
  ik as BellIcon,
  ak as BellOutlinedIcon,
  uk as BlockCircleIcon,
  Ck as BlockCollaboratorIcon,
  gk as BlockIcon,
  vk as BlockWarningIcon,
  $k as BlockedCardIcon,
  xk as BlueBarGraphIcon,
  mk as BlueCheckIcon,
  wk as BoletoIcon,
  yk as BorderCheckIcon,
  kk as BriefcaseIcon,
  bk as BuildingIcon,
  dk as BulletListGradientIcon,
  _k as BurgerIcon,
  Mk as BusinessIcon,
  Lk as BusinessUnitIcon,
  Bk as CalendarClockIcon,
  Vk as CalendarIcon,
  Hk as CancelCircleIcon,
  Fk as CancelIcon,
  ck as CardBlockIllustrationIcon,
  hk as CardBlockedPadlockIcon,
  pk as CardCancelIllustrationIcon,
  fk as CardFreezeIllustrationIcon,
  Ak as CardGradientIcon,
  Sk as CardIcon,
  zk as CardOrderActivatePhoneIcon,
  Dk as CardOrderIssuanceStarIcon,
  Tk as CardTemplateEmptyIcon,
  Ok as CardsNavGradientIcon,
  Pk as CartIcon,
  Nk as ChangeIcon,
  Gk as ChangeNotificationIcon,
  Uk as ChargeGradientIcon,
  Wk as ChargeIcon,
  Yk as ChatIcon,
  Qk as CheckCircleIcon,
  Xk as CheckFilledIcon,
  Kk as CheckIcon,
  Ek as ChecklistGradientIcon,
  vt as ChevronDownIcon,
  Ml as ChevronLeftIcon,
  Jk as ChevronRightBlueIcon,
  Al as ChevronRightIcon,
  ey as ClearBenefitIcon,
  ty as ClearFiltersIcon,
  oy as ClockIcon,
  ny as ClockTimeArrowIcon,
  Yl as CloseIcon,
  ft as CloseSmallIcon,
  ly as CoinIcon,
  sy as CollaboratorIcon,
  iy as CollaboratorIconWithBorder,
  ay as CollaboratorsIcon,
  Rk as ComboCardIcon,
  dy as CommunityIcon,
  uy as CopyActionIcon,
  cy as CopyIcon,
  hy as CreditCardAddIcon,
  py as CreditCardIcon,
  fy as CreditCardSearchIcon,
  Ik as CreditCardSingleGradientIcon,
  Zk as CreditCardTransferSwapIcon,
  jk as CreditCardsStackGradientIcon,
  Cy as CreditReportIcon,
  gy as CsvIcon,
  Ct as DEFAULT_VEHICLE_ILLUSTRATION_BASE_PATH,
  vy as DashboardIcon,
  my as DeleteBinIcon,
  ky as DeliveryIcon,
  yy as DigitalAccountGradientIcon,
  $y as DocumentDownloadIcon,
  _y as DocumentFileCheckmarkIcon,
  My as DocumentPlaceholder,
  Vy as DocumentTextIcon,
  Ly as DocumentWithMagnifierIcon,
  by as DocumentationIcon,
  By as DollarSignIcon,
  H8 as DotsIcon,
  Fy as DownloadFileIcon,
  Ay as DownloadIcon,
  Sy as DrawerToggleBlueIcon,
  Ey as DrawerToggleGrayIcon,
  e9 as DrawerToggleIcon,
  zy as EcoIcon,
  Dy as EcosystemIcon,
  ZL as EcxAccordion,
  gL as EcxActionBar,
  vL as EcxActionBarButton,
  wL as EcxAlert,
  ht as EcxAsyncMultiSelectFilter,
  ct as EcxAvatar,
  xL as EcxBadge,
  V1 as EcxButton,
  VL as EcxCaption,
  AL as EcxCard,
  jL as EcxCardHeader,
  $3 as EcxCheckbox,
  yw as EcxCheckboxCard,
  kw as EcxCheckboxField,
  Pw as EcxContentContainer,
  SL as EcxCopyButton,
  zL as EcxCountBadge,
  Fw as EcxCreatableSelect,
  km as EcxDateRangePicker,
  EL as EcxDivider,
  Rw as EcxDrawer,
  yL as EcxEmptyState,
  RL as EcxEmptyStateCard,
  bL as EcxFeedbackToast,
  _L as EcxFeedbackToastContainer,
  HL as EcxFilterBadge,
  Aw as EcxForm,
  xw as EcxFormField,
  ML as EcxHeading,
  DL as EcxInfoBadge,
  jw as EcxInfoModal,
  h2 as EcxInput,
  T3 as EcxInputField,
  $L as EcxLabel,
  Iw as EcxLoadingModal,
  pw as EcxModal,
  hw as EcxMoneyInput,
  bw as EcxMoneyInputField,
  Mw as EcxMultiSelect,
  hL as EcxNavItem,
  NL as EcxOptionsMenu,
  PL as EcxOrganizeTableColumnsPopover,
  Dw as EcxPageContainer,
  Tw as EcxPageHeader,
  Ow as EcxPageTitleHeader,
  CL as EcxPagination,
  R0 as EcxPickerListHeader,
  zw as EcxPinInput,
  TL as EcxPopover,
  mL as EcxProgressBar,
  gw as EcxRadio,
  FL as EcxScrollableFilters,
  Cw as EcxSearchInput,
  Vw as EcxSearchableSelect,
  _w as EcxSearchableSelectField,
  Ew as EcxSegmentedControl,
  w3 as EcxSelect,
  ww as EcxSelectField,
  pL as EcxSidebar,
  cL as EcxSmallScreenBanner,
  mt as EcxSpinner,
  IL as EcxStatItem,
  mw as EcxStep,
  vw as EcxStepper,
  E3 as EcxStepperIndicator,
  BL as EcxSummaryLabelValue,
  OL as EcxTable,
  LL as EcxText,
  kL as EcxToast,
  Zw as EcxToggle,
  Sw as EcxToggleSwitch,
  fL as EcxToolbar,
  fe as EcxTooltip,
  Lw as EcxUserAsyncMultiSelectFilter,
  W0 as EcxUserOptionRow,
  $w as EcxVehicleAsyncMultiSelectFilter,
  K0 as EcxVehicleOptionRow,
  Hw as EcxVehicleSearchSelect,
  Ty as EditBulkIcon,
  Oy as EditCreditLimitIcon,
  Py as EditIcon,
  Ry as EditSmallIcon,
  jy as EmailIcon,
  Wy as EmptyCardIcon,
  Yy as EmptyGraphPlaceholderIcon,
  Ny as EmptyStateIcon,
  Gy as EmptyStateNoUsersIcon,
  Uy as EmptyTeamsIcon,
  qy as EmptyWalletIcon,
  Ky as EnvelopeIcon,
  Hy as ExcelFileIcon,
  T9 as ExitIcon,
  Qy as ExportIcon,
  Iy as EyeIcon,
  Zy as EyeOffIcon,
  Xy as FileFolderIcon,
  Jy as FillBenefitIcon,
  eb as FilterIcon,
  tb as FlexIcon,
  ob as FolderAnimationIcon,
  nb as FolderIcon,
  rb as FolderShareArrowIcon,
  lb as FolderXIcon,
  cb as GasStationGradientIcon,
  hb as GenerateKeyIcon,
  ab as GooglePayIcon,
  xy as GridSquaresGradientIcon,
  sb as GroupIcon,
  ib as GroupItemIcon,
  db as GroupsChargeIcon,
  ub as GroupsIcon,
  pb as GuardianIcon,
  fb as HelpIcon,
  Cb as HintIcon,
  gb as HistoryReportIcon,
  vb as HomeGradientIcon,
  qw as IconAnalysisNotification,
  Qw as IconApprovalNotification,
  Nk as IconChange,
  $b as IconInformation,
  $b as IconInformationDefault,
  E_ as IconReprovedNotification,
  U_ as IconSettings,
  eL as IconWhatsApp,
  mb as ImediateIcon,
  xb as InactivateCollaboratorIcon,
  wb as InactivateIcon,
  kb as InactivateUserIcon,
  yb as InactiveCollaboratorIcon,
  bb as InactiveWarningIcon,
  Ke as InfoHelpIcon,
  _b as InfoIcon,
  _b as InfoIconCollaborators,
  Mb as InformationAlertIcon,
  $b as InformationIcon,
  Vb as InformationIconBlue,
  Bb as InvoiceGradientIcon,
  Lb as ItemImageTextCheckmarkIcon,
  Hb as KnowMoreIcon,
  Fb as LampIcon,
  Ab as ListIcon,
  jb as LockIcon,
  Ib as LogoutIcon,
  Eb as MagnifyingGlassIcon,
  Sb as ManageKeysIcon,
  Zb as MapPinIcon,
  zb as MarketplaceIcon,
  o$ as Masks,
  Db as MassEditIcon,
  Tb as MegaphoneIcon,
  Ob as MenuArrowBackIcon,
  Pb as MenuIcon,
  qk as MessageOutlineIcon,
  Rb as MoneyIcon,
  Nb as MoveGroupIcon,
  Gb as MoveIcon,
  Ub as MoveSelectIcon,
  qb as MultiplePersonFolder,
  p_ as NewsPaperTextIcon,
  Kb as OfficeBuildingIcon,
  Qb as OldTransferIcon,
  Xb as OnePersonFolder,
  Jb as OrangeCardIcon,
  wy as PackageGradientIcon,
  e_ as PaymentAccountBalanceIcon,
  t_ as PaymentBoletoIcon,
  o_ as PaymentPixIcon,
  n_ as PdfIcon,
  l_ as PersonBlueIcon,
  s_ as PersonGradientIcon,
  i_ as PersonIcon,
  a_ as PersonWithCheckIcon,
  Wb as PieChartGradientIcon,
  h_ as PixCnpjIcon,
  x_ as PixCopyKeyIcon,
  m_ as PixDeleteKeyIcon,
  f_ as PixEmailIcon,
  d_ as PixIcon,
  u_ as PixKeyEmptyIcon,
  C_ as PixPhoneIcon,
  g_ as PixRandomIcon,
  r_ as PixReceivedIcon,
  c_ as PixRegisterKeyIcon,
  v_ as PixValidateKeyIcon,
  Yb as PizzaReportIcon,
  w_ as PoweredByEcxIcon,
  k_ as QrCodeIcon,
  y_ as RayIcon,
  b_ as ReactivateIcon,
  M_ as ReceiptCheckIcon,
  __ as ReceiptIcon,
  L_ as ReceiptListIcon,
  $_ as RefreshIcon,
  V_ as RefreshInfoIcon,
  B_ as RepeatIcon,
  H_ as ReportGradientIcon,
  F_ as ReportIcon,
  A_ as ReportIconOptions,
  j_ as ReportPdfIcon,
  Z_ as ReportXlsIcon,
  I_ as ReportsIcon,
  E_ as ReprovedNotificationIcon,
  S_ as RequestCardIcon,
  z_ as RoyalCardCheckIcon,
  D_ as SafeIcon,
  T_ as SamsungPayIcon,
  O_ as SearchGrayIcon,
  P_ as SearchIcon,
  R_ as SegmentBenefitIcon,
  N_ as SelectArrowIcon,
  G_ as SeparateChargeIcon,
  G_ as SepareteChargeIcon,
  U_ as SettingsIcon,
  W_ as SettingsOutlineIcon,
  Y_ as SlidersHorizontalGradientIcon,
  q_ as SlidersHorizontalOutlineIcon,
  th as SmallDisplayIcon,
  X_ as SnowIcon,
  K_ as SolicitateReportIcon,
  Q_ as SortDirectionIcon,
  ah as SortIcon,
  tM as SpreadSheetIcon,
  dL as SpreadsheetFolderEmptyIllustration,
  uL as SpreadsheetFolderSuccessIllustration,
  J_ as SpreadsheetGrayIcon,
  tM as SpreadsheetIcon,
  oM as StatementAntecipayIcon,
  nM as StatementIcon,
  eM as SuitcasePortfolioIcon,
  rM as SupportIcon,
  lM as TableEditIcon,
  ZM as TeamMenuAddMemberIcon,
  EM as TeamMenuDeleteIcon,
  ry as TimeInputClockIcon,
  iM as TimerIcon,
  LM as ToastCheckIcon,
  aM as ToolingIcon,
  dM as TopbarImportIcon,
  uM as TrackDeliveryIcon,
  NM as TransactionsEmptyIllustrationIcon,
  cM as TransferIcon,
  hM as TrashIcon,
  fM as TruckGradientIcon,
  pM as TurnOnOffIcon,
  CM as UpDownArrow,
  gM as UploadIcon,
  vM as UsedCashbackIcon,
  mM as UserGroupGradientIcon,
  xM as UserGroupIcon,
  SM as UserMenuResendInviteIcon,
  wM as UserNoteIcon,
  bM as UserOutlineIcon,
  kM as UserPlusIcon,
  _M as UserProfileInputIcon,
  yM as UserSingleGradientIcon,
  sM as UsersGroupGradientIcon,
  MM as UsersGroupInputIcon,
  $M as VehicleAssetSliderEquipmentIcon,
  Ne as VehicleAssetSliderVehicleIcon,
  U5 as VehicleIllustrationIcon,
  zM as VehicleKpiActiveDriverIcon,
  DM as VehicleKpiActiveVehicleIcon,
  TM as VehicleKpiCostPerKmGaugeIcon,
  GM as VehicleKpiDistanceIcon,
  OM as VehicleKpiFuelConsumptionIcon,
  UM as VehicleKpiRefueledVolumeIcon,
  PM as VehicleKpiTotalSpendIcon,
  RM as VehicleKpiTransactionsIcon,
  VM as VehicleMenuEditIcon,
  BM as VehicleMenuInactivateIcon,
  HM as VehicleMenuLinkCardIcon,
  FM as VehicleMenuReactivateIcon,
  AM as VehicleMenuStatementIcon,
  jM as VehicleMenuViewDetailsIcon,
  IM as VehicleMenuWriteOffIcon,
  WM as VideoIcon,
  YM as ViewIcon,
  KM as VoucherBlueIcon,
  qM as VtIcon,
  QM as WalletIcon,
  XM as WarningCircleIcon,
  JM as WarningTriangleIcon,
  eL as WhatsAppIcon,
  tL as WhatsAppOutlineIcon,
  oL as XCardIcon,
  nL as XCircleIcon,
  rL as XIcon,
  lL as XPointsBrandIcon,
  sL as XPointsReceiveIcon,
  iL as XPointsRedeemIcon,
  aL as XlsxIcon,
  s$ as buildChartTooltipHtml,
  e$ as capitalize,
  l$ as centsToReaisString,
  QL as formatCEP,
  qL as formatCNPJ,
  YL as formatCPF,
  XL as formatCurrency,
  KL as formatPhone,
  t$ as getInitials,
  N5 as getVehicleIllustrationUrl,
  n$ as maskPatterns,
  o$ as masks,
  Bw as prefetchVehicleIllustrationUrl,
  r$ as reaisStringToCents,
  WL as removeAccents,
  JL as truncate,
  GL as useClickOutside,
  UL as useCopyToClipboard,
  Wv as useFeedbackToast,
  O3 as useFormField
};
